/**
 * This file was automatically generated by `TranslationsCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source English locale translations at
 * `src/locales/en/*.json`, and run `yarn i18n:codegen` to regenerate this file.
 */

import { TOptions } from 'i18next';
export type TranslateFunction = (options?: TOptions) => string;

export type LeafNodeValue = string | TranslateFunction;

export type AccommodationsAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Best for families'
     */
    '9zEPb': T;

    /**
     * @default 'Best for couples'
     */
    '8yghu': T;

    /**
     * @default 'Best for art lovers'
     */
    VdtFH: T;

    /**
     * @default 'Best for walkable areas'
     */
    wEPoM: T;

    /**
     * @default 'Menu'
     */
    '3bFMA': T;

    /**
     * @default 'Explore'
     */
    FdNcu: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Stay Areas'
     */
    fJuJb: T;

    /**
     * @default 'We found a few curated stay zones suggestions near your venue. Add, remove and tweak them the way you want.'
     */
    '7kygL': T;
  };
};

export type AccommodationsConsoleTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Explore Hotels'
     */
    exploreHotels: T;

    /**
     * @default 'Show only couple’s recommendations'
     */
    pickedByCouple: T;

    rooms: {
      /**
       * @default '1 Room'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Room
       * - plural: {{ rooms }} Rooms
       */
      rooms: T;
    };
    guests: {
      /**
       * @default '1 Guest'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Guest
       * - plural: {{ guests }} Guests
       */
      guests: T;
    };
  };
  loader: {
    /**
     * @default 'Finding hotels with exclusive event rates, up to 40% off.'
     */
    title: T;

    loaderTexts: [
      {
        /**
         * @default 'Loading all hotels around your event'
         */
        text: T;
      },
      {
        /**
         * @default 'Finding the best hotels near the venue'
         */
        text: T;
      },
      {
        /**
         * @default 'Selecting hotels loved by Joy guests'
         */
        text: T;
      },
      {
        /**
         * @default 'Unlocking your exclusive Joy rates'
         */
        text: T;
      },
      {
        /**
         * @default 'Calculating walk and drive time'
         */
        text: T;
      },
    ];
  };
  mobileSearch: {
    /**
     * @default 'Search Location'
     */
    title: T;

    /**
     * @default 'Select Dates'
     */
    selectDates: T;

    /**
     * @default 'Save'
     */
    save: T;
  };
  filterPanel: {
    /**
     * @default 'Browse CUG Rates Hotels'
     */
    title: T;

    /**
     * @default 'Filters'
     */
    filters: T;

    /**
     * @default 'Picked by the couple'
     */
    pickedByCouple: T;

    /**
     * @default 'Browse hotels with exclusive rates available only for our guests.'
     */
    findHotels: T;

    /**
     * @default 'Reset All Filters'
     */
    resetAllFilters: T;

    /**
     * @default 'Show Results'
     */
    showResults: T;

    showAvailableOnly: {
      /**
       * @default 'Show available hotels first'
       */
      title: T;
    };
    joyTravelBenefits: {
      /**
       * @default 'Joy Travel Benefits'
       */
      title: T;

      /**
       * @default 'Closed User Group Rates'
       */
      closedUserGroupRates: T;

      /**
       * @default 'Closed User Group (CUG) rates are special discounted hotel prices offered only to a specific group of people, in this case Joy guests. These rates are not listed publicly on standard travel websites. To access them, you just need to book through Joy.'
       */
      closedUserGroupRatesTooltipContent: T;
    };
    guestRating: {
      /**
       * @default 'Guest Rating'
       */
      title: T;

      /**
       * @default 'Wonderful: 9+'
       */
      wonderful: T;

      /**
       * @default 'Very Good: 8+'
       */
      veryGood: T;

      /**
       * @default 'Good: 7+'
       */
      good: T;

      /**
       * @default 'Pleasant: 6+'
       */
      pleasant: T;
    };
    priceRange: {
      /**
       * @default 'Price per night'
       */
      title: T;

      /**
       * @default 'Includes all taxes and fees'
       */
      description: T;

      /**
       * @default 'Min'
       */
      min: T;

      /**
       * @default 'Max'
       */
      max: T;
    };
    starRating: {
      /**
       * @default 'Star Rating'
       */
      title: T;

      /**
       * @default 'Hotel quality—1 star is basic, 5 stars is luxe'
       */
      description: T;

      /**
       * @default '{{star}} Star'
       */
      starWithCount: T;
    };
    facilities: {
      /**
       * @default 'Facilities'
       */
      title: T;

      /**
       * @default 'Parking'
       */
      parking: T;

      /**
       * @default 'Restaurant'
       */
      restaurant: T;

      /**
       * @default 'Internet'
       */
      internet: T;

      /**
       * @default 'Spa'
       */
      spa: T;

      /**
       * @default 'Bar'
       */
      bar: T;

      /**
       * @default 'Breakfast'
       */
      breakfast: T;

      /**
       * @default 'ATM'
       */
      atm: T;

      /**
       * @default 'Swimming Pool'
       */
      swimmingPool: T;

      /**
       * @default 'Air Conditioning'
       */
      airConditioning: T;

      /**
       * @default 'Pets Allowed'
       */
      petsAllowed: T;

      /**
       * @default 'Non Smoking'
       */
      nonSmoking: T;
    };
  };
  listingsPanel: {
    /**
     * @default 'Browse Hotels'
     */
    title: T;

    /**
     * @default 'Book before {{cutoffDate}}'
     */
    cutoffDate: T;

    /**
     * @default 'more'
     */
    readMore: T;

    /**
     * @default 'Added'
     */
    added: T;

    /**
     * @default 'less'
     */
    readLess: T;

    /**
     * @default 'Show only couple’s recommendations'
     */
    pickedByCouple: T;

    /**
     * @default 'This hotel has no availability for the dates selected.'
     */
    soldOutMessage: T;

    /**
     * @default 'Map'
     */
    map: T;

    resetFiltersHeader: {
      /**
       * @default 'Reset All'
       */
      resetAll: T;

      /**
       * @default 'Price: {{min}} - {{max}}'
       */
      price: T;

      /**
       * @default 'Guest Rating: {{guestRating}}'
       */
      guestRating: T;

      /**
       * @default 'Star Rating: {{starRating}}'
       */
      starRating: T;
    };
    specialEventRates: {
      /**
       * @default 'Special Event Rates'
       */
      title: T;

      /**
       * @default 'Discounted Rates for Joy Guests'
       */
      tooltipTitle: T;

      /**
       * @default 'Benefit from exclusive rates up to 40% less compared to Expedia.'
       */
      tooltipContent: T;
    };

    /**
     * @default 'Couple's Pick'
     */
    couplesPick: T;

    /**
     * @default 'Room Block'
     */
    couplesPickRoomBlock: T;

    /**
     * @default 'Our Room Block'
     */
    ourRoomBlock: T;

    /**
     * @default 'Show More'
     */
    showMore: T;

    costBreakdown: {
      /**
       * @default '{{percentage}}% off'
       */
      discount: T;

      /**
       * @default '/ night'
       */
      perNight: T;

      /**
       * @default '{{totalCost}} total'
       */
      totalAfterTax: T;

      /**
       * @default '1 night, 1 room, incl. taxes and fees'
       */
      singleRoomSingleNight: T;

      /**
       * @default '1 night, {{rooms}} rooms, incl. taxes and fees'
       */
      multiRoomSingleNight: T;

      /**
       * @default '{{nights}} nights, 1 room, incl. taxes and fees'
       */
      singleRoomMultiNight: T;

      /**
       * @default '{{nights}} nights, {{rooms}} rooms, incl. taxes and fees'
       */
      multiRoomMultiNight: T;
    };
    hotelCTA: {
      /**
       * @default 'See Availability'
       */
      title: T;

      /**
       * @default 'Remove Hotel'
       */
      couplePicksButtonText: T;

      /**
       * @default 'Add Hotel'
       */
      coupleHotelButtonText: T;

      /**
       * @default 'See Availability'
       */
      hotelButtonText: T;
    };
    userRatings: {
      category: {
        /**
         * @default 'Wonderful'
         */
        wonderful: T;

        /**
         * @default 'Excellent'
         */
        excellent: T;

        /**
         * @default 'Fabulous'
         */
        fabulous: T;

        /**
         * @default 'Very Good'
         */
        veryGood: T;

        /**
         * @default 'Good'
         */
        good: T;

        /**
         * @default 'Pleasant'
         */
        pleasant: T;

        /**
         * @default 'Fair'
         */
        fair: T;
      };

      /**
       * @default '{{reviewCount}} reviews'
       */
      reviewCounts: T;
    };
    userRatingCategory: {
      /**
       * @default 'Wonderful'
       */
      wonderful: T;

      /**
       * @default 'Excellent'
       */
      excellent: T;

      /**
       * @default 'Fabulous'
       */
      fabulous: T;

      /**
       * @default 'Very Good'
       */
      veryGood: T;

      /**
       * @default 'Good'
       */
      good: T;

      /**
       * @default 'Pleasant'
       */
      pleasant: T;

      /**
       * @default 'Fair'
       */
      fair: T;
    };
    exploreMore: {
      /**
       * @default 'Explore More Hotels'
       */
      title: T;

      /**
       * @default 'Browse {{count}} other hotels near the wedding venue loved by Joy guests. '
       */
      subTitle: T;

      /**
       * @default 'Browse {{count}} More Stays'
       */
      buttonText: T;
    };
  };
  map: {
    /**
     * @default 'Search this area'
     */
    searchCta: T;

    /**
     * @default 'Stays in Map area'
     */
    areaSearchLocationValue: T;

    /**
     * @default 'Wedding venue'
     */
    weddingVenue: T;
  };
  emptyState: {
    /**
     * @default 'No Exact Matches'
     */
    title: T;

    /**
     * @default 'Try changing or removing some of your filters or adjusting your search area.'
     */
    content: T;

    /**
     * @default 'Show Nearest Hotels'
     */
    buttonText: T;
  };
  singleHotelView: {
    /**
     * @default 'Swipe to Preview Hotels'
     */
    swipeRightForQuickView: T;
  };
  sort: {
    /**
     * @default 'Sort by'
     */
    title: T;

    /**
     * @default 'Sort by:'
     */
    sortPrefix: T;

    /**
     * @default 'Couple's Picks'
     */
    couplesPicks: T;

    /**
     * @default 'Price Low to High'
     */
    priceLowToHigh: T;

    /**
     * @default 'Price High to Low'
     */
    priceHighToLow: T;

    /**
     * @default 'Top Matches'
     */
    topMatches: T;

    /**
     * @default 'Most Savings'
     */
    mostSavings: T;

    /**
     * @default 'Highest Discount'
     */
    highestDiscount: T;

    /**
     * @default 'Distance'
     */
    distance: T;

    /**
     * @default 'Done'
     */
    done: T;
  };
  quick: {
    /**
     * @default 'Loading all hotels around your event'
     */
    KBasV: T;

    /**
     * @default 'Finding the best hotels near the venue'
     */
    xlwWN: T;

    /**
     * @default 'Selecting hotels loved by Joy guests'
     */
    LgbBE: T;

    /**
     * @default 'Unlocking your exclusive Joy rates'
     */
    sDxLt: T;

    /**
     * @default 'Calculating walk and drive time'
     */
    '6KxZ1': T;

    /**
     * @default 'Finding hotels with exclusive event rates, up to 40% off.'
     */
    '7Ptps': T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default '{{0}} {{1}} from venue'
     */
    ejS7V: T;

    /**
     * @default '{{0}} {{1}} walk'
     */
    '0uoli': T;

    /**
     * @default '{{0}} {{1}} drive'
     */
    hNVO9: T;

    /**
     * @default 'Couple's Picks'
     */
    '8YA22': T;

    /**
     * @default 'Top Matches'
     */
    AokRW: T;

    /**
     * @default 'Price Low to High'
     */
    MwdHU: T;

    /**
     * @default 'Price High to Low'
     */
    WZBgs: T;

    /**
     * @default 'Most Savings'
     */
    '68rkP': T;

    /**
     * @default 'Distance'
     */
    '3I584': T;

    /**
     * @default 'See Availability'
     */
    '2ZFEq': T;

    /**
     * @default 'Browse more hotels with our special rates'
     */
    '0J7l4': T;

    /**
     * @default 'Explore More Hotels'
     */
    BmXGM: T;

    /**
     * @default 'Map'
     */
    '4pWAA': T;

    /**
     * @default 'Close dialog'
     */
    CoNQA: T;

    /**
     * @default 'Show {{0}} on Map'
     */
    '2FeXZ': T;

    /**
     * @default 'Show on Map'
     */
    IeS7u: T;

    /**
     * @default 'List'
     */
    KR7LA: T;

    /**
     * @default 'Book on Joy'
     */
    '22I4P': T;

    /**
     * @default 'We prioritize showing available hotels, but you can choose to see them all.'
     */
    '0uU41': T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'venue'
     */
    '914sJ': T;

    /**
     * @default '{{0}} {{1}} from {{2}}'
     */
    '32NZW': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Browse more stays with our special rates'
     */
    tX7MW: T;

    /**
     * @default 'Discounted Rates for Joy Guests'
     */
    TDKaE: T;

    /**
     * @default 'Benefit from exclusive rates up to 40% less compared to Expedia.'
     */
    gG0BF: T;

    /**
     * @default 'Special Event Rates'
     */
    ugPDv: T;

    /**
     * @default 'Wonderful: 9+'
     */
    '2X5DE': T;

    /**
     * @default 'Very Good: 8+'
     */
    EgsNS: T;

    /**
     * @default 'Good: 7+'
     */
    nLJKE: T;

    /**
     * @default 'Pleasant: 6+'
     */
    JF3Fk: T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'Browse hotels with exclusive rates just for our guests.'
     */
    '6ZcbY': T;

    /**
     * @default 'Show available hotels first'
     */
    '35dsA': T;

    /**
     * @default 'Joy Travel Benefits'
     */
    Yc2nX: T;

    /**
     * @default 'Search by property name'
     */
    LeMdS: T;

    /**
     * @default 'e.g., Marriott'
     */
    KcHZo: T;

    /**
     * @default 'Guest Rating'
     */
    XZAT2: T;

    /**
     * @default 'Price per night'
     */
    GlaeW: T;

    /**
     * @default 'Includes all taxes and fees'
     */
    Z5R4k: T;

    /**
     * @default 'Star Rating'
     */
    t9Xyc: T;

    /**
     * @default 'Hotel quality—1 star is basic, 5 stars is luxe'
     */
    I5J8P: T;

    /**
     * @default 'Facilities'
     */
    '9ibd4': T;

    /**
     * @default 'Reset All Filters'
     */
    bnE3D: T;

    /**
     * @default 'Show Results'
     */
    ttgga: T;
  };
};

export type AccommodationsGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '{{0}} guests interested'
     */
    eugAd: T;

    /**
     * @default 'less'
     */
    BTvQA: T;

    /**
     * @default 'more'
     */
    hd7QA: T;

    /**
     * @default 'Book before {{0}}'
     */
    q8D6D: T;

    /**
     * @default 'Group Rate'
     */
    '7rn7p': T;

    /**
     * @default '{{0}} / night'
     */
    jB2AV: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default '{{0}} walk'
     */
    pVA2E: T;

    /**
     * @default '{{0}} drive'
     */
    '8pImk': T;

    /**
     * @default 'Starting from'
     */
    IKBXI: T;

    /**
     * @default 'Event-Only Rate'
     */
    TvGKq: T;

    /**
     * @default '{{0}}'s exclusive guest rates are available when you book with Joy. Reserve soon here to lock in this price—rooms are limited.'
     */
    BzVlk: T;

    /**
     * @default 'Exclusive Rate'
     */
    c0Mip: T;

    /**
     * @default 'Compared to'
     */
    SWS2n: T;

    /**
     * @default 'Book before'
     */
    EDAQC: T;

    /**
     * @default 'A group rate is a special discounted price arranged for wedding guests at this hotel.'
     */
    ISKAR: T;

    /**
     * @default 'We're Staying Here'
     */
    zR9rJ: T;
  };
};

export type AccountTranslations<T extends LeafNodeValue = TranslateFunction> = {
  signin: {
    /**
     * @default 'Sign in with Google'
     */
    google: T;

    /**
     * @default 'Continue with Facebook'
     */
    facebook: T;

    /**
     * @default 'Sign in to Joy'
     */
    signInToJoy: T;

    /**
     * @default 'Don't have an account?'
     */
    donthaveaccount: T;

    /**
     * @default 'Create an account'
     */
    createAnAccount: T;

    /**
     * @default 'Email'
     */
    enterEmail: T;

    /**
     * @default 'Password'
     */
    enterPassword: T;

    /**
     * @default 'Sign In'
     */
    signin: T;

    /**
     * @default 'Continue with your email and password'
     */
    or: T;
  };
  signup: {
    /**
     * @default 'Sign up with Google'
     */
    google: T;

    /**
     * @default 'Continue with Facebook'
     */
    facebook: T;

    /**
     * @default 'Sign Up for Joy'
     */
    signUpForJoy: T;

    /**
     * @default 'Sign Up'
     */
    signup: T;
  };

  /**
   * @default 'Already signed up? <signInLink/>'
   */
  alreadyAccount: T;

  forgotpassword: {
    /**
     * @default 'Forgot your password'
     */
    forgotPassword: T;

    /**
     * @default 'Send password reset'
     */
    sendPasswordReset: T;
  };

  /**
   * @default 'By signing up, you agree to our <termsLink/> and <privacyLink/>.'
   */
  termsandprivacy: T;

  /**
   * @default 'Terms'
   */
  terms: T;

  /**
   * @default 'Privacy Policy'
   */
  privacyPolicy: T;

  /**
   * @default ' See '
   */
  privacyNoticeSee: T;

  /**
   * @default 'CA Privacy Notice'
   */
  privacyNotice: T;

  formWarnings: {
    /**
     * @default 'Invalid email'
     */
    invalidEmail: T;

    /**
     * @default 'Required'
     */
    required: T;

    /**
     * @default 'The email or password you entered is incorrect.'
     */
    invalidCredentials: T;
  };

  /**
   * @default 'Sign out'
   */
  signout: T;

  /**
   * @default 'You are signed in as {{name}}'
   */
  signedinas: T;

  /**
   * @default 'Joy admin'
   */
  youJoyAdmin: T;

  /**
   * @default 'You are not a Joy admin'
   */
  youNotJoyAdmin: T;

  /**
   * @default 'You need to sign in with your withjoy.com account'
   */
  youNeedToJoyLogin: T;

  eventPicker: {
    /**
     * @default 'Create New Event'
     */
    createNew: T;

    /**
     * @default 'Current Event'
     */
    currentEvent: T;
  };
  verifyEmailSuccess: {
    /**
     * @default 'We’ve verified your email. Thanks!'
     */
    message: T;
  };
  sentResetPassword: {
    /**
     * @default 'Change Password'
     */
    title: T;

    /**
     * @default 'OK'
     */
    confirmButton: T;

    /**
     * @default 'We sent an email to {{email}} with instructions to change your password. '
     */
    sentEmail: T;

    /**
     * @default 'If this was a mistake, just ignore the email and your password will remain the same.'
     */
    ignoreClause: T;
  };
  deleteUser: {
    /**
     * @default 'Delete Account'
     */
    title: T;

    /**
     * @default 'Delete Account'
     */
    confirmButton: T;

    /**
     * @default 'Deleting your account is irreversible. If you delete your account, we will not be able to restore it.'
     */
    message: T;

    /**
     * @default 'Type DELETE to confirm you want to delete your account:'
     */
    fieldTitle: T;
  };
  mustLeaveEvents: {
    /**
     * @default 'Delete Account'
     */
    title: T;

    /**
     * @default 'Before deleting your account, please delete any events you have created and leave any events you have joined.'
     */
    message: T;

    /**
     * @default 'Learn More'
     */
    linkText: T;

    /**
     * @default 'OK'
     */
    confirmButton: T;
  };
  leaveEvent: {
    /**
     * @default 'Are you sure?'
     */
    title: T;

    /**
     * @default 'Are you sure you’d like to leave this event?'
     */
    titleV2: T;

    /**
     * @default 'Please confirm you’d like to leave this event.'
     */
    message: T;

    /**
     * @default 'Leave Event'
     */
    confirmButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Event Name'
     */
    label: T;

    /**
     * @default 'Please Note'
     */
    warningLabel: T;

    /**
     * @default 'If you leave this event we will remove it from your Joy account.'
     */
    warningMessage: T;

    /**
     * @default 'You have successfully left this event'
     */
    successToast: T;

    /**
     * @default 'We were unable to remove you from this event'
     */
    failureToast: T;

    /**
     * @default 'close dialog'
     */
    closeDialog: T;
  };
  deleteEvent: {
    /**
     * @default 'Are you sure you’d like to delete this event?'
     */
    title: T;

    /**
     * @default 'Delete Event'
     */
    confirmButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Deleting your event will permanently remove your entire event from Joy. This includes all event details, your website, invitations, photos and guest list.'
     */
    confirmMessage: T;

    /**
     * @default 'If you would like to continue, please type'
     */
    confirm1: T;

    /**
     * @default 'in the field below to permanently delete your event from Joy.'
     */
    confirm2: T;

    /**
     * @default 'Please Note:'
     */
    warningLabel: T;

    /**
     * @default 'Deleting your event is an irreversible change.'
     */
    warningMessage: T;

    /**
     * @default 'Your event has been successfully deleted.'
     */
    successToast: T;

    /**
     * @default 'close dialog'
     */
    closeDialog: T;
  };
  deleteEventSuccess: {
    /**
     * @default 'We’re sorry to see you go!'
     */
    title: T;

    /**
     * @default 'Done'
     */
    confirmButton: T;

    /**
     * @default 'Your event was deleted successfully.'
     */
    confirmMessage: T;

    /**
     * @default 'Before you go, would you mind sharing why you’re leaving? Your feedback would be greatly appreciated.'
     */
    message: T;

    /**
     * @default 'I deleted my Joy event because...'
     */
    placeholderText: T;
  };
  deleteEventFailure: {
    /**
     * @default 'An error occured'
     */
    title: T;

    /**
     * @default 'We were unable to delete the event.'
     */
    message: T;

    /**
     * @default 'OK'
     */
    confirmButton: T;
  };
  leaveEventFailure: {
    /**
     * @default 'An error occured'
     */
    title: T;

    /**
     * @default 'We were unable to remove you from the event.'
     */
    message: T;

    /**
     * @default 'OK'
     */
    confirmButton: T;
  };
  savePersonInfoFailure: {
    /**
     * @default 'An error occured'
     */
    title: T;

    /**
     * @default 'Unfortunately your changes could not be saved.'
     */
    message: T;

    /**
     * @default 'OK'
     */
    confirmButton: T;

    /**
     * @default 'Your email could not be updated to {{targetEmail}}, because an account with that email address already exists.'
     */
    userAlreadyExists: T;

    /**
     * @default 'If you want to use {{targetEmail}} for an event, you can <userAlreadyExistsLink/> to the account with that email address.'
     */
    userAlreadyExistsSuggestion: T;

    /**
     * @default 'transfer ownership of the event'
     */
    userAlreadyExistsLinkText: T;
  };
  eventsPage: {
    /**
     * @default 'What kind of event would you like to create?'
     */
    createDialogTitle: T;

    /**
     * @default 'Upcoming Events'
     */
    myEventsTitle: T;

    /**
     * @default 'Past Events'
     */
    pastEventsTitle: T;

    newEventOptions: {
      /**
       * @default 'Baby Registry'
       */
      baby: T;

      /**
       * @default 'Wedding'
       */
      wedding: T;

      /**
       * @default 'Other'
       */
      custom: T;

      /**
       * @default 'Professional'
       */
      professional: T;

      /**
       * @default 'AI Planner'
       */
      aiPlanner: T;
    };
    createCustomEvent: {
      /**
       * @default 'Create Custom Event'
       */
      buttonTitle: T;
    };
    findEventButton: {
      /**
       * @default 'Find Event'
       */
      value: T;
    };
    createEventButton: {
      /**
       * @default 'Create Event'
       */
      value: T;
    };
    copyLink: {
      /**
       * @default 'Copy Link'
       */
      buttonTitle: T;

      /**
       * @default '✨ Link Copied to Clipboard ✨'
       */
      toastMessage: T;
    };
    editEvent: {
      /**
       * @default 'Edit'
       */
      buttonTitle: T;
    };
    rsvpEvent: {
      /**
       * @default 'RSVP'
       */
      buttonTitle: T;
    };
    shareEvent: {
      /**
       * @default 'Share'
       */
      buttonTitle: T;
    };
    previewEvent: {
      /**
       * @default 'Preview'
       */
      buttonTitle: T;
    };
    deleteEvent: {
      /**
       * @default 'Delete'
       */
      buttonTitle: T;
    };
    leaveEvent: {
      /**
       * @default 'Leave This Event'
       */
      buttonTitle: T;
    };

    /**
     * @default 'Coming up! 🎉'
     */
    eventComingUp: T;

    /**
     * @default 'Attending'
     */
    eventAttending: T;

    /**
     * @default 'Not Attending'
     */
    eventNotAttending: T;

    /**
     * @default 'Event'
     */
    event: T;

    /**
     * @default 'Manage Event'
     */
    manageEvent: T;

    status: {
      /**
       * @default 'Owner'
       */
      owner: T;

      /**
       * @default 'Admin'
       */
      admin: T;

      /**
       * @default 'Collaborator'
       */
      collaborator: T;

      /**
       * @default 'Guest'
       */
      guest: T;
    };
  };
  accountManageNav: {
    /**
     * @default 'Events'
     */
    eventsNavTitle: T;

    /**
     * @default 'Account'
     */
    account: T;
  };
  personalInfoForm: {
    /**
     * @default 'Email address'
     */
    emailTitle: T;

    /**
     * @default 'Password'
     */
    passwordTitle: T;

    /**
     * @default 'Change Password'
     */
    passwordChangeActionText: T;

    /**
     * @default 'First name'
     */
    firstNameTitle: T;

    /**
     * @default 'Last name'
     */
    lastNameTitle: T;

    /**
     * @default 'Save'
     */
    submitButtonText: T;

    /**
     * @default 'Your personal info has been updated'
     */
    submitToastText: T;

    /**
     * @default 'Customer Support'
     */
    customerSupport: T;
  };

  /**
   * @default 'Delete Account'
   */
  deleteAccountButtonText: T;

  verfiyEmailWarning: {
    /**
     * @default 'Email address needs verification. <verifyLink/>'
     */
    message: T;

    /**
     * @default 'Verify email address'
     */
    linkText: T;
  };
  MFASettings: {
    /**
     * @default 'Turn Off Two-Factor Authentication'
     */
    disableButtonTitle: T;

    /**
     * @default 'Set Up Two-Factor Authentication'
     */
    enableButtonTitle: T;

    /**
     * @default 'Please contact <Link/> for assistance.'
     */
    notSupportedText: T;

    /**
     * @default 'Two-Factor Authentication not available for this account.'
     */
    notSupportedTitle: T;

    /**
     * @default 'Enable Two-Factor Authentication'
     */
    title: T;

    /**
     * @default 'Two-Factor Authentication is On'
     */
    titleEnabled: T;

    /**
     * @default 'Your account is protected with a required login code from your authentication app.'
     */
    enabledTextDescription: T;

    /**
     * @default 'Protect your account with a login code when you sign in on a device we don’t recognize.'
     */
    description: T;

    /**
     * @default 'Two-factor authentication is now enabled'
     */
    successMFA: T;

    /**
     * @default 'Two-factor is now enabled'
     */
    successMFAMobile: T;

    /**
     * @default 'Two-factor authentication has been disabled'
     */
    successMFAReseted: T;

    /**
     * @default 'Two-factor is now disabled'
     */
    successMFAResetedMobile: T;
  };
  resetMFA: {
    /**
     * @default 'Two-Factor Authentication is Enabled'
     */
    title: T;

    /**
     * @default 'Remove Two-Factor Authentication'
     */
    confirmButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Your account is more secure when you need a password and a login code to sign in. If you remove this extra layer of security, you will only be asked for a password when you sign in. You will have to sign in again after removing two-factor authentication.'
     */
    message: T;
  };
  noEventsSection: {
    /**
     * @default 'There are no events for {{email}}.'
     */
    noEventsForEmail: T;

    /**
     * @default 'If you created an event and expected to find it here, <signInLink/>.'
     */
    incorrectAccount: T;

    /**
     * @default 'try signing in a different way'
     */
    incorrectSignInLinkText: T;

    /**
     * @default 'The email we sent from “Joy Team” with subject “Welcome to Joy” will tell you how to sign in.'
     */
    accountEmailHint: T;

    /**
     * @default 'Create your first event'
     */
    heading: T;

    /**
     * @default 'Get your wedding plans started or add the perfect gifts for your baby registry.'
     */
    description: T;
  };
};

export type ActionBarTranslations<T extends LeafNodeValue = TranslateFunction> = {
  text: {
    /**
     * @default '{{date}}'
     */
    date: T;

    /**
     * @default 'Hello {{guestName}}. '
     */
    personalizedText: T;
  };
  buttons: {
    /**
     * @default 'Not You?'
     */
    buttonNotYou: T;
  };
  quick: {
    /**
     * @default 'Now Live'
     */
    qVdWI: T;

    /**
     * @default 'Join Livestream'
     */
    wEPDO: T;
  };
};

export type AddFromFriendsRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  banner: {
    /**
     * @default 'Only with Joy'
     */
    eyebrow: T;

    /**
     * @default 'Add gifts from'
     */
    title: T;

    /**
     * @default 'anyone’s registry'
     */
    titleAnyones: T;

    /**
     * @default 'a friend’s registry'
     */
    titleFriends: T;

    /**
     * @default 'a family’s registry'
     */
    titleFamily: T;

    /**
     * @default 'a celebrity’s registry'
     */
    titleCelebrities: T;

    /**
     * @default 'We’ll collect their gifts so you can pick what to add.'
     */
    content: T;

    /**
     * @default 'Registry URL'
     */
    inputTitle: T;

    /**
     * @default 'https://myfriendsregistry.com/gifts'
     */
    inputPlaceholder: T;

    /**
     * @default 'Supported Registries: Babylist, Amazon, Target'
     */
    inputHint: T;

    /**
     * @default 'Get Started'
     */
    ctaText: T;

    errors: {
      /**
       * @default 'This URL seems incorrect.'
       */
      registryUrlInvalid: T;

      /**
       * @default 'Please enter URL.'
       */
      registryUrlRequired: T;

      reasonCode: {
        /**
         * @default 'Sorry! We don’t support that platform or retailer yet.'
         */
        unsupportedDomain: T;

        /**
         * @default 'Oops! This URL seems not right. Copy the link once again and give it another go!'
         */
        invalidRegistryUrl: T;

        /**
         * @default 'Uh oh, it looks like the registry exists, but it's not public yet.'
         */
        registryIsPrivate: T;

        /**
         * @default 'Oops! Something went wrong. Please try again later!'
         */
        registryUnavailable: T;
      };
    };
  };
  scannedRegistriesTracker: {
    /**
     * @default 'Your Friends’ Registries'
     */
    title: T;

    /**
     * @default 'Browse Registries'
     */
    titleMobile: T;

    /**
     * @default 'Only the items you select will be added to your Registry.'
     */
    textMobile: T;

    table: {
      /**
       * @default '{{registryName}} Registry'
       */
      registry: T;

      /**
       * @default 'Registry Name'
       */
      registryName: T;

      /**
       * @default 'Registry URL'
       */
      registryURL: T;

      /**
       * @default 'Scan Date'
       */
      scanDate: T;

      /**
       * @default 'Progress'
       */
      progress: T;

      /**
       * @default 'View Gifts'
       */
      viewGifts: T;
    };

    /**
     * @default 'Show All'
     */
    showAll: T;

    status: {
      /**
       * @default 'Failed'
       */
      failed: T;

      /**
       * @default 'Scanning'
       */
      inProgress: T;

      /**
       * @default 'Scanned'
       */
      ready: T;
    };
    menu: {
      /**
       * @default 'Browse Gifts'
       */
      share: T;

      /**
       * @default 'View Friend’s Registry'
       */
      preview: T;

      /**
       * @default 'Remove Registry'
       */
      delete: T;
    };
    shareRegistryDialog: {
      /**
       * @default 'Share this Registry Page'
       */
      title: T;

      /**
       * @default 'Gifts Scan Page'
       */
      subTitle: T;

      /**
       * @default 'Open New Tab'
       */
      openNewTabButton: T;

      /**
       * @default '✨ Registry Link Copied to Clipboard ✨'
       */
      toastText: T;
    };
    deleteRegistryDialog: {
      /**
       * @default 'Are you sure you want to remove {{registryName}} from your Add from Friend's Registry list?'
       */
      title: T;

      /**
       * @default 'Deleting this registry will remove it from the list of registries from which you can add gifts. If you change your mind, you can always add the registry again in the future.'
       */
      text: T;

      /**
       * @default 'Note: This will not affect the gifts that you already added to your Registry.'
       */
      note: T;

      /**
       * @default 'Delete Registry'
       */
      deleteCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'All Done!'
       */
      deleteConfirmTitle: T;

      /**
       * @default '{{registryName}} was deleted successfully.'
       */
      deleteConfirmSubTitle: T;

      /**
       * @default 'If you change your mind, you can always enter the Registry URL and scan it again.'
       */
      deleteConfirmText: T;

      /**
       * @default 'Done'
       */
      deleteConfirmCta: T;
    };
  };
  scannedRegistriesWidget: {
    /**
     * @default 'Add From Friend’s Registry'
     */
    title: T;

    /**
     * @default '{{registryName}} Registry'
     */
    registryName: T;

    /**
     * @default 'See All'
     */
    seeAllCta: T;

    /**
     * @default 'Add New Registry'
     */
    addNewRegistryCta: T;

    emptyState: {
      /**
       * @default 'Add gifts from your friend’s registry. We’ll collect their gifts so you can pick what to add.'
       */
      message: T;

      /**
       * @default 'Get Started'
       */
      ctaText: T;
    };
  };
  howItWorks: {
    /**
     * @default 'How It Works'
     */
    title: T;

    /**
     * @default 'Start with adding gifts from the registries of those around you, it’s so simple and fun.'
     */
    text: T;

    steps: [
      {
        /**
         * @default 'Step One'
         */
        eyebrow: T;

        /**
         * @default 'Get your friend's registry link.'
         */
        title: T;

        /**
         * @default 'Copy the link from a friend’s registry and paste it at the top of this page.'
         */
        text: T;
      },
      {
        /**
         * @default 'Step Two'
         */
        eyebrow: T;

        /**
         * @default 'Let the scanning magic happen.'
         */
        title: T;

        /**
         * @default 'We’ll gather your friend’s registry gifts, so you choose which gifts you’d like to add to yours.'
         */
        text: T;
      },
      {
        /**
         * @default 'Step Three'
         */
        eyebrow: T;

        /**
         * @default 'Browse gifts to add to your registry.'
         */
        title: T;

        /**
         * @default 'Select the gifts you want to add to your registry.'
         */
        text: T;
      },
      {
        /**
         * @default 'Step Four'
         */
        eyebrow: T;

        /**
         * @default 'Add gifts to your registry.'
         */
        title: T;

        /**
         * @default 'Click on the Add Gifts button and that’s it. You’ve successfully added gifts to your Baby Registry.'
         */
        text: T;
      },
    ];
  };
  faqs: {
    /**
     * @default 'Frequently Asked Questions'
     */
    title: T;

    questions: {
      baby: [
        {
          /**
           * @default '1'
           */
          id: T;

          /**
           * @default 'Which platforms do you currently support?'
           */
          Q: T;

          /**
           * @default 'We currently support Amazon, Target and Babylist! we also support more stores from our wedding registry product.'
           */
          A: T;
        },
        {
          /**
           * @default '2'
           */
          id: T;

          /**
           * @default 'How long does it take to gather gifts from the external registry?'
           */
          Q: T;

          /**
           * @default 'It takes around 10-30 seconds for most registries, but it can take longer for larger registries. Hang tight, it shouldn’t take too long.'
           */
          A: T;
        },
        {
          /**
           * @default '3'
           */
          id: T;

          /**
           * @default 'What if I accidentally close the page when the gifts are being gathered?'
           */
          Q: T;

          /**
           * @default 'Scanning will continue in the background. You can always access the page again by clicking on the banner on the Shop Homepage or from the widget on the left side of your Manage Page.'
           */
          A: T;
        },
        {
          /**
           * @default '4'
           */
          id: T;

          /**
           * @default 'Do I have to use a friend’s registry?'
           */
          Q: T;

          /**
           * @default 'No, it could be also be a registry from a family member, coworker, or influencer. Friends, family, and coworkers shared their registry links with us when we had our own little ones. Finding and picking gifts can be overwhelming who better to trust than those around you who have done it first! Now you can use this feature to shop their registries and quickly draw inspiration for your own.'
           */
          A: T;
        },
        {
          /**
           * @default '5'
           */
          id: T;

          /**
           * @default 'Are these registries publicly visible to my gift-givers?'
           */
          Q: T;

          /**
           * @default 'No, they are only visible to you and other admins of your registry. Registries in the “Add From Friends” feature are never shown to your gift-givers, or on your public registry. This feature allows you to more easily shop from your friend’s registries.'
           */
          A: T;
        },
        {
          /**
           * @default '6'
           */
          id: T;

          /**
           * @default 'How many registries can I bring in?'
           */
          Q: T;

          /**
           * @default 'You can add as many registries as you want, that’s totally up to you. If the registry you scanned was updated, you can delete it and rescan it.'
           */
          A: T;
        },
        {
          /**
           * @default '7'
           */
          id: T;

          /**
           * @default 'Do I have to add all the gifts from the registry?'
           */
          Q: T;

          /**
           * @default 'No, you can pick and choose which items to add. Nothing is stopping you from adding them all though with one click if that’s what you want.'
           */
          A: T;
        },
        {
          /**
           * @default '8'
           */
          id: T;

          /**
           * @default 'If I delete a scanned Registry from Add From Friend’s Registry page, does it delete the gifts in my registry?'
           */
          Q: T;

          /**
           * @default 'No, deleting the scanned registry will keep the items you added in your registry. When you delete one of these Add From Friend’s Registries, you won’t see it in the list and you will not be able to add more items to your registry from your friend’s registry, unless you decide to scan it again.'
           */
          A: T;
        },
      ];

      wedding: [
        {
          /**
           * @default '1'
           */
          id: T;

          /**
           * @default 'Which platforms do you currently support?'
           */
          Q: T;

          /**
           * @default 'We currently support All the same registries that we offer for syncing including Amazon, Target, Crate & Barrel and many more.'
           */
          A: T;
        },
        {
          /**
           * @default '2'
           */
          id: T;

          /**
           * @default 'How long does it take to gather gifts from the external registry?'
           */
          Q: T;

          /**
           * @default 'It takes around 10-30 seconds for most registries, but it can take longer for larger registries. Hang tight, it shouldn’t take too long.'
           */
          A: T;
        },
        {
          /**
           * @default '3'
           */
          id: T;

          /**
           * @default 'What if I accidentally close the page when the gifts are being gathered?'
           */
          Q: T;

          /**
           * @default 'Scanning will continue in the background. You can always access the page again by clicking on the banner on the Shop Homepage or from the widget on the left side of your Manage Page.'
           */
          A: T;
        },
        {
          /**
           * @default '4'
           */
          id: T;

          /**
           * @default 'Do I have to use a friend’s registry?'
           */
          Q: T;

          /**
           * @default 'No, it could be also be a registry from a family member, coworker, or influencer. Finding and picking gifts can be overwhelming who better to trust than those around you who have done it first! Now you can use this feature to shop their registries and quickly draw inspiration for your own wedding registry.'
           */
          A: T;
        },
        {
          /**
           * @default '5'
           */
          id: T;

          /**
           * @default 'Are these registries publicly visible to my gift-givers?'
           */
          Q: T;

          /**
           * @default 'No, they are only visible to you and other admins of your registry. Registries in the “Add From Friends” feature are never shown to your gift-givers, or on your public registry. This feature allows you to more easily shop from your friend’s registries.'
           */
          A: T;
        },
        {
          /**
           * @default '6'
           */
          id: T;

          /**
           * @default 'How many registries can I bring in?'
           */
          Q: T;

          /**
           * @default 'You can add as many registries as you want, that’s totally up to you. If the registry you scanned was updated, you can delete it and rescan it. '
           */
          A: T;
        },
        {
          /**
           * @default '7'
           */
          id: T;

          /**
           * @default 'Do I have to add all the gifts from the registry?'
           */
          Q: T;

          /**
           * @default 'No, you can pick and choose which items to add. Nothing is stopping you from adding them all though with one click if that’s what you want. '
           */
          A: T;
        },
        {
          /**
           * @default '8'
           */
          id: T;

          /**
           * @default 'If I delete a scanned Registry from Add From Friend’s Registry page, does it delete the gifts in my registry?'
           */
          Q: T;

          /**
           * @default 'No, deleting the scanned registry will keep the items you added in your registry. When you delete one of these Add From Friend’s Registries, you won’t see it in the list and you will not be able to add more items to your registry from your friend’s registry, unless you decide to scan it again.'
           */
          A: T;
        },
      ];
    };
  };
  scanned: {
    /**
     * @default 'Back'
     */
    backCta: T;

    /**
     * @default 'Scanned {{scannedDate}}'
     */
    scannedDate: T;

    /**
     * @default 'Latest gift scan: {{scannedDate}}'
     */
    latestScannedDate: T;

    /**
     * @default 'Add from {{registryName}}'
     */
    addFromTitle: T;

    /**
     * @default 'How do I edit a gift?'
     */
    howToEditGift: T;

    /**
     * @default 'Select All'
     */
    selectAllCta: T;

    /**
     * @default 'Select Gifts to Add'
     */
    selectGiftsCta: T;

    /**
     * @default 'Add {{count}} Gift'
     */
    addGiftCta: T;

    /**
     * @default 'Add {{count}} Gifts'
     */
    addGiftsCta: T;

    /**
     * @default 'You can edit gift details, such as quantity, title, etc. after you add the gift to your registry.'
     */
    tooltip: T;

    /**
     * @default 'How to add a gift'
     */
    tooltipAlt: T;

    /**
     * @default 'Cash Fund'
     */
    cashFund: T;

    /**
     * @default '🎉 Yay! We’ve added {{count}} gift to your registry!'
     */
    addedItemToRegistry: T;

    /**
     * @default '🎉 Yay! We’ve added {{count}} gifts to your registry!'
     */
    addedItemsToRegistry: T;

    giftsNotFound: {
      /**
       * @default 'This Registry doesn’t seem to have any items.'
       */
      message: T;

      /**
       * @default 'Please check again'
       */
      ctaText: T;
    };
  };
  scannerDialog: {
    inProgress: {
      /**
       * @default 'Gathering gifts for your inspiration…'
       */
      title: T;

      /**
       * @default 'This will only take a moment.'
       */
      text: T;
    };
    failed: {
      /**
       * @default 'Gathering gifts for your inspiration…'
       */
      title: T;

      /**
       * @default 'This will only take a moment.'
       */
      text: T;
    };
    ready: {
      /**
       * @default 'All done!'
       */
      title: T;

      /**
       * @default 'Now you can select gifts you’d like to add.'
       */
      text: T;
    };

    /**
     * @default 'Select Gifts'
     */
    ctaText: T;
  };
};

export type AddGiftFromStoresPopupTranslations<T extends LeafNodeValue = TranslateFunction> = {
  areYounInterestedPopup: {
    /**
     * @default 'Are You Interested in Adding Gifts from These Stores?'
     */
    title: T;

    /**
     * @default 'Yes, I am!'
     */
    primaryButtonText: T;

    /**
     * @default 'Not Interested'
     */
    secondaryButtonText: T;
  };
  browseGiftPopup: {
    /**
     * @default 'Get It All And More With Joy Registry.'
     */
    title: T;

    /**
     * @default 'Shop Joy and all your favorite retailers in one place.'
     */
    message1: T;

    /**
     * @default 'Create unlimited cash funds with zero-fees'
     */
    message2: T;

    /**
     * @default 'Add gifts from any store and share with one link'
     */
    message3: T;

    /**
     * @default 'Browse Gifts'
     */
    primaryButtonText: T;

    /**
     * @default 'Remind Me Later'
     */
    secondaryButtonText: T;
  };
  registryReminder: {
    /**
     * @default 'Registry Reminder'
     */
    title: T;

    /**
     * @default 'Share your phone number and/or email, and we’ll remind you about <b>creating your wedding registry.</b>'
     */
    subTitle: T;

    /**
     * @default 'Phone Number'
     */
    phoneNumber: T;

    /**
     * @default 'Remind Me In'
     */
    remindMeIn: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Remind me about other milestones'
     */
    remindMeAboutOtherMilestones: T;

    /**
     * @default 'Notify Me'
     */
    notifyMe: T;

    /**
     * @default 'By clicking notify me, you consent the use of your information in accordance with Joy’s privacy policy.'
     */
    footer: T;

    /**
     * @default 'Phone number is not valid'
     */
    phoneNumberNotValid: T;
  };
  youAreAllSet: {
    /**
     * @default 'You’re All Set'
     */
    title: T;

    /**
     * @default 'We’ll send you a reminder about your wedding registry {{reminderTime}} before your event.'
     */
    subTitle: T;

    /**
     * @default 'All Done'
     */
    buttonText: T;
  };
};

export type AddToCalendarTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Google'
   */
  google: T;

  /**
   * @default 'iCal'
   */
  ical: T;

  /**
   * @default 'Outlook'
   */
  outlook: T;

  /**
   * @default 'Cancel'
   */
  cancel: T;

  /**
   * @default 'Apple'
   */
  apple: T;
};

export type AdminDashboardTranslations<T extends LeafNodeValue = TranslateFunction> = {
  sections: {
    website: {
      /**
       * @default 'Website'
       */
      title: T;

      children: {
        design: {
          /**
           * @default 'Design'
           */
          title: T;

          children: {};
        };
        photos: {
          /**
           * @default 'Photos'
           */
          title: T;

          children: {};
        };
        eventDetails: {
          /**
           * @default 'Event Details'
           */
          title: T;

          children: {};
        };
        editPages: {
          /**
           * @default 'Edit Pages'
           */
          title: T;

          children: {
            welcome: {
              /**
               * @default 'Welcome'
               */
              title: T;

              children: {};
            };
            video: {
              /**
               * @default 'Video'
               */
              title: T;

              children: {};
            };
            story: {
              /**
               * @default 'Story'
               */
              title: T;

              children: {};
            };
            schedule: {
              /**
               * @default 'Schedule'
               */
              title: T;

              children: {};
            };
            travel: {
              /**
               * @default 'Travel'
               */
              title: T;

              children: {};
            };
            guest: {
              /**
               * @default 'Guest Q&A'
               */
              title: T;

              children: {};
            };
            weddingParty: {
              /**
               * @default 'Wedding Party'
               */
              title: T;

              children: {};
            };
            registry: {
              /**
               * @default 'Registry'
               */
              title: T;

              children: {};
            };
            addNewPage: {
              /**
               * @default 'Add New Page'
               */
              title: T;

              children: {};
            };
            managePages: {
              /**
               * @default 'Manage Pages'
               */
              title: T;

              children: {};
            };
          };
        };
      };
    };
    registry: {
      /**
       * @default 'Registry'
       */
      title: T;

      children: {
        manage: {
          /**
           * @default 'Manage'
           */
          title: T;

          children: {};
        };
        shop: {
          /**
           * @default 'Shop'
           */
          title: T;

          children: {};
        };
      };
    };
    planning: {
      /**
       * @default 'Planning'
       */
      title: T;

      children: {
        schedule: {
          /**
           * @default 'Schedule'
           */
          title: T;

          children: {};
        };
        guestList: {
          /**
           * @default 'Guest List'
           */
          title: T;

          children: {};
        };
        rsvp: {
          /**
           * @default 'RSVP Questions'
           */
          title: T;

          children: {};
        };
        send: {
          /**
           * @default 'Send'
           */
          title: T;

          children: {
            invitation: {
              /**
               * @default 'Invitation eCard'
               */
              title: T;

              children: {};
            };
            saveTheDate: {
              /**
               * @default 'Save the Date eCard'
               */
              title: T;

              children: {};
            };
            changeTheDate: {
              /**
               * @default 'Change the Date eCard'
               */
              title: T;

              children: {};
            };
            custom: {
              /**
               * @default 'Custom eCard'
               */
              title: T;

              children: {};
            };
            reminder: {
              /**
               * @default 'Reminder Email'
               */
              title: T;

              children: {};
            };
            general: {
              /**
               * @default 'General Message Email'
               */
              title: T;

              children: {};
            };
            thankyou: {
              /**
               * @default 'Thank You Note'
               */
              title: T;

              children: {};
            };
          };
        };
      };
    };
  };
};

export type AdminDashboardV2Translations<T extends LeafNodeValue = TranslateFunction> = {
  inviteAdminDialog: {
    /**
     * @default 'Event Admins'
     */
    title: T;
  };
  visibility: {
    /**
     * @default 'On'
     */
    on: T;

    /**
     * @default 'Off'
     */
    off: T;

    /**
     * @default 'RSVP On'
     */
    rsvpOn: T;

    /**
     * @default 'RSVP Off'
     */
    rsvpOff: T;

    /**
     * @default 'Hidden'
     */
    hidden: T;

    /**
     * @default 'Public'
     */
    public: T;

    /**
     * @default 'Password Protected'
     */
    passwordProtected: T;
  };
  text: {
    /**
     * @default 'Loading admin dashboard'
     */
    loading: T;

    /**
     * @default 'New'
     */
    newBadge: T;
  };
  sections: {
    registry: {
      /**
       * @default 'Registry'
       */
      title: T;

      children: {
        overview: {
          /**
           * @default 'Overview'
           */
          title: T;

          /**
           * @default 'Registry'
           */
          experimentTitle: T;

          children: {};
        };
        track: {
          /**
           * @default 'Track & Thank'
           */
          title: T;

          children: {};
        };
        manage: {
          /**
           * @default 'Manage Registry'
           */
          title: T;

          children: {};
        };
        shop: {
          /**
           * @default 'Add Gifts'
           */
          title: T;

          /**
           * @default 'Add Gifts'
           */
          experimentTitle: T;

          children: {};
        };
      };
    };
    website: {
      /**
       * @default 'Website'
       */
      title: T;

      children: {
        editPages: {
          /**
           * @default 'Edit Pages'
           */
          title: T;

          children: {};
        };
      };
    };
    invites: {
      /**
       * @default 'Cards & Messaging'
       */
      title: T;

      children: {
        saveTheDates: {
          /**
           * @default 'Save the Dates'
           */
          title: T;

          children: {
            print: {
              /**
               * @default 'Paper Cards'
               */
              title: T;

              children: {};
            };
            digital: {
              /**
               * @default 'Digital Cards'
               */
              title: T;

              children: {};
            };
          };
        };
        invitations: {
          /**
           * @default 'Invitations'
           */
          title: T;

          children: {
            print: {
              /**
               * @default 'Paper Cards'
               */
              title: T;

              children: {};
            };
            digital: {
              /**
               * @default 'Digital Cards'
               */
              title: T;

              children: {};
            };
          };
        };
        dayOfStationery: {
          /**
           * @default 'Day-of'
           */
          title: T;

          children: {
            signs: {
              /**
               * @default 'Signs'
               */
              title: T;

              children: {};
            };
            menus: {
              /**
               * @default 'Menus'
               */
              title: T;

              children: {};
            };
            napkins: {
              /**
               * @default 'Napkins'
               */
              title: T;

              children: {};
            };
          };
        };
        thankYou: {
          /**
           * @default 'Thank You Cards'
           */
          title: T;

          children: {};
        };
        customCards: {
          /**
           * @default 'Custom Card'
           */
          title: T;

          children: {};
        };
        print: {
          /**
           * @default 'Paper Cards'
           */
          title: T;

          children: {
            invitations: {
              /**
               * @default 'Invitations'
               */
              title: T;

              children: {};
            };
            saveTheDates: {
              /**
               * @default 'Save the Dates'
               */
              title: T;

              children: {};
            };
            thankYou: {
              /**
               * @default 'Thank You'
               */
              title: T;

              children: {};
            };
          };
        };
        digital: {
          /**
           * @default 'Digital Cards'
           */
          title: T;

          children: {
            invitations: {
              /**
               * @default 'Invitations'
               */
              title: T;

              children: {};
            };
            saveTheDates: {
              /**
               * @default 'Save the Dates'
               */
              title: T;

              children: {};
            };
            customCard: {
              /**
               * @default 'Custom Cards'
               */
              title: T;

              children: {};
            };
          };
        };
        emails: {
          /**
           * @default 'Emails'
           */
          title: T;

          children: {
            reminder: {
              /**
               * @default 'Reminder Email'
               */
              title: T;

              children: {};
            };
            general: {
              /**
               * @default 'General Message'
               */
              title: T;

              children: {};
            };
          };
        };
        messaging: {
          /**
           * @default 'Messaging'
           */
          title: T;

          children: {
            rsvp: {
              /**
               * @default 'RSVP Reminder'
               */
              title: T;

              children: {};
            };
            reminder: {
              /**
               * @default 'Reminder Email'
               */
              title: T;

              children: {};
            };
            hotel: {
              /**
               * @default 'Hotel Reminder'
               */
              title: T;

              children: {};
            };
            general: {
              /**
               * @default 'General Message'
               */
              title: T;

              children: {};
            };
            tracking: {
              /**
               * @default 'Tracking'
               */
              title: T;

              children: {};
            };
          };
        };
      };
    };
    guestList: {
      /**
       * @default 'Planning & RSVP'
       */
      title: T;

      children: {
        guestList: {
          /**
           * @default 'Guest List'
           */
          title: T;

          children: {};
        };
        contactCollector: {
          /**
           * @default 'Contact Collector'
           */
          title: T;

          children: {};
        };
        rsvp: {
          /**
           * @default 'Manage RSVP'
           */
          title: T;

          children: {};
        };
        weddingShop: {
          /**
           * @default 'Decor & Favors'
           */
          title: T;

          children: {};
        };
        hotels: {
          /**
           * @default 'Hotels'
           */
          title: T;

          children: {
            roomBlocks: {
              /**
               * @default 'Room Blocks'
               */
              title: T;

              children: {};
            };
            honeymoon: {
              /**
               * @default 'Honeymoon'
               */
              title: T;

              children: {};
            };
          };
        };
      };
    };
  };
  valuePropositions: {
    postWeddingDiscount: {
      /**
       * @default 'Registry Completion Discount'
       */
      title: T;

      /**
       * @default 'Save 20% on all remaining items in your registry.'
       */
      description: T;
    };
    priceMatchPromise: {
      /**
       * @default 'Price Match Promise'
       */
      title: T;

      /**
       * @default 'If you find a lower price on Registry items, we’ll match it!'
       */
      description: T;
    };
    freeShipping: {
      /**
       * @default 'Free Shipping'
       */
      title: T;

      /**
       * @default 'Enjoy free standard shipping on all your registry gifts.'
       */
      description: T;
    };
    easyReturns: {
      /**
       * @default 'Easy Returns'
       */
      title: T;

      /**
       * @default 'Free and easy online returns let you get the gift you want'
       */
      description: T;
    };
    general: {
      /**
       * @default 'Get Started'
       */
      cta: T;
    };
  };
  printEarlyAccessDialog: {
    /**
     * @default 'Find Your Perfect Match'
     */
    eyebrow: T;

    /**
     * @default 'With Joy Paper, you can customize gorgeous Save the Dates and wedding invitations as unique as your love story.'
     */
    title: T;

    features: [
      /**
       * @default 'Match your wedding website'
       */
      T,
      /**
       * @default 'Add your own design'
       */
      T,
      /**
       * @default 'QR code for simple sharing'
       */
      T,
      /**
       * @default 'Premium invitation suites'
       */
      T,
      /**
       * @default 'Send paper & digital cards'
       */
      T,
      /**
       * @default 'Endless customization'
       */
      T,
    ];

    /**
     * @default 'Browse Card Designs'
     */
    cta: T;

    legacyContent: {
      /**
       * @default 'Introducing'
       */
      eyebrow: T;

      /**
       * @default 'Joy Paper'
       */
      title: T;

      /**
       * @default 'Explore Designs'
       */
      cta: T;

      promo: {
        /**
         * @default 'Get {{percentageDiscount}} off to print your favorite Save the Dates and Invitations with the exclusive discount.'
         */
        description: T;
      };
      nonPromo: {
        /**
         * @default 'Design and print your favorite Save the Dates and Invitations.'
         */
        description: T;
      };
    };
  };
  addressReminderBanner: {
    /**
     * @default 'Registry - Avoid missing packages and awkward texts, we’ll take care of the rest.'
     */
    description: T;

    /**
     * @default 'Add Shipping Address'
     */
    buttonLabel: T;
  };
  multiProductPromoBanner: {
    /**
     * @default 'Learn More'
     */
    learnMoreCta: T;

    valueProps: {
      hotelBlocks: {
        /**
         * @default 'Room Blocks by Joy. Get discounted hotel rates with no commitment.'
         */
        valuePropMessage: T;

        /**
         * @default 'Introducing Room Block Discounts'
         */
        title: T;

        /**
         * @default 'Pick hotels near your venue and take care of your guests with great rates and no fees.'
         */
        description: T;

        /**
         * @default 'Explore Hotels'
         */
        ctaText: T;
      };
      printAndDigital: {
        /**
         * @default 'Create Beautiful Paper and Digital Save the Dates and Invitations.'
         */
        valuePropMessage: T;

        /**
         * @default 'Paper and Digital Cards'
         */
        title: T;

        /**
         * @default 'Match your wedding website or pick your favorite Save the Date or Invitation design.'
         */
        description: T;

        /**
         * @default 'Explore Designs'
         */
        ctaText: T;
      };
      registry: {
        /**
         * @default 'Meet the Everything Registry. Add Gifts from Anywhere.'
         */
        valuePropMessage: T;

        /**
         * @default 'Meet the Everything Registry'
         */
        title: T;

        /**
         * @default 'Shop the top brands, cash funds and experiences all in one place. Add gifts from any store.'
         */
        description: T;

        /**
         * @default 'Browse Gifts'
         */
        ctaText: T;
      };
    };
  };
  multiProductPromoDialog: {
    /**
     * @default 'Unlock the Best of Joy'
     */
    dialogTitle: T;

    /**
     * @default 'Discover how we can help plan your wedding.'
     */
    dialogDescription: T;

    /**
     * @default 'Next'
     */
    nextCta: T;

    steps: {
      hotelBlocks: {
        /**
         * @default 'Hotel Room Blocks'
         */
        stepperLabel: T;

        /**
         * @default 'Hotel Room Blocks'
         */
        title: T;

        /**
         * @default 'Pick hotels near your venue and let our free concierge agent negotiate exclusive rates for you and your guests.'
         */
        description: T;

        /**
         * @default 'Explore Hotels'
         */
        ctaText: T;
      };
      printAndDigital: {
        /**
         * @default 'Paper & Digital Cards'
         */
        stepperLabel: T;

        /**
         * @default 'Paper and Digital Cards'
         */
        title: T;

        /**
         * @default 'Match your wedding website or pick your favorite Save the Date or Invitation design to celebrate your special day.'
         */
        description: T;

        /**
         * @default 'Explore Designs'
         */
        ctaText: T;
      };
      registry: {
        /**
         * @default 'Universal Registry'
         */
        stepperLabel: T;

        /**
         * @default 'Meet the Everything Registry'
         */
        title: T;

        /**
         * @default 'Shop the top brands, cash funds and experiences all in one place. Add gifts from any store.'
         */
        description: T;

        /**
         * @default 'Browse Gifts'
         */
        ctaText: T;
      };
    };
  };
  checklist: {
    progressBar: {
      /**
       * @default 'Planning Checklist'
       */
      titleExpanded: T;

      /**
       * @default '{{count}} Days til the big day!'
       */
      titleCollapsedUntil: T;

      /**
       * @default 'Tomorrow is the big day!'
       */
      titleCollapseTomorrow: T;

      /**
       * @default 'Today is the big day!'
       */
      titleCollapsedToday: T;

      /**
       * @default 'Congratulations on your wedding!'
       */
      titleCollapsedPast: T;

      /**
       * @default '0 of 6 Complete'
       */
      counter0: T;

      /**
       * @default '1 of 6 Complete ✨ Keep it up!'
       */
      counter1: T;

      /**
       * @default '2 of 6 Complete 🌈 Nice work!'
       */
      counter2: T;

      /**
       * @default '3 of 6 Complete 🎉 Halfway there!'
       */
      counter3: T;

      /**
       * @default '4 of 6 Complete 🔥 You’re on fire!'
       */
      counter4: T;

      /**
       * @default '5 of 6 Complete 😎 Nearly there!'
       */
      counter5: T;

      /**
       * @default '6 of 6 Complete 💍 Time to party!'
       */
      counter6: T;

      /**
       * @default '{{count}} Day left'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} Day left
       * - plural: {{count}} Days left
       */
      countdown: T;

      /**
       * @default 'Today is the day!'
       */
      countdownToday: T;

      /**
       * @default 'Congratulations!'
       */
      countdownCongrats: T;
    };
    reminderButton: {
      /**
       * @default 'Plan It'
       */
      noDate: T;

      /**
       * @default 'Change Date'
       */
      changeDate: T;
    };
    groupModal: {
      /**
       * @default 'Visit our Help Center'
       */
      helpCenter: T;

      /**
       * @default 'Contact Support'
       */
      support: T;

      items: {
        reviewEventDetails: {
          /**
           * @default 'Make sure to set up the basics'
           */
          subtitle: T;

          /**
           * @default 'Because it never hurts to triple check!'
           */
          tip: T;
        };
        createWeddingWebsite: {
          /**
           * @default 'All the details for you and your guests.'
           */
          subtitle: T;

          /**
           * @default 'Most Joy couples start here and finish pre-invites.'
           */
          tip: T;
        };
        saveTheDate: {
          /**
           * @default 'A mix of paper and digital cards is most common.'
           */
          subtitle: T;

          /**
           * @default 'Most Joy couples do this 8-12 months before their event.'
           */
          tip: T;
        };
        readyYourRegistry: {
          /**
           * @default 'Finish before invites and avoid the awkward.'
           */
          subtitle: T;

          /**
           * @default 'Most Joy couples do this 4 months before their event.'
           */
          tip: T;
        };
        beTheSuperHost: {
          /**
           * @default 'Help your guests save and celebrate.'
           */
          subtitle: T;

          /**
           * @default 'Most Joy couples do this 4 months before their event.'
           */
          tip: T;
        };
        sendOutInvitations: {
          /**
           * @default 'Guests will ask you about registry and accommodations so it is best finish these first.'
           */
          subtitle: T;

          /**
           * @default 'Most Joy couples do this 6-8 weeks before their event.'
           */
          tip: T;
        };
      };
    };
  };
  stats: {
    progressType: {
      /**
       * @default 'Goal'
       */
      goal: T;
    };
    guestList: {
      /**
       * @default 'Guest List'
       */
      title: T;
    };
    potentialGuests: {
      /**
       * @default 'Potential Guests'
       */
      cta: T;

      /**
       * @default 'Edit Guest List'
       */
      ctaHover: T;
    };
    contactsCollected: {
      /**
       * @default 'Contacts Collected'
       */
      cta: T;

      /**
       * @default 'Open Collector'
       */
      ctaHover: T;
    };
    saveTheDates: {
      /**
       * @default 'Save the Dates'
       */
      title: T;
    };
    printsOrdered: {
      /**
       * @default 'Prints Ordered'
       */
      cta: T;

      /**
       * @default 'Start Design'
       */
      ctaHover: T;
    };
    digitalCardsSent: {
      /**
       * @default 'Digital Cards Sent'
       */
      cta: T;

      /**
       * @default 'Send Digital Cards'
       */
      ctaHover: T;
    };
    hotels: {
      /**
       * @default 'Hotels'
       */
      title: T;
    };
    hotelWishList: {
      /**
       * @default 'Hotel Wish List'
       */
      cta: T;

      /**
       * @default 'Select Hotels'
       */
      ctaHover: T;
    };
    roomsRequested: {
      /**
       * @default 'Rooms Requested'
       */
      cta: T;

      /**
       * @default 'Contact Concierge'
       */
      ctaHover: T;
    };
    registry: {
      /**
       * @default 'Registry'
       */
      title: T;
    };
    giftsAvailable: {
      /**
       * @default 'Gifts Available'
       */
      cta: T;

      /**
       * @default 'Manage Gifts'
       */
      ctaHover: T;
    };
    reservedAndPurchased: {
      /**
       * @default 'Reserved & Purchased'
       */
      cta: T;

      /**
       * @default 'View Gifts Received'
       */
      ctaHover: T;
    };
    thankYouNotesSent: {
      /**
       * @default 'Thank You Notes Sent'
       */
      cta: T;

      /**
       * @default 'Send Thanks'
       */
      ctaHover: T;
    };
    cashReceived: {
      /**
       * @default 'Cash Received'
       */
      cta: T;

      /**
       * @default 'View Gifts Received & Transfer Funds'
       */
      ctaHover: T;
    };
    rsvp: {
      /**
       * @default 'RSVP'
       */
      title: T;
    };
    attending: {
      /**
       * @default 'Attending'
       */
      cta: T;

      /**
       * @default 'Open RSVPs'
       */
      ctaHover: T;
    };
    declined: {
      /**
       * @default 'Declined'
       */
      cta: T;

      /**
       * @default 'Open RSVPs'
       */
      ctaHover: T;
    };
    pending: {
      /**
       * @default 'Pending'
       */
      cta: T;

      /**
       * @default 'Open RSVPs'
       */
      ctaHover: T;
    };
    invitations: {
      /**
       * @default 'Invitations'
       */
      title: T;
    };
  };
  websitePreview: {
    /**
     * @default '{{count}} Public Page'
     * @param {number} count - The number of occurrences.
     * - singular: {{count}} Public Page
     * - plural: {{count}} Public Pages
     */
    publicPage: T;

    /**
     * @default '{{count}} Protected'
     */
    protectedPage: T;

    /**
     * @default '{{count}} Off'
     */
    off: T;

    /**
     * @default 'Edit Design'
     */
    editDesignCta: T;

    /**
     * @default 'View Website'
     */
    viewWebsiteCta: T;
  };
  reEngagementPopup: {
    hotelBlock: {
      /**
       * @default 'Finish requesting your room block'
       */
      title: T;

      /**
       * @default '{{numberOfHotels}} hotels selected'
       */
      subTitle: T;
    };
    print: {
      /**
       * @default 'Your drafts are waiting — finalize your card'
       */
      title: T;

      subTitle: {
        /**
         * @default '{{numberOfDrafts}} draft in progress'
         */
        singular: T;

        /**
         * @default '{{numberOfDrafts}} drafts in progress'
         */
        plural: T;
      };

      /**
       * @default 'Your Save The Dates are waiting'
       */
      saveTheDateTitle: T;

      /**
       * @default 'Your Invitations are waiting'
       */
      invitationTitle: T;

      /**
       * @default 'Your Thank You Cards are waiting'
       */
      thankYouTitle: T;

      /**
       * @default 'Add the finishing touches.'
       */
      cardSubtile: T;
    };
    hotelReminder: {
      /**
       * @default 'Remind your guests about accommodations'
       */
      title: T;

      /**
       * @default 'Send a friendly reminder.'
       */
      subTitle: T;
    };
  };
  thingsToDo: {
    /**
     * @default 'Introducing Things To Do'
     */
    title: T;

    /**
     * @default 'Joy has a new page to help your guests have a great trip. We’ve added top things to do in {{eventCity}} to get you started. Take a look, add your own, and make it yours.'
     */
    subtitle: T;

    /**
     * @default 'Explore Things to Do'
     */
    cta: T;

    /**
     * @default 'I’ll do this later'
     */
    ctaLater: T;
  };
  honeymoonPlanning: {
    /**
     * @default 'Introducing Local Honeymoon Experts'
     */
    title: T;

    /**
     * @default 'Your honeymoon should be as unforgettable as your wedding day. Joy has partnered with regional experts to design the trip of a lifetime.'
     */
    subtitle: T;

    /**
     * @default 'Get a free intro to a local expert'
     */
    primaryCta: T;

    /**
     * @default 'Remind me later'
     */
    secondaryCta: T;

    /**
     * @default 'I'm not interested'
     */
    notInterestedCta: T;
  };
  honeymoonSurvey: {
    /**
     * @default 'Connect with a local travel expert.'
     */
    title: T;

    /**
     * @default 'Tell us a little about your dream honeymoon.'
     */
    description: T;

    /**
     * @default 'First Name'
     */
    firstName: T;

    /**
     * @default 'First Name'
     */
    firstNamePlaceholder: T;

    /**
     * @default 'Last Name'
     */
    lastName: T;

    /**
     * @default 'Last Name'
     */
    lastNamePlaceholder: T;

    /**
     * @default 'Email Address'
     */
    email: T;

    /**
     * @default 'my@email.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Phone Number'
     */
    phone: T;

    /**
     * @default '+1-555-555-5555'
     */
    phonePlaceholder: T;

    /**
     * @default 'Honeymoon Destination'
     */
    honeymoonDestination: T;

    /**
     * @default 'Our perfect honeymoon is...'
     */
    honeymoonDestinationPlaceholder: T;

    /**
     * @default 'Next'
     */
    submitLabel: T;

    /**
     * @default 'Budget Range'
     */
    budgetRange: T;

    /**
     * @default 'Under $2,500'
     */
    budgetUnder2500: T;

    /**
     * @default '$2,500 - $5,000'
     */
    budget2500to5000: T;

    /**
     * @default '$5,000 - $7,500'
     */
    budget5000to7500: T;

    /**
     * @default '$7,500 - $10,000'
     */
    budget7500to10000: T;

    /**
     * @default 'Over $10,000'
     */
    budgetOver10000: T;

    /**
     * @default 'Loading...'
     */
    loading: T;

    /**
     * @default 'No options available'
     */
    noOptionsAvailable: T;

    /**
     * @default 'Select...'
     */
    select: T;

    /**
     * @default 'When is your ideal honeymoon?'
     */
    whenIsYourIdealHoneymoon: T;

    /**
     * @default 'Departure Date'
     */
    departureDate: T;

    /**
     * @default 'Return Date'
     */
    returnDate: T;

    /**
     * @default 'Where are you traveling from?'
     */
    whereAreYouTravelingFrom: T;

    /**
     * @default 'Departure City'
     */
    departureCity: T;

    /**
     * @default 'San Francisco, CA'
     */
    departureCityPlaceholder: T;

    /**
     * @default 'Where would you like to go?'
     */
    whereWouldYouLikeToGo: T;

    /**
     * @default 'Country'
     */
    country: T;

    /**
     * @default 'Add Another Country'
     */
    addAnotherCountry: T;

    /**
     * @default 'Next'
     */
    next: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Please complete all the fields above'
     */
    pleaseCompleteAllFields: T;

    /**
     * @default 'What is your budget range?'
     */
    budgetRangeTitle: T;

    /**
     * @default 'Couples spend an average of $5-10k.'
     */
    budgetRangeDescription: T;
  };
  honeymoonConfirmation: {
    /**
     * @default 'Thank you for your interest!'
     */
    title: T;

    /**
     * @default 'A local planning expert will reach out soon.'
     */
    subtitle: T;

    /**
     * @default 'Sounds Good'
     */
    cta: T;
  };
  quick: {
    /**
     * @default 'An error occurred while submitting your form. Please try again.'
     */
    xl21f: T;

    /**
     * @default 'Manage Collections'
     */
    AUib6: T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Home'
     */
    lgXLA: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Story & Tidbits'
     */
    MZCpe: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Guest Q & A'
     */
    sWsGi: T;

    /**
     * @default 'Wedding Party'
     */
    QfgiL: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'On'
     */
    zrAAA: T;

    /**
     * @default 'Off'
     */
    hRXAA: T;

    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Templates Gallery'
     */
    P0odk: T;

    /**
     * @default 'Your Site Design'
     */
    aW2DJ: T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Edit Pages'
     */
    '28e42': T;

    /**
     * @default 'Add New Page'
     */
    wsKWg: T;

    /**
     * @default 'Manage Pages'
     */
    Ljvjt: T;

    /**
     * @default 'Share what city or town your event takes place.'
     */
    v3lS0: T;

    /**
     * @default 'Add Event Location'
     */
    QMt5A: T;

    /**
     * @default 'Share when your event takes place.'
     */
    BSLVq: T;

    /**
     * @default 'Add Event Date'
     */
    PXcRO: T;

    /**
     * @default 'Share event information'
     */
    '9twNQ': T;

    /**
     * @default 'Preview website'
     */
    xMFBT: T;

    /**
     * @default 'We’ve simplified your event dashboard.'
     */
    '9i9IF': T;

    /**
     * @default 'Everything in Joy is still available as before, but now you’ll see a cleaner view of the different aspects of your event.'
     */
    C0gQG: T;

    /**
     * @default 'Got It'
     */
    BlI4z: T;

    /**
     * @default 'Guests Stays'
     */
    FRbu1: T;

    /**
     * @default 'Collect Addresses'
     */
    kS7jV: T;

    /**
     * @default 'Stationery'
     */
    khI0P: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Photo Moments'
     */
    n7PqX: T;

    /**
     * @default 'Messaging'
     */
    q8dH3: T;

    /**
     * @default 'Emails'
     */
    VHPZu: T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default 'Need more help?'
     */
    lhJaq: T;

    /**
     * @default 'Guest Q&A'
     */
    gMg7F: T;
  };
};

export type AdminDashboardV3Translations<T extends LeafNodeValue = TranslateFunction> = {
  mainHeader: {
    /**
     * @default 'Wedding Planner'
     */
    title: T;

    /**
     * @default 'Preview Site'
     */
    previewCta: T;

    /**
     * @default 'Share'
     */
    shareCta: T;

    /**
     * @default 'Support'
     */
    supportCta: T;
  };
  dashboardPreview: {
    navigationTabs: {
      /**
       * @default 'Next Steps'
       */
      nextSteps: T;

      /**
       * @default 'Website'
       */
      website: T;

      /**
       * @default 'Invitations'
       */
      invitations: T;
    };
    actions: {
      /**
       * @default 'View Site'
       */
      viewSite: T;

      /**
       * @default 'Share'
       */
      share: T;

      /**
       * @default 'Reposition Photo'
       */
      repositionPhoto: T;
    };
  };
  adminMenu: {
    /**
     * @default 'Event Settings'
     */
    eventSettings: T;

    /**
     * @default 'Invite Collaborator'
     */
    inviteCollaborator: T;

    /**
     * @default 'Leave a Suggestion'
     */
    leaveSuggestion: T;

    /**
     * @default 'Contact Support'
     */
    contactSupport: T;

    /**
     * @default 'Help'
     */
    help: T;

    /**
     * @default 'Manage Events'
     */
    manageEvents: T;

    /**
     * @default 'Account Info'
     */
    accountInfo: T;

    /**
     * @default 'Sign Out'
     */
    signOut: T;

    /**
     * @default 'Edit Photos'
     */
    editPhotos: T;
  };
  joyStationery: {
    /**
     * @default 'Beautiful Paper & Digital Cards to Match Your Style'
     */
    nonMatchingTitle: T;

    /**
     * @default 'Beautiful Paper & Digital Cards to Match Your Website'
     */
    matchingTitle: T;

    /**
     * @default 'Explore Save The Dates'
     */
    exploreSaveTheDates: T;

    /**
     * @default 'Explore Invitations'
     */
    exploreInvitations: T;

    /**
     * @default 'Save the Date'
     */
    saveTheDateAlt: T;

    /**
     * @default 'Invitation'
     */
    invitationAlt: T;

    /**
     * @default 'Explore Joy Print'
     */
    exploreJoyPrintAlt: T;
  };
  dashboardAccordion: {
    promoCards: {
      /**
       * @default 'Maybe Later'
       */
      maybeLaterCta: T;

      website: {
        /**
         * @default 'Your website is ready.'
         */
        title: T;

        /**
         * @default 'Customize your design or begin making these pages your own.'
         */
        subtitle: T;

        /**
         * @default 'Design Your Website'
         */
        primaryCta: T;

        /**
         * @default 'Edit Pages'
         */
        secondaryCta: T;
      };
      planningRsvp: {
        /**
         * @default 'Collect everyone’s contact info, instantly.'
         */
        title: T;

        /**
         * @default 'Build your guest list faster by sending friends a magic link or uploading phone contacts.'
         */
        subtitle: T;

        /**
         * @default 'Start Collecting Contacts'
         */
        primaryCta: T;

        /**
         * @default 'Upload Contacts with Joy App'
         */
        secondaryCta: T;
      };
      saveTheDates: {
        /**
         * @default 'Save that Date!'
         */
        title: T;

        /**
         * @default 'Whether you’re sending prints, digital, or both, we’ll help you do it in style.'
         */
        subtitle: T;

        /**
         * @default 'Start Save the Dates'
         */
        primaryCta: T;
      };
      invitations: {
        /**
         * @default 'Start Inviting & Delighting'
         */
        title: T;

        /**
         * @default 'Design the perfect card in print, digital, or both—your big day starts here.'
         */
        subtitle: T;

        /**
         * @default 'Start Invitations'
         */
        primaryCta: T;
      };
      travel: {
        /**
         * @default 'Wedding travel has never been easier.'
         */
        title: T;

        /**
         * @default 'Give your guests all the details and hook them up with the best rates.'
         */
        subtitle: T;

        /**
         * @default 'Select Hotels'
         */
        primaryCta: T;
      };
      registry: {
        /**
         * @default 'Your universal registry is waiting.'
         */
        title: T;

        /**
         * @default 'Any gifts. Any store. All yours.'
         */
        subtitle: T;

        /**
         * @default 'Build Your Registry'
         */
        primaryCta: T;

        /**
         * @default 'I already have a Registry'
         */
        secondaryCta: T;
      };
    };
    onOffBadge: {
      /**
       * @default 'On'
       */
      onBadgeLabel: T;

      /**
       * @default 'Off'
       */
      offBadgeLabel: T;
    };
    badges: {
      /**
       * @default 'RSVP'
       */
      rsvp: T;

      /**
       * @default 'RSVP is'
       */
      rsvpIs: T;

      /**
       * @default 'Registry'
       */
      registry: T;
    };
    items: {
      /**
       * @default 'Website'
       */
      website: T;

      /**
       * @default 'Planning & RSVP'
       */
      planningRsvp: T;

      /**
       * @default 'Save the Dates'
       */
      saveTheDates: T;

      /**
       * @default 'Registry'
       */
      registry: T;

      /**
       * @default 'Travel'
       */
      travel: T;

      /**
       * @default 'Invitations'
       */
      invitations: T;

      /**
       * @default 'Contact Guests'
       */
      contactGuests: T;
    };
    displayStatus: {
      /**
       * @default '{{count}} Public Page'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} Public Page
       * - plural: {{count}} Public Pages
       */
      publicPage: T;

      /**
       * @default '{{count}} Protected'
       */
      protectedPage: T;

      /**
       * @default '{{count}} Hidden'
       */
      off: T;

      /**
       * @default '{{page}} is Public'
       */
      isPublic: T;

      /**
       * @default '{{page}} is Password Protected'
       */
      isProtected: T;

      /**
       * @default '{{page}} is Hidden'
       */
      isOff: T;
    };
    menu: {
      /**
       * @default 'New'
       */
      newBadgeLabel: T;

      menuItems: {
        /**
         * @default 'Design'
         */
        website: T;

        /**
         * @default 'Photos'
         */
        photos: T;

        /**
         * @default 'Hotels'
         */
        hotels: T;

        /**
         * @default 'Edit Pages'
         */
        editPages: T;

        /**
         * @default 'Guest List'
         */
        guestList: T;

        /**
         * @default 'Contact Collector'
         */
        contactCollector: T;

        /**
         * @default 'Manage RSVP'
         */
        manageRSVP: T;

        /**
         * @default 'Gifts & Decor'
         */
        giftsAndDecor: T;

        /**
         * @default 'Design & Send'
         */
        designAndSend: T;

        /**
         * @default 'Overview'
         */
        overview: T;

        /**
         * @default 'Add Gifts'
         */
        addGifts: T;

        /**
         * @default 'Manage'
         */
        manage: T;

        /**
         * @default 'Track & Thanks'
         */
        trackAndThanks: T;

        /**
         * @default 'Hotels'
         */
        roomBlocks: T;

        /**
         * @default 'Travel Page'
         */
        travelPage: T;

        /**
         * @default 'Where to Stay'
         */
        whereToStay: T;

        /**
         * @default 'Send Message to Guests'
         */
        sendMessageToGuests: T;

        /**
         * @default 'Remind Guests to RSVP'
         */
        remindGuestsToRSVP: T;

        /**
         * @default 'Remind Guests to Book'
         */
        sendBookHotelReminder: T;

        /**
         * @default 'Thank You Cards'
         */
        thankYouCards: T;

        /**
         * @default 'Custom Card'
         */
        customCard: T;

        /**
         * @default 'Overview'
         */
        websiteOverview: T;
      };
    };
    statCards: {
      progressType: {
        /**
         * @default 'Goal'
         */
        goal: T;
      };
      potentialGuests: {
        /**
         * @default 'Potential Guests'
         */
        cta: T;

        /**
         * @default 'Edit Guest List'
         */
        ctaHover: T;
      };
      contactsCollected: {
        /**
         * @default 'Contacts Collected'
         */
        cta: T;

        /**
         * @default 'Open Collector'
         */
        ctaHover: T;
      };
      printsOrdered: {
        /**
         * @default 'Prints Ordered'
         */
        cta: T;

        /**
         * @default 'Start Design'
         */
        ctaHover: T;
      };
      digitalCardsSent: {
        /**
         * @default 'Digital Cards Sent'
         */
        cta: T;

        /**
         * @default 'Send Digital Cards'
         */
        ctaHover: T;
      };
      hotelWishList: {
        /**
         * @default 'Hotel Wish List'
         */
        cta: T;

        /**
         * @default 'Select Hotels'
         */
        ctaHover: T;
      };
      roomsRequested: {
        /**
         * @default 'Rooms Requested'
         */
        cta: T;

        /**
         * @default 'Contact Concierge'
         */
        ctaHover: T;
      };
      giftsAvailable: {
        /**
         * @default 'Gifts Available'
         */
        cta: T;

        /**
         * @default 'Manage Gifts'
         */
        ctaHover: T;
      };
      reservedAndPurchased: {
        /**
         * @default 'Reserved & Purchased'
         */
        cta: T;

        /**
         * @default 'View Gifts Received'
         */
        ctaHover: T;
      };
      thankYouNotesSent: {
        /**
         * @default 'Thank You Notes Sent'
         */
        cta: T;

        /**
         * @default 'Send Thanks'
         */
        ctaHover: T;
      };
      cashReceived: {
        /**
         * @default 'Cash Received'
         */
        cta: T;

        /**
         * @default 'View Gifts Received & Transfer Funds'
         */
        ctaHover: T;
      };
      attending: {
        /**
         * @default 'Attending'
         */
        cta: T;

        /**
         * @default 'Open RSVPs'
         */
        ctaHover: T;
      };
      declined: {
        /**
         * @default 'Declined'
         */
        cta: T;

        /**
         * @default 'Open RSVPs'
         */
        ctaHover: T;
      };
      pending: {
        /**
         * @default 'Pending'
         */
        cta: T;

        /**
         * @default 'Open RSVPs'
         */
        ctaHover: T;
      };
    };
  };
  quick: {
    /**
     * @default 'Share the venue where your event takes place.'
     */
    MHQEV: T;

    /**
     * @default 'Add Event Venue'
     */
    '456a7': T;

    /**
     * @default 'Add Event Location'
     */
    QMt5A: T;

    /**
     * @default 'Event Location'
     */
    '1F8sC': T;

    /**
     * @default 'Event Venue'
     */
    DR5KP: T;

    /**
     * @default 'Add Event Date'
     */
    PXcRO: T;

    /**
     * @default 'Event Date'
     */
    M6IZn: T;

    /**
     * @default 'Potential Guests'
     */
    '7eBlB': T;

    /**
     * @default 'Edit Guest List'
     */
    YzM5R: T;

    /**
     * @default 'Attending Guests'
     */
    rR6VF: T;

    /**
     * @default 'Open RSVPs'
     */
    CVUnc: T;

    /**
     * @default 'Gifts Available'
     */
    GY05C: T;

    /**
     * @default 'Manage Gifts'
     */
    ykL2s: T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Update Your Venue'
     */
    T9ruO: T;

    /**
     * @default 'Add Your Venue'
     */
    tFsbg: T;

    /**
     * @default 'Venue setup is nearly complete. Add accommodations to help guests plan their stay.'
     */
    TLjuc: T;

    /**
     * @default 'Include it on your website, invitations, and other guest facing communication.'
     */
    LpEsL: T;

    /**
     * @default 'Complete Your Venue Setup'
     */
    Cx7iI: T;

    /**
     * @default 'Make it easy for your guests to plan their trip.'
     */
    Veb8n: T;

    /**
     * @default 'Event Settings'
     */
    lXboj: T;

    /**
     * @default 'Invite Collaborator'
     */
    '5lFSE': T;

    /**
     * @default 'Contact Support'
     */
    TLnuy: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'Manage Events'
     */
    CGUli: T;

    /**
     * @default 'Account Info'
     */
    bZS93: T;

    /**
     * @default 'Sign Out'
     */
    bXv8o: T;

    /**
     * @default 'Joy Home Page'
     */
    MAxNh: T;
  };
};

export type AiReviewTextareaTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Proofread'
     */
    iCHDI: T;

    /**
     * @default 'Rewrite'
     */
    MHRQg: T;

    /**
     * @default 'Concise'
     */
    '2b372': T;

    /**
     * @default 'Friendly'
     */
    dcMbs: T;

    /**
     * @default 'Professional'
     */
    '5obWB': T;

    /**
     * @default 'New Draft'
     */
    To0LY: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Compose'
     */
    qK442: T;

    /**
     * @default 'Generating...'
     */
    qOw0Q: T;

    /**
     * @default 'Revert'
     */
    oASPS: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Describe your change'
     */
    qqEcP: T;

    /**
     * @default 'Failed to improve text, please try again.'
     */
    UZS1M: T;
  };
};

export type ArtUploadTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Upload Art'
     */
    aHKxO: T;

    /**
     * @default 'Desktop Photo'
     */
    KVbd8: T;

    /**
     * @default 'Replace Desktop Photo'
     */
    EeGqB: T;

    /**
     * @default 'Remove Desktop Photo'
     */
    E3fgu: T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'Mobile Photo'
     */
    uG8aE: T;

    /**
     * @default 'Replace Mobile Photo'
     */
    C2eeW: T;

    /**
     * @default 'Remove Mobile Photo'
     */
    oAGq2: T;

    /**
     * @default 'Select Art'
     */
    tpboI: T;

    /**
     * @default 'Upload Your Art'
     */
    v8hGl: T;

    /**
     * @default 'Upload Your Own'
     */
    O9lGl: T;

    /**
     * @default 'An error occurred while uploading your art. Please try again.'
     */
    BB4FO: T;

    /**
     * @default 'No art selected. Please select an art to upload.'
     */
    vL0pC: T;

    /**
     * @default 'Custom Theme'
     */
    '8rmoz': T;

    /**
     * @default 'An error occurred while removing your art. Please try again.'
     */
    '5ZBOk': T;

    /**
     * @default 'Desktop'
     */
    UpyS2: T;

    /**
     * @default 'Mobile'
     */
    YsAvF: T;
  };
};

export type AutoPopulationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'We found 1 hotel near your venue with exclusive event rates, up to 40% off.'
     * @param {number} count - The number of occurrences.
     * - singular: We found 1 hotel near your venue with exclusive event rates, up to 40% off.
     * - plural: We found {{0}} hotels near your venue with exclusive event rates, up to 40% off.
     */
    u0v6A: T;

    /**
     * @default 'Your hotel suggestions are ready.'
     */
    NuetS: T;

    /**
     * @default 'Remind Me Later'
     */
    vxjAH: T;

    /**
     * @default 'See Hotels'
     */
    mvDzV: T;

    /**
     * @default 'We found 1 hotel suggestion with up to 40% lower rates.'
     * @param {number} count - The number of occurrences.
     * - singular: We found 1 hotel suggestion with up to 40% lower rates.
     * - plural: We found {{0}} hotel suggestions with up to 40% lower rates.
     */
    OiIFC: T;

    /**
     * @default 'Room Blocks without the Contract.'
     */
    sWplI: T;

    /**
     * @default 'Finding hotels near your venue with exclusive event rates, up to 40% off.'
     */
    r35s8: T;

    /**
     * @default 'Are these hotel suggestions helpful?'
     */
    NdVkF: T;

    /**
     * @default 'Your feedback helps us improve our recommendations for future events.'
     */
    rLmUX: T;

    /**
     * @default 'Not helpful'
     */
    XptR9: T;

    /**
     * @default 'Very helpful'
     */
    uYANy: T;

    /**
     * @default 'See Hotel Suggestions'
     */
    cIKIw: T;

    /**
     * @default 'Close Auto Population Completed Dialog'
     */
    f23hG: T;

    /**
     * @default 'We looked for great hotel deals near your venue and found a few you might like.'
     */
    sksHn: T;

    /**
     * @default 'Were these hotel suggestions helpful?'
     */
    MHBs9: T;

    /**
     * @default 'Your feedback helps us refine the list for your guests.'
     */
    b1TGW: T;

    /**
     * @default '1'
     */
    xAAAA: T;

    /**
     * @default '2'
     */
    yAAAA: T;

    /**
     * @default '3'
     */
    zAAAA: T;

    /**
     * @default '4'
     */
    '0AAAA': T;

    /**
     * @default '5'
     */
    '1AAAA': T;

    /**
     * @default 'Close feedback form'
     */
    '3EIQ8': T;

    /**
     * @default 'We're improving our recommendation engine, tell us how can we do better.'
     */
    wZiB2: T;

    /**
     * @default 'Tell us what worked, what didn't, and what you'd like to see instead.'
     */
    TjD6S: T;

    /**
     * @default 'Type your reply here'
     */
    zdiAG: T;

    /**
     * @default 'Submit'
     */
    '6TIIW': T;

    /**
     * @default 'Same Hotels For Less.'
     */
    XpNnS: T;

    /**
     * @default 'We found new hotels near your venue that we think your guests will like.'
     */
    zrZFX: T;
  };
};

export type BnplTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Settings'
   */
  settingsTitle: T;

  /**
   * @default 'Edit your business profile and linked bank accounts'
   */
  settingsSubTitle: T;

  /**
   * @default 'Edit what coulples, guests and peers see on Joy'
   */
  editProfileText: T;

  /**
   * @default 'Edit Profile'
   */
  editProfileButtonText: T;

  /**
   * @default 'Update your account information such as login email and password'
   */
  editAccountText: T;

  /**
   * @default 'Update Account'
   */
  editAccountButtonText: T;

  /**
   * @default 'Linked Bank Accounts'
   */
  linkBankAccountTitle: T;

  /**
   * @default 'Link a bank account'
   */
  linkBankAcountButtonSingular: T;

  /**
   * @default 'Link another bank account'
   */
  linkBankAcountButtonPlural: T;
};

export type BookmarkletTranslations<T extends LeafNodeValue = TranslateFunction> = {
  bookmarklet: {
    /**
     * @default 'You can add items to your registry from any store!'
     */
    title: T;

    /**
     * @default 'Drag the button below to your Bookmarks bar to get started'
     */
    subtitle: T;

    /**
     * @default 'Add to Joy'
     */
    button: T;

    /**
     * @default 'Please drag and drop this button to the Bookmarks bar'
     */
    dragAlert: T;

    steps: [
      {
        /**
         * @default 'Make sure your Bookmarks bar is visible'
         */
        step: T;

        /**
         * @default 'In Chrome's top menu, go to View and make sure there's a checkmark next to Always Show Bookmarks Bar.'
         */
        description: T;
      },
      {
        /**
         * @default 'Click and drag the Add to Joy button to your Bookmarks bar'
         */
        step: T;

        /**
         * @default ' '
         */
        description: T;
      },
      {
        /**
         * @default 'Now try it out!'
         */
        step: T;

        /**
         * @default 'Visit any store and click your new Registry button.'
         */
        description: T;
      },
    ];
  };
  addRegistry: {
    /**
     * @default 'Sign in'
     */
    signIn: T;
  };
  validation: {
    /**
     * @default 'Invalid URL'
     */
    invalidDomain: T;

    /**
     * @default 'Required'
     */
    required: T;
  };
  joyButtonDialog: {
    /**
     * @default 'Easily add items from any store with the Joy bookmark button'
     */
    title: T;

    /**
     * @default 'Drag the button below to your browser’s Bookmark bar to save it.'
     */
    subtitle: T;

    /**
     * @default 'Add to Joy'
     */
    addToJoy: T;

    /**
     * @default 'All done? Let’s test it out'
     */
    alreadyAdded: T;

    /**
     * @default 'Read the guide'
     */
    watchTurtorial: T;

    /**
     * @default 'Nice work! Now try testing it by adding the item below'
     */
    trySubtitle: T;

    /**
     * @default 'Try Adding This Item'
     */
    tryButton: T;

    /**
     * @default 'Start over'
     */
    startOver: T;

    /**
     * @default 'Still need help?'
     */
    stillNeedHelp: T;
  };
  addGiftDialog: {
    /**
     * @default 'Choose your registry'
     */
    multipleEventSelectTitle: T;

    /**
     * @default 'Add Gift'
     */
    actionText: T;

    /**
     * @default 'Choose Image'
     */
    giftImageLabel: T;

    /**
     * @default 'Title'
     */
    nameInputLabel: T;

    /**
     * @default 'Price'
     */
    priceInputLabel: T;

    /**
     * @default 'Qty'
     */
    qtyInputLabel: T;

    /**
     * @default 'Gift Type'
     */
    typeInputLabel: T;

    /**
     * @default 'Note to Family and Friends'
     */
    noteInputLabel: T;

    /**
     * @default 'Add an optional note here to help your gift-givers.'
     */
    noteInputPlaceholder: T;
  };
  successContent: {
    /**
     * @default 'Awesome!'
     */
    successTitle: T;

    /**
     * @default '{{title}} has been successfully added to your registry.'
     */
    successMessage: T;

    /**
     * @default 'Go to registry'
     */
    successCta: T;

    /**
     * @default 'add your shipping address'
     */
    shippingAddressLinkText: T;

    /**
     * @default 'Don’t forget to <shippingAddressLink/> so gift givers know where to send your gift!'
     */
    shippingAddressReminderText: T;
  };
  failContent: {
    /**
     * @default 'Your Registry'
     */
    yourRegistry: T;

    /**
     * @default 'Item Could Not Be Added'
     */
    failTitle: T;

    /**
     * @default 'This item failed to be added. Go to <br /><yourRegistry/> to manually add this item'
     */
    failMessage: T;
  };
  noAuthDialog: {
    /**
     * @default 'You are no longer signed in to Joy.'
     */
    title: T;

    /**
     * @default 'Login at withjoy.com and try again.'
     */
    subtitle: T;

    /**
     * @default 'Sign In'
     */
    signIn: T;

    /**
     * @default 'Connect your Joy account first to start adding items to your registry.'
     */
    notConnected: T;

    /**
     * @default 'Connect'
     */
    connect: T;

    /**
     * @default 'Your Joy account is now connected, you can start adding gifts to your registry!'
     */
    accountConnected: T;
  };
  safariComingDialog: {
    /**
     * @default 'The Joy button is coming to Safari soon'
     */
    title: T;

    /**
     * @default 'In the meantime, you can use the browser button on Chrome, Firefox, or Microsoft Edge'
     */
    subtitle: T;

    /**
     * @default 'Still need help?'
     */
    stillNeedHelp: T;
  };
  customItemDataLabels: {
    /**
     * @default 'Product'
     */
    gift: T;

    /**
     * @default 'Charity'
     */
    charity: T;

    /**
     * @default 'Cash Fund'
     */
    cash: T;
  };
  browserButton: {
    /**
     * @default 'This store doesn’t work with the Joy Browser button. Copy the URL and add this item manually on your manage page in Joy.'
     */
    scriptLoadError: T;
  };
  popupTrigger: {
    /**
     * @default 'Popup May Have Been Blocked'
     */
    heading: T;

    /**
     * @default 'Click the button below to launch Add to Joy in another window'
     */
    instructions: T;

    /**
     * @default 'Open Add to Joy'
     */
    button: T;

    /**
     * @default 'Looks like we couldn't get past your popup blocker. Could you please disable it just so we can figure out what product you're trying to add to your registry?'
     */
    error: T;
  };
};

export type CashFundsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Manage Collections'
     */
    AUib6: T;

    /**
     * @default 'Active Funds'
     */
    CbGF4: T;

    /**
     * @default 'New Fund'
     */
    RBqUG: T;

    /**
     * @default 'Zero state icon'
     */
    CEE6F: T;

    /**
     * @default 'Easily collect funds for your event and track it all in Joy.'
     */
    wxdnF: T;

    /**
     * @default 'Create Collection Fund'
     */
    RoRne: T;

    /**
     * @default 'Amounts shown include cash collected from registry funds and private funds via Stripe.'
     */
    description: T;

    /**
     * @default 'Reactivate Fund'
     */
    PtCdW: T;

    /**
     * @default 'Hide Transactions'
     */
    f8N5s: T;

    /**
     * @default 'View Transactions'
     */
    iX0OS: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default '{{0}} of {{1}}'
     */
    aUt0t: T;

    /**
     * @default '{{0}} Paid'
     */
    asHwE: T;

    /**
     * @default 'Request Payment'
     */
    rQLGa: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'More options'
     */
    LeY4P: T;

    /**
     * @default 'Contributed'
     */
    tTNlH: T;

    /**
     * @default 'Goal'
     */
    rEOLA: T;

    /**
     * @default 'Received'
     */
    vGhoO: T;

    /**
     * @default 'Copy'
     */
    XymKA: T;

    /**
     * @default 'Message from Guest'
     */
    pM2XN: T;

    /**
     * @default 'Duplicate'
     */
    djRAg: T;

    /**
     * @default 'Deactivate'
     */
    g1L73: T;

    /**
     * @default 'Activate'
     */
    nPknl: T;

    /**
     * @default 'Need Assistance?'
     */
    XxPx8: T;

    /**
     * @default 'Contact Us'
     */
    mf53u: T;

    /**
     * @default 'Approval is taking longer than expected'
     */
    RjULU: T;

    /**
     * @default 'Your account is being reviewed'
     */
    CzJ31: T;

    /**
     * @default 'This will only take a minute'
     */
    '07bGD': T;

    /**
     * @default 'Check Stripe Status'
     */
    '3tBjr': T;

    /**
     * @default 'Resolve Stripe Issue'
     */
    gM2q9: T;

    /**
     * @default 'Transfer Balance'
     */
    '9Hnit': T;

    /**
     * @default 'Your guests can now send you cash with a credit card! See your contributions and transfer cash to your bank or debit card using Stripe.'
     */
    '7CVmS': T;

    /**
     * @default 'Balance'
     */
    qIfoN: T;

    /**
     * @default 'Transfer Fee'
     */
    VObkV: T;

    /**
     * @default 'Transaction fees apply and are subject to change.'
     */
    T1ALP: T;

    /**
     * @default 'Total Transfer'
     */
    DRExO: T;

    /**
     * @default 'Your balance is too low to transfer.'
     */
    '3uEIO': T;

    /**
     * @default 'Yes, Transfer Balance'
     */
    Qwcxd: T;

    /**
     * @default 'Nevermind'
     */
    Gt32n: T;

    /**
     * @default 'Transfer Successful!'
     */
    '6Gyox': T;

    /**
     * @default 'Transfer Failed'
     */
    SeB8L: T;

    /**
     * @default 'Your transfer has been processed successfully.'
     */
    turLo: T;

    /**
     * @default 'We couldn't complete your transfer. Please contact support.'
     */
    WtXqm: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Cash Received'
     */
    SYN24: T;

    /**
     * @default 'Available Balance'
     */
    R98qj: T;

    /**
     * @default 'Pending Transactions'
     */
    '6sTkB': T;

    /**
     * @default 'These funds will be available soon'
     */
    ooKPl: T;

    /**
     * @default 'Pending Withdrawals'
     */
    ltxgA: T;

    /**
     * @default 'These funds will be transferred to your bank soon'
     */
    '5sLxi': T;

    /**
     * @default 'Previously Withdrawn'
     */
    QxFhK: T;

    /**
     * @default 'Total funds transferred to your bank'
     */
    YZl9y: T;

    /**
     * @default 'Lifetime Received'
     */
    oJelT: T;

    /**
     * @default 'Total funds you've received with Joy'
     */
    sOIHk: T;

    /**
     * @default 'Amounts shown include cash collected from registry funds and private funds via Stripe.'
     */
    '4Snpy': T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Transfer processing...'
     */
    CHg1I: T;

    /**
     * @default 'We couldn't complete one of your transfers. Please contact support.'
     */
    uQVER: T;

    /**
     * @default 'Transfer to Bank'
     */
    WRWhY: T;

    /**
     * @default 'Approval pending...'
     */
    MGHfP: T;

    /**
     * @default 'More information needed.'
     */
    '2hgjB': T;

    /**
     * @default 'Connect Your Bank Account'
     */
    kxCVI: T;

    /**
     * @default 'Allow guests to give with credit and debit cards.'
     */
    HZyTD: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default 'Sorry, there's been an error. Please refresh the page.'
     */
    JNbvd: T;

    /**
     * @default 'Anonymous'
     */
    F6mAC: T;

    /**
     * @default 'Private Funds'
     */
    TynyK: T;

    /**
     * @default 'All Funds'
     */
    PJr8J: T;

    /**
     * @default 'Edit Fund'
     */
    TkwHg: T;

    /**
     * @default 'No contributions yet'
     */
    '4lxAt': T;

    /**
     * @default 'Contributions will appear here once guests start giving.'
     */
    gGZaa: T;

    /**
     * @default '✨ Cash Fund link copied to clipboard ✨'
     */
    '7JcJK': T;

    /**
     * @default 'Invalid URL'
     */
    iirED: T;

    /**
     * @default 'Hello {{0}},'
     */
    gaBCG: T;

    /**
     * @default '{{0}} is requesting funds.'
     */
    Fwpn2: T;

    /**
     * @default 'Contribute with Pay'
     */
    IKOdM: T;

    /**
     * @default 'Contribute Another Way'
     */
    j3l9E: T;

    /**
     * @default 'Fund not found'
     */
    mMJHa: T;

    /**
     * @default 'Unable to load fund information'
     */
    '7rOQX': T;

    /**
     * @default '{{0}} per person'
     */
    YTHGq: T;

    /**
     * @default 'Host information saved successfully.'
     */
    YbcJs: T;

    /**
     * @default 'Failed to save host information. Please try again.'
     */
    WxDgr: T;

    /**
     * @default 'Fund created successfully.'
     */
    QoA5U: T;

    /**
     * @default 'Failed to create fund. Please try again.'
     */
    yCIaQ: T;

    /**
     * @default 'Host information is required. Please complete the contact and address forms first.'
     */
    X1Ivf: T;

    /**
     * @default 'Please confirm your home address.'
     */
    sAspa: T;

    /**
     * @default 'Edit Private Fund'
     */
    KqG2H: T;

    /**
     * @default 'New Private Fund'
     */
    '47apL': T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'First name is required'
     */
    '8niW2': T;

    /**
     * @default 'Last name is required'
     */
    cLL4a: T;

    /**
     * @default 'Who is your cash fund contact?'
     */
    A6tAf: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'By continuing, you agree to Stripe's '
     */
    '0v1Mt': T;

    /**
     * @default 'terms of service.'
     */
    r0jio: T;

    /**
     * @default 'Guests give with Credit or Debit Card'
     */
    UeKs6: T;

    /**
     * @default 'Collect donations on your website. Automatic tracking.'
     */
    mw1Iv: T;

    /**
     * @default 'Transaction fees apply.'
     */
    nHnH6: T;

    /**
     * @default 'Secure, fast checkout with'
     */
    tLJHH: T;

    /**
     * @default 'Fixed Amount'
     */
    '0UmcM': T;

    /**
     * @default 'Any Amount'
     */
    QGaMT: T;

    /**
     * @default 'Total Goal'
     */
    drMGO: T;

    /**
     * @default 'Hide goal from guests'
     */
    cwGJY: T;

    /**
     * @default 'No goal? Just leave it blank.'
     */
    Hlk3p: T;

    /**
     * @default 'Quantity'
     */
    tT8ln: T;

    /**
     * @default 'Fund name is required'
     */
    '7sgdb': T;

    /**
     * @default 'Fixed amount is required'
     */
    '1sHb4': T;

    /**
     * @default 'Amount must be greater than 0'
     */
    fjMil: T;

    /**
     * @default 'Quantity is required'
     */
    E8WlC: T;

    /**
     * @default 'Quantity must be at least 1'
     */
    wpOZ2: T;

    /**
     * @default 'Quantity must be a whole number'
     */
    Euc61: T;

    /**
     * @default 'Total goal must be at least $5'
     */
    Ar3tC: T;

    /**
     * @default 'Total goal must be a whole number'
     */
    uVxXH: T;

    /**
     * @default 'Fund updated successfully!'
     */
    sLj9Q: T;

    /**
     * @default 'Failed to update fund. Please try again.'
     */
    '3X1ay': T;

    /**
     * @default 'Failed to save fund. Please try again.'
     */
    VE5ZP: T;

    /**
     * @default 'Upload photo'
     */
    LEJBD: T;

    /**
     * @default 'Fund photo'
     */
    hN4UL: T;

    /**
     * @default 'Fund Name'
     */
    Ezomg: T;

    /**
     * @default 'Enter fund name'
     */
    IENXH: T;

    /**
     * @default 'Note to Family and Friends'
     */
    FQxQv: T;

    /**
     * @default 'Optional: Tell folks what this fund means to you'
     */
    JcPuG: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Name is required'
     */
    umtFL: T;

    /**
     * @default 'Phone number is required'
     */
    OhpSu: T;

    /**
     * @default 'Invalid Phone Number'
     */
    Gsdpn: T;

    /**
     * @default 'Address is required'
     */
    nAVhF: T;

    /**
     * @default 'Postal code is required'
     */
    hfKog: T;

    /**
     * @default 'City is required'
     */
    cvisr: T;

    /**
     * @default 'State is required'
     */
    CYpjC: T;

    /**
     * @default 'Country code is required'
     */
    a5B8u: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Phone Number'
     */
    fwf1p: T;

    /**
     * @default 'Country'
     */
    G9ai3: T;

    /**
     * @default 'Zip Code'
     */
    s53Dv: T;

    /**
     * @default 'Address'
     */
    gDl5Q: T;

    /**
     * @default 'Address 2'
     */
    '0SeaA': T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'State'
     */
    Be76G: T;

    /**
     * @default '* Required fields'
     */
    '41fJI': T;

    /**
     * @default 'Important: once your currency and country has been selected, it cannot be changed.'
     */
    gcIqP: T;

    /**
     * @default 'Create Cash Fund'
     */
    gerG6: T;

    /**
     * @default 'Stripe needs more information.'
     */
    JkfmS: T;

    /**
     * @default 'Inactive Funds'
     */
    lZKxc: T;

    /**
     * @default 'Cash fund archived successfully.'
     */
    Tr2cB: T;

    /**
     * @default 'Failed to archive cash fund. Please try again.'
     */
    f4VFX: T;

    /**
     * @default 'Cash fund reactivated successfully.'
     */
    pphCQ: T;

    /**
     * @default 'Failed to reactivate cash fund. Please try again.'
     */
    Vqep6: T;

    /**
     * @default 'Cash fund duplicated successfully.'
     */
    QN66d: T;

    /**
     * @default 'Failed to duplicate cash fund. Please try again.'
     */
    erjem: T;

    /**
     * @default 'Copy of {{0}}'
     */
    QIgEL: T;

    /**
     * @default 'Copy of Cash Fund'
     */
    '8ajfU': T;

    /**
     * @default 'Contribute to my Cash Fund'
     */
    Y6a1H: T;

    /**
     * @default 'Help us celebrate! Contribute to our cash fund.'
     */
    Rx3Im: T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default '1 Contribution'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Contribution
     * - plural: {{0}} Contributions
     */
    qrePD: T;

    /**
     * @default 'Cash Fund'
     */
    cKFaM: T;

    /**
     * @default 'Amounts shown include cash collected from registry funds and cash funds via Stripe.'
     */
    QqE0A: T;

    /**
     * @default 'Copy Link'
     */
    PdDvA: T;

    /**
     * @default 'Edit Cash Fund'
     */
    wPahI: T;

    /**
     * @default 'New Cash Fund'
     */
    KOikK: T;

    /**
     * @default 'Contribution Details'
     */
    YnBbD: T;

    /**
     * @default 'Contribution'
     */
    yJedr: T;

    /**
     * @default 'Processing Fee'
     */
    nDV7d: T;

    /**
     * @default 'Sales Tax'
     */
    pqyDA: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Contributor: {{0}}'
     */
    jNPeu: T;

    /**
     * @default 'Thank you for your contribution!'
     */
    AhRRd: T;

    /**
     * @default 'Contribution #{{0}}'
     */
    ncx4B: T;

    /**
     * @default 'We'll send you an email confirmation for your contribution shortly.'
     */
    vm6qq: T;

    /**
     * @default 'Your contribution to "{{0}}" has been received and will be available to the couple.'
     */
    qnv9H: T;

    /**
     * @default 'Make Another Contribution'
     */
    tdvws: T;

    /**
     * @default 'Visit Wedding Website'
     */
    '6PorS': T;

    /**
     * @default 'Special characters < and > are not allowed'
     */
    Ta6NW: T;

    /**
     * @default 'Amount is required'
     */
    FSO9s: T;

    /**
     * @default 'Please enter a valid amount'
     */
    rJbRQ: T;

    /**
     * @default 'Minimum contribution is {{0}}{{1}}'
     */
    P57sD: T;

    /**
     * @default 'Maximum contribution is {{0}}{{1}}'
     */
    TmN8q: T;

    /**
     * @default 'Unable to calculate fees. Fees will be shown at checkout.'
     */
    Rxd8g: T;

    /**
     * @default 'Payment information is incomplete'
     */
    '23cxK': T;

    /**
     * @default 'Payment failed. Please try again.'
     */
    W11FM: T;

    /**
     * @default 'An unexpected error occurred. Please try again.'
     */
    CSDsd: T;

    /**
     * @default 'This cash fund is no longer active.'
     */
    YvnVO: T;

    /**
     * @default 'Please contact the host for more details.'
     */
    XyGtx: T;

    /**
     * @default 'Amount'
     */
    '6xj0j': T;

    /**
     * @default 'Add a note (optional)'
     */
    je2JC: T;

    /**
     * @default 'Add a personal message...'
     */
    PTB6A: T;

    /**
     * @default 'Quick amount selection'
     */
    BdOJs: T;

    /**
     * @default 'Please enter a valid email address'
     */
    Zf7AP: T;

    /**
     * @default 'Email is required'
     */
    XN2CQ: T;

    /**
     * @default 'Failed to create checkout session. Please try again.'
     */
    '3IBmV': T;

    /**
     * @default 'Please share your details to help {{0}} track your contribution.'
     */
    iV0dq: T;

    /**
     * @default 'First and last name'
     */
    wq1cY: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Continue to Checkout'
     */
    mw2yB: T;

    /**
     * @default 'United States'
     */
    NWZnV: T;

    /**
     * @default 'Full name is required'
     */
    n3aes: T;

    /**
     * @default 'First & Last Name'
     */
    lR4Gj: T;

    /**
     * @default 'Enter your full name'
     */
    jfr4D: T;

    /**
     * @default 'Host information is required. Please complete the contact form first.'
     */
    NqwaL: T;

    /**
     * @default 'Country is required'
     */
    '94Fcd': T;

    /**
     * @default 'Country/Region'
     */
    vKJHw: T;

    /**
     * @default '✨ Email copied to clipboard ✨'
     */
    ttFhK: T;

    /**
     * @default 'Choose from existing photos'
     */
    ty5Sw: T;

    /**
     * @default 'When you have cash available, you can send it to your bank with a standard transfer fee. Transfers take typically 5-7 business days.'
     */
    ICxJP: T;
  };
};

export type CatalogRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  addProduct: {
    /**
     * @default 'Add to Registry'
     */
    addToRegistry: T;

    /**
     * @default 'Add to Cart'
     */
    addToCart: T;

    /**
     * @default 'The item was added to your registry!'
     */
    notificationText: T;

    /**
     * @default 'Added to Registry'
     */
    addedToRegistry: T;

    /**
     * @default 'Edit Gift...'
     */
    editGift: T;
  };
  sidebarNav: {
    /**
     * @default 'Shop All {{categoryName}}'
     */
    showAll: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Shop'
     */
    shop: T;

    /**
     * @default 'Departments'
     */
    departmentTitle: T;
  };
  productDetailPage: {
    /**
     * @default 'Sold by'
     */
    soldBy: T;

    /**
     * @default 'Fulfilled by'
     */
    fulfilledBy: T;

    /**
     * @default 'Exclusively with Joy'
     */
    joyExclusive: T;

    /**
     * @default 'Buy Now'
     */
    buyNow: T;

    /**
     * @default 'Quantity'
     */
    quantity: T;

    /**
     * @default 'Why We Love It'
     */
    whyWeLoveIt: T;

    /**
     * @default 'Specs'
     */
    specs: T;

    /**
     * @default 'Description'
     */
    description: T;

    /**
     * @default 'Return to {{title}}'
     */
    returnTo: T;

    /**
     * @default 'Please select a {{label}}'
     */
    pleaseSelect: T;

    /**
     * @default 'View Details'
     */
    viewDetails: T;

    /**
     * @default 'Quick Add'
     */
    quickAddToRegistry: T;

    /**
     * @default 'Coming Soon'
     */
    comingSoonItemTitle: T;

    /**
     * @default 'This item will be available on Joy soon. You can add to your registry now.'
     */
    comingSoonItemNote: T;

    /**
     * @default 'No longer available'
     */
    discontinuedItemTitle: T;

    /**
     * @default 'This item is no longer available in our catalog.'
     */
    discontinuedItemNote: T;

    /**
     * @default 'Back in Stock Soon'
     */
    backorderedItemTitle: T;

    /**
     * @default 'This item is temporarily out of stock. We're expecting it to be back soon. You can still add it to your registry.'
     */
    backorderedItemNote: T;

    /**
     * @default 'Or'
     */
    buttonsDividerText: T;
  };
  emptyCategoryContent: {
    /**
     * @default 'We're stocking our shelves'
     */
    title: T;

    /**
     * @default 'In the meantime, you can add gifts from any online store to your registry using the Joy App'
     */
    subtitle: T;

    /**
     * @default 'Add Gifts'
     */
    iosButton: T;
  };
  babyCatalogEmptyStateContent: {
    /**
     * @default 'Coming Soon!'
     */
    title: T;

    /**
     * @default 'We're working on bringing the best collection of <b>{{selectedCategory}}</b> for you.'
     */
    subtitle: T;
  };
  cashFundCatalog: {
    /**
     * @default 'Edit and Add'
     */
    editAndAdd: T;

    /**
     * @default '{{title}} added'
     */
    fundAddedTitle: T;

    /**
     * @default 'You'll be notified when friends and family start contributing!'
     */
    fundSuccessSubtitle: T;

    /**
     * @default 'Create Your Own {{fund}}'
     */
    createYourOwn: T;

    /**
     * @default 'You May Also Like'
     */
    collectionMembersTitle: T;

    /**
     * @default 'View Registry'
     */
    viewRegistry: T;
  };
  seo: {
    wedding: {
      /**
       * @default 'Shop | Joy | The All-In-One Wedding Registry'
       */
      shopIndexTitle: T;

      /**
       * @default 'Shop on Joy to create the best all-in-one wedding registry experience from hundreds of brands across kitchen, tabletop, bed & bath, home, travel, cash funds, charities, experiences and more.'
       */
      shopIndexDescription: T;

      /**
       * @default '{{category}} | Joy'
       */
      shopCategoryTitle: T;

      /**
       * @default 'Shop from {{category}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopCategoryDescription: T;

      /**
       * @default 'Curations | Joy | The All-In-One Wedding Registry'
       */
      shopCurationIndexTitle: T;

      /**
       * @default 'Shop from Joy Curations created by our team of registry experts to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopCurationIndexDescription: T;

      /**
       * @default '{{curation}} | Joy'
       */
      shopCurationDetailsTitle: T;

      /**
       * @default 'Shop from {{curation}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopCurationDetailsDescription: T;

      /**
       * @default 'Brands | Joy'
       */
      shopBrandIndexTitle: T;

      /**
       * @default 'Shop from Brands on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopBrandIndexDescription: T;

      /**
       * @default ' {{brand}} | Joy'
       */
      shopBrandDetailsTitle: T;

      /**
       * @default 'Shop {{brand}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopBrandDetailsDescription: T;
    };
    baby: {
      /**
       * @default 'Baby Shop | Joy | The Universal Baby Registry'
       */
      shopIndexTitle: T;

      /**
       * @default 'Shop on Joy to add everything for you and your new bundle of Joy from  hundreds of brands across clothing, strollers & car seats, travel & gear, feeding & nursing, nursery, health & safety, bath & potty, toys & activity, and cash funds.'
       */
      shopIndexDescription: T;

      /**
       * @default '{{category}} | Joy'
       */
      shopCategoryTitle: T;

      /**
       * @default 'Shop from {{category}} on Joy to build a complete baby registry for you and your new bundle of Joy'
       */
      shopCategoryDescription: T;

      /**
       * @default 'Curations | Joy | The Universal Baby Registry'
       */
      shopCurationIndexTitle: T;

      /**
       * @default 'Shop from Joy Curations created by our team of baby registry experts to build the complete registry for your new bundle of Joy.'
       */
      shopCurationIndexDescription: T;

      /**
       * @default '{{curation}} | Joy'
       */
      shopCurationDetailsTitle: T;

      /**
       * @default 'Shop from {{curation}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopCurationDetailsDescription: T;

      /**
       * @default 'Brands | Joy'
       */
      shopBrandIndexTitle: T;

      /**
       * @default 'Shop from Brands on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopBrandIndexDescription: T;

      /**
       * @default '{{brand}} | Joy'
       */
      shopBrandDetailsTitle: T;

      /**
       * @default 'Shop {{brand}} on Joy to build the best all-in-one wedding registry experience for you and your guests.'
       */
      shopBrandDetailsDescription: T;
    };
  };
  currencyWarningDialog: {
    /**
     * @default 'Delivery for these items is not available outside the United States.'
     */
    title: T;

    /**
     * @default 'Instead add items from stores that can ship to you in two easy ways:'
     */
    subtitle: T;

    /**
     * @default 'Instead add items from stores that can ship to you via the Joy App.'
     */
    mobileSubtitle: T;

    /**
     * @default 'Add items to your registry from other retailers'
     */
    ctaOne: T;

    /**
     * @default 'Install Browser Button'
     */
    ctaOneButton: T;

    /**
     * @default 'Paste a link to an item and fill out the details'
     */
    ctaTwo: T;

    /**
     * @default 'Add Item Manually'
     */
    ctaTwoButton: T;

    /**
     * @default 'Get the App'
     */
    mobileButton: T;

    /**
     * @default 'Dismiss'
     */
    dismiss: T;

    /**
     * @default 'Add Item Anyway'
     */
    addAnyway: T;
  };
  refinementsPanel: {
    /**
     * @default 'Refine'
     */
    refineFilters: T;

    /**
     * @default 'Clear All'
     */
    clearAll: T;

    clearAllFilters: {
      /**
       * @default 'Clear {{count}} filter'
       */
      messageWithCountOne: T;

      /**
       * @default 'Clear {{count}} filters'
       */
      messageWithCountMoreThanOne: T;
    };

    /**
     * @default 'Filter'
     */
    filter: T;

    /**
     * @default 'Filters'
     */
    filters: T;

    /**
     * @default 'Hide Filter'
     */
    hideFilter: T;

    /**
     * @default 'Hide Filters'
     */
    hideFilters: T;

    /**
     * @default 'Price: >${{minValue}}'
     */
    priceGraterThan: T;

    /**
     * @default 'Price: <=${{maxValue}}'
     */
    priceLowerThan: T;

    /**
     * @default 'Price: ${{minValue}} - ${{maxValue}}'
     */
    priceRange: T;

    /**
     * @default 'Price: '
     */
    pricePrefix: T;

    /**
     * @default '${{maxValue}} or less'
     */
    priceAndLess: T;

    /**
     * @default '${{minValue}} or more'
     */
    priceAndMore: T;

    /**
     * @default '${{minValue}} - ${{maxValue}}'
     */
    priceBucketRange: T;

    /**
     * @default 'Custom'
     */
    custom: T;

    /**
     * @default 'Show Filter'
     */
    showFilter: T;

    /**
     * @default 'Show Filters'
     */
    showFilters: T;

    /**
     * @default 'Sort'
     */
    sort: T;

    sortByPriceOptions: {
      /**
       * @default 'Recommended'
       */
      featured: T;

      /**
       * @default 'Price: Low to High'
       */
      priceAsc: T;

      /**
       * @default 'Price: High to Low'
       */
      priceDesc: T;
    };
  };
  searchBar: {
    /**
     * @default 'Search brands, products, and more'
     */
    searchInputPlaceholder: T;

    /**
     * @default 'Search'
     */
    searchInputPlaceholderMobile: T;

    /**
     * @default 'Couples are searching for…'
     */
    coupleTrendsTitle: T;

    /**
     * @default '{{quantity}} in the last hour'
     */
    lastHour: T;
  };
  searchHeader: {
    /**
     * @default 'Searching for...'
     */
    titleSearching: T;

    /**
     * @default 'Showing results for'
     */
    titleShowResult: T;

    /**
     * @default 'Item{{plural}} Found'
     */
    subTitle: T;

    /**
     * @default 'No items were found matching'
     */
    subTitleNoItemsFound: T;

    /**
     * @default '{{count}} item{{pluralization}} for “{{searchTerm}}”'
     */
    itemsFoundV2: T;

    breadcrumbs: {
      /**
       * @default 'Shop'
       */
      root: T;

      /**
       * @default 'Search Results'
       */
      current: T;
    };
    noSearchResults: {
      /**
       * @default 'Add From Any Store'
       */
      hed: T;

      /**
       * @default 'You can add top items from any store'
       */
      dek: T;
    };
  };
  searchResult: {
    /**
     * @default 'Modify your search'
     */
    modifySearchButtonText: T;

    /**
     * @default 'Or'
     */
    modifySearchText: T;

    modifySearchExplore: {
      /**
       * @default 'Explore Popular Couple Picks'
       */
      wedding: T;

      /**
       * @default 'Explore Popular Picks For Your Baby'
       */
      baby: T;
    };
  };
  curationList: {
    /**
     * @default 'Top Curations'
     */
    title: T;

    /**
     * @default 'Browse All'
     */
    cta: T;

    /**
     * @default 'Explore More Curations'
     */
    title2: T;

    /**
     * @default 'See All Curations'
     */
    cta2: T;

    /**
     * @default 'Show All {{total}}'
     */
    cta3: T;
  };
  categoryRecommendationsCarousel: {
    /**
     * @default 'Explore {{title}}'
     */
    explore: T;

    /**
     * @default 'Show All {{length}}'
     */
    showAll: T;

    /**
     * @default 'Explore {{title}} Top Picks'
     */
    explorePopularStores: T;
  };
  curationHeroHeader: {
    billboard: {
      /**
       * @default 'Shop the Curation'
       */
      exploreButton: T;

      /**
       * @default 'Watch the Video'
       */
      watchButton: T;

      /**
       * @default 'Shop {{brandName}}'
       */
      shopButton: T;
    };
  };
  curationHero: {
    /**
     * @default 'Read more'
     */
    readMore: T;

    /**
     * @default 'less'
     */
    less: T;
  };
  browseCategoryBanner: {
    /**
     * @default 'Browse All Gifts'
     */
    browseButton: T;

    /**
     * @default 'Interested in more gifts from {{categoryTitle}}?'
     */
    bannerText: T;
  };
  recommendedProductsSection: {
    wedding: {
      /**
       * @default 'Your Personalized Picks'
       */
      sectionTitle: T;
    };
    baby: {
      /**
       * @default 'Baby Registry Essentials'
       */
      sectionTitle: T;
    };
  };
  brandPage: {
    /**
     * @default 'Show more'
     */
    showMore: T;

    /**
     * @default 'Less'
     */
    less: T;
  };
  productTile: {
    /**
     * @default '{{lowerBound}} - {{upperBound}}'
     */
    priceRange: T;
  };
  brandsMarquee: {
    /**
     * @default 'Over 10,000+ items from all the best brands'
     */
    weddingTitle: T;

    /**
     * @default 'Top items from all the best brands'
     */
    babyRegistryTitle: T;

    /**
     * @default 'Shop Your Favorite Brands'
     */
    titleOverview: T;
  };
  curationsSection: {
    /**
     * @default 'View'
     */
    button: T;

    /**
     * @default 'Explore'
     */
    explore: T;

    /**
     * @default 'Gift Inspo '
     */
    titleR1: T;

    /**
     * @default 'From the Experts'
     */
    titleR2: T;

    /**
     * @default 'Registry recommendations you'll love (and why you need them).'
     */
    subtitle: T;
  };
  categoryPage: {
    /**
     * @default 'Browse'
     */
    buttonHover: T;
  };
  productGrid: {
    /**
     * @default 'Explore All Products'
     */
    exploreAllProducts: T;

    /**
     * @default 'Explore all {{categoryTitle}}'
     */
    exploreAllCategory: T;

    /**
     * @default 'Top {{title}} Gifts Added <br />by Joy Couples'
     */
    popularCategory: T;

    /**
     * @default 'Explore More {{parentTitle}}'
     */
    exploreMore: T;

    /**
     * @default 'Explore More'
     */
    exploreMoreTitle: T;
  };
  storefrontNavigator: {
    /**
     * @default 'New'
     */
    badgeNew: T;

    /**
     * @default 'Joy Wedding'
     */
    labelStorefrontWedding: T;

    /**
     * @default 'Joy Baby'
     */
    labelStorefrontBaby: T;
  };
  departmentNavSection: {
    /**
     * @default 'Browse by Department'
     */
    title: T;

    /**
     * @default 'Explore {{categoryTitle}}'
     */
    exploreCategory: T;
  };
  valuePropsTopBar: {
    wedding: {
      shipping: {
        /**
         * @default 'Free Shipping'
         */
        title: T;
      };
      completionDiscount: {
        /**
         * @default 'Registry Completion Discount'
         */
        title: T;
      };
      priceMatchPromise: {
        /**
         * @default 'Price Match Promise'
         */
        title: T;
      };
      easyReturns: {
        /**
         * @default 'Easy Returns'
         */
        title: T;
      };
    };
    baby: {
      shipping: {
        /**
         * @default 'Free Shipping'
         */
        title: T;
      };
      completionDiscount: {
        /**
         * @default '20% Completion Discount'
         */
        title: T;
      };
      priceMatchPromise: {
        /**
         * @default 'Price Match Promise'
         */
        title: T;
      };
      easyReturns: {
        /**
         * @default 'Easy Returns'
         */
        title: T;
      };
    };
  };
  valuePropsSection: {
    /**
     * @default 'Every Joy Registry Deserves'
     */
    title: T;

    /**
     * @default 'Perks of Registering with Joy'
     */
    titleOverview: T;

    /**
     * @default 'Free Shipping over ${{price}}'
     */
    freeShipping: T;

    /**
     * @default 'Delay Shipping If You Need It'
     */
    delayShipping: T;

    /**
     * @default 'AI-Assisted Thank You Notes'
     */
    thankYouNotes: T;

    /**
     * @default '20% Completion Discount'
     */
    postWeddingDiscount: T;

    /**
     * @default '20% Completion Discount'
     */
    completionDiscountBaby: T;

    /**
     * @default 'Zero-Fee Cash Funds'
     */
    zeroFeeCashFunds: T;

    /**
     * @default 'Universal Registry'
     */
    universalRegistry: T;

    /**
     * @default 'Price Match Promise'
     */
    priceMatchPromise: T;

    /**
     * @default 'Easy Returns'
     */
    easyReturns: T;
  };
  productRating: {
    /**
     * @default ''
     */
    noLabel: T;

    /**
     * @default '{{averageRating}}'
     */
    averageRating: T;

    /**
     * @default '{{averageRating}} ({{totalReviewCount}} Reviews)'
     */
    averageRatingWithCount: T;

    /**
     * @default '{{averageRating}} ({{totalReviewCount}})'
     */
    averageRatingWithCountShort: T;

    /**
     * @default '({{totalReviewCount}} Reviews)'
     */
    totalReviewCount: T;

    /**
     * @default '({{totalReviewCount}})'
     */
    totalReviewCountShort: T;
  };
  catalogItemCustomerReviewsSection: {
    wedding: {
      /**
       * @default 'Ratings & Reviews'
       */
      sectionTitle: T;
    };
    baby: {
      /**
       * @default 'Ratings & Reviews'
       */
      sectionTitle: T;
    };
    statsSummary: {
      /**
       * @default '{{reviewCount}} Reviews'
       */
      totalReviewCount: T;
    };
    reviewList: {
      /**
       * @default 'Reviews'
       */
      header: T;

      /**
       * @default 'Show More'
       */
      showMoreButton: T;

      /**
       * @default 'Anonymous'
       */
      unknownReviewAuthor: T;

      /**
       * @default 'Originally posted on {{source}}'
       */
      syndicationSourceNotice: T;
    };
  };
  universalSearch: {
    productgrid: {
      /**
       * @default 'Add From Anywhere'
       */
      sectionHed: T;

      /**
       * @default 'Explore top items from other shops.'
       */
      sectionDek: T;

      productTile: {
        /**
         * @default 'View Product'
         */
        viewProductCta: T;

        /**
         * @default 'Create Registry'
         */
        createRegistryCta: T;
      };
    };
    pdpModal: {
      formFields: {
        price: {
          /**
           * @default 'Price'
           */
          label: T;

          /**
           * @default 'Missing a price'
           */
          error: T;
        };
        title: {
          /**
           * @default 'Title'
           */
          label: T;

          /**
           * @default 'Missing a title'
           */
          error: T;
        };
        quantity: {
          /**
           * @default 'Quantity'
           */
          label: T;
        };
        note: {
          /**
           * @default 'Note'
           */
          label: T;

          /**
           * @default 'Optional: Tell folks what this gift means to you, what you'll do with it, or why you want it — have fun with it.'
           */
          placeholder: T;
        };
      };

      /**
       * @default 'View on {{shopName}}'
       */
      viewShopOnLink: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Add to Registry'
       */
      addCta: T;
    };

    /**
     * @default 'This product cannot be loaded at the moment. Please try again later.'
     */
    getProductByIdError: T;

    /**
     * @default 'This product cannot be added to the registry at the moment. Please try again later.'
     */
    addProductToRegistryError: T;
  };
  brands: {
    /**
     * @default 'Our Brands'
     */
    ourBrands: T;

    /**
     * @default 'Shop by'
     */
    shopBy: T;

    /**
     * @default 'Filter'
     */
    filter: T;

    /**
     * @default 'Clear All'
     */
    clearAll: T;

    /**
     * @default 'Confirm'
     */
    confirm: T;

    /**
     * @default 'All Brands'
     */
    allBrands: T;

    /**
     * @default 'Brands'
     */
    brands: T;
  };
  recentlyAddedRegistryItemUpdateDrawer: {
    /**
     * @default 'Added to your registry!'
     */
    drawerTitle: T;

    /**
     * @default 'You can also mark this gift as:'
     */
    updateSectionHeader: T;

    /**
     * @default 'Your change has been saved.'
     */
    updateConfirmationMessage: T;

    markAsMostWantedToggle: {
      /**
       * @default 'Our Most Wanted'
       */
      label: T;

      /**
       * @default 'Let your guests know your must-have gifts!'
       */
      tooltipMessage: T;
    };

    /**
     * @default 'Mark Gift as Most Wanted'
     */
    updateCtaMessage: T;

    /**
     * @default 'Most Wanted'
     */
    mostWanted: T;

    /**
     * @default 'Remove from Most Wanted'
     */
    removeFromMostWanted: T;

    /**
     * @default 'Adding item to registry...'
     */
    loadingMessage: T;
  };
  salesPrice: {
    /**
     * @default 'Sale'
     */
    message: T;
  };
  doYouHaveRegistry: {
    /**
     * @default 'Quick Question'
     */
    eyebrow: T;

    /**
     * @default 'Do you already have
a registry somewhere else?'
*/
    question: T;

    /**
     * @default 'Yes'
     */
    yes: T;

    /**
     * @default 'No'
     */
    no: T;
  };
};

export type ChecklistTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Verify your email'
     */
    ggVTZ: T;

    /**
     * @default 'Check wedding location'
     */
    VCiyJ: T;

    /**
     * @default 'Set ceremony date'
     */
    oyWOK: T;

    /**
     * @default 'Add countdown'
     */
    WANcW: T;

    /**
     * @default 'Check password and privacy'
     */
    ofmoq: T;

    /**
     * @default 'Upload and manage photos'
     */
    aUtxE: T;

    /**
     * @default 'Design your website'
     */
    gIVb3: T;

    /**
     * @default 'Avoid repeated guest questions'
     */
    C9mi0: T;

    /**
     * @default 'Finalize your event schedule'
     */
    ifDsm: T;

    /**
     * @default 'Upload video'
     */
    KPGfD: T;

    /**
     * @default 'Set your Joy URL'
     */
    CTVYt: T;

    /**
     * @default 'Set up privacy options'
     */
    ZVlt4: T;

    /**
     * @default 'Toggle pages'
     */
    k3DIJ: T;

    /**
     * @default 'Invite partner or friend to help'
     */
    WpXoZ: T;

    /**
     * @default 'Collect guest information'
     */
    aVdAX: T;

    /**
     * @default 'Upload contacts'
     */
    irKYX: T;

    /**
     * @default 'Design paper cards'
     */
    X4oVm: T;

    /**
     * @default 'Design and send digital cards'
     */
    '6ESfe': T;

    /**
     * @default 'Add gifts to your registry'
     */
    VmmUN: T;

    /**
     * @default 'Add cash funds'
     */
    CjZzO: T;

    /**
     * @default 'Order gifts from your registry'
     */
    P5k9j: T;

    /**
     * @default 'Set photo update note'
     */
    PAWdt: T;

    /**
     * @default 'Set shipping address'
     */
    qXys3: T;

    /**
     * @default 'Install Joy button'
     */
    bb0Og: T;

    /**
     * @default 'Connect another registry'
     */
    QyqmZ: T;

    /**
     * @default 'Try auto thank you notes'
     */
    uTV1Q: T;

    /**
     * @default 'Apply post-wedding discount'
     */
    CJpKQ: T;

    /**
     * @default 'Save on Hertz car rentals'
     */
    '2zojR': T;

    /**
     * @default 'Save on hotel bookings'
     */
    iZRuO: T;

    /**
     * @default 'Give guests travel tips'
     */
    CPCJ1: T;

    /**
     * @default 'Set up ground transportation'
     */
    Eslvc: T;

    /**
     * @default 'Chat with concierge'
     */
    FluRO: T;

    /**
     * @default 'Organize your guest list'
     */
    CI0Ou: T;

    /**
     * @default 'Finalize your guest list'
     */
    nNIHd: T;

    /**
     * @default 'Set up RSVP questions'
     */
    pVeWQ: T;

    /**
     * @default 'Use tags for RSVP questions'
     */
    XFDMS: T;

    /**
     * @default 'Finalize details'
     */
    IA0ul: T;

    /**
     * @default 'Edit accommodations'
     */
    JXzoR: T;

    /**
     * @default 'Edit travel tips'
     */
    AkNdZ: T;

    /**
     * @default 'Remind guests'
     */
    yIYVg: T;

    /**
     * @default 'Add Places to Stay'
     */
    dOTDN: T;
  };
};

export type CollaborationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'This invite is invalid or has expired.'
     */
    kRjbZ: T;

    /**
     * @default 'Please contact the event organizer for a new invitation.'
     */
    xnDAB: T;

    /**
     * @default 'You've been invited to become a collaborator.'
     */
    tyxin: T;

    /**
     * @default 'Join as {{0}}'
     */
    g6WMa: T;

    /**
     * @default 'Sign out and use another account'
     */
    ZpUuS: T;

    /**
     * @default 'Go back to event'
     */
    '8U60b': T;

    /**
     * @default 'Log In or Create Account'
     */
    z21SR: T;

    /**
     * @default 'Error accepting invite. Please contact customer support.'
     */
    GP67i: T;
  };
};

export type ColorsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Pick any color from your photo or anywhere to apply it.'
     */
    BxfRy: T;

    /**
     * @default 'Pick color from screen'
     */
    MtQFT: T;
  };
};

export type CompanyPoliciesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  shippingPolicy: {
    seo: {
      /**
       * @default 'With Joy Shipping Policy'
       */
      title: T;

      /**
       * @default 'Joy Shipping policy. Most items will ship via Standard Ground Shipping and arrive within 5-10 business days from when the order was placed. Estimated shipping times are counted in business days, excluding weekends and holidays, after the order has shipped.'
       */
      description: T;
    };
    hero: {
      /**
       * @default 'Shipping Info'
       */
      title: T;

      /**
       * @default 'Last Updated: December 12, 2023'
       */
      date: T;

      /**
       * @default 'Don’t you just love it when something special is on its way? Here’s what to expect when it comes to shipping with Joy…'
       */
      subtitle: T;
    };

    paragraphs: [
      {
        /**
         * @default '<strong>Items Added from the Joy Shop:</strong> Most items will ship via Standard Ground Shipping and arrive within 5-10 business days from when the order was placed. Estimated shipping times are counted in business days, excluding weekends and holidays, after the order has shipped.'
         */
        text: T;
      },
      {
        /**
         * @default 'Expedited Shipping is not always available. If applicable, you’ll see which items are eligible during checkout.'
         */
        text: T;
      },
      {
        /**
         * @default 'For gifts added from the Joy shop, you can enjoy free shipping on all orders over $75. For gifts added from external registries, the shipping terms will typically align with the policies of the retailer itself. In this case, the shipping fees, delivery times, and any additional details will be determined by the external retailer’s shipping policies. Any shipping and handling fees will be listed during checkout.'
         */
        text: T;
      },
      {
        /**
         * @default 'For Joy physical and eligible items, subtotals equal to or more than $75 will ship for free.'
         */
        text: T;
      },
      {
        /**
         * @default '<strong>These items include</strong>: Physical Joy Shop products and Joy Gift Wrap eCards.'
         */
        text: T;
      },
      {
        /**
         * @default 'Items that <strong>are not eligible</strong> or may not include free shipping include: Gift cards or eGift cards, Cash gifts or cash contributions, Experiences or other email vouchers, Gifts added from external registries.'
         */
        text: T;
      },
      {
        /**
         * @default 'Shipping is only available in the contiguous U.S. and items cannot be shipped to a PO Box or APO/FPO/DPO. Additional surcharges may apply depending on the item and location and will be shown at checkout when applicable. Please note, shipping fees are non-refundable.'
         */
        text: T;
      },
      {
        /**
         * @default '<strong>Items Added from External Registries or Retailers:</strong> The shipping terms, including fees, delivery times, and details for these items will typically align with the policies of the retailer itself. Any shipping and handling fees will be listed during checkout.'
         */
        text: T;
      },
    ];
  };
  returnPolicy: {
    seo: {
      /**
       * @default 'With Joy Return Policy'
       */
      title: T;

      /**
       * @default 'Experience the Joy return policy, allowing for returns on most items within a generous 90-day window. Discover more about our policy.'
       */
      description: T;
    };
    hero: {
      /**
       * @default 'Returns & Exchanges'
       */
      title: T;

      /**
       * @default 'Last Updated: September 12, 2024'
       */
      date: T;

      /**
       * @default 'We always strive to deliver Joy, but in case you’d like to return or exchange an item, here are the details.'
       */
      subtitle: T;
    };
    topSection: {
      /**
       * @default 'Purchases on Joy'
       */
      title: T;

      /**
       * @default 'When you purchase a gift on our site, you're buying the equivalent in Joy Credit, which is equal to the full price of the item at the time of purchase, including taxes and shipping. The gift recipient can use that value to have the selected item shipped at their convenience. If the item's price increases after purchase or during a shipping hold, we’ll cover the difference. They can also choose to apply that value toward a different item on Joy.'
       */
      description: T;

      listItems: [
        {
          /**
           * @default '<strong>Joy Credit </strong> never expires and can be used on physical products and experiences sold by Joy. You cannot use credit for cash gifts, honeymoon funds, digital gift cards, or items from other websites. It also cannot be applied to past orders. Promo codes may be offered occasionally and may have expiration dates or additional terms and conditions.'
           */
          text: T;
        },
        {
          /**
           * @default 'We reserve the right to cancel or decline to process orders for reasons such as pricing errors, concerns about fraud, or out-of-stock items. If that happens, you will not be charged, or we’ll issue a refund.'
           */
          text: T;
        },
        {
          /**
           * @default 'We accept returns on select items; please refer to our Return Policy below for details. While we strive to provide accurate product information, we can’t guarantee all content is error-free. If something is incorrect, your primary option will be to return the item.'
           */
          text: T;
        },
        {
          /**
           * @default 'Occasionally, product listings may be outdated or inaccurate. We reserve the right to update or correct information without notice and may cancel orders placed at incorrect prices.'
           */
          text: T;
        },
        {
          /**
           * @default 'By purchasing or registering for an item on our site, you agree to our shipping and return policies. We don’t sell alcohol, but some third-party gift cards may be redeemable for alcohol from other sellers. You must be at least 21 years of age to purchase these products and comply with all applicable state laws.'
           */
          text: T;
        },
      ];
    };

    sections: [
      {
        /**
         * @default 'Registry Purchases'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'Most items can be returned within 90 days. Don’t worry! If you’re returning a gift that was purchased for you, the gift giver will not be notified.'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'You must request a return or exchange no more than 90 days after your event OR no more than 90 days after purchase, whichever date is later. There are no exceptions.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'In order for eligible item(s) to be returned, proof of purchase is required and returned item(s) must be in the same condition received, unopened, unused, and in the original packaging.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'You’ll be issued a refund in the form of a merchandise credit in the amount of the full value originally paid, less any shipping and restocking fees if applicable.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'If the item was purchased through a Third Party’s website, for example, Amazon.com or Target.com, that store’s return policy applies. Any return, refund, or exchange should be handled directly by the retailer from where the item was purchased.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Please note: Joy retains the right to review and/or deny any return request on a case-by-case basis.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Printed Cards and Paper'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'We want you to be 100% happy with your prints. That’s why each order has a 24 hour window to make any last minute changes, be it a typo, updated shipping address, or other minor change. Simply reach out to our customer support team at printsupport@withjoy.com with your change or cancellation request.'
             */
            title: T;

            listItems: [];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'Given that each paper order is custom printed to your specifications, all sales are final after the 24-hour grace period.'
             */
            title: T;

            listItems: [];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'If an error was detected after the 24-hour grace period, you may reach out to our customer support team at printsupport@withjoy.com, and our agents will review your request on a case-by-case basis.'
             */
            title: T;

            listItems: [];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'In the rare event that a printing issue affected your order, please reach out to our customer support team at printsupport@withjoy.com with the following information:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Name'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Order number'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Brief description of the issue'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Photo showing the issue and how many items were impacted'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'If we determine that there is a quality issue with our printing process, we will refund your order or reprint free of charge.'
             */
            title: T;

            listItems: [];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'All Other Purchases'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'Most items can be returned within 30 days.'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'An order may be canceled provided the item hasn’t shipped yet.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'If the item has already shipped, you must request a refund or exchange no more than 30 days after purchase. There are no exceptions.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'If the item was purchased through a Third Party’s website, for example, Amazon.com or Target.com, that store’s return policy applies. Any return, refund, or exchange should be handled directly by the retailer from where the item was purchased.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Refund Policy'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'In order for the eligible item(s) to be refunded, you must ensure that:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Returned item(s) must be in the same condition received, unopened, unused, and in the original packaging.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Proof of purchase is provided.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Please note: Joy retains the right to review and/or deny any return request on a case-by-case basis.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'Proof of purchase is required to issue an appropriate exchange, credit, or refund of an eligible item(s), as well as any taxes due to be refunded in accordance with applicable state law. For your convenience, any of the following is accepted as proof of your purchase:'
             */
            title: T;

            listItems: [];

            listIndentedItems: [
              {
                /**
                 * @default 'Gift Receipt'
                 */
                text: T;
              },
              {
                /**
                 * @default 'eReceipt'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Original Packing Slip'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Gift Packing Slip'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Order Number'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Gift Registry Number'
                 */
                text: T;
              },
            ];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'There are a few items that can’t be returned:'
             */
            title: T;

            listItems: [];

            listIndentedItems: [
              {
                /**
                 * @default 'Opened and assembled furniture items'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Gift cards and eGift cards'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Redeemed experiences'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Personalized items or custom orders'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Shipping fees, if applicable, are non-refundable'
                 */
                text: T;
              },
            ];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'Restocking fees may apply to certain items:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Any restocking fee will be deducted from your refund total once the return has been processed.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Experiences'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'Joy partners with third-party providers to offer our registrants a wide variety of experiences and event ticket options.'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Unredeemed experiences can be returned for a merchandise credit but are not eligible for a refund.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Third-party providers offer site-specific return policies. Gifts purchased through a third party are subject to those policies, if applicable.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Spur offers cash back refunds up to 30 days after the purchase on un-redeemed experiences.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'After 30 days, customers can exchange experiences for credit to their e-wallet.  These funds never expire and can be used towards other Spur experiences as well as tickets to sporting events and concerts. Experience vouchers never expire. However, some experience providers may change their offerings over time. If the experience is no longer offered, the total amount of the voucher will be credited to the user’s e-wallet. Spur’s full policy details can be viewed here.  <a href='https://spurexperiences.com/terms-conditions' target='blank'>https://spurexperiences.com/terms-conditions</a>'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Third Party and External Items'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'Joy’s registry platform allows registrants to add items from other stores so they can manage their registry all in one place. If you’d like to return or exchange an item purchased through a third party, please be aware that:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Items purchased from other websites are subject to the return policy of the store from which they were purchased.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'Any customer service inquiry, return, refund, or exchange for these items should be handled directly by the retailer from where the item was purchased.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
      {
        /**
         * @default 'Delivery Issues'
         */
        title: T;

        subsections: [
          {
            /**
             * @default 'If an item is damaged upon delivery:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Contact customer service within 30 days of delivery.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'A photo of the damaged item and any packaging in the order must be provided in order to process any requests.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'A replacement or merchandise credit will be issued.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'If an item is defective:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Contact customer service within 90 days of delivery and provide a photo of any visible defects and any information pertaining to the issue, regular care and use, and any possible troubleshooting of the issue.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'For all other defective items, please refer to the manufacturer’s warranty.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'If a replacement is not desired, the value of the item will be issued as a merchandise credit.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'If an item is lost or missing in transit:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'Contact customer service within 14 days of scheduled delivery.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'After 14 days, your order may not be able to be replaced.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'For back ordered items, including items that were purchased and are no longer available or items delayed from the manufacturer:'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'You may cancel the order prior to the item being shipped.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'A merchandise credit will be issued for the full value paid less any fees, if applicable.'
                 */
                text: T;
              },
              {
                /**
                 * @default 'A replacement item of equal or greater value may be offered in certain circumstances.'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
          {
            /**
             * @default 'Questions?'
             */
            title: T;

            listItems: [
              {
                /**
                 * @default 'If you’re unable to find the answer to your question here, please contact Joy customer support at <a href='mailto:support@withjoy.com'>support@withjoy.com</a> and we’d be happy to help!'
                 */
                text: T;
              },
            ];

            listIndentedItems: [];

            listNoBulletItems: [];
          },
        ];
      },
    ];
  };
};

export type ContactCollectorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  admin: {
    /**
     * @default 'Can you share your current mailing address? {{names}} would love to send you something special! 💌'
     */
    messagePlaceholder: T;

    /**
     * @default 'Hey! Mind sharing your current mailing address? 📮 {{names}} are excited to send you a little something special!'
     */
    messagePlaceholder0: T;

    /**
     * @default 'Hey! 👋 {{names}} are gathering addresses to send you something special! Could you share yours?'
     */
    messagePlaceholder1: T;

    /**
     * @default 'Hi! Could you share your mailing address? {{names}} have a special surprise to send your way!'
     */
    messagePlaceholder2: T;

    /**
     * @default 'You’re invited! But first, we need your mailing address. Click the link to share with {{names}}.'
     */
    messagePlaceholder3: T;

    /**
     * @default 'Hey! {{names}} are collecting addresses to mail you a special invitation. Can you provide yours? 📬'
     */
    messagePlaceholder4: T;

    /**
     * @default 'Can you provide your mailing address? {{names}} want to send something your way!'
     */
    messagePlaceholder5: T;

    /**
     * @default 'Hey! {{names}} are getting ready to send you something special. Can you share your address with them?'
     */
    messagePlaceholder6: T;

    /**
     * @default '{{names}} are collecting addresses for their event. Please click the link to share.'
     */
    messagePlaceholder7: T;

    /**
     * @default 'Quickly get everyone’s info in your Guest List.'
     */
    createTitle: T;

    /**
     * @default 'Customize how it looks to your heart’s delight.'
     */
    createSubTitle: T;

    /**
     * @default 'Edit Design'
     */
    editDesign: T;

    /**
     * @default 'Design Your Collector'
     */
    design: T;

    /**
     * @default 'Customize how it looks to your heart’s delight.'
     */
    customize: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Text Message Preview'
     */
    textMessagePreview: T;

    /**
     * @default 'How does it work?'
     */
    instructionsTitle: T;

    /**
     * @default 'Share via text or email.'
     */
    instructionsFirst: T;

    /**
     * @default 'Your guests fill out a form.'
     */
    instructionsSecond: T;

    /**
     * @default 'Your guest list updates!'
     */
    instructionsThird: T;

    /**
     * @default 'Set a Visual'
     */
    visual: T;

    /**
     * @default 'Photo source'
     */
    photo: T;

    /**
     * @default 'Write a Brief Note'
     */
    note: T;

    /**
     * @default 'Your Message'
     */
    message: T;

    /**
     * @default 'Link to Event Website'
     */
    linkWebsite: T;

    /**
     * @default 'Display Event Date'
     */
    displayEventDate: T;

    /**
     * @default 'Event Date'
     */
    eventDate: T;

    /**
     * @default 'Edit Date'
     */
    editDate: T;

    /**
     * @default 'Your Event Date is currently set to private. If you’d like it displayed here, please update your preferences in'
     */
    privateDate: T;

    /**
     * @default ', and refresh this page.'
     */
    refresh: T;

    /**
     * @default 'Create Magic Link'
     */
    createMagicLink: T;

    /**
     * @default 'Update Magic Link'
     */
    updateMagicLink: T;

    /**
     * @default 'There was an error creating the Magic Link'
     */
    magicLinkError: T;

    /**
     * @default 'There was an error clearing the Contact List'
     */
    clearContactListError: T;

    /**
     * @default 'Settings'
     */
    settings: T;

    /**
     * @default 'Your Contact Collector'
     */
    previewTitle: T;

    /**
     * @default 'Send this link to your guests. They’ll fill out their details and we’ll update your guest list.'
     */
    previewSubTitle: T;

    /**
     * @default 'Your Contact Collector is disabled to collecting households.'
     */
    disabledCollectHouseholdHelper: T;

    /**
     * @default 'Clear Contact List'
     */
    clearContactList: T;

    /**
     * @default 'I understand that by clicking Clear Contact List, I will no longer be able to recover the contacts.'
     */
    clearContactListDialog: T;

    /**
     * @default 'Recent Updates'
     */
    recentUpdates: T;

    /**
     * @default 'Edit Guest List'
     */
    editGuestList: T;

    /**
     * @default 'Start sharing!'
     */
    startSharing: T;

    /**
     * @default 'Your updated contacts will appear here.'
     */
    recentUpdatesPlaceholder: T;

    /**
     * @default 'Select Animation'
     */
    selectAnimation: T;

    /**
     * @default 'Select Image'
     */
    selectImage: T;

    /**
     * @default 'Hmm… we’re having some trouble.'
     */
    errorPageTitle: T;

    /**
     * @default 'This page may have changed or is temporarily unavailable.'
     */
    errorPageSubTitle: T;

    /**
     * @default 'There was an error fetching the Contacts Updates.'
     */
    recentUpdatesError: T;

    /**
     * @default 'Contact Collector'
     */
    title: T;

    /**
     * @default 'Your details will only be shared with {{names}}.'
     */
    landingPageMessage: T;

    /**
     * @default 'Provide Details'
     */
    provideDetails: T;

    /**
     * @default 'Visit Event Website'
     */
    visitEventWebsite: T;

    /**
     * @default 'The Couple'
     */
    theCouple: T;

    /**
     * @default 'Please Add Your Info'
     */
    addYourInfo: T;

    /**
     * @default 'Contact Info'
     */
    contactInfo: T;

    /**
     * @default 'First Name'
     */
    firstName: T;

    /**
     * @default 'Last Name'
     */
    lastName: T;

    /**
     * @default 'Mobile Phone'
     */
    phoneNumber: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Mailing Address'
     */
    mailingAddress: T;

    /**
     * @default 'Address Line 1'
     */
    address1: T;

    /**
     * @default 'Apartment, Suite, etc. (Optional)'
     */
    address2: T;

    /**
     * @default 'Zip/Postal Code'
     */
    postalCode: T;

    /**
     * @default 'City'
     */
    city: T;

    /**
     * @default 'State/Province/Territory'
     */
    region: T;

    /**
     * @default 'Country/Region'
     */
    country: T;

    /**
     * @default 'Save Details'
     */
    saveDetails: T;

    /**
     * @default 'Add a member to this party'
     */
    addMember: T;

    /**
     * @default 'Required'
     */
    required: T;

    /**
     * @default 'Invalid Email'
     */
    invalidEmail: T;

    /**
     * @default 'Invalid Phone Number'
     */
    invalidPhoneNumber: T;

    /**
     * @default 'Does this look right?'
     */
    looksRight: T;

    /**
     * @default 'Modify Details'
     */
    modifyDetails: T;

    /**
     * @default 'Looks Good'
     */
    looksGood: T;

    /**
     * @default 'There was an error creating the contact'
     */
    contactError: T;

    /**
     * @default '*Required fields'
     */
    requiredFields: T;

    /**
     * @default 'You’re all set, {{name}}!'
     */
    allSet: T;

    /**
     * @default 'We’ve sent your details to {{names}}!'
     */
    successMessage: T;

    /**
     * @default 'Address Suggestion'
     */
    addressSuggestion: T;

    /**
     * @default 'It is possible the following modified address will ensure a more successful delivery.'
     */
    addressSuggestionText1: T;

    /**
     * @default 'Please select the address you’d like to use.'
     */
    addressSuggestionText2: T;

    /**
     * @default 'Original Address'
     */
    originalAddress: T;

    /**
     * @default 'Suggested Address'
     */
    suggestedAddress: T;

    /**
     * @default 'Confirm Address'
     */
    confirmAddress: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'We couldn’t validate your address.'
     */
    addressValidationError: T;

    /**
     * @default 'Terms'
     */
    terms: T;

    /**
     * @default 'Privacy Policy'
     */
    privacyPolicy: T;

    /**
     * @default 'By clicking “Save Details”, you agree to Joy’s'
     */
    termsAndConditions1: T;

    /**
     * @default 'and'
     */
    termsAndConditions2: T;

    /**
     * @default 'and consent to receive messages for this event via SMS. Message and data rates apply.'
     */
    termsAndConditions3: T;

    /**
     * @default 'By entering your phone number, you consent to receive messages for this event via SMS. Message and data rates may apply. Reply STOP to opt out proceeding, you confirm that you have read and agree to Joy’s'
     */
    termsAndConditions4: T;

    /**
     * @default 'Help'
     */
    help: T;

    csvUpload: {
      /**
       * @default 'Upload Spreadsheet'
       */
      title: T;

      /**
       * @default '🎉 Success! Upload Completed!'
       */
      successTitle: T;

      /**
       * @default '😑 Something went wrong'
       */
      errorTitle: T;

      /**
       * @default 'contacts'
       */
      contacts: T;

      /**
       * @default 'valid'
       */
      valid: T;

      /**
       * @default 'invalid'
       */
      invalid: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Import Valid Contacts'
       */
      importCta: T;

      /**
       * @default 'Upload Spreadsheet'
       */
      uploadCta: T;

      /**
       * @default 'Upload Your Spreadsheet'
       */
      uploadYourCta: T;

      /**
       * @default 'Already have a list of contacts?'
       */
      haveAList: T;

      /**
       * @default 'Get a head start by uploading a spreadsheet of your contacts.'
       */
      getAHead: T;

      /**
       * @default 'Seems like something went wrong. Please try to submit your spreadsheet again.'
       */
      error: T;

      /**
       * @default 'Please'
       */
      please: T;

      /**
       * @default 'Please make sure that all the required fields are filled in as per spreadsheet'
       */
      pleaseLong: T;

      /**
       * @default 'template'
       */
      template: T;

      /**
       * @default 'download the template'
       */
      download: T;

      /**
       * @default 'and follow the instructions on'
       */
      follow: T;

      /**
       * @default 'this page.'
       */
      thisPage: T;

      /**
       * @default 'Important:'
       */
      important: T;

      /**
       * @default 'Uploading a spreadsheet will create a new contact in your Guest List for each row. If you already have contacts in your guest list, we recommend editing them directly in your recipient selector or'
       */
      importantText: T;

      /**
       * @default 'Guest List'
       */
      guestList: T;

      /**
       * @default 'to avoid duplicates.'
       */
      avoid: T;

      /**
       * @default 'Download Template'
       */
      downloadCta: T;

      /**
       * @default 'Upload File'
       */
      uploadFileCta: T;

      /**
       * @default 'Upload New File'
       */
      uploadNewFileCta: T;

      /**
       * @default 'We’ve successfully imported {{quantity}} contacts from the spreadsheet.'
       */
      validContacts: T;

      /**
       * @default 'View Contacts'
       */
      viewContactsCta: T;

      /**
       * @default 'The spreadsheet couldn’t be uploaded due to incorrect formatting.'
       */
      fileFormatError: T;

      /**
       * @default 'The spreadsheet couldn’t have been uploaded due to the required column missing.'
       */
      fileRequiredColumnsError: T;

      /**
       * @default 'Learn More'
       */
      learnMore: T;
    };

    /**
     * @default 'Contact'
     */
    contact: T;

    /**
     * @default 'created successfully.'
     */
    created: T;
  };
  quick: {
    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Invalid Email'
     */
    zS8sb: T;

    /**
     * @default 'Contact updated successfully.'
     */
    '0Tolw': T;

    /**
     * @default 'Contacts created successfully.'
     */
    AvgRB: T;

    /**
     * @default 'Contact created successfully.'
     */
    NXs1L: T;

    /**
     * @default 'Hmm… we’re having some trouble.'
     */
    iPvSw: T;

    /**
     * @default 'This page may have changed or is temporarily unavailable.'
     */
    t6ozN: T;

    /**
     * @default '✨ Link copied! ✨'
     */
    NlEES: T;

    /**
     * @default 'First Name*'
     */
    f49kf: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Last Name*'
     */
    dVHQv: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'Mobile Phone*'
     */
    '80mWM': T;

    /**
     * @default 'Mobile Phone'
     */
    YD8aE: T;

    /**
     * @default 'Email*'
     */
    KGPZu: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Mailing Address'
     */
    RvleZ: T;

    /**
     * @default 'Envelope Name'
     */
    vyb70: T;

    /**
     * @default 'The Smith Family, Mr. and Mrs. Smith, etc'
     */
    ndLjC: T;

    /**
     * @default 'Address Line 1*'
     */
    lMvoK: T;

    /**
     * @default 'Address Line 1'
     */
    r2ebI: T;

    /**
     * @default 'Apartment, Suite, etc. (Optional)'
     */
    FR7Qu: T;

    /**
     * @default 'City*'
     */
    Z1vnF: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'State/Province/Territory*'
     */
    '1ZAce': T;

    /**
     * @default 'State/Province/Territory'
     */
    LLPZf: T;

    /**
     * @default 'Zip/Postal Code*'
     */
    oHAyT: T;

    /**
     * @default 'Zip/Postal Code'
     */
    Ya5jy: T;

    /**
     * @default 'Country/Region'
     */
    vKJHw: T;

    /**
     * @default 'The Couple'
     */
    P9H7j: T;

    /**
     * @default 'Can you share your current mailing address? {{0}} would love to send you something special! 💌'
     */
    yIFF9: T;

    /**
     * @default 'Hmm… we're having some trouble.'
     */
    MLsxY: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'Contact Collector'
     */
    pHmSZ: T;

    /**
     * @default 'SMART TIP'
     */
    '4Gu8p': T;

    /**
     * @default 'Get free, effortless envelope addressing on your Save the Dates and Invitations.'
     */
    D8uS0: T;

    /**
     * @default 'Browse Card Designs'
     */
    '1Y392': T;

    /**
     * @default 'Address Envelopes Effortlessly.'
     */
    XiRsN: T;

    /**
     * @default 'Use our contact collector to gather all the guest information and reach everyone.'
     */
    fXX0g: T;

    /**
     * @default 'Hey! Mind sharing your current mailing address? 📮 {{0}} are excited to send you a little something special!'
     */
    '7b0y0': T;

    /**
     * @default 'Hey! 👋 {{0}} are gathering addresses to send you something special! Could you share yours?'
     */
    sSeKB: T;

    /**
     * @default 'Hi! Could you share your mailing address? {{0}} have a special surprise to send your way!'
     */
    rOanI: T;

    /**
     * @default 'You're invited! But first, we need your mailing address. Click the link to share with {{0}}.'
     */
    F7YcN: T;

    /**
     * @default 'Hey! {{0}} are collecting addresses to mail you a special invitation. Can you provide yours? 📬'
     */
    BH6Qt: T;

    /**
     * @default 'Can you provide your mailing address? {{0}} want to send something your way!'
     */
    LMalE: T;

    /**
     * @default 'Hey! {{0}} are getting ready to send you something special. Can you share your address with them?'
     */
    jLSdU: T;

    /**
     * @default '{{0}} are collecting addresses for their event. Please click the link to share.'
     */
    UEr51: T;

    /**
     * @default 'Set a Visual'
     */
    N832i: T;

    /**
     * @default 'Photo source'
     */
    jmBIs: T;

    /**
     * @default 'Write a Brief Note'
     */
    agUQE: T;

    /**
     * @default 'Your Message'
     */
    '4EHf6': T;

    /**
     * @default 'Link to Event Website'
     */
    iyG8j: T;

    /**
     * @default 'Display Event Date'
     */
    Kg303: T;

    /**
     * @default 'Edit Date'
     */
    '8QYHg': T;

    /**
     * @default 'Your Event Date is currently set to private. If you'd like it displayed here, please update your preferences in'
     */
    MWOUX: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default ', and refresh this page.'
     */
    HRbiZ: T;

    /**
     * @default 'Update Magic Link'
     */
    e6wTy: T;

    /**
     * @default 'Create Magic Link'
     */
    pToeX: T;

    /**
     * @default 'There was an error creating the Magic Link'
     */
    NS4UT: T;
  };
};

export type CountriesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Afghanistan'
   */
  af: T;

  /**
   * @default 'Albania'
   */
  al: T;

  /**
   * @default 'Algeria'
   */
  dz: T;

  /**
   * @default 'American Samoa'
   */
  as: T;

  /**
   * @default 'Andorra'
   */
  ad: T;

  /**
   * @default 'Angola'
   */
  ao: T;

  /**
   * @default 'Anguilla'
   */
  ai: T;

  /**
   * @default 'Antarctica'
   */
  aq: T;

  /**
   * @default 'Antigua and Barbuda'
   */
  ag: T;

  /**
   * @default 'Argentina'
   */
  ar: T;

  /**
   * @default 'Armenia'
   */
  am: T;

  /**
   * @default 'Aruba'
   */
  aw: T;

  /**
   * @default 'Australia'
   */
  au: T;

  /**
   * @default 'Austria'
   */
  at: T;

  /**
   * @default 'Azerbaijan'
   */
  az: T;

  /**
   * @default 'Bahamas'
   */
  bs: T;

  /**
   * @default 'Bahrain'
   */
  bh: T;

  /**
   * @default 'Bangladesh'
   */
  bd: T;

  /**
   * @default 'Barbados'
   */
  bb: T;

  /**
   * @default 'Belarus'
   */
  by: T;

  /**
   * @default 'Belgium'
   */
  be: T;

  /**
   * @default 'Belize'
   */
  bz: T;

  /**
   * @default 'Benin'
   */
  bj: T;

  /**
   * @default 'Bermuda'
   */
  bm: T;

  /**
   * @default 'Bhutan'
   */
  bt: T;

  /**
   * @default 'Bolivia'
   */
  bo: T;

  /**
   * @default 'Bonaire, Sint Eustatius and Saba'
   */
  bq: T;

  /**
   * @default 'Bosnia and Herzegovina'
   */
  ba: T;

  /**
   * @default 'Botswana'
   */
  bw: T;

  /**
   * @default 'Bouvet Island'
   */
  bv: T;

  /**
   * @default 'Brazil'
   */
  br: T;

  /**
   * @default 'British Indian Ocean Territory'
   */
  io: T;

  /**
   * @default 'Brunei Darussalam'
   */
  bn: T;

  /**
   * @default 'Bulgaria'
   */
  bg: T;

  /**
   * @default 'Burkina Faso'
   */
  bf: T;

  /**
   * @default 'Burundi'
   */
  bi: T;

  /**
   * @default 'Cabo Verde'
   */
  cv: T;

  /**
   * @default 'Cambodia'
   */
  kh: T;

  /**
   * @default 'Cameroon'
   */
  cm: T;

  /**
   * @default 'Canada'
   */
  ca: T;

  /**
   * @default 'Cayman Islands'
   */
  ky: T;

  /**
   * @default 'Central African Republic'
   */
  cf: T;

  /**
   * @default 'Chad'
   */
  td: T;

  /**
   * @default 'Chile'
   */
  cl: T;

  /**
   * @default 'China'
   */
  cn: T;

  /**
   * @default 'Christmas Island'
   */
  cx: T;

  /**
   * @default 'Cocos (Keeling) Islands'
   */
  cc: T;

  /**
   * @default 'Colombia'
   */
  co: T;

  /**
   * @default 'Comoros'
   */
  km: T;

  /**
   * @default 'Congo'
   */
  cg: T;

  /**
   * @default 'Congo (Democratic Republic of the)'
   */
  cd: T;

  /**
   * @default 'Cook Islands'
   */
  ck: T;

  /**
   * @default 'Costa Rica'
   */
  cr: T;

  /**
   * @default 'Côte d'Ivoire'
   */
  ci: T;

  /**
   * @default 'Croatia'
   */
  hr: T;

  /**
   * @default 'Cuba'
   */
  cu: T;

  /**
   * @default 'Curaçao'
   */
  cw: T;

  /**
   * @default 'Cyprus'
   */
  cy: T;

  /**
   * @default 'Czechia'
   */
  cz: T;

  /**
   * @default 'Denmark'
   */
  dk: T;

  /**
   * @default 'Djibouti'
   */
  dj: T;

  /**
   * @default 'Dominica'
   */
  dm: T;

  /**
   * @default 'Dominican Republic'
   */
  do: T;

  /**
   * @default 'Ecuador'
   */
  ec: T;

  /**
   * @default 'Egypt'
   */
  eg: T;

  /**
   * @default 'El Salvador'
   */
  sv: T;

  /**
   * @default 'Equatorial Guinea'
   */
  gq: T;

  /**
   * @default 'Eritrea'
   */
  er: T;

  /**
   * @default 'Estonia'
   */
  ee: T;

  /**
   * @default 'Eswatini'
   */
  sz: T;

  /**
   * @default 'Ethiopia'
   */
  et: T;

  /**
   * @default 'Falkland Islands (Malvinas)'
   */
  fk: T;

  /**
   * @default 'Faroe Islands'
   */
  fo: T;

  /**
   * @default 'Fiji'
   */
  fj: T;

  /**
   * @default 'Finland'
   */
  fi: T;

  /**
   * @default 'France'
   */
  fr: T;

  /**
   * @default 'French Guiana'
   */
  gf: T;

  /**
   * @default 'French Polynesia'
   */
  pf: T;

  /**
   * @default 'French Southern Territories'
   */
  tf: T;

  /**
   * @default 'Gabon'
   */
  ga: T;

  /**
   * @default 'Gambia'
   */
  gm: T;

  /**
   * @default 'Georgia'
   */
  ge: T;

  /**
   * @default 'Germany'
   */
  de: T;

  /**
   * @default 'Ghana'
   */
  gh: T;

  /**
   * @default 'Gibraltar'
   */
  gi: T;

  /**
   * @default 'Greece'
   */
  gr: T;

  /**
   * @default 'Greenland'
   */
  gl: T;

  /**
   * @default 'Grenada'
   */
  gd: T;

  /**
   * @default 'Guadeloupe'
   */
  gp: T;

  /**
   * @default 'Guam'
   */
  gu: T;

  /**
   * @default 'Guatemala'
   */
  gt: T;

  /**
   * @default 'Guernsey'
   */
  gg: T;

  /**
   * @default 'Guinea'
   */
  gn: T;

  /**
   * @default 'Guinea-Bissau'
   */
  gw: T;

  /**
   * @default 'Guyana'
   */
  gy: T;

  /**
   * @default 'Haiti'
   */
  ht: T;

  /**
   * @default 'Heard Island and McDonald Islands'
   */
  hm: T;

  /**
   * @default 'Holy See'
   */
  va: T;

  /**
   * @default 'Honduras'
   */
  hn: T;

  /**
   * @default 'Hong Kong'
   */
  hk: T;

  /**
   * @default 'Hungary'
   */
  hu: T;

  /**
   * @default 'Iceland'
   */
  is: T;

  /**
   * @default 'India'
   */
  in: T;

  /**
   * @default 'Indonesia'
   */
  id: T;

  /**
   * @default 'Iran'
   */
  ir: T;

  /**
   * @default 'Iraq'
   */
  iq: T;

  /**
   * @default 'Ireland'
   */
  ie: T;

  /**
   * @default 'Isle of Man'
   */
  im: T;

  /**
   * @default 'Israel'
   */
  il: T;

  /**
   * @default 'Italy'
   */
  it: T;

  /**
   * @default 'Jamaica'
   */
  jm: T;

  /**
   * @default 'Japan'
   */
  jp: T;

  /**
   * @default 'Jersey'
   */
  je: T;

  /**
   * @default 'Jordan'
   */
  jo: T;

  /**
   * @default 'Kazakhstan'
   */
  kz: T;

  /**
   * @default 'Kenya'
   */
  ke: T;

  /**
   * @default 'Kiribati'
   */
  ki: T;

  /**
   * @default 'Korea (Democratic People's Republic of)'
   */
  kp: T;

  /**
   * @default 'Korea (Republic of)'
   */
  kr: T;

  /**
   * @default 'Kuwait'
   */
  kw: T;

  /**
   * @default 'Kyrgyzstan'
   */
  kg: T;

  /**
   * @default 'Lao People's Democratic Republic'
   */
  la: T;

  /**
   * @default 'Latvia'
   */
  lv: T;

  /**
   * @default 'Lebanon'
   */
  lb: T;

  /**
   * @default 'Lesotho'
   */
  ls: T;

  /**
   * @default 'Liberia'
   */
  lr: T;

  /**
   * @default 'Libya'
   */
  ly: T;

  /**
   * @default 'Liechtenstein'
   */
  li: T;

  /**
   * @default 'Lithuania'
   */
  lt: T;

  /**
   * @default 'Luxembourg'
   */
  lu: T;

  /**
   * @default 'Macao'
   */
  mo: T;

  /**
   * @default 'Madagascar'
   */
  mg: T;

  /**
   * @default 'Malawi'
   */
  mw: T;

  /**
   * @default 'Malaysia'
   */
  my: T;

  /**
   * @default 'Maldives'
   */
  mv: T;

  /**
   * @default 'Mali'
   */
  ml: T;

  /**
   * @default 'Malta'
   */
  mt: T;

  /**
   * @default 'Marshall Islands'
   */
  mh: T;

  /**
   * @default 'Martinique'
   */
  mq: T;

  /**
   * @default 'Mauritania'
   */
  mr: T;

  /**
   * @default 'Mauritius'
   */
  mu: T;

  /**
   * @default 'Mayotte'
   */
  yt: T;

  /**
   * @default 'Mexico'
   */
  mx: T;

  /**
   * @default 'Micronesia (Federated States of)'
   */
  fm: T;

  /**
   * @default 'Moldova'
   */
  md: T;

  /**
   * @default 'Monaco'
   */
  mc: T;

  /**
   * @default 'Mongolia'
   */
  mn: T;

  /**
   * @default 'Montenegro'
   */
  me: T;

  /**
   * @default 'Montserrat'
   */
  ms: T;

  /**
   * @default 'Morocco'
   */
  ma: T;

  /**
   * @default 'Mozambique'
   */
  mz: T;

  /**
   * @default 'Myanmar'
   */
  mm: T;

  /**
   * @default 'Namibia'
   */
  na: T;

  /**
   * @default 'Nauru'
   */
  nr: T;

  /**
   * @default 'Nepal'
   */
  np: T;

  /**
   * @default 'Netherlands'
   */
  nl: T;

  /**
   * @default 'New Caledonia'
   */
  nc: T;

  /**
   * @default 'New Zealand'
   */
  nz: T;

  /**
   * @default 'Nicaragua'
   */
  ni: T;

  /**
   * @default 'Niger'
   */
  ne: T;

  /**
   * @default 'Nigeria'
   */
  ng: T;

  /**
   * @default 'Niue'
   */
  nu: T;

  /**
   * @default 'Norfolk Island'
   */
  nf: T;

  /**
   * @default 'North Macedonia'
   */
  mk: T;

  /**
   * @default 'Northern Mariana Islands'
   */
  mp: T;

  /**
   * @default 'Norway'
   */
  no: T;

  /**
   * @default 'Oman'
   */
  om: T;

  /**
   * @default 'Pakistan'
   */
  pk: T;

  /**
   * @default 'Palau'
   */
  pw: T;

  /**
   * @default 'Palestine, State of'
   */
  ps: T;

  /**
   * @default 'Panama'
   */
  pa: T;

  /**
   * @default 'Papua New Guinea'
   */
  pg: T;

  /**
   * @default 'Paraguay'
   */
  py: T;

  /**
   * @default 'Peru'
   */
  pe: T;

  /**
   * @default 'Philippines'
   */
  ph: T;

  /**
   * @default 'Pitcairn'
   */
  pn: T;

  /**
   * @default 'Poland'
   */
  pl: T;

  /**
   * @default 'Portugal'
   */
  pt: T;

  /**
   * @default 'Puerto Rico'
   */
  pr: T;

  /**
   * @default 'Qatar'
   */
  qa: T;

  /**
   * @default 'Réunion'
   */
  re: T;

  /**
   * @default 'Romania'
   */
  ro: T;

  /**
   * @default 'Russian Federation'
   */
  ru: T;

  /**
   * @default 'Rwanda'
   */
  rw: T;

  /**
   * @default 'Saint Barthélemy'
   */
  bl: T;

  /**
   * @default 'Saint Helena, Ascension and Tristan da Cunha'
   */
  sh: T;

  /**
   * @default 'Saint Kitts and Nevis'
   */
  kn: T;

  /**
   * @default 'Saint Lucia'
   */
  lc: T;

  /**
   * @default 'Saint Martin (French part)'
   */
  mf: T;

  /**
   * @default 'Saint Pierre and Miquelon'
   */
  pm: T;

  /**
   * @default 'Saint Vincent and the Grenadines'
   */
  vc: T;

  /**
   * @default 'Samoa'
   */
  ws: T;

  /**
   * @default 'San Marino'
   */
  sm: T;

  /**
   * @default 'Sao Tome and Principe'
   */
  st: T;

  /**
   * @default 'Saudi Arabia'
   */
  sa: T;

  /**
   * @default 'Senegal'
   */
  sn: T;

  /**
   * @default 'Serbia'
   */
  rs: T;

  /**
   * @default 'Seychelles'
   */
  sc: T;

  /**
   * @default 'Sierra Leone'
   */
  sl: T;

  /**
   * @default 'Singapore'
   */
  sg: T;

  /**
   * @default 'Sint Maarten (Dutch part)'
   */
  sx: T;

  /**
   * @default 'Slovakia'
   */
  sk: T;

  /**
   * @default 'Slovenia'
   */
  si: T;

  /**
   * @default 'Solomon Islands'
   */
  sb: T;

  /**
   * @default 'Somalia'
   */
  so: T;

  /**
   * @default 'South Africa'
   */
  za: T;

  /**
   * @default 'South Georgia and the South Sandwich Islands'
   */
  gs: T;

  /**
   * @default 'South Sudan'
   */
  ss: T;

  /**
   * @default 'Spain'
   */
  es: T;

  /**
   * @default 'Sri Lanka'
   */
  lk: T;

  /**
   * @default 'Sudan'
   */
  sd: T;

  /**
   * @default 'Suriname'
   */
  sr: T;

  /**
   * @default 'Svalbard and Jan Mayen'
   */
  sj: T;

  /**
   * @default 'Sweden'
   */
  se: T;

  /**
   * @default 'Switzerland'
   */
  ch: T;

  /**
   * @default 'Syrian Arab Republic'
   */
  sy: T;

  /**
   * @default 'Taiwan'
   */
  tw: T;

  /**
   * @default 'Tajikistan'
   */
  tj: T;

  /**
   * @default 'Tanzania'
   */
  tz: T;

  /**
   * @default 'Thailand'
   */
  th: T;

  /**
   * @default 'Timor-Leste'
   */
  tl: T;

  /**
   * @default 'Togo'
   */
  tg: T;

  /**
   * @default 'Tokelau'
   */
  tk: T;

  /**
   * @default 'Tonga'
   */
  to: T;

  /**
   * @default 'Trinidad and Tobago'
   */
  tt: T;

  /**
   * @default 'Tunisia'
   */
  tn: T;

  /**
   * @default 'Turkey'
   */
  tr: T;

  /**
   * @default 'Turkmenistan'
   */
  tm: T;

  /**
   * @default 'Turks and Caicos Islands'
   */
  tc: T;

  /**
   * @default 'Tuvalu'
   */
  tv: T;

  /**
   * @default 'Uganda'
   */
  ug: T;

  /**
   * @default 'Ukraine'
   */
  ua: T;

  /**
   * @default 'United Arab Emirates'
   */
  ae: T;

  /**
   * @default 'United Kingdom'
   */
  gb: T;

  /**
   * @default 'United States Minor Outlying Islands'
   */
  um: T;

  /**
   * @default 'United States'
   */
  us: T;

  /**
   * @default 'Uruguay'
   */
  uy: T;

  /**
   * @default 'Uzbekistan'
   */
  uz: T;

  /**
   * @default 'Vanuatu'
   */
  vu: T;

  /**
   * @default 'Venezuela'
   */
  ve: T;

  /**
   * @default 'Viet Nam'
   */
  vn: T;

  /**
   * @default 'Virgin Islands (British)'
   */
  vg: T;

  /**
   * @default 'Virgin Islands (U.S.)'
   */
  vi: T;

  /**
   * @default 'Wallis and Futuna'
   */
  wf: T;

  /**
   * @default 'Western Sahara'
   */
  eh: T;

  /**
   * @default 'Yemen'
   */
  ye: T;

  /**
   * @default 'Zambia'
   */
  zm: T;

  /**
   * @default 'Zimbabwe'
   */
  zw: T;
};

export type CreateBabyRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Create your Joy Event'
   */
  title: T;

  /**
   * @default 'Start creating your registry today and celebrate this special milestone with Joy!'
   */
  description: T;

  /**
   * @default 'Congratulations! You’re in for an amazing journey.'
   */
  heroText: T;

  /**
   * @default 'Let’s get your registry started.<helpChangeDetails/>'
   */
  helpText: T;

  /**
   * @default 'You can change these details later.'
   */
  helpChangeDetails: T;

  createEventForm: {
    /**
     * @default 'Your First Name'
     */
    ownerFirstName: T;

    /**
     * @default 'Your Last Name'
     */
    ownerLastName: T;

    /**
     * @default 'Pat'
     */
    ownerFirstNamePlaceholder: T;

    /**
     * @default 'Smith'
     */
    ownerLastNamePlaceholder: T;

    /**
     * @default 'Baby’s Estimated Arrival Date'
     */
    babyArrivalDate: T;

    /**
     * @default 'Not sure yet'
     */
    skipDateDefinition: T;

    /**
     * @default 'Create Registry'
     */
    createEventCta: T;

    errors: {
      /**
       * @default 'First name is required.'
       */
      ownerFirstNameRequired: T;

      /**
       * @default 'Last name is required.'
       */
      ownerLastNameRequired: T;

      /**
       * @default 'Baby’s estimated arrival date is required.'
       */
      registryDateRequired: T;
    };
  };
};

export type CreateEventTranslations<T extends LeafNodeValue = TranslateFunction> = {
  createAccount: {
    general: {
      /**
       * @default ''
       */
      devAlertMessage: T;
    };
    wedding: {
      /**
       * @default 'This is a test environment for the Joy engineering team. Are you sure you want to create an event here? Click cancel to be redirected to our main site.'
       */
      devAlertMessage: T;
    };
    babyRegistry: {
      /**
       * @default 'This is a test environment for the Joy engineering team. Are you sure you want to create a baby registry here? Click cancel to be redirected to our main site.'
       */
      devAlertMessage: T;

      /**
       * @default 'Celebrate life’s joyful moments.'
       */
      heroText: T;

      /**
       * @default 'Create one account for all your Joy events. Sign up or'
       */
      helpText: T;
    };
    errors: {
      /**
       * @default 'Please enter an email'
       */
      emailRequired: T;

      /**
       * @default 'Please enter a valid email address'
       */
      emailValid: T;

      /**
       * @default 'Please enter a password'
       */
      passwordRequired: T;
    };

    /**
     * @default 'log in.'
     */
    signIn: T;

    /**
     * @default 'Sign in with Facebook'
     */
    signInWithFacebook: T;

    /**
     * @default 'Sign in with Google'
     */
    signInWithGoogle: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Password'
     */
    password: T;

    /**
     * @default 'Create Account'
     */
    createAccountCta: T;

    /**
     * @default 'privacy policy'
     */
    privacyPolicy: T;

    /**
     * @default 'terms of service'
     */
    termsOfService: T;

    /**
     * @default 'CA Privacy Notice.'
     */
    privacyNotice: T;

    /**
     * @default 'By creating an account you agree to Joy's <PrivacyPolicy/> and <TermsOfService/>. <PrivacyNotice/>'
     */
    termsAndPrivacy: T;
  };
  socialAccount: {
    /**
     * @default 'To create a baby registry, sign in with email and password'
     */
    createEventTitle: T;

    /**
     * @default 'You're currently signed in with {{provider}}, and creating baby registry with {{provider}} is no longer supported.'
     */
    currentAuthDisclaimer: T;

    /**
     * @default 'The good news is you can still create a baby registry by signing in with email and password.'
     */
    goodNews: T;

    /**
     * @default 'Create registry with email and password'
     */
    createEventCta: T;
  };
  searchBanner: {
    /**
     * @default 'Looking for an event or registry?'
     */
    text: T;
  };
  notYou: {
    /**
     * @default 'Not {{email}}?'
     */
    changeAccount: T;

    /**
     * @default 'Sign Out'
     */
    signOut: T;
  };
  tyingTheKnot: {
    /**
     * @default 'We've thought of everything, so you don't have to.'
     */
    loadingText: T;

    /**
     * @default 'Help Center'
     */
    helpCenter: T;

    /**
     * @default 'Oops! Something’s amiss. Disable Adblocker or VPN and try again. If the issue continues, visit our <HelpCenter/>'
     */
    errorText: T;
  };
};

export type CreateGeneralTranslations<T extends LeafNodeValue = TranslateFunction> = {
  createGeneralForm: {
    /**
     * @default 'By creating an account you agree to Joy's <PrivacyPolicy/> and <TermsOfService/>. <PrivacyNotice/>'
     */
    termsAndPrivacy: T;
  };
  quick: {
    /**
     * @default 'There was an issue creating your event. Please try again.'
     */
    ueZxA: T;

    /**
     * @default 'Please enter a valid email address'
     */
    Zf7AP: T;

    /**
     * @default 'Please enter an email'
     */
    fwiR3: T;

    /**
     * @default 'Please enter a password'
     */
    WdKje: T;

    /**
     * @default 'There was an error creating your account. Please try again.'
     */
    iEg0c: T;

    /**
     * @default 'Hi! Let's get started.'
     */
    cr4mg: T;

    /**
     * @default 'Already have an account?'
     */
    RsKwS: T;

    /**
     * @default 'Log in'
     */
    '10NHD': T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Password'
     */
    dLXuW: T;

    /**
     * @default 'Create Account'
     */
    TZwKT: T;

    /**
     * @default 'Please select an event type'
     */
    rjg9N: T;

    /**
     * @default 'Please enter a name for your event'
     */
    kX9j6: T;

    /**
     * @default 'Please enter a location'
     */
    OQjB2: T;

    /**
     * @default 'Event start time cannot be in the past. Setting to next available time.'
     */
    deN0L: T;

    /**
     * @default 'End date must be after start date. Setting to next available time.'
     */
    JxgLc: T;

    /**
     * @default 'Select event type'
     */
    oKAyu: T;

    /**
     * @default 'Event Start'
     */
    gQM8O: T;

    /**
     * @default 'Event End'
     */
    dKqb6: T;

    /**
     * @default 'Event Timezone'
     */
    '1oUd0': T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'There was an error resetting your password. Please try again.'
     */
    cOoZh: T;

    /**
     * @default 'Forgot your password?'
     */
    KylRy: T;

    /**
     * @default 'Enter the email you used to signup for Joy and we'll send you an email to reset it.'
     */
    guSNM: T;

    /**
     * @default 'Reset Password'
     */
    c9fHt: T;

    /**
     * @default 'New to Joy?'
     */
    MXi7b: T;

    /**
     * @default 'Log into Joy. 🎉'
     */
    Bm1HF: T;

    /**
     * @default 'Don't have an account?'
     */
    '3kFXl': T;

    /**
     * @default 'Forgot password?'
     */
    lxOzM: T;
  };
};

export type CreateRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  pasteLink: {
    /**
     * @default 'Add a registry from another store'
     */
    title: T;

    /**
     * @default 'Put all your registries in one place for your guests.'
     */
    subtitle: T;

    /**
     * @default 'Registry URL'
     */
    inputlabel: T;

    /**
     * @default 'amazon.com/my-registry'
     */
    inputPlaceholder: T;

    /**
     * @default 'How does it work?'
     */
    learnMore: T;

    /**
     * @default 'Add Registry'
     */
    buttonText: T;
  };
  registryStoreSection: {
    default: {
      /**
       * @default 'Don’t have a registry yet? Quickly get started.'
       */
      title: T;

      /**
       * @default 'Find and add popular stores and charities recommended by other Joy recipient'
       */
      subtitle: T;
    };
    mobile: {
      /**
       * @default 'Pick your stores'
       */
      title: T;

      /**
       * @default 'Find and add popular stores and charities recommended by other Joy recipient'
       */
      subtitle: T;
    };

    /**
     * @default 'Show more'
     */
    showMore: T;

    /**
     * @default 'Show fewer'
     */
    showFewer: T;

    /**
     * @default 'The only cash fund registry with zero fees. Whether saving for a house, honeymoon, or other purchase, create a cash fund and personalize your cash gift requests to make your dreams a reality.'
     */
    cashFundDescription: T;

    /**
     * @default 'Create Cash Fund'
     */
    cashFundTitle: T;
  };
  storeDialog: {
    /**
     * @default 'Create New Registry'
     */
    createNewRegistry: T;

    /**
     * @default 'Add Existing Registry'
     */
    addExistingRegistry: T;

    /**
     * @default 'Congratulations on creating your registry! Paste in your registry URL below to add it to your wedding website.'
     */
    congrats: T;
  };
  validation: {
    /**
     * @default 'Invalid URL'
     */
    invalidDomain: T;

    /**
     * @default 'Required'
     */
    required: T;
  };
  addRegistryDialog: {
    /**
     * @default 'Link Registry'
     */
    title: T;

    /**
     * @default 'Edit Registry'
     */
    updateTitle: T;

    /**
     * @default 'Update Registry'
     */
    actionUpdateText: T;

    /**
     * @default 'Save'
     */
    actionText: T;

    /**
     * @default 'Cancel'
     */
    cancelActionText: T;

    /**
     * @default 'Registry Link'
     */
    urlInputLabel: T;

    /**
     * @default 'Registry Title'
     */
    nameInputLabel: T;

    /**
     * @default 'Link'
     */
    urlInputPlaceholder: T;

    /**
     * @default 'Title'
     */
    nameInputPlaceholder: T;

    /**
     * @default 'Registry Image'
     */
    registryImageLabel: T;

    /**
     * @default 'Delete Registry'
     */
    deleteActionText: T;

    /**
     * @default 'Test Registry Link'
     */
    testLink: T;
  };
  addGift: {
    default: {
      /**
       * @default 'Add gifts from any store'
       */
      title: T;

      /**
       * @default 'Paste a link to add anything from any site to your Joy registry.'
       */
      subtitle: T;

      /**
       * @default 'Add Gift'
       */
      buttonText: T;
    };
    mobile: {
      /**
       * @default 'Add a gift from any store'
       */
      title: T;

      /**
       * @default 'Find something you want from another store? Copy and paste the link to add that gift to your Joy registry.'
       */
      subtitle: T;

      /**
       * @default 'Add Gift'
       */
      buttonText: T;
    };
  };
  linkRegistry: {
    /**
     * @default 'Already have a registry?'
     */
    title: T;

    /**
     * @default 'Put all your registries in one place for your guests’ convenience. '
     */
    subtitle: T;

    /**
     * @default 'Find and Add'
     */
    findAndAdd: T;

    /**
     * @default 'Ex. amazon.com/registry/userid'
     */
    inputPlaceholder: T;

    /**
     * @default ' Learn more.'
     */
    learnMore: T;

    /**
     * @default 'Link Registry'
     */
    linkRegistry: T;

    /**
     * @default 'Add Registry'
     */
    addRegistry: T;
  };
  welcomeHeader: {
    /**
     * @default 'Welcome to Your All-In-One Registry'
     */
    title: T;

    valueProps: {
      connectRegistries: {
        /**
         * @default 'Connect Registries'
         */
        title: T;

        /**
         * @default 'Everything in one place.'
         */
        subtitle: T;
      };
      shopJoy: {
        /**
         * @default 'Shop on Joy'
         */
        title: T;

        /**
         * @default 'Find the perfect gift.'
         */
        subtitle: T;
      };
      shopTheWeb: {
        /**
         * @default 'Shop the Web'
         */
        title: T;

        /**
         * @default 'Add from anywhere.'
         */
        subtitle: T;
      };
    };
  };
  productCards: {
    shopNow: {
      /**
       * @default 'Shop and build your happily ever after.'
       */
      title: T;

      /**
       * @default 'From kitchens to gardens.'
       */
      subtitle: T;

      /**
       * @default 'Shop Now'
       */
      buttonText: T;
    };
    exploreCashFunds: {
      /**
       * @default 'Zero-fee cash funds are here.'
       */
      title: T;

      /**
       * @default 'Jump start your dreams.'
       */
      subtitle: T;

      /**
       * @default 'Create Cash Fund'
       */
      buttonText: T;
    };
    getBrowserBtn: {
      /**
       * @default 'Add anything as you browse the web.'
       */
      title: T;

      /**
       * @default 'One click to add.'
       */
      subtitle: T;

      /**
       * @default 'Get the Quick Add Button'
       */
      buttonText: T;
    };
    downloadApp: {
      /**
       * @default 'Get the app and add gifts on the go.'
       */
      title: T;

      /**
       * @default 'Browse or search, whenever, wherever.'
       */
      subtitle: T;

      /**
       * @default 'Download the App'
       */
      buttonText: T;
    };
    browsingSotres: {
      /**
       * @default 'Start shopping from your favorite stores.'
       */
      title: T;

      /**
       * @default 'Just browse and tap to add gifts.'
       */
      subtitle: T;

      /**
       * @default 'Find and Add Gifts'
       */
      buttonText: T;
    };
  };
  experiments: {
    installBrowserButton: {
      native: {
        /**
         * @default 'Find and Add'
         */
        buttonText: T;
      };
      mobile: {
        /**
         * @default 'Open Joy App'
         */
        buttonText: T;
      };
      default: {
        /**
         * @default 'Get the Quick Add Button'
         */
        buttonText: T;
      };
    };
  };
  promoFeed: {
    firstItem: {
      /**
       * @default 'Add your first gift'
       */
      hed: T;

      /**
       * @default 'Amazing products, cash funds, and charities... oh my!'
       */
      dek: T;
    };

    introBlock: [
      {
        /**
         * @default 'Let's get shopping'
         */
        hed: T;

        /**
         * @default 'Check back daily for inspiration'
         */
        dek: T;
      },
      {
        /**
         * @default 'Get your shop on'
         */
        hed: T;

        /**
         * @default 'We're whippin' up more ideas on the daily'
         */
        dek: T;
      },
      {
        /**
         * @default 'New ideas and inspo'
         */
        hed: T;

        /**
         * @default 'Window shopping is what's up'
         */
        dek: T;
      },
      {
        /**
         * @default 'Dream big'
         */
        hed: T;

        /**
         * @default 'We've got some fresh ideas for you'
         */
        dek: T;
      },
      {
        /**
         * @default 'Get into ship shop page'
         */
        hed: T;

        /**
         * @default 'Your registry's gotta look good'
         */
        dek: T;
      },
    ];

    outroBlock: [
      {
        /**
         * @default 'Did you know?'
         */
        hed: T;

        /**
         * @default 'This is like fantasy football, but for shopping, and you're always the winner.'
         */
        dek: T;
      },
      {
        /**
         * @default 'The first retail registry was built in 1924'
         */
        hed: T;

        /**
         * @default 'You can thank Macy's for bringing it mainstream.'
         */
        dek: T;
      },
      {
        /**
         * @default '"On the reg" has a whole new meaning'
         */
        hed: T;

        /**
         * @default 'It's where all the cool products want to be.'
         */
        dek: T;
      },
    ];

    /**
     * @default 'Add to Registry'
     */
    addToRegistry: T;

    /**
     * @default 'Item Added'
     */
    addedToRegistry: T;

    /**
     * @default 'Shop by Department'
     */
    departmentNavTitle: T;
  };
  invitePartner: {
    /**
     * @default 'Shop together.'
     */
    title: T;

    /**
     * @default 'Invite your person.'
     */
    titleSecondLine: T;

    /**
     * @default 'Divide and conquer to make quick work of building out your perfect registry.'
     */
    subtitle: T;

    /**
     * @default 'Invite Your Person'
     */
    buttonText: T;
  };
  transferRegistry: {
    /**
     * @default 'Don’t forget to make your old registry private'
     */
    publicReminderTitle: T;

    /**
     * @default 'The registry you transferred to Joy is still publicly visible, which can result in duplicate gifts. We recommend hiding the following registry:'
     */
    publicReminderSubtitle: T;

    /**
     * @default 'Continue adding gifts from your favorite stores using the'
     */
    publicReminderDesc: T;

    /**
     * @default 'Joy Browser Button'
     */
    publicReminderCTA: T;

    /**
     * @default ' or the '
     */
    publicReminderCTACont: T;

    /**
     * @default 'Joy App'
     */
    publicReminderCTAApp: T;

    /**
     * @default 'Got It'
     */
    publicReminderButton: T;

    /**
     * @default 'Set your {{storeName}} registry private to avoid duplicate gifts.'
     */
    bannerTitle: T;

    /**
     * @default 'Your registry was last seen as public at {{lastCheckDate}}.'
     */
    bannerSubtitle: T;

    /**
     * @default 'Fix Privacy'
     */
    bannerButton: T;

    /**
     * @default 'We only check this once a day, so if it doesn't seem accurate please check back tomorrow.'
     */
    bannerTooltip: T;

    /**
     * @default 'Learn How'
     */
    learnHow: T;
  };
};

export type CreateWeddingTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Create your Joy Event'
   */
  title: T;

  /**
   * @default 'Craft your dream wedding with Joy and become part of a community of over one million  couples who effortlessly planned their special day with joy and ease!'
   */
  description: T;

  createAccount: {
    scenarios: {
      default: {
        /**
         * @default 'Hi! Let’s get started.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      'save-the-date': {
        /**
         * @default 'Smarter Save the Dates, coming right up.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      invitation: {
        /**
         * @default 'Smarter invitations, coming right up.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      'wedding-website': {
        /**
         * @default 'Let’s get ready to get planning'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      'guest-list': {
        /**
         * @default 'Start building your smarter guest list.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      registry: {
        /**
         * @default 'Start building your all-in-one registry.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      app: {
        /**
         * @default 'The smarter app for you and your guests.'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
      'imagine-your-card': {
        /**
         * @default 'Sign up for free to finish creating your card'
         */
        heroText: T;

        /**
         * @default 'Already have an account?'
         */
        helpText: T;
      };
    };
    errors: {
      /**
       * @default 'Please enter an email'
       */
      emailRequired: T;

      /**
       * @default 'Please enter a valid email'
       */
      emailValid: T;

      /**
       * @default 'Please enter a password'
       */
      passwordRequired: T;
    };

    /**
     * @default 'Sign In.'
     */
    signIn: T;

    /**
     * @default 'Sign in with Facebook'
     */
    signInWithFacebook: T;

    /**
     * @default 'Sign in with Google'
     */
    signInWithGoogle: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Password'
     */
    password: T;

    /**
     * @default 'Create Account'
     */
    createAccountCta: T;

    /**
     * @default 'privacy policy'
     */
    privacyPolicy: T;

    /**
     * @default 'terms of service'
     */
    termsOfService: T;

    /**
     * @default 'CA Privacy Notice.'
     */
    privacyNotice: T;

    /**
     * @default 'By creating an account you agree to Joy's <PrivacyPolicy/> and <TermsOfService/>. <PrivacyNotice/>'
     */
    termsAndPrivacy: T;

    /**
     * @default 'Attending as a guest?'
     */
    findCoupleText: T;

    /**
     * @default 'Find a Couple'
     */
    findCoupleLink: T;

    /**
     * @default 'Join over one million happy couples who planned their wedding with Joy.'
     */
    sidebarText: T;
  };
  signIn: {
    /**
     * @default 'Log into Joy. 🎉'
     */
    heroText: T;

    /**
     * @default 'Don't have an account?'
     */
    helpText: T;

    /**
     * @default 'Create Account.'
     */
    createAccount: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Password'
     */
    password: T;

    /**
     * @default 'Login'
     */
    login: T;

    /**
     * @default 'Forgot password?'
     */
    forgotCredentials: T;

    /**
     * @default 'Join over one million happy couples'
     */
    socialProofBanner: T;

    errors: {
      /**
       * @default 'Please enter an email'
       */
      emailRequired: T;

      /**
       * @default 'Please enter a valid email'
       */
      emailValid: T;

      /**
       * @default 'Please enter a password'
       */
      passwordRequired: T;
    };
  };
  forgotPassword: {
    /**
     * @default 'Forgot your password?'
     */
    heroText: T;

    /**
     * @default 'Enter the email you used to signup for Joy and we’ll send you an email to reset it.'
     */
    helpText: T;

    /**
     * @default 'Enter your email'
     */
    email: T;

    /**
     * @default 'Reset Password'
     */
    resetPassword: T;

    /**
     * @default 'Already have an account?'
     */
    accountExists: T;

    /**
     * @default 'Log in'
     */
    login: T;

    /**
     * @default 'New to Joy?'
     */
    createAccountCta: T;

    /**
     * @default 'Create An Account'
     */
    createAccount: T;
  };
  weddingForm: {
    scenarios: {
      default: {
        /**
         * @default 'Let’s get ready to get planning'
         */
        heroText: T;

        /**
         * @default 'We'll need a few details first.'
         */
        helpText: T;
      };
      defaultAbTest: {
        /**
         * @default 'Nice to meet you, {{ownerFirstName}} & {{partnerFirstName}}!'
         */
        heroText: T;

        /**
         * @default 'Let's talk details.'
         */
        helpText: T;
      };
      'save-the-date': {
        /**
         * @default 'Smarter Save the Dates, coming right up.'
         */
        heroText: T;

        /**
         * @default 'We'll need a few details first.'
         */
        helpText: T;
      };
      invitation: {
        /**
         * @default 'Smarter invitations, coming right up.'
         */
        heroText: T;

        /**
         * @default 'We'll need a few details first.'
         */
        helpText: T;
      };
      'wedding-website': {
        /**
         * @default 'Let’s get ready to get planning'
         */
        heroText: T;

        /**
         * @default 'We'll need a few details first.'
         */
        helpText: T;
      };
      'guest-list': {
        /**
         * @default 'Start building your smarter guest list.'
         */
        heroText: T;

        /**
         * @default 'We'll need a few details first.'
         */
        helpText: T;
      };
      registry: {
        /**
         * @default 'Start building your all-in-one registry.'
         */
        heroText: T;

        /**
         * @default 'We'll need a few details first.'
         */
        helpText: T;
      };
      app: {
        /**
         * @default 'The smarter app for you and your guests.'
         */
        heroText: T;

        /**
         * @default 'We'll need a few details first.'
         */
        helpText: T;
      };
    };

    /**
     * @default 'First, a quick introduction.'
     */
    coupleFormHeroText: T;

    /**
     * @default 'Tell us your names.'
     */
    coupleFormHelpText: T;

    /**
     * @default 'Your First Name'
     */
    ownerFirstName: T;

    /**
     * @default 'Your Partner's First Name'
     */
    partnerFirstName: T;

    /**
     * @default 'How many guests are coming?'
     */
    guestsNumberLabel: T;

    /**
     * @default 'Are you hiring a wedding planner?'
     */
    weddingPlannerLabel: T;

    /**
     * @default 'Jordan'
     */
    ownerFirstNamePlaceholder: T;

    /**
     * @default 'Cameron'
     */
    partnerFirstNamePlaceholder: T;

    /**
     * @default 'Provide an estimate'
     */
    guestsNumberPlaceholder: T;

    /**
     * @default 'Let us know'
     */
    weddingPlannerPlaceholder: T;

    /**
     * @default 'Yes, we're using a wedding planner.'
     */
    weddingPlannerOptionYes: T;

    /**
     * @default 'No, we're doing our own planning.'
     */
    weddingPlannerOptionNo: T;

    /**
     * @default 'We're not sure yet.'
     */
    weddingPlannerOptionUnknown: T;

    /**
     * @default 'Start typing to see options'
     */
    noOptions: T;

    /**
     * @default 'Wedding Date'
     */
    weddingDate: T;

    /**
     * @default 'We haven't picked a date (yet)'
     */
    skipDateDefinition: T;

    /**
     * @default 'Location'
     */
    location: T;

    /**
     * @default 'Next'
     */
    createWeddingCta: T;

    /**
     * @default 'Not {{email}}? <SignOut/>'
     */
    changeAccount: T;

    /**
     * @default 'Sign Out'
     */
    signOut: T;

    errors: {
      /**
       * @default 'We need your first name.'
       */
      firstNameRequired: T;

      /**
       * @default 'Who are you getting hitched with?'
       */
      partnerNameRequired: T;

      /**
       * @default 'Pick a place, any place. You can always change it.'
       */
      locationRequired: T;

      /**
       * @default 'Please re-enter the date in MM/DD/YYYY format'
       */
      invalidDate: T;
    };
    customEvent: {
      /**
       * @default 'You are trying to create a custom event. We're working on supporting custom events soon! For now, you can create a wedding and configure it to fit your needs.'
       */
      description: T;

      /**
       * @default 'Start Creating My Custom Event'
       */
      buttonTitle: T;
    };
  };
  questionnaire: {
    /**
     * @default 'How did you hear about Joy?'
     */
    sourceQuestion: T;

    /**
     * @default 'Check all that apply'
     */
    checkAll: T;

    /**
     * @default 'Submit'
     */
    submit: T;

    /**
     * @default 'Skip'
     */
    skip: T;

    questions: {
      /**
       * @default 'Friend or family member'
       */
      friendOrFamilyMember: T;

      /**
       * @default 'Attended a wedding that used Joy'
       */
      weddingThatUsedJoy: T;

      /**
       * @default 'Online Search'
       */
      search: T;

      /**
       * @default 'News / Media outlet'
       */
      news: T;

      /**
       * @default 'Blog'
       */
      blog: T;

      /**
       * @default 'Social Media'
       */
      socialMedia: T;

      /**
       * @default 'Influencer'
       */
      influencer: T;

      /**
       * @default 'Podcast'
       */
      podcast: T;

      /**
       * @default 'Advertisement'
       */
      ad: T;

      /**
       * @default 'Email'
       */
      email: T;

      /**
       * @default 'Other'
       */
      other: T;
    };
  };
  tyingTheKnot: {
    /**
     * @default 'We've thought of everything, so you don't have to.'
     */
    loadingText: T;

    /**
     * @default 'Help Center'
     */
    helpCenter: T;

    /**
     * @default 'Oops! Something’s amiss. Disable Adblocker or VPN and try again. If the issue continues, visit our <HelpCenter/>'
     */
    errorText: T;

    /**
     * @default 'You’re rocking event creation! To keep things smooth for everyone, kindly space out your event creations and try again in about an hour. If the issue continues, visit our <HelpCenter/>'
     */
    rateLimitErrorText: T;
  };
  weddingAlreadyExists: {
    /**
     * @default 'Looks like you already made'
     */
    alreadyMade: T;

    /**
     * @default 'Right now we support only one website per account.'
     */
    onlyOneWebsiteSupported: T;

    /**
     * @default 'If you would like to create a second site, please first logout of your account and sign up with a different email.'
     */
    createSecondSite: T;

    /**
     * @default 'Proceed to Website'
     */
    proceedWebsite: T;

    /**
     * @default 'Logout and Continue'
     */
    logout: T;
  };
  socialAccount: {
    /**
     * @default 'To create an event, sign in with email and password'
     */
    createEventTitle: T;

    /**
     * @default 'You're currently signed in with {{provider}}, and creating events with {{provider}} is no longer supported.'
     */
    currentAuthDisclaimer: T;

    /**
     * @default 'The good news is you can still create an event by signing in with email and password.'
     */
    goodNews: T;

    /**
     * @default 'Create event with email and password'
     */
    createEventCta: T;
  };
  survey: {
    /**
     * @default 'Lastly, what brings you here?'
     */
    title: T;

    /**
     * @default 'Select all that interest you.'
     */
    subtitle: T;

    /**
     * @default 'Wedding Website'
     */
    website: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Invitations & Save the Dates'
     */
    invitations: T;

    /**
     * @default 'Guest List & RSVP'
     */
    guestList: T;

    cta: {
      /**
       * @default 'Let's go!'
       */
      proceed: T;

      /**
       * @default 'Skip'
       */
      skip: T;
    };
  };
  quick: {
    /**
     * @default 'Add your venue, even if it’s not final, to get tailored recommendations for your big day.'
     */
    XQCV3: T;

    /**
     * @default 'Event Venue'
     */
    DR5KP: T;

    /**
     * @default 'San Francisco City Hall'
     */
    QSamB: T;

    /**
     * @default 'We haven't picked a venue (yet)'
     */
    QyZcV: T;

    /**
     * @default 'Invalid template settings payload'
     */
    MZ3tl: T;

    /**
     * @default 'Invalid website design settings'
     */
    JARlU: T;

    /**
     * @default 'Failed to parse website design settings'
     */
    z7LVU: T;

    /**
     * @default 'We need your first name.'
     */
    '4d4cM': T;

    /**
     * @default 'Please re-enter the date in MM/DD/YYYY format'
     */
    '5dGnM': T;

    /**
     * @default 'Pick a place, any place. You can always change it.'
     */
    D1rUk: T;

    /**
     * @default 'Skip'
     */
    TMBNA: T;

    /**
     * @default 'Join over one million happy couples who planned their wedding with Joy.'
     */
    PdVC1: T;

    /**
     * @default 'Add your venue for your event. If you haven't picked a venue yet, check the box below.'
     */
    zKpVe: T;

    /**
     * @default 'You can add a venue you’re considering and update this later — or check the box to skip for now.'
     */
    cg24B: T;
  };
};

export type CurationsRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  curations: {
    /**
     * @default 'Curations'
     */
    departmentTitle: T;

    /**
     * @default 'Home'
     */
    defaultDepartmentTitle: T;
  };
  sections: {
    /**
     * @default 'Explore more collections'
     */
    exploreOthersTitle: T;

    /**
     * @default 'Add All'
     */
    addAll: T;

    /**
     * @default 'Added'
     */
    addedAll: T;

    /**
     * @default 'Added to Registry'
     */
    addedAllToRegistry: T;

    /**
     * @default 'Add All to Registry'
     */
    addAllToRegistry: T;
  };
};

export type CurrenciesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'United States Dollar'
     */
    '91iKh': T;

    /**
     * @default 'Euro'
     */
    '5N7KA': T;

    /**
     * @default 'Pound Sterling'
     */
    '01bzz': T;

    /**
     * @default 'Canadian Dollar'
     */
    d8ElE: T;

    /**
     * @default 'Australian Dollar'
     */
    qEwoZ: T;

    /**
     * @default 'Yen'
     */
    wGaAA: T;

    /**
     * @default 'New Zealand Dollar'
     */
    tvakv: T;
  };
};

export type CustomDomainTranslations<T extends LeafNodeValue = TranslateFunction> = {
  domainSearch: {
    /**
     * @default 'Personalize Your URL'
     */
    personalizeURL: T;

    /**
     * @default 'may be available'
     */
    domainSuggestion: T;

    /**
     * @default 'Custom domains are an optional service provided by GoDaddy, not Joy. Domain masking is not supported.'
     */
    poweredByText: T;

    /**
     * @default 'Learn more'
     */
    learnMoreText: T;
  };
  addDomainDialog: {
    /**
     * @default 'How would you like to add a custom domain?'
     */
    dialogTitle: T;

    /**
     * @default 'Find the Perfect Domain'
     */
    buttonText: T;

    /**
     * @default 'I already have a domain'
     */
    linkText: T;
  };
  connectDomainDialog: {
    /**
     * @default 'Did you just buy a new domain?'
     */
    dialogTitle: T;

    /**
     * @default 'We’ll walk you through how to connect your domain to your Joy website.'
     */
    dialogSubtitle: T;

    /**
     * @default 'Yes, Connect My Domain'
     */
    buttonText: T;

    /**
     * @default 'No, but maybe later'
     */
    laterText: T;

    /**
     * @default 'No, I’m not interested'
     */
    notInterestedText: T;

    dialogActions: [
      {
        /**
         * @default 'Search Again'
         */
        title: T;

        /**
         * @default 'Find the domain you’re looking for.'
         */
        description: T;

        /**
         * @default 'Search Domains'
         */
        actionText: T;
      },
      {
        /**
         * @default 'Have More Questions?'
         */
        title: T;

        /**
         * @default 'Our FAQ section may have the answers.'
         */
        description: T;

        /**
         * @default 'Explore FAQs'
         */
        actionText: T;
      },
      {
        /**
         * @default 'We’re Here For You'
         */
        title: T;

        /**
         * @default 'Our team is just a chat bubble away.'
         */
        description: T;

        /**
         * @default 'Talk to Us'
         */
        actionText: T;
      },
    ];
  };
  findDomainDialog: {
    /**
     * @default 'may be available...'
     */
    dialogTitlePart: T;

    /**
     * @default 'Personalize your site and make it easier to share with a custom domain.'
     */
    dialogSubtitle: T;

    /**
     * @default 'Find the Perfect Domain'
     */
    buttonText: T;

    /**
     * @default 'Settings'
     */
    settingsText: T;
  };
  inputDomainDialog: {
    /**
     * @default 'What is your custom domain?'
     */
    dialogTitle: T;

    /**
     * @default 'Having trouble? '
     */
    dialogHelpText: T;

    /**
     * @default 'We’re here to help'
     */
    dialogHelpTextLink: T;

    /**
     * @default 'Test URL'
     */
    testButtonText: T;

    /**
     * @default 'Save'
     */
    saveButtonText: T;

    /**
     * @default 'Domain cannot be blank'
     */
    blankDomainError: T;

    /**
     * @default 'Not a valid domain'
     */
    notValidDomainError: T;
  };
  removeDomainDialog: {
    /**
     * @default 'Are you sure you want to remove your custom domain?'
     */
    dialogTitle: T;

    /**
     * @default 'Removing your custom domain removes it from your eCards, but it will not disconnect it with your provider.'
     */
    descriptionText: T;

    /**
     * @default 'Need help disconnecting your domain?'
     */
    linkText: T;

    /**
     * @default 'Remove Domain'
     */
    buttonText: T;

    /**
     * @default 'Cancel'
     */
    cancelText: T;
  };
  soundsGoodDialog: {
    /**
     * @default 'Sounds Good!'
     */
    dialogTitle: T;

    /**
     * @default 'You can come back to search for a custom domain anytime. '
     */
    dialogSubtitle: T;
  };
};

export type DatesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  translatedDates: {
    /**
     * @default 'Today'
     */
    today: T;

    weekdayNames: [
      /**
       * @default 'Sunday'
       */
      T,
      /**
       * @default 'Monday'
       */
      T,
      /**
       * @default 'Tuesday'
       */
      T,
      /**
       * @default 'Wednesday'
       */
      T,
      /**
       * @default 'Thursday'
       */
      T,
      /**
       * @default 'Friday'
       */
      T,
      /**
       * @default 'Saturday'
       */
      T,
    ];

    monthNames: [
      /**
       * @default 'January'
       */
      T,
      /**
       * @default 'February'
       */
      T,
      /**
       * @default 'March'
       */
      T,
      /**
       * @default 'April'
       */
      T,
      /**
       * @default 'May'
       */
      T,
      /**
       * @default 'June'
       */
      T,
      /**
       * @default 'July'
       */
      T,
      /**
       * @default 'August'
       */
      T,
      /**
       * @default 'September'
       */
      T,
      /**
       * @default 'October'
       */
      T,
      /**
       * @default 'November'
       */
      T,
      /**
       * @default 'December'
       */
      T,
    ];
  };
  time: {
    minutesFromNow: {
      /**
       * @default '{{count}} minute ago'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} minute ago
       * - plural: {{count}} minutes ago
       */
      minute: T;
    };
    hoursFromNow: {
      /**
       * @default '{{count}} hour ago'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} hour ago
       * - plural: {{count}} hours ago
       */
      hour: T;
    };
  };
  quick: {
    /**
     * @default '{{0}} minute ago'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} minute ago
     * - plural: {{0}} minutes ago
     */
    DjUH3: T;

    /**
     * @default '{{0}} m ago'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} m ago
     * - plural: {{0}} m ago
     */
    '29b6L': T;

    /**
     * @default '{{0}} hour ago'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} hour ago
     * - plural: {{0}} hours ago
     */
    Bkd8v: T;

    /**
     * @default '{{0}} h ago'
     * @param {number} count - The number of occurrences.
     * - singular: {{0}} h ago
     * - plural: {{0}} h ago
     */
    OGVll: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default '{{0}} on {{1}}'
     */
    g1iYS: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default '{{0}} to {{1}}'
     */
    oaYs3: T;
  };
};

export type DiscountedRatesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'This property has discounted rates applied.'
     */
    xnheG: T;

    /**
     * @default 'View Rates'
     */
    O2u4E: T;

    /**
     * @default 'You will lose access to our exclusive pricing if you update the URL for this hotel.'
     */
    JzkUn: T;

    /**
     * @default 'We provide up to 30% discounts through our hotel partners.'
     */
    tgrBu: T;

    /**
     * @default 'Keep discount for my guests'
     */
    IrJUO: T;

    /**
     * @default 'Remove this discount'
     */
    PcyaI: T;
  };
};

export type EmailPreferencesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Joy - Email Preferences'
   */
  title: T;

  content: {
    /**
     * @default 'Update your email preferences.'
     */
    heading: T;

    /**
     * @default 'How much Joy do you want in your life? Select the email communications you’d like to receive.'
     */
    body: T;

    /**
     * @default 'Managing preferences for:'
     */
    managingPreferences: T;

    /**
     * @default 'Announcements'
     */
    prefAnnouncements: T;

    /**
     * @default 'Get the scoop on amazing new products, helpful features, and more.'
     */
    prefAnnouncementsBody: T;

    /**
     * @default 'Advice & Inspiration'
     */
    prefAdvice: T;

    /**
     * @default 'Stay organized with guides, checklists, registry progress reports, and articles.'
     */
    prefAdviceBody: T;

    /**
     * @default 'Registry Ideas'
     */
    prefRegistry: T;

    /**
     * @default 'Explore features and learn insider tips for creating your ultimate gift list.'
     */
    prefRegistryBody: T;

    /**
     * @default 'Unsubscribe'
     */
    unsubscribe: T;

    /**
     * @default 'If you no longer wish to receive marketing emails from Joy, please check this option.'
     */
    unsubscribeBody: T;

    /**
     * @default 'Save Changes'
     */
    saveChanges: T;

    /**
     * @default 'Updated Email Preferences!'
     */
    successMessage: T;
  };
  errors: {
    email: {
      /**
       * @default 'Missing Email ID'
       */
      required: T;

      /**
       * @default 'Invalid Email ID'
       */
      validate: T;
    };
  };
};

export type EmailsAndEcardsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  emailEditor: {
    /**
     * @default 'Edit Email'
     */
    header: T;

    /**
     * @default 'Email Subject'
     */
    emailSubjectLabel: T;

    /**
     * @default 'Don’t forget about the wedding rehearsal!'
     */
    emailSubjectPlaceholder: T;

    /**
     * @default 'Email Subject is required'
     */
    emailSubjectErrorMessage: T;

    /**
     * @default 'Reply-to Email'
     */
    replyToLabel: T;

    /**
     * @default 'Reply-to Email is required'
     */
    replyToErrorMessage: T;

    /**
     * @default 'Photo'
     */
    photoLabel: T;

    photoOptions: [
      /**
       * @default 'Welcome photo'
       */
      T,
      /**
       * @default 'Custom photo'
       */
      T,
    ];

    /**
     * @default 'Drag & drop a new image here or '
     */
    photoDragAndDropText: T;

    /**
     * @default 'choose an image...'
     */
    photoChooseImageText: T;

    /**
     * @default 'Headline'
     */
    headlineLabel: T;

    /**
     * @default 'You have an event display name {{headline}} that looks like a link. For security reasons we do not allow links to be posted in emails. Please change the event display name to proceed.'
     */
    headlineError: T;

    /**
     * @default 'Subheadline'
     */
    subheadlineLabel: T;

    /**
     * @default 'We’re getting married!'
     */
    subheadlinePlaceholder: T;

    /**
     * @default 'Salutation'
     */
    salutationLabel: T;

    /**
     * @default 'Hello'
     */
    salutationPlaceholder: T;

    /**
     * @default 'Include guest name(s)'
     */
    includeGuestNamesLabel: T;

    /**
     * @default 'Message'
     */
    messageLabel: T;

    /**
     * @default 'Message to our guest'
     */
    messagePlaceholder: T;

    /**
     * @default 'Link'
     */
    linkLabel: T;

    /**
     * @default 'Button Text'
     */
    buttonTextLabel: T;

    /**
     * @default 'View Card'
     */
    buttonTextPlaceholder: T;

    /**
     * @default 'Button Text is required'
     */
    buttonTextError: T;

    /**
     * @default 'Date hidden'
     */
    dateHidden: T;

    generalMessageEmailOptions: [
      {
        /**
         * @default 'Display link to your website'
         */
        hed: T;

        /**
         * @default 'Guests can visit your website for additional wedding details.'
         */
        dek: T;
      },
      {
        /**
         * @default 'Display event password'
         */
        hed: T;

        /**
         * @default 'Guests may need your event password to access some content.'
         */
        dek: T;
      },
      {
        /**
         * @default 'Display links to install Joy app'
         */
        hed: T;

        /**
         * @default 'Guests can view and share photos while staying up-to-date on the go.'
         */
        dek: T;
      },
    ];

    ecardEmailOptions: [
      {
        /**
         * @default 'Include event date'
         */
        hed: T;
      },
      {
        /**
         * @default 'Include “Add to Calendar” link'
         */
        hed: T;

        /**
         * @default 'So people can add it to their calendar '
         */
        dek: T;
      },
    ];

    /**
     * @default 'Save'
     */
    doneButtonText: T;

    /**
     * @default 'Your email has been updated.'
     */
    doneTooltipText: T;

    /**
     * @default 'Cancel'
     */
    cancelButtonText: T;

    /**
     * @default 'Password is required when you include a link to download the Joy app.'
     */
    passwordToggleTooltip: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the message of the email.'
     */
    invalidMessageIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the subject of the email.'
     */
    invalidSubjectIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the headline of the email.'
     */
    invalidHeadlineIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the subheadline of the email.'
     */
    invalidSubheadlineIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the salutation of the email.'
     */
    invalidSalutationIsEmailOrUrlError: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the button text of the email.'
     */
    invalidButtonTextIsEmailOrUrlError: T;

    /**
     * @default 'Add Photos'
     */
    addPhotos: T;

    footerText: {
      /**
       * @default 'This message was sent from withjoy.com on behalf of {{names}}.'
       */
      sentFrom: T;

      /**
       * @default 'Send replies to {{email}}.'
       */
      sendRepliesTo: T;
    };
  };
  emailEditorPhotoSaveTheDate: {
    /**
     * @default 'Edit Email'
     */
    header: T;

    /**
     * @default 'Subject'
     */
    subjectLabel: T;

    /**
     * @default 'Email Subject'
     */
    emailSubjectLabel: T;

    /**
     * @default 'Reply-to Email'
     */
    replyToLabel: T;

    /**
     * @default 'Reply-to Email is required'
     */
    replyToErrorMessage: T;

    /**
     * @default 'Photo Source'
     */
    photoSourceLabel: T;

    /**
     * @default 'Headline'
     */
    headlineLabel: T;

    /**
     * @default 'Subheadline'
     */
    subheadlineLabel: T;

    /**
     * @default 'Salutation'
     */
    salutationLabel: T;

    /**
     * @default 'Dear'
     */
    salutationPlaceholder: T;

    /**
     * @default 'Use guest name(s)'
     */
    useGuestNamesLabel: T;

    /**
     * @default 'Message'
     */
    messageLabel: T;

    /**
     * @default 'Message Body'
     */
    messagePlaceholder: T;

    /**
     * @default 'Button Text'
     */
    buttonTextLabel: T;

    /**
     * @default 'View Photo Save the Date'
     */
    buttonTextPlaceholder: T;

    /**
     * @default 'Save'
     */
    doneButtonText: T;

    /**
     * @default 'Cancel'
     */
    cancelButtonText: T;

    /**
     * @default 'Email Information'
     */
    emailInformationLabel: T;
  };
  confirmAndSend: {
    /**
     * @default 'Almost done!'
     */
    header: T;

    /**
     * @default 'Review the final details and treat yourself afterwards. You’ve earned it.'
     */
    body: T;

    /**
     * @default 'Email Personalized Cards'
     */
    emailHeader: T;

    /**
     * @default 'Each email will be addressed to the guest selected, and tracking of delivered and opened messages will be visible in your guest list.'
     */
    emailBody: T;

    /**
     * @default 'Share with a Link'
     */
    shareTitle: T;

    /**
     * @default 'Easily share a direct link to your cards with anyone.'
     */
    shareBody: T;

    /**
     * @default 'Copy Link'
     */
    shareAction: T;

    shareableDialog: {
      /**
       * @default 'About Shareable Card Links'
       */
      title: T;

      /**
       * @default 'Unlike cards sent via email, cards shared via link will not be addressed to a specific guest or tracked on your guest list.'
       */
      specific: T;

      /**
       * @default 'Card contents will be visible to anyone with the link, regardless of your event privacy settings.'
       */
      visible: T;

      /**
       * @default 'This includes your event date, location, and website password (if you have included it on the card).'
       */
      includes: T;

      /**
       * @default 'Contents of your website, including schedule visibility and RSVP, will continue to be protected by your existing privacy settings.'
       */
      privacy: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'I Understand'
       */
      copy: T;
    };
    confirmAndSendActions: {
      addGuests: {
        hed: {
          /**
           * @default 'Add recipients'
           */
          guest_0: T;

          /**
           * @default 'Add or remove recipients'
           * @param {number} count - The number of occurrences.
           * - singular: Add or remove recipients
           * - plural: Add or remove recipients
           */
          guest: T;
        };

        /**
         * @default 'Each guest will receive a unique invitation.'
         */
        dek: T;

        buttonText: {
          /**
           * @default 'Select Guests'
           */
          guest_0: T;

          /**
           * @default '{{count}} Guest Selected…'
           * @param {number} count - The number of occurrences.
           * - singular: {{count}} Guest Selected…
           * - plural: {{count}} Guests Selected…
           */
          guest: T;
        };

        /**
         * @default 'Modify Recipients'
         */
        buttonTextHover: T;
      };
      testEmail: {
        /**
         * @default 'Do an optional final check'
         */
        hed: T;

        /**
         * @default 'Never hurts to make sure everything is just right.'
         */
        dek: T;

        /**
         * @default 'Send Test Email'
         */
        buttonText: T;
      };
      send: {
        /**
         * @default 'Send and track'
         */
        hed: T;

        /**
         * @default 'Keep an eye on replies and poke the slow pokes.'
         */
        dek: T;

        /**
         * @default 'Send Now'
         */
        buttonText: T;
      };
      verifyEmail: {
        /**
         * @default 'First, verify your email address'
         */
        hed: T;

        /**
         * @default 'Only verified accounts can send cards.'
         */
        dek: T;

        /**
         * @default 'Verify Email Address'
         */
        buttonText: T;
      };
      copyLink: {
        /**
         * @default 'Shareable link'
         */
        hed: T;

        /**
         * @default 'A direct link to your eCard that is not addressed to a specific guest. Tracking not available.'
         */
        dek: T;

        /**
         * @default 'Copy Link'
         */
        buttonText: T;
      };
    };
    emailSentSuccessMessage: {
      /**
       * @default 'Your email is on the way!'
       * @param {number} count - The number of occurrences.
       * - singular: Your email is on the way!
       * - plural: Your emails are on the way!
       */
      guest: T;
    };

    /**
     * @default 'Sorry, something may have gone wrong. Please allow 1 hour for the last email status to update. If blank, please send again.'
     */
    emailSentErrorMessage: T;

    /**
     * @default 'Please, select guests first'
     */
    noGuestsSelectedErrorMessage: T;

    confirmationScreen: {
      /**
       * @default 'Your message has been sent'
       */
      hed: T;

      dek: {
        /**
         * @default 'Your message has been sent to {{count}} guest. Track which guests have received and opened your card in '
         * @param {number} count - The number of occurrences.
         * - singular: Your message has been sent to {{count}} guest. Track which guests have received and opened your card in
         * - plural: Your message has been sent to {{count}} guests. Track which guests have received and opened your card in
         */
        dek: T;
      };

      /**
       * @default 'Guest List'
       */
      linkText: T;

      /**
       * @default 'View Your Guest List'
       */
      buttonText: T;

      /**
       * @default 'Add Paper Cards'
       */
      printTitle: T;

      /**
       * @default 'Some guests prefer a physical card. Create a matching (or different) paper card for them!'
       */
      printDesc: T;

      /**
       * @default 'Create Paper Card'
       */
      printAction: T;
    };
    confirmationScreenThankYou: {
      /**
       * @default 'Your thank you note has been sent'
       */
      hed: T;

      /**
       * @default 'An email has been sent to {{ name }}.'
       */
      dek_name: T;

      /**
       * @default 'An email has been sent to {{ number }} People.'
       */
      dek_number: T;

      /**
       * @default 'Thank Another Guest'
       */
      buttonText: T;
    };
    sendTestEmailDialog: {
      /**
       * @default 'Send Test Email'
       */
      header: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Email'
       */
      testEmailLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default 'your@email.com'
       */
      testEmailPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Email is required'
       */
      testEmailErrorMessage: T;

      /**
       * @default 'Send'
       */
      sendButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
  };
  ecardEditor: {
    ecardEditPanel: {
      /**
       * @default 'Edit Card'
       */
      header: T;

      /**
       * @default 'Save'
       */
      doneButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;

      /**
       * @default 'Your card has been updated.'
       */
      doneTooltipText: T;
    };
    ecardEditorSwitch: {
      /**
       * @default 'Content'
       */
      content: T;

      /**
       * @default 'Design'
       */
      design: T;
    };
    ecardDesignEditor: {
      /**
       * @default 'Upload Your Own Card Design'
       */
      uploadOwn: T;

      /**
       * @default 'If you have a card designed or if you want to design your own card, be sure it includes names, date, and location and '
       */
      uploadDesc: T;

      /**
       * @default 'check out our design guidelines.'
       */
      uploadDescHighlight: T;

      /**
       * @default 'Drag & drop your image here or '
       */
      dragAndDrop: T;

      /**
       * @default 'choose an image...'
       */
      chooseImage: T;

      /**
       * @default 'Your Card Design'
       */
      yourCard: T;

      /**
       * @default 'Be sure your image includes names, date, and location, and that you have rights to use this image.'
       */
      yourCardDesc: T;

      /**
       * @default 'Check out our design guidelines.'
       */
      yourCardDescHighlight: T;
    };
    ecardContentEditor: {
      /**
       * @default 'Title'
       */
      titleLabel: T;

      /**
       * @default 'Subtitle'
       */
      subtitleLabel: T;

      /**
       * @default 'Date Format'
       */
      dateFormatLabel: T;

      /**
       * @default 'Date'
       */
      dateLabel: T;

      /**
       * @default '1 May, 2020'
       */
      datePlaceholder: T;

      /**
       * @default 'Edit Date'
       */
      editDate: T;

      /**
       * @default 'Date hidden'
       */
      dateHidden: T;

      /**
       * @default 'Location hidden'
       */
      locationHidden: T;

      /**
       * @default 'Location'
       */
      locationLabel: T;

      /**
       * @default 'Los Angeles, CA, USA'
       */
      locationPlaceholder: T;

      /**
       * @default 'Edit Location'
       */
      editLocation: T;

      /**
       * @default 'Message'
       */
      messageLabel: T;

      linkOptions: [
        {
          /**
           * @default 'Display link to your website'
           */
          hed: T;

          /**
           * @default 'Guests can visit your website for additional wedding details.'
           */
          dek: T;
        },
        {
          /**
           * @default 'Image links to event website'
           */
          hed: T;

          /**
           * @default 'This link personalizes your website, schedule, and RSVP for each guest.'
           */
          dek: T;
        },
        {
          /**
           * @default 'Links Unlock Guest-Only Content'
           */
          hed: T;

          /**
           * @default 'Website pages that require a password will be auto-unlocked.'
           */
          dek: T;
        },
      ];

      /**
       * @default 'Additional Information'
       */
      additionalInformation: T;

      /**
       * @default 'Choose up to two additional links to display'
       */
      chooseLinkTitle: T;

      /**
       * @default 'Additional Message'
       */
      additionalMessageLabel: T;

      /**
       * @default 'We’re doing it! We’re getting married. And we’d be delighted if you could attend. Our website has all the important details—most importantly the RSVP.'
       */
      additionalMessagePlaceholder: T;

      /**
       * @default 'Website Options'
       */
      websiteOptions: T;

      /**
       * @default 'Your URL'
       */
      yourURL: T;

      /**
       * @default 'Change URL'
       */
      editURL: T;

      /**
       * @default ' may be available!'
       */
      URLAvailable: T;

      /**
       * @default 'You’re Using a Custom Design'
       */
      usingCustomDesign: T;

      /**
       * @default 'All your event details are included in your image.'
       */
      usingCustomDesignDesc1: T;

      /**
       * @default 'You can revert back to using themes.'
       */
      usingCustomDesignDesc2: T;

      /**
       * @default 'Revert to Joy Theme'
       */
      revertToJoyTheme: T;
    };
  };
  ecardEditorPhotoSaveTheDate: {
    ecardEditPanel: {
      /**
       * @default 'Edit Card'
       */
      header: T;

      /**
       * @default 'Save'
       */
      doneButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
    ecardEditorSwitch: {
      /**
       * @default 'Content'
       */
      content: T;

      /**
       * @default 'Design'
       */
      design: T;
    };
    ecardDesignEditor: {
      /**
       * @default 'Photo Source'
       */
      photoSourceLabel: T;

      /**
       * @default 'Adjust Photo Position'
       */
      adjustPhotoLabel: T;

      /**
       * @default 'Templates'
       */
      templatesLabel: T;

      /**
       * @default 'Reset Position'
       */
      resetPosition: T;

      /**
       * @default 'Edit Design'
       */
      editDesignButton: T;

      /**
       * @default 'Edit Content'
       */
      editContentButton: T;
    };
    ecardPhotoAdjustmentEditor: {
      /**
       * @default 'Zoom & drag photo to adjust position'
       */
      title: T;
    };
    ecardContentEditor: {
      /**
       * @default 'Name Format'
       */
      nameFormatLabel: T;

      /**
       * @default 'Edit Names'
       */
      editNameFormatLabel: T;

      /**
       * @default 'Date Format'
       */
      dateFormatLabel: T;

      /**
       * @default 'Edit Date'
       */
      editDateFormatLabel: T;

      /**
       * @default 'Location Format'
       */
      locationFormatLabel: T;

      /**
       * @default 'Edit Location'
       */
      editLocationFormatLabel: T;

      /**
       * @default 'Note'
       */
      inviteLabel: T;

      /**
       * @default 'Invitation to Follow'
       */
      invitePlaceholder: T;

      /**
       * @default 'Additional Info'
       */
      additionalInformationTitle: T;

      /**
       * @default 'Additional links to display'
       */
      additionalLinksLabel: T;

      /**
       * @default 'Optional Message'
       */
      optionalMessageLabel: T;

      /**
       * @default 'Website Options'
       */
      websiteOptionsTitle: T;

      displayEventLink: {
        /**
         * @default 'Display link to your website'
         */
        title: T;

        /**
         * @default 'Guests can visit your website for additional wedding details.'
         */
        subtitle: T;
      };
      unlockGuestOnlyContent: {
        /**
         * @default 'Unlock Guest-Only Content'
         */
        title: T;

        /**
         * @default 'Website pages that require a password will be auto-unlocked with this link.'
         */
        subtitle: T;
      };

      /**
       * @default 'Your URL'
       */
      yourURLLabel: T;

      /**
       * @default 'Edit URL'
       */
      editYourURLLabel: T;

      /**
       * @default 'Guest Help'
       */
      guestHelpLink: T;

      /**
       * @default 'About'
       */
      aboutLink: T;

      /**
       * @default 'Made with'
       */
      madeWithText: T;

      /**
       * @default 'Password:'
       */
      passwordLabel: T;
    };
    premiumUpsell: {
      banner: {
        /**
         * @default 'Switch to Premium Card Designer'
         */
        title: T;

        /**
         * @default 'Try premium editor to change fonts, move text around, upload your own image, and more.'
         */
        description: T;

        /**
         * @default 'Try Premium'
         */
        cta: T;
      };
      dialog: {
        /**
         * @default 'Try Premium Card and Customize Your Way!'
         */
        title: T;

        /**
         * @default 'Edit all your details inline on the card.'
         */
        valuePropEdit: T;

        /**
         * @default 'Customize your card exactly how you like it, with hundreds of font styles, photo, and layout options.'
         */
        valuePropCustomize: T;

        /**
         * @default 'Choose silhouette of your card and wallpaper color.'
         */
        valuePropSilhoutte: T;

        /**
         * @default 'Try Premium'
         */
        cta: T;

        /**
         * @default 'Back to Free'
         */
        cancel: T;
      };
    };
  };
  ecardDefaults: {
    /**
     * @default '✨ Link copied. Share away! ✨'
     */
    copiedLinkTooltip: T;

    changethedate: {
      ecardContent: {
        /**
         * @default 'Change the Date'
         */
        title: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        subtitle: T;

        /**
         * @default 'We've had to change the date for our big day but we can't wait to celebrate with you soon. Please check our wedding website for updates!'
         */
        message: T;

        /**
         * @default ' '
         */
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'We're changing the date!'
         */
        subject: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        headline: T;

        /**
         * @default 'We're changing the date!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
         * @default 'We've had to change the date for our big day but we can't wait to celebrate with you soon. Please check our wedding website for updates!'
         */
        message: T;

        /**
         * @default 'View Card'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Change the Dates'
         */
        title: T;
      };
    };
    savethedate: {
      ecardContent: {
        /**
         * @default 'Save the Date'
         */
        title: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        subtitle: T;

        /**
         * @default 'Invitation to follow. Please visit our website for more details and photos.'
         */
        message: T;

        /**
         * @default ' '
         */
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'Save the Date!'
         */
        subject: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        headline: T;

        /**
         * @default 'We're getting married!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
         * @default 'We've set a date for our big day and we can't wait to share it with you.'
         */
        message: T;

        /**
         * @default 'Open Save The Date'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Save the Dates'
         */
        title: T;
      };
    };
    invitation: {
      ecardContent: {
        /**
         * @default '{{ eventDisplayName }}'
         */
        title: T;

        /**
         * @default ' '
         */
        subtitle: T;

        /**
         * @default 'We are so excited and can't wait to see you.'
         */
        message: T;

        /**
     * @default 'We’re doing it! We’re getting married. And we’d be delighted if you could attend.
 Our website has all the important details—most importantly the RSVP! We want to know things like whether or
 not you’re bringing a +1, your dietary preferences, and if you’re bringing your dancing shoes.

 We also provide recommendations for our favorite local activities, where to stay, and what to wear.
 We’d love if you’d download the app and start sharing photos too! It’ll be a collection of memorable moments,
before, during, and after our special day'
*/
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'We're getting married!'
         */
        subject: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        headline: T;

        /**
         * @default 'We're getting married!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
     * @default 'We’re making it official, and you’re cordially invited! We have a wedding
 website and app with all the details—from travel and lodging to the day-of schedule and what to wear. Take
 a look to RSVP and find more information. We hope you can join us! '
*/
        message: T;

        /**
         * @default 'View Invitation'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Invitations'
         */
        title: T;
      };
    };
    custom: {
      ecardContent: {
        /**
         * @default 'Party Time'
         */
        title: T;

        /**
         * @default 'Will you join us?'
         */
        subtitle: T;

        /**
         * @default 'We are so excited and can't wait to see you.'
         */
        message: T;

        /**
         * @default ' '
         */
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'Party Time!'
         */
        subject: T;

        /**
         * @default 'Party Time!'
         */
        headline: T;

        /**
         * @default 'We're having a party!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
         * @default 'We're having a party and we can't wait to see you.'
         */
        message: T;

        /**
         * @default 'Open Card'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Custom eCards'
         */
        title: T;
      };
    };
    savethedatephoto: {
      ecardContent: {
        /**
         * @default 'Save the Date'
         */
        title: T;

        /**
         * @default 'Invitation to follow'
         */
        subtitle: T;

        /**
         * @default 'Please visit our website for more details and photos.'
         */
        message: T;

        /**
         * @default ' '
         */
        additionalMessage: T;
      };
      emailContent: {
        /**
         * @default 'Save the Date!'
         */
        subject: T;

        /**
         * @default '{{ eventDisplayName }}'
         */
        headline: T;

        /**
         * @default 'We're getting married!'
         */
        subheadline: T;

        /**
         * @default 'Hello'
         */
        salutation: T;

        /**
         * @default 'We've set a date for our big day and we can't wait to share it with you.'
         */
        message: T;

        /**
         * @default 'Open Save The Date'
         */
        buttonText: T;
      };
      ecardLanding: {
        /**
         * @default 'Send Save the Dates'
         */
        title: T;
      };
    };
  };
  ecardNavBar: {
    /**
     * @default 'Edit Card'
     */
    design: T;

    /**
     * @default 'Edit Email'
     */
    email: T;

    /**
     * @default 'Confirm & Send'
     */
    confirm: T;
  };
  unsavedChangesDialog: {
    /**
     * @default 'Cancel'
     */
    cancelButtonText: T;

    /**
     * @default 'Discard'
     */
    discardButtonText: T;

    /**
     * @default 'Unsaved Changes'
     */
    unsavedChangesWarningHed: T;

    /**
     * @default 'Are you sure you want to stop editing your {{ warningMessageContent }}? Doing so will discard all unsaved changes.'
     */
    unsavedChangesWarningDek: T;
  };
  genericEcard: {
    /**
     * @default 'Edit eCard'
     */
    editEcard: T;

    /**
     * @default 'To:'
     */
    toPerson: T;

    /**
     * @default 'Not'
     */
    notPerson: T;

    /**
     * @default 'Not you?'
     */
    notYou: T;

    /**
     * @default '[First Name(s)]'
     */
    toPersonNames: T;

    /**
     * @default 'Next'
     */
    next: T;
  };
  genericEmail: {
    /**
     * @default 'Event Password:'
     */
    eventPassword: T;

    /**
     * @default 'View Our Website'
     */
    viewOurWebsite: T;

    /**
     * @default 'Download Our App'
     */
    downloadOurApp: T;

    /**
     * @default 'Get the Joy app to view and share photos and stay up-to-date with details on the go.'
     */
    appDescription: T;
  };
  ecardLanding: {
    ecardLandingLeftPane: {
      /**
       * @default 'Make the big announcement in a big way'
       */
      titleLanding: T;

      /**
       * @default 'Send Beautiful Digital Cards'
       */
      title: T;

      /**
       * @default 'Match your wedding website or pick from beautiful designs for every taste.'
       */
      desc: T;

      /**
       * @default 'Create Digital Card'
       */
      customize: T;

      /**
       * @default 'Track Your eCard Delivery'
       */
      trackTitle: T;

      /**
       * @default 'Already sent? Track delivery in guest list'
       */
      trackLandingTitle: T;

      /**
       * @default 'Track which guests have received and opened your Digital Card in the “Email Status” column of your guest list.'
       */
      trackDesc: T;

      /**
       * @default 'Track in Guest List'
       */
      trackButtonText: T;

      /**
       * @default 'Matching Stationery is Available'
       */
      printsTitle: T;

      /**
       * @default 'Matching stationery is available for your current art card design'
       */
      printsLandingTitle: T;

      /**
       * @default 'Your website theme has matching stationery. Order {{ ecardTypeDisplayName }} prints that match your wedding website.'
       */
      printsDesc: T;

      /**
       * @default 'Order Save the Date prints that match your wedding website.'
       */
      printsLandingDesc: T;

      /**
       * @default 'US and international shipping available.'
       */
      paperlustDesc: T;

      /**
       * @default 'Shipping only available in the United States.'
       */
      paperCultureDesc: T;

      /**
       * @default 'View and Order Prints'
       */
      printsButtonText: T;

      /**
       * @default 'Our partner Paper Culture can only send cards to a US address. They do, however, ship to all United States addresses, including military and APO/FPO addresses, and US Territories.'
       */
      printsPaperCultureTooltipText: T;

      /**
       * @default 'Paperlust has express worldwide shipping to all countries including the USA, Canada, New Zealand, the UK and Europe. Please note that you are responsible for any local duties, tariffs, taxes or fees payable on delivery.'
       */
      printsPaperlustTooltipText: T;

      /**
       * @default 'Explore Our Print Partners'
       */
      exploreTitle: T;

      /**
       * @default 'Explore our print partners'
       */
      exploreLandingTitle: T;

      /**
       * @default 'International Shipping'
       */
      internationalShipping: T;

      /**
       * @default 'U.S.-Only Shipping'
       */
      USOnlyShipping: T;

      /**
       * @default 'Please use the desktop browser. Don’t worry, your guests will be able to see and experience the eCard on their phones.'
       */
      mobileAlertTextSubTitle: T;

      /**
       * @default 'Photo Digital Cards'
       */
      landingPhotoTitle: T;

      /**
       * @default 'Add your own photos and choose from ten stunning custom-designed Photo Digital Cards to announce your big day.'
       */
      landingPhotoSubTitle: T;

      /**
       * @default 'Customize Photo Digital Card'
       */
      landingPhotoButtonTitle: T;

      /**
       * @default 'Art Digital Cards'
       */
      landingArtTitle: T;

      /**
       * @default 'Select from a variety of beautiful custom-designed Art Digital Cards to make your big announcement stand out.'
       */
      landingArtSubTitle: T;

      /**
       * @default 'Customize Art Digital Card'
       */
      landingArtButtonTitle: T;

      /**
       * @default 'Add Paper Cards'
       */
      landingPrintTitle: T;

      /**
       * @default 'Some guests prefer a physical card. Create a matching (or different) paper card for them.'
       */
      landingPrintSubTitle: T;

      /**
       * @default 'Customize Paper Card'
       */
      landingPrintButtonTitle: T;

      /**
       * @default 'New'
       */
      chipNew: T;
    };
    ecardLandingRightPane: {
      /**
       * @default 'eCard'
       */
      ecard: T;

      /**
       * @default 'Print'
       */
      print: T;

      /**
       * @default 'Explore Prints'
       */
      explorePrints: T;
    };
  };
  ecardGuest: {
    /**
     * @default 'A special message from {{event}}'
     */
    title: T;

    error: {
      /**
       * @default 'Hmm… we can’t find that.'
       */
      title: T;

      /**
       * @default 'This eCard may have been changed or is temporarily unavailable.'
       */
      subtitle: T;

      /**
       * @default 'Find a Couple'
       */
      linkText: T;
    };
    toolTip: {
      /**
       * @default 'Guests are addressed by first name.'
       */
      firstPart: T;

      /**
       * @default 'If the recipient is in a party, all first names in the party will be included. e.g. “Sam, Sue, & Fred“, or “Suzy & Guest“'
       */
      secondPart: T;
    };
  };
  ecardFooter: {
    /**
     * @default 'Plan your forever, better.'
     */
    label: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Privacy Policy'
     */
    privacyPolicy: T;

    /**
     * @default 'Terms and Conditions'
     */
    termsAndConditions: T;
  };
  footerText: {
    /**
     * @default 'This message was sent from withjoy.com on behalf of'
     */
    messageSentFrom: T;

    /**
     * @default 'Send replies to'
     */
    sendRepliesTo: T;
  };
  quick: {
    /**
     * @default '✨ Link copied. Share away! ✨'
     */
    oV6ax: T;

    /**
     * @default '[First Name(s)]'
     */
    l0QDU: T;

    /**
     * @default 'Guests are addressed by first name.'
     */
    '6X8VI': T;

    /**
     * @default 'If the recipient is in a party, all first names in the party will be included. e.g. "Sam, Sue, & Fred", or "Suzy & Guest"'
     */
    i1skY: T;

    /**
     * @default 'Add to Calendar'
     */
    sLe7P: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Browse Registry'
     */
    DSLYE: T;

    /**
     * @default 'View Schedule'
     */
    A4Wso: T;

    /**
     * @default 'View Travel Details'
     */
    '9dd3R': T;

    /**
     * @default 'View Website'
     */
    QNwvH: T;

    /**
     * @default 'Enter Mailing Address'
     */
    LXQLq: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Social'
     */
    XYZoV: T;

    /**
     * @default 'Premium Digital Available'
     */
    aEZRP: T;

    /**
     * @default 'Your Website Theme'
     */
    nVYHd: T;

    /**
     * @default 'Use My Color'
     */
    gZ5aV: T;

    /**
     * @default 'Upload Custom Photo'
     */
    uQzsH: T;

    /**
     * @default 'Send Beautiful Digital Cards'
     */
    qmAlO: T;

    /**
     * @default 'Match your wedding website or pick from beautiful designs for every taste.'
     */
    capG8: T;

    /**
     * @default 'Create Digital Card'
     */
    kAQHO: T;

    /**
     * @default 'Add Paper Cards'
     */
    W8G94: T;

    /**
     * @default 'Some guests prefer a physical card. Create a matching (or different) paper card for them.'
     */
    bOOoY: T;

    /**
     * @default 'Customize Paper Card'
     */
    bV1Kq: T;

    /**
     * @default 'Already sent? Track delivery in message Tracking'
     */
    lhkKk: T;

    /**
     * @default 'Track which guests have received and opened your Digital Card in the message tracker.'
     */
    OUXlG: T;

    /**
     * @default 'View Message Tracker'
     */
    '2TfeF': T;

    /**
     * @default 'Your message needs more detail so it ends up in your guests' inbox. Please include at least {{0}} characters. Spam filters flag both short and generic content.'
     */
    RIWZR: T;

    /**
     * @default 'Please enter a valid reply-to email address.'
     */
    '7Pto5': T;

    /**
     * @default 'Your email has been updated.'
     */
    I1h8O: T;

    /**
     * @default 'Email Subject is required'
     */
    hMTsq: T;

    /**
     * @default 'Reply-to Email is required'
     */
    TvNTr: T;

    /**
     * @default 'Button Text is required'
     */
    EhDuc: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the subject of the email.'
     */
    '4w8vI': T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the headline of the email.'
     */
    sZEGU: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the salutation of the email.'
     */
    oqseB: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the subheadline of the email.'
     */
    OrPEX: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the message of the email.'
     */
    NUkYd: T;

    /**
     * @default 'Sorry! To keep our emails secure, email addresses and URLs are not allowed in the button text of the email.'
     */
    jDfXS: T;
  };
};

export type ErrorsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  errorSplash: {
    /**
     * @default 'Hmm… we're having trouble with that.'
     */
    title: T;

    /**
     * @default 'This page can’t be loaded at the moment. Please try again later.'
     */
    subtitle: T;
  };
  contributionError: {
    /**
     * @default 'Hmm… we can’t find that.'
     */
    title: T;

    /**
     * @default 'The item may have been changed or removed from the couple’s registry.'
     */
    subtitle: T;

    /**
     * @default 'Go to Registry'
     */
    linkText: T;
  };
  registryHidden: {
    /**
     * @default 'Hmm… we can’t find that.'
     */
    title: T;

    /**
     * @default 'It seems that the couple may have hidden their registry.'
     */
    subtitle: T;
  };
  componentError: {
    /**
     * @default 'An error occurred. Please refresh to try again.'
     */
    message: T;
  };
};

export type EventCountdownTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default '{{dateTime}} ago'
   */
  eventDateWithAgoText: T;
};

export type EventCountdownCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Event Countdown'
     */
    hlzOJ: T;

    /**
     * @default 'Days, Hours, Minutes, Seconds'
     */
    c3BPk: T;

    /**
     * @default 'Days, Hours, Minutes'
     */
    '9tVTc': T;

    /**
     * @default 'Days, Hours'
     */
    '24of2': T;

    /**
     * @default 'Days Only'
     */
    Nrf42: T;

    /**
     * @default 'An error occurred while updating the event countdown. Please try again.'
     */
    I9STG: T;

    /**
     * @default 'Event countdown updated successfully.'
     */
    RonAa: T;

    /**
     * @default 'An error occurred while adding the event countdown. Please try again.'
     */
    ZEC0h: T;

    /**
     * @default 'Event countdown added successfully.'
     */
    cshOJ: T;

    /**
     * @default 'Main Event Countdown'
     */
    yRO2D: T;

    /**
     * @default 'Edit Date in Settings'
     */
    sS7Be: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Countdown Format'
     */
    S4sdu: T;

    /**
     * @default 'Select format...'
     */
    rWxc7: T;

    /**
     * @default 'Edit Date in Settings →'
     */
    QlsLa: T;
  };
};

export type EventDetailsCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'MM/DD/YYYY'
     */
    oiQg8: T;

    /**
     * @default 'Month Day, Year'
     */
    XhfsH: T;

    /**
     * @default 'Weekday, Month Day, Year'
     */
    '5DNmC': T;

    /**
     * @default 'Date Format'
     */
    vaDAI: T;

    /**
     * @default 'Select format...'
     */
    rWxc7: T;

    /**
     * @default 'Event Details'
     */
    YixyG: T;

    /**
     * @default 'Success! Event details have been saved.'
     */
    H3s5U: T;

    /**
     * @default 'Failed to save event details. Please try again.'
     */
    IO87J: T;

    /**
     * @default 'Venue name, city, state or country'
     */
    pR5yJ: T;

    /**
     * @default 'City, state or country'
     */
    vIlXM: T;

    /**
     * @default 'City only'
     */
    v0x6w: T;

    /**
     * @default 'Edit Date in Settings'
     */
    sS7Be: T;

    /**
     * @default 'Edit Location in Settings'
     */
    nsiU1: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Location Format'
     */
    qMEAc: T;

    /**
     * @default 'Edit Date in Settings →'
     */
    QlsLa: T;

    /**
     * @default 'Edit Location in Settings →'
     */
    xUAuc: T;
  };
};

export type EventFormDisplayTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Error saving form. Please try again later.'
     */
    tTVh2: T;

    /**
     * @default 'Error saving registration. Please try again later.'
     */
    Cyvww: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Submit'
     */
    '6TIIW': T;

    /**
     * @default 'Attendance'
     */
    DE1nO: T;

    /**
     * @default 'Will you be attending the event?'
     */
    elIlh: T;

    /**
     * @default 'Yes'
     */
    '1GaAA': T;

    /**
     * @default 'No'
     */
    TrAAA: T;

    /**
     * @default 'Welcome Back'
     */
    fNWGr: T;

    /**
     * @default 'You've already responded to this form'
     */
    '4O2MM': T;

    /**
     * @default 'Hi, {{0}}, would you like to edit your response?'
     */
    '0WtkI': T;

    /**
     * @default 'Edit Response'
     */
    zt3SF: T;

    /**
     * @default 'Not You?'
     */
    D1zbA: T;

    /**
     * @default 'Welcome'
     */
    oKwVg: T;

    /**
     * @default 'Let's make sure we have the right person'
     */
    AdlLJ: T;

    /**
     * @default 'Would you like to respond to this form as {{0}}?'
     */
    b388D: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Invalid email'
     */
    FrMSe: T;

    /**
     * @default 'Registration'
     */
    zeLZS: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'No longer Accepting Responses'
     */
    '4gR7z': T;

    /**
     * @default '{{0}} is closed. Please contact the host if you have any questions.'
     */
    '8JK59': T;

    /**
     * @default 'Review & Submit'
     */
    epYCv: T;

    /**
     * @default 'Please review your information before submitting.'
     */
    SpAx9: T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Not Attending'
     */
    RXHya: T;

    /**
     * @default 'Contact Information'
     */
    ghluB: T;

    /**
     * @default 'Guest Name'
     */
    BwmqA: T;
  };
};

export type EventMenuTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Edit Event'
   */
  editEvent: T;

  /**
   * @default 'MENU'
   */
  menu: T;
};

export type EventPhotoPickerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;
  };
};

export type EventRedirectTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Pick Your Event'
   */
  pickYourEvent: T;

  /**
   * @default 'Or create a new one'
   */
  orCreateNewOne: T;
};

export type EventServiceCenterTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Guest List Actions'
     */
    '3hW78': T;

    /**
     * @default 'Update Contacts in Firebase'
     */
    auzC0: T;

    /**
     * @default 'There was an error running the script: Update Contacts in Firebase'
     */
    bs58k: T;

    /**
     * @default 'Sync Recipients List from Firebase'
     */
    GBQ4Y: T;

    /**
     * @default 'There was an error running the script: Sync Recipients List from Firebase'
     */
    lI7oZ: T;

    /**
     * @default 'Update Contacts in Firebase script completed successfully'
     */
    tYNm1: T;

    /**
     * @default 'Sync Recipients List from Firebase script completed successfully'
     */
    '9jDxa': T;

    /**
     * @default 'Missing Event ID'
     */
    BAUPb: T;

    /**
     * @default 'Missing Auth Token'
     */
    dOtxo: T;

    /**
     * @default 'Missing User JWT'
     */
    '4fVKJ': T;

    /**
     * @default 'Missing Script Params for script: {{0}}'
     */
    '7hs2L': T;

    /**
     * @default 'Transfer contacts to guestlist'
     */
    VZA91: T;

    /**
     * @default 'Transfer contacts to guestlist script completed successfully'
     */
    E3R13: T;

    /**
     * @default 'Resync recipients from guestlist'
     */
    yYWN5: T;

    /**
     * @default 'Resync recipients from guestlist script completed successfully'
     */
    BixrF: T;

    /**
     * @default 'Rebuild contacts from guestlist'
     */
    MfMOT: T;

    /**
     * @default 'Last Resort: this deletes contacts and rebuilds it from guest list'
     */
    adpJd: T;

    /**
     * @default 'Rebuild contacts from guestlist script completed successfully'
     */
    X35NN: T;

    /**
     * @default 'Another sync is already in progress for this event. Please wait 2 minutes.'
     */
    pvmt8: T;

    /**
     * @default 'There was an error running the script: {{0}}'
     */
    '1O5ac': T;
  };
};

export type EventSiteTranslations<T extends LeafNodeValue = TranslateFunction> = {
  eventRedirect: {
    eventNotFoundError: {
      /**
       * @default 'Hmm... we're having trouble with that.'
       */
      hed: T;

      /**
       * @default 'This event can no longer be found. We wish we knew more.'
       */
      dek: T;
    };
    graphqlError: {
      /**
       * @default 'Hmm... we're having trouble with that.'
       */
      hed: T;

      /**
       * @default 'This page can't be loaded at the moment. Please try again later.'
       */
      dek: T;
    };
  };
};

export type EventSiteAppsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Get the app'
   */
  title: T;

  /**
   * @default 'Download Joy and join our app using our event handle {{website}}. View and share photos and stay up-to-date with details on the go.'
   */
  message: T;
};

export type EventWorkspaceTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'Design and customize your event website'
     */
    MkOnb: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Manage your wedding gift registry and cash funds with ease'
     */
    XfYWE: T;

    /**
     * @default 'Guest Stays'
     */
    iLmdi: T;

    /**
     * @default 'Simplify guest accommodations while saving them money'
     */
    '3PJUq': T;

    /**
     * @default 'Contacts'
     */
    BNWOJ: T;

    /**
     * @default 'Collect and manage contacts for your event'
     */
    FOezj: T;

    /**
     * @default 'Guest List'
     */
    sYWqA: T;

    /**
     * @default 'Manage the guests attending your event, including RSVPs, dietary restrictions, and more'
     */
    WDfhd: T;

    /**
     * @default 'Messaging'
     */
    q8dH3: T;

    /**
     * @default 'Communicate with your guests through messaging'
     */
    MVgJc: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Event schedule to define times and locations for various activities during the event'
     */
    LOcW4: T;

    /**
     * @default 'Save the Date'
     */
    ymYpv: T;

    /**
     * @default 'Create and send a Save the Date for your wedding'
     */
    ShQXW: T;

    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'Manage your event RSVPs, including guest responses and dietary restrictions'
     */
    BGJ4A: T;

    /**
     * @default 'Invitation'
     */
    LbEQO: T;

    /**
     * @default 'Design and send invitations for your wedding'
     */
    pXFX1: T;

    /**
     * @default 'Day of'
     */
    fwl0q: T;

    /**
     * @default 'Browse signs, menus, and other stationery for your wedding'
     */
    FEsFb: T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default 'Manage your event photos and albums'
     */
    AlKkR: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'Event settings to manage your event details, including title, date, location, and more'
     */
    qwg1U: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Registration'
     */
    zeLZS: T;

    /**
     * @default 'Concierge'
     */
    NvCRC: T;

    /**
     * @default 'Event Site'
     */
    Jbbbn: T;

    /**
     * @default 'Hotels'
     */
    lVpi2: T;

    /**
     * @default 'Make Planning Simple with Joy Concierge'
     */
    '6Xk6D': T;

    /**
     * @default 'Joy offers concierge services for venues, marketing materials, event swag, and more. Use the link below to submit a concierge request and our team will be in touch within 24 business hours.'
     */
    '9oNFD': T;

    /**
     * @default 'Create Request'
     */
    DRlvk: T;

    /**
     * @default 'Speakers'
     */
    IloSD: T;

    /**
     * @default 'Manage the your event speakers'
     */
    Vacbs: T;
  };
};

export type ExampleConfigUsageTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Event type config - {{eventType}}'
   */
  eventTypeInfo: T;

  /**
   * @default 'Example switching content based on event type'
   */
  exampleContent: T;

  /**
   * @default 'Example passing args to API calls based on event type'
   */
  exampleAPIArgs: T;

  eventTypeStrings: {
    general: {
      /**
       * @default 'This is from the general event type ✅'
       */
      exampleStringFromEventType: T;
    };
    wedding: {
      /**
       * @default 'This is from the wedding event type 💒'
       */
      exampleStringFromEventType: T;
    };
    babyRegistry: {
      /**
       * @default 'This is from the babyRegistry event type 👶'
       */
      exampleStringFromEventType: T;
    };
  };
};

export type FaqCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'confirm'
     */
    wNSec: T;

    /**
     * @default 'cancel'
     */
    q0r5A: T;

    /**
     * @default 'Confirm'
     */
    WeV82: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Title and subtitle are required'
     */
    kfPFE: T;

    /**
     * @default 'Failed to save FAQ'
     */
    NhBGT: T;

    /**
     * @default 'FAQs'
     */
    ri1KA: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Exit without saving?'
     */
    pUbF1: T;

    /**
     * @default 'Are you sure you want to exit without saving? All unsaved changes will be lost.'
     */
    Y7YP9: T;

    /**
     * @default 'Exit'
     */
    '497KA': T;

    /**
     * @default 'Question'
     */
    ubqly: T;

    /**
     * @default 'Enter your question'
     */
    p8Px6: T;

    /**
     * @default 'Answer'
     */
    gMK6j: T;

    /**
     * @default 'Enter your answer'
     */
    XDJz8: T;

    /**
     * @default 'Untitled'
     */
    rHPYf: T;

    /**
     * @default 'No answer'
     */
    RsBSM: T;

    /**
     * @default '{{0}} item'
     */
    '3w8zE': T;

    /**
     * @default '{{0}} items'
     */
    MtSBl: T;

    /**
     * @default 'Your Reply'
     */
    VrHkQ: T;

    /**
     * @default 'Type your response here'
     */
    SLUdS: T;

    /**
     * @default 'Your Q&A'
     */
    juESg: T;

    /**
     * @default 'Remove All'
     */
    xXZwg: T;

    /**
     * @default 'Add New'
     */
    jyHtQ: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'What's Guest Q&A'
     */
    ALdaA: T;

    /**
     * @default 'Collect and answer frequently asked questions in one place.'
     */
    feDBD: T;
  };
};

export type FocusPointTranslations<T extends LeafNodeValue = TranslateFunction> = {
  editPhoto: {
    /**
     * @default 'Edit Photo'
     */
    actionEditText: T;
  };
  focusPointDialog: {
    /**
     * @default 'Select a Focus Point'
     */
    title: T;

    /**
     * @default 'Your focus point ensures your image displays well on all devices.'
     */
    subtitle: T;

    /**
     * @default 'Change Photo...'
     */
    changePhotoText: T;

    /**
     * @default 'Save Focus Point'
     */
    applyButtonText: T;
  };
};

export type FormTranslations<T extends LeafNodeValue = TranslateFunction> = {
  admin: {
    /**
     * @default 'Create Form'
     */
    createForm: T;

    /**
     * @default 'Save Form'
     */
    saveForm: T;

    /**
     * @default 'Edit Form'
     */
    editForm: T;

    /**
     * @default 'Preview Form'
     */
    previewForm: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Answers'
     */
    answers: T;

    /**
     * @default 'No answers yet'
     */
    noAnswers: T;

    /**
     * @default 'Forms'
     */
    title: T;

    /**
     * @default 'Select a Template'
     */
    selectTemplate: T;

    /**
     * @default 'Form Name'
     */
    formName: T;

    /**
     * @default 'Form Description'
     */
    formDescription: T;

    /**
     * @default 'Warning'
     */
    warning: T;

    /**
     * @default 'Unused steps detected'
     */
    unusedSteps: T;

    /**
     * @default 'Invalid next references'
     */
    invalidNextReferences: T;

    /**
     * @default 'Form created successfully'
     */
    formCreated: T;

    /**
     * @default 'Form updated successfully'
     */
    formUpdated: T;

    /**
     * @default 'An error occurred'
     */
    error: T;

    /**
     * @default 'Form Answers'
     */
    formAnswers: T;

    /**
     * @default 'Total Answers:'
     */
    totalAnswers: T;

    /**
     * @default 'Total Responses:'
     */
    totalResponses: T;

    /**
     * @default 'Unique Respondents:'
     */
    uniqueRespondents: T;

    /**
     * @default 'Question:'
     */
    question: T;

    /**
     * @default 'Questions:'
     */
    questions: T;

    /**
     * @default 'Question Analysis'
     */
    questionAnalysis: T;

    /**
     * @default 'Guest Respondents'
     */
    guestRespondents: T;

    /**
     * @default 'Answer Breakdown:'
     */
    answerBreakdown: T;

    /**
     * @default 'responses'
     */
    responses: T;

    /**
     * @default 'View Answers'
     */
    viewAnswers: T;

    /**
     * @default 'Anonymous Guest'
     */
    anonymousGuest: T;

    /**
     * @default 'Answers for'
     */
    answersFor: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default ':'
     */
    colon: T;
  };
  guest: {
    /**
     * @default 'An error occurred'
     */
    error: T;

    /**
     * @default 'Thank you for completing the form!'
     */
    thankYou: T;
  };
  quick: {
    /**
     * @default 'Root value must be an object.'
     */
    '377jP': T;

    /**
     * @default '"components" must be an array.'
     */
    szObT: T;

    /**
     * @default 'components[{{0}}] must be an object.'
     */
    wngcm: T;

    /**
     * @default 'components[{{0}}].id must be a string.'
     */
    x9i0f: T;

    /**
     * @default 'components[{{0}}].required must be a boolean.'
     */
    w0zD7: T;

    /**
     * @default 'components[{{0}}].title must be a string when provided.'
     */
    b61LV: T;

    /**
     * @default 'components[{{0}}].placeholder must be a string.'
     */
    Ph4PX: T;

    /**
     * @default 'components[{{0}}].options must be an array.'
     */
    '0gIO0': T;

    /**
     * @default 'components[{{0}}].options[{{1}}] must be an object.'
     */
    Fy5kz: T;

    /**
     * @default 'components[{{0}}].options[{{1}}].label must be a string.'
     */
    JUl6l: T;

    /**
     * @default 'components[{{0}}].options[{{1}}].value must be a string.'
     */
    Q1B5L: T;

    /**
     * @default 'components[{{0}}].options[{{1}}].next must be a string.'
     */
    oEPjF: T;

    /**
     * @default 'components[{{0}}].options[{{1}}].checked must be a boolean when provided.'
     */
    swOUF: T;

    /**
     * @default 'components[{{0}}].type "{{1}}" is not supported.'
     */
    '6lxYo': T;

    /**
     * @default 'Add at least one question.'
     */
    Np5gA: T;

    /**
     * @default 'Question {{0}}: id is required.'
     */
    orUJL: T;

    /**
     * @default 'Question {{0}}: duplicate id "{{1}}".'
     */
    bbgDi: T;

    /**
     * @default 'Question {{0}}: required must be a boolean.'
     */
    igkwi: T;

    /**
     * @default 'Question {{0}}: placeholder is required.'
     */
    Mwjfy: T;

    /**
     * @default 'Question {{0}}: add at least one option.'
     */
    g9rES: T;

    /**
     * @default 'Question {{0}} option {{1}}: label is required.'
     */
    N5pN6: T;

    /**
     * @default 'Question {{0}} option {{1}}: value is required.'
     */
    a7GFS: T;

    /**
     * @default 'Question {{0}} option {{1}}: checked must be a boolean.'
     */
    '2Q3w2': T;

    /**
     * @default 'Short Answer'
     */
    '0isuN': T;

    /**
     * @default 'Paragraph'
     */
    sx99g: T;

    /**
     * @default 'Multiple Choice'
     */
    xnpsD: T;

    /**
     * @default 'Checkboxes'
     */
    fS1Yr: T;

    /**
     * @default 'Question'
     */
    ubqly: T;

    /**
     * @default 'Go to question'
     */
    '1chcl': T;

    /**
     * @default 'Go to next question'
     */
    wUwhh: T;

    /**
     * @default 'Submit form'
     */
    ssRg5: T;

    /**
     * @default 'Question {{0}}'
     */
    W3Iq4: T;

    /**
     * @default 'type'
     */
    gtDSA: T;

    /**
     * @default 'Question title'
     */
    qI4E4: T;

    /**
     * @default 'Clear title'
     */
    jXJy2: T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'Placeholder'
     */
    '9DreF': T;

    /**
     * @default 'Clear placeholder'
     */
    gP8xe: T;

    /**
     * @default 'Options'
     */
    Uw6kb: T;

    /**
     * @default 'Option {{0}}'
     */
    FKOI3: T;

    /**
     * @default 'Clear option label'
     */
    '44SIR': T;

    /**
     * @default 'When selected go to'
     */
    Q8zCS: T;

    /**
     * @default 'Remove option {{0}}'
     */
    '3Wz4P': T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Checked by default'
     */
    bkDjI: T;

    /**
     * @default 'Add option'
     */
    mItFQ: T;

    /**
     * @default 'Remove question'
     */
    aQVdI: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Add question'
     */
    hwC7X: T;

    /**
     * @default 'Add Question'
     */
    '7XvlO': T;

    /**
     * @default 'Change question type?'
     */
    J5Mhu: T;

    /**
     * @default 'Changing this question${currentTypeLabel ? '
     */
    YrsgO: T;

    /**
     * @default 'Are you sure you want to continue?'
     */
    '8Vw4Q': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Change'
     */
    cH8ro: T;

    /**
     * @default 'Remove question?'
     */
    VMWSA: T;

    /**
     * @default 'Deleting this question cannot be undone.'
     */
    '7nEU8': T;

    /**
     * @default 'Are you sure you want to remove it?'
     */
    MQ7Wj: T;

    /**
     * @default 'Fix the following issues:'
     */
    '7eoaq': T;

    /**
     * @default 'Changing this question{{0}}{{1}} will reset type-specific settings such as answer options.'
     */
    yI0yS: T;
  };
};

export type FormCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'The form will be displayed directly on your website page. Visitors can fill out the form without leaving the page.'
     */
    UMuJc: T;

    /**
     * @default 'A link to the form will be displayed on your website page. Visitors will need to click the link to open and fill out the form.'
     */
    s0lsR: T;

    /**
     * @default 'Choose Form'
     */
    hWMiA: T;

    /**
     * @default 'Please select a form.'
     */
    rFzC6: T;

    /**
     * @default 'Display Type'
     */
    KL7DB: T;

    /**
     * @default 'Embedded'
     */
    gVjRv: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Button Text'
     */
    VGWQI: T;

    /**
     * @default 'Enter button text (e.g. 'Go To RSVP')'
     */
    SgQ37: T;

    /**
     * @default 'Button Title'
     */
    '0pptE': T;

    /**
     * @default 'Enter heading text (e.g. 'Register for the Event')'
     */
    '1Cgp4': T;

    /**
     * @default 'Form successfully submitted.'
     */
    IGHAu: T;

    /**
     * @default 'Your answer was not recorded'
     */
    '3Itbi': T;

    /**
     * @default 'An error occurred while saving. Please try again.'
     */
    Q3xiD: T;

    /**
     * @default 'Form updated successfully!'
     */
    fPc2C: T;

    /**
     * @default 'No forms found. Please create a form first.'
     */
    ljWWc: T;

    /**
     * @default 'Form'
     */
    I2ELA: T;

    /**
     * @default 'Registration successful'
     */
    '1fxgg': T;

    /**
     * @default 'Event Registration'
     */
    TPiGx: T;

    /**
     * @default 'Registration'
     */
    zeLZS: T;

    /**
     * @default 'Registration Closed'
     */
    bFTnn: T;

    /**
     * @default 'To join the event, register below'
     */
    '0KoqJ': T;

    /**
     * @default 'This event is no longer accepting registrations'
     */
    Qf1Yx: T;
  };
};

export type GeneralEventScheduleTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Event Schedule'
     */
    RrFg4: T;

    /**
     * @default 'No events scheduled.'
     */
    N8fit: T;

    /**
     * @default 'Add to Calendar'
     */
    sLe7P: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Get Directions'
     */
    m7hcK: T;

    /**
     * @default 'TBA'
     */
    lXYAA: T;

    /**
     * @default '{{0}} {{1}} to
{{2}} {{3}}'
*/
    '5ttKD': T;

    /**
     * @default '{{0}} to {{1}}'
     */
    oaYs3: T;

    /**
     * @default 'Add a label...'
     */
    sK113: T;

    /**
     * @default 'Remove {{0}}'
     */
    '0zcyi': T;

    /**
     * @default 'No options available'
     */
    GuGvA: T;
  };
};

export type GeneralEventScheduleEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Event Privacy'
     */
    aP73J: T;

    /**
     * @default 'Start building your schedule'
     */
    eToYI: T;

    /**
     * @default 'Add Event'
     */
    '3wzVJ': T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Event Schedule'
     */
    RrFg4: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Date To Be Announced'
     */
    VRIWE: T;

    /**
     * @default '{{0}} - {{1}}'
     */
    iy4m2: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Failed to edit schedule'
     */
    xl1yj: T;

    /**
     * @default 'Failed to add schedule'
     */
    '2AYLS': T;
  };
};

export type GeneralFormValidationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Invalid Email'
   */
  invalidEmail: T;

  /**
   * @default 'Required'
   */
  required: T;

  /**
   * @default 'You must agree to continue'
   */
  mustAgreeToContinue: T;

  quick: {
    /**
     * @default 'Required'
     */
    zNaqf: T;
  };
};

export type GraphicAccentCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Graphic Accent'
     */
    uJOr5: T;

    /**
     * @default 'Please select a graphic accent.'
     */
    BcTwU: T;

    /**
     * @default 'An error occurred while updating the graphic accent. Please try again.'
     */
    tHkVI: T;

    /**
     * @default 'Success! Graphic accent has been updated.'
     */
    rlcAI: T;

    /**
     * @default 'An error occurred while adding the graphic accent. Please try again.'
     */
    klMXA: T;

    /**
     * @default 'Success! Graphic accent has been added.'
     */
    C3gzE: T;

    /**
     * @default 'Current Selection'
     */
    Rmj9W: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Decorative accent for your page'
     */
    noAwf: T;
  };
};

export type GuestGuideTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Guest Guide'
   */
  buttonText: T;

  /**
   * @default 'Add to Calendar'
   */
  buttonTextAddToCalendar: T;

  /**
   * @default 'Browse Car Rentals'
   */
  buttonTextCarRental: T;

  /**
   * @default 'Edit RSVP Response'
   */
  buttonTextEditRSVP: T;

  /**
   * @default 'Guest-Only Hotel Deals'
   */
  buttonTextHotelDeals: T;

  /**
   * @default 'Browse Couple's Registry'
   */
  buttonTextRegistry: T;

  /**
   * @default 'Set stay reminder'
   */
  buttonTextStayReminder: T;

  /**
   * @default '💎 Celebration takes place in: <time/>'
   */
  countDownBannerWedding: T;

  /**
   * @default '💎 Event takes place in: <time/>'
   */
  countDownBannerEvent: T;

  /**
   * @default '{{days}} days'
   */
  countDownBannerDays: T;

  /**
     * @default 'Useful links to help you 
celebrate with {{eventName}}'
*/
  guideDescription: T;

  /**
   * @default 'Guest Guide'
   */
  guideTitle: T;

  /**
   * @default 'DEALS'
   */
  tagDeals: T;

  quick: {
    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Not Attending'
     */
    RXHya: T;

    /**
     * @default 'Add to Calendar'
     */
    sLe7P: T;

    /**
     * @default 'Browse Registry'
     */
    DSLYE: T;

    /**
     * @default 'Book Event Exclusive Stays'
     */
    hoIPo: T;

    /**
     * @default 'Remind to Book'
     */
    lCxDC: T;

    /**
     * @default 'Guest guide to what's next.'
     */
    uZmEA: T;

    /**
     * @default 'Not You?'
     */
    D1zbA: T;

    /**
     * @default 'Sign Out'
     */
    bXv8o: T;

    /**
     * @default 'View Guest Guide'
     */
    fBVQW: T;

    /**
     * @default 'Hi {{0}}!'
     */
    qYySE: T;

    /**
     * @default 'Change Response'
     */
    tA6un: T;

    /**
     * @default 'Book Event-Exclusive Stays'
     */
    OsMGN: T;

    /**
     * @default 'See Event-Exclusive Stays'
     */
    gAGcC: T;
  };
};

export type GuestKitTranslations<T extends LeafNodeValue = TranslateFunction> = {
  components: {
    virtualEventBlock: {
      /**
       * @default 'at'
       */
      at: T;

      /**
       * @default 'Join Livestream'
       */
      joinCta: T;

      /**
       * @default 'Join With Zoom'
       */
      joinCtaZoom: T;

      /**
       * @default 'Now Live'
       */
      eventLive: T;

      /**
       * @default 'The event has not yet started.'
       */
      eventUpcoming: T;

      /**
       * @default 'Starts in {{startsInMin}} minutes.'
       */
      eventStartsSoon: T;

      /**
       * @default 'This event has passed.'
       */
      eventPassed: T;

      /**
       * @default 'Time to be announced'
       */
      eventTba: T;

      /**
       * @default 'Your Local Time ({{offset}})'
       */
      localTimezoneOffset: T;

      /**
       * @default 'Streaming by'
       */
      streamingProvider: T;

      /**
       * @default 'Having trouble with the app?'
       */
      troubleWithApp: T;

      /**
       * @default 'Watch in a browser'
       */
      watchInBrowser: T;
    };
  };
  widgetRegistry: {
    /**
     * @default 'Visit {{name}} registry'
     */
    visitNamedRegistry: T;

    /**
     * @default 'Visit registry'
     */
    visitUnnamedRegistry: T;

    /**
     * @default 'Browse Our Registry'
     */
    buttonText: T;
  };
  common: {
    /**
     * @default '{{start}} to {{end}}'
     */
    timeframe: T;

    /**
     * @default '{{start}} to {{end}} ({{timezoneAbbr}})'
     */
    timeframeTz: T;

    /**
     * @default '{{startDate}} {{startTime}} to
{{endDate}} {{endTime}}'
*/
    timeframeMultiDay: T;

    /**
     * @default '{{startDate}} {{startTime}} to
{{endDate}} {{endTime}} ({{timezoneAbbr}})'
*/
    timeframeMultiDayTz: T;

    /**
     * @default '{{time}} ({{timezoneAbbr}})'
     */
    timeTz: T;

    /**
     * @default 'Add to Calendar'
     */
    addToCalendar: T;

    /**
     * @default 'Where to Stay'
     */
    whereToStay: T;

    /**
     * @default 'Add to Cal'
     */
    addToCal: T;

    /**
     * @default 'Discount Code'
     */
    discountCodeLabel: T;

    /**
     * @default 'Dress Code'
     */
    dressCode: T;

    /**
     * @default 'Directions'
     */
    getDirections: T;

    /**
     * @default 'menu'
     */
    menu: T;

    /**
     * @default 'For more details'
     */
    moreDetails: T;

    /**
     * @default 'To Be Announced'
     */
    toBeAnnouncedHeader: T;

    /**
     * @default 'Details for this event will be shared at a later date.'
     */
    toBeAnnouncedDescription: T;

    /**
     * @default 'Text Copied!'
     */
    textCopiedNotificationLabel: T;
  };
  quick: {
    /**
     * @default 'Video background fallback'
     */
    xpMpC: T;

    /**
     * @default 'Error loading video background'
     */
    fCVmY: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default 'Add to Calendar'
     */
    sLe7P: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Dress Code'
     */
    '4K6cX': T;

    /**
     * @default 'Directions'
     */
    G3n2r: T;

    /**
     * @default 'For more details'
     */
    MGEK8: T;

    /**
     * @default '{{0}} ({{1}})'
     */
    YPUxD: T;

    /**
     * @default '{{0}} {{1}} to
{{2}} {{3}} ({{4}})'
*/
    e1blL: T;

    /**
     * @default '{{0}} {{1}} to
{{2}} {{3}}'
*/
    '5ttKD': T;

    /**
     * @default '{{0}} to {{1}} ({{2}})'
     */
    TigjO: T;

    /**
     * @default '{{0}} to {{1}}'
     */
    oaYs3: T;

    /**
     * @default 'To Be Announced'
     */
    tG3lp: T;

    /**
     * @default 'Details for this event will be shared at a later date.'
     */
    ncOcz: T;
  };
};

export type GuestListTranslations<T extends LeafNodeValue = TranslateFunction> = {
  admin: {
    /**
     * @default 'Guest'
     */
    guest: T;

    /**
     * @default 'Guests'
     */
    guests: T;

    /**
     * @default 'created'
     */
    created: T;

    /**
     * @default 'updated'
     */
    updated: T;

    /**
     * @default 'deleted'
     */
    deleted: T;

    /**
     * @default 'successfully'
     */
    successfully: T;

    /**
     * @default 'There was an error performing the'
     */
    error: T;

    /**
     * @default 'create'
     */
    create: T;

    /**
     * @default 'update'
     */
    update: T;

    /**
     * @default 'delete'
     */
    delete: T;

    /**
     * @default 'Required'
     */
    required: T;

    /**
     * @default 'Invalid Email'
     */
    invalidEmail: T;

    /**
     * @default 'Hmm… we’re having some trouble.'
     */
    errorPageTitle: T;

    /**
     * @default 'This page may have changed or is temporarily unavailable.'
     */
    errorPageSubTitle: T;

    /**
     * @default 'Are you sure that you want to delete the following'
     */
    confirmDelete: T;

    /**
     * @default 'from your guest list? This cannot be undone'
     */
    confirmDeleteCont: T;

    /**
     * @default 'Delete Guest'
     */
    deleteGuest: T;

    /**
     * @default 'Delete Guests'
     */
    deleteGuests: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'Delete'
     */
    deleteCta: T;

    /**
     * @default 'Add Guest'
     */
    addGuest: T;

    /**
     * @default 'Selected'
     */
    selected: T;

    /**
     * @default 'Filter by'
     */
    filterBy: T;

    /**
     * @default 'Missing Addresses'
     */
    missingAddresses: T;

    /**
     * @default 'No Guests were found'
     */
    noGuests: T;

    /**
     * @default 'Select All'
     */
    selectAll: T;

    /**
     * @default 'Unselect All'
     */
    unSelectAll: T;

    /**
     * @default 'Clear all filters'
     */
    clearAllFilters: T;

    /**
     * @default 'Guest List'
     */
    guestList: T;

    /**
     * @default 'Jump start your guest list.'
     */
    emptyJumpStartTitle: T;

    /**
     * @default 'Add Your Contacts'
     */
    emptyAddContactsCta: T;

    /**
     * @default 'Collect everyone's contact info, instantly.'
     */
    emptyCollectInfoTitle: T;

    /**
     * @default 'Send your guests a magic link and build your guest list faster.'
     */
    emptyCollectInfoBody: T;

    /**
     * @default 'Collect Contacts'
     */
    emptyCollectContactsCta: T;

    /**
     * @default 'Already started?'
     */
    emptyAlreadyStartedTitle: T;

    /**
     * @default 'Import a CSV file of your guest list.'
     */
    emptyImportCsvBody: T;

    /**
     * @default 'Attending'
     */
    attendingLabel: T;

    /**
     * @default 'Declined'
     */
    declinedLabel: T;

    /**
     * @default 'Pending'
     */
    pendingLabel: T;

    /**
     * @default 'Add contacts'
     */
    altAddContacts: T;

    /**
     * @default 'CSV import options'
     */
    altCsvImportOptions: T;

    /**
     * @default '-'
     */
    hyphen: T;
  };
  quick: {
    /**
     * @default 'You have unsaved changes'
     */
    Imr9T: T;

    /**
     * @default 'Would you like to save or discard them?'
     */
    n21tG: T;

    /**
     * @default 'Save Changes'
     */
    u9Ddv: T;

    /**
     * @default 'Discard Changes'
     */
    '9jhfJ': T;

    /**
     * @default 'Attending'
     */
    wbfbK: T;

    /**
     * @default 'Not Going'
     */
    '7TiDk': T;

    /**
     * @default 'Add Status'
     */
    ta9ME: T;

    /**
     * @default 'Close attendance menu'
     */
    C8Idw: T;

    /**
     * @default 'Remove Status'
     */
    '0LLJZ': T;

    /**
     * @default 'Delete {{0}} Guest'
     */
    P6evq: T;

    /**
     * @default 'Delete {{0}} Guests'
     */
    io1Rp: T;

    /**
     * @default 'Close dialog'
     */
    CoNQA: T;

    /**
     * @default 'Are you sure you want to delete 1 guest?'
     */
    XnC93: T;

    /**
     * @default 'Are you sure you want to delete {{0}} guests?'
     */
    rAIk7: T;

    /**
     * @default 'Missing addresses'
     */
    U4VII: T;

    /**
     * @default 'Failed to delete guest{{0}}. Please try again.'
     */
    ACDiE: T;

    /**
     * @default 'Add Guest'
     */
    bfnfJ: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Select'
     */
    YS91U: T;

    /**
     * @default 'Unselect All'
     */
    M6Bwa: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Selected'
     */
    '5gqDQ': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'No guests'
     */
    kOWXH: T;

    /**
     * @default 'Guest'
     */
    gyZ9F: T;

    /**
     * @default 'Guests'
     */
    '1THW0': T;

    /**
     * @default 'Delete Guests'
     */
    wvR7N: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Guest List'
     */
    sYWqA: T;
  };
};

export type GuestRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  pageTitle: {
    /**
     * @default '🎁 Did you purchase it?'
     */
    confirmPaymentTitle: T;

    /**
     * @default 'Registry'
     */
    registryPage: T;

    /**
     * @default 'Already Gifted'
     */
    alreadyGifted: T;
  };
  coupleHeader: {
    /**
     * @default 'Manage Registry'
     */
    dashboardBtn: T;

    /**
     * @default 'Continue reading…'
     */
    readMore: T;

    /**
     * @default 'Collapse note…'
     */
    readLess: T;

    /**
     * @default '…'
     */
    readMoreText: T;

    /**
     * @default 'Change Photo'
     */
    photoButton: T;

    /**
     * @default 'Add Photo'
     */
    addPhotoButton: T;

    /**
     * @default 'Edit Note'
     */
    noteButton: T;

    /**
     * @default 'Add Note'
     */
    addNoteButton: T;

    /**
     * @default 'Menu'
     */
    menu: T;

    /**
     * @default 'Edit Event'
     */
    editEvent: T;

    /**
     * @default 'Logout'
     */
    logout: T;

    /**
     * @default 'More…'
     */
    more: T;

    defaultName: {
      /**
       * @default 'Baby Registry'
       */
      babyRegistry: T;

      /**
       * @default 'Jack & Jill's Registry'
       */
      wedding: T;

      /**
       * @default 'Registry'
       */
      general: T;
    };
  };
  productTile: {
    /**
     * @default 'Purchased'
     */
    purchased: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default '{{amount}} Remaining'
     */
    remaining: T;

    /**
     * @default '{{amount}} Requested'
     */
    requested: T;

    /**
     * @default 'Trending'
     */
    labelTrending: T;

    /**
     * @default 'Purchased by you'
     */
    purchasedByYou: T;

    /**
     * @default 'Reserved by you'
     */
    reservedByYou: T;

    /**
     * @default '<StillNeeded/> more needed'
     */
    needed: T;

    /**
     * @default 'Contribute what you wish'
     */
    contributionAnyAmountText: T;

    /**
     * @default 'Goal Reached!'
     */
    goalReachedText: T;

    /**
     * @default '{{goal}} Goal Reached!'
     */
    goalReachedWithPriceText: T;

    /**
     * @default 'Charity'
     */
    charity: T;

    /**
     * @default 'Cash Fund'
     */
    cashFund: T;

    /**
     * @default 'Funded'
     */
    funded: T;

    /**
     * @default 'Our Most Wanted'
     */
    ourMostWanted: T;
  };
  emptyFilter: {
    /**
     * @default 'Nothing to see here (yet).'
     */
    title: T;

    /**
     * @default 'There are no current items that appear in this category.'
     */
    subtitle: T;
  };
  productDialog: {
    /**
     * @default 'Registered on'
     */
    availableToPurchaseOn: T;

    /**
     * @default 'Purchase on Retailer'
     */
    clickToBuy: T;

    /**
     * @default 'Retailer'
     */
    retailer: T;

    /**
     * @default 'How do I mark this gift as purchased?'
     */
    markAsPurchased: T;

    /**
     * @default 'This gift is from a {{storeName}} registry'
     */
    markAsPurchasedTitle: T;

    /**
     * @default 'Mark your item as purchased on that registry. We check and update the purchase status daily.'
     */
    markAsPurchasedSubtitle: T;
  };
  purchaseDialog: {
    /**
     * @default 'How many are you purchasing?'
     */
    howManyRequest: T;

    /**
     * @default '<StillNeeded/> more needed'
     */
    needed: T;

    /**
     * @default 'Your Name'
     */
    fieldNameLabel: T;

    /**
     * @default 'Email'
     */
    fieldEmailLabel: T;

    /**
     * @default 'First and last name'
     */
    fieldNamePlaceholder: T;

    /**
     * @default 'Your email address'
     */
    fieldEmailPlaceholder: T;

    /**
     * @default 'Gift Note'
     */
    fieldNoteLabel: T;

    /**
     * @default 'Add a note (optional)'
     */
    fieldNotePlaceholder: T;

    /**
     * @default 'Reserve & Purchase'
     */
    formButtonReservePurchase: T;

    /**
     * @default 'Buy Now'
     */
    formButtonBuyNow: T;

    /**
     * @default 'Add to Cart'
     */
    formButtonAddToCart: T;

    /**
     * @default 'Purchase Now'
     */
    formButtonPurchaseNow: T;

    /**
     * @default 'I've Already Purchased This'
     */
    formButtonAlreadyPurchase: T;

    /**
     * @default 'Mark as Purchased'
     */
    formButtonMarkAsPurchased: T;

    /**
     * @default 'Hide description'
     */
    hideDescription: T;

    /**
     * @default 'Read More'
     */
    readMore: T;

    /**
     * @default 'Out of Stock'
     */
    outOfStock: T;

    /**
     * @default 'This gift is not available for purchase right now. Browse <link/>'
     */
    isNotPurchasableText: T;

    /**
     * @default 'Unavailable'
     */
    isNotPurchasableButton: T;

    /**
     * @default 'Description'
     */
    descriptionLabel: T;

    /**
     * @default 'Added from {{storeName}}'
     */
    detailsLinkText: T;

    /**
     * @default 'Note'
     */
    noteLabel: T;

    /**
     * @default ' other gifts'
     */
    otherGifts: T;

    /**
     * @default 'Have Questions?'
     */
    questionLinkText: T;

    /**
     * @default 'Have questions? We’re here to help.'
     */
    questionV2LinkText: T;

    /**
     * @default 'This item will be fulfilled by Joy'
     */
    fulfilledByJoy: T;

    /**
     * @default 'This item will be fulfilled by {{storeName}}'
     */
    fulfilledByExternal: T;

    /**
     * @default 'Add to Cart & Reserve'
     */
    formButtonAddCartReserve: T;

    /**
     * @default 'Please enter your name'
     */
    requiredNameWarning: T;

    /**
     * @default 'Please enter your email'
     */
    requiredEmailWarning: T;

    /**
     * @default 'Please enter a valid email'
     */
    validEmailWarning: T;

    /**
     * @default 'We could not process your order at this time.'
     */
    purchaseErrorMsg: T;

    /**
     * @default 'Change Email'
     */
    changeEmail: T;

    /**
     * @default 'Quantity'
     */
    quantityTitle: T;

    /**
     * @default 'Subtotal'
     */
    subtotalTitle: T;

    /**
     * @default '{{quantity}} x {{price}}'
     */
    quantityTimesPrice: T;

    /**
     * @default 'Total {{total}}'
     */
    totalPriceTitleText: T;

    /**
     * @default 'Gift'
     */
    giftTitle: T;

    /**
     * @default '🎁 Item added to cart 🎁'
     */
    itemAddedSuccess: T;

    /**
     * @default 'Free shipping fulfilled by Joy'
     */
    freeShippingByJoy: T;

    /**
     * @default 'Fulfilled by Joy'
     */
    fulfilledByJoyShort: T;

    /**
     * @default 'Free Shipping'
     */
    freeShipping: T;

    /**
     * @default 'For orders over ${{price}}'
     */
    freeShippingDescription: T;

    /**
     * @default 'Every Joy Registry Deserves'
     */
    everyJoyRegistryDeserves: T;

    /**
     * @default 'Price Match Promise'
     */
    priceMatchPromise: T;

    /**
     * @default 'We'll match any retailer'
     */
    priceMatchPromiseDescription: T;

    /**
     * @default 'Easy Returns'
     */
    easyReturns: T;

    /**
     * @default 'Free online returns'
     */
    easyReturnsDescription: T;

    /**
     * @default 'Your Details'
     */
    backToDetails: T;

    /**
     * @default 'Where's it going?'
     */
    backToMissingCoupleAddress: T;

    /**
     * @default 'Add optional gift note'
     */
    giftNoteTitle: T;

    /**
     * @default 'Gift Details'
     */
    backToGiftDetails: T;

    /**
     * @default 'Greeting Card'
     */
    backToGreetingCard: T;

    /**
     * @default 'Upgrade My Gift Note'
     */
    upgradeGiftNote: T;

    /**
     * @default 'Next'
     */
    next: T;

    /**
     * @default 'Subject to third party shipping.'
     */
    shippingInfo: T;

    /**
     * @default 'Learn more'
     */
    learnMore: T;

    missingCoupleAddress: {
      /**
       * @default 'Where's it going?'
       */
      title: T;

      /**
       * @default 'Missing Recipient's Address'
       */
      warningTitle: T;

      /**
       * @default 'Please contact the recipient to complete this purchase.'
       */
      warningBody: T;

      /**
       * @default 'Ship to'
       */
      shipTo: T;

      /**
       * @default 'Another U.S. Address'
       */
      anotherAddressTitle: T;

      /**
       * @default 'Joy only ships to U.S. addresses'
       */
      anotherAddressTooltip: T;

      /**
       * @default 'We'll tell the recipient it was purchased.'
       */
      anotherAddressBody: T;

      /**
       * @default 'Add Shipping Address'
       */
      button: T;
    };
    otherAddress: {
      /**
       * @default 'Shipping Address'
       */
      title: T;

      /**
       * @default 'Name'
       */
      nameLabel: T;

      /**
       * @default 'Only one recipient name is recommended'
       */
      namePlaceholder: T;

      /**
       * @default 'Jamie Lee'
       */
      nameGhost: T;

      /**
       * @default 'Address Line 1'
       */
      addressLine1Label: T;

      /**
       * @default 'Only Non-P.O. Box addresses in the United States'
       */
      addressLine1Placeholder: T;

      /**
       * @default 'Address Line 2'
       */
      addressLine2Label: T;

      /**
       * @default 'City'
       */
      cityLabel: T;

      /**
       * @default 'State'
       */
      stateLabel: T;

      /**
       * @default 'Zip/Postal Code'
       */
      postalCode: T;

      /**
       * @default '*Required fields'
       */
      requiredFields: T;

      /**
       * @default 'We cannot ship to P.O. boxes'
       */
      poBoxWarningCaption: T;

      /**
       * @default 'Review Details'
       */
      button: T;
    };
    groupGifting: {
      /**
       * @default 'Buy Entire Gift'
       */
      buyEntireGift: T;

      /**
       * @default 'Contribute'
       */
      contribute: T;

      /**
       * @default 'Contribute {{amount}} to Gift'
       */
      contributeToGiftBtn: T;

      /**
       * @default 'Contribute to Gift'
       */
      contributeToGiftBtnMobile: T;

      /**
       * @default 'Contribute Remaining Amount'
       */
      contributeRemainingAmount: T;

      /**
       * @default 'Contribute a Partial Amount'
       */
      contributePartialAmount: T;

      /**
       * @default '{{amount}} Remaining'
       */
      amountRemaining: T;
    };
  };
  confirmationPage: {
    /**
     * @default 'Quantity'
     */
    quantity: T;

    /**
     * @default 'Subtotal'
     */
    subtotal: T;

    /**
     * @default 'Shipping and Handling'
     */
    shipping: T;

    /**
     * @default 'Est Taxes'
     */
    estimatedTaxes: T;

    /**
     * @default 'eCard Fee'
     */
    eCardFee: T;

    /**
     * @default 'total'
     */
    total: T;

    /**
     * @default 'Thank you for your order!'
     */
    giftPurchased: T;

    /**
     * @default 'Your gift will ship directly to them in <addressText/>'
     */
    giftPurchasedSubtitle: T;

    /**
     * @default 'Order #{{orderId}}'
     */
    giftPurchasedOrderNumber: T;

    /**
     * @default 'We'll send you an email confirmation for your order shortly. {{host}} will also receive an email notifying them of your gift.'
     */
    giftPurchasedSendEmail: T;

    /**
     * @default 'We'll send you an email confirmation for your order shortly.'
     */
    giftPurchasedEmail: T;

    /**
     * @default '{{host}} will also receive an email notifying them of your gift.'
     */
    giftPurchasedCouple: T;

    /**
     * @default 'Your gift will be delivered electronically to them.'
     */
    giftPurchasedSubtitleState1Paragraph3: T;

    /**
     * @default 'Your item will ship directly to them in {{address}}'
     */
    giftPurchasedSubtitleState2Paragraph3: T;

    /**
     * @default 'Paid via {{card}} {{cardLastDigits}}'
     */
    paidNote: T;

    /**
     * @default 'Back to Registry'
     */
    backToRegistryBtn: T;

    /**
     * @default 'Go to Wedding Website'
     */
    goToWeddingWebsiteBtn: T;

    /**
     * @default 'Have you purchased your gift?'
     */
    confirmQuestion: T;

    /**
     * @default 'Yes, I've Purchased This'
     */
    confirmButtonPage: T;

    /**
     * @default 'Yes'
     */
    confirmButton: T;

    /**
     * @default 'Please confirm your gift was purchased, and we'll let the recipient know.'
     */
    confirmSubtitle: T;

    /**
     * @default 'No'
     */
    noButton: T;

    /**
     * @default 'Something wrong?'
     */
    somethingWrongTitle: T;

    /**
     * @default 'Go back'
     */
    somethingWrongAction: T;

    /**
     * @default 'Changed your mind?'
     */
    changedMindTitle: T;

    /**
     * @default 'Cancel Reservation'
     */
    changedMindAction: T;

    /**
     * @default 'Have Questions?'
     */
    haveQuestions: T;

    /**
     * @default 'Just to be safe, please double check that you've sent it to the right address.'
     */
    justToBeSafe: T;

    /**
     * @default 'Like what you see?'
     */
    likeWhatYouSee: T;

    /**
     * @default 'Treat yourself'
     */
    treatYourself: T;

    /**
     * @default 'We won't tell anyone if you want to buy it for yourself — it'll be our little secret.'
     */
    weWontTellAnyone: T;

    /**
     * @default 'Buy Now'
     */
    buyNowBtn: T;

    /**
     * @default 'Next Steps'
     */
    nextSteps: T;

    /**
     * @default 'Book your place to stay  🛏️'
     */
    bookYourPlaceToStay: T;

    /**
     * @default 'Rooms can book up quickly and discounted rates can expire.'
     */
    roomsBookUpQuickly: T;

    /**
     * @default 'Visit event website  👩‍💻'
     */
    visitEventWebsite: T;

    /**
     * @default 'For important travel, schedule and details for this event'
     */
    detailsForTheEvent: T;

    /**
     * @default 'Continue shopping  🎁'
     */
    continueShopping: T;

    /**
     * @default 'Have you booked your stay for {{eventName}}’s event?'
     */
    haveYouBookedStay: T;

    /**
     * @default '{{eventName}} have picked some hotels to help you stay close to the venue.'
     */
    pickedHotels: T;

    /**
     * @default 'Confirmation has been sent to'
     */
    confirmationSentTo: T;

    /**
     * @default 'Prices can expire and rooms are filling up.'
     */
    pricesExpiring: T;

    /**
     * @default 'Book Your Stay'
     */
    bookYourStay: T;

    /**
     * @default 'Check In'
     */
    checkIn: T;

    /**
     * @default 'Check Out'
     */
    checkOut: T;
  };
  confirmationPurchaseModal: {
    /**
     * @default 'Ready to head to {{retailer}}?'
     */
    title: T;

    /**
     * @default 'After purchasing, we will ask you to confirm that you've completed your purchase.'
     */
    afterPurchasing: T;

    /**
     * @default 'We don't have a shipping address for the recipient. Please ask them where they would like to receive their gifts.'
     */
    dontHaveAddress: T;

    /**
     * @default 'Continue to {{retailer}}'
     */
    button: T;

    /**
     * @default '✨ Address copied ✨'
     */
    addressCopied: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Shipping Address'
     */
    couplesAddressTitle: T;

    /**
     * @default 'Joy may earn an affiliate commission on purchases.'
     */
    legal: T;

    /**
     * @default 'Before you leave, you'll need the recipient's address.'
     */
    addressNote: T;

    /**
     * @default 'When you're done, come back here to mark the gift as purchased on the registry.'
     */
    purchaseNote: T;

    /**
     * @default 'Got It'
     */
    buttonGotIt: T;

    /**
     * @default 'Shipping Address'
     */
    shippingAddress: T;
  };
  intentToPurchaseModal: {
    /**
     * @default 'Do you still intend to purchase this gift?'
     */
    title: T;

    /**
     * @default 'Yes, just not right now'
     */
    ctaYes: T;

    /**
     * @default 'No, cancel my reservation'
     */
    ctaNo: T;

    /**
     * @default 'How “Mark as Purchased” works:'
     */
    titleHowTo: T;

    /**
     * @default 'Purchase the item from any store'
     */
    howTo1: T;

    /**
     * @default 'Return to Joy with your order number and mark the item as purchased'
     */
    howTo2: T;

    /**
     * @default 'How sending a cash gift works:'
     */
    titleHowToDonation: T;

    /**
     * @default 'Send your gift via {{platform}}'
     */
    howTo1Donation: T;

    /**
     * @default 'Return to Joy and mark the item as purchased'
     */
    howTo2Donation: T;
  };
  createOrderAndPurchaseModal: {
    /**
     * @default 'Great! Now add your purchase details.'
     */
    title: T;

    /**
     * @default 'How many did you purchase?'
     */
    qtyPurchased: T;

    /**
     * @default '{{qty}} needed'
     */
    qtyNeeded: T;

    /**
     * @default 'Your Name'
     */
    nameLabel: T;

    /**
     * @default 'First and last name'
     */
    namePlaceholder: T;

    /**
     * @default 'Email'
     */
    emailLabel: T;

    /**
     * @default 'Your email address'
     */
    emailPlaceholder: T;

    /**
     * @default 'Done'
     */
    doneButton: T;

    /**
     * @default 'Didn't purchase this gift?'
     */
    cancelTitle: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelButton: T;
  };
  purchaseGift: {
    /**
     * @default 'Your gift is reserved. Please complete your purchase.'
     */
    reservedTitle: T;

    /**
     * @default 'Didn't mean to reserve this item?'
     */
    reservedGift: T;

    /**
     * @default 'Complete your order on {{retailer}} and make sure you mark it as a gift to include a gift receipt.'
     */
    purchaseDescription: T;

    /**
     * @default 'Your gift is reserved. Please complete your purchase.'
     */
    customPurchaseTitle: T;

    /**
     * @default 'Complete your order and make sure you mark it as a gift to include a gift receipt.'
     */
    customPurchaseDescription: T;

    /**
     * @default 'Complete your order on Amazon and make sure you mark it as a gift to include a gift receipt.'
     */
    customPurchaseDescriptionAmazon: T;

    /**
     * @default 'Address is not filled out automatically.'
     */
    purchaseTip: T;

    /**
     * @default 'Shipping Address'
     */
    shippingAddress: T;

    /**
     * @default '✨ Address copied ✨'
     */
    copyToClipboard: T;

    /**
     * @default 'Back to Registry'
     */
    backToRegistry: T;

    /**
     * @default 'Complete Purchase'
     */
    completeButton: T;

    /**
     * @default 'Buy on {{storeText}}'
     */
    buyOn: T;

    /**
     * @default 'Thanks for buying this gift!'
     */
    thanksTitle: T;

    /**
     * @default 'Please confirm that you've bought this item so it can be marked as purchased.'
     */
    thanksDescription: T;

    /**
     * @default 'All Done'
     */
    thanksButton: T;

    /**
     * @default 'Copy'
     */
    copyAddress: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservation: T;

    /**
     * @default 'Undo'
     */
    undo: T;

    /**
     * @default ' Didn't complete purchase?'
     */
    didntCompletePurchase: T;

    /**
     * @default 'The recipient hasn't indicated a shipping address. Please ask them about where they would like to receive their gifts.'
     */
    missingShippingAddress: T;

    /**
     * @default 'Retailer'
     */
    retailer: T;

    /**
     * @default 'Address doesn't transfer automatically.'
     */
    addressWarning: T;
  };
  contributeToFund: {
    /**
     * @default 'Via {{platform}}'
     */
    viaPlatform: T;

    /**
     * @default 'Now, let's send it.'
     */
    contributeTitle: T;

    /**
     * @default 'Need help?'
     */
    needHelp: T;

    /**
     * @default 'All Done'
     */
    allDone: T;

    /**
     * @default '{{amount}} for {{fundTitle}}'
     */
    contributeDetails: T;

    /**
     * @default '{{handle}} on {{platform}}'
     */
    contributeDetailsPayment: T;

    /**
     * @default 'Send Gift on {{donationPlatform}}'
     */
    contributeButtonSend: T;

    /**
     * @default 'Go to Donation Site'
     */
    contributeButtonTextCharity: T;

    /**
     * @default 'Suggested Note'
     */
    contributeSuggestedNoteLabel: T;

    /**
     * @default 'Copy'
     */
    contributeCopyText: T;

    /**
     * @default 'Copied'
     */
    contributeCopiedText: T;

    /**
     * @default 'For your {{fundTitle}} on Joy ❤️'
     */
    contributeSuggestedNoteString: T;

    /**
     * @default 'Have you sent your gift?'
     */
    contributeConfirmationHeader: T;

    /**
     * @default 'Please confirm your gift was sent, and we'll let the recipient know.'
     */
    contributeConfirmationBody: T;

    /**
     * @default 'Yes, I've Sent My Gift'
     */
    contributeConfirmationButtonText: T;

    /**
     * @default 'Changed your mind?'
     */
    contributeCancelQuestion: T;

    /**
     * @default 'Cancel Reservation'
     */
    contributeCancelText: T;

    /**
     * @default 'Thanks for giving to this gift!'
     */
    contributeConfirmationTitle: T;

    /**
     * @default 'Thanks for buying this gift!'
     */
    contributeConfirmationTitleProduct: T;

    /**
     * @default 'This gift has been marked as purchased and is unavailable for purchase by other gift givers.'
     */
    contributeConfirmationDescription: T;

    /**
     * @default 'Back to Registry'
     */
    contributeBackToRegistryText: T;

    /**
     * @default 'We've reserved your gift'
     */
    reservedCashOrCheckDonationTitle: T;

    /**
     * @default 'Bring your gift to the wedding or mail it to them at this address. We'll let them know that you plan to give them this gift.'
     */
    reservedCashOrCheckDonationInstructions: T;
  };
  undoPurchase: {
    /**
     * @default 'Would you like to cancel your reservation?'
     */
    undoPurchaseTitle: T;

    /**
     * @default 'The recipient will no longer see this gift as reserved, and the item will be available again for purchase.'
     */
    undoPurchaseBody: T;

    /**
     * @default 'Cancel Reservation'
     */
    undoPurchaseButtonText: T;

    /**
     * @default 'Nevermind'
     */
    undoPurchaseCancelText: T;

    /**
     * @default 'Reservation canceled'
     */
    undoPurchaseConfirmationTitle: T;

    /**
     * @default 'Back to Registry'
     */
    undoPurchaseBackText: T;

    /**
     * @default 'thanks for buying'
     */
    thanksForBuying: T;

    /**
     * @default 'contribute'
     */
    contribute: T;

    /**
     * @default 'purchase gift'
     */
    purchaseGift: T;
  };
  giveGiftDialog: {
    /**
     * @default 'Gift Amount'
     */
    fieldAmountLabel: T;

    /**
     * @default 'Your Name'
     */
    fieldNameLabel: T;

    /**
     * @default 'Email'
     */
    fieldEmailLabel: T;

    /**
     * @default 'Gift Note'
     */
    fieldNoteLabel: T;

    /**
     * @default 'First and last name'
     */
    fieldNamePlaceholder: T;

    /**
     * @default 'Your email address'
     */
    fieldEmailPlaceholder: T;

    /**
     * @default 'Add a note (optional)'
     */
    fieldNotePlaceholder: T;

    /**
     * @default 'Reserve and Give'
     */
    formButtonReserveGive: T;

    /**
     * @default 'Provide your name so the recipient knows who to thank.'
     */
    nameEmptyError: T;

    /**
     * @default 'Provide your email so the recipient knows who to thank.'
     */
    emailEmptyError: T;

    /**
     * @default 'Not a valid email.'
     */
    emailNotValidError: T;

    /**
     * @default 'How does this work?'
     */
    explanationLink: T;

    /**
     * @default 'Also registered at'
     */
    alsoRegisteredAt: T;

    /**
     * @default 'Please enter a gift amount.'
     */
    amountEmptyError: T;

    /**
     * @default 'Payment Method'
     */
    paymentMethodLabel: T;

    /**
     * @default 'Select...'
     */
    paymentMethodSelectPlaceholder: T;

    /**
     * @default 'Select a payment method'
     */
    paymentMethodError: T;

    /**
     * @default 'Cash/Check'
     */
    cashOrCheckGuestSelectLabel: T;

    /**
     * @default 'Add to Cart & Reserve'
     */
    formButtonAddCartReserve: T;

    /**
     * @default 'Update Reservation'
     */
    formButtonUpdateDonation: T;
  };
  registryHidden: {
    /**
     * @default 'This registry isn't ready.'
     */
    title: T;

    /**
     * @default 'You'll be redirected to the event website in a moment. Otherwise, '
     */
    subtitle: T;

    /**
     * @default 'click here to be redirected now.'
     */
    link: T;
  };
  retailerRedirect: {
    /**
     * @default 'We're taking you to {{storeName}}...'
     */
    title: T;

    /**
     * @default 'Don't forget!'
     */
    markGiftTitle: T;

    /**
     * @default 'After purchasing, go back to your previous tab to mark your gift as purchased. ✅ 🎁'
     */
    markGiftDescription: T;

    /**
     * @default 'This will help the host know who to thank.'
     */
    coupleMessage: T;

    /**
     * @default 'Click here if you haven't been redirected'
     */
    link: T;
  };
  browserWindow: {
    /**
     * @default '🎁  Did you purchase it?'
     */
    joyBrowserTabTitle: T;
  };
  registryProtected: {
    /**
     * @default 'This event is protected'
     */
    title: T;

    /**
     * @default 'Please enter the password'
     */
    subtitle: T;

    /**
     * @default 'Password'
     */
    inputPlaceholder: T;

    /**
     * @default 'Unlock Registry'
     */
    actionButton: T;

    /**
     * @default 'Sign In'
     */
    signInButton: T;

    /**
     * @default 'Contact Host'
     */
    contactButton: T;

    /**
     * @default 'Incorrect Password. Please try again.'
     */
    incorrectPass: T;
  };
  contactTheHost: {
    /**
     * @default 'Request Password'
     */
    title: T;

    /**
     * @default 'Tell the host who you are, so they can email you back with their event password.'
     */
    subtitle: T;

    /**
     * @default 'Your Full Name'
     */
    namePlaceholder: T;

    /**
     * @default 'Your Email'
     */
    emailPlaceholder: T;

    /**
     * @default 'Send Request'
     */
    actionButton: T;

    /**
     * @default 'We've sent the host an email'
     */
    successTitle: T;

    /**
     * @default 'In the meantime, we'll redirect you to their website. '
     */
    sucessSubtitle: T;

    /**
     * @default 'Click here to be redirected now.'
     */
    successLink: T;

    /**
     * @default 'Invalid Email. Please try again.'
     */
    emailInputError: T;
  };
  confirmationSection: {
    /**
     * @default 'Cancel Reservation'
     */
    cancelText: T;

    /**
     * @default 'Change Payment Method'
     */
    changeGiftingMethod: T;

    /**
     * @default 'Changed your mind?'
     */
    cancelQuestion: T;

    /**
     * @default 'Have Questions?'
     */
    haveQuestions: T;

    /**
     * @default 'Your gift is reserved.'
     */
    itsReserved: T;
  };
  alreadyReserveSection: {
    /**
     * @default 'It looks like you've already reserved this gift with that email address.'
     */
    title: T;

    /**
     * @default 'We've sent you an email with a link to your reservation so you can complete your purchase or cancel your reservation.'
     */
    subTitle: T;

    /**
     * @default 'Check your  “{{email}}” email inbox.'
     */
    checkEmail: T;

    /**
     * @default 'Change Email'
     */
    changeEmail: T;
  };
  reserveItem: {
    /**
     * @default 'Did you reserve {{itemName}}?'
     */
    title: T;

    /**
     * @default 'Enter the email address you used to reserve this gift and we'll send you a link to your reservation.'
     */
    subTitle: T;

    /**
     * @default 'Email address'
     */
    inputLabel: T;

    /**
     * @default 'Find Reservation'
     */
    buttonLabel: T;

    /**
     * @default 'Cancel'
     */
    cancelText: T;

    /**
     * @default 'We've sent a link to your reservation! Check your email at {{email}}.'
     */
    successMessage: T;

    /**
     * @default 'This gift was not reserved with this email.'
     */
    errorMessage: T;

    /**
     * @default 'Did you reserve a gift for {{itemName}}?'
     */
    cashFundTitle: T;
  };
  registryFooter: {
    /**
     * @default 'About'
     */
    about: T;

    /**
     * @default 'Help'
     */
    help: T;
  };
  trackingSection: {
    /**
     * @default 'Update Tracking'
     */
    updateCta: T;

    /**
     * @default 'Add Tracking Info'
     */
    addTrackingCta: T;

    /**
     * @default 'Add Tracking Info for recipient'
     */
    addTrackingInfoCta: T;

    /**
     * @default 'Help the recipient keep track of this gift by providing your Order and Tracking Numbers.'
     */
    addTrackingTooltip: T;

    /**
     * @default 'Order Number (Required)'
     */
    orderNumberLabel: T;

    /**
     * @default 'Please enter an order number'
     */
    orderNumberRequiredError: T;

    /**
     * @default 'Tracking Number'
     */
    trackingNumberLabel: T;

    /**
     * @default 'Test Link'
     */
    testLink: T;

    /**
     * @default 'Save'
     */
    saveCta: T;

    /**
     * @default 'Save Tracking Info'
     */
    saveTrakingInfoCta: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;
  };
  changeEmailSection: {
    /**
     * @default 'Are you sure you want to change your email?'
     */
    title: T;

    /**
     * @default 'Continuing with a new email will clear your shopping cart and past purchases, and start a new one.'
     */
    subTitle: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Change Email'
     */
    changeEmail: T;

    /**
     * @default 'Email'
     */
    email: T;
  };
  checkoutDialog: {
    /**
     * @default '{{amount}} Contribution'
     */
    contributionAmount: T;

    /**
     * @default 'Read more'
     */
    readMoreButton: T;

    /**
     * @default 'Read less'
     */
    readLessButton: T;

    giftMethodBadge: {
      /**
       * @default 'Cash / Check'
       */
      cashCheckLabel: T;

      /**
       * @default 'Charity'
       */
      charityLabel: T;
    };
    donationProgressBar: {
      /**
       * @default 'funded of {{amount}} goal'
       */
      fundedLabelWithoutGift: T;

      /**
       * @default 'funded of {{amount}} goal (with your gift)'
       */
      fundedLabelWithGift: T;
    };
    shippingAddress: {
      /**
       * @default 'The recipient hasn't indicated a shipping address. Please ask them where they would like to receive their gifts.'
       */
      noShippingAddress: T;

      /**
       * @default 'Mailing Address'
       */
      shippingAddressTitle: T;

      /**
       * @default 'Copy'
       */
      copy: T;

      /**
       * @default 'Address copied'
       */
      copied: T;
    };
    stateBackLabels: {
      /**
       * @default 'Payment Method'
       */
      gifterDetails: T;

      /**
       * @default 'Your Details'
       */
      giftWrap: T;

      /**
       * @default 'Gift Wrap'
       */
      giftWrapNote: T;

      /**
       * @default 'Gift Wrap'
       */
      externalCheckoutInstructionsGiftWrapIdle: T;

      /**
       * @default 'Gift'
       */
      paymentMethod: T;

      /**
       * @default 'Payment Method'
       */
      paperCheckoutInstructions: T;

      /**
       * @default 'Gift Wrap'
       */
      paperCheckoutInstructionsGiftWrapIdle: T;

      /**
       * @default 'Address'
       */
      paperCheckoutConfirmAndNotify: T;

      /**
       * @default 'Payment Method'
       */
      externalCheckoutInstructions: T;

      /**
       * @default 'Your Details'
       */
      externalCheckoutInstructionsAffiliate: T;

      /**
       * @default 'Your Details'
       */
      externalCheckoutInstructionsCharity: T;

      /**
       * @default 'Instructions'
       */
      externalCheckoutCopyAddress: T;

      /**
       * @default 'Instructions'
       */
      externalCheckoutReview: T;

      /**
       * @default 'Address'
       */
      externalCheckoutReviewAffiliate: T;

      /**
       * @default 'Confirm Gift'
       */
      cancelGiftIntent: T;
    };
    screens: {
      externalCheckoutInstructions: {
        /**
         * @default 'Great! Here's how it works:'
         */
        title: T;

        steps: {
          step1: {
            venmo: {
              /**
               * @default '<strong>On mobile</strong>, we'll take you to the Venmo app to send your gift.'
               */
              mobile: T;

              /**
               * @default '<strong>On desktop</strong>, we'll take you to the Venmo website to send your gift.'
               */
              desktop: T;
            };

            /**
             * @default 'You'll be taken to the recipient's PayPal page to send your gift.'
             */
            paypal: T;

            /**
             * @default 'You'll be taken to the recipient's Cash App page to send your gift.'
             */
            cashapp: T;

            /**
             * @default 'You'll be taken to the charity website.'
             */
            charity: T;

            /**
             * @default '<strong>You'll be taken to {{retailer}}</strong> and your gift will be added to the cart in this registry.'
             */
            affiliate: T;
          };
          step2: {
            /**
             * @default 'Venmo account: <strong>{{couplesAccount}}</strong>'
             */
            venmo: T;

            /**
             * @default 'PayPal.me account is: <strong>{{couplesAccount}}</strong>'
             */
            paypal: T;

            /**
             * @default 'Open Cash App on your phone and <strong>tap the QR Scanner</strong> on the top left corner of the home screen.'
             */
            cashapp: T;

            /**
             * @default 'Amount you're donating: <br><strong>{{amount}}</strong>'
             */
            charity: T;

            /**
             * @default 'Purchase your gift at <strong>{{retailer}}.</strong>'
             */
            affiliate: T;
          };
          step3: {
            /**
             * @default 'Amount you're sending: <strong>{{amount}}</strong>'
             */
            venmo: T;

            /**
             * @default 'Amount you're sending: <strong>{{amount}}</strong>'
             */
            paypal: T;

            /**
             * @default 'Hold your camera over the QR code generated on your desktop to scan it.'
             */
            cashapp: T;

            /**
             * @default 'Give your donation.'
             */
            charity: T;

            /**
             * @default '<strong>Come back to this tab</strong> to confirm your purchase and we'll notify the recipient.'
             */
            affiliate: T;
          };
        };
        stepsGiftWrap: {
          step1: {
            /**
             * @default 'Pay for your personalized eCard.'
             */
            venmo: T;

            /**
             * @default 'Pay for your personalized eCard.'
             */
            paypal: T;

            /**
             * @default 'Pay for your personalized eCard.'
             */
            cashapp: T;

            /**
             * @default 'Pay for your personalized eCard.'
             */
            affiliate: T;
          };
          step2: {
            /**
             * @default 'You'll be taken to the Venmo app to send your gift.'
             */
            venmo: T;

            /**
             * @default 'You'll be taken to the couple's PayPal page to send your gift.'
             */
            paypal: T;

            /**
             * @default 'We'll take you to the Cash App to send your gift.'
             */
            cashapp: T;

            /**
             * @default '<strong>You'll then be taken to {{retailer}}</strong> to purchase your gift.'
             */
            affiliate: T;
          };
          step3: {
            /**
             * @default 'Venmo account: @{{couplesAccount}}<br>Amount you're sending: {{amount}}'
             */
            venmo: T;

            /**
             * @default 'Paypal.me account: @{{couplesAccount}}<br>Amount you're sending: {{amount}}'
             */
            paypal: T;

            /**
             * @default 'Cash App account: ${{couplesAccount}}<br>Amount you're sending: {{amount}}'
             */
            cashapp: T;

            /**
             * @default '<strong>After purchase, come back to this tab</strong> to confirm your purchase.'
             */
            affiliate: T;
          };
        };

        /**
         * @default 'When you're done: '
         */
        alertTitle: T;

        /**
         * @default 'Come back to this tab to confirm your gift and we'll notify the recipient.'
         */
        alertText: T;

        /**
         * @default 'While gifts are in your cart, they won't be available for other gifts givers to purchase.'
         */
        alertTextAffiliate: T;

        /**
         * @default 'Copy {{account}} Account'
         */
        copyButton: T;

        /**
         * @default 'Got it'
         */
        gotItButton: T;
      };
      externalCheckoutReview: {
        /**
     * @default 'Almost done!
You're headed to {{platform}}...'
*/
        title: T;

        /**
         * @default 'Let's go to {{platform}}'
         */
        goToButton: T;

        /**
         * @default 'Cancel Gift'
         */
        cancelButton: T;

        /**
         * @default 'Go to Charity'
         */
        goToCharityButton: T;
      };
      giftAmount: {
        /**
         * @default 'Give {{amount}} Now'
         */
        giveNow: T;

        /**
         * @default 'Give Now'
         */
        giveNowWithAmount: T;

        /**
         * @default 'Additional Payment Options'
         */
        additionalPaymentOptions: T;

        /**
         * @default 'A gift amount is required'
         */
        amountEmptyError: T;
      };
      gifterDetails: {
        /**
         * @default 'Add your details'
         */
        title: T;

        /**
         * @default 'Share your details to mark this gift as purchased'
         */
        titleDeferred: T;

        /**
         * @default 'Please share your details to help {{host}} track your gift.'
         */
        description: T;

        /**
         * @default 'Add Details'
         */
        cta: T;

        /**
         * @default 'Email'
         */
        fieldEmailLabel: T;

        /**
         * @default 'Your email address'
         */
        fieldEmailPlaceholder: T;

        /**
         * @default 'Sharing your email is required'
         */
        fieldEmailMissing: T;

        /**
         * @default 'Name'
         */
        fieldNameLabel: T;

        /**
         * @default 'First and last name'
         */
        fieldNamePlaceholder: T;

        /**
         * @default 'Sharing your name is required'
         */
        fieldNameMissing: T;

        /**
         * @default 'Gift Note'
         */
        fieldNoteLabel: T;

        /**
         * @default 'Add an optional note'
         */
        fieldNotePlaceholder: T;

        /**
         * @default 'Come back to this tab to confirm your gift and we'll notify the recipient.'
         */
        warningText: T;
      };
      paymentMethod: {
        /**
         * @default 'How would you like to give?'
         */
        title: T;

        /**
         * @default '{{host}} would like to receive their gifts using one of the methods below:'
         */
        description: T;

        /**
         * @default 'Select a method below to contribute to {{fundName}}'
         */
        descriptionDonation: T;

        /**
         * @default 'Next'
         */
        cta: T;

        /**
         * @default 'Cash / Check'
         */
        cashCheck: T;

        /**
         * @default 'Credit or Debit Card'
         */
        creditCard: T;

        /**
         * @default 'Enter Card Manually'
         */
        enterCardManually: T;
      };
      paperCheckoutInstructions: {
        /**
         * @default 'You'll need the recipient's address to mail your gift:'
         */
        title: T;

        /**
         * @default 'Got it'
         */
        cta: T;
      };
      paperCheckoutInstructionsGiftWrap: {
        /**
         * @default 'Great! Here's how it works:'
         */
        title: T;

        /**
         * @default 'You'll need the couple's address if you're mailing your gift:'
         */
        subtitle: T;

        stepsGiftWrap: {
          /**
           * @default 'Pay for your personalized eCard.'
           */
          step1: T;

          /**
           * @default 'Confirm your gift details and we'll send your eCard.'
           */
          step2: T;

          /**
           * @default 'Send your check gift by mail or bring cash or check with you to the event.'
           */
          step3: T;
        };

        /**
         * @default 'Got it'
         */
        cta: T;
      };
      paperCheckoutConfirmAndNotify: {
        /**
         * @default 'Great!'
         */
        title: T;

        /**
         * @default 'Once you confirm below, we'll let the recipient know you're contributing to this gift.'
         */
        description: T;

        /**
         * @default 'Confirm & Notify recipient'
         */
        cta: T;

        /**
         * @default 'Cancel Gift'
         */
        cancelButton: T;
      };
      externalCheckoutConfirmAndNotify: {
        /**
         * @default 'Did you send your gift with {{platform}}?'
         */
        title: T;

        /**
         * @default 'Did you give to the charity in the recipient's name?'
         */
        titleCharity: T;

        /**
         * @default 'Have you purchased your gift?'
         */
        titleAffiliate: T;

        /**
         * @default 'When you confirm your gift, we'll let the recipient know it's headed their way and mark your gift as purchased.'
         */
        subtitle: T;

        /**
         * @default 'Yes, I did'
         */
        affirmativeButton: T;

        /**
         * @default 'No, I didn't'
         */
        negativeButton: T;

        /**
         * @default 'Not sure what to do?'
         */
        helpText: T;

        /**
         * @default 'Get help'
         */
        helpButton: T;
      };
      cancelGiftIntent: {
        /**
         * @default 'Do you still intend to send this gift?'
         */
        title: T;

        /**
         * @default 'Keep this gift in your cart and send it later, or cancel your reservation.'
         */
        subtitle: T;

        /**
         * @default 'Yes, I'll send it later'
         */
        affirmativeButton: T;

        /**
         * @default 'No, Cancel Gift'
         */
        negativeButton: T;
      };
      cancelGiftWarning: {
        /**
         * @default 'Are you sure you want to cancel this gift?'
         */
        title: T;

        /**
         * @default 'The recipient will no longer see this gift as reserved and it will be available again for others to purchase.'
         */
        subtitle: T;

        /**
         * @default 'Cancel Gift'
         */
        affirmativeButton: T;

        /**
         * @default 'Nevermind'
         */
        negativeButton: T;
      };
      confirmedPurchase: {
        /**
         * @default 'Thank You!'
         */
        title: T;

        /**
         * @default 'We've just let {{host}} know that you sent this gift with {{platform}}.'
         */
        subtitle: T;

        /**
         * @default 'We've just let {{host}} know that you plan to give this gift.'
         */
        subtitleForCashCheckMethod: T;

        /**
         * @default 'All Done'
         */
        affirmativeButton: T;
      };
      cancelGiftConfirmation: {
        /**
         * @default 'Your gift has been cancelled'
         */
        title: T;

        /**
         * @default 'This gift was removed from your shopping cart and is now available for others to buy.'
         */
        subtitle: T;

        /**
         * @default 'Done'
         */
        buttonLabel: T;
      };
      externalCheckoutCopyAddress: {
        /**
         * @default 'You'll need the recipient address to mail your gift:'
         */
        title: T;

        /**
         * @default 'Mailing Address'
         */
        coupleMailingAddress: T;

        /**
         * @default 'Copy'
         */
        copyButton: T;

        /**
         * @default 'Got it'
         */
        cta: T;

        /**
         * @default 'The recipient hasn't indicated a shipping address. Please ask them about where they would like to receive their gifts.'
         */
        missingShippingAddress: T;

        /**
         * @default 'Copied to clipboard'
         */
        copyToClipboard: T;
      };
      creditCardCheckoutError: {
        /**
         * @default 'Oops! An error has ocurred.'
         */
        title: T;

        /**
         * @default 'Please try again later.  If you continue to receive this error, try contacting the owner of this event, or contact Joy support at support@withjoy.com.'
         */
        description: T;

        /**
         * @default 'Close'
         */
        close: T;

        /**
         * @default 'Oops, that didn't work.'
         */
        checkoutErrorTitle: T;

        /**
         * @default 'We're sorry, but there was an error while processing your order. Please try again later or contact our support team at support@withjoy.com for assistance. Thank you for your patience.'
         */
        checkoutErrorText: T;

        /**
         * @default 'Back'
         */
        checkoutErrorAction: T;

        /**
         * @default 'We're sorry, but there seems to be an issue with your address. Please double-check the address in your account settings to ensure everything is correct. If you need further assistance, feel free to reach out to our support team at support@withjoy.com'
         */
        badAddress: T;

        /**
         * @default 'It looks like your transaction is still being verified. Check back soon and thank you for your patience.'
         */
        registryError: T;

        /**
         * @default 'We're sorry, but the item you're looking for is currently out of stock. We're working to replenish our inventory, so please check back later or explore similar options.'
         */
        outOfStock: T;
      };
    };
  };
  sortByOptions: {
    /**
     * @default 'Sort by'
     */
    sortBy: T;

    /**
     * @default 'Featured'
     */
    featured: T;

    /**
     * @default 'Price: Low to High'
     */
    priceLowToHigh: T;

    /**
     * @default 'Price: High to Low'
     */
    priceHighToLow: T;
  };
  orderTrackingDialog: {
    /**
     * @default 'Great! Now add your purchase details.'
     */
    orderTrackingDialogTitle: T;

    /**
     * @default 'Help {{host}} keep track of this gift by providing your Order Number'
     */
    orderTrackingDialogSubTitle: T;

    /**
     * @default 'Enter Order Number'
     */
    orderNumberPlaceholder: T;

    /**
     * @default 'Add Order Number'
     */
    submit: T;

    /**
     * @default 'Add Later'
     */
    addLater: T;

    /**
     * @default 'Please enter an Order Number'
     */
    requiredMessage: T;

    /**
     * @default 'Not sure where to find it? Check your confirmation email from {{retailer}}.'
     */
    orderTrackingDialogDetail: T;

    /**
     * @default 'Didn't purchase this gift?'
     */
    didntPurchase: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservation: T;

    /**
     * @default '✨ Thank you, Order Number submitted ✨'
     */
    successMessage: T;

    /**
     * @default 'Something went wrong, try again later'
     */
    errorMessage: T;

    /**
     * @default '🚫 Your gift reservation has been canceled. 🚫'
     */
    removeSuccess: T;

    /**
     * @default '🎉 This item has been marked as purchased. 🎉'
     */
    purchaseSuccess: T;
  };
  photoMenu: {
    /**
     * @default 'Update Photo'
     */
    updatePhoto: T;

    /**
     * @default 'Delete Photo'
     */
    deletePhoto: T;

    /**
     * @default 'An error occurred uploading your image. Please try again'
     */
    error: T;

    /**
     * @default 'Your image has been updated'
     */
    success: T;
  };
  checkoutGiftCard: {
    /**
     * @default 'Elevate your gift with a personalized eCard'
     */
    title: T;

    /**
     * @default 'Wrap your gift note in a beautiful design.'
     */
    subtitle: T;

    /**
     * @default 'Select Design'
     */
    selectDesign: T;

    /**
     * @default 'Edit Message'
     */
    editMessage: T;

    /**
     * @default 'Unwrap My Gift'
     */
    unwrap: T;

    /**
     * @default 'Add Greeting Card'
     */
    addGreetingCard: T;

    /**
     * @default 'No Thanks'
     */
    noThanks: T;

    /**
     * @default 'Sent with'
     */
    sentWith: T;

    /**
     * @default 'Collapse theme list'
     */
    collapseThemeList: T;

    /**
     * @default 'Expand theme list'
     */
    expandThemeList: T;

    otherGifts: {
      /**
       * @default '... and {{count}} other gift!'
       */
      single: T;

      /**
       * @default '... and {{count}} other gifts!'
       */
      plural: T;
    };

    /**
     * @default 'Next'
     */
    next: T;
  };
  host: {
    /**
     * @default 'the recipient'
     */
    defaultValue: T;
  };
  expressCheckout: {
    shippingAddress: {
      /**
       * @default 'Shipping Method'
       */
      shippingMethod: T;

      /**
       * @default 'Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Standard Shipping'
       */
      standardShipping: T;

      /**
       * @default 'Ship to'
       */
      shipTo: T;

      /**
       * @default '🎁'
       */
      giftEmoji: T;

      /**
       * @default 'Joy only ships to U.S. addresses'
       */
      onlyUSAddress: T;

      /**
       * @default 'Ship to me, I’ll give it to them.'
       */
      shipToMe: T;

      /**
       * @default 'You will add a shipping address during payment.'
       */
      shippingAddressDuringPayment: T;

      /**
       * @default 'Shipping address pending'
       */
      shippingAddressPending: T;
    };

    /**
     * @default 'We’ve written you a nice first draft gift note, please edit it before purchase, or use as-is.'
     */
    giftWrapUneditedMessageWarning: T;

    errorDialog: {
      /**
       * @default 'An error occurred, please try again'
       */
      header: T;

      /**
       * @default 'Error code'
       */
      code: T;

      /**
       * @default 'An unexpected error occurred with your purchase, please check your information and try again. If the problem persists, please '
       */
      defaultMessageBeginning: T;

      /**
       * @default 'contact our support team'
       */
      defaultMessageContactSupport: T;

      /**
       * @default 'Okay'
       */
      okay: T;
    };
  };
};

export type GuestSiteCustomTranslations<T extends LeafNodeValue = TranslateFunction> = {
  emptyState: {
    /**
     * @default 'Stay Tuned!'
     */
    title: T;

    /**
     * @default 'We’re working on something exciting for this space—check back soon.'
     */
    content: T;
  };
  thingsToDo: {
    /**
     * @default 'Attraction'
     */
    attraction: T;

    /**
     * @default 'Activity'
     */
    activity: T;

    /**
     * @default 'Bar'
     */
    bar: T;

    /**
     * @default 'Wine Bar'
     */
    wineBar: T;

    /**
     * @default 'Beach'
     */
    beach: T;

    /**
     * @default 'Breakfast'
     */
    breakfast: T;

    /**
     * @default 'Brewery'
     */
    brewery: T;

    /**
     * @default 'Brunch'
     */
    brunch: T;

    /**
     * @default 'Cocktail Bar'
     */
    cocktailBar: T;

    /**
     * @default 'Caffeine'
     */
    caffeine: T;

    /**
     * @default 'Dinner'
     */
    dinner: T;

    /**
     * @default 'Dive Bar'
     */
    diveBar: T;

    /**
     * @default 'Event'
     */
    event: T;

    /**
     * @default 'Food Truck'
     */
    foodTruck: T;

    /**
     * @default 'Landmark'
     */
    landmark: T;

    /**
     * @default 'Late Night'
     */
    lateNight: T;

    /**
     * @default 'Lunch'
     */
    lunch: T;

    /**
     * @default 'Museum'
     */
    museum: T;

    /**
     * @default 'Neighborhood'
     */
    neighborhood: T;

    /**
     * @default 'Park'
     */
    park: T;

    /**
     * @default 'Playground'
     */
    playground: T;

    /**
     * @default 'Hangout Spot'
     */
    hangoutSpot: T;

    /**
     * @default 'Hike'
     */
    hike: T;

    /**
     * @default 'Restaurant'
     */
    restaurant: T;

    /**
     * @default 'Shopping'
     */
    shopping: T;

    /**
     * @default 'Tour'
     */
    tour: T;

    /**
     * @default 'Walk'
     */
    walk: T;

    /**
     * @default 'Workout'
     */
    workout: T;

    /**
     * @default 'Popular'
     */
    popular: T;

    /**
     * @default 'Popular Nearby'
     */
    popularNearby: T;

    /**
     * @default 'See more tickets & tours'
     */
    seeMore: T;

    /**
     * @default 'Custom'
     */
    custom: T;

    /**
     * @default 'See Availability'
     */
    seeAvailability: T;

    /**
     * @default 'Explore More'
     */
    exploreMore: T;

    /**
     * @default 'Close modal'
     */
    closeModal: T;

    /**
     * @default 'From'
     */
    from: T;

    /**
     * @default 'per person'
     */
    perPerson: T;

    /**
     * @default 'Here are some tours we think would be interesting:'
     */
    interestingTours: T;
  };
  accommodations: {
    /**
     * @default 'Venue'
     */
    venue: T;

    /**
     * @default 'Book before {{date}}'
     */
    beforeDate: T;

    /**
     * @default 'This hotel has no availability for the event dates.'
     */
    soldOutMessage: T;

    numberOfBookings: {
      /**
       * @default '{{reservationsCount}} booking'
       * @param {number} count - The number of occurrences.
       * - singular: {{reservationsCount}} booking
       * - plural: {{reservationsCount}} bookings
       */
      numberOfBookings: T;
    };
    bookedTooltipTitle: {
      /**
       * @default '{{reservationsCount}} Guest Booked This Hotel'
       * @param {number} count - The number of occurrences.
       * - singular: {{reservationsCount}} Guest Booked This Hotel
       * - plural: {{reservationsCount}} Guests Booked This Hotel
       */
      bookedTooltipTitle: T;
    };
    bookedTooltipBody: {
      /**
       * @default 'Joy has seen {{reservationsCount}} booking at this hotel across our events recently. It's a popular spot. You should book soon.'
       * @param {number} count - The number of occurrences.
       * - singular: Joy has seen {{reservationsCount}} booking at this hotel across our events recently. It's a popular spot. You should book soon.
       * - plural: Joy has seen {{reservationsCount}} bookings at this hotel across our events recently. It's a popular spot. You should book soon.
       */
      bookedTooltipBody: T;
    };

    /**
     * @default 'EVENT TAKES PLACE IN:'
     */
    countdownTitle: T;

    /**
     * @default '{{days}} DAYS'
     */
    countdownDays: T;

    /**
     * @default 'Explore Hotels Nearby'
     */
    exploreHotelsNearby: T;

    /**
     * @default 'From ${{strikeoutPricePerNight}}'
     */
    fromPrice: T;

    /**
     * @default '{{miles}} miles away'
     */
    milesAway: T;

    /**
     * @default '{{miles}} mi from venue'
     */
    milesFromVenue: T;

    /**
     * @default '{{interestedGuestCount}} guests interested'
     */
    guestsInterested: T;

    /**
     * @default 'We reserved {{rooms}} rooms'
     */
    reservedRooms: T;

    /**
     * @default 'Per night'
     */
    perNight: T;

    /**
     * @default 'Book before'
     */
    bookBefore: T;

    /**
     * @default 'Group Rate'
     */
    groupRate: T;

    /**
     * @default 'Swipe to Preview Hotels'
     */
    swipeRightForQuickView: T;

    /**
     * @default 'A group rate is a special discounted price arranged for wedding guests at this hotel.'
     */
    groupRateTooltip: T;

    /**
     * @default 'Our Favorite Hotel'
     */
    favoriteHotel: T;

    /**
     * @default 'Hotel Room Block'
     */
    hotelRoomBlock: T;

    /**
     * @default 'Room Block'
     */
    roomBlockEyebrow: T;

    /**
     * @default 'Risk-free cancellation.'
     */
    riskFreeCancellation: T;

    /**
     * @default 'See Availability'
     */
    seeAvailability: T;

    /**
     * @default 'Select Rooms'
     */
    selectCTARoomBlock: T;

    /**
     * @default 'Select Hotel'
     */
    selectCTAHotel: T;

    /**
     * @default 'Select Property'
     */
    selectCTACustom: T;

    /**
     * @default '{{rooms}} Rooms Available'
     */
    roomsAvailable: T;

    /**
     * @default '{{rooms}} Room Available'
     */
    roomAvailable: T;

    /**
     * @default 'Night'
     */
    night: T;

    /**
     * @default 'more'
     */
    more: T;

    /**
     * @default 'less'
     */
    less: T;

    /**
     * @default 'guests are interested'
     */
    guestCount: T;

    /**
     * @default 'View More'
     */
    viewMore: T;

    leadGenDialog: {
      /**
       * @default 'Unlock your guest accommodations page'
       */
      title: T;

      /**
       * @default 'Add courtesy room blocks to your site with our free hotel concierge service. We offer discounted hotel rates with zero deposit requirements.'
       */
      content: T;

      /**
       * @default 'Get Started'
       */
      cta: T;
    };

    /**
     * @default 'Explore On Map'
     */
    exploreOnMap: T;

    /**
     * @default 'Exclusive block rate for our guests!'
     */
    exclusiveBlockRate: T;

    /**
     * @default 'Starting from'
     */
    roomsStartingFrom: T;

    /**
     * @default '{{price}} / night'
     */
    pricePerNight: T;

    /**
     * @default 'Exclusive Rate'
     */
    exclusiveRate: T;

    /**
     * @default 'Event-Only Rate'
     */
    eventOnlyRate: T;

    /**
     * @default 'Save {{percentage}}%'
     */
    percentageOff: T;

    /**
     * @default '{{name}}’s exclusive guest rates are available when you book with Joy. Reserve soon here to lock in this price—rooms are limited.'
     */
    eventOnlyRateInfo: T;

    /**
     * @default 'compared to {{price}}'
     */
    comparedToPublicRates: T;

    /**
     * @default 'Special Event Rate'
     */
    specialEventRate: T;

    /**
     * @default 'Joy Travel'
     */
    joyTravel: T;

    /**
     * @default 'Compared to public rates'
     */
    comparedTo: T;

    linkInterceptor: {
      /**
       * @default 'Others'
       */
      others: T;

      /**
       * @default 'Compared to'
       */
      comparedTo: T;

      /**
       * @default 'View Joy Rates'
       */
      viewJoyRates: T;

      /**
       * @default 'and Others'
       */
      expediaAndOthers: T;

      /**
       * @default 'Guest only price'
       */
      guestOnlyPrice: T;

      /**
       * @default 'Save {{percentage}}%'
       */
      savePercentage: T;

      /**
       * @default 'Compare Prices Before You Book'
       */
      title: T;

      /**
       * @default 'Open external link instead'
       */
      openExternalLink: T;
    };
  };
  bookingAssistant: {
    /**
     * @default 'Explore More Hotels'
     */
    cta: T;

    /**
     * @default 'Browse more hotels with our special rates'
     */
    title: T;
  };

  /**
   * @default '👀 {{count}} people looking'
   */
  peopleCurrentlyViewing: T;

  /**
   * @default '{{count}} Guests Currently Looking At This Hotel'
   */
  peopleCurrentlyViewingTooltipTitle: T;

  /**
   * @default 'Rooms are filling up fast. Don’t miss the chance to get exclusive rates for Joy guests.'
   */
  peopleCurrentlyLookingTooltipBody: T;

  photoGallery: {
    emptyState: {
      /**
       * @default 'This album is currently set to Hidden, so your guests won’t be able to see it. You can change its visibility by setting it to Public to make it visible.'
       */
      content: T;
    };
  };
  joyPlacePricingMobile: {
    /**
     * @default 'Total'
     */
    total: T;

    /**
     * @default '/ night'
     */
    perNight: T;

    /**
     * @default '{{percent}}% Off'
     */
    percentageOff: T;

    /**
     * @default '2 nights, 1 room, incl. taxes and fees'
     */
    nightsStay: T;
  };
  reminderModal: {
    /**
     * @default 'Not ready to book?'
     */
    title: T;

    /**
     * @default 'Set a reminder to come back later.'
     */
    subtitle: T;

    tabs: {
      /**
       * @default 'Text'
       */
      text: T;

      /**
       * @default 'Email'
       */
      email: T;
    };

    /**
     * @default 'Send Reminder'
     */
    sendReminder: T;

    /**
     * @default 'Email'
     */
    emailLabel: T;

    /**
     * @default 'your@email.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Please enter a valid email address'
     */
    emailErrorText: T;

    /**
     * @default 'Set Reminder'
     */
    setReminder: T;

    /**
     * @default 'No, Thanks'
     */
    noThanks: T;

    /**
     * @default 'By proceeding, you confirm that you have read and agree to Joy’s <terms/> and <privacyPolicy/>.'
     */
    consentTextEmail: T;

    /**
     * @default 'Terms'
     */
    terms: T;

    /**
     * @default 'Privacy Policy'
     */
    privacyPolicy: T;

    durationOptions: {
      /**
       * @default 'in 1 week'
       */
      '1week': T;

      /**
       * @default 'in 2 weeks'
       */
      '2weeks': T;

      /**
       * @default 'in 3 weeks'
       */
      '3weeks': T;

      /**
       * @default 'in 4 weeks'
       */
      '4weeks': T;

      /**
       * @default 'in 5 weeks'
       */
      '5weeks': T;

      /**
       * @default 'in 6 weeks'
       */
      '6weeks': T;
    };
    success: {
      /**
       * @default 'All done!'
       */
      title: T;

      subtitle: {
        /**
         * @default 'We'll send you a reminder in {{count}} week.'
         * @param {number} count - The number of occurrences.
         * - singular: We'll send you a reminder in {{count}} week.
         * - plural: We'll send you a reminder in {{count}} weeks.
         */
        text: T;
      };

      /**
       * @default 'Done'
       */
      doneButton: T;
    };
  };
  quick: {
    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default '{{0}} walk'
     */
    pVA2E: T;

    /**
     * @default '{{0}} drive'
     */
    '8pImk': T;

    /**
     * @default 'See Availability'
     */
    '2ZFEq': T;

    /**
     * @default 'Explore Hotels Nearby'
     */
    F3uMA: T;

    /**
     * @default 'Select'
     */
    YS91U: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;
  };
};

export type GuestSiteTravelTranslations<T extends LeafNodeValue = TranslateFunction> = {
  booking: {
    /**
     * @default 'Suggested Stay:'
     */
    suggestedStayDatesTitle: T;

    /**
     * @default 'Search'
     */
    searchButtonTitle: T;

    /**
     * @default 'Guests'
     */
    guestOptionPlural: T;

    /**
     * @default 'Guest'
     */
    guestOptionSingle: T;

    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;
  };
  hertzWidget: {
    /**
     * @default 'For Our Guests: Rental Car Savings'
     */
    offerTitle: T;

    /**
     * @default 'Search Rental Cars'
     */
    ctaLabel: T;

    /**
     * @default 'Provided by'
     */
    providedBy: T;
  };
  accommodationLink: {
    /**
     * @default 'For more information on where to stay'
     */
    linkText: T;

    /**
     * @default 'More'
     */
    readMore: T;

    /**
     * @default 'Less'
     */
    readLess: T;
  };
  interceptorRedirectDialog: {
    /**
     * @default '{{hotelName}} isn’t available for your dates.'
     */
    titleWithHotelName: T;

    /**
     * @default 'This hotel isn’t available for your dates.'
     */
    title: T;

    /**
     * @default 'We’ve found similar hotels nearby with availability — some up to 40% off per night. You can also return to the list of hotels recommended by your host.'
     */
    accommodationPlaceContent: T;

    /**
     * @default 'We’ve found similar hotels nearby with the best prices — up to 40% off per night.'
     */
    content: T;

    /**
     * @default 'Search Similar Stays'
     */
    acceptCta: T;

    /**
     * @default 'See Nearby Hotels'
     */
    seeNearbyHotels: T;

    /**
     * @default 'Not Interested'
     */
    declineCta: T;

    /**
     * @default 'Back to Host's Hotel List'
     */
    backToHostsHotelList: T;
  };
};

export type GuestSiteWelcomeTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'View Details'
   */
  viewDetails: T;

  quick: {
    /**
     * @default 'View Details'
     */
    zvlhe: T;
  };
};

export type GuestUnlockTranslations<T extends LeafNodeValue = TranslateFunction> = {
  unlockForm: {
    /**
     * @default 'Let’s find your invitation...'
     */
    title: T;

    /**
     * @default 'Enter the password you received from your host.'
     */
    subtitle: T;

    /**
     * @default 'Password'
     */
    passwordLabel: T;

    /**
     * @default 'e.g. abc123'
     */
    passwordPlaceholder: T;

    /**
     * @default 'Unlock'
     */
    submitButtonText: T;

    /**
     * @default 'Ask the Host'
     */
    contactButtonText: T;

    /**
     * @default 'Sign In'
     */
    signInButtonText: T;

    /**
     * @default 'Incorrect password. Please check that you typed the password correctly or try copying and pasting.'
     */
    incorrectPassText: T;

    /**
     * @default 'Password is required'
     */
    required: T;
  };
  findInviteForm: {
    /**
     * @default 'Let’s find your invitation'
     */
    title: T;

    /**
     * @default 'Enter your name to get your event schedule.'
     */
    subtitle: T;

    /**
     * @default 'First name'
     */
    firstNameLabel: T;

    /**
     * @default 'Last name'
     */
    lastNameLabel: T;

    /**
     * @default 'e.g. Sarah'
     */
    firstNamePlaceholder: T;

    /**
     * @default 'e.g. Smith'
     */
    lastNamePlaceholder: T;

    /**
     * @default 'Find Invitation'
     */
    submitButtonText: T;

    /**
     * @default 'Searching...'
     */
    loadingButtonText: T;

    /**
     * @default '{{firstName}} {{lastName}} is not on the guest list. Try an alternative spelling or nickname. You can still view the public schedule.'
     */
    notFoundErrorText: T;

    /**
     * @default 'All fields are required'
     */
    required: T;
  };
  verifyEmailForm: {
    /**
     * @default 'Enter your email'
     */
    title: T;

    /**
     * @default 'We found multiple guests with the name {{firstName}} {{lastName}}. Please provide your email to confirm your identity.'
     */
    subtitle: T;

    /**
     * @default 'Email (Only visible to the host)'
     */
    emailLabel: T;

    /**
     * @default 'Find Invitation'
     */
    submitButtonText: T;

    /**
     * @default 'Searching...'
     */
    loadingButtonText: T;

    /**
     * @default 'We couldn’t find {{firstName}} {{lastName}} with that email on the guest list. Please try another email address.'
     */
    notFoundErrorText: T;

    /**
     * @default 'Email is required'
     */
    required: T;

    /**
     * @default 'e.g. sarahsmith@example.com'
     */
    inputPlaceholder: T;
  };
  findInviteSuccessForm: {
    /**
     * @default 'Welcome {{firstName}}!'
     */
    title: T;

    /**
     * @default 'You’ve unlocked guest-only details.'
     */
    subtitle: T;

    /**
     * @default 'Explore the Event'
     */
    submitButtonText: T;
  };
  askHostForm: {
    /**
     * @default 'Ask the host'
     */
    title: T;

    /**
     * @default 'Tell the host who you are, so they can email you back with their event password.'
     */
    subtitle: T;

    /**
     * @default 'Your Full Name'
     */
    fullNameLabel: T;

    /**
     * @default 'Your Email'
     */
    emailLabel: T;

    /**
     * @default 'e.g. Sarah Smith'
     */
    namePlaceholder: T;

    /**
     * @default 'e.g. sarahsmith@example.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Send Request'
     */
    submitButtonText: T;

    /**
     * @default 'Sending...'
     */
    loadingButtonText: T;

    /**
     * @default 'All fields are required'
     */
    required: T;

    /**
     * @default 'Please enter a valid email'
     */
    validEmailWarning: T;
  };
  askHostSuccessForm: {
    /**
     * @default 'Your message has been sent'
     */
    title: T;

    /**
     * @default 'We’ve sent the host an email letting them know you’ve requested their event password.'
     */
    subtitle: T;

    /**
     * @default 'Return to Site'
     */
    submitButtonText: T;
  };
  quick: {
    /**
     * @default 'Password’s required'
     */
    '8U1Bi': T;

    /**
     * @default 'Wrong password. Double-check what you’ve typed, or try copying and pasting.'
     */
    ncD4c: T;

    /**
     * @default 'Private Event'
     */
    bLwtK: T;

    /**
     * @default 'Use the password shared by your host to see event details. '
     */
    eIQH6: T;

    /**
     * @default 'Need it?'
     */
    c8fBa: T;

    /**
     * @default 'Ask the Host'
     */
    u4Kzl: T;

    /**
     * @default 'Event Password'
     */
    '9SjQp': T;

    /**
     * @default 'eg. xy4686'
     */
    X0zlv: T;

    /**
     * @default 'View Event'
     */
    '5WK5D': T;

    /**
     * @default 'Sign In'
     */
    M4Z7E: T;
  };
};

export type GuestVacationRentalsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Explore Vacation Rentals'
     */
    JCygg: T;
  };
};

export type HeaderHelpMenuTranslations<T extends LeafNodeValue = TranslateFunction> = {
  menuItems: {
    /**
     * @default 'Leave a Suggestion'
     */
    suggestion: T;

    /**
     * @default 'Contact Support'
     */
    support: T;

    /**
     * @default 'Help Guides'
     */
    help: T;
  };
};

export type HeaderLayoutUpgradeTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Video Background Thumbnail'
     */
    JDUZb: T;

    /**
     * @default 'Upgrade for $9.90'
     */
    FhIoA: T;

    /**
     * @default 'No thanks, turn off video header'
     */
    GiRqs: T;

    /**
     * @default 'All Done'
     */
    Dc3ZI: T;

    /**
     * @default 'Make Your Site Come to Life with Video Background!'
     */
    '5aOWx': T;

    /**
     * @default 'Yay! You’ve been selected for a free upgrade to video background.'
     */
    '8xQjm': T;

    /**
     * @default 'Pick your favorite from variety of video background options, or upload your own video to make the site uniquely yours.'
     */
    VidK0: T;

    /**
     * @default 'Congrats, you're now able to use the premium video background.'
     */
    rZvmC: T;

    /**
     * @default 'Something went wrong. Please try again later.'
     */
    UzWaL: T;

    /**
     * @default 'Your website is published without the video background'
     */
    '0tyBH': T;

    /**
     * @default 'Upgrade Now'
     */
    ChNFF: T;

    /**
     * @default 'Make your site come to life with a video background!'
     */
    q0XKf: T;

    /**
     * @default 'We appreciate you - enjoy this free upgrade.'
     */
    FIPZp: T;

    /**
     * @default 'Want to keep this stunning video design? Upgrade now to make your website truly stand out.'
     */
    roPhT: T;

    /**
     * @default 'Our premium feature (worth $9.90) is yours at no cost. Thank you for choosing Joy.'
     */
    zjMd3: T;

    /**
     * @default '💎 Feeling Fancy?'
     */
    zdFLi: T;

    /**
     * @default 'Make your site come to life with a stunning video background!'
     */
    Cno2F: T;

    /**
     * @default 'Upgrade for only $9.90 →'
     */
    rMvD2: T;
  };
};

export type HostBannersTranslations<T extends LeafNodeValue = TranslateFunction> = {};

export type HotelBlockTranslations<T extends LeafNodeValue = TranslateFunction> = {
  leadGenerationForm: {
    /**
     * @default 'Destination'
     */
    destination: T;

    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;

    /**
     * @default 'Rooms Per Night'
     */
    roomsPerNight: T;

    /**
     * @default 'Full Name'
     */
    fullName: T;

    /**
     * @default 'Email Address'
     */
    email: T;

    /**
     * @default 'Who should we contact?'
     */
    sendQuotes: T;

    /**
     * @default 'Continue'
     */
    cont: T;

    /**
     * @default 'Your full name will help us know who to contact.'
     */
    fullNameError: T;

    /**
     * @default 'Please share your email address.'
     */
    emailError: T;

    /**
     * @default 'Please select the number of rooms per night.'
     */
    numberRoomsError: T;

    /**
     * @default 'Search for a city or venue for your event.'
     */
    locationError: T;

    /**
     * @default 'Add a check in date.'
     */
    checkInDateError: T;

    /**
     * @default 'Add a check out date.'
     */
    checkOutDateError: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    checkInDateRangeError: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    checkOutDateRangeError: T;

    /**
     * @default 'Search for a city or venue'
     */
    locationPlaceholder: T;

    /**
     * @default 'Add a date'
     */
    datePlaceholder: T;

    /**
     * @default 'Choose your best estimate'
     */
    numberRoomsPlaceholder: T;

    /**
     * @default 'Almost Done!'
     */
    almostDone: T;

    /**
     * @default 'Get the best hotel rates by answering a few more optional questions below.'
     */
    additionalInfoTitle: T;

    /**
     * @default 'Any additional details we should know?'
     */
    additionalInfoSubtext: T;

    /**
     * @default 'You can tell us about hotel brand preferences, any special needs, or even specific neighborhoods.'
     */
    notePlaceholder: T;

    /**
     * @default 'How would you like to be contacted?'
     */
    howContacted: T;

    /**
     * @default 'Your phone number is kept confidential and not shared with other parties. SMS data rates apply.'
     */
    confidential: T;

    /**
     * @default 'Phone Number'
     */
    phoneLabel: T;

    /**
     * @default 'Interested in scheduling a call with our concierge team?'
     */
    scheduleCall: T;

    /**
     * @default 'Select a date and time'
     */
    scheduleCallCTA: T;

    /**
     * @default 'Concierge Call Confirmed'
     */
    callConfirmed: T;

    /**
     * @default 'Finish'
     */
    finishCTA: T;

    /**
     * @default 'All Set!'
     */
    allSet: T;

    /**
     * @default 'A member of our concierge team will contact you.'
     */
    allSetText: T;

    /**
     * @default 'An error occurred while submitting your request. Please try again.'
     */
    submitError: T;

    /**
     * @default 'Please share your cell phone number.'
     */
    smsRequiredError: T;

    /**
     * @default 'Please select a convenient time slot.'
     */
    timeSlotRequiredError: T;
  };
  smsGenerationForm: {
    /**
     * @default 'Success!'
     */
    successTitle: T;

    /**
     * @default 'A member of our concierge team will text you within 48 hours.'
     */
    successDescription: T;

    /**
     * @default 'Unlock group hotel rates delivered right to your phone.'
     */
    title: T;

    /**
     * @default 'Our concierge team will text you within 48 hours.'
     */
    description: T;

    /**
     * @default 'Phone Number'
     */
    inputPhoneLabel: T;

    /**
     * @default 'Text Me'
     */
    buttonConfirm: T;

    /**
     * @default 'Your phone number is kept confidential and not shared with other parties.'
     */
    buttonConfirmLabel: T;

    /**
     * @default 'Or share your hotel preferences now and get started.'
     */
    labelForm: T;

    /**
     * @default 'Get Started Now'
     */
    buttonForm: T;

    /**
     * @default 'Please share your cell phone number.'
     */
    inputRequired: T;
  };
  hotelBookingSubmissionSuccess: {
    /**
     * @default 'Success!'
     */
    successTitle: T;

    /**
     * @default 'A member of our concierge team will get back to you.'
     */
    successDescription: T;
  };
  hotelSelection: {
    informativeDialog: {
      /**
       * @default 'What happens next?'
       */
      title: T;

      /**
       * @default 'Select hotels near your venue and let our concierge team do the work of negotiating discounted rates.'
       */
      item1: T;

      /**
       * @default 'Review your personalized hotel group rates with your personal concierge and select your favorite hotel for your guests.'
       */
      item2: T;

      /**
       * @default 'View Hotels'
       */
      btn: T;
    };
    addManuallyHotelDialog: {
      /**
       * @default 'Manually add hotel'
       */
      title: T;

      /**
       * @default 'Hotel'
       */
      inputHotelTitle: T;

      /**
       * @default 'Find Hotel'
       */
      inputHotelPlaceholder: T;

      /**
       * @default 'URL'
       */
      inputHotelLocationTitle: T;

      /**
       * @default 'company.com'
       */
      inputHotelLocationPlaceholder: T;

      /**
       * @default 'Add Hotel'
       */
      btn: T;
    };
    confirmationDialog: {
      /**
       * @default 'Are you sure you want to continue?'
       */
      title: T;

      /**
       * @default 'You can add up to five hotels to your group rate request.'
       */
      subtitle: T;

      /**
       * @default 'Confirm Hotels'
       */
      btn: T;
    };
    list: {
      search: {
        /**
         * @default 'Event Venue or Destination'
         */
        location: T;

        /**
         * @default 'Near'
         */
        near: T;

        /**
         * @default '{{roomBlocks}} Room Blocks'
         */
        roomBlocks: T;

        /**
         * @default 'Destination or Hotel'
         */
        locationV2: T;

        /**
         * @default 'Check in'
         */
        checkIn: T;

        /**
         * @default 'Check out'
         */
        checkOut: T;

        /**
         * @default '{{startDate}} - {{endDate}}'
         */
        dateRange: T;

        /**
         * @default 'Search for a city or venue for your event.'
         */
        locationError: T;

        /**
         * @default 'Add a check in date.'
         */
        checkInDateError: T;

        /**
         * @default 'Add a check out date.'
         */
        checkOutDateError: T;

        /**
         * @default 'Check in date must be before check out date'
         */
        checkInDateRangeError: T;

        /**
         * @default 'Check out date must be after check in date'
         */
        checkOutDateRangeError: T;

        /**
         * @default 'Central Park Boathouse'
         */
        locationPlaceholder: T;

        /**
         * @default 'Date'
         */
        datePlaceholder: T;

        /**
         * @default 'Search'
         */
        searchCTA: T;
      };
      hotelList: {
        /**
         * @default 'Select Your Hotels'
         */
        selectHotels: T;

        /**
         * @default 'Show More'
         */
        showMore: T;

        /**
         * @default 'Top Picks'
         */
        filterPopularity: T;

        /**
         * @default 'Distance'
         */
        filterDistance: T;
      };
      hotelItem: {
        /**
         * @default 'Add Hotel'
         */
        addHotelTxt: T;

        /**
         * @default 'miles away'
         */
        distance: T;

        /**
         * @default 'Remove'
         */
        removeHotelTxt: T;

        /**
         * @default 'Interested Property'
         */
        interestedLabel: T;

        /**
         * @default 'Couple Favorite'
         */
        preferredHotelTooltipTitle: T;

        /**
         * @default 'Get a room block with one of Joy's partner hotels and get the best group rates fast. We hand picked these properties based on reviews from other Joy couples, competitive rates, and a great fit for larger groups.'
         */
        preferredHotelTooltipDescription: T;

        /**
         * @default 'Couple Favorite'
         */
        preferredHotelMobileViewLabel: T;
      };
      hotelCart: {
        /**
         * @default 'Confirm Hotels'
         */
        btnConfirm: T;

        /**
         * @default 'Your Hotels'
         */
        yourHotels: T;

        /**
         * @default '{{hotelsCount}} of {{maxHotels}}'
         */
        hotelsCountLabel: T;

        /**
         * @default 'Add your first hotel!'
         */
        noHotels: T;

        /**
         * @default 'You can add a maximum of 5 hotels.'
         */
        onlyFive: T;
      };
      addManuallyBanner: {
        /**
         * @default 'Manually Add Hotel'
         */
        addHotelManually: T;

        /**
         * @default 'Not finding what you’re looking for?'
         */
        label: T;
      };
      noResults: {
        /**
         * @default 'Sorry, no results found.'
         */
        label: T;

        /**
         * @default 'Update your search area to see hotel options.'
         */
        eyeBrow: T;
      };
      noItem: {
        /**
         * @default 'Not finding what you’re looking for?'
         */
        label: T;

        /**
         * @default 'Manually Add Hotel'
         */
        manualAddCTA: T;

        /**
         * @default 'Contact Concierge Team'
         */
        buttonCTA: T;

        /**
         * @default 'Chat'
         */
        intercomButtonCTA: T;
      };
      addManuallyDialog: {
        /**
         * @default 'Manually add hotel'
         */
        title: T;

        /**
         * @default 'Search for hotels'
         */
        label: T;

        /**
         * @default 'Hotel Name'
         */
        placeholder: T;

        /**
         * @default 'Add Hotel'
         */
        addHotelCTA: T;

        /**
         * @default 'Remove Hotel'
         */
        removeHotelCTA: T;
      };
    };
  };
  hotelConfirmation: {
    /**
     * @default 'Confirm and Request Rates'
     */
    title: T;

    /**
     * @default 'Review and request rates'
     */
    titleV2: T;

    /**
     * @default 'Request Hotel Rates'
     */
    buttonCTA: T;

    /**
     * @default 'City or Venue'
     */
    location: T;

    /**
     * @default 'Hotel Search Area'
     */
    hotelSearchArea: T;

    personalDetailSection: {
      /**
       * @default 'Personal Details'
       */
      header: T;

      /**
       * @default 'Partner One'
       */
      partnerOneHeader: T;

      /**
       * @default 'Partner Two'
       */
      partnerTwoHeader: T;

      /**
       * @default 'First Name'
       */
      firstNamePlaceholder: T;

      /**
       * @default 'Last Name'
       */
      lastNamePlaceholder: T;
    };

    /**
     * @default 'Event Name'
     */
    requestName: T;

    /**
     * @default 'your@email.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Dates'
     */
    dates: T;

    /**
     * @default 'Add a date'
     */
    datePlaceholder: T;

    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;

    /**
     * @default 'We don’t have a venue (yet)'
     */
    venueNotSelectedCheckBoxText: T;

    /**
     * @default 'Venue Name'
     */
    venueNamePlaceholder: T;

    /**
     * @default 'Address'
     */
    venueAddressPlaceholder: T;

    /**
     * @default 'Venue Address'
     */
    venueAddressTitle: T;

    /**
     * @default 'Please enter a venue address to help us find your properties.'
     */
    venueAddressFieldError: T;

    /**
     * @default 'Please enter a location to help us find your properties.'
     */
    hotelSearchAreaFieldError: T;

    /**
     * @default 'Please share your venue address to help us locate the most relevant properties for your guests.'
     */
    venueAddressTooltipText: T;

    /**
     * @default 'Search for a city or venue for your event.'
     */
    locationError: T;

    /**
     * @default 'Add a check in date.'
     */
    checkInDateError: T;

    /**
     * @default 'Add a check out date.'
     */
    checkOutDateError: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    checkInDateRangeError: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    checkOutDateRangeError: T;

    /**
     * @default 'Search for a city or venue'
     */
    locationPlaceholder: T;

    /**
     * @default 'Additional Notes'
     */
    additionalNotes: T;

    /**
     * @default 'You can tell us about hotel brand preferences, any special needs, or even specific neighborhoods you like.'
     */
    additionalNotesText: T;

    /**
     * @default 'Your Contact Details'
     */
    contact: T;

    /**
     * @default 'Contact Preference'
     */
    contactPreference: T;

    /**
     * @default 'Please enter a valid phone number.'
     */
    invalidPhoneNumberError: T;

    /**
     * @default 'How would you like us to contact you?'
     */
    contactYou: T;

    /**
     * @default 'How would you like to receive your rates?'
     */
    howWouldYouLikeToRecieveRates: T;

    /**
     * @default 'Please select a convenient time slot.'
     */
    contactError: T;

    /**
     * @default 'Please provdie a phone number.'
     */
    contactPhoneError: T;

    /**
     * @default 'Phone Number'
     */
    phoneNumber: T;

    /**
     * @default 'Please select the number of rooms per night.'
     */
    numberRoomsError: T;

    /**
     * @default 'Choose your best estimate'
     */
    numberRoomsPlaceholder: T;

    /**
     * @default 'Mininum is 10'
     */
    minNumberRoomsError: T;

    /**
     * @default 'Maximum is 999'
     */
    maxNumberRoomsError: T;

    /**
     * @default 'Must be a number'
     */
    mustBeNumberRoomsError: T;

    /**
     * @default 'More than 50'
     */
    moreThanFifty: T;

    /**
     * @default 'Estimated Rooms Per Night'
     */
    roomsPerNight: T;

    /**
     * @default 'You can change this later.'
     */
    roomsPerNightSubtitle: T;

    /**
     * @default 'Schedule a call'
     */
    scheduleCall: T;

    /**
     * @default 'Text Message'
     */
    textMessage: T;

    /**
     * @default 'Concierge Call Confirmed'
     */
    callConfirmed: T;

    /**
     * @default 'Phone Number'
     */
    phoneLabel: T;

    /**
     * @default 'Choose a slot that suits you.'
     */
    timeSlotLabel: T;

    /**
     * @default 'Select a date and time'
     */
    scheduleCallCTA: T;

    /**
     * @default 'Please add a name for your event.'
     */
    eventNameError: T;

    /**
     * @default 'Please add a first name for partner one.'
     */
    partnerOneFirstNameError: T;

    /**
     * @default 'Please add a last name for partner one.'
     */
    partnerOneLastNameError: T;

    /**
     * @default 'Please add a first name for partner two.'
     */
    partnerTwoFirstNameError: T;

    /**
     * @default 'Please add a last name for partner two.'
     */
    partnerTwoLastNameError: T;

    /**
     * @default 'Your phone number is kept confidential and not shared with other parties. SMS data rates apply.'
     */
    confidential: T;

    /**
     * @default 'Your Hotels'
     */
    yourHotels: T;

    /**
     * @default 'Edit'
     */
    changeCTA: T;

    /**
     * @default 'An error occurred while submitting your request. Please try again.'
     */
    submitError: T;

    /**
     * @default 'An error occurred while submitting your request. Please refresh the page and try again'
     */
    authError: T;

    /**
     * @default 'Please share your cell phone number.'
     */
    smsRequiredError: T;

    /**
     * @default 'Please select a convenient time slot.'
     */
    timeSlotRequiredError: T;

    /**
     * @default 'Remove'
     */
    remove: T;

    /**
     * @default 'Hotel image'
     */
    hotelImage: T;

    /**
     * @default 'We suggest considering both out-of-town and in-town guests when calculating the number of rooms needed per night.'
     */
    tooltipText: T;

    /**
     * @default 'Please share a location to help us locate the most relevant properties for your guests.'
     */
    hotelSearchAreaTooltipText: T;

    /**
     * @default 'You need at least one accommodation to submit your rate request.'
     */
    minimumShortlistError: T;

    /**
     * @default 'Email'
     */
    contactViaEmail: T;

    /**
     * @default 'Email Address'
     */
    emailAddress: T;

    /**
     * @default 'Please share your email address.'
     */
    emailError: T;

    /**
     * @default 'Name'
     */
    fullName: T;

    /**
     * @default 'John Smith'
     */
    fullNamePlaceholder: T;

    /**
     * @default 'Your full name will help us know who to contact.'
     */
    fullNameError: T;

    informativeBox: {
      /**
       * @default 'You're just a step away from our free hotel concierge service!'
       */
      title: T;

      /**
       * @default 'Joy concierge does the work so you don’t have to.'
       */
      item1: T;

      /**
       * @default 'Exclusively negotiated discounts up to 30% off.'
       */
      item2: T;

      /**
       * @default 'Hotel perks and upgrades.'
       */
      item3: T;
    };
  };
  hotelAdmin: {
    /**
     * @default 'Room Blocks'
     */
    menu: T;

    /**
     * @default 'Request Submitted!'
     */
    title: T;

    /**
     * @default 'Our concierge team is working with our hotel partners to secure the best group rates possible. We'll contact you via your preferred channel once we have all the details. 🌟'
     */
    subTitle: T;

    /**
     * @default 'Event Name'
     */
    eventName: T;

    /**
     * @default 'City or Venue'
     */
    location: T;

    /**
     * @default 'Hotel Dates'
     */
    hotelDates: T;

    /**
     * @default 'Rooms Requested'
     */
    roomsRequested: T;

    /**
     * @default 'Additional Details'
     */
    additionalDetails: T;

    /**
     * @default 'Need Help? Contact Our Team'
     */
    helpText: T;

    /**
     * @default 'Email Us'
     */
    emailUsCta: T;

    /**
     * @default 'Chat Now'
     */
    chatNowCta: T;
  };
  hotelRoomBlockFunnel: {
    /**
     * @default 'Room Blocks'
     */
    menu: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Event Name'
     */
    eventName: T;

    /**
     * @default 'City or Venue'
     */
    location: T;

    /**
     * @default 'Hotel Dates'
     */
    hotelDates: T;

    /**
     * @default 'Chat with us'
     */
    headerChat: T;

    /**
     * @default 'Chat'
     */
    headerChatMobile: T;

    /**
     * @default 'Rooms Requested'
     */
    roomsRequested: T;

    /**
     * @default 'Additional Details'
     */
    additionalDetails: T;

    /**
     * @default 'We’re working on getting you the best deals.'
     */
    subTitleV2: T;

    /**
     * @default 'Rates are coming in slower than expected but rest assure they’re coming.'
     */
    slowProgressInfoMessage: T;

    /**
     * @default 'Need Changes Made?'
     */
    conciergeMemberDetailsCardHeader: T;

    /**
     * @default '🙌 At your service!'
     */
    atYourService: T;

    /**
     * @default 'Joy concierge team is here to assist you'
     */
    conciergeMemberNotAvailableCardText: T;

    /**
     * @default 'Chat with Concierge'
     */
    chatWithConcierge: T;

    heading: {
      /**
       * @default 'Your search has begun!'
       */
      workingOnRequest: T;

      /**
       * @default 'We’re reaching out to your hotels.'
       */
      gettingTheBestRates: T;

      /**
       * @default 'Success! We got great rates!'
       */
      ratesReadyForReview: T;

      /**
       * @default 'Your hotel are almost ready.'
       */
      finalizingHotelDeals: T;
    };
    info: {
      /**
       * @default 'We’re assigning your hotel requests to one of our concierge to help you throughout this process. Leave it up to us!'
       */
      workingOnRequest: T;

      /**
       * @default 'We’re working on getting you the best deals. The typical request takes 6 days. We’ll contact you when your rates are ready.'
       */
      gettingTheBestRates: T;

      /**
       * @default 'We’ve received hotel offers and they’re ready for you to review.'
       */
      ratesReadyForReview: T;

      /**
       * @default 'We’re crossing t’s and dotting i’s to make sure your deals are locked in. Your guests will soon have the best deals.'
       */
      finalizingHotelDeals: T;
    };
    progressBarStates: {
      /**
       * @default 'Working on'
       */
      workingOnRequestPart1: T;

      /**
       * @default 'request'
       */
      workingOnRequestPart2: T;

      /**
       * @default 'Getting the'
       */
      gettingTheBestRatesPart1: T;

      /**
       * @default 'Best Rates'
       */
      gettingTheBestRatesPart2: T;

      /**
       * @default 'Rates Ready'
       */
      ratesReadyForReviewPart1: T;

      /**
       * @default 'for Review'
       */
      ratesReadyForReviewPart2: T;

      /**
       * @default 'Finalizing'
       */
      finalizingHotelDetailsPart1: T;

      /**
       * @default 'Hotels Deals'
       */
      finalizingHotelDetailspart2: T;

      /**
       * @default 'Time to'
       */
      timeToPartyParty1: T;

      /**
       * @default 'Party!'
       */
      timeToPartyParty2: T;
    };
  };
  headerSection: {
    /**
     * @default 'Hotels'
     */
    headerTitle: T;

    /**
     * @default 'Help'
     */
    help: T;
  };
  hotelBlockV4: {
    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Hotels'
     */
    headerTitle: T;

    /**
     * @default 'Chat with us'
     */
    headerChat: T;

    /**
     * @default 'Chat'
     */
    headerChatMobile: T;

    /**
     * @default 'Request discounted rates for hotels near your venue.'
     */
    headerSubtitle: T;

    /**
     * @default 'Find Your Perfect Wedding Stay'
     */
    header: T;

    /**
     * @default 'We unlock exclusive rates by bringing together the bargaining power of all Joy couples.'
     */
    headerSubtitleV2: T;

    /**
     * @default 'Potential Hotels Near Your Destination'
     */
    title: T;

    /**
     * @default 'Load More Hotels'
     */
    btnLoadMore: T;

    /**
     * @default 'Introducing Group Reservations with Joy'
     */
    valuePropHeaderEyeBrow: T;

    /**
     * @default 'Take care of your guests with great rates and no fees.'
     */
    valuePropHeaderTitle: T;

    /**
     * @default 'Your personal Joy concierge agent will help you get the best room block rates for you and your guests.'
     */
    valuePropHeaderSubtitle: T;

    /**
     * @default 'Save up to 30% Off Room Rates'
     */
    valuePropOneTitle: T;

    /**
     * @default 'Zero Deposit Requirements'
     */
    valuePropTwoTitle: T;

    /**
     * @default 'Dedicated Concierge'
     */
    valuePropThreeTitle: T;

    /**
     * @default 'Good to Know'
     */
    remindMeHeaderEyeBrow: T;

    /**
     * @default '86% of Joy couples share hotels with their guests.'
     */
    remindMeHeaderTitle: T;

    /**
     * @default 'When do you wish to begin selecting your hotels?'
     */
    remindMeTitle: T;

    /**
     * @default 'We’ll help you get started with your hotel search on time.'
     */
    remindMeSubtitle: T;

    /**
     * @default 'Remind me in 2 weeks.'
     */
    remindMeOpt1: T;

    /**
     * @default 'Remind me in 4 weeks'
     */
    remindMeOpt2: T;

    /**
     * @default 'Remind me in 8 weeks'
     */
    remindMeOpt3: T;

    /**
     * @default 'Set a Reminder'
     */
    remindMeBtn: T;

    /**
     * @default 'An error occurred while submitting your request. Please try again.'
     */
    submitError: T;

    /**
     * @default 'An error occurred while submitting your request. Please refresh the page and try again.'
     */
    authError: T;

    /**
     * @default 'Thank You!'
     */
    reminderThankYouTitle: T;

    /**
     * @default 'your email address'
     */
    reminderThankYouEmailText: T;

    /**
     * @default 'We’ll send you an email reminder at <Email/> in {{reminderSelected}}'
     */
    reminderThankYouMessage: T;
  };
  hotelShortlistingFlowSelection: {
    /**
     * @default 'Hotels'
     */
    menu: T;

    /**
     * @default 'Chat with us'
     */
    headerChat: T;

    /**
     * @default 'Chat'
     */
    headerChatMobile: T;

    /**
     * @default 'Tailor Your Hotel Choices'
     */
    title: T;

    /**
     * @default 'You can request discounted rates through our free concierge service or simply add hotels without discounts'
     */
    subTitle: T;

    /**
     * @default 'Request discounted rates through our free concierge service or directly add the hotels to your website.'
     */
    subTitleV2: T;

    /**
     * @default 'Most Popular'
     */
    popularCardTitleLabel: T;

    /**
     * @default 'Back'
     */
    titleBack: T;

    /**
     * @default 'An error occurred while adding your hotels to your website.'
     */
    hotelAdditioinErrorMessage: T;

    withoutDiscountCard: {
      /**
       * @default 'Hotels Only'
       */
      title: T;

      /**
       * @default 'Your selected hotels will be automatically added to your website.'
       */
      subTitle: T;

      /**
       * @default 'Add Hotels Only'
       */
      cta: T;
    };
    withDiscountCard: {
      /**
       * @default 'Hotel Room Blocks'
       */
      title: T;

      /**
       * @default 'Concierge will secure exclusive block rates at no cost. Hotels will be added to your website.'
       */
      subTitle: T;

      /**
       * @default 'Add Hotels With Room Blocks'
       */
      cta: T;

      /**
       * @default 'What is a room block'
       */
      footerCtaText: T;

      /**
       * @default 'A room block is a reservation of a grouping of rooms (typically 10 or more) that are usually at the same hotel.'
       */
      footerCtaHoverText: T;
    };
    cardPoints: {
      makeItEasyPoint: {
        /**
         * @default 'Make it easy'
         */
        title: T;

        /**
         * @default 'Share hotel options with guests on your website.'
         */
        description: T;
      };
      riskFreePoint: {
        /**
         * @default 'Risk-Free'
         */
        title: T;

        /**
         * @default 'No financial commitment required.'
         */
        description: T;
      };
      perksAndDiscountsPoint: {
        /**
         * @default 'Discounts & Perks'
         */
        title: T;

        /**
         * @default 'Get up to 30% off market rates and enjoy hotel upgrades.'
         */
        description: T;
      };
      personalizedConciergePoint: {
        /**
         * @default 'Free Concierge'
         */
        title: T;

        /**
         * @default 'We negotiate exclusive group booking rates so you don’t have to.'
         */
        description: T;
      };
    };
  };
  hotelShortlistingFlowReviewRequestAccommodations: {
    /**
     * @default 'Back'
     */
    titleBack: T;

    /**
     * @default 'We’ve added these hotels to your accommodations page!'
     */
    infoTextAccommodations: T;

    /**
     * @default 'Edit Accommodations Page'
     */
    editAccommodationsPageCTAText: T;

    /**
     * @default 'View Accommodations Page'
     */
    viewAccommodationsPageCTAText: T;
  };
  roomBlockManager: {
    /**
     * @default 'Your Room Blocks'
     */
    title: T;

    /**
     * @default 'Your room blocks are ready'
     */
    titleV2: T;

    /**
     * @default 'Share your booking link with guests. Help them get the best rates before they expire.'
     */
    subTitle: T;

    /**
     * @default 'Share your booking link with guests to ensure they get the best rates before they expire.'
     */
    subTitleV2: T;

    /**
     * @default 'Rate expires {{date}}'
     */
    rateExpires: T;

    /**
     * @default '{{rooms}} Rooms'
     */
    rooms: T;

    /**
     * @default 'night'
     */
    night: T;

    /**
     * @default 'Share Booking Link'
     */
    shareBookingLink: T;

    /**
     * @default 'Copy Hotel Booking Link'
     */
    copyBookingLink: T;

    /**
     * @default 'Need help or have questions?'
     */
    helpText: T;

    /**
     * @default 'Chat With Us'
     */
    chatWithUs: T;

    /**
     * @default '✨ Link Copied ✨'
     */
    copied: T;

    /**
     * @default '{{miles}} miles from the venue'
     */
    milesFromVenue: T;

    errorState: {
      /**
       * @default 'Something went wrong. We're unable to display your reserved room blocks right now.'
       */
      title: T;

      /**
       * @default 'You can still copy your hotels page link below and share with your guests.'
       */
      subTitle: T;

      /**
       * @default 'Copy Link'
       */
      copyLink: T;
    };

    /**
     * @default 'Room Block Cancelled'
     */
    roomBlockCancelled: T;

    contactCollector: {
      /**
       * @default 'Smart Tip'
       */
      smartTip: T;

      /**
       * @default 'Gather contacts and share your room block.'
       */
      title: T;

      /**
       * @default 'Easily gather guest info and share your room block with everyone on your list.'
       */
      text: T;

      /**
       * @default 'Gather Contacts'
       */
      cta: T;
    };
    progressBar: {
      roomsBooked: {
        /**
         * @default '{{numberRoomsGuestBooked}} Room Booked'
         */
        singular: T;

        /**
         * @default '{{numberRoomsGuestBooked}} Rooms Booked'
         */
        plural: T;
      };

      /**
       * @default '{{totalRoomsBooked}} Total'
       */
      totalRoomsBooked: T;
    };
  };
  roomBlockManagerIncentives: {
    /**
     * @default 'Unlock Joy perks when your guests book'
     */
    title: T;

    /**
     * @default 'Speak with your Joy concierge to unlock perks as you reach your booking milestones.'
     */
    subTitle: T;

    /**
     * @default 'Level 1: 40% Nights Filled  '
     */
    titleTierOne: T;

    /**
     * @default 'Claim one of the Joy perks below when your guests book 40% of your room block.'
     */
    subtitleTierOne: T;

    /**
     * @default 'Discounts on printed invitations and save the dates.'
     */
    subtitleTierOneNoRegistry: T;

    /**
     * @default '40% Discount on Printed Cards'
     */
    discountPrint: T;

    /**
     * @default '40% Off Printed Cards'
     */
    discountPrintV2: T;

    /**
     * @default '$50 Registry Gift Card'
     */
    registryGiftCard: T;

    /**
     * @default 'Learn More'
     */
    cta: T;

    /**
     * @default 'Level 2: 60% Nights Filled'
     */
    titleTierTwo: T;

    /**
     * @default 'Earn points towards your next reservation at participating US properties.'
     */
    subtitleTierTwo: T;

    /**
     * @default 'Available for room blocks at Marriott, Hilton, IHG, or Wyndham properties in the United States.'
     */
    tierTwoTooltip: T;

    /**
     * @default 'More Info'
     */
    moreInfo: T;

    /**
     * @default '15,000 Hotel Points'
     */
    hotelPoints: T;

    /**
     * @default 'Let your guests know about your room block:'
     */
    titleNextSteps: T;

    /**
     * @default 'Share your room block with your guests:'
     */
    titleNextStepsV2: T;

    /**
     * @default 'Add a note in your invitation or save the date'
     */
    nextStepOne: T;

    /**
     * @default 'Send a message to your guests'
     */
    nextStepTwo: T;

    /**
     * @default 'Add an announcement note on your website'
     */
    nextStepThree: T;

    /**
     * @default 'Nights Filled:'
     */
    titleV2: T;

    /**
     * @default 'Milestones:'
     */
    milestones: T;

    /**
     * @default 'Perk 1'
     */
    perkOne: T;

    /**
     * @default 'Perk 2'
     */
    perkTwo: T;

    /**
     * @default 'Learn more about Joy room block perks'
     */
    subtitleV2: T;

    /**
     * @default 'Room Block Perks'
     */
    subtitleV2Mobile: T;

    /**
     * @default 'Room Block Perks'
     */
    subtitleNoUtilData: T;

    /**
     * @default 'Perk 1: 40% Nights Filled'
     */
    titlePerkOne: T;

    /**
     * @default 'Send thank you notes and invitations to your guests.'
     */
    subtitlePerkOne: T;

    /**
     * @default 'Perk 2: 60% Nights Filled'
     */
    titlePerkTwo: T;

    /**
     * @default 'Claim one of the Joy perks below.'
     */
    subtitlePerkTwo: T;

    /**
     * @default 'Claim Perk'
     */
    claimPerkCta: T;

    printPerkDialog: {
      /**
       * @default 'You’ve unlocked {{percentageDiscount}}% off all printed cards from Joy.'
       */
      title: T;

      /**
       * @default 'We’re unable to retrieve your promo code at this time.'
       */
      titleError: T;

      /**
       * @default 'Excludes concierge premium prints.'
       */
      subtitle: T;

      /**
       * @default 'Please contact our concierge team if your continue to experience this issue.'
       */
      subtitleError: T;

      /**
       * @default 'Use this promo code at checkout:'
       */
      promoCodeHeader: T;

      /**
       * @default 'View Printed Cards'
       */
      cta: T;

      /**
       * @default 'Contact Concierge'
       */
      ctaError: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };
    registryPerkDialog: {
      /**
       * @default 'You’ve unlocked ${{dollarDiscount}} off a registry gift from Joy.'
       */
      title: T;

      /**
       * @default 'We’re unable to retrieve your promo code at this time.'
       */
      titleError: T;

      /**
       * @default 'Promo code is valid on orders of $75 or more, after promotions and discounts are applied. Excludes gift cards, cash funds, and gifts added to a Joy Registry from external stores and websites.'
       */
      subtitle: T;

      /**
       * @default 'Please contact our concierge team if your continue to experience this issue.'
       */
      subtitleError: T;

      /**
       * @default 'Use this promo code at checkout:'
       */
      promoCodeHeader: T;

      /**
       * @default 'View Registry'
       */
      cta: T;

      /**
       * @default 'Contact Concierge'
       */
      ctaError: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };

    /**
     * @default 'incentive'
     */
    incentive: T;
  };
  simplifiedLeadGenerationFlow: {
    landingPage: {
      /**
       * @default 'Get the list of the top hotels Joy couples have chosen near your venue.'
       */
      subTitle: T;

      /**
       * @default ' Learn how we make this list.'
       */
      learnMoreCtaText: T;

      infoList: [
        /**
         * @default 'Hotels which Joy couples pick for their wedding guests'
         */
        T,
        /**
         * @default 'Hotels that offer the deepest group discounts for weddings — sometimes up to 45% off'
         */
        T,
        /**
         * @default 'Hotels that gives most perks to Joy couples and their guests'
         */
        T,
      ];

      /**
       * @default 'Enter your venue to get your personalized list.'
       */
      locationSectionTitle: T;

      /**
       * @default 'Venue or location'
       */
      locationPlaceholder: T;

      /**
       * @default 'Please enter a location to help us find your properties.'
       */
      locationError: T;

      /**
       * @default 'Get It'
       */
      locationCtaText: T;

      learnMoreDialog: {
        /**
         * @default 'How does it work?'
         */
        title: T;

        /**
         * @default 'We’ve helped millions of couples around the world plan their weddings, and through that experience, we’ve gathered valuable insights into the best hotels for wedding guests. Here’s how we curate your personalized list:'
         */
        subTitle: T;

        listItems: [
          {
            /**
             * @default 'Anonymized Data Collection'
             */
            title: T;

            /**
             * @default 'We analyze anonymized data from all the weddings we’ve assisted with to identify the most popular hotels among couples who’ve used our platform.'
             */
            description: T;
          },
          {
            /**
             * @default 'Top Choices by Couples'
             */
            title: T;

            /**
             * @default 'We look at the hotels that Joy couples have consistently chosen for their wedding guests. These hotels have proven to be reliable, comfortable, and conveniently located near popular venues.'
             */
            description: T;
          },
          {
            /**
             * @default 'Best Group Discounts'
             */
            title: T;

            /**
             * @default 'We identify hotels that offer the deepest discounts for wedding room blocks. Some of our hotel partners offer savings of up to 45% off regular rates, ensuring your guests get great value.'
             */
            description: T;
          },
          {
            /**
             * @default 'Perks and Benefits'
             */
            title: T;

            /**
             * @default 'We also consider the perks that hotels have provided to our couples and their guests, such as complimentary breakfasts, late check-outs, or free parking.'
             */
            description: T;
          },
          {
            /**
             * @default 'Personalized Recommendations'
             */
            title: T;

            /**
             * @default 'By sharing your venue, we tailor the list to include hotels that are close by and have been popular among other Joy couples getting married in the same area.'
             */
            description: T;
          },
        ];

        /**
         * @default 'Our goal is to make sure you and your guests have an amazing stay while saving time and money on accommodations. We look forward to helping you!'
         */
        footerInfo: T;
      };
    };
    phoneNumberCollectionPage: {
      /**
       * @default 'Where shall we send your list?'
       */
      title: T;

      /**
       * @default 'We’ll send you a text with the most popular hotels near your venue in 3-5 business days.'
       */
      subTitle: T;

      /**
       * @default 'Phone Number'
       */
      phoneLabel: T;

      /**
       * @default 'We understand how frustrating marketing texts can be. Rest assured, we never share or sell your phone number to third parties.'
       */
      phoneNumberInfo: T;

      /**
       * @default 'SMS data rates may apply.'
       */
      dataRatesInfo: T;

      /**
       * @default 'Get The List'
       */
      submitPhoneNumberCtaText: T;

      /**
       * @default 'Please share your cell phone number.'
       */
      smsRequiredError: T;

      /**
       * @default 'Please enter a valid phone number.'
       */
      invalidPhoneNumberError: T;
    };
    confirmationPage: {
      /**
       * @default 'Thank you!'
       */
      titlePart1: T;

      /**
       * @default 'Our team is on it.'
       */
      titlePart2: T;

      /**
       * @default 'Look out for a text with your personalized recommendations in the coming days. Happy planning!'
       */
      note: T;

      /**
       * @default 'Back to Dashboard'
       */
      backToDashboardCtaText: T;
    };
  };
  quick: {
    /**
     * @default 'Wedding Venue'
     */
    R07CM: T;

    /**
     * @default 'stars'
     */
    b1LgJ: T;

    /**
     * @default 'perk'
     */
    '2qWRA': T;
  };
};

export type HotelReminderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Send Hotels Reminder'
   */
  title: T;

  /**
   * @default 'A little reminder for our upcoming wedding – we've handpicked some wonderful places for you to stay. Be sure to book your room before they fill up! Can't wait to celebrate with you all! 🥂 Hotel details here:'
   */
  defaultMessage: T;

  /**
   * @default 'Message From {{from}} via Joy:'
   */
  messageFrom: T;

  emailPreview: {
    /**
     * @default 'Subject:'
     */
    subject: T;

    /**
     * @default 'From {{from}} via Joy'
     */
    fromViaJoy: T;

    /**
     * @default 'View Hotels'
     */
    viewHotels: T;
  };

  /**
   * @default 'Edit Message'
   */
  editMessage: T;

  /**
   * @default 'Confirm & Send'
   */
  confirmAndSendLabel: T;

  createReminder: {
    /**
     * @default 'Remind your guests to book their stay.'
     */
    title: T;

    /**
     * @default 'Send your guests a quick reminder about booking their accommodations, so they can celebrate without a worry in the world.'
     */
    description: T;

    /**
     * @default 'From'
     */
    fromLabel: T;

    /**
     * @default 'Your Message'
     */
    messageLabel: T;

    /**
     * @default 'Accommodations Link'
     */
    linkLabel: T;

    /**
     * @default 'Link is not editable to prevent abuse and misuse of the platform.'
     */
    linkLabelHint: T;

    tabs: {
      /**
       * @default 'Text Preview'
       */
      text: T;

      /**
       * @default 'Email Preview'
       */
      email: T;
    };
    howItWorks: {
      /**
       * @default 'How does it work?'
       */
      title: T;

      /**
       * @default 'Write your message. Pick guests to remind. Reminder sent!'
       */
      description: T;

      steps: {
        /**
         * @default 'Write your message.'
         */
        writeMessage: T;

        /**
         * @default 'Pick guests to remind.'
         */
        pickGuests: T;

        /**
         * @default 'Reminder sent!'
         */
        reminderSent: T;
      };
    };
  };
  confirmAndSend: {
    /**
     * @default 'Almost done!'
     */
    header: T;

    /**
     * @default 'Review the final details and treat yourself afterwards. You’ve earned it.'
     */
    body: T;

    confirmAndSendActions: {
      addGuests: {
        hed: {
          /**
           * @default 'Add recipients'
           */
          guest_0: T;

          /**
           * @default 'Add or remove recipients'
           * @param {number} count - The number of occurrences.
           * - singular: Add or remove recipients
           * - plural: Add or remove recipients
           */
          guest: T;
        };

        /**
         * @default 'Each guest will receive the SMS reminder, or email in case their phone number is missing.'
         */
        dekSMS: T;

        /**
         * @default 'Each guest will receive the email reminder.'
         */
        dekEmail: T;

        buttonText: {
          /**
           * @default 'Select Guests'
           */
          guest_0: T;

          /**
           * @default '{{count}} Guest Selected…'
           * @param {number} count - The number of occurrences.
           * - singular: {{count}} Guest Selected…
           * - plural: {{count}} Guests Selected…
           */
          guest: T;
        };

        /**
         * @default 'Modify Recipients'
         */
        buttonTextHover: T;
      };
      testSMS: {
        /**
         * @default 'Do an optional final check'
         */
        hed: T;

        /**
         * @default 'Never hurts to make sure everything is just right.'
         */
        dek: T;

        /**
         * @default 'Send Test SMS'
         */
        buttonTextSMS: T;

        /**
         * @default 'Send Test Email'
         */
        buttonTextEmail: T;
      };
      send: {
        /**
         * @default 'Send Reminder'
         */
        hed: T;

        /**
         * @default 'Send reminder to all guests you picked.'
         */
        dek: T;

        /**
         * @default 'Send Now'
         */
        buttonText: T;
      };
    };
    SMSSentSuccessMessage: {
      /**
       * @default 'Your reminder is on the way!'
       * @param {number} count - The number of occurrences.
       * - singular: Your reminder is on the way!
       * - plural: Your reminders are on the way!
       */
      guest: T;
    };

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    SMSSentErrorMessage: T;

    /**
     * @default 'Please, select guests first'
     */
    noGuestsSelectedErrorMessage: T;

    /**
     * @default 'Phone Number is not valid'
     */
    testNumberInvalidMessage: T;

    confirmationScreen: {
      /**
       * @default 'Your reminder to book has been sent to {{count}} people.'
       */
      hed: T;

      /**
       * @default 'Patience is a virtue, but these great rates won’t wait!'
       */
      dek: T;

      /**
       * @default 'View Your Guests List'
       */
      buttonText: T;
    };
    sendTestSMSDialog: {
      /**
       * @default 'Send Test SMS'
       */
      header: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Phone number'
       */
      testNumberLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default '+1-555-555-5555'
       */
      testNumberPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Phone Number is required'
       */
      testNumberErrorMessage: T;

      /**
       * @default 'Should be a valid phone number'
       */
      testNumberInvalidErrorMessage: T;

      /**
       * @default 'Send'
       */
      sendButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
    sendTestEmailDialog: {
      /**
       * @default 'Send Test Email'
       */
      header: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Email'
       */
      testEmailLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default 'hello@gmail.com'
       */
      testEmailPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Email is required'
       */
      testEmailErrorMessage: T;

      /**
       * @default 'Send'
       */
      sendButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
  };
  peoplePicker: {
    /**
     * @default 'SMS'
     */
    emailAndValidPhoneMessage: T;

    /**
     * @default 'No SMS or email'
     */
    noEmailAndPhoneError: T;

    /**
     * @default 'email (no mobile)'
     */
    emailButNoPhoneError: T;

    /**
     * @default 'email (invalid mobile)'
     */
    emailAndInvalidPhoneError: T;
  };
  nav: {
    /**
     * @default 'Next'
     */
    next: T;
  };
  quick: {
    /**
     * @default 'Your reminder to book has been sent to {{0}} people.'
     */
    pCHNw: T;

    /**
     * @default 'Patience is a virtue, but these great rates won't wait!'
     */
    oIH9s: T;

    /**
     * @default 'View Your Guests List'
     */
    '1esP9': T;

    /**
     * @default 'Edit Message'
     */
    '72hts': T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Preview and edit your message to your guests.'
     */
    '2ms2C': T;

    /**
     * @default 'Optional Test SMS'
     */
    zNsov: T;

    /**
     * @default 'Optional Test Email'
     */
    UbuTN: T;

    /**
     * @default 'Never hurts to make sure everything is just right.'
     */
    dEpA1: T;

    /**
     * @default 'Send Test SMS'
     */
    P33MK: T;

    /**
     * @default 'Send Test Email'
     */
    G4RRe: T;

    /**
     * @default 'Select Recipients'
     */
    WeTkN: T;

    /**
     * @default 'Send Message'
     */
    bkLsr: T;

    /**
     * @default 'Keep an eye on replies and poke the slow pokes.'
     */
    cqENB: T;

    /**
     * @default 'Select recipients to send your message'
     */
    TcLCM: T;

    /**
     * @default 'Send to (No Guests Selected)'
     */
    xdSso: T;

    /**
     * @default 'Send'
     */
    Yh9MA: T;

    /**
     * @default 'Your message needs more detail so it ends up in your guests' inbox. Please include at least {{0}} characters. Spam filters flag both short and generic content.'
     */
    RIWZR: T;

    /**
     * @default 'A little reminder for our upcoming wedding – we've handpicked some wonderful places for you to stay. Be sure to book your room before they fill up! Can't wait to celebrate with you all! 🥂 Hotel details here:'
     */
    hDEnC: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    A3Epe: T;

    /**
     * @default 'Your reminder is on the way!'
     */
    x2ptP: T;

    /**
     * @default 'Phone Number is not valid'
     */
    wYGfE: T;

    /**
     * @default 'Message from {{0}} via Joy:'
     */
    nJyxR: T;
  };
};

export type HotelTileTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Save {{0}}%'
     */
    u1SBH: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default '{{0}} {{1}} walk'
     */
    '0uoli': T;

    /**
     * @default '{{0}} {{1}} drive'
     */
    hNVO9: T;

    /**
     * @default 'Less'
     */
    '3I6LA': T;

    /**
     * @default 'More'
     */
    ZTIMA: T;

    /**
     * @default 'Special Event Rate'
     */
    bmIeF: T;

    /**
     * @default '{{0}}'s exclusive guest rates are available when you book with Joy. Reserve soon here to lock in this price—rooms are limited.'
     */
    BzVlk: T;

    /**
     * @default 'Nightly price from'
     */
    uS1D2: T;

    /**
     * @default 'Book before'
     */
    EDAQC: T;

    /**
     * @default 'Group Rate'
     */
    '7rn7p': T;

    /**
     * @default 'A group rate is a special discounted price arranged for wedding guests at this hotel.'
     */
    ISKAR: T;

    /**
     * @default '${{0}}'
     */
    '0IUgr': T;

    /**
     * @default '${{0}}/night'
     */
    x6eTr: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default 'One Guest Booked This Hotel'
     * @param {number} count - The number of occurrences.
     * - singular: One Guest Booked This Hotel
     * - plural: {{0}} Guests Booked This Hotel
     */
    b1pcW: T;

    /**
     * @default 'Joy has seen a booking at this hotel across our events recently. It's a popular spot. You should book soon.'
     * @param {number} count - The number of occurrences.
     * - singular: Joy has seen a booking at this hotel across our events recently. It's a popular spot. You should book soon.
     * - plural: Joy has seen {{0}} bookings at this hotel across our events recently. It's a popular spot. You should book soon.
     */
    o8Ba0: T;

    /**
     * @default '1 booking'
     * @param {number} count - The number of occurrences.
     * - singular: 1 booking
     * - plural: {{0}} bookings
     */
    YLzDq: T;

    /**
     * @default 'less'
     */
    BTvQA: T;

    /**
     * @default 'more'
     */
    hd7QA: T;

    /**
     * @default 'Nightly price'
     */
    GcjRC: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'We're Staying Here'
     */
    zR9rJ: T;
  };
};

export type IdeabookTranslations<T extends LeafNodeValue = TranslateFunction> = {
  ideas: {
    /**
     * @default 'Ideas'
     */
    pageTitle: T;

    /**
     * @default 'Ideabooks'
     */
    ideabookSectionTitle: T;
  };
  ideabook: {};
};

export type IdeasTranslations<T extends LeafNodeValue = TranslateFunction> = {
  addIdeabooks: {
    /**
     * @default 'Create'
     */
    create: T;

    /**
     * @default 'Description'
     */
    description: T;

    /**
     * @default 'Create Ideabook'
     */
    formTitle: T;

    /**
     * @default 'Name'
     */
    name: T;
  };
  editIdeabook: {
    /**
     * @default 'Upload Photo'
     */
    addCollectionItemButtonTitle: T;

    /**
     * @default 'Saving'
     */
    savingCollection: T;

    /**
     * @default 'Ideabook items could not be saved'
     */
    generalError: T;
  };
};

export type ImageFilePickerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  toast: {
    /**
     * @default 'An error occurred while uploading photo. Please try again.'
     */
    toastPhotoUploadFailed: T;
  };
  quick: {
    /**
     * @default 'Image uploaded but could not be added to gallery. The image is still usable.'
     */
    s2Mep: T;
  };
};

export type ImpermissibleTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Hmm… we're having trouble with that.'
   */
  headerText: T;

  /**
   * @default 'If you already have an account, we don't recognize these credentials, please <Action/>'
   */
  alreadyHaveAccountSuggestion: T;

  /**
   * @default 'try another sign in method.'
   */
  alreadyHaveAccountAction: T;

  /**
   * @default 'Creating a new account? We're phasing out Facebook and Gmail sign up. Please <Action/>'
   */
  newAccountSuggestion: T;

  /**
   * @default 'sign up with your email.'
   */
  newAccountAction: T;
};

export type JoykitTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Back'
   */
  back: T;

  /**
   * @default 'Frequently Asked Questions'
   */
  frequentlyAskedQuestions: T;

  /**
   * @default 'Animated'
   */
  animated: T;

  /**
   * @default 'Congratulations! Your email has been verified!'
   */
  emailVerificationSuccess: T;

  /**
   * @default 'Open In New Window'
   */
  openInNewWindow: T;

  /**
   * @default 'Trash'
   */
  trash: T;

  drawer: {
    /**
     * @default 'Drawer'
     */
    rootLabel: T;

    /**
     * @default 'Close'
     */
    closeButtonLabel: T;
  };
  locationInput: {
    /**
     * @default 'Start typing to see options'
     */
    noOptionsMessage: T;
  };
  emailVerificationFailed: {
    /**
     * @default 'We're having trouble verifying your email address.'
     */
    title: T;

    /**
     * @default 'The attempt to verify your email didn't quite work. Please try again.'
     */
    description: T;

    /**
     * @default 'Resend Verification Email'
     */
    ctaLabel: T;
  };
  deleteDialog: {
    /**
     * @default 'Are you sure you want to delete this item?'
     */
    title: T;

    /**
     * @default 'This cannot be undone.'
     */
    message: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'Delete'
     */
    deleteCta: T;
  };
  inviteAdmin: {
    /**
     * @default 'Add Collaborator'
     */
    addCollaborator: T;

    /**
     * @default 'Verify your email address to invite collaborators'
     */
    verifyYourEmail: T;

    /**
     * @default 'Owner'
     */
    owner: T;

    /**
     * @default 'Collaborators'
     */
    collaborators: T;

    /**
     * @default 'Pending Invites'
     */
    pendingInvites: T;

    /**
     * @default 'You'
     */
    you: T;

    /**
     * @default 'Transfer Ownership'
     */
    transferOwnership: T;

    /**
     * @default 'Resend Invite'
     */
    resendInvite: T;

    /**
     * @default 'Revoke Invite'
     */
    revokeInvite: T;

    /**
     * @default 'Done'
     */
    done: T;

    /**
     * @default 'First name is required'
     */
    firstNameRequired: T;

    /**
     * @default 'Last name is required'
     */
    lastNameRequired: T;

    /**
     * @default 'Email is required'
     */
    emailRequired: T;

    /**
     * @default 'Invalid email format'
     */
    invalidEmail: T;

    /**
     * @default 'Add Collaborator'
     */
    addAdminTitle: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Send Invite'
     */
    sendInvite: T;

    /**
     * @default 'First name'
     */
    firstNameAriaLabel: T;

    /**
     * @default 'First Name'
     */
    firstNamePlaceholder: T;

    /**
     * @default 'Last name'
     */
    lastNameAriaLabel: T;

    /**
     * @default 'Last Name'
     */
    lastNamePlaceholder: T;

    /**
     * @default 'Email'
     */
    emailAriaLabel: T;

    /**
     * @default 'name@example.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Revoke Invitation?'
     */
    revokeAdminInvitationTitle: T;

    /**
     * @default 'Are you sure you want to revoke <fullname/> admin privileges?'
     */
    revokeAdminMessage: T;

    /**
     * @default 'Revoke'
     */
    revoke: T;

    /**
     * @default 'Transfer'
     */
    transfer: T;

    /**
     * @default 'Transfer Ownership?'
     */
    transferOwnershipTitle: T;

    /**
     * @default 'Are you sure you want to transfer the ownership of this Joy event to <fullname/>?'
     */
    transferOwnershipMessage: T;

    /**
     * @default 'You will no longer be the primary account owner and your account will be downgraded to an admin account for this event.'
     */
    transferOwnershipConfirmation: T;

    /**
     * @default 'Enter '{{confirmationWord}}' to Confirm'
     */
    transferOwnershipInputLabel: T;

    /**
     * @default 'Email verification is required.'
     */
    emailVerificationRequired: T;

    /**
     * @default 'Verify Email'
     */
    verifyEmail: T;

    /**
     * @default 'Transfer Account'
     */
    transferAccount: T;
  };
  deleteEvent: {
    /**
     * @default 'Are you sure you want to delete this event?'
     */
    title: T;

    /**
     * @default 'Permanently deleting your Joy event includes all event details, your website, admin dashboard, photos, and guests.'
     */
    message1: T;

    /**
     * @default 'If you would like to continue, please type ‘DELETE’ in the field below to permanently delete your event and all its associated information from Joy.'
     */
    message2: T;

    /**
     * @default 'This is an IRREVERSIBLE change.'
     */
    message3: T;

    /**
     * @default 'Enter ‘DELETE’ to Confirm'
     */
    inputTitle: T;

    /**
     * @default 'DELETE'
     */
    delete: T;

    /**
     * @default 'Delete My Joy Event'
     */
    deleteMyJoyEvent: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'We were unable to delete the event.'
     */
    deleteEventFailureMessage: T;
  };
  focusPointDialog: {
    /**
     * @default 'Edit Page Photo'
     */
    title: T;

    /**
     * @default 'Focus point ensures your image displays well on all devices.'
     */
    note: T;

    /**
     * @default 'Delete'
     */
    delete: T;

    /**
     * @default 'Change'
     */
    change: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Photo settings updated successfully.'
     */
    photoSettingsUpdateSuccess: T;

    /**
     * @default 'Failed to update photo settings.'
     */
    photoSettingsUpdateFailure: T;

    /**
     * @default 'Photo has been deleted'
     */
    photoDeleteSuccess: T;

    /**
     * @default 'Failed to delete photo.'
     */
    photoDeleteError: T;

    /**
     * @default 'Replace Photo'
     */
    replacePhoto: T;

    /**
     * @default 'Photo Layout'
     */
    photoLayout: T;

    /**
     * @default 'Full Width Photo'
     */
    fullWidthPhoto: T;

    /**
     * @default 'Centered Photo'
     */
    centeredPhoto: T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    fullWidthCropNote: T;

    photoLayoutDropDown: {
      fullWidth: {
        /**
         * @default 'Screen Width Photo'
         */
        title: T;
      };
      centered: {
        /**
         * @default 'Centered Photo'
         */
        title: T;
      };
      pageWidth: {
        /**
         * @default 'Page Width Photo'
         */
        title: T;
      };
    };
    cancelConfirmationDialog: {
      /**
       * @default 'Save Changes?'
       */
      title: T;

      /**
       * @default 'Would you like to save this photo and the settings selected to your website? '
       */
      content: T;

      /**
       * @default 'Discard Changes'
       */
      discardChanges: T;

      /**
       * @default 'Save'
       */
      save: T;
    };
  };
  inlineEditor: {
    /**
     * @default 'Content'
     */
    content: T;

    /**
     * @default 'Font Styles'
     */
    fontStyles: T;

    /**
     * @default 'Font Size'
     */
    fontSize: T;

    /**
     * @default 'Alignment'
     */
    alignement: T;

    /**
     * @default 'Photo'
     */
    photo: T;

    /**
     * @default 'Colors'
     */
    colors: T;

    /**
     * @default 'This page is public.'
     */
    pagePublic: T;

    /**
     * @default 'This page is password protected.'
     */
    pageProtected: T;

    /**
     * @default 'This page is hidden.'
     */
    pageHidden: T;

    /**
     * @default 'Edit Photo'
     */
    editPhoto: T;

    /**
     * @default 'Edit Monogram'
     */
    editMonogram: T;

    /**
     * @default 'Add Page Photo'
     */
    addPagePhoto: T;

    /**
     * @default 'Edit Color'
     */
    editColor: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Edit Content'
     */
    editContent: T;

    /**
     * @default 'Event info has been saved'
     */
    eventInfoUpdateSuccess: T;

    /**
     * @default 'Error updating event info. Please try again later.'
     */
    eventInfoUpdateError: T;

    /**
     * @default 'Display Name'
     */
    displayName: T;

    /**
     * @default 'Event Date'
     */
    eventDate: T;

    /**
     * @default 'Please re-enter the date in MM/DD/YYYY format'
     */
    invalidDate: T;

    /**
     * @default 'Greetings'
     */
    greetings: T;

    /**
     * @default 'Text should be {{max}} characters or less.'
     */
    maxCharacters: T;

    /**
     * @default 'Event Location'
     */
    eventLocation: T;

    /**
     * @default 'Buttons'
     */
    buttons: T;

    /**
     * @default 'Navigation'
     */
    navigation: T;

    /**
     * @default 'Powered by Google'
     */
    poweredBy: T;

    /**
     * @default 'Theme'
     */
    theme: T;

    /**
     * @default 'Page Settings'
     */
    pageSettings: T;

    /**
     * @default 'Graphic Accent'
     */
    graphicAccent: T;

    /**
     * @default 'Couple’s Name'
     */
    couplesName: T;

    /**
     * @default 'Customize Names'
     */
    customizeNames: T;

    type: {
      /**
       * @default 'Photo'
       */
      photo: T;

      /**
       * @default 'Monogram'
       */
      monogram: T;
    };
  };
  colorPalettePicker: {
    /**
     * @default 'Reset to default'
     */
    resetToDefault: T;
  };
  photoMenu: {
    /**
     * @default 'Update Photo'
     */
    update: T;

    /**
     * @default 'Reset to Default'
     */
    reset: T;

    /**
     * @default 'Delete Photo'
     */
    delete: T;
  };
  editEventUrl: {
    /**
     * @default 'Event URL'
     */
    eventUrl: T;

    /**
     * @default 'Joy Event URL'
     */
    joyEventURL: T;

    /**
     * @default 'Please Note:'
     */
    pleaseNote: T;

    /**
     * @default 'Your old Joy URL will no longer work - this means you'll need to let all your guests know the new address so they can still access your website. Please note that if you have a custom domain, you will also need to update your forwarding URL to point to this new Joy URL.'
     */
    eventUrlNote: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Event URL updated'
     */
    eventUrlUpdateSuccess: T;

    /**
     * @default 'Error updating event URL. Please try again later.'
     */
    eventUrlUpdateError: T;
  };
  smartAppBanner: {
    /**
     * @default 'Continue in the App'
     */
    title: T;

    /**
     * @default 'Join event: {{eventHandle}}'
     */
    description: T;

    /**
     * @default 'View'
     */
    view: T;
  };
  photoPicker: {
    /**
     * @default 'Choose Your Photo'
     */
    chooseYourPhoto: T;

    /**
     * @default 'All your photos will appear here.'
     */
    allYourPhotosWillAppearHere: T;

    /**
     * @default 'Upload Photos'
     */
    uploadPhotos: T;

    /**
     * @default 'Save Photo'
     */
    savePhoto: T;

    /**
     * @default 'Uploads'
     */
    uploads: T;

    /**
     * @default 'All Photos'
     */
    allPhotos: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    savePhotoError: T;

    /**
     * @default 'This album is currently hidden. Would you like to make it public?'
     */
    alertHiddenCollectionTitle: T;

    /**
     * @default 'This will allow your guests to view the photos from this album on your site.'
     */
    alertHiddenCollectionSubtitle: T;

    /**
     * @default 'Yes, Change to Public'
     */
    changeToPublicCTA: T;

    /**
     * @default 'No, Keep Private'
     */
    keepPrivateCTA: T;
  };
  hotelSuggestionDialog: {
    /**
     * @default 'Compare prices before you book.'
     */
    title: T;

    /**
     * @default 'You’re heading to an external site to view <HotelName/>.'
     */
    descriptionLine1: T;

    /**
     * @default 'You can also book this hotel through Joy - our exclusive rates for couples and guests often beat other sites.'
     */
    descriptionLine2: T;

    /**
     * @default 'Continue to External Site'
     */
    continueToExternalSite: T;

    /**
     * @default 'Check Rates on Joy'
     */
    checkRatesOnJoy: T;
  };
  eventCountdown: {
    /**
     * @default '{{days}} days {{hrs}} hrs {{mins}} mins'
     */
    displayText: T;

    /**
     * @default '{{days}} days {{hrs}} hrs {{mins}} mins ago'
     */
    displayTextAgo: T;
  };
  pageNote: {
    /**
     * @default 'You can share a note with your guests here!'
     */
    defaultNote: T;

    /**
     * @default 'Page Note'
     */
    title: T;

    /**
     * @default 'Need some ideas? Use suggest and we'll write a message that Joy couples have found helpful.'
     */
    hint: T;

    tooltip: {
      /**
       * @default 'Tell Guests Why'
       */
      title: T;

      /**
       * @default 'Add a note for your guests — this will show on your Places to Stay page. It’s a great spot to share travel tips or booking details. Don’t forget to mention that guests should book here to get the group discount! Need help? Hit “Suggest” and we’ll write it for you with AI.'
       */
      content: T;
    };

    /**
     * @default 'Note to Guests'
     */
    noteLabel: T;

    /**
     * @default 'Suggest'
     */
    suggestion: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'Save'
     */
    saveCta: T;
  };
  multiPhotoSelector: {
    /**
     * @default 'Add Photos'
     */
    addPhotos: T;

    /**
     * @default 'Swap Photo'
     */
    swapPhoto: T;

    /**
     * @default 'Edit Photo'
     */
    editPhoto: T;

    /**
     * @default 'Remove Photo'
     */
    removePhoto: T;

    /**
     * @default 'You must select {{countRange}} for the {{layout}}.'
     */
    photoSelectionHelperText: T;

    /**
     * @default 'You must select one photo.'
     */
    singlePhotoSelectionHelperText: T;
  };
  photoAdjustDialog: {
    /**
     * @default 'Crop Photo'
     */
    cropTitle: T;

    /**
     * @default 'Focus Point'
     */
    focusPointTitle: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    cropNote: T;

    /**
     * @default 'Focus point ensures your image displays well on all devices.'
     */
    focusPointNote: T;
  };
  quick: {
    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Couple's Name'
     */
    n226o: T;

    /**
     * @default 'Event Display Name'
     */
    rZqZK: T;

    /**
     * @default 'Photo has been deleted'
     */
    XG519: T;

    /**
     * @default 'Failed to delete photo.'
     */
    VTRSR: T;

    /**
     * @default 'Edit Page Photo'
     */
    '3b7U6': T;

    /**
     * @default 'Photo settings updated successfully.'
     */
    t063A: T;

    /**
     * @default 'Failed to update photo settings.'
     */
    '4oJdX': T;

    /**
     * @default 'Focus point ensures your image displays well on all devices.'
     */
    FG3cr: T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    NMFwg: T;

    /**
     * @default 'Swap Photo'
     */
    LnQfM: T;

    /**
     * @default 'Edit Photo'
     */
    syk52: T;

    /**
     * @default 'Remove Photo'
     */
    '064Tf': T;

    /**
     * @default 'You reached a maximum number of photos in this header.'
     */
    ReztN: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'The maximum number of photos have been selected for this header layout'
     */
    nWp59: T;

    /**
     * @default '💎 Feeling Fancy?'
     */
    zdFLi: T;

    /**
     * @default 'Pick one of premium templates and personalize your site even more with a video background.'
     */
    Oq0JR: T;

    /**
     * @default '{{0}} days'
     */
    vzIzE: T;

    /**
     * @default '{{0}} days {{1}} hrs'
     */
    PY6PD: T;

    /**
     * @default '{{0}} days {{1}} hrs {{2}} mins {{3}} secs'
     */
    RexSU: T;

    /**
     * @default '{{0}} days {{1}} hrs {{2}} mins'
     */
    kq8hO: T;

    /**
     * @default '{{0}} ago'
     */
    XkQ5Z: T;

    /**
     * @default 'Theme'
     */
    v2IAH: T;

    /**
     * @default '{{0}} to {{1}}'
     */
    oaYs3: T;

    /**
     * @default 'Not helpful'
     */
    XptR9: T;

    /**
     * @default 'Very helpful'
     */
    uYANy: T;

    /**
     * @default 'Rate {{0}}'
     */
    a5XB1: T;

    /**
     * @default 'Default hotel image'
     */
    '8smrM': T;

    /**
     * @default 'Previous Month'
     */
    HMlg0: T;

    /**
     * @default 'Next Month'
     */
    '3VsVl': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'No items selected'
     * @param {number} count - The number of occurrences.
     * - zero: No items selected
     * - singular: 1 item selected
     * - plural: {{0}} items selected
     */
    agQzx: T;

    /**
     * @default 'Hello {{0}}!'
     */
    VaBCG: T;
  };
};

export type LayoutEngineTranslations<T extends LeafNodeValue = TranslateFunction> = {
  components: {
    footer: {
      /**
       * @default 'Help'
       */
      help: T;

      /**
       * @default 'About'
       */
      about: T;
    };
    announcement: {
      /**
       * @default 'Close'
       */
      close: T;

      /**
       * @default 'Continue'
       */
      continue: T;
    };
    eventCta: {
      /**
       * @default 'Hello {{guestName}}.'
       */
      personalizedText: T;

      /**
       * @default 'Not You?'
       */
      buttonNotYouText: T;
    };
  };
  quick: {
    /**
     * @default 'You are attending'
     */
    DUoV0: T;

    /**
     * @default 'You are not attending'
     */
    qdFsO: T;

    /**
     * @default 'Other'
     */
    KSFnG: T;

    /**
     * @default 'Unlock Your Schedule'
     */
    ybxpH: T;

    /**
     * @default 'Unlock Guest Details'
     */
    eKWZY: T;

    /**
     * @default 'Don't Forget to RSVP'
     */
    F6q94: T;
  };
};

export type LocationDatesOccupantsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Search'
   */
  mIY0U: T;

  /**
   * @default 'Select dates'
   */
  '7dKV6': T;

  /**
   * @default 'Select Room'
   */
  '8jYxL': T;

  /**
   * @default 'Configuring Rooms'
   */
  '9kZmP': T;

  /**
   * @default 'Room {{number}}'
   */
  '0nQwR': T;

  /**
   * @default 'Child {{number}}'
   */
  '1pXsT': T;

  /**
   * @default 'Adults'
   */
  '2qYvU': T;

  /**
   * @default 'Age 17 or under'
   */
  '3rZwV': T;

  /**
   * @default 'Age 18 or above'
   */
  '4sAwX': T;

  /**
   * @default 'Apply'
   */
  '5tByZ': T;

  /**
   * @default 'Add Room'
   */
  '6uCzA': T;

  /**
   * @default 'Remove Room'
   */
  '7vDxB': T;

  /**
   * @default 'Select Age'
   */
  '8wEyC': T;

  /**
   * @default 'Provide the age of child'
   */
  '9xFzD': T;

  /**
   * @default 'Age must be at least 0'
   */
  '0yGAE': T;

  /**
   * @default 'Age must be 17 or under'
   */
  '1zHBF': T;

  /**
   * @default 'Children'
   */
  '2AICG': T;

  /**
   * @default '1 Room'
   */
  '3BJDH': T;

  /**
   * @default '{{count}} Rooms'
   */
  '4CKEI': T;

  /**
   * @default '1 Guest'
   */
  '5DLFJ': T;

  /**
   * @default '{{count}} Guests'
   */
  '6EMGK': T;

  quick: {
    /**
     * @default 'Provide the age of child'
     */
    qnhUI: T;

    /**
     * @default 'Age must be at least 0'
     */
    XK89v: T;

    /**
     * @default 'Age must be 17 or under'
     */
    CLkze: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Select dates'
     */
    xyVOA: T;

    /**
     * @default '1 Room'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Room
     * - plural: {{0}} Rooms
     */
    YfpCH: T;

    /**
     * @default '1 Guest'
     * @param {number} count - The number of occurrences.
     * - singular: 1 Guest
     * - plural: {{0}} Guests
     */
    smTdz: T;

    /**
     * @default 'Select Room'
     */
    hsTPG: T;

    /**
     * @default 'Configuring Rooms'
     */
    NJwkV: T;

    /**
     * @default 'Add Room'
     */
    SkfsO: T;

    /**
     * @default 'Apply'
     */
    YD1eF: T;

    /**
     * @default 'Room {{0}}'
     */
    '7Jf7l': T;

    /**
     * @default 'Remove Room'
     */
    J7AzN: T;

    /**
     * @default 'Adults'
     */
    '9woIj': T;

    /**
     * @default 'Age 18 or above'
     */
    '2JQeH': T;

    /**
     * @default 'Children'
     */
    jbb2a: T;

    /**
     * @default 'Age 17 or under'
     */
    '6FDhE': T;

    /**
     * @default 'Child {{0}}'
     */
    '2LJOz': T;

    /**
     * @default 'Select Age'
     */
    njboI: T;
  };
};

export type LocationVenueSyncDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Failed to update venue. Please try again.'
     */
    Pu4SG: T;

    /**
     * @default 'Failed to update location. Please try again.'
     */
    rf3wB: T;

    /**
     * @default 'Your Venue'
     */
    sPB4Q: T;

    /**
     * @default 'Would you like to update your location to match your venue?'
     */
    OdYjc: T;

    /**
     * @default 'Would you like to update your venue to match your location?'
     */
    aN9BN: T;

    /**
     * @default 'New event location: {{0}}'
     */
    '1TMcy': T;

    /**
     * @default 'Please search and select your wedding venue, so we can help you plan better.'
     */
    e1bzf: T;

    /**
     * @default 'Event Venue'
     */
    DR5KP: T;

    /**
     * @default 'San Francisco City Hall'
     */
    QSamB: T;

    /**
     * @default 'Update your venue'
     */
    nT5yS: T;

    /**
     * @default 'Yes, Update Location'
     */
    BajQ2: T;

    /**
     * @default 'Save Venue'
     */
    U5GvJ: T;

    /**
     * @default 'No, Keep Original Location'
     */
    cizlA: T;

    /**
     * @default 'No, thanks'
     */
    '6kQyP': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;
  };
};

export type MarcomTranslations<T extends LeafNodeValue = TranslateFunction> = {
  topLevelLinks: {
    /**
     * @default 'Joy Wedding'
     */
    joyWedding: T;

    /**
     * @default 'Joy Baby'
     */
    joyBaby: T;

    /**
     * @default 'Find an Event'
     */
    findACouple: T;

    /**
     * @default 'Log In'
     */
    login: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Shipping'
     */
    shipping: T;

    /**
     * @default 'Returns'
     */
    returns: T;

    /**
     * @default 'Newsroom'
     */
    newsroom: T;

    /**
     * @default 'Careers'
     */
    careers: T;

    /**
     * @default 'About Joy'
     */
    aboutJoy: T;

    /**
     * @default 'Contact Us'
     */
    contactUs: T;

    /**
     * @default 'Terms'
     */
    terms: T;

    /**
     * @default 'Privacy'
     */
    privacy: T;

    /**
     * @default 'Checklist'
     */
    giftBasketWidget: T;

    /**
     * @default 'California Privacy Notice'
     */
    californiaPrivacyNotice: T;

    /**
     * @default 'Do not share my personal information.'
     */
    doNotShareInformation: T;
  };
  linkGroupHeaders: {
    /**
     * @default 'Plan & Invite'
     */
    planInvite: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Expert Advice'
     */
    expertAdvice: T;
  };
  planInvite: {
    /**
     * @default 'Wedding Website'
     */
    weddingWebsite: T;

    /**
     * @default 'Guest List'
     */
    guestList: T;

    /**
     * @default 'Save the Dates'
     */
    saveTheDates: T;

    /**
     * @default 'Invitations'
     */
    invitations: T;

    /**
     * @default 'Smart RSVP'
     */
    smartRsvp: T;

    /**
     * @default 'Hotel Room Blocks'
     */
    hotelRoomBlocks: T;

    /**
     * @default 'Mobile App'
     */
    mobileApp: T;
  };
  registry: {
    /**
     * @default 'Wedding Registry'
     */
    weddingRegistry: T;

    /**
     * @default 'The Registry Store'
     */
    shopWedding: T;

    /**
     * @default 'Zero-Fee Cash Funds'
     */
    zeroFeeCashFunds: T;

    /**
     * @default 'Honeymoon Funds'
     */
    honeymoonFunds: T;

    /**
     * @default 'Baby Registry'
     */
    babyRegistry: T;

    /**
     * @default 'Shop Baby Gifts'
     */
    shopBabyGift: T;
  };
  expertAdvice: {
    /**
     * @default 'Wedding Guides & Ideas'
     */
    weddingGuidesIdeas: T;

    /**
     * @default 'Wedding Guides'
     */
    weddingGuidesIdeasMobile: T;

    /**
     * @default 'Baby & Parenting Guides'
     */
    babyParentingGuides: T;

    /**
     * @default 'Baby Guides'
     */
    babyParentingGuidesMobile: T;

    /**
     * @default 'FAQs'
     */
    faq: T;

    /**
     * @default 'Help & Support'
     */
    support: T;

    blogs: {
      /**
       * @default 'Wedding Planning'
       */
      weddingPlanning: T;

      /**
       * @default 'Budget'
       */
      budget: T;

      /**
       * @default 'Tips & Tricks'
       */
      tipsTricks: T;

      /**
       * @default 'Venues'
       */
      venues: T;

      /**
       * @default 'Photography'
       */
      photography: T;

      /**
       * @default 'Food & Drink'
       */
      foodDrink: T;

      /**
       * @default 'Wedding Guests'
       */
      weddingGuests: T;

      /**
       * @default 'Registry & Gift Ideas'
       */
      registryGiftIdeas: T;

      /**
       * @default 'Real Weddings'
       */
      realWeddings: T;

      /**
       * @default 'Proposal Ideas'
       */
      proposalIdeas: T;

      /**
       * @default 'Honeymoons'
       */
      honeymoons: T;

      /**
       * @default 'Pregnancy'
       */
      pregnancy: T;

      /**
       * @default 'Planning'
       */
      planning: T;

      /**
       * @default 'Parties'
       */
      parties: T;

      /**
       * @default 'Parenting'
       */
      parenting: T;

      /**
       * @default 'View All Categories'
       */
      viewAllCategories: T;
    };
  };
  identityWidget: {
    /**
     * @default 'Dashboard'
     */
    toDashboard: T;

    /**
     * @default 'Registry'
     */
    toRegistry: T;

    /**
     * @default 'Settings'
     */
    toSettings: T;

    /**
     * @default 'Manage Account'
     */
    toManageAcct: T;

    /**
     * @default 'Invite Collaborator'
     */
    toInvite: T;

    /**
     * @default 'Help'
     */
    toHelp: T;

    /**
     * @default 'Sign Out'
     */
    signOut: T;

    /**
     * @default 'Add Photos'
     */
    addPhotos: T;

    /**
     * @default 'Switch Event'
     */
    switchEvent: T;

    /**
     * @default 'Select Event'
     */
    selectEvent: T;

    /**
     * @default 'No Event Selected'
     */
    noEventSelected: T;
  };
  footerNav: {
    /**
     * @default 'New'
     */
    new: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default '© {{year}} Joy. All rights reserved.'
     */
    copyright: T;
  };
  footerMenu: {
    primary: {
      /**
       * @default 'Wedding Website'
       */
      weddingWebsite: T;

      /**
       * @default 'Guest List'
       */
      guestList: T;

      /**
       * @default 'Save the Dates'
       */
      saveTheDates: T;

      /**
       * @default 'Invitations'
       */
      invitations: T;

      /**
       * @default 'Smart RSVP'
       */
      smartRsvp: T;

      /**
       * @default 'Registry'
       */
      registry: T;

      /**
       * @default 'Hotel Room Blocks'
       */
      hotelRoomBlocks: T;

      /**
       * @default 'Mobile App'
       */
      mobileApp: T;

      /**
       * @default 'Baby Registry'
       */
      babyRegistry: T;

      /**
       * @default 'Shop Baby Gifts'
       */
      shopBabyGifts: T;

      /**
       * @default 'Zero-Fee Cash Funds'
       */
      zeroFeeCashFunds: T;
    };
    secondary: {
      /**
       * @default 'Design Templates'
       */
      designTemplates: T;

      /**
       * @default 'Ideas & Inspiration'
       */
      ideasInspiration: T;

      /**
       * @default 'Common Questions'
       */
      commonQuestions: T;

      /**
       * @default 'Help & Support'
       */
      helpSupport: T;

      /**
       * @default 'Pricing'
       */
      pricing: T;

      /**
       * @default 'Baby & Parenting Guides'
       */
      babyParentingGuides: T;

      /**
       * @default 'FAQs'
       */
      faqs: T;
    };
  };
};

export type MessageTranslations<T extends LeafNodeValue = TranslateFunction> = {
  title: {
    /**
     * @default 'Send General Message'
     */
    general: T;
  };
  shared: {
    recipientPickerDialog: {
      /**
       * @default 'Select Recipients'
       */
      title: T;

      /**
       * @default 'Search'
       */
      searchPlaceholder: T;

      /**
       * @default 'No recipients found.'
       */
      noRecipients: T;

      /**
       * @default 'Selected ({{count}})'
       */
      selected: T;

      /**
       * @default 'Unselect All'
       */
      unselectAll: T;

      /**
       * @default 'Select All'
       */
      selectAll: T;

      /**
       * @default 'Select Recipients ({{count}})'
       */
      cta: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };
    sendTestEmailDialog: {
      /**
       * @default 'Send Test Email'
       */
      title: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Email'
       */
      testEmailLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default 'hello@gmail.com'
       */
      testEmailPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Email is required'
       */
      testEmailErrorMessage: T;

      /**
       * @default 'Email is invalid'
       */
      testEmailInvalidErrorMessage: T;

      /**
       * @default 'Send'
       */
      cta: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };
    editLinkDialog: {
      /**
       * @default 'Select Link'
       */
      websiteLinkTitle: T;

      /**
       * @default 'Edit Link'
       */
      websiteLinkTitleDigital: T;

      /**
       * @default 'Edit Your Website Details'
       */
      handleAndPasswordTitle: T;

      websiteLink: {
        /**
         * @default 'Select the link users will navigate to, making it easy for them to see the most relevant information.'
         */
        description: T;

        /**
         * @default 'Add a link to your card, so guests can easily access your wedding website and see all the details.'
         */
        linkDescription: T;

        /**
         * @default 'Your Website'
         */
        yourWebsiteTitle: T;

        /**
         * @default 'Edit'
         */
        edit: T;

        /**
         * @default 'Edit URL and Password'
         */
        editURLAndPassword: T;

        /**
         * @default 'Uh oh! Your website link seems a bit long, you can edit it to make it shorter and more personal to make it easier for your guests.'
         */
        longHandleWarning: T;

        /**
         * @default 'Your Custom Link'
         */
        customLinkTitle: T;

        /**
         * @default 'Contact Collector'
         */
        contactCollectorTitle: T;

        /**
         * @default 'Please ensure you're using the correct format, starting with http:// or https://'
         */
        invalidCustomLinkError: T;

        /**
         * @default 'Select a Page'
         */
        selectAPage: T;

        /**
         * @default 'Password'
         */
        password: T;

        /**
         * @default 'Save'
         */
        save: T;
      };
      editLinkAndPassword: {
        /**
         * @default 'URL'
         */
        url: T;

        /**
         * @default 'This URL is available'
         */
        urlAvailable: T;

        /**
         * @default ' This URL is not available'
         */
        urlNotAvailable: T;

        /**
         * @default '/60 Max Chars'
         */
        urlCharsCounter: T;

        /**
         * @default 'URL cannot be blank.'
         */
        urlRequiredError: T;

        /**
         * @default 'URL must be less than 60 characters long.'
         */
        urlLengthError: T;

        /**
         * @default 'Only letters, numbers and '-' are allowed in your URL.'
         */
        urlCharactersError: T;

        /**
         * @default 'Your old Joy URL will no longer work. If you have a custom domain, you’ll need to update your forwarding URL with your domain provider.'
         */
        urlWarning: T;

        /**
         * @default 'Password'
         */
        password: T;

        /**
         * @default 'Password cannot be blank.'
         */
        passwordRequiredError: T;

        /**
         * @default 'Your password can only contain letters and numbers.'
         */
        passwordCharactersError: T;

        /**
         * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
         */
        passwordWarning: T;

        /**
         * @default 'Cancel'
         */
        cancel: T;

        /**
         * @default 'Update Details'
         */
        updateDetails: T;

        /**
         * @default 'Your Event Website has been updated.'
         */
        successToast: T;

        /**
         * @default 'An error occurred while updating your Event Website. Please try again.'
         */
        errorToast: T;
      };
    };
  };
  general: {
    nav: {
      /**
       * @default 'Next'
       */
      next: T;

      /**
       * @default 'Edit Message'
       */
      editMessage: T;

      /**
       * @default 'Confirm & Send'
       */
      confirmAndSendLabel: T;
    };
    bottomSheet: {
      editMessage: {
        /**
         * @default 'Edit Message'
         */
        title: T;

        /**
         * @default 'Preview and edit your message to your guests.'
         */
        description: T;

        /**
         * @default 'Edit Message'
         */
        cta: T;
      };
      selectRecipients: {
        /**
         * @default 'Select Recipients'
         */
        title: T;

        /**
         * @default 'No guests selected yet.'
         */
        description_0: T;

        /**
         * @default '{{count}} guests selected.'
         */
        description_n: T;

        /**
         * @default 'Select Guests'
         */
        cta_0: T;

        /**
         * @default '1 Guest Selected…'
         */
        cta_1: T;

        /**
         * @default '{{count}} Guests Selected…'
         */
        cta_n: T;
      };
      optionalTestEmail: {
        /**
         * @default 'Optional Test Email'
         */
        title: T;

        /**
         * @default 'Never hurts to make sure everything is just right.'
         */
        description: T;

        /**
         * @default 'Send Test Email'
         */
        cta: T;
      };
      sendMessage: {
        /**
         * @default 'Send Message'
         */
        title: T;

        /**
         * @default 'Keep an eye on replies and poke the slow pokes.'
         */
        description: T;

        /**
         * @default 'Select recipients to send your message'
         */
        tooltip: T;

        /**
         * @default 'Send to (No Guests Selected)'
         */
        cta_0: T;

        /**
         * @default 'Send to 1 Person'
         */
        cta_1: T;

        /**
         * @default 'Send to {{count}} People'
         */
        cta_n: T;
      };
    };
    toasts: {
      /**
       * @default 'Please, select guests first'
       */
      noGuestsSelectedErrorMessage: T;

      /**
       * @default 'Your email is on the way!'
       */
      emailSentSuccessMessage: T;

      /**
       * @default 'Sorry, something might have gone wrong'
       */
      emailSentErrorMessage: T;

      /**
       * @default 'Your test email is on the way!'
       */
      testEmailSentSuccessMessage: T;

      /**
       * @default 'Sorry, something might have gone wrong'
       */
      testEmailSentErrorMessage: T;
    };
    create: {
      form: {
        /**
         * @default 'Subject'
         */
        subject: T;

        /**
         * @default 'Subject'
         */
        subjectPlaceholder: T;

        /**
         * @default 'Photo'
         */
        photo: T;

        /**
         * @default 'Salutation'
         */
        salutation: T;

        /**
         * @default 'Salutation'
         */
        salutationPlaceholder: T;

        /**
         * @default 'Include Recipient Name'
         */
        includeGuestNames: T;

        /**
         * @default 'Message'
         */
        message: T;

        /**
         * @default 'Message'
         */
        messagePlaceholder: T;

        /**
         * @default 'Display Button in Email'
         */
        displayButton: T;

        /**
         * @default 'Button Text'
         */
        buttonText: T;

        /**
         * @default 'Button Text'
         */
        buttonTextPlaceholder: T;

        /**
         * @default 'Button URL'
         */
        buttonUrl: T;

        /**
         * @default 'Edit'
         */
        editButtonUrl: T;
      };
      emailPreview: {
        /**
         * @default 'Subject:'
         */
        subject: T;

        /**
         * @default 'Recipient Name'
         */
        recipientNames: T;

        /**
         * @default 'Host Your Event'
         */
        hostYourEvent: T;

        /**
         * @default '140 Keller Street #229, Petaluma, CA 94952'
         */
        address: T;

        /**
         * @default 'Help Center'
         */
        helpCenter: T;

        /**
         * @default 'Privacy Policy'
         */
        privacyPolicy: T;

        /**
         * @default 'Terms and Conditions'
         */
        termsAndConditions: T;
      };
      emailDefaultContent: {
        /**
         * @default 'Exciting info about our upcoming event!'
         */
        subject: T;

        /**
         * @default 'Hi'
         */
        salutation: T;

        /**
     * @default 'We’re excited to share the latest news and updates for our upcoming event.

Thank you for being a part of our community!'
*/
        message: T;

        /**
         * @default 'Learn More'
         */
        buttonText: T;
      };
      editMessageDrawer: {
        /**
         * @default 'Edit Message'
         */
        title: T;

        /**
         * @default 'Save'
         */
        cta: T;

        /**
         * @default 'Cancel'
         */
        cancel: T;
      };
    };
    confirm: {
      /**
       * @default 'Almost done!'
       */
      header: T;

      actions: {
        addGuests: {
          hed: {
            /**
             * @default 'Add recipients'
             */
            guest_0: T;

            /**
             * @default 'Add or remove recipients'
             * @param {number} count - The number of occurrences.
             * - singular: Add or remove recipients
             * - plural: Add or remove recipients
             */
            guest: T;
          };

          /**
           * @default 'We have pre-selected guests who have not RSVP’d, but you can edit our selection if you wish.'
           */
          dek: T;

          buttonText: {
            /**
             * @default 'Select Guests'
             */
            guest_0: T;

            /**
             * @default '{{count}} Guest Selected…'
             * @param {number} count - The number of occurrences.
             * - singular: {{count}} Guest Selected…
             * - plural: {{count}} Guests Selected…
             */
            guest: T;
          };

          /**
           * @default 'Modify Recipients'
           */
          buttonTextHover: T;
        };
        test: {
          /**
           * @default 'Do an optional final check'
           */
          hed: T;

          /**
           * @default 'Never hurts to make sure everything is just right.'
           */
          dek: T;

          /**
           * @default 'Send Test Email'
           */
          buttonTextEmail: T;
        };
        send: {
          /**
           * @default 'Send Message'
           */
          hed: T;

          /**
           * @default 'Send this message to all selected guests.'
           */
          dek: T;

          /**
           * @default 'Send Now'
           */
          buttonText: T;
        };
      };
    };
  };
  quick: {
    /**
     * @default 'This email was sent from withjoy.com on behalf of {{eventDisplayName}}.'
     */
    vuDEI: T;

    /**
     * @default 'Test Recipient'
     */
    lf11J: T;

    /**
     * @default 'Exciting info about our upcoming event!'
     */
    VMWLg: T;

    /**
     * @default 'Hi'
     */
    BoAAA: T;

    /**
     * @default 'We're excited to share the latest news and updates for our upcoming event.

Thank you for being a part of our community!'
*/
    d61x2: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Sorry, something might have gone wrong'
     */
    EuZmf: T;

    /**
     * @default 'Your email is on the way!'
     */
    TEOIO: T;

    /**
     * @default 'Sorry, something went wrong'
     */
    kkwz0: T;

    /**
     * @default 'Your test email is on the way!'
     */
    rgeEE: T;

    /**
     * @default 'Create New Fund'
     */
    VfFAE: T;

    /**
     * @default 'Select Fund to Link'
     */
    oR0DK: T;

    /**
     * @default 'Select…'
     */
    '6Kcu4': T;

    /**
     * @default 'Contribute'
     */
    VZXCJ: T;

    /**
     * @default 'Edit Message'
     */
    '72hts': T;

    /**
     * @default 'Subject'
     */
    '67HAP': T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Salutation'
     */
    gkDux: T;

    /**
     * @default 'Include Recipient Name'
     */
    USARc: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Button Text'
     */
    VGWQI: T;

    /**
     * @default 'Display Button in Email'
     */
    P1HsB: T;

    /**
     * @default 'Button URL'
     */
    '9lRdM': T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Subject:'
     */
    sHXE7: T;

    /**
     * @default 'Recipient Name'
     */
    yNxhf: T;

    /**
     * @default 'Host Your Event'
     */
    To11c: T;

    /**
     * @default '140 Keller Street #229, Petaluma, CA 94952'
     */
    xqEQs: T;

    /**
     * @default 'Help Center'
     */
    '0H3Rt': T;

    /**
     * @default 'Privacy Policy'
     */
    k1ThL: T;

    /**
     * @default 'Terms and Conditions'
     */
    i5MF4: T;

    /**
     * @default 'This message was sent from withjoy.com on behalf of {{0}}. Send replies to {{1}}.'
     */
    '59Fuw': T;

    /**
     * @default 'This message was sent from withjoy.com on behalf of {{0}}.'
     */
    VnvYf: T;

    /**
     * @default 'Plan your forever, better.'
     */
    NZaqE: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Your message needs more detail so it ends up in your guests' inbox. Please include at least {{0}} characters. Spam filters flag both short and generic content.'
     */
    RIWZR: T;
  };
};

export type MessagingTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Messaging'
     */
    title: T;
  };
  messageList: {
    item: {
      /**
       * @default 'Track'
       */
      track: T;

      /**
       * @default 'Forward'
       */
      forwardIconTitle: T;

      status: {
        /**
         * @default 'Sent'
         */
        sent: T;

        /**
         * @default 'Delivered'
         */
        delivered: T;

        /**
         * @default 'Failed'
         */
        failed: T;

        /**
         * @default 'In Review'
         */
        inReview: T;

        /**
         * @default 'Your message will be sent once it has been reviewed. Please contact support if you have any questions.'
         */
        inReviewTooltip: T;
      };
    };
  };
  messageDetails: {
    /**
     * @default 'Preview as Guest'
     */
    previewAsGuestCta: T;

    /**
     * @default 'Preview'
     */
    previewAsGuestCtaMobile: T;

    /**
     * @default 'Add Recipients'
     */
    addRecipientsCta: T;

    /**
     * @default 'Unable to deliver to this address'
     */
    undeliverableMessage: T;
  };
  home: {
    /**
     * @default 'Message Tracking'
     */
    title: T;

    cards: {
      /**
       * @default 'Cards'
       */
      title: T;

      /**
       * @default 'Save the Dates, Invitations, Thank yous, Enclosure Cards and more.'
       */
      description: T;

      /**
       * @default 'Create Card'
       */
      cta: T;

      /**
       * @default 'Create New Card'
       */
      createNew: T;
    };
    reminders: {
      /**
       * @default 'Reminders'
       */
      title: T;

      /**
       * @default 'Ensure your guests don't forget to RSVP, book their stay and more.'
       */
      description: T;

      /**
       * @default 'Create Reminder'
       */
      cta: T;

      /**
       * @default 'Create New Reminder'
       */
      createNew: T;
    };
    messages: {
      /**
       * @default 'Messages'
       */
      title: T;

      /**
       * @default 'Updates about your event, schedule, and more useful tips for your guests.'
       */
      description: T;

      /**
       * @default 'Create Message'
       */
      cta: T;
    };
    emptyState: {
      noMessages: {
        /**
         * @default 'No New Messages'
         */
        title: T;

        /**
         * @default 'Once you start sending them to your guests, you can view and track them here.'
         */
        description: T;
      };
      messagesAndReminders: {
        /**
         * @default 'Messages and Reminders'
         */
        title: T;

        /**
         * @default 'Send and Easily Track Messages to Your Guests'
         */
        sectionTitle: T;

        bulletPoints: [
          /**
           * @default 'Send a reminder to RSVP'
           */
          T,
          /**
           * @default 'Send details for the shuttle'
           */
          T,
          /**
           * @default 'Send link to book accommodations'
           */
          T,
          /**
           * @default 'Send an update about attire'
           */
          T,
          /**
           * @default 'Share your photo gallery'
           */
          T,
        ];

        /**
         * @default 'and anything else you would like your guests to remember!'
         */
        footer: T;

        /**
         * @default 'New Message'
         */
        cta: T;
      };
      digitalCards: {
        /**
         * @default 'Digital Cards'
         */
        title: T;

        /**
         * @default 'Create and Effortlessly Send Beautiful Digital Cards'
         */
        sectionTitle: T;

        /**
         * @default 'Pick from thousands of Save the Dates, Invitations and Thank you cards designs. Customize them your way, choose a reveal animation and background.'
         */
        description: T;

        /**
         * @default 'Browse Designs'
         */
        cta: T;
      };
    };

    /**
     * @default 'Create'
     */
    createButton: T;

    disclaimer: {
      /**
       * @default 'Can't find older messages?'
       */
      title: T;

      /**
       * @default 'Messages sent before March 1st, 2025 might not show here, we're working hard to backfill older messages.'
       */
      description: T;
    };
    delayDisclaimer: {
      /**
       * @default 'Recently sent a message?'
       */
      title: T;

      /**
       * @default 'Wait a few minutes for it to appear here. Message status could take up to an hour.'
       */
      description: T;
    };
  };
  dropdownItems: {
    cards: {
      /**
       * @default 'Save the Date'
       */
      saveTheDate: T;

      /**
       * @default 'Invitation'
       */
      invitation: T;

      /**
       * @default 'Thank you Card'
       */
      thankYou: T;

      /**
       * @default 'Enclosure Card'
       */
      enclosure: T;
    };
    reminders: {
      /**
       * @default 'RSVP Reminder'
       */
      rsvp: T;

      /**
       * @default 'Hotel Reminder'
       */
      hotel: T;

      /**
       * @default 'General Reminder'
       */
      general: T;
    };
  };
  createOptions: {
    /**
     * @default 'Create'
     */
    title: T;

    /**
     * @default 'Card'
     */
    card: T;

    /**
     * @default 'Reminder'
     */
    reminder: T;

    /**
     * @default 'Custom Message'
     */
    customMessage: T;
  };
  messageListV2: {
    headers: {
      /**
       * @default 'Subject'
       */
      subject: T;

      /**
       * @default 'Message Type'
       */
      messageType: T;

      /**
       * @default 'Date'
       */
      date: T;

      /**
       * @default 'Message Details'
       */
      messageDetails: T;

      status: {
        /**
         * @default 'Sent'
         */
        sent: T;

        /**
         * @default 'Delivered'
         */
        delivered: T;

        /**
         * @default 'Failed'
         */
        failed: T;
      };
    };

    /**
     * @default 'View Details'
     */
    viewDetails: T;
  };
  messageDetailsBottomSheet: {
    /**
     * @default 'Recipient Name'
     */
    recipientNameTitle: T;

    /**
     * @default 'Recipient Email'
     */
    emailTitle: T;

    /**
     * @default 'Status'
     */
    statusTitle: T;

    /**
     * @default 'Details'
     */
    detailsTitle: T;

    /**
     * @default 'View Message'
     */
    viewMessageTitle: T;

    tableHeaders: {
      /**
       * @default 'Recipient Name'
       */
      recipientName: T;

      /**
       * @default 'Recipient Email'
       */
      email: T;

      /**
       * @default 'Status'
       */
      status: T;

      /**
       * @default 'Details'
       */
      details: T;

      /**
       * @default 'View Message'
       */
      viewMessage: T;
    };
  };
  quick: {
    /**
     * @default 'Messaging'
     */
    q8dH3: T;

    /**
     * @default 'Tracking'
     */
    dFG59: T;

    /**
     * @default 'Delivery'
     */
    yBnpo: T;

    /**
     * @default 'Sent'
     */
    oh9MA: T;

    /**
     * @default 'Status'
     */
    '2hCDW': T;

    /**
     * @default 'Latest Activity Date'
     */
    oylKV: T;

    /**
     * @default 'History'
     */
    Afkgo: T;

    /**
     * @default 'View →'
     */
    TVjHd: T;

    /**
     * @default 'Message History'
     */
    bI7u7: T;

    /**
     * @default 'No status history available'
     */
    ECb7M: T;

    /**
     * @default 'View Message →'
     */
    Q5LHy: T;

    /**
     * @default 'Message Details'
     */
    bk8P0: T;

    /**
     * @default 'Resend'
     */
    X5zOS: T;

    /**
     * @default 'Recipient'
     */
    Z1BYT: T;

    /**
     * @default 'General'
     */
    ojXaZ: T;

    /**
     * @default 'Cash Funds'
     */
    rYfN5: T;

    /**
     * @default 'General Message'
     */
    LWh4S: T;

    /**
     * @default 'Digital Card'
     */
    epjCf: T;

    /**
     * @default 'Hotel Reminder'
     */
    kNSK9: T;

    /**
     * @default 'RSVP Reminder'
     */
    d6QBS: T;
  };
};

export type MultiPhotoSelectorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Focus point ensures your image displays well on all devices.'
     */
    FG3cr: T;

    /**
     * @default 'Focus Point'
     */
    '4dv0n': T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    NMFwg: T;

    /**
     * @default 'Crop Photo'
     */
    EnCSr: T;
  };
};

export type PageNotFoundTranslations<T extends LeafNodeValue = TranslateFunction> = {
  pageNotFound: {
    /**
     * @default 'Error on Aisle 404'
     */
    textEyebrow: T;

    /**
     * @default 'Let’s get this cleaned up.'
     */
    textTitle: T;

    /**
     * @default 'That link doesn’t seem to exist.'
     */
    textInfoOne: T;

    /**
     * @default 'Double check it or try one of these options:'
     */
    textInfoTwo: T;

    /**
     * @default 'Find an Event'
     */
    findBtn: T;

    /**
     * @default 'Start a Registry'
     */
    registryBtn: T;

    /**
     * @default 'Explore the Joy Shop'
     */
    shopBtn: T;

    /**
     * @default 'Get Started with Joy'
     */
    getStartedBtn: T;

    /**
     * @default 'Need Help?'
     */
    helpBtn: T;

    /**
     * @default 'Home'
     */
    homeBtn: T;
  };
};

export type PageSettingsDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  pageSettingsDialog: {
    /**
     * @default '{{pageDisplayName}} Settings'
     */
    title: T;

    /**
     * @default 'Hidden'
     */
    hidden: T;

    /**
     * @default 'Public'
     */
    public: T;

    /**
     * @default 'Password Protected'
     */
    passwordProtected: T;

    /**
     * @default 'Save'
     */
    saveButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Password copied.'
     */
    passwordCopiedToast: T;

    /**
     * @default 'Event Password'
     */
    eventPassword: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Please Note:'
     */
    passwordNoteTitle: T;

    /**
     * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
     */
    passwordNoteMessage: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Visibility. Please try again.'
     */
    changeVisibilityFailed: T;

    /**
     * @default 'Your {{resource}} is now {{visibility}}.'
     */
    changeVisibilitySuccessful: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Password. Please try again.'
     */
    changePasswordFailed: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    changePasswordSuccessful: T;

    /**
     * @default 'Your password must be atleast 3 characters and only contain letters, numbers and '!', '&', '+'.'
     */
    passwordError: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Copy'
     */
    copy: T;

    /**
     * @default 'Title'
     */
    titleLabel: T;

    /**
     * @default 'Visibility'
     */
    visibility: T;

    /**
     * @default 'Require password for guest uploads'
     */
    requirePasswordForGuestPhotos: T;

    /**
     * @default 'Note: This will password-protect your entire event for guests using the Joy app.'
     */
    requirePasswordForGuestPhotosNote: T;

    /**
     * @default 'All Pages'
     */
    allPages: T;

    /**
     * @default 'Override your current page visibility settings and set them all to one option.'
     */
    allPagesNote: T;

    /**
     * @default 'Edit Page Photo'
     */
    editPagePhoto: T;

    /**
     * @default 'Copy Event Password'
     */
    copyEventPassword: T;

    /**
     * @default 'Please add a page title.'
     */
    pageTitleRequiredError: T;

    /**
     * @default 'Page title must be less than {{maxLength}} characters long.'
     */
    pageTitleMaxLengthError: T;

    /**
     * @default 'Delete Page'
     */
    deletePageCta: T;

    /**
     * @default 'Page Path'
     */
    pagePath: T;

    /**
     * @default 'Be sure to share the new URL with your guests if you've already shared a link to this page.'
     */
    pagePathNote: T;

    /**
     * @default '{{maxLength}} Max Chars'
     */
    pagePathMax: T;

    /**
     * @default 'This page path is available'
     */
    pagePathAvailable: T;

    /**
     * @default 'This page path is not available.'
     */
    pagePathNotAvailable: T;

    /**
     * @default 'Oops! Something went wrong. 
 Please reload the page and try again.'
*/
    pagePathError: T;

    /**
     * @default 'Coming Soon'
     */
    comingSoon: T;

    /**
     * @default 'Optional'
     */
    optional: T;

    /**
     * @default 'Allow Your Guests to Browse Hotels with Exclusive Rates'
     */
    areYouSure: T;

    /**
     * @default 'We've found that keeping this page on your website encourages guests to book early and confidently plan their attendance, knowing their stays are secured.'
     */
    disableAccommodationNote: T;

    /**
     * @default 'Lowest rates - up to 40% off'
     */
    lowestRatesPossible: T;

    /**
     * @default 'The best rates available through group discounts that is only through your website.'
     */
    lowestRatesPossibleNote: T;

    /**
     * @default 'Help guest decide on attendance'
     */
    helpOnAttendance: T;

    /**
     * @default 'We’ve seen it help out-of-town guests RSVP when they know where they will be staying.'
     */
    helpOnAttendanceNote: T;

    /**
     * @default 'Know where guests are staying'
     */
    whereGuestsAreStaying: T;

    /**
     * @default 'Plan your event better and know where guests will be staying.'
     */
    whereGuestsAreStayingNote: T;

    /**
     * @default 'Keep the Page'
     */
    keepPageCta: T;

    /**
     * @default 'Remove the Page'
     */
    continueCta: T;

    accommodationModalV2: {
      /**
       * @default 'Tests messaging focused on most-visited page angle - emphasizes that this is the most visited page and 80% of guests ask questions'
       */
      _comment: string;

      /**
       * @default 'This is the most visited page for guests.'
       */
      title: T;

      /**
       * @default 'We've found that on average 80% of guests ask questions about accommodations. Having suggestions helps them confidently plan their attendance.'
       */
      description: T;
    };
    accommodationModalV3: {
      /**
       * @default 'Tests messaging focused on RSVP speed benefit - emphasizes 25% faster RSVP rate for couples who list hotels'
       */
      _comment: string;

      /**
       * @default 'Couples who list hotels on Joy see a 25% faster RSVP rate'
       */
      title: T;

      /**
       * @default 'We've found that keeping this page on your website encourages guests to RSVP faster as they can confidently plan their attendance, knowing their stays are secured.'
       */
      description: T;
    };
    accommodationModalV4: {
      /**
       * @default 'Tests messaging focused on guest questions angle - emphasizes that 80% of guests will ask questions and hotel suggestions help'
       */
      _comment: string;

      /**
       * @default 'On average, 80% of guests will ask you questions about place to stay.'
       */
      title: T;

      /**
       * @default 'Couples who list hotels on Joy see a much faster RSVP response. Having hotel suggestions help your guests confidently plan their attendance.'
       */
      description: T;
    };

    /**
     * @default 'Edit Website Header'
     */
    editWebsiteHeader: T;

    customNativePageStep: {
      /**
       * @default 'Did you know?'
       */
      subtitleIntro: T;

      /**
       * @default 'There’s a page for this.'
       */
      subtitle: T;

      /**
       * @default 'We’re always looking to improve our built-in pages. Could you share what made you choose a custom one instead?'
       */
      feedbackSubtitle: T;

      /**
       * @default 'It didn’t work for me because…'
       */
      feedbackPlaceholder: T;

      useNativePage: {
        /**
         * @default 'Use "{{pageName}}" Page'
         */
        title: T;
      };
      useCustomPage: {
        /**
         * @default 'Empty Custom Page'
         */
        title: T;

        /**
         * @default 'Start with a generic blank page I’ll customize myself.'
         */
        subtitle: T;
      };
    };
  };
  quick: {
    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Empty Custom Page'
     */
    FHEQ8: T;

    /**
     * @default 'Start with a generic blank page I'll customize myself.'
     */
    kP0cC: T;
  };
};

export type PhotoPickerDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Select Photo'
     * @param {number} count - The number of occurrences.
     * - zero: Select Photo
     * - singular: Select 1 Photo
     * - plural: Select {{0}} Photos
     */
    ubkwt: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Add to Album'
     */
    douf3: T;

    /**
     * @default 'Select Photo'
     */
    It1n8: T;

    /**
     * @default 'Crop'
     */
    YonKA: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'Select Photos'
     */
    rRf3x: T;

    /**
     * @default 'Select'
     */
    YS91U: T;

    /**
     * @default 'Pick the part of the image that you’d like to show on your site for all desktop devices.'
     */
    UyKOF: T;

    /**
     * @default 'Pick the part of the image that you'd like to show on your site.'
     */
    NMFwg: T;

    /**
     * @default 'Pick the part of the image that you’d like to show on your site for all mobile devices.'
     */
    '0jSCH': T;

    /**
     * @default 'Desktop Crop'
     */
    a66yX: T;

    /**
     * @default 'Mobile Crop'
     */
    '4wt0O': T;

    /**
     * @default 'Desktop'
     */
    UpyS2: T;

    /**
     * @default 'Mobile'
     */
    YsAvF: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;
  };
};

export type PhotoUploaderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default '{{0}} photo(s) failed to upload'
     */
    zECdN: T;

    /**
     * @default 'All photos successfully uploaded'
     */
    P3gVJ: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;

    /**
     * @default 'An error occurred while adding photos to your album. Please try again.'
     */
    h4DHM: T;

    /**
     * @default 'Some of the items could not be added. Please check the album and try again.'
     */
    bJz4t: T;

    /**
     * @default 'Photos added to album.'
     */
    fVd3i: T;

    /**
     * @default 'We support JPEG and PNG images.'
     */
    '32yZ1': T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;
  };
};

export type PlaceToStayComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Edit Place to Stay'
     */
    '7Yj5u': T;

    /**
     * @default 'Add Place to Stay'
     */
    O0HA1: T;

    /**
     * @default 'Update the hotel suggestion for your guests.'
     */
    Zz71B: T;

    /**
     * @default 'Add a hotel suggestion for your guests to make their trip planning easier.'
     */
    Ryz2N: T;

    /**
     * @default 'Search for a hotel'
     */
    UnhAH: T;

    /**
     * @default 'Renaissance Chelsea, New York'
     */
    '0EEYY': T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Booking link'
     */
    X4Knc: T;

    /**
     * @default 'Note for Guests'
     */
    ijXsE: T;

    /**
     * @default 'A note to share with your guests about this hotel.'
     */
    wYK19: T;

    /**
     * @default 'Failed to save place to stay. Please try again.'
     */
    NwgHC: T;

    /**
     * @default 'Place to stay updated successfully.'
     */
    Nv1yJ: T;

    /**
     * @default 'Place to stay saved successfully.'
     */
    P0sxY: T;

    /**
     * @default 'Are you sure you want to delete this place to stay?'
     */
    tWwMI: T;

    /**
     * @default 'The contents of this section will be lost. This action can't be undone.'
     */
    Ddyiq: T;

    /**
     * @default 'Delete Place to Stay'
     */
    aDWC0: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Success! Place to stay has been deleted.'
     */
    c1FTv: T;

    /**
     * @default 'An error occurred while deleting this place to stay. Please try again.'
     */
    PApPT: T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'View Hotel'
     */
    VnGJE: T;

    /**
     * @default 'Place to Stay'
     */
    DpU5D: T;

    /**
     * @default 'NEW'
     */
    KsWAA: T;

    /**
     * @default 'Side by side simple'
     */
    x75ov: T;

    /**
     * @default 'Side by side elegant'
     */
    '3TJIP': T;

    /**
     * @default 'Full width photo'
     */
    D9Rsr: T;

    /**
     * @default 'Flashlight'
     */
    kLQdg: T;

    /**
     * @default 'Select Layout'
     */
    ANUvm: T;

    /**
     * @default 'What's Place to Stay'
     */
    TwBQK: T;

    /**
     * @default 'Quick add hotels or other stays with photos, addresses, and notes.'
     */
    HHfQP: T;
  };
};

export type PlaceToStayGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'View Hotel'
     */
    VnGJE: T;
  };
};

export type PlanningAccommodationsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  topBar: {
    /**
     * @default 'Hotels'
     */
    headerTitle: T;

    /**
     * @default 'Page Settings'
     */
    pageSettings: T;

    /**
     * @default 'Share'
     */
    share: T;

    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Help'
     */
    help: T;

    visibility: {
      /**
       * @default 'Hidden'
       */
      hidden: T;

      /**
       * @default 'Password Protected'
       */
      protected: T;

      /**
       * @default 'Public'
       */
      visible: T;
    };

    /**
     * @default '✨ Link copied! Share it with your guests!'
     */
    linkCopied: T;

    /**
     * @default 'Your page settings has been updated.'
     */
    updateSettingsSuccessful: T;

    /**
     * @default 'An error occurred while updating your page settings. Please try again.'
     */
    updateSettingsFailed: T;

    /**
     * @default 'Explore Hotels'
     */
    exploreHotels: T;
  };
  tabs: {
    /**
     * @default 'Overview'
     */
    overview: T;

    /**
     * @default 'Room Blocks'
     */
    roomBlocks: T;

    /**
     * @default 'Browse'
     */
    browse: T;

    /**
     * @default 'Share'
     */
    share: T;

    /**
     * @default 'Menu'
     */
    menu: T;
  };
  overview: {
    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Your Accommodations'
     */
    yourAccommodations: T;

    zeroState: {
      /**
       * @default 'Introducing Joy Hotels'
       */
      caption: T;

      /**
       * @default 'Discover and share the best hotels with amazing discounts.'
       */
      title: T;

      /**
       * @default 'Amazing deals at top hotels worldwide, shared by other Joy couples. Lock in room blocks for even bigger savings, and easily add hotels to your site so guests can book hassle-free.'
       */
      body: T;

      /**
       * @default 'Learn more about Joy Hotels'
       */
      learnMoreLink: T;

      /**
       * @default 'Popular Hotels near {{nearCity}}'
       */
      popularHotels: T;

      /**
       * @default 'Your Destination'
       */
      yourDestination: T;

      /**
       * @default 'Explore More'
       */
      exploreMore: T;
    };
    noneZeroState: {
      /**
       * @default 'Your Room Blocks'
       */
      caption: T;

      /**
       * @default 'Manage Room blocks'
       */
      title: T;

      requestRoomBlock: {
        /**
         * @default 'Group Reservations with Joy'
         */
        caption: T;

        /**
         * @default 'Request Room Block Rates'
         */
        title: T;

        /**
         * @default 'Your Hotels'
         */
        yourHotels: T;

        /**
         * @default 'Request Room Rates'
         */
        requestRoomRates: T;

        /**
         * @default 'View Your Request'
         */
        viewRequests: T;

        /**
         * @default 'Text Revisions Mode'
         */
        tooltipTitle: T;

        /**
         * @default 'It allows you to fix typographical errors. You can edit all text fields on the card and move elements around. At this point, you cannot change the card specifications.'
         */
        tooltipContent: T;

        /**
         * @default 'Rates are coming in slower than expected but rest assure they’re coming.'
         */
        slowProgressInfoMessage: T;

        /**
         * @default 'An error occurred while submitting your request. Please try again.'
         */
        leadSubmitError: T;

        heading: {
          /**
           * @default 'Your search has begun!'
           */
          workingOnRequest: T;

          /**
           * @default 'We’re reaching out to your hotels.'
           */
          gettingTheBestRates: T;

          /**
           * @default 'Success! We got great rates!'
           */
          ratesReadyForReview: T;

          /**
           * @default 'Your hotel are almost ready.'
           */
          finalizingHotelDeals: T;
        };
        info: {
          /**
           * @default 'We’re assigning your hotel requests to one of our concierge to help you throughout this process. Leave it up to us!'
           */
          workingOnRequest: T;

          /**
           * @default 'We’re working on getting you the best deals. The typical request takes 6 days. We’ll contact you when your rates are ready.'
           */
          gettingTheBestRates: T;

          /**
           * @default 'We’ve received hotel offers and they’re ready for you to review.'
           */
          ratesReadyForReview: T;

          /**
           * @default 'We’re crossing t’s and dotting i’s to make sure your deals are locked in. Your guests will soon have the best deals.'
           */
          finalizingHotelDeals: T;
        };
        progressBarStates: {
          /**
           * @default 'Working on'
           */
          workingOnRequestPart1: T;

          /**
           * @default 'request'
           */
          workingOnRequestPart2: T;

          /**
           * @default 'Getting the'
           */
          gettingTheBestRatesPart1: T;

          /**
           * @default 'Best Rates'
           */
          gettingTheBestRatesPart2: T;

          /**
           * @default 'Rates Ready'
           */
          ratesReadyForReviewPart1: T;

          /**
           * @default 'for Review'
           */
          ratesReadyForReviewPart2: T;

          /**
           * @default 'Finalizing'
           */
          finalizingHotelDetailsPart1: T;

          /**
           * @default 'Hotels Deals'
           */
          finalizingHotelDetailspart2: T;

          /**
           * @default 'Time to'
           */
          timeToPartyParty1: T;

          /**
           * @default 'Party!'
           */
          timeToPartyParty2: T;
        };
      };
      myRoomBlocks: {
        /**
         * @default 'My Room Blocks'
         */
        title: T;

        /**
         * @default 'Text Revisions Mode'
         */
        tooltipTitle: T;

        /**
         * @default 'It allows you to fix typographical errors. You can edit all text fields on the card and move elements around. At this point, you cannot change the card specifications.'
         */
        tooltipContent: T;
      };
      yourRoomBlock: {
        /**
         * @default 'Group Reservations with Joy'
         */
        caption: T;

        /**
         * @default 'Your Room Blocks'
         */
        title: T;

        /**
         * @default 'View Your Reservation'
         */
        viewYourReservation: T;

        /**
         * @default 'Nights Filled:'
         */
        titleV2: T;
      };
      requestGroupRates: {
        /**
         * @default 'Introducing Group Reservations with Joy'
         */
        caption: T;

        /**
         * @default 'Take care of your guests with great rates and no fees.'
         */
        title: T;

        /**
         * @default 'Your personal Joy concierge agent will help you get the best room block rates for you and your guests.'
         */
        body: T;

        /**
         * @default 'Save up to 30% Off Room Rates'
         */
        saveRoomRates: T;

        /**
         * @default 'Zero Deposit Requirements'
         */
        zeroDeposit: T;

        /**
         * @default 'Dedicated Concierge'
         */
        dedicatedConcierge: T;

        /**
         * @default 'Maybe Later'
         */
        maybeLater: T;

        /**
         * @default 'Request Your Group Rates'
         */
        requestYourGroupRates: T;
      };
    };
  };
  firstPartyOverview: {
    heroSection: {
      /**
       * @default 'Introducing'
       */
      caption: T;

      /**
       * @default 'Instant Room Blocks'
       */
      title: T;

      /**
       * @default 'Now you can reserve room blocks instantly from the top hotels near your venue. Together with Joy, each hotel includes exclusive upgrades and the lowest prices to make your event memorable. Share them with guests so they can book hassle-free.'
       */
      body: T;

      /**
       * @default 'Watch the Video'
       */
      watchVideo: T;

      /**
       * @default 'Venue or Destination'
       */
      inputTitle: T;

      /**
       * @default 'Check Availability'
       */
      inputCta: T;
    };
    hotelTileInfo: {
      /**
       * @default 'Joy Certified Celebration Partner Hotels are trusted favorites used by other Joy couples getting married near you and carefully vetted to make sure your event is seamless and stress-free.'
       */
      joyCertifiedCelebration: T;

      /**
       * @default 'Every Room blocks includes exclusive upgrades and perks most asked for by couples and guests. From suite upgrades to early check-in and late checkout to luxury touches like spa treatments and free drinks, it’s more then just a place for guests to stay.'
       */
      everyRoomBlocks: T;

      /**
       * @default 'Discover nearby hotels with guaranteed room blocks for you and your guests without the need to play phone tag with hotel representatives.'
       */
      discoverNearbyHotels: T;

      /**
       * @default 'Joy leverages its collective power from millions of weddings to secure unmatched deals, offering you the lowest possible rates. We did the talking so you don’t have too.'
       */
      joyLeverages: T;

      /**
       * @default 'Lock-in limited rooms with blocks reserved just for Joy events. Calling hotels to get group rates takes an average or 5 days and countless hours for each hotel.'
       */
      lockInLimited: T;
    };
    joyCertification: {
      /**
       * @default 'Joy Certified Celebration Partners'
       */
      title: T;

      /**
       * @default 'Given only to the top hotels and thoughtfully curated, Joy Celebration Hotels highlights hotels known for exceptional service, personalized experiences, and wedding-ready amenities, making them the go-to choice for hosts, guests, and planners. '
       */
      body: T;

      founder: {
        /**
         * @default 'Vishal Joshi'
         */
        title: T;

        /**
         * @default 'Co-Founder & CEO'
         */
        subTitle: T;
      };
      features: {
        /**
         * @default 'What it takes'
         */
        title: T;

        features: [
          {
            /**
             * @default 'A Couple’s Favorite'
             */
            title: T;

            /**
             * @default 'Each hotel is highly rated and favorite among Joy couples getting married nearby.'
             */
            description: T;
          },
          {
            /**
             * @default 'Instant Room Block Reservations'
             */
            title: T;

            /**
             * @default 'Inventory reserved just for Joy couples. Reserve instantly with no deposit required.'
             */
            description: T;
          },
          {
            /**
             * @default 'Exclusive Perks and Upgrades'
             */
            title: T;

            /**
             * @default 'Exclusive and most requested perks for hosts and guests for an all inclusive experience.'
             */
            description: T;
          },
          {
            /**
             * @default 'Lowest Available Rates'
             */
            title: T;

            /**
             * @default 'Zero-hassle and with the lowest transparent room rates without requiring traditional back and forth negotiations. '
             */
            description: T;
          },
          {
            /**
             * @default 'History of Exceptional Service'
             */
            title: T;

            /**
             * @default 'Personalized and exceptional history of service for large group events.'
             */
            description: T;
          },
          {
            /**
             * @default 'Designed for Events'
             */
            title: T;

            /**
             * @default 'Facilities that caters to large events and celebrations. Such as accessible common areas for guests and beautiful event settings.'
             */
            description: T;
          },
        ];
      };
      valueProps: {
        /**
         * @default 'What’s included'
         */
        title: T;

        valueProps: [
          {
            /**
             * @default 'For Hosts'
             */
            tag: T;

            /**
             * @default 'Suite Upgrade'
             */
            caption: T;

            /**
             * @default 'Free upgrade from a standard room to bridal suite or equivalent for the host of the event.'
             */
            title: T;
          },
          {
            /**
             * @default 'Everyone'
             */
            tag: T;

            /**
             * @default 'Check-In & Check-Out'
             */
            caption: T;

            /**
             * @default 'Early check-in and late check-out for you and your guests.'
             */
            title: T;
          },
          {
            /**
             * @default 'Guests'
             */
            tag: T;

            /**
             * @default 'Welcome Bags'
             */
            caption: T;

            /**
             * @default 'Free delivery of host provided welcome bags in every room.'
             */
            title: T;
          },
          {
            /**
             * @default 'Guests'
             */
            tag: T;

            /**
             * @default 'Spa Discount'
             */
            caption: T;

            /**
             * @default 'Up to 20% on spa services like massage facials, and treatments.'
             */
            title: T;
          },
          {
            /**
             * @default 'Guests'
             */
            tag: T;

            /**
             * @default 'Welcome Drink'
             */
            caption: T;

            /**
             * @default 'One complimentary drink per guest, ideally provided on behalf of the couple and Joy.'
             */
            title: T;
          },
          {
            /**
             * @default 'Everyone'
             */
            tag: T;

            /**
             * @default 'Food & Beverage Discount'
             */
            caption: T;

            /**
             * @default '15% discount on food and beverage services, saving up to $150 on meals, drinks, and catering.'
             */
            title: T;
          },
          {
            /**
             * @default 'Everyone'
             */
            tag: T;

            /**
             * @default 'Free Parking'
             */
            caption: T;

            /**
             * @default 'Complimentary for you and your guests, saving $50 per vehicle per day.'
             */
            title: T;
          },
          {
            /**
             * @default 'Everyone'
             */
            tag: T;

            /**
             * @default 'Champagne Welcome'
             */
            caption: T;

            /**
             * @default 'Complimentary champagne or wine, along with a personalized welcome note from hotel management.'
             */
            title: T;
          },
          {
            /**
             * @default 'Guests'
             */
            tag: T;

            /**
             * @default 'Group Pricing Extended to Shoulder Days'
             */
            caption: T;

            /**
             * @default 'Discounted group pricing on shoulder days (surrounding event days) giving you rate flexibility for your guests'
             */
            title: T;
          },
          {
            /**
             * @default 'Everyone'
             */
            tag: T;

            /**
             * @default 'Points for All Reservations'
             */
            caption: T;

            /**
             * @default 'Earn points on all reservations made through Joy, which can be redeemed for future savings.'
             */
            title: T;
          },
        ];
      };
    };
    faqs: {
      questions: [
        {
          /**
           * @default 'How does Joy's zero fee cash gifting work?'
           */
          Q: T;

          /**
           * @default 'We've integrated with your favorite cash-sharing services such as Venmo, PayPal, and Cash App, so that guests can easily and conveniently send funds to couples, without being charged a credit card processing fee or any other fee.'
           */
          A: T;
        },
        {
          /**
           * @default 'What should be on my wedding registry?'
           */
          Q: T;

          /**
           * @default 'It all depends on what you need or want for your wedding or bridal registry. For instance, if you and your partner recently moved in together or bought a new house, your wish list may include a stand mixer, dinnerware, or kitchen gadgets. If you prefer cash gifts to have control over what to buy, you can set up a cash registry and link it to a goal such as a romantic honeymoon or a downpayment on your dream house. Whatever your preferences, be sure to briefly explain your reasoning in a note or on your wedding website.'
           */
          A: T;
        },
        {
          /**
           * @default 'When should we start our registry?'
           */
          Q: T;

          /**
           * @default 'It’s best to start your registry any time between the time you start wedding planning and about 4 months before your wedding day. You’ll likely want to set up your registry before sending out wedding invitations, as guests are likely to want to know by that time.'
           */
          A: T;
        },
        {
          /**
           * @default 'How many gifts should we register for?'
           */
          Q: T;

          /**
           * @default 'When creating your wedding registry, you’ll want to give guests plenty of options, so the best bet is to register for more gifts than you have guests. For example, in a wedding with 90 guests you would want to have at least 100 registry items. You can build registries with multiple brands like Amazon, Bed Bath & Beyond, Crate & Barrel, and Williams-Sonoma, and then sync them all to your Joy registry for an easier guest shopping experience.'
           */
          A: T;
        },
        {
          /**
           * @default 'How can I explain to my guests that we are using a cash registry?'
           */
          Q: T;

          /**
           * @default 'For your family and friends who are more used to gift registries, it’s helpful to include a note explaining what their cash gift will go towards and expressing your gratitude for any amount they are able to give.'
           */
          A: T;
        },
        {
          /**
           * @default 'Is it rude to ask for money instead of wedding gifts?'
           */
          Q: T;

          /**
           * @default 'Not at all! In fact, in many places outside of the US, it’s common (and sometimes expected) to give money in lieu of traditional gifts. In recent years, cash gifting has become more and more popular in the US, as a way of elevating experiences instead of accumulating things, thanks in part to the emergence of cash registry platforms such as Joy and Honeyfund. Check out our article <a class="faq-link" href="https://withjoy.com/blog/cash-wedding-registries-guide/" target="blank">Cash Wedding Registries: An Introductory Guide</a> for best practices on how to navigate the cash ask on your wedding website.'
           */
          A: T;
        },
        {
          /**
           * @default 'How many types of wedding registries should I have?'
           */
          Q: T;

          /**
           * @default 'It’s always good to give your loved ones plenty of gift ideas. Some wedding guests may be uncomfortable with the idea of giving money, so it’s best to include the option of a wedding gift registry as well. '
           */
          A: T;
        },
        {
          /**
           * @default 'Can I send thank-you notes through Joy?'
           */
          Q: T;

          /**
           * @default 'Yes! Joy allows you to keep track of who has given a gift and send guests personalized messages.'
           */
          A: T;
        },
        {
          /**
           * @default 'What does Joy cost?'
           */
          Q: T;

          /**
           * @default 'Joy wedding websites, planning tools, registry, and online RSVP are free! Paper wedding invitations come in a range of price and style options, and all include free back-of-card printing and free recipient and return address printing. On a tight budget? Mix and match Joy’s digital and paper cards to save money on paper and postage. Hundreds of digital wedding invitation designs are available to send for free.'
           */
          A: T;
        },
        {
          /**
           * @default 'Do you have a support team we can reach out to if we have questions?'
           */
          Q: T;

          /**
           * @default 'Absolutely! Our amazing support team works hard around the clock, every day of the week, including weekends, to make sure that your questions are answered. You can send us an email at support@withjoy.com.'
           */
          A: T;
        },
      ];
    };
  };
  browse: {
    /**
     * @default 'Venue'
     */
    venue: T;

    /**
     * @default 'Show More'
     */
    showMore: T;

    /**
     * @default 'Add Manually'
     */
    addCustomLink: T;

    /**
     * @default 'Can't find your hotel? Add your own listing.'
     */
    cantFindHotel: T;

    /**
     * @default 'Our Top Picks'
     */
    filterPopularity: T;

    /**
     * @default 'Distance'
     */
    filterDistance: T;

    /**
     * @default 'Top Picks'
     */
    topPicks: T;

    /**
     * @default '{{ price }} / night'
     */
    pricePerNight: T;

    /**
     * @default 'An error occurred while updating hotel order. Please try again.'
     */
    changeBlockOrderFailed: T;

    /**
     * @default '{{ count }} hotels near the venue'
     */
    hotelsNear: T;

    /**
     * @default 'Price'
     */
    price: T;

    /**
     * @default 'Rating'
     */
    rating: T;

    hotelItem: {
      /**
       * @default 'Add Hotel'
       */
      addHotelTxt: T;

      /**
       * @default 'miles away'
       */
      distance: T;

      /**
       * @default 'Remove Hotel'
       */
      removeHotelTxt: T;

      /**
       * @default 'Request Group Rates'
       */
      requestGroupRates: T;

      /**
       * @default 'View Your Request'
       */
      viewYourRequest: T;

      /**
       * @default 'Interested Property'
       */
      interestedLabel: T;

      /**
       * @default 'Read More'
       */
      readMore: T;

      /**
       * @default 'Read Less'
       */
      readLess: T;

      /**
       * @default 'Need a room block?'
       */
      preferredHotelTooltipTitle: T;

      /**
       * @default 'Get a room block with one of Joy's partner hotels and get the best group rates fast. We hand picked these properties based on reviews from other Joy couples, competitive rates, and a great fit for larger groups. '
       */
      preferredHotelTooltipDescription: T;

      /**
       * @default 'Get Started'
       */
      getStarted: T;

      /**
       * @default 'Room Block Requested'
       */
      roomBlockRequested: T;

      /**
       * @default 'Our Room Block'
       */
      ourRoomBlock: T;

      /**
       * @default 'Couple Favorite'
       */
      preferredHotelMobileViewLabel: T;

      /**
       * @default 'View Hotel'
       */
      viewHotel: T;

      /**
       * @default 'Group Rate'
       */
      groupRate: T;

      /**
       * @default 'Standard Price'
       */
      standardPrice: T;

      ratingCategory: {
        /**
         * @default 'Wonderful'
         */
        wonderful: T;

        /**
         * @default 'Excellent'
         */
        excellent: T;

        /**
         * @default 'Fabulous'
         */
        fabulous: T;

        /**
         * @default 'Very Good'
         */
        veryGood: T;

        /**
         * @default 'Good'
         */
        good: T;

        /**
         * @default 'Pleasant'
         */
        pleasant: T;

        /**
         * @default 'Fair'
         */
        fair: T;
      };

      /**
       * @default '{{miles}} miles away'
       */
      milesAway: T;

      /**
       * @default '{{minutes}} min walk'
       * @param {number} count - The number of occurrences.
       * - singular: {{minutes}} min walk
       * - plural: {{minutes}} min drive
       */
      venueDistance: T;

      /**
       * @default '{{rooms}} rooms'
       */
      roomsTotal: T;

      /**
       * @default 'Compared to'
       */
      comparedTo: T;

      /**
       * @default 'Starting at'
       */
      startingAt: T;

      /**
       * @default '{{reviews}} reviews'
       */
      reviews: T;
    };
    noResults: {
      /**
       * @default 'Sorry, no results found.'
       */
      label: T;

      /**
       * @default 'Update your search area to see hotel options.'
       */
      eyeBrow: T;
    };
    failedSearchApi: {
      /**
       * @default 'Sorry, something went wrong.'
       */
      label: T;

      /**
       * @default 'An error occurred while retrieving hotel information.'
       */
      eyeBrow: T;

      /**
       * @default 'Try Again'
       */
      cta: T;
    };
    manualItem: {
      /**
       * @default 'Not finding what you’re looking for?'
       */
      label: T;

      /**
       * @default 'Manually Add Hotel'
       */
      manualAddCTA: T;

      /**
       * @default 'Contact Concierge Team'
       */
      buttonCTA: T;

      /**
       * @default 'Chat'
       */
      intercomButtonCTA: T;
    };
    starRatingFilter: {
      /**
       * @default 'Star Rating'
       */
      title: T;

      /**
       * @default 'Hotel quality—1 star is basic, 5 stars is luxe'
       */
      description: T;

      /**
       * @default 'Reset Filter'
       */
      resetFilter: T;

      /**
       * @default '{{ rating }} Star'
       */
      star: T;

      /**
       * @default 'Done'
       */
      done: T;
    };
    priceFilter: {
      /**
       * @default 'Price range'
       */
      title: T;

      /**
       * @default 'Nightly Price, includes all taxes and fees'
       */
      description: T;

      /**
       * @default 'Min'
       */
      min: T;

      /**
       * @default 'Max'
       */
      max: T;

      /**
       * @default 'Reset Filter'
       */
      resetFilter: T;

      /**
       * @default 'Done'
       */
      done: T;
    };
    sortComponent: {
      /**
       * @default 'Sort by'
       */
      title: T;

      /**
       * @default 'Top picks ranked by Joy using couple preferences, amenities, and venue distance.'
       */
      topPicksDescription: T;

      /**
       * @default 'Show hotels based on distance starting with the closest to your venue.'
       */
      distanceDescription: T;

      /**
       * @default 'Top Picks'
       */
      topPicks: T;

      /**
       * @default 'Distance from Venue'
       */
      distance: T;

      /**
       * @default 'Done'
       */
      done: T;
    };
    informativeDialog: {
      /**
       * @default 'What happens next?'
       */
      title: T;

      /**
       * @default 'Select hotels near your venue and let our concierge team do the work of negotiating discounted rates.'
       */
      item1: T;

      /**
       * @default 'Review your personalized hotel group rates with your personal concierge and select your favorite hotel for your guests.'
       */
      item2: T;

      /**
       * @default 'View Hotels'
       */
      btn: T;

      ourPicks: {
        /**
         * @default 'Why add hotels to your website?  ✨ '
         */
        title: T;

        picks: [
          {
            /**
             * @default 'Save Guests Money'
             */
            title: T;

            /**
             * @default 'Because we help millions of guests, we are able to get cheaper group rates than Expedia—up to 40% off nightly rates.'
             */
            subTitle: T;
          },
          {
            /**
             * @default 'Something for Everyone'
             */
            title: T;

            /**
             * @default 'A range of price points that include hotels with the best event friendly amenities.'
             */
            subTitle: T;
          },
          {
            /**
             * @default 'Stay Close to the Venue'
             */
            title: T;

            /**
             * @default 'Balancing travel time and distance, we’ve picked the most popular and conveniently located hotels near your event.'
             */
            subTitle: T;
          },
        ];
      };
    };
    addManuallyDialog: {
      /**
       * @default 'Manually add hotel'
       */
      title: T;

      /**
       * @default 'Search for hotels'
       */
      label: T;

      /**
       * @default 'Hotel Name'
       */
      placeholder: T;

      /**
       * @default 'Add Hotel'
       */
      addHotelCTA: T;

      /**
       * @default 'Remove Hotel'
       */
      removeHotelCTA: T;
    };

    /**
     * @default 'An error occurred while saving your accommodations place. Please try again.'
     */
    addAccommodationsPlaceFailed: T;

    /**
     * @default 'An error occurred while deleting your hotel. Please try again.'
     */
    deleteAccommodationsPlaceFailed: T;

    /**
     * @default '✨ Hotel added to page'
     */
    addedToPageSuccess: T;

    /**
     * @default '✨ Hotel removed from page'
     */
    removedFromPageSuccess: T;
  };
  firstPartyBrowse: {
    /**
     * @default 'Venue or Destination'
     */
    locationLabel: T;

    /**
     * @default 'View Hotel'
     */
    viewHotel: T;

    /**
     * @default 'Add Hotel'
     */
    addHotelTxt: T;

    /**
     * @default 'Remove Hotel'
     */
    removeHotelTxt: T;

    hotelCard: {
      /**
       * @default '️⚡️ Likely to Sell Out'
       */
      likelyToSellOut: T;

      /**
       * @default '{{miles}} miles from venue'
       */
      milesFromVenue: T;

      /**
       * @default '12 Exclusive Upgrades'
       */
      exclusiveUpgrades: T;

      /**
       * @default 'Upgrade from standard to suite'
       */
      propsUpgrade: T;

      /**
       * @default 'Early Check-in and Late Check-out'
       */
      propsEarlyCheckInOut: T;

      /**
       * @default 'Free welcome drink on check-in'
       */
      propsFreeWelcomeDrink: T;

      /**
       * @default 'Group Rate'
       */
      groupRate: T;

      /**
       * @default 'Per Night'
       */
      perNight: T;

      /**
       * @default '{{percent}}% Off'
       */
      off: T;

      /**
       * @default 'Compared to'
       */
      comparedTo: T;

      /**
       * @default 'See Room Block Offer 🎉'
       */
      seeRoomBlockOffer: T;

      /**
       * @default 'Text Revisions Mode'
       */
      tooltipTitle: T;

      /**
       * @default 'It allows you to fix typographical errors. You can edit all text fields on the card and move elements around. At this point, you cannot change the card specifications.'
       */
      tooltipContent: T;
    };
  };
  share: {
    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Save Guest Note'
     */
    saveGuestNote: T;

    /**
     * @default 'Edit Guest Note'
     */
    editGuestNote: T;

    /**
     * @default '✨ Couple note has been updated.'
     */
    coupleNoteUpdateSuccess: T;

    /**
     * @default 'An error occurred while updating couple note. Please try again.'
     */
    coupleNoteUpdateFailed: T;

    /**
     * @default 'Add Hotels'
     */
    addHotels: T;

    /**
     * @default 'Add Hotel'
     */
    addHotelTxt: T;

    /**
     * @default 'Remove Hotel'
     */
    removeHotelTxt: T;

    /**
     * @default 'Remove Custom Property'
     */
    removeCustomPropertyTxt: T;

    /**
     * @default 'Remove Room Block'
     */
    removeRoomBlockTxt: T;

    /**
     * @default 'Request Group Rates'
     */
    requestGroupRates: T;

    /**
     * @default 'Requested Group Rates'
     */
    requestedGroupRates: T;

    /**
     * @default 'Reserved Room Blocks'
     */
    reservedRoomBlocks: T;

    /**
     * @default 'View Your Request'
     */
    viewYourRequest: T;

    /**
     * @default 'Select Hotel'
     */
    selectHotel: T;

    /**
     * @default 'View Hotel'
     */
    viewHotel: T;

    /**
     * @default 'No Hotel Room Blocks Reserved.'
     */
    noRoomBlocks: T;

    /**
     * @default 'Find Hotels Room Blocks'
     */
    findRoomBlocks: T;

    /**
     * @default 'Find More Hotels Room Blocks'
     */
    findMoreRoomBlocks: T;

    /**
     * @default 'No Hotels Added.'
     */
    noHotels: T;

    /**
     * @default 'You can’t drag an item 
 above your preferred hotel.'
*/
    changeOrderInfo: T;

    /**
     * @default 'An error occurred while updating hotel order. Please try again.'
     */
    changeBlockOrderFailed: T;

    /**
     * @default 'Your Hotel order has been updated.'
     */
    changeBlockOrderSuccess: T;

    cards: {
      hotel: {
        /**
         * @default 'Add, edit or rearrange your hotels'
         */
        title: T;

        /**
         * @default 'Text Revisions Mode'
         */
        tooltipTitle: T;

        /**
         * @default 'It allows you to fix typographical errors. You can edit all text fields on the card and move elements around. At this point, you cannot change the card specifications.'
         */
        tooltipContent: T;
      };
      coupleNote: {
        /**
         * @default 'Note To Guests'
         */
        title: T;

        /**
         * @default 'Text Revisions Mode'
         */
        tooltipTitle: T;

        /**
         * @default 'It allows you to fix typographical errors. You can edit all text fields on the card and move elements around. At this point, you cannot change the card specifications.'
         */
        tooltipContent: T;
      };
      roomBlocks: {
        /**
         * @default 'Hotel Room Blocks'
         */
        title: T;

        /**
         * @default 'Text Revisions Mode'
         */
        tooltipTitle: T;

        /**
         * @default 'It allows you to fix typographical errors. You can edit all text fields on the card and move elements around. At this point, you cannot change the card specifications.'
         */
        tooltipContent: T;
      };
      addHotel: {
        /**
         * @default 'Hotels & Accommodations'
         */
        title: T;

        /**
         * @default 'Text Revisions Mode'
         */
        tooltipTitle: T;

        /**
         * @default 'It allows you to fix typographical errors. You can edit all text fields on the card and move elements around. At this point, you cannot change the card specifications.'
         */
        tooltipContent: T;
      };
    };
    delete: {
      /**
       * @default 'Are you sure you want to delete this item?'
       */
      title: T;

      /**
       * @default 'This cannot be undone.'
       */
      message: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Success! Accommodation have been deleted.'
       */
      deleteAccommodationSuccess: T;

      /**
       * @default 'An error occurred while deleting your accommodation. Please try again.'
       */
      deleteAccommodationFailed: T;

      travelMapVenue: {
        /**
         * @default 'Delete Venue'
         */
        deleteCta: T;
      };
      travelMapHotels: {
        /**
         * @default 'Delete Hotel'
         */
        deleteCta: T;
      };
      travelMapAccommodationsHotel: {
        /**
         * @default 'Delete Accommodation'
         */
        deleteCta: T;
      };
      travelMapAccommodationsCustom: {
        /**
         * @default 'Delete Custom Property'
         */
        deleteCta: T;
      };
      travelMapAccommodationsRoomblock: {
        /**
         * @default 'Delete Room Block'
         */
        deleteCta: T;
      };
    };
  };
  roomBlocks: {
    /**
     * @default 'Request room blocks'
     */
    title: T;

    /**
     * @default 'Amazing deals at top hotels worldwide, shared by other Joy couples. Lock in room blocks for even bigger savings, and easily add hotels to your site so guests can book hassle-free.'
     */
    body: T;

    /**
     * @default 'Learn more about Room Blocks'
     */
    learnMoreLink: T;

    /**
     * @default 'Selected Hotels'
     */
    selectedHotels: T;

    /**
     * @default 'Request Group Rates'
     */
    requestGroupRates: T;

    /**
     * @default 'Select More Hotels'
     */
    selectMoreHotels: T;
  };
  hotelPdpDialog: {
    /**
     * @default '{{miles}} miles away'
     */
    milesAway: T;

    /**
     * @default 'Night'
     */
    night: T;

    /**
     * @default 'Exclusive block rate for our guests!'
     */
    exclusiveBlockRate: T;

    /**
     * @default 'View Hotel'
     */
    viewHotel: T;

    /**
     * @default 'More'
     */
    readMore: T;

    /**
     * @default 'Less'
     */
    readLess: T;
  };
  firstPartyExclusiveUpgradesDialog: {
    /**
     * @default 'Exclusive Upgrades'
     */
    title: T;

    /**
     * @default 'This Joy Certified Hotel includes the following exclusive upgrades for your event.'
     */
    body: T;

    upgrades: [
      {
        /**
         * @default 'Suite Room Upgrade'
         */
        title: T;

        /**
         * @default 'Free upgrade from a standard room to bridal suite or equivalent for the host of the event.'
         */
        body: T;
      },
      {
        /**
         * @default 'Early Check-In and Late Check-Out'
         */
        title: T;

        /**
         * @default 'Early check-in at 1pm instead of 3pm and late check-out changed from 11am to 1pm for you and all your guests.'
         */
        body: T;
      },
      {
        /**
         * @default 'Champagne Welcome'
         */
        title: T;

        /**
         * @default 'Complimentary champagne or wine, along with a personalized welcome note from hotel management.'
         */
        body: T;
      },
      {
        /**
         * @default 'Spa Discounts'
         */
        title: T;

        /**
         * @default 'Discount of 20% on spa services, saving up to $200 on massages, facials, and treatments.'
         */
        body: T;
      },
      {
        /**
         * @default 'Welcome Drink'
         */
        title: T;

        /**
         * @default 'One complimentary drink per guest, ideally provided on behalf of the couple and Joy.'
         */
        body: T;
      },
      {
        /**
         * @default 'Food & Beverage Discount'
         */
        title: T;

        /**
         * @default '15% discount on food and beverage services, saving up to $150 on meals, drinks, and catering.'
         */
        body: T;
      },
      {
        /**
         * @default 'Free Parking'
         */
        title: T;

        /**
         * @default 'Complimentary for you and your guests, saving $50 per vehicle per day.'
         */
        body: T;
      },
      {
        /**
         * @default 'Welcome Bags'
         */
        title: T;

        /**
         * @default 'Free delivery of couple-provided welcome bags to guest rooms, a thoughtful and convenient service.'
         */
        body: T;
      },
      {
        /**
         * @default 'Group Pricing Extended to Shoulder Days'
         */
        title: T;

        /**
         * @default 'Discounted group pricing on shoulder days (surrounding event days) giving you rate flexibility for your guests'
         */
        body: T;
      },
      {
        /**
         * @default 'Points for All Reservations'
         */
        title: T;

        /**
         * @default 'Earn points on all reservations made through Joy, which can be redeemed for future savings.'
         */
        body: T;
      },
    ];
  };
  firstPartyHotelDialog: {
    /**
     * @default 'Venue'
     */
    venue: T;

    /**
     * @default 'See all {{count}} reviews'
     */
    seeAllReviews: T;

    ratingCategory: {
      /**
       * @default 'Excellent'
       */
      excellent: T;

      /**
       * @default 'Very Good'
       */
      veryGood: T;

      /**
       * @default 'Good'
       */
      good: T;

      /**
       * @default 'Fair'
       */
      fair: T;

      /**
       * @default 'Poor'
       */
      poor: T;

      /**
       * @default 'Terrible'
       */
      terrible: T;
    };

    /**
     * @default 'A couple favorite with exclusive room block pricing & upgrades'
     */
    favoriteNote: T;

    /**
     * @default 'Included Upgrades'
     */
    includedUpgrades: T;

    /**
     * @default 'Title'
     */
    upgradesTooltipTitle: T;

    /**
     * @default 'Content'
     */
    upgradesTooltipBody: T;

    /**
     * @default 'See all {{count}} upgrades'
     */
    seeAllUpgrades: T;

    upgrades: [
      {
        /**
         * @default 'Room Upgrade'
         */
        title: T;

        /**
         * @default 'Guaranteed suite or equivalent upgrade for the host.'
         */
        body: T;
      },
      {
        /**
         * @default 'Check In & Out'
         */
        title: T;

        /**
         * @default 'Early check-in and late check-out for you and your guests.'
         */
        body: T;
      },
      {
        /**
         * @default 'Welcome Bags'
         */
        title: T;

        /**
         * @default 'Free delivery of host welcome bags in every room.'
         */
        body: T;
      },
    ];

    /**
     * @default 'Why it’s Our Pick'
     */
    whyItsOurPick: T;

    /**
     * @default 'Title'
     */
    ourPickTooltipTitle: T;

    /**
     * @default 'Content'
     */
    ourPickTooltipBody: T;

    /**
     * @default 'Couple’s Favorite'
     */
    couplesFavorite: T;

    /**
     * @default 'Highly rated and favorite among Joy couples.'
     */
    couplesFavoriteBody: T;

    /**
     * @default 'Instant Room Block Reservation'
     */
    instantReservation: T;

    /**
     * @default 'Reserve instantly with no deposit required.'
     */
    instantReservationBody: T;

    /**
     * @default '{{drive}} min drive or {{walk}} min walk from your venue'
     */
    easilyAccessible: T;

    /**
     * @default 'Hotel is easily accessible from your venue.'
     */
    easilyAccessibleBody: T;

    /**
     * @default 'Read More'
     */
    readMore: T;

    /**
     * @default 'Show Less'
     */
    showLess: T;

    /**
     * @default '{{miles}} miles from venue'
     */
    milesFromVenue: T;

    /**
     * @default '{{walk}} min walk from venue'
     */
    walkFromVenue: T;

    /**
     * @default '{{drive}} min drive from venue'
     */
    driveFromVenue: T;

    /**
     * @default '{{min}} min from {{location}}'
     */
    fromLocation: T;

    /**
     * @default 'Front Desk'
     */
    frontDesk: T;
  };
  instantRoomBlockForm: {
    /**
     * @default 'Reserve Your Room Block'
     */
    title: T;

    /**
     * @default 'Your Room Blocks'
     */
    titleView: T;

    /**
     * @default 'Event Date'
     */
    eventDate: T;

    /**
     * @default 'Guest Count'
     */
    guestCount: T;

    /**
     * @default 'Add Guests'
     */
    addGuests: T;

    /**
     * @default ' Guests'
     */
    guests: T;

    /**
     * @default 'Title'
     */
    guestCountTooltipTitle: T;

    /**
     * @default 'Content'
     */
    guestCountTooltipBody: T;

    /**
     * @default 'Rooms Per Night'
     */
    roomsPerNight: T;

    /**
     * @default 'Title'
     */
    roomsPerNightTooltipTitle: T;

    /**
     * @default 'Content'
     */
    roomsPerNightTooltipBody: T;

    /**
     * @default 'Only '
     */
    only: T;

    /**
     * @default '% Off'
     */
    off: T;

    /**
     * @default 'Night'
     */
    night: T;

    /**
     * @default ' and '
     */
    and: T;

    /**
     * @default ' more '
     */
    more: T;

    /**
     * @default 'Reserve Room Blocks'
     */
    reserveRoomBlocks: T;

    /**
     * @default 'Reserve now & confirm later. We’ll hold your room block for 48 hr.'
     */
    note: T;

    /**
     * @default 'Block Left'
     */
    blockLeft: T;

    /**
     * @default '⚡️ Likely to Sell Out'
     */
    likelyToSellOut: T;

    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;

    /**
     * @default 'Add a date'
     */
    addADatePlaceholder: T;

    /**
     * @default '10'
     */
    numberOfRoomsPlaceholder: T;

    /**
     * @default 'Please add a check in date.'
     */
    checkInDateError: T;

    /**
     * @default 'Please add a check out date.'
     */
    checkOutDateError: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    checkInDateRangeError: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    checkOutDateRangeError: T;

    /**
     * @default 'Please enter the number of rooms.'
     */
    numberOfRoomsError: T;

    /**
     * @default 'Please enter a valid number of rooms.'
     */
    numberOfRoomsTypeError: T;

    /**
     * @default 'Please add the number of guests.'
     */
    numberOfGuestError: T;

    /**
     * @default 'Please add a event date.'
     */
    eventDateError: T;

    /**
     * @default 'Minimum is 10'
     */
    minNumberError: T;

    /**
     * @default 'Maximum is 999'
     */
    maxNumberError: T;

    /**
     * @default 'Must be a number'
     */
    mustBeNumberError: T;

    /**
     * @default 'Group Pricing'
     */
    groupPricing: T;

    /**
     * @default 'View Hotel'
     */
    viewHotel: T;
  };

  /**
   * @default 'Starting From <StrikeOutPrice/> <PricePerNight/>'
   */
  startingFrom: T;

  /**
   * @default '<ExpediaAndOthers/> and others'
   */
  expediaAndOthers: T;

  hotelSearch: {
    /**
     * @default 'Check in'
     */
    checkIn: T;

    /**
     * @default 'Check out'
     */
    checkOut: T;

    /**
     * @default 'Add dates'
     */
    addDates: T;

    /**
     * @default 'City or Venue'
     */
    cityOrVenue: T;

    /**
     * @default 'Check in'
     */
    checkInFallback: T;

    /**
     * @default 'Check out'
     */
    checkOutFallback: T;

    /**
     * @default 'Rooms Needed'
     */
    roomsNeeded: T;

    /**
     * @default 'Guests'
     */
    guests: T;

    /**
     * @default 'Search For Hotels'
     */
    searchForHotels: T;

    /**
     * @default 'Search'
     */
    search: T;

    /**
     * @default 'Rooms needed'
     */
    roomsNeededLabel: T;

    /**
     * @default 'Just an estimate'
     */
    justAnEstimate: T;

    /**
     * @default 'More than 50'
     */
    moreThan50: T;
  };
  quick: {
    /**
     * @default 'Venue'
     */
    tdqJH: T;

    /**
     * @default 'Show List'
     */
    FYmIB: T;

    /**
     * @default 'Show Map'
     */
    DQ7y6: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;
  };
};

export type PostOfficeTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Send General Message'
     */
    generic: T;

    /**
     * @default 'Send Reminder'
     */
    reminder: T;

    /**
     * @default 'Send Thank You'
     */
    thankyou: T;
  };
  emailEditor: {
    /**
     * @default 'Edit Email'
     */
    header: T;

    /**
     * @default 'Email Subject'
     */
    emailSubjectLabel: T;

    /**
     * @default 'Don’t forget about the wedding rehearsal!'
     */
    emailSubjectPlaceholder: T;

    /**
     * @default 'Email Subject is required'
     */
    emailSubjectErrorMessage: T;

    /**
     * @default 'Reply-to Email'
     */
    replyToLabel: T;

    /**
     * @default 'Reply-to Email is required'
     */
    replyToErrorMessage: T;

    /**
     * @default 'Message'
     */
    messageLabel: T;

    /**
     * @default 'Message to our guest'
     */
    messagePlaceholder: T;

    emailEditorOptions: [
      {
        /**
         * @default 'Include link to download Joy app'
         */
        hed: T;

        /**
         * @default 'Guests can view & share photos and stay up-to-date on the go.'
         */
        dek: T;
      },
      {
        /**
         * @default 'Include link to your website'
         */
        hed: T;

        /**
         * @default 'Guests can visit your website for wedding details.'
         */
        dek: T;
      },
      {
        /**
         * @default 'Include event password'
         */
        hed: T;

        /**
         * @default 'Guests need an event password to gain access to your website and app.'
         */
        dek: T;
      },
    ];

    /**
     * @default 'Save'
     */
    doneButtonText: T;

    /**
     * @default 'Cancel'
     */
    cancelButtonText: T;

    /**
     * @default 'Discard'
     */
    discardButtonText: T;

    /**
     * @default 'Unsaved Changes'
     */
    undavedChangesWarningHed: T;

    /**
     * @default 'Are you sure you want to stop editing your digital message? Doing so will discard all unsaved changes.'
     */
    undavedChangesWarningDek: T;

    /**
     * @default 'Password is required when you include link to download the Joy app.'
     */
    passwordToggleTooltip: T;

    /**
     * @default 'Sorry. Something went wrong. Try again later.'
     */
    saveDraftError: T;

    /**
     * @default 'Salutation'
     */
    salutationLabel: T;

    /**
     * @default 'Hello'
     */
    salutationPlaceholder: T;

    /**
     * @default 'Include guest name(s)'
     */
    includeGuestNamesLabel: T;

    /**
     * @default 'Generating first draft...'
     */
    generatingDraft: T;
  };
  bottomSheet: {
    sendAndTrack: {
      /**
       * @default 'Send and Track'
       */
      title: T;

      /**
       * @default 'Keep an eye on replies and poke the slow pokes.'
       */
      description: T;

      /**
       * @default 'Send to 1 Person'
       */
      sendToSingular: T;

      /**
       * @default 'Send to {{count}} People'
       */
      sendTo: T;

      /**
       * @default 'Send to {{name}}'
       */
      sendToName: T;

      /**
       * @default 'Send to (No Guests Selected)'
       */
      sendToDisabled: T;
    };
    confirm: {
      /**
       * @default 'Your message has been sent'
       */
      title: T;

      /**
       * @default 'Your thank you note has been sent'
       */
      titleThankYou: T;

      /**
       * @default 'Your email has been sent to {{count}} guests. Track which guests have received and opened your card in Guest List.'
       */
      description: T;

      /**
       * @default 'An email has been sent to {{ name }}.'
       */
      descriptionThankYouName: T;

      /**
       * @default 'An email has been sent to {{ count }} People.'
       */
      descriptionThankYouCount: T;

      /**
       * @default 'Back to Dashboard'
       */
      button: T;

      /**
       * @default 'Thank Another Guest'
       */
      buttonThankYou: T;
    };
    designEmail: {
      /**
       * @default 'Design Email'
       */
      title: T;

      /**
       * @default 'Preview and edit your message to your guests.'
       */
      description: T;

      /**
       * @default 'Edit Email'
       */
      editEmail: T;
    };
    designEcard: {
      /**
       * @default 'Design Card'
       */
      title: T;

      /**
       * @default 'Upload your design and edit your message content.'
       */
      description: T;

      /**
       * @default 'Edit Card'
       */
      editEmail: T;
    };
    optionalTestEmail: {
      /**
       * @default 'Optional Test Email'
       */
      title: T;

      /**
       * @default 'Never hurts to make sure everything is just right.'
       */
      description: T;

      /**
       * @default 'Send Test'
       */
      sendTest: T;
    };
    selectRecipients: {
      /**
       * @default 'Select Recipients'
       */
      title: T;

      /**
       * @default 'Edit Guests'
       */
      editGuests: T;

      /**
       * @default 'Add Guests'
       */
      addGuests: T;

      /**
       * @default 'Share With a Link'
       */
      shareLink: T;

      /**
       * @default 'Easily share a direct link to your eCards with anyone.'
       */
      shareLinkDescription: T;

      /**
       * @default 'Copy Link'
       */
      shareLinkCTA: T;

      /**
       * @default 'Delivery Method'
       */
      deliveryMethod: T;

      /**
       * @default 'How would you like to share your eCard?'
       */
      deliveryMethodDescription: T;

      /**
       * @default 'Send by Email'
       */
      deliveryMethodEmailCTA: T;

      /**
       * @default 'Share with a Link'
       */
      deliveryMethodLinkCTA: T;
    };
  };
  defaults: {
    generic: {
      /**
       * @default 'A new outdoor location'
       */
      subject: T;

      /**
     * @default 'With the storm no longer in the forecast, we're happy to be able to move the reception outside.

After the ceremony, please arrive at the park by 6pm.'
*/
      message: T;

      /**
       * @default 'Hello'
       */
      salutation: T;
    };
    reminder: {
      /**
       * @default 'It's almost time…'
       */
      subject: T;

      /**
     * @default 'We know you're busy (trust us, we're planning a wedding, so we know busy), but we just wanted to send a friendly reminder about some of our wedding details.

We can't wait to see you at the wedding!'
*/
      message: T;

      /**
       * @default 'Hello'
       */
      salutation: T;
    };
    thankyou: {
      /**
       * @default 'Thank you!'
       */
      subject: T;

      /**
     * @default 'Thank you so much for celebrating with us on our special day! We are grateful for your presence, warm wishes, and generous gifts.

We look forward to our future together and making more memories with you!'
*/
      message: T;
    };
  };
  quick: {
    /**
     * @default 'No guests selected yet.'
     * @param {number} count - The number of occurrences.
     * - zero: No guests selected yet.
     * - singular: 1 guest selected.
     * - plural: {{0}} guests selected.
     */
    t0nZk: T;

    /**
     * @default 'Select recipients to send your message'
     */
    TcLCM: T;

    /**
     * @default 'Social'
     */
    XYZoV: T;
  };
};

export type ProductSelectionDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  text: {
    /**
     * @default 'What would you like to use?'
     */
    title: T;

    /**
     * @default 'Select all that interest you. You can always change your mind later.'
     */
    subtitle: T;

    /**
     * @default 'Website'
     */
    website: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Cards & Messaging'
     */
    invitations: T;

    /**
     * @default 'Guest List & RSVP'
     */
    guestList: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Your interests were updated successfully'
     */
    success: T;

    /**
     * @default 'An error occurred while updating your interests'
     */
    error: T;
  };
};

export type PublishReminderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Close'
   */
  close: T;

  /**
   * @default 'Not seeing your design changes? Check that you’ve applied changes in the '
   */
  message: T;

  /**
   * @default 'website designer'
   */
  linkText: T;

  quick: {
    /**
     * @default 'Your website is hidden from guests for now. Publish before sharing.'
     */
    Co1yR: T;

    /**
     * @default 'Your website is hidden from guests for now. Publish it when you’re ready to share.'
     */
    OQQS1: T;

    /**
     * @default 'Publish Website'
     */
    C04Ki: T;

    /**
     * @default '🥳 Your website has been successfully published!'
     */
    rQbtw: T;

    /**
     * @default '😬 Failed to publish website. Please try again.'
     */
    QWLqh: T;

    /**
     * @default 'Your website is hidden from guests for now. Publish it when you're ready to share.'
     */
    qDmAQ: T;

    /**
     * @default 'Publish'
     */
    PqFdr: T;

    /**
     * @default 'Your 'Where to Stay' page is hidden from guests.'
     */
    '4VyRZ': T;

    /**
     * @default 'Your 'Where to Stay' page is hidden from guests. Enable it when you're ready to share.'
     */
    EUd3x: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'Update Visibility'
     */
    zIY9L: T;

    /**
     * @default 'Not seeing your design changes? Check that you've applied changes in the design page'
     */
    yAKtN: T;
  };
};

export type RegistrationTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Registration'
     */
    zeLZS: T;

    /**
     * @default 'RSVP Settings'
     */
    a76AP: T;

    /**
     * @default 'Attendance Question'
     */
    bYFSy: T;

    /**
     * @default 'Disabled'
     */
    CNgc3: T;

    /**
     * @default 'Enabled'
     */
    nS8tS: T;

    /**
     * @default 'Enable for RSVP experience where your guest list will contain all guests with their attendance status of attending and not going. Keep disabled for event registration where filling out the form means the guest is attending.'
     */
    OUGjw: T;

    /**
     * @default 'Ask all guests to RSVP, enabling you to track guests who cannot attend.'
     */
    '6DWSA': T;

    /**
     * @default 'An error occurred'
     */
    UY1ZW: T;

    /**
     * @default 'Questions'
     */
    h1BuU: T;

    /**
     * @default 'enabled'
     */
    DC5P2: T;

    /**
     * @default 'disabled'
     */
    mlxxC: T;

    /**
     * @default 'Form {{0}} successfully'
     */
    JC90g: T;

    /**
     * @default 'Contact Information'
     */
    ghluB: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'First and Last Name'
     */
    inBtG: T;

    /**
     * @default 'Name is required. When sending invitations via Joy or using our Smart links, this will be pre-filled from your guest list'
     */
    bedU9: T;

    /**
     * @default 'Mobile Phone'
     */
    YD8aE: T;

    /**
     * @default 'Optional'
     */
    KozAy: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Email Address'
     */
    OgwcY: T;

    /**
     * @default 'Email is required. When sending invitations via Joy or using our Smart links, this will be pre-filled from your guest list'
     */
    qkOoJ: T;

    /**
     * @default 'Mailing Address'
     */
    RvleZ: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Form updated successfully'
     */
    IwUlp: T;

    /**
     * @default 'Enable form'
     */
    '57SSw': T;

    /**
     * @default 'When enabled, guests can access and submit the registration form.'
     */
    t6pcN: T;

    /**
     * @default 'Disabling the form will prevent guests from registering. Any existing registrations will remain unaffected.'
     */
    OiXQN: T;

    /**
     * @default 'An error occurred while initializing registration form'
     */
    p5VtS: T;

    /**
     * @default 'No form templates available'
     */
    JsC7w: T;

    /**
     * @default 'Registration template not found in template list'
     */
    LC1zD: T;

    /**
     * @default 'Failed to create registration form'
     */
    l1Wrz: T;

    /**
     * @default 'An error occurred while creating registration form'
     */
    HlWoP: T;
  };
};

export type RegistryChecklistTranslations<T extends LeafNodeValue = TranslateFunction> = {
  progress: {
    /**
     * @default 'Checklist Progress'
     */
    title: T;

    /**
     * @default 'Keep going, you’re doing great! 👍'
     */
    subtitle: T;
  };
  zeroState: {
    /**
     * @default 'Need Some Ideas?'
     */
    title: T;

    /**
     * @default 'Use our checklist as a starting point to build your registry.'
     */
    subtitle: T;

    /**
     * @default 'Try Checklist'
     */
    primaryButton: T;

    /**
     * @default 'No Thanks'
     */
    secondaryButton: T;
  };
};

export type RegistryOnboardingSurveyTranslations<T extends LeafNodeValue = TranslateFunction> = {
  actions: {
    /**
     * @default '{{questionIndex}} of {{count}}'
     */
    xOfY: T;

    /**
     * @default 'Not sure yet'
     */
    stillDeciding: T;

    /**
     * @default 'Yes'
     */
    yes: T;

    /**
     * @default 'No'
     */
    no: T;

    /**
     * @default 'Next'
     */
    next: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Skip survey'
     */
    skip: T;

    /**
     * @default 'Show me later'
     */
    showLater: T;

    /**
     * @default 'Don’t show me again'
     */
    neverShowAgain: T;

    /**
     * @default 'All Done'
     */
    allDone: T;

    /**
     * @default 'That's it. We'll use this to help you find gifts you love... Starting now!'
     */
    completed: T;
  };
  questions: {
    question1: {
      /**
       * @default 'Let's get started! What are you planning to register for?'
       */
      title: T;

      /**
       * @default 'Select all that interest you.'
       */
      subtitle: T;

      types: {
        /**
         * @default 'Gifts'
         */
        gifts: T;

        /**
         * @default 'Cash Funds'
         */
        'cash-funds': T;

        /**
         * @default 'Experiences'
         */
        experiences: T;
      };
      feedback: {
        /**
         * @default 'Nice! There’s so much *joy* in unboxing your gifts. 😄'
         */
        gifts: T;

        /**
         * @default 'Nice! You’ve come to the right place for zero-fee cash funds.'
         */
        'cash-funds': T;

        /**
         * @default 'Rock on! What better way to celebrate than to experience something fun together.'
         */
        experiences: T;

        /**
         * @default 'Nice! We’ve seen that couples that register for everything get more gifts. 😉'
         */
        multiple: T;

        /**
         * @default 'No worries, we’ll help you shop all the best newlywed essentials on Joy.'
         */
        'still-deciding': T;
      };
    };
    question2: {
      /**
       * @default 'Are you registering at any other store? It’s okay if you are!'
       */
      title: T;

      /**
       * @default 'Joy lets you connect all your registries in one place.'
       */
      subtitle: T;

      feedback: {
        /**
         * @default 'Awesome! You can easily link other registries and add gifts from any store to your Joy registry, allowing guests to shop for everything in one place.'
         */
        yes: T;

        /**
         * @default 'Sweet! You’ll find all the gifts you want at Joy, and your guests will love shopping for everything in one place.'
         */
        no: T;

        /**
         * @default 'No problem, Joy’s registry is a great place to start.'
         */
        'still-deciding': T;
      };
    };
    question3: {
      /**
       * @default 'What are some things you and your partner enjoy doing together?'
       */
      title: T;

      /**
       * @default 'Select all that interest you.'
       */
      subtitle: T;

      types: {
        /**
         * @default 'Travel & experiences'
         */
        'travel-and-experiences': T;

        /**
         * @default 'Cooking together'
         */
        'cooking-together': T;

        /**
         * @default 'Outdoor adventures'
         */
        'outdoor-adventures': T;

        /**
         * @default 'Decorating our place'
         */
        'decorating-our-place': T;

        /**
         * @default 'Baking'
         */
        baking: T;

        /**
         * @default 'Happy hour'
         */
        'happy-hour': T;

        /**
         * @default 'Sleeping in'
         */
        'sleeping-in': T;

        /**
         * @default 'Date night'
         */
        'date-night': T;

        /**
         * @default 'Outdoor entertaining'
         */
        'outdoor-entertaining': T;

        /**
         * @default 'Coffee & tea'
         */
        'coffee-and-tea': T;

        /**
         * @default 'Playing with pets'
         */
        'playing-with-pets': T;

        /**
         * @default 'Health and wellness'
         */
        'health-and-wellness': T;
      };
      feedback: {
        /**
         * @default 'That's great, we'll show you all the unique gifts for what you like to do together.'
         */
        ok: T;
      };
    };
    question4: {
      /**
       * @default 'How many guests are you planning to invite to your wedding?'
       */
      title: T;

      /**
       * @default 'It's okay if you don't know exactly, you can always update this number later.'
       */
      subtitle: T;

      feedback: {
        /**
         * @default 'Sounds like a party! We'll help you figure out how many gifts to add so you have enough for your guests.'
         */
        ok: T;

        /**
         * @default 'No worries, you can update this number when you have a better idea.'
         */
        'still-deciding': T;
      };
    };
    question5: {
      /**
       * @default 'Are you having a wedding shower?'
       */
      title: T;

      /**
       * @default 'You can change this at any time.'
       */
      subtitle: T;

      feedback: {
        /**
         * @default 'Nice, saving it all for the big day!'
         */
        no: T;
      };
    };
    question6: {
      /**
       * @default 'How many guests will you invite to your wedding shower?'
       */
      title: T;

      /**
       * @default 'Guests often look for shower gifts on your wedding registry so we recommend adding more to help them find gifts you’ll love.'
       */
      subtitle: T;

      feedback: {
        /**
         * @default 'Great! If your shower is being organized by a friend or relative, be sure to share with them a link to your registry!'
         */
        ok: T;

        /**
         * @default 'Okay, you can update this number later.'
         */
        'still-deciding': T;
      };
    };
  };
  newRegistryOnboardingCards: {
    'onbrd-reg-add-shipping-address': {
      /**
       * @default 'Where should we ship your gifts?'
       */
      title: T;

      /**
       * @default 'Add a shipping address'
       */
      titleV2: T;
    };
    'onbrd-reg-set-currency': {
      /**
       * @default 'Set registry currency'
       */
      title: T;

      /**
       * @default 'Set registry currency'
       */
      titleV2: T;
    };
    'reg-shop': {
      /**
       * @default 'Start shopping'
       */
      title: T;

      /**
       * @default 'Enjoy a 20% Registry Completion Discount'
       */
      titleV2: T;
    };
    'reg-browse-cash-funds': {
      /**
       * @default 'Explore zero-fee cash funds'
       */
      title: T;

      /**
       * @default 'Explore zero-fee cash funds'
       */
      titleV2: T;
    };
    'reg-connect-registries': {
      /**
       * @default 'Connect a registry from another store'
       */
      title: T;

      /**
       * @default 'Connect a registry from another store'
       */
      titleV2: T;
    };
    'onbrd-reg-install-browser-button': {
      /**
       * @default 'Install the Quick Add Button to shop anywhere'
       */
      title: T;

      /**
       * @default 'Install the Joy Quick Add Button to shop anywhere'
       */
      titleV2: T;
    };
    'onbrd-reg-add-external-gift': {
      /**
       * @default 'Add a gift from another store'
       */
      title: T;

      /**
       * @default 'Add a gift from another store'
       */
      titleV2: T;
    };
    'onboarding-invite-admin': {
      /**
       * @default 'Invite your partner'
       */
      title: T;

      /**
       * @default 'Invite your partner'
       */
      titleV2: T;
    };
    'onbrd-reg-download-app': {
      /**
       * @default 'Download the App and add gifts on the go'
       */
      title: T;

      /**
       * @default 'Download the mobile app and add gifts on the go'
       */
      titleV2: T;
    };
    'onbrd-reg-add-registry-photo': {
      /**
       * @default 'Select a photo for your registry'
       */
      title: T;

      /**
       * @default 'Select a registry photo'
       */
      titleV2: T;
    };
    'onbrd-reg-write-page-greeting': {
      /**
       * @default 'Write a page greeting'
       */
      title: T;

      /**
       * @default 'Write a page greeting'
       */
      titleV2: T;
    };
    'onbrd-reg-share-registry': {
      /**
       * @default 'Share your registry'
       */
      title: T;

      /**
       * @default 'Share your registry'
       */
      titleV2: T;
    };
  };
  newRegistryOnboardingMeta: {
    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default '{{completed}} / {{count}} done'
     */
    completedCards: T;
  };
};

export type RegistryOnboardingSurveyV2Translations<T extends LeafNodeValue = TranslateFunction> = {
  ctaBlocks: {
    /**
     * @default 'Sounds good'
     */
    primaryCtaSoundsGood: T;

    /**
     * @default 'Skip Survey'
     */
    secondaryCTASkipSurvey: T;

    /**
     * @default 'Turn On Recommendations'
     */
    primaryCtaRecommend: T;

    /**
     * @default 'Turn on Cash Funds '
     */
    primaryCtaCashFunds: T;

    /**
     * @default 'All Done'
     */
    allDone: T;
  };
  intro: {
    /**
     * @default 'Recommendations'
     */
    eyebrowText: T;

    /**
     * @default 'Let’s Personalize Your Joy Registry Experience'
     */
    hed: T;

    /**
     * @default 'Let's personalize your shopping experience based on your interests. We'll make gift recommendations based on couples like you.'
     */
    dek: T;
  };
  collectGiftCatalogInterest: {
    /**
     * @default 'Browse the Best Gifts'
     */
    hed: T;

    /**
     * @default 'Enjoy shopping from over 10,000 best wedding gifts selected by our team and delivered right to your doorstep with free shipping.'
     */
    dek: T;

    /**
     * @default 'Not Interested in Physical Gifts'
     */
    secondaryCta: T;
  };
  collectCashFundCatalogInterest: {
    /**
     * @default 'Zero-Fee Cash Funds'
     */
    hed: T;

    /**
     * @default 'No fees. No, really. From your honeymoon to your first home, make your dreams come true without paying pesky fees when you use your Paypal, Venmo, or CashApp account.'
     */
    dek: T;

    /**
     * @default 'Not Interested in Cash Funds'
     */
    secondaryCta: T;
  };
  collectExperiencesCatalogInterest: {
    /**
     * @default 'Unforgettable Experiences'
     */
    hed: T;

    /**
     * @default 'Discover our Experience gifts and crowdfund memories that will last a lifetime. Learn to surf in Costa Rica, explore the open ocean on a private cruise, or hike across Yosemite National Park.'
     */
    dek: T;

    /**
     * @default 'Not Interested in Experiences'
     */
    secondaryCta: T;
  };
  saveLater: {
    /**
     * @default 'Register Now, Save Later.'
     */
    hed: T;

    /**
     * @default 'Register now and save later with 20% off all remaining registry items.'
     */
    dek: T;

    /**
     * @default 'Love It'
     */
    primaryCta: T;

    /**
     * @default 'Not Interested in Saving Later'
     */
    secondaryCta: T;
  };
  browserButton: {
    /**
     * @default 'Your Universal Registry'
     */
    hed: T;

    /**
     * @default 'Shop on Joy or your favorite stores, connect another registry, and give guests one place to more easily shop from your wedding website.'
     */
    dek: T;

    /**
     * @default 'Not Interested'
     */
    secondaryCta: T;
  };
  giftsPersonalization: {
    /**
     * @default 'What are you interested in?'
     */
    hed: T;

    /**
     * @default 'We’ll help you find the best gifts from each category.'
     */
    dek: T;

    /**
     * @default 'Select Interests'
     */
    primaryCta: T;

    /**
     * @default 'Please choose your interests first.'
     */
    primaryCtaError: T;

    /**
     * @default 'Maybe Later'
     */
    secondaryCta: T;

    types: {
      /**
       * @default 'Travel & Experiences'
       */
      'travel-and-experiences': T;

      /**
       * @default 'Cooking Together'
       */
      'cooking-together': T;

      /**
       * @default 'Outdoor Adventures'
       */
      'outdoor-adventures': T;

      /**
       * @default 'Decorating Our Place'
       */
      'decorating-our-place': T;

      /**
       * @default 'Baking'
       */
      baking: T;

      /**
       * @default 'Happy Hour'
       */
      'happy-hour': T;

      /**
       * @default 'Sleeping In'
       */
      'sleeping-in': T;

      /**
       * @default 'Date Night'
       */
      'date-night': T;

      /**
       * @default 'Outdoor Entertaining'
       */
      'outdoor-entertaining': T;

      /**
       * @default 'Coffee & Tea'
       */
      'coffee-and-tea': T;

      /**
       * @default 'Spa Worthy Essentials'
       */
      'spa-worthy-essentials': T;

      /**
       * @default 'Cleaning & Organization'
       */
      'cleaning-and-organization': T;
    };
  };
  giftRecommendations: {
    /**
     * @default 'That’s it. We’ll use this to help you find gifts you love...starting now!'
     */
    hed: T;

    /**
     * @default 'The item was added to your registry!'
     */
    notificationText: T;
  };
  socialProofOnboarding: {
    perks: {
      /**
       * @default 'Your exclusive perks.'
       */
      title: T;

      /**
       * @default 'All Joy couples get access to helpful tools and money-saving benefits.'
       */
      subtitle: T;

      /**
       * @default 'Shop your favorite brands'
       */
      shopFavBrands: T;

      /**
       * @default 'Add gifts from any store'
       */
      addGiftsAnyStore: T;

      /**
       * @default 'Connect any registry'
       */
      connectAnyRegistry: T;

      /**
       * @default 'Zero-fee cash funds'
       */
      zeroFeeCashFund: T;

      /**
       * @default 'Cash options with Joy Wallet'
       */
      CashOptions: T;

      /**
       * @default 'Price Match Guarantee'
       */
      priceMatch: T;

      /**
       * @default 'Group Gifting'
       */
      groupGifting: T;

      /**
       * @default 'Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Ship When You Want'
       */
      shipWhenYouWant: T;

      /**
       * @default 'To the Door Tracking'
       */
      doorTracking: T;

      /**
       * @default 'Mobile App'
       */
      mobileApp: T;

      /**
       * @default 'Quick Add Button'
       */
      quickAddBtn: T;

      /**
       * @default 'Live Concierge Help'
       */
      liveHelp: T;

      /**
       * @default '20% Completion Discount'
       */
      discount: T;

      /**
       * @default 'Automagic Thank You Notes'
       */
      thankYouNotes: T;
    };
    universalRegistry: {
      /**
       * @default 'Your universal registry with <br />anything from anywhere.'
       */
      title: T;

      /**
       * @default 'We've helped over a million couples — now we're excited to make your registry experience a breeze and your guests happy.'
       */
      subtitle: T;

      /**
       * @default 'Create one registry. Share one link.'
       */
      bulletOne: T;

      /**
       * @default 'Shop your favorite stores and add gifts easily.'
       */
      bulletTwo: T;

      /**
       * @default 'Get personal assistance whenever you or your guests need it.'
       */
      bulletThree: T;

      /**
       * @default 'View All Perks'
       */
      viewAllPerks: T;

      /**
       * @default 'Complete your registry effortlessly with Checklist.'
       */
      completeRegistry: T;

      /**
       * @default 'Let’s do this!'
       */
      letsDoThis: T;
    };
    shopPopularBrands: {
      /**
       * @default 'Shop popular brands.'
       */
      title: T;
    };
    anyStore: {
      /**
       * @default 'Add anything from any store, literally.'
       */
      title: T;

      /**
       * @default 'You only need one registry with Joy. Add items from any store with our Quick Add button. Already have a registry? Connect it to Joy. You'll have one registry to manage and guests will have one place to shop.'
       */
      subtitle: T;
    };
    usingRegistry: {
      /**
       * @default 'Using your registry is a piece of cake.'
       */
      title: T;

      /**
       * @default 'Get a detailed overview of your registry and recommendations to add options for guests, plus track gifts to your doorstep.'
       */
      subtitle: T;
    };
    reviewOne: {
      /**
       * @default 'I think my favorite feature is the 'Registry Advisor' that suggests how many products to have in all the various price ranges! It is super helpful to have it broken down like that!'
       */
      content: T;

      /**
       * @default '— Molly & Wyatt'
       */
      reviewer: T;
    };
    singleRegistry: {
      /**
       * @default 'Don’t get locked into a single registry.'
       */
      title: T;

      /**
       * @default 'Add any registry to Joy for ultimate flexibility. Seamlessly combine all your registries in one place, making it easy to manage and share with your guests. No more limitations—just pure convenience.'
       */
      subtitle: T;
    };
    reviewTwo: {
      /**
       * @default 'Joy was easy to connect registry items from Amazon, Macy’s and other online and store vendors. The website tracks everything for you. We had one broken registry item and returned without any issues. I was frankly surprised at how quickly they responded to the return request. I love having one site that tracks everything. 5 Stars.'
       */
      content: T;

      /**
       * @default '— Paul & Febbie'
       */
      reviewer: T;
    };
    universalSearch: {
      /**
       * @default 'Universal Search'
       */
      title: T;

      /**
       * @default 'If it’s on Google, it’s on Joy.'
       */
      subtitle: T;
    };
    reviewThree: {
      /**
       * @default 'We used the registry and it was fantastic. We particularly enjoyed the fund feature and how seamlessly it allowed us to import items from other registries. The easy exchange and return process also gave us peace of mind, making the whole experience smooth for us and our guests.'
       */
      content: T;

      /**
       * @default '— Guadalupe & Andy'
       */
      reviewer: T;
    };
    getHelp: {
      /**
       * @default 'Get help any time.'
       */
      title: T;

      /**
       * @default 'Joy is here for you and your guests via chat and email.'
       */
      subtitle: T;

      /**
       * @default 'Online Support 24/7'
       */
      onlineSupport: T;

      /**
       * @default 'Enjoy round-the-clock assistance online.'
       */
      roundClockAssistance: T;

      /**
       * @default 'Reach Out'
       */
      reachOut: T;

      /**
       * @default 'Live Concierge Help'
       */
      liveConcierge: T;

      /**
       * @default 'Get personalized help with a Zoom call.'
       */
      personalisedHelp: T;

      /**
       * @default 'Book Appointment'
       */
      bookAppointment: T;
    };
  };
};

export type RegistryOverviewTranslations<T extends LeafNodeValue = TranslateFunction> = {
  helpLinks: {
    /**
     * @default 'Preview'
     */
    previewRegistry: T;

    shareRegistry: {
      /**
       * @default 'Share'
       */
      title: T;

      /**
       * @default '✨ Link copied! Share it with gift givers so they can shop in one place!'
       */
      toast: T;
    };

    /**
     * @default 'Public'
     */
    registryIsPublic: T;

    /**
     * @default 'Hidden'
     */
    registryIsHidden: T;

    /**
     * @default 'Protected'
     */
    registryIsPasswordProtected: T;

    settings: {
      /**
       * @default 'Settings'
       */
      title: T;

      /**
       * @default 'Registry Settings'
       */
      navTitle: T;

      /**
       * @default 'Event Settings'
       */
      event: T;

      /**
       * @default 'Shipping Address'
       */
      shippingAddress: T;

      /**
       * @default 'Set Currency'
       */
      currencyZeroState: T;

      /**
       * @default 'Currency ({{code}} - {{symbol}})'
       */
      currency: T;

      /**
       * @default 'Edit Welcome Note'
       */
      note: T;

      /**
       * @default 'Your presence is enough of a present to us! But for those of you who are stubborn, we've put together a wish-list to help you out.'
       */
      defaultNote: T;

      /**
       * @default 'Invite Collaborator'
       */
      invite: T;

      /**
       * @default 'Connect a Registry'
       */
      connect: T;

      /**
       * @default 'Seamless checkout (On)'
       */
      seamlessCheckoutOn: T;

      /**
       * @default 'Seamless checkout (Off)'
       */
      seamlessCheckoutOff: T;
    };
  };
  tabsNavigation: {
    /**
     * @default 'Overview'
     */
    overview: T;

    /**
     * @default 'Manage'
     */
    manage: T;

    /**
     * @default 'Track'
     */
    track: T;
  };
  checklist: {
    /**
     * @default 'Registry Checklist'
     */
    title: T;

    /**
     * @default 'Use our checklist as a starting point to build your registry.'
     */
    subtitle: T;

    /**
     * @default 'Try Checklist'
     */
    button: T;
  };
  registry101: {
    /**
     * @default 'Registry 101'
     */
    title: T;

    /**
     * @default 'Need some guidance? Try one of these:'
     */
    subtitle: T;

    /**
     * @default 'Registry Walkthrough'
     */
    registryWalkthrough: T;

    /**
     * @default 'Tips & Tricks'
     */
    tipsTricks: T;

    /**
     * @default 'FAQs'
     */
    faqs: T;
  };
  registryPerks: {
    /**
     * @default 'Registry Completion Discount'
     */
    header: T;

    /**
     * @default 'Save 20% on Products'
     */
    title1: T;

    /**
     * @default 'You 100% Love.'
     */
    title2: T;

    /**
     * @default 'Use your completion discount up to six months after the big day.'
     */
    subTitle: T;

    /**
     * @default 'Explore All Benefits'
     */
    button: T;

    perksDialog: {
      /**
       * @default 'Registry Perks & Benefits'
       */
      header: T;

      /**
       * @default 'For You'
       */
      forYou: T;

      /**
       * @default 'For Your Guests'
       */
      forGuest: T;

      /**
       * @default 'Easy Returns'
       */
      easyReturns: T;

      /**
       * @default 'Free online returns let you get the gifts you want without any cost or inconvenience.'
       */
      easyReturnsSubTitle: T;

      /**
       * @default '20% Completion Discount'
       */
      registryCompletionDiscount: T;

      /**
       * @default 'Enjoy 20% off eligible gifts remaining on your registry up to 6 months after the big day.'
       */
      registryCompletionDiscountSubTitle: T;

      /**
       * @default 'Universal Registry'
       */
      universalRegistry: T;

      /**
       * @default 'Add gifts and experiences from the Joy Shop or any online store, plus connect or transfer another registry.'
       */
      universalRegistrySubTitle: T;

      /**
       * @default 'Zero-Fee Cash Funds'
       */
      zeroCashFund: T;

      /**
       * @default 'Save for your dreams faster by creating a cash fund for anything from your honeymoon to a new home.'
       */
      zeroCashFundSubTitle: T;

      /**
       * @default 'Joy Consultation'
       */
      joyConsultation: T;

      /**
       * @default 'Elevate your wedding planning with complimentary expert advice and creative ideas from the pros.'
       */
      joyConsultationSubTitle: T;

      /**
       * @default 'Gift Tracking'
       */
      giftNotifications: T;

      /**
       * @default 'See which gifts have been purchased, view your cash fund’s progress, and send free online thank you notes.'
       */
      giftNotificationsSubTitle: T;

      /**
       * @default 'Flexible, Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Guests can choose to ship to you or to themselves so they can bring your gifts with them to your event.'
       */
      freeShippingSubTitle: T;

      /**
       * @default 'Price Match Promise'
       */
      priceMatch: T;

      /**
       * @default 'If your guests find a better price on a qualifying product from our eligible retailers, we'll match it.'
       */
      priceMatchSubTitle: T;

      /**
       * @default 'Group Gifting'
       */
      groupGifting: T;

      /**
       * @default 'A win-win for everyone, add big gifts over $350 and let your friends and family contribute what they want.'
       */
      groupGiftingSubTitle: T;

      /**
       * @default 'Fast Checkout'
       */
      fastCheckout: T;

      /**
       * @default 'Convenient payment options, like ApplePay and GooglePay, plus a streamlined checkout simplify gifting.'
       */
      fastCheckoutSubTitle: T;

      /**
       * @default 'Data Protection'
       */
      dataProtection: T;

      /**
       * @default 'Keeping personal data secure is our priority and we will never sell or compromise that information.'
       */
      dataProtectionSubTitle: T;

      /**
       * @default 'Priority Picks'
       */
      priorityPicks: T;

      /**
       * @default 'We’ll help your guests see which items are your must-haves, taking the guesswork out of picking the right gifts.'
       */
      priorityPicksSubTitle: T;

      /**
       * @default 'See Details'
       */
      seeDetails: T;
    };
  };
  virtualConsultation: {
    /**
     * @default 'Need Help?'
     */
    needHelp: T;

    /**
     * @default 'Get expert registry advice.'
     */
    title: T;

    /**
     * @default 'Build your registry like a pro with the help of expert advice.'
     */
    subTitle: T;

    /**
     * @default 'Book An Appointment'
     */
    button: T;
  };
  registryTools: {
    quickAdd: {
      /**
       * @default 'Install the Joy Quick Add Button'
       */
      title: T;

      /**
       * @default 'Add anything as you browse the web.'
       */
      subtitle: T;

      /**
       * @default 'Get the button'
       */
      button: T;
    };
    mobileApp: {
      /**
       * @default 'Shop on Your Phone'
       */
      title: T;

      /**
       * @default 'Add items from wherever, whenever.'
       */
      subtitle: T;

      /**
       * @default 'Download App'
       */
      button: T;
    };
    externalRegistries: {
      /**
       * @default 'Add Anything from Any Store'
       */
      title: T;

      /**
       * @default 'Joy lets you do you.'
       */
      subtitle: T;

      /**
       * @default 'Connect a Registry'
       */
      button: T;

      /**
       * @default 'Add a Gift'
       */
      buttonBaby: T;

      /**
       * @default 'Gifts'
       */
      gifts: T;

      /**
       * @default 'Cash Funds'
       */
      cashFunds: T;

      /**
       * @default 'Experiences'
       */
      experiences: T;

      /**
       * @default 'Charity'
       */
      charity: T;

      /**
       * @default 'Babymoons'
       */
      babymoons: T;
    };
  };
  registryToolsV2: {
    mobileApp: {
      /**
       * @default 'Add gifts on the go<lineBreak/>with the Joy App.'
       */
      title: T;

      /**
       * @default 'Get the App'
       */
      button: T;
    };
    universalRegistry: {
      /**
       * @default ' Already registered?<lineBreak/>Make it easier for your guests.'
       */
      title: T;

      /**
       * @default 'Connect a Registry'
       */
      button: T;
    };
  };
  departmentShowcase: {
    /**
     * @default 'Explore Departments'
     */
    title: T;
  };
  curationShowcase: {
    /**
     * @default 'Shop by Collection'
     */
    title: T;
  };
  faqs: {
    /**
     * @default 'Frequently Asked Questions'
     */
    title: T;

    /**
     * @default 'Our most commonly asked questions are here, and you can reach our support team <0>here</0>.'
     */
    subtitle: T;

    questions: [
      {
        /**
         * @default '1'
         */
        id: T;

        /**
         * @default 'Why do we need a registry?'
         */
        Q: T;

        /**
         * @default 'With your big day around the corner, we’re sure your friends and family are excited to shower you with gifts. Chances are they’ll buy something for you even if you don’t have a registry and those gifts may not exactly be what you need or want. Having a wedding registry ensures you'll receive stuff, experiences, or even cash fund gifts that you truly need and want. So, it's a win-win for you and your guests–you’ll get what you love, and your guests feel awesome knowing they've given you something you'll cherish.'
         */
        A: T;
      },
      {
        /**
         * @default '2'
         */
        id: T;

        /**
         * @default 'Why should we register with Joy?'
         */
        Q: T;

        /**
         * @default 'The Joy wedding registry is a truly all-in-one registry that has been designed to make the registering process simple and fun for you and your guests. We've stocked our online <0>Joy Shop</0> with tons of products from top-name brands, <1>zero-fee cash funds</1> to make your dreams come true, and even the option to give back with charitable donations. We have gift cards, <2>honeymoon funds</2>, and <3>experiences</3> to make your future even more memorable, too.<br><br>And here's the icing on the cake: Joy's a universal registry wizard. You can register for items from any online store, and even transfer or connect existing registries, giving you and your guests one super-convenient place to shop for absolutely everything you desire.<br><br>We know weddings are expensive and time-consuming, so we’re always rolling out more features and perks to save you money and time. We promise to match prices, ship items free, offer convenient group gifting, make returns a breeze, and even give you a 20% Post-Wedding Completion Discount for most items left on your registry. It's like a wedding gift that keeps on giving! So why register with Joy? Because we're here to make your journey as stress-free and seamless as possible.'
         */
        A: T;
      },
      {
        /**
         * @default '3'
         */
        id: T;

        /**
         * @default 'When should we start our registry?'
         */
        Q: T;

        /**
         * @default 'Creating your wedding registry about 8-9 months before your wedding date is a fantastic idea because it gives you time to thoughtfully select items and gives guests time to browse and choose the perfect gifts. You definitely want to have your wedding registry finalized before sending out any shower or wedding invitations. When you start early, it takes away any last-minute rushing and gives everyone the chance to find the most meaningful and thoughtful presents for you and your future spouse.'
         */
        A: T;
      },
      {
        /**
         * @default '4'
         */
        id: T;

        /**
         * @default 'What should we add to our wedding registry?'
         */
        Q: T;

        /**
         * @default 'What you add to your wedding registry really comes down to your lifestyle and preferences. It's your opportunity to curate a list of items that will truly enhance your married life together. A couple who is moving into a new space for the first time together will likely have a different registry than a couple who is planning to travel the world. To strike a good balance, consider a mix of physical gifts like kitchen gadgets, home essentials, and comfy linens, which can make everyday life more enjoyable. Including options like cash funds for future plans or even charitable donations adds a meaningful touch to your registry. But don't stop there! Registering for experiences is a way for you to create beautiful memories that will last a lifetime. So, go ahead and make it a reflection of your needs and wants, knowing that your loved ones are excited to support your journey in whichever way they can. It's all about making your wedding registry uniquely yours.<br><br>Still not sure what to add? We recommend starting with our Registry Checklist, which you can find at the top of your registry page. We’ll guide you through the must-have items and tell you how many of each you might need. Check out the checklist.'
         */
        A: T;
      },
      {
        /**
         * @default '5'
         */
        id: T;

        /**
         * @default 'How many gifts should we register for?'
         */
        Q: T;

        /**
         * @default 'Ah, the age-old question, right? How many gifts should you put on that wedding registry? The thing is, there's no one-size-fits-all answer here. It really boils down to your unique situation. But here's a helpful rule of thumb: aim to have more items on your registry than you have guests. This gives folks a range of options to choose from. To make it easier, we’ve created your personal Registry Calculator, found within the “Overview” and “Gifts” sections of your registry. Tell us how many guests you’re inviting and we’ll give you a recommendation of how many gifts to register for. You’ll also be able to see how many gifts you have on your registry per price range.<br><br>Include a mix of essentials and fun stuff, all at different price points. That way, your guests can pick something that suits their budget and your new life together. And, don’t stress about over-registering. You can use your 20% Post-Wedding Discount on most items remaining on your registry after the big day. Learn more about how your discount works <0>here</0>.'
         */
        A: T;
      },
      {
        /**
         * @default '6'
         */
        id: T;

        /**
         * @default 'What is the Joy Shop and how are the products selected?'
         */
        Q: T;

        /**
         * @default 'While the Joy registry is truly universal and you can add any item from any online store when you download the Joy Browser Button, there are over 10,000 products from top brands, niche brands, and artisans around the world right in the <0>Joy Shop</0>.<br><br>Our product selection process is driven by a passionate commitment to deliver an exceptional catalog that feels hand-selected, intentional, and truly special. We take great pride in offering a diverse range of products chosen with a commitment to quality and longevity. The Joy Shop is thoughtfully curated to cater to every couples’ and guest's budget, ensuring there's something special for everyone to choose from. We also pay close attention to what our Joy couples love and listen to your suggestions. Your input helps us refine our product selection and introduce new items that cater to your evolving preferences and needs.'
         */
        A: T;
      },
      {
        /**
         * @default '7'
         */
        id: T;

        /**
         * @default 'Is it rude to ask for money instead of wedding gifts?'
         */
        Q: T;

        /**
         * @default 'Not at all! In fact, in many places outside of the US, giving money in lieu of traditional gifts is quite common and sometimes expected. Cash gifting has become increasingly popular in recent years as it allows couples to focus on experiences rather than material possessions. Joy has made it easier than ever to create cash registries, where you can politely express your preference for cash gifts. With Joy, you can create a general cash fund for your honeymoon or house downpayment, or customize cash funds for specific experiences like airfare, future date nights, or whatever you dream up.<br><br>Just remember to express gratitude for any type of gift you receive. You can send free, online thank you notes right from your Gift Tracker, quickly and easily. We’ll even help you write them.'
         */
        A: T;
      },
      {
        /**
         * @default '8'
         */
        id: T;

        /**
         * @default 'How do Joy's zero fee-cash funds work?'
         */
        Q: T;

        /**
         * @default 'Just like any product, you can register for a zero-fee cash fund right from the <0>Joy Shop</0>. Select one or create your own, make any edits to the amount, and add to your registry. Using Venmo, PayPal, or CashApp, your loved ones can sprinkle a little monetary magic your way without those pesky credit card fees. Whether you're dreaming of a honeymoon getaway, saving for that first home, or looking to fly high with airfare funds, the sky's the limit when it comes to crafting the perfect cash gifts for your newlywed journey.<br><br>P.S. Don’t stress if your guests want to pay in a more traditional way. They’ll also have the option to contribute via cash or check.'
         */
        A: T;
      },
      {
        /**
         * @default '9'
         */
        id: T;

        /**
         * @default 'How can we explain to our guests that we are using a cash registry?'
         */
        Q: T;

        /**
         * @default 'For loved ones who are more accustomed to traditional gift registries, it's a lovely idea to leave them a little note. You can write a note right in your Joy registry to let them know how much you appreciate their generosity, and share what your cash gift will be used for–whether it's your dream honeymoon, saving for a cozy home, or any other exciting adventure you're planning. It's all about making your guests feel connected to your journey and showing them that every contribution, big or small, means the world to you.'
         */
        A: T;
      },
      {
        /**
         * @default '10'
         */
        id: T;

        /**
         * @default 'Does Joy offer a post-wedding or completion discount?'
         */
        Q: T;

        /**
         * @default 'Absolutely! We’re here for you before, during, and after your wedding. Our 20% Post-Wedding discount can be used on eligible items that are still left on your registry after your big day. It's our way of helping you grab those items you've had your eye on at an even better price, so don’t be shy about adding everything you need and everything you love to your registry now. Use it as MANY times as you’d like, up to 6 months after your wedding date. Learn more about it here.'
         */
        A: T;
      },
      {
        /**
         * @default '11'
         */
        id: T;

        /**
         * @default 'Does Joy offer price matching?'
         */
        Q: T;

        /**
         * @default 'Yes! At Joy, we've got your back when it comes to getting the most value out of your purchases, so we’re happy to offer our Price Match Promise. If you find a better price for a qualifying product from one of our eligible retailers within 48 hours of making your order, just give us a shout. Learn more about it <0>here</0>.'
         */
        A: T;
      },
      {
        /**
         * @default '12'
         */
        id: T;

        /**
         * @default 'We already have a registry with another store. Can we link it to Joy?'
         */
        Q: T;

        /**
         * @default 'We know you’ve got your eyes on some fantastic finds from various stores. Imagine registering at a bunch of different stores and combining all of those registries into one glorious display on your wedding website. Let’s dive into how you can add external registries to your Joy Registry:<br><br><strong>1</strong>. Linking: Simply add a link to any external registry for guests’ convenience.<br><strong>2</strong>. Transfer: Move an external registry into Joy, manage items, and see gift details within Joy. Supported for specific registries.<br><strong>3</strong>. Syncing: Automatically import items from an external registry into Joy, though changes must be made on the external registry. Supported for specific registries.'
         */
        A: T;
      },
      {
        /**
         * @default '13'
         */
        id: T;

        /**
         * @default 'Does Joy cost anything to use?'
         */
        Q: T;

        /**
         * @default 'Joy's wedding websites, planning tools, registry, and online Save the Dates, invitations, and thank you notes are all available for free, so you can save on wedding costs and enjoy a stress-free planning experience.'
         */
        A: T;
      },
      {
        /**
         * @default '14'
         */
        id: T;

        /**
         * @default 'Do you have a support team we can reach out to if we have questions?'
         */
        Q: T;

        /**
         * @default 'Our awesome support squad has whipped up a fantastic collection of FAQs and nifty tips in our Help Center, all designed to make your wedding planning journey easier. This treasure trove of information is here to give you lightning-fast and super-detailed answers, so you can get the most out of your Joy experience. Visit our <0>Help Center</0>.'
         */
        A: T;
      },
    ];
  };
  highlights: {
    cashFundPromo: {
      /**
       * @default 'Cash in Your Dreams'
       */
      eyebrow: T;

      /**
     * @default 'Joy accepts the most
 Cash Fund payment options.'
*/
      title: T;

      /**
       * @default 'Create Cash Fund'
       */
      buttonLabel: T;

      /**
       * @default 'Honeymoon Fund'
       */
      progressBarLabel: T;
    };
    completionDiscountPromo: {
      /**
       * @default 'Post-Wedding Completion Discount'
       */
      eyebrow: T;

      /**
       * @default 'Celebrate all over again with 20% off registry gifts after your wedding.'
       */
      title: T;

      /**
       * @default 'Learn More'
       */
      buttonLabel: T;
    };
    curationsPromo: {
      /**
       * @default 'Expert Curations'
       */
      eyebrow: T;

      /**
       * @default 'Hot recs from industry pros to craft your registry.'
       */
      title: T;

      /**
       * @default 'Explore Curations'
       */
      buttonLabel: T;
    };
    customerSupportPromo: {
      /**
       * @default 'Customer support for you and your guests at every step.'
       */
      title: T;
    };
    delayShippingPromo: {
      /**
       * @default 'Avoid Honeymoon Deliveries'
       */
      eyebrow: T;

      /**
       * @default 'With Joy, only you decide when your gifts should ship.'
       */
      title: T;

      /**
       * @default 'Set Up Delay Shipping'
       */
      buttonLabel: T;
    };
    etsyPromo: {
      /**
       * @default 'Shop the Best of Etsy Wedding Supplies'
       */
      title: T;

      /**
       * @default 'Explore Wedding Shop'
       */
      buttonLabel: T;
    };
    framesPromo: {
      /**
       * @default 'Upload and frame your wedding photos.'
       */
      title: T;

      /**
       * @default 'Joy and Frameology bring you gorgeous frames at great prices.'
       */
      description: T;

      /**
       * @default 'Shop Frames'
       */
      buttonLabel: T;
    };
    printPromo: {
      /**
       * @default 'Ready to share your registry?'
       */
      title: T;

      /**
       * @default 'Joy paper and digital cards make it easy with built in QR codes and links.'
       */
      description: T;

      /**
       * @default 'Add to Save the Dates'
       */
      buttonLabel: T;

      /**
       * @default 'Add to Invites'
       */
      buttonLabel2: T;
    };
    groupGiftingPromo: {
      /**
       * @default 'Group Gifting'
       */
      eyebrow: T;

      /**
       * @default 'Let guests chip in together on your dreamiest gifts.'
       */
      title: T;

      progressBar: {
        /**
         * @default 'Sofa Sectional 🎉 You’re almost there!'
         */
        leftLabel: T;

        /**
         * @default '$4,000 Goal'
         */
        rightLabel: T;
      };
    };
    universalSearchPromo: {
      /**
       * @default 'Universal Search'
       */
      eyebrow: T;

      /**
     * @default 'If it’s on Google,
it’s on Joy.'
*/
      title: T;

      /**
       * @default 'Search for anything. Yes, really.'
       */
      buttonLabel: T;
    };
    weddingThankYouNotes: {
      /**
     * @default 'Thank You Notes
Made Easy'
*/
      title: T;

      /**
       * @default 'Introducing'
       */
      eyebrow: T;

      /**
       * @default 'Watch the Video'
       */
      buttonLabel: T;
    };
    weddingChecklist: {
      /**
     * @default 'Not sure where
to start?'
*/
      title: T;

      /**
       * @default 'Try Checklist'
       */
      buttonLabel: T;
    };
    weddingCashFunds: {
      /**
     * @default 'Zero-Fee
Cash Funds.'
*/
      title: T;

      /**
       * @default 'Explore Cash Funds'
       */
      buttonLabel: T;
    };
    weddingBrowserButton: {
      /**
     * @default 'Add anything from
anywhere. Like, literally.'
*/
      title: T;

      /**
       * @default 'Install Quick Add Button'
       */
      buttonLabel: T;
    };
    weddingMobileApp: {
      /**
     * @default 'Add anything from
anywhere. Like, literally.'
*/
      title: T;

      /**
       * @default 'Install Quick Add Button'
       */
      buttonLabel: T;
    };
    babyFriendsRegistry: {
      /**
       * @default 'Only with Joy'
       */
      eyebrow: T;

      /**
     * @default 'Add items from
anyone’s registry.'
*/
      title: T;

      /**
       * @default 'We’ll collect their gifts so you can pick what to add.'
       */
      text: T;

      /**
       * @default 'Scan and Add Gifts'
       */
      buttonLabel: T;
    };
    babyBrowserButton: {
      /**
     * @default 'Register for
anything. Literally.'
*/
      title: T;

      /**
       * @default 'Install the Quick Add Button'
       */
      buttonLabel: T;
    };
    babyCashFunds: {
      /**
     * @default 'Zero-Fee
Cash Funds.'
*/
      title: T;

      /**
       * @default 'Explore Cash Funds'
       */
      buttonLabel: T;
    };
    babyChecklists: {
      /**
     * @default 'Don't know
what to add?'
*/
      title: T;

      /**
       * @default 'Try Checklist'
       */
      buttonLabel: T;
    };
    babyThankYouNotes: {
      /**
     * @default 'Automagic
Thank You Notes.'
*/
      title: T;

      /**
       * @default 'Watch the Video'
       */
      buttonLabel: T;
    };
  };
  mainPromo: {
    /**
     * @default 'Meet the best registry on earth.'
     */
    title: T;

    /**
     * @default 'Shop the top brands, gift cards and experiences in one place. Create unlimited cash funds with zero fees. Add gifts from any store and share them with one link.'
     */
    description: T;

    /**
     * @default 'See All Perks'
     */
    ctaText: T;
  };

  /**
   * @default 'Explore'
   */
  explore: T;

  /**
   * @default 'View All'
   */
  viewAll: T;

  exploreRegistry: {
    /**
     * @default 'Explore Your Registry'
     */
    headerTitle: T;

    /**
     * @default 'Check out
The Check List'
*/
    tryCheckListTitle: T;

    /**
     * @default 'Top Gifts
Under $100'
*/
    topGiftsTitle: T;

    /**
     * @default 'Add a
Cash Fund'
*/
    addCashFundTitle: T;

    /**
     * @default 'Go Dutch'
     */
    goDutchTitle: T;

    /**
     * @default 'Shop by Brand'
     */
    shopByBrandTitle: T;

    /**
     * @default 'Explore
Curations'
*/
    exploreCurationsTitle: T;
  };
  productRecommendations: {
    /**
     * @default 'No product recommendations here yet.
Select your interests from the dropdown.'
*/
    emptyState: T;

    /**
     * @default 'Show All {{count}}'
     */
    showAll: T;

    interestsDropdown: {
      /**
       * @default 'Select your interests'
       */
      empty: T;

      /**
       * @default 'Because you like <interest/>'
       */
      liked: T;

      /**
       * @default 'Add'
       */
      add: T;

      /**
       * @default 'Remove'
       */
      remove: T;
    };
  };
};

export type RichTextEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Do you want to keep extra formatting for this text?'
     */
    MEQs9: T;

    /**
     * @default 'We noticed this text includes some extra formatting. It might not match your site's style. You can keep it if it's intentional or remove it for a consistent look.'
     */
    Th3tq: T;

    /**
     * @default 'Don't show this message again'
     */
    wHeOZ: T;

    /**
     * @default 'Remove formatting'
     */
    lKKes: T;

    /**
     * @default 'Keep extra formatting'
     */
    mjDds: T;
  };
};

export type RsvpAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  messageCardHelper: {
    /**
     * @default 'We've added some common questions to get you started. <learnHowToCustomizeLink/>'
     */
    commonQuestionsAdded: T;
  };
  labelSelector: {
    /**
     * @default 'The {{tagNames}} tag is not applied to any guests on your guest list. '
     * @param {number} count - The number of occurrences.
     * - singular: The {{tagNames}} tag is not applied to any guests on your guest list.
     * - plural: The {{tagNames}} tags are not applied to any guests on your guest list.
     */
    tagNotAppliedWarning: T;
  };
  rsvpOff: {
    /**
     * @default 'Please disable RSVP in <settingsLink/> if you have not done so already.'
     */
    disableRsvpMessage: T;
  };
  cardFooter: {
    /**
     * @default 'and {{count}} other guest'
     * @param {number} count - The number of occurrences.
     * - singular: and {{count}} other guest
     * - plural: and {{count}} other guests
     */
    andOtherGuests: T;

    /**
     * @default '{{count}} Guest'
     * @param {number} count - The number of occurrences.
     * - singular: {{count}} Guest
     * - plural: {{count}} Guests
     */
    guestCount: T;
  };
  hoverInfo: {
    /**
     * @default 'Ask {{count}} guest'
     * @param {number} count - The number of occurrences.
     * - singular: Ask {{count}} guest
     * - plural: Ask {{count}} guests
     */
    askGuestCount: T;
  };
  quick: {
    /**
     * @default 'Set up your questions'
     */
    '57WCi': T;

    /**
     * @default 'Learn how to customize rsvp.'
     */
    ZXp8t: T;

    /**
     * @default 'Please note: You do NOT need to create RSVP questions regarding guest contact info. Joy lets your guest enter or update their guest list contact info when they RSVP.'
     */
    rDs0G: T;

    /**
     * @default 'Add Question'
     */
    '7XvlO': T;

    /**
     * @default 'Select the groups of guests you’d like to ask this question. You can manage your guest tags on your '
     */
    Kk8Nd: T;

    /**
     * @default 'guest list'
     */
    '4eKQC': T;

    /**
     * @default 'Learn more.'
     */
    tnDNB: T;

    /**
     * @default 'Selected Guest Tags'
     */
    '6rnwo': T;

    /**
     * @default 'No tags selected yet'
     */
    XWZBC: T;

    /**
     * @default 'Unselected Guest Tags'
     */
    FdcNb: T;

    /**
     * @default 'No tags available'
     */
    vpQUx: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Guest {{0}}'
     */
    '4Qerl': T;

    /**
     * @default 'No guests available to select'
     */
    ahlq4: T;

    /**
     * @default 'Select {{0}}'
     */
    ImZIC: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Select the individual guests you’d like to ask this question.'
     */
    '42eGr': T;

    /**
     * @default 'No specific guests selected yet'
     */
    Z8S2A: T;

    /**
     * @default 'Select'
     */
    YS91U: T;

    /**
     * @default 'Please try reloading'
     */
    Ad073: T;

    /**
     * @default 'Show to guests with tag'
     */
    NJNZb: T;

    /**
     * @default 'and the following guests'
     */
    '48cmA': T;

    /**
     * @default 'Your privacy settings were unable to be saved.'
     */
    '7sEwI': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Something bad happened when trying to preview tag with id: {{0}}'
     */
    lSRlT: T;

    /**
     * @default 'Guests tagged'
     */
    thd7C: T;

    /**
     * @default 'Leave this choice empty?'
     */
    WSJlV: T;

    /**
     * @default 'You have a follow-up question attached to this choice. It will not be shown to any guests if this choice is empty.'
     */
    qmyZ8: T;

    /**
     * @default 'OK'
     */
    QrAAA: T;

    /**
     * @default 'Choice already selected by guests'
     */
    syPTq: T;

    /**
     * @default 'Guests who have selected this choice will have their answers updated. Are you sure you want to update this choice?'
     */
    MebsG: T;

    /**
     * @default 'Update'
     */
    R74Bb: T;

    /**
     * @default 'For guests who have selected this choice, their answers would disappear. We strongly advise that you not delete this choice.'
     */
    '4BP1R': T;

    /**
     * @default 'Delete Anyway'
     */
    OT12S: T;

    /**
     * @default 'Cannot delete choice'
     */
    hY80K: T;

    /**
     * @default 'A follow-up question is currently being asked if this choice is selected. Delete that follow-up question first, then you can delete this choice.'
     */
    ri9aq: T;

    /**
     * @default 'Ok'
     */
    wrAAA: T;

    /**
     * @default 'Choice {{0}}'
     */
    vsBkX: T;

    /**
     * @default 'Attending answer'
     */
    '0dBW0': T;

    /**
     * @default 'Declining answer'
     */
    puWPJ: T;

    /**
     * @default 'Ask follow-up question'
     */
    eFyc8: T;

    /**
     * @default 'Adding answer choice...'
     */
    oC45P: T;

    /**
     * @default 'Add answer choice'
     */
    S5Jup: T;

    /**
     * @default 'If'
     */
    foAAA: T;

    /**
     * @default 'Please fill in your choice field'
     */
    CEj0N: T;

    /**
     * @default 'Anyone who visits your website'
     */
    G9yvi: T;

    /**
     * @default 'Anyone who has your event password'
     */
    IIYEA: T;

    /**
     * @default 'Specific guests'
     */
    Xn01r: T;

    /**
     * @default 'Specific guests with your event password'
     */
    xg6fk: T;

    /**
     * @default 'Who can see this?'
     */
    k2Dqo: T;

    /**
     * @default 'Show this question to your guests.'
     */
    s6bHU: T;

    /**
     * @default 'Individual'
     */
    '1Ilox': T;

    /**
     * @default 'Household'
     */
    Xc1bJ: T;

    /**
     * @default 'Attendance questions are special. Guests should answer this individually, in case not everyone in a household can attend.'
     */
    laMfk: T;

    /**
     * @default 'Follow-up questions to questions that are ask once per household, cannot be set to ask per guest.'
     */
    kdjB7: T;

    /**
     * @default 'If a main question has a follow-up question that is set to ask once per guest, the main question cannot be set to ask per household.'
     */
    G9F9C: T;

    /**
     * @default 'Unnamed Guest'
     */
    s4P35: T;

    /**
     * @default 'No one can see this question'
     */
    cfqhy: T;

    /**
     * @default 'Choose who to show this question to.'
     */
    '0o8YM': T;

    /**
     * @default 'Ask'
     */
    naTAA: T;

    /**
     * @default 'All Guests'
     */
    IwnQp: T;

    /**
     * @default 'Ask once per'
     */
    XyMxJ: T;

    /**
     * @default 'Receive one response per guest/plus one or household.'
     */
    sBiGT: T;

    /**
     * @default 'Guest list column'
     */
    uWYiU: T;

    /**
     * @default 'Column header'
     */
    nG34e: T;

    /**
     * @default 'Delete question'
     */
    voLQO: T;

    /**
     * @default 'Unarchive'
     */
    J6WZA: T;

    /**
     * @default 'Attendance'
     */
    DE1nO: T;

    /**
     * @default 'Food'
     */
    Y0ELA: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'Multiple choice'
     */
    R7rIF: T;

    /**
     * @default '{{0}} questions always need to be answered.'
     */
    pWFft: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Rename guest list column'
     */
    yCfin: T;

    /**
     * @default 'Responses to this question will appear in a column in your '
     */
    EtCaR: T;

    /**
     * @default 'guest list.'
     */
    GG26X: T;

    /**
     * @default 'Custom column name'
     */
    iASIG: T;

    /**
     * @default 'E.g. Rehearsal Dinner'
     */
    Tqe3s: T;

    /**
     * @default 'You can rename the column tag on Guest List. These columns will automatically populate with guest responses after guests RSVP'
     */
    g2gWV: T;

    /**
     * @default 'Guest List Column Header'
     */
    jUezM: T;

    /**
     * @default 'Ask all guests'
     */
    Rje4P: T;

    /**
     * @default 'once per guest'
     */
    cOD3i: T;

    /**
     * @default 'once per household'
     */
    vqHqh: T;

    /**
     * @default 'Unarchive Question'
     */
    F6FDH: T;

    /**
     * @default 'Guests will be able to type a response here.'
     */
    p6Yky: T;

    /**
     * @default 'Please fill in your question here'
     */
    '91wAj': T;

    /**
     * @default 'Supports follow-up questions'
     */
    MSEdX: T;

    /**
     * @default 'Choose a question type'
     */
    UezlI: T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'Suggestions'
     */
    JzeyJ: T;

    /**
     * @default 'Add'
     */
    hSTAA: T;

    /**
     * @default 'Image indicating that RSVP is turned off.'
     */
    SPhfD: T;

    /**
     * @default 'You have no enabled questions.'
     */
    eCyuJ: T;

    /**
     * @default 'settings'
     */
    pogda: T;

    /**
     * @default 'On'
     */
    zrAAA: T;

    /**
     * @default 'Off'
     */
    hRXAA: T;

    /**
     * @default 'Make it Easy: '
     */
    '1dxJZ': T;

    /**
     * @default 'Guests can scan the QR code and RSVP straight from their phone.'
     */
    fpo6t: T;

    /**
     * @default 'Simple Tracking: '
     */
    vmjPG: T;

    /**
     * @default 'Keep an eye on replies with notifications.'
     */
    YE9t1: T;

    /**
     * @default 'RSVP Reminders: '
     */
    s36BB: T;

    /**
     * @default 'Poke the slowpokes with one click.'
     */
    ZQgqs: T;

    /**
     * @default 'Gather addresses with a single magic link.'
     */
    tuPhn: T;

    /**
     * @default 'Create and share your contact collector link to let guests easily add their details to your Guest List automatically.'
     */
    mrFLp: T;

    /**
     * @default 'Gather Contacts'
     */
    msjSb: T;

    /**
     * @default 'Easily share your RSVP with your guests'
     */
    shUsQ: T;

    /**
     * @default 'Design the perfect invitation with a QR code on the back, so guests can easily RSVP from their phone.'
     */
    IuHcR: T;

    /**
     * @default 'Browse Card Designs'
     */
    '1Y392': T;

    /**
     * @default 'Copy RSVP Link'
     */
    '8K7Uy': T;

    /**
     * @default '✨ Link copied! ✨'
     */
    NlEES: T;

    /**
     * @default 'Smart Tip'
     */
    MOPzc: T;

    /**
     * @default 'Adding...'
     */
    bv3l8: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Saving...'
     */
    '60ObM': T;

    /**
     * @default 'Changes saved'
     */
    aL6C5: T;

    /**
     * @default 'Back to Dashboard'
     */
    qTmel: T;

    /**
     * @default 'RSVP Questions'
     */
    yM1hj: T;

    /**
     * @default 'Page Visibility'
     */
    lyp4s: T;

    /**
     * @default 'View Responses'
     */
    nfTR9: T;

    /**
     * @default 'Manage questions'
     */
    UKtAG: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'Leaving this site? Changes you made have not been saved.'
     */
    JDjEc: T;

    /**
     * @default 'Active ({{0}})'
     */
    RG4rs: T;

    /**
     * @default 'Inactive ({{0}})'
     */
    ok3L6: T;

    /**
     * @default 'Advanced Settings'
     */
    Tmkoh: T;

    /**
     * @default 'Open'
     */
    cLbMA: T;

    /**
     * @default 'Most users leave these set to defaults.'
     */
    CVW2l: T;

    /**
     * @default 'Send event details message after RSVP completion'
     */
    MDcd0: T;

    /**
     * @default 'Event Details Message'
     */
    vjRwC: T;

    /**
     * @default 'This is the second message after someone completes RSVP that includes a helpful summary of event details and important links.'
     */
    TvpQ0: T;

    /**
     * @default 'Automatically remind guests about important event details'
     */
    '42wf4': T;

    /**
     * @default 'Automatic Event Reminders'
     */
    Izk2R: T;

    /**
     * @default 'Sometimes guests forget to read FAQs, check the schedule, or plan what to wear. Keep your event top of mind and occasionally remind attending guests about event details and send them links to the event.'
     */
    RBdzP: T;

    /**
     * @default 'Enable custom redirect for guests who RSVP No'
     */
    IuEk1: T;

    /**
     * @default 'Custom Redirect for No RSVP'
     */
    '0kuPT': T;

    /**
     * @default 'When enabled, guests who RSVP No will be redirected to a custom URL after submitting their RSVP. This can be used to provide additional information or resources for those who are unable to attend.'
     */
    '4UN0U': T;

    /**
     * @default 'Instead, Take Not Attending Guests to...'
     */
    '4g20u': T;

    /**
     * @default 'Enable custom redirect for guests who RSVP Yes'
     */
    KFYij: T;

    /**
     * @default 'Custom Redirect for Yes RSVP'
     */
    OnW7r: T;

    /**
     * @default 'When enabled, guests who RSVP Yes will be redirected to a custom URL after submitting their RSVP. This can be used to provide additional information or resources for those who are attending.'
     */
    '4M3Ee': T;

    /**
     * @default 'Instead, Take Attending Guests to...'
     */
    '1jufL': T;

    /**
     * @default 'Privacy'
     */
    CovGk: T;

    /**
     * @default 'Show RSVP'
     */
    a9ZJB: T;

    /**
     * @default 'Turning RSVP on or off will add or remove it from your website and app.'
     */
    afx2e: T;

    /**
     * @default 'Require Password'
     */
    qvrpI: T;

    /**
     * @default 'Guests can only RSVP after first entering a password you choose in'
     */
    xQA72: T;

    /**
     * @default 'Settings.'
     */
    TwPYF: T;

    /**
     * @default 'Restrict RSVP To Guest List'
     */
    iaB6e: T;

    /**
     * @default 'Only allow people you’ve added to your guest list to RSVP. Guests will be asked to confirm their names and only exact matches will be allowed to RSVP.'
     */
    '2LYWi': T;

    /**
     * @default 'Learn More.'
     */
    dPzn8: T;

    /**
     * @default 'Allow guests to add their own +1s'
     */
    '9SlDn': T;

    /**
     * @default 'This will allow any guest to RSVP and add +1s themselves without you having to assign the number individually in Joy. Recommended only if you are letting guests know about +1s through paper invites or in-person.  If you turn this option off, you can still select individual guests in your guest list who you do want to allow +1s for.'
     */
    oT3LV: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;

    /**
     * @default 'Superuser Settings (Not visible to Couples)'
     */
    '9QKxF': T;

    /**
     * @default 'Connection trouble'
     */
    XDrUl: T;

    /**
     * @default 'Apologies, we weren’t able to auto-save your changes. Please click “Try again” to reconnect.'
     */
    FcOEK: T;

    /**
     * @default 'Try again'
     */
    '5VMwm': T;

    /**
     * @default 'Uh oh, it’s still not working...'
     */
    '1KDw6': T;

    /**
     * @default 'Unfortunately, auto-save still isn’t working. Please refresh to try again. We’re very sorry about that.'
     */
    xbGA0: T;

    /**
     * @default 'Refresh'
     */
    jQp3e: T;
  };
};

export type RsvpCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'RSVP'
     */
    f2uMA: T;

    /**
     * @default 'RSVP button text is required'
     */
    P1T9S: T;

    /**
     * @default 'Unlock button text is required'
     */
    oxVMB: T;

    /**
     * @default 'Unlock Guest Details'
     */
    eKWZY: T;

    /**
     * @default 'Success! RSVP block has been updated.'
     */
    XuSV0: T;

    /**
     * @default 'Success! RSVP block has been saved.'
     */
    '9Bn0F': T;

    /**
     * @default 'An error occurred while saving the RSVP block. Please try again.'
     */
    LxP7T: T;

    /**
     * @default 'RSVP/Unlock Button'
     */
    Ck0Zi: T;

    /**
     * @default 'RSVP Button Text'
     */
    Um52l: T;

    /**
     * @default 'Enter RSVP button text'
     */
    QdTz4: T;

    /**
     * @default 'Unlock Button Text'
     */
    jZv2N: T;

    /**
     * @default 'Enter unlock button text'
     */
    jsYmF: T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Access to RSVP for your guests'
     */
    hOVHX: T;

    /**
     * @default 'RSVP/Unlock Button component is not editable.'
     */
    MlqAC: T;
  };
};

export type RsvpReminderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Send RSVP Reminder'
   */
  title: T;

  /**
   * @default 'Dear Evan,'
   */
  dearEvan: T;

  /**
   * @default 'RSVP'
   */
  rsvp: T;

  /**
   * @default 'From {{from}} via Joy'
   */
  fromViaJoy: T;

  /**
   * @default 'Evan'
   */
  evan: T;

  editMessage: {
    /**
     * @default 'From'
     */
    fromLabel: T;

    /**
     * @default 'Your message'
     */
    messageLabel: T;

    /**
     * @default 'RSVP Link'
     */
    rsvpLinkLabel: T;

    /**
     * @default 'Link is not editable to prevent abuse and misuse of the platform.'
     */
    rsvpLinkLabelHint: T;

    /**
     * @default 'Remind your guests to RSVP'
     */
    title: T;

    /**
     * @default 'Send email to make sure your guests don’t miss the chance to RSVP to your event.'
     */
    description: T;

    /**
     * @default 'How does it work?'
     */
    howItWorks: T;

    /**
     * @default 'Write your message.'
     */
    howItWorksStep1: T;

    /**
     * @default 'Pick guests to remind.'
     */
    howItWorksStep2: T;

    /**
     * @default 'Reminder sent!'
     */
    howItWorksStep3: T;
  };
  confirmAndSend: {
    /**
     * @default 'Almost done!'
     */
    header: T;

    /**
     * @default 'Review the final details and treat yourself afterwards. You’ve earned it.'
     */
    body: T;

    /**
     * @default 'Has not RSVPd'
     */
    hasNotRSVPdLabel: T;

    /**
     * @default 'All guests with contact info in the guest list have RSVP’d'
     */
    hasNotRSVPdLabelInfo: T;

    confirmAndSendActions: {
      addGuests: {
        hed: {
          /**
           * @default 'Add recipients'
           */
          guest_0: T;

          /**
           * @default 'Add or remove recipients'
           * @param {number} count - The number of occurrences.
           * - singular: Add or remove recipients
           * - plural: Edit recipients
           */
          guest: T;
        };

        /**
         * @default 'We have preselected guests who have not RSVP’d, but you can edit our selection if you wish.'
         */
        dek: T;

        buttonText: {
          /**
           * @default 'Select Guests'
           */
          guest_0: T;

          /**
           * @default '{{count}} Guest Selected…'
           * @param {number} count - The number of occurrences.
           * - singular: {{count}} Guest Selected…
           * - plural: {{count}} Guests Selected…
           */
          guest: T;
        };

        /**
         * @default 'Modify Recipients'
         */
        buttonTextHover: T;
      };
      testEmail: {
        /**
         * @default 'Do an optional final check'
         */
        hed: T;

        /**
         * @default 'Never hurts to make sure everything is just right.'
         */
        dek: T;

        /**
         * @default 'Send Test Email'
         */
        buttonText: T;
      };
      send: {
        /**
         * @default 'Send Reminder'
         */
        hed: T;

        /**
         * @default 'Send reminder to all guests you picked.'
         */
        dek: T;

        /**
         * @default 'Send Now'
         */
        buttonText: T;
      };
    };
    EmailSentSuccessMessage: {
      /**
       * @default 'Your email is on the way!'
       * @param {number} count - The number of occurrences.
       * - singular: Your email is on the way!
       * - plural: Your emails are on the way!
       */
      guest: T;
    };

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    EmailSentErrorMessage: T;

    /**
     * @default 'Please, select guests first'
     */
    noGuestsSelectedErrorMessage: T;

    /**
     * @default 'Email is not valid'
     */
    emailInvalidMessage: T;

    confirmationScreen: {
      /**
       * @default 'Your reminder to RSVP has been sent to {{count}} people.'
       */
      hed: T;

      /**
       * @default 'Patience is a virtue, but these great rates won’t wait!'
       */
      dek: T;

      /**
       * @default 'You can track their responses by clicking the link below.'
       */
      buttonText: T;
    };
    sendTestEmailDialog: {
      /**
       * @default 'Send Test Email'
       */
      header: T;

      /**
       * @default 'Name'
       */
      testNameLabel: T;

      /**
       * @default 'Email'
       */
      emailLabel: T;

      /**
       * @default 'First Name'
       */
      testNamePlaceholder: T;

      /**
       * @default 'pat@withjoy.com'
       */
      emailPlaceholder: T;

      /**
       * @default 'Name is required'
       */
      testNameErrorMessage: T;

      /**
       * @default 'Email is required'
       */
      emailErrorMessage: T;

      /**
       * @default 'Should be a valid email address'
       */
      emailInvalidErrorMessage: T;

      /**
       * @default 'Send'
       */
      sendButtonText: T;

      /**
       * @default 'Cancel'
       */
      cancelButtonText: T;
    };
    message: {
      /**
       * @default 'Our wedding is right around the corner 🎉. We can’t wait to celebrate with you! Friendly reminder that our RSVP deadline is coming up. Let us know as soon as possible if you will be in attendance.'
       */
      default: T;
    };

    /**
     * @default 'Confirm & Send'
     */
    confirmAndSendLabel: T;

    /**
     * @default 'Edit Message'
     */
    editMessageLabel: T;

    /**
     * @default 'Next'
     */
    nextButtonText: T;

    /**
     * @default 'To:'
     */
    toLabel: T;

    /**
     * @default 'Subject:'
     */
    subjectLabel: T;
  };
  quick: {
    /**
     * @default 'View Your Guests List'
     */
    '1esP9': T;

    /**
     * @default 'Edit Message'
     */
    '72hts': T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Message'
     */
    xuA6e: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Optional Test Email'
     */
    UbuTN: T;

    /**
     * @default 'Never hurts to make sure everything is just right.'
     */
    dEpA1: T;

    /**
     * @default 'Send Test Email'
     */
    G4RRe: T;

    /**
     * @default 'Select Recipients'
     */
    WeTkN: T;

    /**
     * @default 'Edit Guests'
     */
    Zoa0t: T;

    /**
     * @default 'Add Guests'
     */
    sMEgi: T;

    /**
     * @default 'Send Message'
     */
    bkLsr: T;

    /**
     * @default 'Keep an eye on replies and poke the slow pokes.'
     */
    cqENB: T;

    /**
     * @default 'Select recipients to send your message'
     */
    TcLCM: T;

    /**
     * @default 'Send to (No Guests Selected)'
     */
    xdSso: T;

    /**
     * @default 'Send'
     */
    Yh9MA: T;

    /**
     * @default 'Your message needs more detail so it ends up in your guests' inbox. Please include at least {{0}} characters. Spam filters flag both short and generic content.'
     */
    RIWZR: T;

    /**
     * @default 'Our wedding is right around the corner 🎉. We can't wait to celebrate with you! Friendly reminder that our RSVP deadline is coming up. Let us know as soon as possible if you will be in attendance.'
     */
    e3PKk: T;

    /**
     * @default 'Please, select guests first'
     */
    '3tzWP': T;

    /**
     * @default 'Sorry, something may have gone wrong'
     */
    A3Epe: T;

    /**
     * @default 'Your email is on the way!'
     */
    TEOIO: T;
  };
};

export type ScheduleEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  form: {
    /**
     * @default 'Event Title'
     */
    nameFieldTitle: T;

    /**
     * @default 'Event Title'
     */
    nameFieldPlaceholder: T;

    /**
     * @default 'Description'
     */
    descriptionFieldTitle: T;

    /**
     * @default 'Description (Optional)'
     */
    descriptionFieldPlaceholder: T;

    /**
     * @default 'Event Time Zone'
     */
    timezoneFieldTitle: T;

    /**
     * @default 'Select your time zone'
     */
    timezoneFieldPlaceholder: T;

    /**
     * @default 'Start Date'
     */
    startDateTitle: T;

    /**
     * @default 'End Date'
     */
    endDateTitle: T;

    eventTimeSelector: {
      /**
       * @default 'Date and Time'
       */
      title: T;

      /**
       * @default 'Start Only'
       */
      startOnly: T;

      /**
       * @default 'Start + End'
       */
      startEnd: T;

      /**
       * @default 'TBA'
       */
      tba: T;
    };
    eventTypeSelector: {
      /**
       * @default 'Event Type'
       */
      title: T;

      /**
       * @default 'In Person'
       */
      inPerson: T;

      /**
       * @default 'Virtual'
       */
      virtual: T;

      /**
       * @default 'Both'
       */
      both: T;

      /**
       * @default 'Connect a Livestream'
       */
      eventTypeHeading: T;

      /**
       * @default 'Paste your livestream link below. Only guests who have access to this event will be able to see the link.'
       */
      eventTypeBody: T;

      /**
       * @default 'Virtual Event Link'
       */
      eventLinkHeading: T;

      /**
       * @default 'https://zoom.us/j/12345...'
       */
      eventLinkPlaceholder: T;

      /**
       * @default 'Test Livestream Link'
       */
      testLivestreamCTA: T;

      /**
       * @default 'Don’t have a link? Create one:'
       */
      createStreamHeading: T;

      /**
       * @default 'Which one is right for me?'
       */
      whichIsRight: T;
    };

    /**
     * @default 'Dress Code'
     */
    dressCodeTitle: T;

    /**
     * @default 'Business Casual'
     */
    dressCodePlaceholder: T;

    /**
     * @default 'Save'
     */
    primaryCTA: T;

    /**
     * @default 'Cancel'
     */
    secondaryCTA: T;

    /**
     * @default 'Delete Event'
     */
    destroyCTA: T;
  };
  confirmationModals: {
    cancelModal: {
      /**
       * @default 'Are you sure you want to discard your changes?'
       */
      title: T;

      /**
       * @default 'This cannot be undone.'
       */
      subtitle: T;

      /**
       * @default 'Cancel'
       */
      goBackCTA: T;

      /**
       * @default 'Discard Changes'
       */
      discardCTA: T;
    };
    deleteModal: {
      /**
       * @default 'Are you sure you want to delete this?'
       */
      title: T;

      /**
       * @default 'This cannot be undone.'
       */
      subtitle: T;

      /**
       * @default 'Cancel'
       */
      goBackCTA: T;

      /**
       * @default 'Delete Event'
       */
      discardCTA: T;
    };
  };
  quick: {
    /**
     * @default 'Event Type'
     */
    qRpbn: T;

    /**
     * @default 'Date and Time'
     */
    uDcZF: T;

    /**
     * @default 'Start Only'
     */
    OpjFJ: T;

    /**
     * @default 'Start + End'
     */
    '2PO4c': T;

    /**
     * @default 'TBA'
     */
    lXYAA: T;

    /**
     * @default 'Basic Info'
     */
    Kg1oX: T;

    /**
     * @default 'Event Privacy'
     */
    aP73J: T;

    /**
     * @default 'Who should be able to see this item on your schedule?'
     */
    X6R6K: T;

    /**
     * @default 'Anyone who visits your website'
     */
    G9yvi: T;

    /**
     * @default 'Specific guests'
     */
    Xn01r: T;

    /**
     * @default 'Select tags to show only to these guests'
     */
    ur9GJ: T;

    /**
     * @default 'Add tags...'
     */
    '8pk9P': T;
  };
};

export type SettingsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Event Settings'
     */
    eventSettings: T;

    /**
     * @default 'Home'
     */
    home: T;

    /**
     * @default 'Help'
     */
    help: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Save Changes'
     */
    saveChanges: T;
  };
  nav: {
    /**
     * @default 'General'
     */
    general: T;

    /**
     * @default 'Website'
     */
    website: T;

    /**
     * @default 'Admins'
     */
    admins: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'Where to Stay'
     */
    whereToStay: T;

    /**
     * @default 'You’ve got unsaved changes. Are you sure you want to navigate away from this page?'
     */
    blockedMessages: T;
  };
  inputJoyUrl: {
    /**
     * @default 'withjoy.com/'
     */
    prefix: T;

    /**
     * @default 'This URL is available'
     */
    available: T;

    /**
     * @default 'This URL is not available'
     */
    notAvailable: T;

    /**
     * @default 'Oops! Something went wrong. 
 Please reload the page and try again.'
*/
    error: T;

    /**
     * @default 'Max characters'
     */
    labelMaxCharacters: T;
  };
  registry: {
    /**
     * @default 'Registry'
     */
    title: T;

    /**
     * @default 'Shipping Address'
     */
    shippingAddress: T;

    /**
     * @default 'Gifts fulfilled by Joy can ship to the contiguous United States (excluding Non-Continental United States territories).'
     */
    shippingAddressNote: T;

    /**
     * @default 'Currency'
     */
    currency: T;

    /**
     * @default 'Set the currency which is displayed on your manually added registry gifts and new cash funds. This will not affect existing cash funds or gifts added from the Joy shop.'
     */
    currencyNote: T;

    /**
     * @default 'Delay Shipping'
     */
    delayShipping: T;

    /**
     * @default 'You decide when you want gifts fulfilled by Joy to ship.'
     */
    delayShippingNote: T;

    /**
     * @default 'On'
     */
    on: T;

    /**
     * @default 'Off'
     */
    off: T;

    /**
     * @default 'Delay Shipping is'
     */
    toggleLabel: T;

    /**
     * @default 'Seamless Checkout'
     */
    seamlessCheckout: T;

    /**
     * @default 'Simplify your guests' checkout experience for eligible gifts when possible.'
     */
    seamlessCheckoutNote: T;

    /**
     * @default 'Seamless Checkout is'
     */
    seamlessCheckoutToggleLabel: T;

    /**
     * @default 'Cash Fund Setup'
     */
    cashFundSetup: T;

    /**
     * @default 'Let your guests contribute to your cash funds with their credit cards.'
     */
    cashFundSetupNote: T;

    /**
     * @default 'Manage Account'
     */
    manageAccount: T;

    /**
     * @default 'Connect to Stripe'
     */
    stripeConnect: T;

    /**
     * @default 'Connected Registries'
     */
    connectedRegistries: T;

    /**
     * @default 'Connect a Registry'
     */
    connectRegistry: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'No Shipping Address.'
     */
    noShippingAddress: T;

    /**
     * @default 'Add'
     */
    add: T;

    /**
     * @default 'Bank Account'
     */
    bankAccount: T;

    /**
     * @default 'Exchange eligible gifts for cash, allow gift givers to contribute to your cash funds using a credit card, and more when you create a Joy Wallet!'
     */
    joyCreditNote: T;

    /**
     * @default 'Continue'
     */
    continue: T;

    /**
     * @default 'Already registered somewhere else? Connect it to Joy to make your registry a success'
     */
    connectRegistryNote: T;

    /**
     * @default 'You need to add a valid US shipping address'
     */
    addValidShippingAddress: T;

    /**
     * @default 'Advanced Settings'
     */
    advancedSettings: T;

    /**
     * @default 'Most users leave these set to defaults.'
     */
    advancedSettingsNote: T;

    /**
     * @default 'Help guests find my registry'
     */
    findMyRegistryInMessagingSettingTitle: T;

    /**
     * @default 'Keep it easy for guests to contribute to your registry.'
     */
    titleConfirmationDialog: T;

    /**
     * @default '87% of guests want to give to wedding registries. Joy helps millions of people make the best decisions during this important moment in their lives.'
     */
    findMyRegistryInMessagingSettingNote: T;

    /**
     * @default 'Help guests find my registry'
     */
    findMyRegistryInMessagingSettingConfirm: T;

    /**
     * @default 'Don't help guests find my registry'
     */
    findMyRegistryInMessagingSettingCancel: T;

    /**
     * @default 'Tastefully links guests to your registry'
     */
    benefit1: T;

    /**
     * @default 'Avoids unwanted and duplicate gifts'
     */
    benefit2: T;

    /**
     * @default 'Reduces “Where's your registry??” questions'
     */
    benefit3: T;

    /**
     * @default 'Helps guests who can't attend send a gift'
     */
    benefit4: T;

    /**
     * @default 'Keeping this on:'
     */
    keepSettingOn: T;

    /**
     * @default 'Joy will help guests find your registry after RSVP and in confirmation messages to guests.'
     */
    findMyRegistryTooltip: T;
  };
  whereToStay: {
    /**
     * @default 'Where to Stay'
     */
    title: T;

    /**
     * @default 'Hotel Booking Alerts'
     */
    hotelBookingAlerts: T;

    smsNotifications: {
      /**
       * @default 'SMS Notifications'
       */
      title: T;

      /**
       * @default 'Receive a text message when a guest books a Joy Travel hotel on your website. <NoteLink/>'
       */
      note: T;

      /**
       * @default 'Add a mobile phone number to get alerts.'
       */
      noteLink: T;
    };
    emailNotifications: {
      /**
       * @default 'Email Notifications'
       */
      title: T;

      /**
       * @default 'Receive an email when a guest books a Joy Travel hotel on your website.'
       */
      note: T;
    };

    /**
     * @default 'Guest Hotel Booking Reminder'
     */
    guestHotelBookingReminder: T;

    guestHotelReminder: {
      /**
       * @default 'Booking Auto-Reminder'
       */
      title: T;

      /**
       * @default 'Remind guests who RSVP'd with a “yes” about booking accommodations with discounted prices. <NoteLink/>'
       */
      note: T;

      /**
       * @default 'Learn more'
       */
      noteLink: T;

      dialog: {
        /**
         * @default 'Don’t let guests miss out on rooms.'
         */
        title: T;

        features: [
          {
            /**
             * @default 'Prevent Last Minute Mishaps'
             */
            title: T;

            /**
             * @default 'Remind guests to book early and save. Hotels near your venue can sell out quickly. '
             */
            note: T;
          },
          {
            /**
             * @default 'How it Works'
             */
            title: T;

            /**
             * @default 'Joy will send attending guests a reminder to book 7 days after they RSVP, linking them to your hotel recs. '
             */
            note: T;
          },
        ];

        /**
         * @default 'Remind Guests to Book'
         */
        keepCta: T;

        /**
         * @default 'I’ll risk my guests missing out'
         */
        removeCta: T;
      };
    };

    /**
     * @default 'Guest Perks & Smart Tools'
     */
    guestPerksSmartTools: T;

    scheduleWhereToStay: {
      /**
       * @default 'Show 'Where to Stay' on Schedule'
       */
      title: T;

      /**
       * @default 'Link to your ‘Where to Stay’ page from your Schedule'
       */
      note: T;
    };
    exploreMoreHotels: {
      /**
       * @default 'Show 'Explore More Hotels' Button'
       */
      title: T;

      /**
       * @default 'Give guests more options — let them browse and book other nearby hotels with ease.'
       */
      note: T;

      dialog: {
        /**
         * @default 'Allow Your Guests to Browse Hotels with Exclusive Rates'
         */
        title: T;

        features: [
          {
            /**
             * @default 'Broader hotel selection'
             */
            title: T;

            /**
             * @default 'Guests can easily find more hotel options with the same exclusive rates.'
             */
            note: T;
          },
          {
            /**
             * @default 'Track where your guests are staying'
             */
            title: T;

            /**
             * @default 'We’ll notify you when a guest books, and you can view all bookings to help with planning.'
             */
            note: T;
          },
        ];

        /**
         * @default 'Keep Explore Other Options'
         */
        keepCta: T;

        /**
         * @default 'Remove Explore More'
         */
        removeCta: T;
      };
    };

    /**
     * @default 'Advanced Hotel Settings'
     */
    advancedHotelSettings: T;

    tripProfit: {
      /**
       * @default 'Share Joy’s exclusive hotel discounts when available'
       */
      title: T;

      /**
       * @default 'Joy gets special discounts through Closed User Group rates. Enable this to offer these discounts to your guests.'
       */
      note: T;

      dialog: {
        /**
         * @default 'Show Discounted Partner Hotel Rates'
         */
        title: T;

        features: [
          {
            /**
             * @default 'Show the most competitive offer to your guests'
             */
            title: T;

            /**
             * @default 'Joy gets special discounts as a part of closed user group rates. Enable these for your guests.'
             */
            note: T;
          },
          {
            /**
             * @default 'Exclusive Event Only Access '
             */
            title: T;

            /**
             * @default 'Allow your guests to book with rates available only to Joy couples and guests.'
             */
            note: T;
          },
        ];

        /**
         * @default 'Suggest Partner Hotel Rates'
         */
        keepCta: T;

        /**
         * @default 'Remove Suggestions'
         */
        removeCta: T;
      };
    };
    priceCompare: {
      /**
       * @default 'Help guests compare and find the lowest rate before booking'
       */
      title: T;

      /**
       * @default 'Display a quick hotel price comparison, ensuring your guests can easily find the best available rate for their stay.'
       */
      note: T;

      dialog: {
        /**
         * @default 'Display Hotel Price Comparisons'
         */
        title: T;

        features: [
          {
            /**
             * @default 'Offer Rate Insights'
             */
            title: T;

            /**
             * @default 'Display a quick hotel price comparison, ensuring your guests can easily find the best available rate for their stay.'
             */
            note: T;
          },
          {
            /**
             * @default 'Offer More Booking Options'
             */
            title: T;

            /**
             * @default 'Allow guests to choose the most suitable place to book their stay.'
             */
            note: T;
          },
        ];

        /**
         * @default 'Display Hotel Price Comparisons'
         */
        keepCta: T;

        /**
         * @default 'Remove Comparison'
         */
        removeCta: T;
      };
    };

    /**
     * @default 'There was an error getting the settings values.'
     */
    queryError: T;

    /**
     * @default 'There was an error performing the update.'
     */
    mutationError: T;
  };
  website: {
    /**
     * @default 'Website'
     */
    title: T;

    /**
     * @default 'Event Password'
     */
    eventPassword: T;

    /**
     * @default 'Password'
     */
    password: T;

    /**
     * @default 'Copy Event Password'
     */
    copyPassword: T;

    /**
     * @default 'Password copied.'
     */
    passwordCopiedToast: T;

    /**
     * @default 'Edit Password'
     */
    editPassword: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Please Note:'
     */
    pleaseNote: T;

    /**
     * @default 'If you changed your password, guests will no longer be able to use your current password to unlock your event.'
     */
    passwordChangeNote: T;

    /**
     * @default 'Guests will need to know your Joy event URL and event password to find and join your event on the app.'
     */
    passwordNote: T;

    /**
     * @default 'Password protect event date'
     */
    protectEventDate: T;

    /**
     * @default 'Password protect your event date so guests with password can access this information.'
     */
    protectEventDateNote: T;

    /**
     * @default 'Password protect event location'
     */
    protectEventLocation: T;

    /**
     * @default 'Password protect your event location so guests with password can access this information.'
     */
    protectEventLocationNote: T;

    /**
     * @default 'Event Settings saved'
     */
    settingsUpdateSuccess: T;

    /**
     * @default 'Error updating settings. Please try again later.'
     */
    settingsUpdateError: T;

    /**
     * @default 'Page settings saved.'
     */
    pageSettingsSaved: T;

    /**
     * @default 'Error saving page settings. Please try again later.'
     */
    pageSettingsError: T;

    /**
     * @default 'Page order saved.'
     */
    pageOrderSaved: T;

    /**
     * @default 'Error saving page order. Please try again later.'
     */
    pageOrderError: T;

    /**
     * @default 'Search Privacy'
     */
    searchPrivacy: T;

    /**
     * @default 'Allow guests to search for my event on Joy'
     */
    showOnGuestSearch: T;

    /**
     * @default 'Help guests find your website and registry if they’ve lost the link. Search results are not guaranteed.'
     */
    showOnGuestSearchNote: T;

    /**
     * @default 'Allow my event to be found on Google etc.'
     */
    showOnSearchEngine: T;

    /**
     * @default 'Search engine changes may take anywhere from a few days to weeks to take effect. Search results are not guaranteed.'
     */
    showOnSearchEngineNote: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Email verification is required.'
     */
    emailVerificationRequired: T;

    /**
     * @default 'Verify Email'
     */
    verifyEmail: T;

    /**
     * @default 'Pages'
     */
    pages: T;

    /**
     * @default 'Modify All…'
     */
    modifyAll: T;

    /**
     * @default 'Password Protections'
     */
    passwordProtections: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'None of your pages are password protected.'
     */
    nonePasswordProtected: T;

    /**
     * @default 'Some of your pages are password protected.'
     */
    somePagesProtected: T;

    /**
     * @default 'All of your pages are password protected.'
     */
    allPagesProtected: T;

    /**
     * @default 'All of your pages are hidden.'
     */
    allPagesHidden: T;

    /**
     * @default 'Announcement Banner'
     */
    announcementBanner: T;

    /**
     * @default 'Display announcement banner'
     */
    displayAnnouncementBanner: T;

    /**
     * @default 'Make sure guests don't miss an update or important detail when they arrive on your website.'
     */
    displayAnnouncementBannerNote: T;

    /**
     * @default 'Title'
     */
    bannerTitle: T;

    /**
     * @default 'Message'
     */
    message: T;

    /**
     * @default 'Preview Banner'
     */
    previewBanner: T;

    /**
     * @default 'Countdown and App Link'
     */
    countdownAndAppLink: T;

    /**
     * @default 'Display event countdown'
     */
    displayEventCountdown: T;

    /**
     * @default 'Countdown to your {{eventName}} for {{date}}. You can edit event times in your'
     */
    displayCountdownNoteWithEvent: T;

    /**
     * @default 'Countdown to {{date}}.'
     */
    displayCountdownNoteWithoutEvent: T;

    /**
     * @default 'Schedule.'
     */
    schedule: T;

    /**
     * @default 'Schedule Event'
     */
    scheduleEvent: T;

    /**
     * @default 'Display "Get the App" link'
     */
    getTheAppTitle: T;

    /**
     * @default 'Give guests a link to download the Joy app so they can upload photos and access event details on the go.'
     */
    getTheAppSubtitle: T;

    /**
     * @default 'App Photo'
     */
    appPhoto: T;

    /**
     * @default 'Update Photo'
     */
    updatePhoto: T;

    /**
     * @default 'Delete Photo'
     */
    deletePhoto: T;

    /**
     * @default 'Error uploading photo. Please try again later.'
     */
    uploadError: T;

    /**
     * @default 'Photo uploaded successfully.'
     */
    uploadSuccess: T;

    /**
     * @default 'Error deleting photo. Please try again later.'
     */
    deletePhotoError: T;

    /**
     * @default 'Photo deleted successfully.'
     */
    deletePhotoSuccess: T;

    /**
     * @default 'Add an event to your schedule to customize'
     */
    scheduleEmptyPlaceholder: T;

    /**
     * @default 'Select...'
     */
    scheduleNotSelectedPlaceholder: T;

    /**
     * @default 'We have determined that your website contains potentially dangerous content which is in breach of our terms of service. Please contact our customer support team to resolve this issue.'
     */
    unSafeEventInfoText: T;

    /**
     * @default 'Contact Us'
     */
    contactSupport: T;

    /**
     * @default 'No page photo'
     */
    noPagePhoto: T;

    /**
     * @default 'Advanced Hotel Settings'
     */
    advancedHotelSettings: T;

    /**
     * @default 'Most users keep these set to defaults.'
     */
    advancedHotelSettingsNote: T;

    /**
     * @default 'There was an error getting the settings values.'
     */
    advancedHotelSettingsQueryError: T;

    /**
     * @default 'There was an error performing the update.'
     */
    advancedHotelSettingsMutationError: T;

    /**
     * @default 'Disable Closed User Group (CUG) discounted hotel rates for my guests'
     */
    tripProfitTitle: T;

    /**
     * @default 'Joy secures exclusive hotel discounts called Closed User Group (CUG) rates by supporting millions of events and hundreds of millions of guests. These private rates are not available anywhere else online and are shown only when relevant. If you have arranged room blocks with specific hotels, Joy will automatically exclude those from showing CUG rates. Most couples keep this setting on. See real-world discounts before deciding to turn it off.'
     */
    tripProfitNote: T;

    /**
     * @default 'Let my guests compare rates and choose what works best for them'
     */
    interceptorTitle: T;

    /**
     * @default 'Joy supports millions of events and hundreds of millions of guests, unlocking exclusive Closed User Group (CUG) hotel rates. When a hotel link is shared, Joy may show guests a choice between the original link and a lower private rate. Room blocks you arrange are automatically respected, and this will not interfere with them. Rates can change from day to day, so we recommend not turning this off based on a single day's comparison. Most couples leave this on so guests can choose what works best for them. Turn off only if you are using an attrition-based room block with financial guarantees.'
     */
    interceptorNote: T;

    pageVisibility: {
      /**
       * @default 'Public'
       */
      public: T;

      /**
       * @default 'Password'
       */
      passwordProtected: T;

      /**
       * @default 'Hidden'
       */
      hidden: T;
    };

    /**
     * @default 'Page Settings'
     */
    pageDisplayName: T;

    /**
     * @default 'Advanced Schedule Settings'
     */
    advancedScheduleSettings: T;

    addToCalendar: {
      /**
       * @default 'Show 'Add to Calendar' on Schedule'
       */
      title: T;

      /**
       * @default 'Allow guests to easily add your event details to their calendar.'
       */
      note: T;

      dialog: {
        /**
         * @default 'Guests rely on Add to Calendar to avoid missing important events.'
         */
        title: T;

        /**
         * @default 'Disabling this option may make it harder for them to remember times and locations. We recommend keeping it on to ensure a smoother experience for your guests.'
         */
        note: T;

        /**
         * @default 'Keep Add to Calendar'
         */
        keepCta: T;

        /**
         * @default 'Remove Add to Calendar'
         */
        removeCta: T;
      };
    };
  };
  general: {
    /**
     * @default 'General'
     */
    title: T;

    /**
     * @default 'Joy Event URL'
     */
    joyEventURL: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Add a Custom Domain'
     */
    addCustomDomain: T;

    /**
     * @default 'Copy Event URL'
     */
    copyEventURL: T;

    /**
     * @default 'Event URL copied.'
     */
    eventUrlCopiedToast: T;

    /**
     * @default 'Custom domain URL copied.'
     */
    customDomainCopiedToast: T;

    /**
     * @default 'Event URL'
     */
    eventUrl: T;

    /**
     * @default 'Your old Joy URL will no longer work - this means you'll need to let all your guests know the new address so they can still access your website. Please note that if you have a custom domain, you will also need to update your forwarding URL to point to this new Joy URL.'
     */
    eventUrlNote: T;

    /**
     * @default 'Event URL updated'
     */
    eventUrlUpdateSuccess: T;

    /**
     * @default 'Error updating event URL. Please try again later.'
     */
    eventUrlUpdateError: T;

    /**
     * @default 'Personal Info'
     */
    personalInfo: T;

    /**
     * @default 'Partner One'
     */
    partnerOne: T;

    /**
     * @default 'Partner Two'
     */
    partnerTwo: T;

    /**
     * @default 'Event Display Name'
     */
    eventDisplayName: T;

    /**
     * @default 'First Name'
     */
    firstName: T;

    /**
     * @default 'Last Name'
     */
    lastName: T;

    /**
     * @default 'First name is required'
     */
    firstNameError: T;

    /**
     * @default 'Event display name cannot be blank'
     */
    eventDisplayNameError: T;

    /**
     * @default 'Date'
     */
    date: T;

    /**
     * @default 'Please re-enter the date in MM/DD/YYYY format'
     */
    invalidDate: T;

    /**
     * @default 'Show date in website and app'
     */
    showDateInApp: T;

    /**
     * @default 'When you hide your date, it won’t appear on your website or app and your countdown will be disabled.'
     */
    showDateInAppInfo: T;

    /**
     * @default 'Location'
     */
    location: T;

    /**
     * @default 'Powered by Google'
     */
    poweredBy: T;

    /**
     * @default 'Time Zone'
     */
    timeZone: T;

    /**
     * @default 'Delete Event'
     */
    deleteEvent: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Custom Domain'
     */
    customDomain: T;

    /**
     * @default 'Remove Domain'
     */
    removeDomain: T;

    /**
     * @default 'Copy Custom Domain URL'
     */
    copyCustomDomainUrl: T;

    /**
     * @default 'Need Help?'
     */
    needHelp: T;

    /**
     * @default 'Custom domain updated'
     */
    customDomainUpdateSuccess: T;

    /**
     * @default 'Error updating custom domain. Please try again later.'
     */
    customDomainUpdateError: T;

    /**
     * @default 'Custom domain removed'
     */
    customDomainRemoveSuccess: T;

    /**
     * @default 'Error removing custom domain. Please try again later.'
     */
    customDomainRemoveError: T;

    findCustomDomainDialog: {
      /**
       * @default 'How would you like to add a custom domain?'
       */
      title: T;

      /**
       * @default 'Find the perfect domain'
       */
      ctaLabel1: T;

      /**
       * @default 'I already have a domain'
       */
      ctaLabel2: T;

      /**
       * @default 'Custom domains are an option service provided by GoDaddy not Joy. Domain masking is not supported.'
       */
      note: T;
    };
    addCustomDomainDialog: {
      /**
       * @default 'What’s your custom domain?'
       */
      title: T;

      /**
       * @default 'We’ll walk you through how to connect your domain to your Joy website.'
       */
      subtitle: T;

      /**
       * @default 'Save'
       */
      ctaLabel1: T;

      /**
       * @default 'Cancel'
       */
      ctaLabel2: T;

      /**
       * @default 'Custom domains are an option service provided by GoDaddy not Joy. Domain masking is not supported.'
       */
      note: T;

      /**
       * @default 'Your Domain Name'
       */
      yourDomainName: T;

      /**
       * @default 'yourdomain.com'
       */
      placeholder: T;

      /**
       * @default 'Test URL'
       */
      testUrl: T;

      /**
       * @default 'Domain name cannot be blank'
       */
      blankDomainError: T;

      /**
       * @default 'Not a valid domain'
       */
      notValidDomainError: T;

      quickAccess: [
        {
          /**
           * @default 'search_domain'
           */
          id: T;

          /**
           * @default 'Search Again'
           */
          title: T;

          /**
           * @default 'Find the domain you’re looking for.'
           */
          subtitle: T;

          /**
           * @default 'Search Domains'
           */
          ctaLabel: T;
        },
        {
          /**
           * @default 'faq'
           */
          id: T;

          /**
           * @default 'Have Questions?'
           */
          title: T;

          /**
           * @default 'Our FAQ section may have the answers.'
           */
          subtitle: T;

          /**
           * @default 'Explore FAQs'
           */
          ctaLabel: T;
        },
        {
          /**
           * @default 'chat'
           */
          id: T;

          /**
           * @default 'Have More Questions'
           */
          title: T;

          /**
           * @default 'Our team is just a chat bubble away.'
           */
          subtitle: T;

          /**
           * @default 'Chat with Us'
           */
          ctaLabel: T;
        },
      ];
    };
    removeCustomDomainDialog: {
      /**
       * @default 'Remove your custom domain?'
       */
      title: T;

      /**
       * @default 'Removing your custom domain removes it from your eCards but it will not disconnect it with your domain host.'
       */
      subtitle: T;

      /**
       * @default 'Need help?'
       */
      needHelp: T;

      /**
       * @default 'Remove Domain'
       */
      ctaLabel1: T;

      /**
       * @default 'Cancel'
       */
      ctaLabel2: T;
    };
  };
  users: {
    /**
     * @default 'Admins'
     */
    title: T;
  };
  quick: {
    /**
     * @default 'Don't let guests miss out on rooms.'
     */
    PGS08: T;

    /**
     * @default 'Hotels near your venue can sell out quickly. Make sure your guests have a place to stay, and save money too.'
     */
    AeYnp: T;

    /**
     * @default 'How It Works:'
     */
    jGjZO: T;

    /**
     * @default 'Joy will send attending guests a reminder to book 7 days after they RSVP, linking them to your hotel recs. That way, they book early and you don't have to worry.'
     */
    GnFtl: T;

    /**
     * @default 'Remind Guests to Book'
     */
    KhgiN: T;

    /**
     * @default 'I'll risk my guests missing out'
     */
    ECZeA: T;

    /**
     * @default 'You're all set!'
     */
    Lz3uB: T;

    /**
     * @default 'We'll send the reminder to attending guests 7 days after they RSVP.'
     */
    p87Bx: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'An error occurred while saving the venue. Please try again.'
     */
    wLY6w: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    wHpXa: T;

    /**
     * @default 'Add Collaborator'
     */
    V0CJK: T;

    /**
     * @default 'First Name'
     */
    ZUk3G: T;

    /**
     * @default 'Last Name'
     */
    Z0j3J: T;

    /**
     * @default 'Email Address'
     */
    OgwcY: T;

    /**
     * @default 'Send Invite'
     */
    h6nET: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Revoke Access?'
     */
    bZHfj: T;

    /**
     * @default 'Revoke Invitation?'
     */
    Gn4TP: T;

    /**
     * @default 'Are you sure you want to revoke ${displayName ? '
     */
    nMapa: T;

    /**
     * @default 'this'
     */
    a18RA: T;

    /**
     * @default 'Revoke'
     */
    UwUPS: T;

    /**
     * @default 'Confirm'
     */
    WeV82: T;

    /**
     * @default 'Resend Invite'
     */
    cOU21: T;

    /**
     * @default 'Copy Invite Link'
     */
    '8SepB': T;

    /**
     * @default 'Invite link copied to clipboard!'
     */
    ZCqp9: T;

    /**
     * @default 'Revoke Invite'
     */
    xZvez: T;

    /**
     * @default 'TRANSFER'
     */
    nnzOX: T;

    /**
     * @default 'Enter '{{0}}' to confirm'
     */
    h8LBR: T;

    /**
     * @default 'Are you sure you want to transfer the ownership of this Joy event to:'
     */
    XRbst: T;

    /**
     * @default 'You will no longer be the primary account owner and your account will be downgraded to an admin account for this event.'
     */
    pYslU: T;

    /**
     * @default 'Transfer Ownership?'
     */
    p9pkJ: T;

    /**
     * @default 'Transfer Ownership'
     */
    '2ZKfN': T;

    /**
     * @default 'You'
     */
    NMaAA: T;

    /**
     * @default 'Please wait before resending invitation'
     */
    k1dNs: T;

    /**
     * @default 'Invitation Resent'
     */
    cVNO8: T;

    /**
     * @default 'Access Revoked'
     */
    sjnYU: T;

    /**
     * @default 'Error revoking access'
     */
    ts3We: T;

    /**
     * @default 'Invitation Revoked!'
     */
    SygZ1: T;

    /**
     * @default 'Error revoking invitation'
     */
    e7PiM: T;

    /**
     * @default 'Error sending invitation'
     */
    nW7cf: T;

    /**
     * @default 'Invitation Sent'
     */
    RlADB: T;

    /**
     * @default 'Something went wrong, please try again'
     */
    mmJyj: T;

    /**
     * @default 'Error transferring ownership'
     */
    cZpuK: T;

    /**
     * @default 'Ownership Transferred'
     */
    PwarE: T;

    /**
     * @default 'Remove Admin'
     */
    '7MpGe': T;

    /**
     * @default 'Admins'
     */
    EGbHj: T;

    /**
     * @default 'Owner'
     */
    bCjnG: T;

    /**
     * @default 'Collaborators'
     */
    '3wCvR': T;

    /**
     * @default 'Are you sure you want to revoke {{0}} admin privileges?'
     */
    WduJH: T;

    /**
     * @default 'Are you sure you want to revoke {{0}} invitation?'
     */
    '4pYLB': T;

    /**
     * @default 'Website Visibility'
     */
    NvtPx: T;

    /**
     * @default 'Publish your website'
     */
    rvvgD: T;

    /**
     * @default 'Keep your site unpublished while you’re building it. Publish it when you’re ready for guests to visit.'
     */
    dsWlA: T;

    /**
     * @default 'Page Currency'
     */
    A8sWK: T;

    /**
     * @default 'Error loading currency settings'
     */
    aHmYC: T;

    /**
     * @default 'Error saving currency settings'
     */
    ANKen: T;

    /**
     * @default 'The default currency that your guests will see for the hotel recommendations.'
     */
    bidMj: T;

    /**
     * @default 'Default Currency'
     */
    EEdII: T;

    /**
     * @default 'Select a currency'
     */
    ow1mE: T;

    /**
     * @default 'Photo uploaded successfully.'
     */
    rCjjD: T;

    /**
     * @default 'Error uploading photo. Please try again later.'
     */
    yLC80: T;

    /**
     * @default 'Photo deleted successfully.'
     */
    '8YqSl': T;

    /**
     * @default 'Error deleting photo. Please try again later.'
     */
    bhtcc: T;

    /**
     * @default 'Update Photo'
     */
    LZhkP: T;

    /**
     * @default 'Delete Photo'
     */
    doIgF: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Hotel Booking Alerts'
     */
    o4QTr: T;

    /**
     * @default 'Guest Hotel Booking Reminder'
     */
    '7yzyF': T;

    /**
     * @default 'Guest Perks & Smart Tools'
     */
    rOph0: T;

    /**
     * @default 'Show 'Where to Stay' on Schedule'
     */
    oIoS9: T;

    /**
     * @default 'Link to your 'Where to Stay' page from your Schedule'
     */
    khKc1: T;

    /**
     * @default 'Show vacation rental alongside hotels'
     */
    JCX6B: T;

    /**
     * @default 'Give guests the option to book vacation rentals for more space, privacy, or flexibility. Since vacation rental availability changes quickly, Joy recommends areas near your venue for guests to find available rentals.'
     */
    qlhF5: T;

    /**
     * @default 'Advanced Hotel Settings'
     */
    tNIuC: T;

    /**
     * @default 'Share Joy's exclusive hotel discounts when available'
     */
    '4tbfd': T;

    /**
     * @default 'Joy gets special discounts through Closed User Group rates. Enable this to offer these discounts to your guests.'
     */
    ao0uf: T;

    /**
     * @default 'Show Discounted Partner Hotel Rates'
     */
    k1Gla: T;

    /**
     * @default 'Show the most competitive offer to your guests'
     */
    FGXRO: T;

    /**
     * @default 'Joy gets special discounts as a part of closed user group rates. Enable these for your guests.'
     */
    xwbFA: T;

    /**
     * @default 'Exclusive Event Only Access'
     */
    WAMN5: T;

    /**
     * @default 'Allow your guests to book with rates available only to Joy couples and guests.'
     */
    t8zyl: T;

    /**
     * @default 'Suggest Partner Hotel Rates'
     */
    '33OZM': T;

    /**
     * @default 'Remove Suggestions'
     */
    hON01: T;

    /**
     * @default 'Help guests compare and find the lowest rate before booking'
     */
    klFRU: T;

    /**
     * @default 'Display a quick hotel price comparison, ensuring your guests can easily find the best available rate for their stay.'
     */
    txLeS: T;

    /**
     * @default 'Display Hotel Price Comparisons'
     */
    J93Zv: T;

    /**
     * @default 'Offer Rate Insights'
     */
    '93OcK': T;

    /**
     * @default 'Offer More Booking Options'
     */
    OIDAj: T;

    /**
     * @default 'Allow guests to choose the most suitable place to book their stay.'
     */
    tu4Ha: T;

    /**
     * @default 'Remove Comparison'
     */
    hAioy: T;
  };
};

export type SharedComponentsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  registryGiftBasket: {
    /**
     * @default 'My Registry'
     */
    registryManageRedirectCTA: T;

    /**
     * @default 'Registry Guide'
     */
    giftListProgressTitle: T;

    giftOverlay: {
      giftList: {
        /**
         * @default '{{count}} Gifts'
         */
        tabLabel: T;

        /**
         * @default 'Advisor'
         */
        tabLabelV2: T;

        /**
         * @default 'Recently Added Gifts'
         */
        headerMsg: T;

        /**
         * @default 'Plus {{count}} more gifts in your registry'
         */
        overflowMsg: T;

        /**
         * @default 'Add some gifts and we’ll help you keep track of your most recent adds here.'
         */
        zeroStateMsg: T;

        /**
         * @default 'Manage Gifts'
         */
        fabBtn: T;
      };
      giftTracker: {
        /**
         * @default '{{count}} Tracked'
         */
        tabLabel: T;

        /**
         * @default 'Recently Reserved or Purchased'
         */
        headerMsg: T;

        /**
         * @default 'Plus {{count}} more gifts tracked in your registry'
         */
        overflowMsg: T;

        /**
         * @default 'There are no gifts reserved (yet!). Once gifts are reserved or purchased, you can preview them here.'
         */
        zeroStateMsg: T;

        /**
         * @default 'Track Gifts'
         */
        fabBtn: T;
      };
      checklist: {
        /**
         * @default 'Building your Checklist…'
         */
        buildingChecklist: T;

        /**
         * @default 'Checklist'
         */
        tabLabel: T;

        /**
         * @default ''
         */
        headerMsg: T;

        /**
         * @default ''
         */
        overflowMsg: T;

        /**
         * @default ''
         */
        zeroStateMsg: T;

        /**
         * @default ''
         */
        fabBtn: T;
      };
      shoppingCart: {
        /**
         * @default 'Cart'
         */
        tabLabel: T;

        /**
         * @default ''
         */
        headerMsg: T;

        /**
         * @default ''
         */
        overflowMsg: T;

        /**
         * @default ''
         */
        zeroStateMsg: T;

        /**
         * @default ''
         */
        fabBtn: T;
      };

      /**
       * @default 'There are no gifts in your registry yet. Once you start adding gifts, you can preview recently added items here.'
       */
      giftListZeroState: T;

      /**
       * @default 'There are no gifts reserved (yet!). Once gifts are reserved or purchased, you can preview them here.'
       */
      giftTrackerZeroState: T;

      trackedGiftBadges: {
        /**
         * @default 'Reserved'
         */
        reserved: T;

        /**
         * @default 'Purchased'
         */
        purchased: T;

        /**
         * @default 'Shipped'
         */
        shipped: T;

        /**
         * @default 'Processing'
         */
        processing: T;

        /**
         * @default 'Given'
         */
        given: T;
      };
    };
    floatingWidget: {
      /**
       * @default '{{count}} Gifts'
       */
      giftCount: T;

      /**
       * @default 'Checklist'
       */
      checklist: T;
    };
  };
  giftProgress: {
    /**
     * @default 'Start adding some gifts! 🎁'
     */
    progressNotStarted: T;

    /**
     * @default 'Keep going, you're doing great! 👍'
     */
    progressLessThanHalf: T;

    /**
     * @default 'You're halfway there! 🙌'
     */
    halfwayProgress: T;

    /**
     * @default 'You're so close! 💃'
     */
    progressAlmostComplete: T;

    /**
     * @default 'Congrats, you did it! 🎉'
     */
    progressComplete: T;

    /**
     * @default 'You're super awesome! 🦄✨'
     */
    progressBeyondComplete: T;

    /**
     * @default '{{count}} gifts added!'
     */
    giftsAdded: T;
  };
  registryTabsNavigation: {
    tabs: {
      /**
       * @default 'Overview'
       */
      overview: T;

      /**
       * @default 'Add Gifts'
       */
      gifts: T;

      /**
       * @default 'Track'
       */
      trackNative: T;

      /**
       * @default 'Track Gifts'
       */
      track: T;

      /**
       * @default 'Manage'
       */
      manageNative: T;

      /**
       * @default 'Manage Registry'
       */
      manage: T;

      /**
       * @default 'Menu'
       */
      menu: T;

      /**
       * @default 'Add'
       */
      giftsNative: T;
    };
  };
  countdownGiftCount: {
    greeting: {
      /**
       * @default '🎊 {{count}} day to go!'
       * @param {number} count - The number of occurrences.
       * - singular: 🎊 {{count}} day to go!
       * - plural: 🎊 {{count}} days to go!
       */
      countdownToWedding: T;

      /**
       * @default '{{count}} days ago ️💘'
       */
      countdownPostWedding: T;

      /**
       * @default 'Today's the big day! 🥂'
       */
      weddingDay: T;

      /**
       * @default 'Happy {{dayOfWeek}}!'
       */
      dailyMessage: T;
    };
    counters: {
      /**
       * @default 'Gifts Available'
       */
      giftsAddedLabel: T;

      /**
       * @default 'Reserved & Purchased'
       */
      reservedAndPurchaseLabel: T;
    };
  };
  missingGifts: {
    /**
     * @default 'Looking for a gift?'
     */
    missingGiftsLabel: T;

    /**
     * @default 'To track gifts on linked or synced registries, please visit those registries directly.'
     */
    trackGiftsLabel: T;
  };
  dialog: {
    /**
     * @default 'close dialog'
     */
    closeDialog: T;
  };
  registryGiftCounts: {
    /**
     * @default 'Registry Advisor'
     */
    registryGuide: T;

    /**
     * @default 'Gift Counts by Price'
     */
    countsByPrice: T;

    /**
     * @default 'Goal: {{targetCount}}'
     */
    giftCounts: T;

    /**
     * @default '{{giftCount}} of {{targetCount}} Gift Goal'
     */
    giftCountWithTarget: T;

    /**
     * @default '{{giftCount}} gifts added!'
     */
    totalCompletionCount: T;

    /**
     * @default 'Gift count is calculated with your potential guest count. Remember to include potential guests for engagement parties and showers.'
     */
    toolTip: T;

    /**
     * @default 'Please enter a valid number.'
     */
    inputError: T;

    /**
     * @default 'Save Estimate'
     */
    save: T;

    /**
     * @default 'How many guests are you inviting?'
     */
    howManyGuests: T;

    /**
     * @default 'Not sure? Just guess for now.'
     */
    guessForNow: T;

    /**
     * @default 'Under {{price}}'
     */
    underPrice: T;

    /**
     * @default 'Over {{price}}'
     */
    overPrice: T;

    /**
     * @default 'Edit Guest Count'
     */
    ariaEditLabel: T;

    /**
     * @default 'Browse'
     */
    button: T;

    /**
     * @default 'of '
     */
    of: T;

    /**
     * @default ' Gift Goal'
     */
    giftGoal: T;

    /**
     * @default ' Gifts Added'
     */
    giftsAdded: T;
  };
  safeLink: {
    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Proceed'
     */
    proceed: T;

    /**
     * @default 'Close'
     */
    close: T;

    /**
     * @default 'You are now leaving our website'
     */
    safeLinkTitle: T;

    /**
     * @default 'Unsafe link detected'
     */
    unsafeLinkTitle: T;

    /**
     * @default 'You are about to leave Joy. We are not responsible for the content or availability of the linked site. Please review the site's privacy and security policy as they may differ from Joy's.'
     */
    safeLinkMessage: T;

    /**
     * @default 'External Link'
     */
    externalLinkLabel: T;

    /**
     * @default 'We have determined that this external link is not safe to visit. Please contact the event owner for more details.'
     */
    unsafeLinkMessage: T;

    /**
     * @default 'Thank you for visiting!'
     */
    emptyTabTitle: T;

    /**
     * @default 'our site'
     */
    ourSite: T;

    /**
     * @default 'You can now close this tab and continue exploring <ourSiteLink/>.'
     */
    emptyTabMessage: T;
  };
  shippingAddressDialog: {
    /**
     * @default 'Add Your Shipping Address for Registry'
     */
    reminderTitle: T;

    /**
     * @default 'Add Shipping Address'
     */
    addShippingAddressBtn: T;

    /**
     * @default 'Avoid missing packages and awkward texts, we’ll take care of the rest.'
     */
    reminderDescription: T;

    /**
     * @default 'Remind me Later'
     */
    remindMeLater: T;

    /**
     * @default 'Where should guests send your gifts?'
     */
    shippingAdressFormTitle: T;

    /**
     * @default 'Address Suggestion'
     */
    addressSuggestion: T;

    /**
     * @default 'Please select the address you’d like to use.'
     */
    addressSuggestionDescription: T;

    /**
     * @default 'Confirm'
     */
    confirmAddress: T;

    /**
     * @default 'Back'
     */
    back: T;

    /**
     * @default 'Save Address'
     */
    saveAddressBtn: T;

    /**
     * @default 'Clear Address'
     */
    clearBtn: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Only one recipient name is recommended'
     */
    nameSubtext: T;

    /**
     * @default 'Phone Number'
     */
    mobilePhone: T;

    /**
     * @default 'By entering your phone number, you agree to receive account notifications. You can opt out at any time.'
     */
    phoneDisclaimer: T;

    /**
     * @default 'Street Address'
     */
    address1: T;

    /**
     * @default 'We cannot ship to P.O. boxes'
     */
    address1Subtext: T;

    /**
     * @default 'Apartment, Suite, etc. (Optional)'
     */
    address2: T;

    /**
     * @default 'City'
     */
    city: T;

    /**
     * @default 'State/Region/Province'
     */
    state: T;

    /**
     * @default 'Zip/Postal Code'
     */
    zipCode: T;

    /**
     * @default 'Country'
     */
    country: T;

    /**
     * @default '*Required fields'
     */
    requiredText: T;

    /**
     * @default 'Suggested Address'
     */
    suggestedAddressText: T;

    /**
     * @default 'Original Address'
     */
    originalAddressText: T;

    /**
     * @default 'We could not validate your address.'
     */
    addressValidationError: T;

    syncAndTransfer: {
      /**
       * @default 'Tell Guests where to send your gifts!'
       */
      formTitle: T;

      /**
       * @default 'Please note: items sold by Joy can only be shipped within the contingent United States.'
       */
      formDescription: T;
    };
  };
  searchBar: {
    /**
     * @default 'Search brands, products, or paste a URL'
     */
    placeholder: T;
  };
  eventInfoToast: {
    /**
     * @default '✨ Event ID Copied ✨'
     */
    copiedTextToast: T;

    /**
     * @default 'The event id has been copied to your clipboard:'
     */
    copiedText: T;

    /**
     * @default 'event ID:'
     */
    eventId: T;

    /**
     * @default 'firebase event ID:'
     */
    firebaseEventId: T;

    /**
     * @default 'Go to Firebase'
     */
    goToFirebase: T;
  };
  viewMore: {
    /**
     * @default 'View More'
     */
    viewMoreTitle: T;

    /**
     * @default '{{count}} of {{total}} products'
     */
    productCountSummary: T;
  };
  registryGiftAdvisorV2: {
    /**
     * @default 'Registry Advisor'
     */
    registryAdvisor: T;

    /**
     * @default '{{count}} Guests'
     */
    guestSummary: T;

    /**
     * @default 'Gifts<br>Available'
     */
    giftsAvailable: T;

    /**
     * @default 'Reserved & <br> Purchased'
     */
    reservedAndPurchased: T;

    /**
     * @default '{{count}} Gifts <br> Needed'
     */
    giftCount: T;

    /**
     * @default '1 Cash Fund <br> Needed'
     */
    cashFundCount: T;

    /**
     * @default 'Gift Price Balance'
     */
    giftPriceBalance: T;

    /**
     * @default 'Shop Now'
     */
    shopNow: T;

    /**
     * @default 'Cash Funds <br> Completed'
     */
    cashFundCompleted: T;

    /**
     * @default 'Gifts <br> Completed'
     */
    giftsCompleted: T;
  };
  guestPreferenceMessage: {
    /**
     * @default 'Next Tip'
     */
    nextTip: T;

    /**
     * @default 'Your registry is ready for gifts! You need at least {{targetedGiftCount}} gifts and 1 cash fund for {{guestCount}} invited guests.'
     */
    initialMessageWhenZero: T;

    /**
     * @default 'You’re {{giftsCompletionPercent}}% towards your goal! You need at least {{targetedGiftCount}} gifts and 1 cash fund for {{guestCount}} invited guests.'
     */
    initialMessageWhenGreaterThanZero: T;

    /**
     * @default 'Congratulations, you have enough gifts for your guests!'
     */
    initialMessageWhenGiftOnlyCompleted: T;

    /**
     * @default 'You’re {{giftsCompletionPercent}}% towards your goal! You still need at least {{targetedGiftCount}} gifts for {{guestCount}} invited guests.'
     */
    initialMessageWhenCashFundOnlyCompleted: T;

    facts: {
      /**
       * @default 'Have everything you need? Your wedding is the perfect time for a little upgrade.'
       */
      messageTitle1: T;

      /**
       * @default 'From a bigger food processor to a better vacuum, cash in on upgrade season.'
       */
      messageSubtitle1: T;

      /**
       * @default '67% of guests prefer to give physical gifts over cash—they are more personal and memorable.'
       */
      messageTitle2: T;

      /**
       * @default 'Keep adding more gifts, your guests will be happier.'
       */
      messageSubtitle2: T;

      /**
       * @default '67% of guests prefer to give physical gifts over cash. Figuring out how much to give can feel awkward and impersonal.'
       */
      messageTitle3: T;

      /**
       * @default 'Keep adding more gifts, so you have something for everyone.'
       */
      messageSubtitle3: T;

      /**
       * @default '33% of guests prefer to give cash over physical gifts, especially if it is for a clear purpose.'
       */
      messageTitle4: T;

      /**
       * @default 'Use gift cards and experiences to craft a story.'
       */
      messageSubtitle4: T;

      /**
       * @default 'Have everything you need? Gift cards are a great compliment to any registry.'
       */
      messageTitle5: T;

      /**
       * @default 'From Airbnb to Starbucks and Delta, we’ve got you.'
       */
      messageSubtitle5: T;

      /**
       * @default 'Did you know that the KitchenAid Stand Mixer and Airbnb gift cards are the most popular gifts in every state?'
       */
      messageTitle6: T;

      /**
       * @default 'Turns out we’re not all that different after all.'
       */
      messageSubtitle6: T;

      /**
       * @default 'Kitchen is the number one registry category, from appliances to bakeware.'
       */
      messageTitle7: T;

      /**
       * @default 'Bed and bath essentials, home tech, and cleaning gadgets are doing their best to catch up, though!'
       */
      messageSubtitle7: T;

      /**
       * @default 'The average honeymoon fund was $5700 last year, but this excludes travel-related gift cards.'
       */
      messageTitle8: T;

      /**
       * @default 'Enhance your travels with travel-related gifts and gift cards.'
       */
      messageSubtitle8: T;

      /**
       * @default 'Nearly 20% of couples are raising money for home down payments.'
       */
      messageTitle9: T;

      /**
       * @default 'Keep adding more gifts—your future home (and guests!) will thank you.'
       */
      messageSubtitle9: T;

      /**
       * @default 'Group gifts are popular with couples but not with guests, who want to give you something unique.'
       */
      messageTitle10: T;

      /**
       * @default 'Keep adding more gifts to make sure there’s something for everyone.'
       */
      messageSubtitle10: T;

      /**
       * @default 'Outdoor gear was the fastest growing registry category last year!'
       */
      messageTitle11: T;

      /**
       * @default 'Add gifts and let your guests help you get out there!'
       */
      messageSubtitle11: T;

      /**
       * @default 'Your registry can help you be more sustainable.'
       */
      messageTitle12: T;

      /**
       * @default 'Help your guests, help the planet with eco-friendly picks like food storage!'
       */
      messageSubtitle12: T;

      /**
       * @default '94% of wedding guests say that registries are helpful.'
       */
      messageTitle13: T;

      /**
       * @default 'Keep adding and avoid returning unwanted gifts.'
       */
      messageSubtitle13: T;

      /**
       * @default '70% of gifts are purchased from a registry.'
       */
      messageTitle14: T;

      /**
       * @default 'Having your registry complete before sending your invitations is a great way to avoid unwanted gifts.'
       */
      messageSubtitle14: T;

      /**
       * @default '78% of guests will purchase a gift for a registry.'
       */
      messageTitle15: T;

      /**
       * @default 'Joy helps make sure you have enough gifts.'
       */
      messageSubtitle15: T;

      /**
       * @default '40% of guests pick a gift based on the price they want to spend.'
       */
      messageTitle16: T;

      /**
       * @default 'Joy's Price Balance tool will make sure you have enough gifts at every price range.'
       */
      messageSubtitle16: T;

      /**
       * @default '38% of guests choose a gift they think is practical for your new life together.'
       */
      messageTitle17: T;

      /**
       * @default 'Guests love to get you things you'll actually use.'
       */
      messageSubtitle17: T;

      /**
       * @default 'Kitchen tools and cookware often get snatched up first.'
       */
      messageTitle18: T;

      /**
       * @default 'Make sure your guests don't go hungry for gifts with dinnerware and tech up next.'
       */
      messageSubtitle18: T;

      /**
       * @default 'Some guests love to give big, so don't be shy!'
       */
      messageTitle19: T;

      /**
       * @default 'In fact, it's mid-priced items that can often go ungifted compared to big and small items.'
       */
      messageSubtitle19: T;

      /**
       * @default 'Guests prefer to give gifts for fun experiences.'
       */
      messageTitle20: T;

      /**
       * @default 'Use experiences, gift cards, and cash funds to tell a story about what you intend to do together.'
       */
      messageSubtitle20: T;

      /**
       * @default 'Guests generally spend between $50 and $200.'
       */
      messageTitle21: T;

      /**
       * @default 'Don't be shy with those big gifts, people love you!'
       */
      messageSubtitle21: T;

      /**
       * @default 'Family members often spend $150-$200, close friends $100-$150.'
       */
      messageTitle22: T;

      /**
       * @default 'Joy's Price Balance tool will make sure you have enough gifts at every price range.'
       */
      messageSubtitle22: T;

      /**
       * @default '57% of boomers would prefer to spend more on a physical gift if they can't attend the wedding.'
       */
      messageTitle23: T;

      /**
       * @default 'That's more than okay, boomers.'
       */
      messageSubtitle23: T;

      /**
       * @default '72% of younger guests prefer to spend more joining the celebration.'
       */
      messageTitle24: T;

      /**
       * @default 'Joy's Price Balance tool will make sure you have enough gifts at every price range.'
       */
      messageSubtitle24: T;

      /**
       * @default 'Alaska loves waffle makers, while the Midwest favors cast iron skillets.'
       */
      messageTitle25: T;

      /**
       * @default 'Joy will help you make sure you have gifts that appeal to everyone, at every price range.'
       */
      messageSubtitle25: T;

      /**
       * @default '80% of registries include a cash fund, while only 33% of guests prefer to give cash.'
       */
      messageTitle26: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle26: T;

      /**
       * @default 'Just over 10% of registries include charity donation options.'
       */
      messageTitle27: T;

      /**
       * @default 'Joy lets you easily add a charity to your registry.'
       */
      messageSubtitle27: T;

      /**
       * @default '91% of registries include physical gifts.'
       */
      messageTitle28: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle28: T;

      /**
       * @default 'Did you know? Registries with cash AND gifts get more gifts from their guests.'
       */
      messageTitle29: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle29: T;

      /**
       * @default 'Over $19 Billion is spent on registries every year in the United States.'
       */
      messageTitle30: T;

      /**
       * @default 'You'll get more if you have gifts AND cash funds.'
       */
      messageSubtitle30: T;

      /**
       * @default '88% of cash funds go to honeymoons or travel.'
       */
      messageTitle31: T;

      /**
       * @default 'Add gifts and have something to come home to.'
       */
      messageSubtitle31: T;

      /**
       * @default '39% of guests are NOT in favor of couples requesting only cash for their registry.'
       */
      messageTitle32: T;

      /**
       * @default 'Keep adding more gifts, your guests will be happier.'
       */
      messageSubtitle32: T;

      /**
       * @default '95% of couples wish asking for cash were more socially acceptable.'
       */
      messageTitle33: T;

      /**
       * @default 'Keep adding more gifts, your guests will be happier.'
       */
      messageSubtitle33: T;

      /**
       * @default '70% of couples say they'd love to receive cash gifts, while only 54% of those same couples say they're comfortable giving cash gifts.'
       */
      messageTitle34: T;

      /**
       * @default 'Keep adding more gifts, your guests will be happier.'
       */
      messageSubtitle34: T;

      /**
       * @default 'Avoid unwanted gifts — your guests are less likely to buy you something random if you have physical gifts on your registry.'
       */
      messageTitle35: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle35: T;

      /**
       * @default 'Be sure to hide large cash fund goals to avoid looking greedy or fantastical.'
       */
      messageTitle36: T;

      /**
       * @default 'It's easy, just check the box 'hide goal amount.''
       */
      messageSubtitle36: T;

      /**
       * @default 'Don't worry about having too many gifts, we'll give you a 20% discount on anything left after your wedding.'
       */
      messageTitle37: T;

      /**
       * @default 'Make sure you add enough gifts for everyone.'
       */
      messageSubtitle37: T;
    };
  };
  quick: {
    /**
     * @default 'Guests might miss key details if you turn this off.'
     */
    vrb8H: T;

    /**
     * @default 'Reminders help guests stay on top of your event (and save you from last-minute texts).'
     */
    f5507: T;

    /**
     * @default 'How Reminders Work:'
     */
    MM8GM: T;

    /**
     * @default 'Sent only to guests who RSVP "Yes" and opt in'
     */
    '1AAOc': T;

    /**
     * @default 'Brings them back to your event website'
     */
    FZMtn: T;

    /**
     * @default 'Helps guests feel prepared and excited'
     */
    ld7zK: T;

    /**
     * @default 'Keep Reminding Guests'
     */
    RAx5z: T;

    /**
     * @default 'Turn Off Reminders'
     */
    dipwv: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default '{{0}} to venue'
     */
    yYdQ3: T;

    /**
     * @default '{{0}} from venue'
     */
    XmNNS: T;

    /**
     * @default 'Your location has been updated.'
     */
    pRNlk: T;

    /**
     * @default 'Your venue has been updated.'
     */
    Zqwxg: T;

    /**
     * @default 'We successfully updated your event location to reflect the new venue.'
     */
    opqHH: T;

    /**
     * @default 'We successfully updated your venue to reflect the new location.'
     */
    YMBMZ: T;

    /**
     * @default 'Update Your Schedule →'
     */
    ts7aS: T;

    /**
     * @default 'Update Where to Stay →'
     */
    eh2OT: T;

    /**
     * @default 'close dialog'
     */
    '4VEdN': T;

    /**
     * @default 'This hotel hasn't opened bookings for the event dates yet.'
     */
    b0SEF: T;

    /**
     * @default 'This hotel is fully booked for the event dates.'
     */
    '71IVT': T;

    /**
     * @default 'View all {{0}} photos'
     */
    nZbqI: T;

    /**
     * @default 'Hotel photo'
     */
    uSpLP: T;

    /**
     * @default 'H'
     */
    KBAAA: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default 'English'
     */
    SIUPT: T;

    /**
     * @default 'English (UK)'
     */
    lTro7: T;

    /**
     * @default 'English (AU)'
     */
    ntlo7: T;

    /**
     * @default 'German'
     */
    UxaGz: T;

    /**
     * @default 'Spanish'
     */
    MltqB: T;

    /**
     * @default 'French'
     */
    gT7cx: T;

    /**
     * @default 'Italian'
     */
    YxTQK: T;

    /**
     * @default 'Japanese'
     */
    d99eC: T;

    /**
     * @default 'Availability for these dates will be released closer to the event date.'
     */
    svNF3: T;

    /**
     * @default 'Most hotels only open bookings 6–12 months in advance. Because your event is farther out, rooms haven’t been released yet — please check back closer to your event date.'
     */
    aZinQ: T;

    /**
     * @default 'Hotel Availability'
     */
    PyvwN: T;

    /**
     * @default 'Proofread'
     */
    iCHDI: T;

    /**
     * @default 'Rewrite'
     */
    MHRQg: T;

    /**
     * @default 'Concise'
     */
    '2b372': T;

    /**
     * @default 'Friendly'
     */
    dcMbs: T;

    /**
     * @default 'Professional'
     */
    '5obWB': T;

    /**
     * @default 'New Draft'
     */
    To0LY: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Compose'
     */
    qK442: T;

    /**
     * @default 'Describe your change'
     */
    qqEcP: T;

    /**
     * @default 'Revert'
     */
    oASPS: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Failed to improve text, please try again.'
     */
    UZS1M: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Invalid Phone Number'
     */
    Gsdpn: T;

    /**
     * @default 'English (United States)'
     */
    WL26h: T;

    /**
     * @default 'English (United Kingdom)'
     */
    vdW8S: T;

    /**
     * @default 'English (Australia)'
     */
    BgEQj: T;

    /**
     * @default 'English (Canada)'
     */
    DISfD: T;

    /**
     * @default 'German (Germany)'
     */
    yob0B: T;

    /**
     * @default 'Spanish (Spain)'
     */
    Ab4hs: T;

    /**
     * @default 'Spanish (United States)'
     */
    Yuimt: T;

    /**
     * @default 'French (France)'
     */
    '6M1E2': T;

    /**
     * @default 'French (Canada)'
     */
    P8qgm: T;

    /**
     * @default 'Italian (Italy)'
     */
    KmAty: T;

    /**
     * @default 'Japanese (Japan)'
     */
    aq5NW: T;
  };
};

export type ShareDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  text: {
    /**
     * @default 'Share with your guests'
     */
    dialogTitle: T;

    /**
     * @default 'Share this event'
     */
    guestDialogTitle: T;

    /**
     * @default 'Joy URL'
     */
    joyUrlText: T;

    /**
     * @default 'Event Password'
     */
    eventPasswordText: T;

    /**
     * @default 'Edit'
     */
    editLinkText: T;

    /**
     * @default 'Copy'
     */
    copy: T;

    /**
     * @default 'Open in New Tab'
     */
    buttonName: T;

    /**
     * @default '✨ {{copyText}} Copied to Clipboard ✨'
     */
    toastText: T;
  };
  quick: {
    /**
     * @default 'Joy URL'
     */
    ZEBKY: T;

    /**
     * @default '✨ Joy URL Copied to Clipboard ✨'
     */
    YmsIU: T;

    /**
     * @default 'Event Password'
     */
    '9SjQp': T;

    /**
     * @default '✨ Event Password Copied to Clipboard ✨'
     */
    '4UZRA': T;

    /**
     * @default '🥳 Your changes have been saved!'
     */
    '9B6xf': T;

    /**
     * @default '😬 Failed to save changes. Please try again.'
     */
    EnYLz: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Share this event.'
     */
    '9xmBd': T;

    /**
     * @default 'Share with your guests.'
     */
    BHnH1: T;

    /**
     * @default 'Copy Event URL'
     */
    ObUzW: T;

    /**
     * @default 'Open in a New Tab'
     */
    JLqa8: T;

    /**
     * @default 'Copy Event Password'
     */
    UoHgZ: T;

    /**
     * @default 'Publish your site before sharing.'
     */
    Aqnsm: T;

    /**
     * @default 'Publish your website'
     */
    rvvgD: T;

    /**
     * @default 'Keep your site unpublished while you're building it. Publish it when you're ready for guests to visit.'
     */
    pEWL3: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;
  };
};

export type SharedRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  shoppingCart: {
    /**
     * @default 'eCard Fee'
     */
    eCardFee: T;

    /**
     * @default 'Cart'
     */
    cartTitle: T;

    /**
     * @default 'Purchase History'
     */
    purchaseHistoryTitle: T;

    /**
     * @default 'Estimated Total: '
     */
    estimatedTotal: T;

    /**
     * @default '{{count}} Gift'
     */
    cartGiftCount: T;

    /**
     * @default '{{count}} Gifts'
     */
    cartGiftCounts: T;

    /**
     * @default 'Quantity: {{quantity}} x {{price}}'
     */
    quantity: T;

    /**
     * @default 'Order #: {{orderNumber}}'
     */
    orderNumber: T;

    /**
     * @default 'Tracking #: {{trackingNumber}}'
     */
    trackingNumber: T;

    /**
     * @default 'Didn't purchase this item?'
     */
    didntPurchase: T;

    /**
     * @default 'Continue to Purchase'
     */
    continuePurchase: T;

    /**
     * @default 'Mark Purchased'
     */
    markPurchased: T;

    /**
     * @default 'Mark as Sent'
     */
    markAsSent: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservation: T;

    /**
     * @default 'Donate Online'
     */
    donationNow: T;

    /**
     * @default 'Send with {{type}}'
     */
    donationSendPlatform: T;

    /**
     * @default 'Send Payment'
     */
    donationSendPayment: T;

    /**
     * @default '🚫 Your gift reservation has been canceled. 🚫'
     */
    removeSuccess: T;

    /**
     * @default 'I did not mean to reserve this gift'
     */
    looking: T;

    /**
     * @default 'The item was not available'
     */
    available: T;

    /**
     * @default 'Changed my mind'
     */
    changed: T;

    /**
     * @default 'Could you tell us what happened?'
     */
    removeTitle: T;

    /**
     * @default 'Cancel Reservation'
     */
    removeItem: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default '🎉 This item has been marked as purchased. 🎉'
     */
    purchaseSuccess: T;

    /**
     * @default '🎁 We've moved this item back to your cart. 🎁'
     */
    reservedSuccess: T;

    /**
     * @default 'Your Cart is Empty'
     */
    cartEmptyTitle: T;

    /**
     * @default 'Send {{type}}'
     */
    donationPlatform: T;

    /**
     * @default 'Donate Online'
     */
    donateOnline: T;

    /**
     * @default '{{count}} View Your Gifts'
     */
    viewGifts: T;

    /**
     * @default 'Start Checkout'
     */
    viewGift: T;

    /**
     * @default '🎁 Item added to cart 🎁'
     */
    itemAddedSuccess: T;

    /**
     * @default 'How does this work?'
     */
    helpText: T;

    /**
     * @default 'Something went wrong, try again later'
     */
    errorMessage: T;

    /**
     * @default 'View Order Details'
     */
    viewOrderDetails: T;

    /**
     * @default 'This gift is no longer available'
     */
    hideWarningTitle: T;

    /**
     * @default 'It has been removed from the registry. Please select another gift to give {{host}} instead.'
     */
    hideWarning: T;

    /**
     * @default 'Gift Message'
     */
    giftMessage: T;

    /**
     * @default 'Edit'
     */
    editGiftNote: T;

    /**
     * @default 'Leave a note for the recipient.'
     */
    fieldNotePlaceholder: T;

    /**
     * @default 'Save'
     */
    saveNote: T;

    /**
     * @default 'Add Gift Message'
     */
    addGiftNote: T;

    /**
     * @default 'Your gift note is set to go!'
     */
    messageUpdateSuccess: T;

    /**
     * @default 'Hmmm we had trouble updating your message.'
     */
    messageUpdateError: T;

    /**
     * @default 'Subtotal'
     */
    subtotal: T;

    /**
     * @default 'Total'
     */
    total: T;

    /**
     * @default 'Delivery'
     */
    delivery: T;

    /**
     * @default 'Sales tax'
     */
    salesTax: T;

    /**
     * @default 'FREE'
     */
    freeDeliveryPriceText: T;

    /**
     * @default 'Personalized eCard'
     */
    eCard: T;

    /**
     * @default 'Amount pending'
     */
    pendingSalesTaxPriceText: T;

    /**
     * @default 'Item'
     */
    item: T;

    /**
     * @default 'Items'
     */
    items: T;

    /**
     * @default 'Ordered'
     */
    ordered: T;

    /**
     * @default 'Paid via {{card}} {{cardLastDigits}}'
     */
    paidNote: T;

    /**
     * @default 'Check Out'
     */
    checkout: T;

    /**
     * @default 'No items are in your cart... yet!'
     */
    cartEmptyMessage: T;

    /**
     * @default 'Cart'
     */
    cart: T;

    /**
     * @default 'Shipping'
     */
    shipping: T;

    /**
     * @default 'Details'
     */
    details: T;

    /**
     * @default 'Payment'
     */
    payment: T;

    /**
     * @default 'Order Summary'
     */
    orderSummary: T;

    /**
     * @default 'Close Order Summary'
     */
    closeOrderSummary: T;

    /**
     * @default 'Have you completed your purchase of {{productName}}?'
     */
    completePurchaseConfirmation: T;

    /**
     * @default 'Let us know'
     */
    completePurchaseConfirmationAction: T;

    /**
     * @default 'Out of Stock'
     */
    outOfStock: T;

    /**
     * @default 'Unavailable'
     */
    isNotPurchasableButton: T;

    metadataAtoms: {
      /**
       * @default 'Gift Message'
       */
      giftMessage: T;

      /**
       * @default 'Order Number'
       */
      orderNumber: T;

      /**
       * @default 'Shipping to'
       */
      shippingTo: T;

      /**
       * @default 'Tracking'
       */
      tracking: T;

      /**
       * @default 'Leave a note for the recipient.'
       */
      leaveNoteForCouple: T;

      /**
       * @default 'Save Gift Message'
       */
      saveGiftNoteButton: T;

      /**
       * @default 'Cancel'
       */
      cancelButton: T;
    };
    addressAtoms: {
      /**
       * @default 'We're missing the recipient's address'
       */
      missingCoupleAddress: T;

      /**
       * @default 'Please contact the recipient or ship to yourself.'
       */
      contactTheCouple: T;
    };

    /**
     * @default 'Edit Gift Message'
     */
    editGiftMessage: T;

    /**
     * @default 'Buy Now'
     */
    buyNow: T;

    /**
     * @default 'Give Now'
     */
    giveNow: T;

    /**
     * @default 'I Already Purchased'
     */
    alreadyPurchased: T;

    /**
     * @default 'I Already Gave'
     */
    alreadyGave: T;

    /**
     * @default 'Did you purchase this?'
     */
    isPurchased: T;

    /**
     * @default 'Purchased from Joy'
     */
    purchasedFromJoy: T;

    /**
     * @default 'Purchased Elsewhere'
     */
    purchasedElsewhere: T;

    /**
     * @default '{{shippingMethod}} to {{addressName}}'
     */
    cartFooterAddressText: T;

    /**
     * @default 'Modify'
     */
    modifyButton: T;

    /**
     * @default 'Check Out'
     */
    checkOutButton: T;

    /**
     * @default 'Continue to Details'
     */
    continueToDetailsButton: T;

    /**
     * @default 'Continue to Payment'
     */
    continueToPaymentButton: T;

    /**
     * @default 'Continue to Message'
     */
    continueToMessageButton: T;

    uneditedMessageWarning: {
      /**
       * @default 'Unedited Message'
       */
      title: T;

      /**
       * @default 'Are you sure you want to continue without editing the gift message?'
       */
      message: T;

      /**
       * @default 'Back'
       */
      back: T;

      /**
       * @default 'Yes, continue'
       */
      continue: T;
    };
    steps: {
      /**
       * @default 'Cart'
       */
      cart: T;

      /**
       * @default 'Shipping'
       */
      shipping: T;

      /**
       * @default 'Details'
       */
      details: T;

      /**
       * @default 'Message'
       */
      message: T;

      /**
       * @default 'Payment'
       */
      payment: T;
    };
    cartStep: {
      /**
       * @default 'History'
       */
      historyTitle: T;

      /**
       * @default 'Cart'
       */
      cartTitle: T;

      /**
       * @default 'Where are we shipping?'
       */
      addressTitle: T;
    };
    shippingAddressStep: {
      /**
       * @default 'Where are we shipping?'
       */
      'whereAreWeShipping?': T;

      addressForm: {
        /**
         * @default 'Name*'
         */
        nameLabel: T;

        /**
         * @default 'Only one recipient name is recommended'
         */
        nameCaption: T;

        /**
         * @default 'Email*'
         */
        emailLabel: T;

        /**
         * @default 'Address Line 1*'
         */
        addressLine1Label: T;

        /**
         * @default 'Only Non-P.O. Box addresses in the United States'
         */
        addressLine1Caption: T;

        /**
         * @default 'Address Line 2'
         */
        addressLine2Label: T;

        /**
         * @default 'City*'
         */
        cityLabel: T;

        /**
         * @default 'State*'
         */
        stateLabel: T;

        /**
         * @default 'Zip/Postal Code*'
         */
        postalCodeLabel: T;

        /**
         * @default '*Required fields'
         */
        requiredFields: T;

        /**
         * @default 'Save Shipping Address'
         */
        saveButton: T;

        /**
         * @default 'Continue to Checkout'
         */
        saveButtonBilling: T;

        /**
         * @default 'Cancel'
         */
        cancelButton: T;

        /**
         * @default 'Edit Shipping Address'
         */
        editButton: T;
      };

      /**
       * @default 'Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Standard Shipping'
       */
      standardShipping: T;

      /**
       * @default 'Shipping'
       */
      shipping: T;

      /**
       * @default 'Shipping Method'
       */
      shippingMethod: T;

      /**
       * @default 'Ship to'
       */
      shipTo: T;

      /**
       * @default '🎁'
       */
      giftEmoji: T;

      /**
       * @default 'Another U.S. Address'
       */
      anotherAddress: T;

      /**
       * @default 'Joy only ships to U.S. addresses'
       */
      onlyUSAddress: T;

      /**
       * @default 'Ship to a different address'
       */
      shipToMe: T;

      /**
       * @default 'We'll tell the recipient about the purchase.'
       */
      weWillTellAboutPurchase: T;
    };
    detailsStep: {
      /**
       * @default 'Shipping Address'
       */
      shippingAddress: T;

      /**
       * @default 'Edit'
       */
      editShippingAddress: T;

      /**
       * @default 'Shipping Method'
       */
      shippingMethod: T;

      /**
       * @default '🎁'
       */
      giftEmoji: T;

      /**
       * @default 'Free Shipping'
       */
      freeShipping: T;

      /**
       * @default 'Standard Shipping'
       */
      standardShipping: T;

      detailsForm: {
        /**
         * @default 'Your Email'
         */
        emailLabel: T;

        /**
         * @default 'Email address'
         */
        emailPlaceholder: T;

        /**
         * @default 'Please enter a valid email'
         */
        validEmailError: T;

        /**
         * @default 'Your Name(s)'
         */
        nameLabel: T;

        /**
         * @default 'Full name or recipient name'
         */
        namePlaceholder: T;

        /**
         * @default 'Gift Message (Optional)'
         */
        messageLabel: T;

        /**
         * @default 'Add an optional note'
         */
        messagePlaceholder: T;
      };
    };
    messageStep: {
      /**
       * @default 'Include a Message (Optional)'
       */
      title: T;

      /**
       * @default 'Personalized eCard'
       */
      wrapTitle: T;

      /**
       * @default 'Wrap your gift note in a beautiful design.'
       */
      wrapDescription: T;

      /**
       * @default 'Basic Gift Note'
       */
      noteTitle: T;

      /**
       * @default 'Gift Note'
       */
      textareaLabel: T;

      /**
       * @default 'Add a note to the couple (optional)'
       */
      textAreaPlaceholder: T;

      /**
       * @default '[Your Name]'
       */
      giverNamePlaceholder: T;
    };
    paymentStep: {
      /**
       * @default 'Some items in your cart have already been purchased. Please check and try again'
       */
      notNeededErrorText: T;

      /**
       * @default 'Oops, that didn't work.'
       */
      checkoutErrorTitle: T;

      /**
       * @default 'We're sorry, but there was an error while processing your order. Please try again later or contact our support team at support@withjoy.com for assistance. Thank you for your patience.'
       */
      checkoutErrorText: T;

      /**
       * @default 'Back'
       */
      checkoutErrorAction: T;

      /**
       * @default 'We're sorry, but there seems to be an issue with your address. Please double-check the address in your account settings to ensure everything is correct. If you need further assistance, feel free to reach out to our support team at support@withjoy.com'
       */
      badAddress: T;

      /**
       * @default 'It looks like your transaction is still being verified. Check back soon and thank you for your patience.'
       */
      registryError: T;

      /**
       * @default 'We're sorry, but the item you're looking for is currently out of stock. We're working to replenish our inventory, so please check back later or explore similar options.'
       */
      inventoryLow: T;
    };
  };
  shoppingCartHelp: {
    /**
     * @default 'How My Cart Works'
     */
    helpTitle: T;

    /**
     * @default 'Reserving Gifts'
     */
    reservingGifts: T;

    /**
     * @default 'When a gift is added to your cart, it is automatically reserved in your name and made unavailable for other gift givers to purchase. Reserved gifts appear at the top of your cart.'
     */
    reservingGiftsDescription: T;

    /**
     * @default 'Purchasing Gifts'
     */
    purchasingGifts: T;

    /**
     * @default 'To check out, just click Continue to Purchase and you can complete your purchase from the retailer that the recipient selected. Please note: Once you're done, be sure to come back here and mark that you have completed your purchase.'
     */
    purchasingGiftsDescription: T;

    /**
     * @default 'What does “mark as purchased” mean?'
     */
    markPurchased: T;

    /**
     * @default 'After you've purchased an item, please mark it as purchased so we can tell the recipient. This is important because it allows the recipient to thank you while also tracking still needed gifts. Purchased gifts appear at the bottom of your cart.'
     */
    markPurchasedDescription: T;

    /**
     * @default 'Where are my past purchases?'
     */
    pastPurchases: T;

    /**
     * @default 'Because Joy doesn't require gift givers to create an account, we use a cookie to track your past purchases. If you need to modify a purchased item that you don't see in your cart, just click on the item you purchased in the registry and enter the email address you used. You'll receive a special link to see your purchase history again.'
     */
    pastPurchasesDescription: T;

    /**
     * @default 'Cancelling Reservations'
     */
    cancelling: T;

    /**
     * @default 'Changed your mind? Please cancel your reservation so other gift givers can purchase the gift.'
     */
    cancellingDescription: T;

    /**
     * @default 'Still need help?'
     */
    stillHelp: T;

    /**
     * @default 'Contact Support'
     */
    contactSupport: T;

    /**
     * @default 'Return Policy'
     */
    returnPolicy: T;
  };
  pageNote: {
    /**
     * @default 'Welcome Note'
     */
    title: T;

    /**
     * @default 'Add a personal message to the top of your registry page for your guests.'
     */
    subtitle: T;

    /**
     * @default 'Note to Guests'
     */
    inputPlaceholder: T;

    /**
     * @default 'of 2000 Max Characters'
     */
    maxCharacters: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Save Note'
     */
    save: T;

    /**
     * @default 'Your presence is enough of a present to us! But for those of you who are stubborn, we've put together a wish-list to help you out, including two charities that are near and dear to our hearts.'
     */
    defaultNote: T;
  };
  giftDialog: {
    /**
     * @default 'Add Gift'
     */
    addGiftTitle: T;

    /**
     * @default 'Edit Gift'
     */
    editGiftTitle: T;

    /**
     * @default 'Link'
     */
    linkField: T;

    /**
     * @default 'Title'
     */
    titleField: T;

    /**
     * @default 'Price'
     */
    priceField: T;

    /**
     * @default 'Quantity'
     */
    qtyField: T;

    /**
     * @default 'Note to Family and Friends'
     */
    noteField: T;

    /**
     * @default 'Optional: Tell folks what this gift means to you, what you'll do with it, or why you want it—have fun with it.'
     */
    noteFieldPlaceholder: T;

    /**
     * @default 'Upload your own photo or search for photos on Unsplash.'
     */
    photoField: T;

    /**
     * @default 'Add Gift'
     */
    addGiftButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Delete'
     */
    deleteButton: T;

    /**
     * @default 'Save Gift'
     */
    saveGiftButton: T;

    /**
     * @default 'Invalid Link'
     */
    linkInvalid: T;

    /**
     * @default 'Missing title'
     */
    missingTitle: T;

    /**
     * @default 'Gift Type'
     */
    giftTypeTitleTooltip: T;

    /**
     * @default 'Each gift type requires different information.'
     */
    giftTypeBodyTooltip: T;

    /**
     * @default 'Quantity must be greater than 0'
     */
    quantityMinError: T;

    /**
     * @default 'Change your registry currency'
     */
    changeCurrencyTitle: T;

    /**
     * @default 'You can change the currency for your entire registry <currencyLink/>.'
     */
    changeCurrencyBody: T;

    /**
     * @default 'here'
     */
    currencyLinkText: T;

    /**
     * @default 'Joy lets you add gifts from anywhere – just paste a link and enter your gift info.'
     */
    helpText: T;

    /**
     * @default 'Read More'
     */
    readMoreText: T;

    /**
     * @default 'The quantity cannot be less than the amount you’ve already received for this gift.'
     */
    receivedQuantityError: T;

    /**
     * @default 'View Product Details'
     */
    pdpLinkText: T;

    /**
     * @default 'MSRP'
     */
    msrpTitle: T;

    /**
     * @default 'We use the MSRP (manufacturer’s suggested retail price). Prices are subject to change based on retailer.'
     */
    msrpDescription: T;

    /**
     * @default 'Allow Group Gifting'
     */
    allowGroupGifting: T;

    /**
     * @default 'Gift givers will be able to contribute any amount.'
     */
    groupGiftingDescription: T;

    /**
     * @default 'Learn more'
     */
    learnMore: T;

    /**
     * @default 'Payment Settings'
     */
    paymentSettings: T;

    /**
     * @default 'Select how you would like guests to contribute.'
     */
    selectPaymentMethod: T;

    /**
     * @default 'By turning on group gifting, we will turn this gift into a cash fund and help you collect money towards this gift using PayPal, Venmo, or CashApp. You can use that money to purchase the gift. The gift will not automatically get bought and delivered when it is funded. Group gifting is only available for gifts over $350. '
     */
    groupGiftingTooltip: T;

    /**
     * @default 'For more details,'
     */
    moreDetails: T;

    /**
     * @default 'Group Gift'
     */
    groupGift: T;

    /**
     * @default 'Mark gift as…'
     */
    markGiftAs: T;

    /**
     * @default 'Our Most Wanted'
     */
    mostWanted: T;

    /**
     * @default 'Let your guests know your must-have gifts!'
     */
    mostWantedDescription: T;

    /**
     * @default 'Sorry we were unable to retrieve that product, please enter your gift manually.'
     */
    autocompleteError: T;

    /**
     * @default 'MSRP Price ({{currency}})'
     */
    msrpLabel: T;

    /**
     * @default 'Select Purchase Options'
     */
    selectPurchaseOption: T;

    /**
     * @default 'Direct friends and family to the store's website'
     */
    selectPurchaseExternalTitle: T;

    /**
     * @default 'We'll share your address with your friends and family so they can buy and ship the gift themselves.'
     */
    selectPurchaseExternalDescription: T;

    /**
     * @default 'Get cash for my gift'
     */
    getCashEquivalentTitle: T;

    /**
     * @default 'Get cash equivalent for this gift; recommended for optimal guest experience.'
     */
    getCashEquivalentDescription: T;

    /**
     * @default '(U.S only)'
     */
    usOnly: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Make this a group gift'
     */
    makeGroupGift: T;

    /**
     * @default 'Gift givers will be able to contribute any amount.'
     */
    makeGroupGiftDescription: T;
  };
  cashFundDialog: {
    wedding: {
      /**
       * @default 'Cash Fund Name'
       */
      nameLabel: T;

      /**
       * @default 'Cash/Check'
       */
      cashOrCheckText: T;

      /**
       * @default 'Please enter a gift name.'
       */
      nameEmptyError: T;

      /**
       * @default 'Next'
       */
      nextButton: T;

      /**
       * @default 'Gift Size'
       */
      amountLabel: T;

      /**
       * @default 'Gift size required.'
       */
      amountRequiredError: T;

      /**
       * @default 'Quantity'
       */
      quantityLabel: T;

      /**
       * @default 'Minimum of 1 required.'
       */
      quantityRequiredError: T;

      /**
       * @default 'Please use whole numbers'
       */
      quantityIntegerError: T;

      /**
       * @default 'Total Goal'
       */
      totalGoalLabel: T;

      /**
       * @default 'Payment Method'
       */
      paymentMethodText: T;

      /**
       * @default 'App Payment'
       */
      appPayment: T;

      /**
       * @default 'Venmo, Cash App, or PayPal'
       */
      appPaymentDescription: T;

      /**
       * @default 'Zero fees. Note that app payments are not automatically tracked by Joy.'
       */
      appPaymentNote: T;

      /**
       * @default 'Credit or Debit Card'
       */
      creditCardOption: T;

      /**
       * @default 'Easiest for your guests.'
       */
      creditCardOptionDescription: T;

      /**
       * @default 'No pesky redirects. Automatic tracking. Transaction fees apply. US only.'
       */
      creditCardOptionNote: T;

      /**
       * @default 'Fast Checkout with'
       */
      fastCheckoutWith: T;

      /**
       * @default 'RECOMMENDED'
       */
      recommended: T;

      /**
       * @default 'Connect Bank Account'
       */
      connectBankAccount: T;

      /**
       * @default '(U.S. only)'
       */
      usOnly: T;

      /**
       * @default 'Continue'
       */
      continueText: T;

      /**
       * @default 'Credit Card'
       */
      enableJoyCreditText: T;

      /**
       * @default 'Guests Contribution Methods'
       */
      paymentSettingsText: T;

      /**
       * @default 'Cash or Check'
       */
      enableCashOrCheckText: T;

      /**
       * @default 'Given in-person or by mail.'
       */
      enableCashOrCheckDescription: T;

      /**
       * @default 'Use your favorite payment app to avoid extra fees.'
       */
      paymentMethodDescription: T;

      /**
       * @default 'Select Provider'
       */
      paymentMethodLabel: T;

      /**
       * @default 'No payment selected'
       */
      selectPaymentEmptyError: T;

      /**
       * @default 'Invalid username'
       */
      invalidUsernameError: T;

      /**
       * @default 'Your username should not be an e-mail address'
       */
      invalidUsernameIsEmailError: T;

      /**
       * @default 'Test payment link'
       */
      testPaymentLinkText: T;

      /**
       * @default 'Test link'
       */
      testLinkText: T;

      /**
       * @default 'Gift of'
       */
      giftOfText: T;

      /**
       * @default 'Gifts of'
       */
      giftsOfText: T;

      /**
       * @default 'Total'
       */
      totalText: T;

      /**
       * @default 'Note to Family and Friends'
       */
      descriptionLabel: T;

      /**
       * @default 'Optional: Tell folks what this gift means to you, what you'll do with it, or why you want it—have fun with it.'
       */
      descriptionPlaceholder: T;

      /**
       * @default 'Add to Registry'
       */
      addtoRegistryButton: T;

      /**
       * @default 'has been added to your registry'
       */
      confirmationHeader: T;

      /**
       * @default 'Sounds like it’ll be rad!'
       */
      confirmationSubHeader: T;

      /**
       * @default 'Discard registry item?'
       */
      cancelHeader: T;

      /**
       * @default 'This gift won’t be added to your registry.'
       */
      cancelText: T;

      /**
       * @default 'Discard Item'
       */
      yesText: T;

      /**
       * @default 'Nevermind'
       */
      noText: T;

      /**
       * @default 'Get Started'
       */
      getStarted: T;

      /**
       * @default 'Max Chars'
       */
      maxCharacters: T;

      /**
       * @default 'Edit'
       */
      editText: T;

      /**
       * @default 'Save'
       */
      saveButton: T;

      /**
       * @default 'Cancel'
       */
      cancelButton: T;

      /**
       * @default 'Delete'
       */
      deleteButton: T;

      cashFundNameSuggestions: [
        /**
         * @default 'Our Newlywed Fund'
         */
        T,
        /**
         * @default '🛣 Roadtrip!'
         */
        T,
        /**
         * @default '🚙 Family Car Fund'
         */
        T,
        /**
         * @default 'Our Favorite Charity'
         */
        T,
        /**
         * @default 'Our Honeymoon Fund'
         */
        T,
        /**
         * @default '🖼 Museum Membership'
         */
        T,
        /**
         * @default 'New Backpacking Gear'
         */
        T,
        /**
         * @default 'Couples Spa Day'
         */
        T,
        /**
         * @default '🍽 Future Kitchen Fund'
         */
        T,
        /**
         * @default '🏕 Camping Adventure'
         */
        T,
      ];

      /**
       * @default 'The quantity cannot be less than the amount you’ve already received for this gift.'
       */
      newQtyError: T;

      /**
       * @default 'The total goal cannot be less than the amount you’ve already received for this gift.'
       */
      newAmountError: T;

      /**
       * @default 'At least one guest has already sent a payment with your previous payment method. Don’t forget!'
       */
      newPaymentMethodWarning: T;

      /**
       * @default 'Charity Fund Name'
       */
      nameLabelCharity: T;

      /**
       * @default 'Donation Method'
       */
      donationMethodText: T;

      /**
       * @default 'Link to Charity'
       */
      donationMethodOptionOneText: T;

      /**
       * @default 'Collect Myself'
       */
      donationMethodOptionTwoText: T;

      /**
       * @default 'Charity Link'
       */
      charityLinkLabel: T;

      /**
       * @default 'ourcharity.org/donate'
       */
      charityLinkPlaceholder: T;

      /**
       * @default 'Invalid link'
       */
      charityLinkInvalidError: T;

      /**
       * @default 'Charity Link Required'
       */
      charityLinkRequiredError: T;

      /**
       * @default 'Use your favorite payment app to collect and donate later.'
       */
      charityPaymentDescription: T;

      charityFundNameSuggestions: [
        /**
         * @default 'Our Favorite Charity'
         */
        T,
        /**
         * @default '🐶 ASPCA'
         */
        T,
        /**
         * @default '✨ Make-A-Wish Foundation'
         */
        T,
        /**
         * @default 'World Wildlife Fund'
         */
        T,
        /**
         * @default 'Leukemia & Lymphoma Society'
         */
        T,
        /**
         * @default 'American Cancer Society'
         */
        T,
        /**
         * @default 'Special Olympics'
         */
        T,
        /**
         * @default 'UNICEF'
         */
        T,
        /**
         * @default 'Habitat for Humanity'
         */
        T,
        /**
         * @default 'United Way Worldwide'
         */
        T,
      ];

      /**
       * @default 'Allow Gifts In'
       */
      goalStepLabel: T;

      /**
       * @default 'Any Amount'
       */
      anyAmountText: T;

      /**
       * @default 'Fixed Amount'
       */
      fixedAmountText: T;

      /**
       * @default 'Hide goal from guests'
       */
      hideGoalLabel: T;

      /**
       * @default 'No goal? Just leave it blank.'
       */
      noGoalCaption: T;

      /**
       * @default 'No Goal'
       */
      noGoalText: T;

      /**
       * @default 'Select at least one payment method'
       */
      errorValidation: T;

      /**
       * @default 'Turn on credit card payments to give your guests more flexibility.'
       */
      proTipTitle: T;

      /**
       * @default 'Some guests are less familiar with payment apps and get confused or even forget to complete payment. We recommend allowing gifts by credit card, just to be safe.'
       */
      proTipDescription: T;
    };
    babyRegistry: {
      /**
       * @default 'Name'
       */
      nameLabel: T;

      /**
       * @default 'Cash/Check'
       */
      cashOrCheckText: T;

      /**
       * @default 'Please enter a gift name.'
       */
      nameEmptyError: T;

      /**
       * @default 'Next'
       */
      nextButton: T;

      /**
       * @default 'Gift Size'
       */
      amountLabel: T;

      /**
       * @default 'Gift size required.'
       */
      amountRequiredError: T;

      /**
       * @default 'Quantity'
       */
      quantityLabel: T;

      /**
       * @default 'Minimum of 1 required.'
       */
      quantityRequiredError: T;

      /**
       * @default 'Please use whole numbers'
       */
      quantityIntegerError: T;

      /**
       * @default 'Total Goal'
       */
      totalGoalLabel: T;

      /**
       * @default 'Payment Method'
       */
      paymentMethodText: T;

      /**
       * @default 'App Payment'
       */
      appPayment: T;

      /**
       * @default 'Venmo, Cash App, or PayPal'
       */
      appPaymentDescription: T;

      /**
       * @default 'Zero fees. Please note that app payments are not automatically tracked by Joy.'
       */
      appPaymentNote: T;

      /**
       * @default 'Credit or Debit Card'
       */
      creditCardOption: T;

      /**
       * @default 'Easiest for your guests.'
       */
      creditCardOptionDescription: T;

      /**
       * @default 'No pesky redirects. Automatic tracking. Transaction fees apply. US only.'
       */
      creditCardOptionNote: T;

      /**
       * @default 'Fast Checkout with'
       */
      fastCheckoutWith: T;

      /**
       * @default 'RECOMMENDED'
       */
      recommended: T;

      /**
       * @default 'Connect Bank Account'
       */
      connectBankAccount: T;

      /**
       * @default '(U.S. only)'
       */
      usOnly: T;

      /**
       * @default 'Continue'
       */
      continueText: T;

      /**
       * @default 'Credit Card'
       */
      enableJoyCreditText: T;

      /**
       * @default 'Guests Contribution Methods'
       */
      paymentSettingsText: T;

      /**
       * @default 'Cash or Check'
       */
      enableCashOrCheckText: T;

      /**
       * @default 'Given in-person or by mail.'
       */
      enableCashOrCheckDescription: T;

      /**
       * @default 'Use your favorite payment app to avoid extra fees.'
       */
      paymentMethodDescription: T;

      /**
       * @default 'Select Provider'
       */
      paymentMethodLabel: T;

      /**
       * @default 'No payment selected'
       */
      selectPaymentEmptyError: T;

      /**
       * @default 'Invalid username'
       */
      invalidUsernameError: T;

      /**
       * @default 'Your username should not be an e-mail address'
       */
      invalidUsernameIsEmailError: T;

      /**
       * @default 'Test payment link'
       */
      testPaymentLinkText: T;

      /**
       * @default 'Test link'
       */
      testLinkText: T;

      /**
       * @default 'Gift of'
       */
      giftOfText: T;

      /**
       * @default 'Gifts of'
       */
      giftsOfText: T;

      /**
       * @default 'Total'
       */
      totalText: T;

      /**
       * @default 'Note to Family and Friends'
       */
      descriptionLabel: T;

      /**
       * @default 'Optional: Tell folks what this gift means to you, what you'll do with it, or why you want it—have fun with it.'
       */
      descriptionPlaceholder: T;

      /**
       * @default 'Add to Registry'
       */
      addtoRegistryButton: T;

      /**
       * @default 'has been added to your registry'
       */
      confirmationHeader: T;

      /**
       * @default 'Sounds like it’ll be rad!'
       */
      confirmationSubHeader: T;

      /**
       * @default 'Discard registry item?'
       */
      cancelHeader: T;

      /**
       * @default 'This gift won’t be added to your registry.'
       */
      cancelText: T;

      /**
       * @default 'Discard Item'
       */
      yesText: T;

      /**
       * @default 'Nevermind'
       */
      noText: T;

      /**
       * @default 'Get Started'
       */
      getStarted: T;

      /**
       * @default 'Max Chars'
       */
      maxCharacters: T;

      /**
       * @default 'Edit'
       */
      editText: T;

      /**
       * @default 'Save'
       */
      saveButton: T;

      /**
       * @default 'Cancel'
       */
      cancelButton: T;

      /**
       * @default 'Delete'
       */
      deleteButton: T;

      cashFundNameSuggestions: [
        /**
         * @default 'Diaper Fund'
         */
        T,
        /**
         * @default 'College Fund'
         */
        T,
        /**
         * @default 'Babymoon'
         */
        T,
        /**
         * @default 'Doula Fund'
         */
        T,
        /**
         * @default 'Meal Fund'
         */
        T,
        /**
         * @default 'Parental Leave Fund'
         */
        T,
        /**
         * @default 'Childcare Fund'
         */
        T,
        /**
         * @default 'Adoption Fund'
         */
        T,
      ];

      /**
       * @default 'The quantity cannot be less than the amount you’ve already received for this gift.'
       */
      newQtyError: T;

      /**
       * @default 'The total goal cannot be less than the amount you’ve already received for this gift.'
       */
      newAmountError: T;

      /**
       * @default 'At least one guest has already sent a payment with your previous payment method. Don’t forget!'
       */
      newPaymentMethodWarning: T;

      /**
       * @default 'Charity Fund Name'
       */
      nameLabelCharity: T;

      /**
       * @default 'Donation Method'
       */
      donationMethodText: T;

      /**
       * @default 'Link to Charity'
       */
      donationMethodOptionOneText: T;

      /**
       * @default 'Collect Myself'
       */
      donationMethodOptionTwoText: T;

      /**
       * @default 'Charity Link'
       */
      charityLinkLabel: T;

      /**
       * @default 'ourcharity.org/donate'
       */
      charityLinkPlaceholder: T;

      /**
       * @default 'Invalid link'
       */
      charityLinkInvalidError: T;

      /**
       * @default 'Charity Link Required'
       */
      charityLinkRequiredError: T;

      /**
       * @default 'Use your favorite payment app to collect and donate later.'
       */
      charityPaymentDescription: T;

      charityFundNameSuggestions: [
        /**
         * @default 'Our Favorite Charity'
         */
        T,
        /**
         * @default '🐶 ASPCA'
         */
        T,
        /**
         * @default '✨ Make-A-Wish Foundation'
         */
        T,
        /**
         * @default 'World Wildlife Fund'
         */
        T,
        /**
         * @default 'Leukemia & Lymphoma Society'
         */
        T,
        /**
         * @default 'American Cancer Society'
         */
        T,
        /**
         * @default 'Special Olympics'
         */
        T,
        /**
         * @default 'UNICEF'
         */
        T,
        /**
         * @default 'Habitat for Humanity'
         */
        T,
        /**
         * @default 'United Way Worldwide'
         */
        T,
      ];

      /**
       * @default 'Allow Gifts In'
       */
      goalStepLabel: T;

      /**
       * @default 'Any Amount'
       */
      anyAmountText: T;

      /**
       * @default 'Fixed Amount'
       */
      fixedAmountText: T;

      /**
       * @default 'Hide goal from gift givers'
       */
      hideGoalLabel: T;

      /**
       * @default 'No goal? Just leave it blank.'
       */
      noGoalCaption: T;

      /**
       * @default 'No Goal'
       */
      noGoalText: T;

      /**
       * @default 'Select at least one payment method'
       */
      errorValidation: T;

      /**
       * @default 'Turn on credit card payments to give your guests more flexibility.'
       */
      proTipTitle: T;

      /**
       * @default 'Some guests are less familiar with payment apps and get confused or even forget to complete payment. We recommend allowing gifts by credit card, just to be safe.'
       */
      proTipDescription: T;
    };
  };
  creditCardSetUpDialog: {
    /**
     * @default 'Connect Your Bank Account'
     */
    joyWalletTitle: T;

    /**
     * @default 'Allow your guests to give you cash with their credit or debit cards by connecting your bank account.'
     */
    joyWalletDescription: T;

    /**
     * @default 'Congrats! You can now enable cash-gift options for external items and cash funds for guests wanting to use a credit card. Purchases and contributions through Stripe will be available as soon as tomorrow. Have questions? Feel free to contact us at support@withjoy.com'
     */
    successJoyWalletDescription: T;

    /**
     * @default 'Your guests can now send you cash with a credit card! See your contributions and transfer cash to your bank or debit card using Stripe.'
     */
    description: T;

    /**
     * @default 'Set Up Credit Card for Cash Funds'
     */
    title: T;

    /**
     * @default 'Here’s what you need to get started:'
     */
    subtitle: T;

    /**
     * @default 'Email & phone number'
     */
    recipient: T;

    /**
     * @default 'Need Assistance?'
     */
    needAssistance: T;

    /**
     * @default 'Contact Us'
     */
    contactUs: T;

    /**
     * @default 'U.S. home address'
     */
    address: T;

    /**
     * @default 'First and last name'
     */
    legalName: T;

    /**
     * @default 'U.S. bank account or debit card'
     */
    bank: T;

    /**
     * @default 'Let’s Get Started'
     */
    letsGo: T;

    /**
     * @default 'Accept All Major Credit Payments'
     */
    footerText: T;

    /**
     * @default 'Approval is taking longer than expected'
     */
    takingLong: T;

    /**
     * @default 'Stripe needs more information'
     */
    stripeIssue: T;

    /**
     * @default 'Check Stripe Status'
     */
    checkStripeStatus: T;

    /**
     * @default 'Resolve Stripe Issue'
     */
    resolveStripeStatus: T;

    /**
     * @default 'Your account is being reviewed'
     */
    inReview: T;

    /**
     * @default 'This will only take a minute'
     */
    inReviewDuration: T;

    /**
     * @default 'You are an editor but not the owner of this event. Only the account owner can connect a bank account.'
     */
    onlyForOwners: T;

    /**
     * @default 'You need a valid U.S address. '
     */
    onlyForUS: T;

    /**
     * @default 'Add Address'
     */
    addAddress: T;

    /**
     * @default 'Continue'
     */
    continueText: T;

    /**
     * @default 'Stripe Connect Policy'
     */
    stripeConnect: T;

    /**
     * @default 'Transaction fees apply and are subject to change.'
     */
    stripeDisclaimer: T;

    /**
     * @default 'Your Stripe Account has been Approved!'
     */
    stripeApprovedTitle: T;

    /**
     * @default 'Congrats! You can now add credit cards as a payment option for your new and existing cash funds. Guests can start contributing as soon as tomorrow. You still have the option of adding alternative contribution methods like cash, check, or mobile app payment.'
     */
    stripeApprovedDescription: T;

    /**
     * @default 'Next'
     */
    next: T;

    /**
     * @default 'I’ll Do This Later'
     */
    doLater: T;

    /**
     * @default 'Accept Cash Fund Credit Card Contributions'
     */
    widgetTitle: T;

    /**
     * @default 'Your guests can now send you cash with a credit card!'
     */
    widgetDescription: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Credit Card Contributions'
     */
    creditCardContributions: T;

    /**
     * @default 'Current Balance'
     */
    currentBalance: T;

    /**
     * @default 'Transfer Balance'
     */
    transferBalance: T;

    /**
     * @default 'Your available balance is updated as contributions are processed and ready to transfer. This can sometimes take 1-3 business days, but is usually instant.'
     */
    balanceTooltip: T;

    /**
     * @default 'Account'
     */
    account: T;

    /**
     * @default 'Connect Bank Account'
     */
    connectBankAccount: T;

    /**
     * @default 'Learn more'
     */
    learnMore: T;
  };
  creditCardWidgetV2: {
    /**
     * @default 'Manage'
     */
    manage: T;

    /**
     * @default 'Transfer to Bank'
     */
    transferToBank: T;

    /**
     * @default 'Joy Wallet'
     */
    joyWallet: T;

    /**
     * @default 'Cash for Gifts'
     */
    cashForGiftsText: T;

    /**
     * @default 'Credit Card Cash Funds'
     */
    cashFundsText: T;

    /**
     * @default 'Total Balance'
     */
    totalBalance: T;

    /**
     * @default 'Why is this different from my available balance?'
     */
    whyText: T;

    /**
     * @default 'You can now receive cash via:'
     */
    footerText: T;

    /**
     * @default 'credit card platforms allowed'
     */
    footerImageAlt: T;

    /**
     * @default 'Available balance sometimes takes 1-3 business days to reflect recent transactions, but is usually instant.'
     */
    balanceTooltip: T;

    /**
     * @default 'Available Balance'
     */
    availableBalance: T;

    /**
     * @default 'Connect Your Bank Account'
     */
    creditCardSetupTitle: T;

    /**
     * @default 'Allow guests to give with credit and debit cards.'
     */
    creditCardSetupDescription: T;

    /**
     * @default 'Approval pending...'
     */
    approvalPending: T;

    /**
     * @default 'More information needed.'
     */
    needMoreInfo: T;

    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default 'Need Assistance?'
     */
    needAssistance: T;

    /**
     * @default 'Contact Us'
     */
    contactUs: T;

    /**
     * @default 'You’ll be able to accept payments from:'
     */
    alternativeFooterText: T;

    /**
     * @default 'Cash Received'
     */
    cashReceived: T;

    /**
     * @default 'Pending Transactions'
     */
    pendingTransactions: T;

    /**
     * @default 'These funds will be available soon'
     */
    pendingTransactionsHint: T;

    /**
     * @default 'Pending Withdrawals'
     */
    pendingWithdrawals: T;

    /**
     * @default 'These funds will be transferred to your bank soon'
     */
    pendingWithdrawalsHint: T;

    /**
     * @default 'Previously Withdrawn'
     */
    previouslyWithdrawn: T;

    /**
     * @default 'Total funds transferred to your bank'
     */
    previouslyWithdrawnHint: T;

    /**
     * @default 'Lifetime Received'
     */
    lifetimeReceived: T;

    /**
     * @default 'Total funds you've received with Joy'
     */
    lifetimeReceivedHint: T;

    /**
     * @default 'Transfer processing...'
     */
    transferProcessing: T;

    /**
     * @default 'Done'
     */
    transferDone: T;

    /**
     * @default 'We couldn't complete one of your transfers. Please contact support.'
     */
    transferError: T;

    /**
     * @default 'Amounts shown include cash collected from registry funds and private funds via Stripe.'
     */
    description: T;
  };
  cashFundDisclaimerDialog: {
    /**
     * @default 'Regarding {paymentMethod} Payments'
     */
    title: T;

    warning: {
      /**
       * @default 'Joy does not perform {paymentMethod} transactions for your guests. Guests will have to leave your registry and go to the payment app to send you money.'
       */
      main: T;

      /**
       * @default 'Venmo, Cash App, and PayPal often do not take responsibility in mistaken transactions, meaning you may be left at the mercy of the unintended recipient to return the money. This can create a messy and possibly unresolvable situation where you have to ask your guests to contact the unintended recipient to recover the funds.'
       */
      additional: T;
    };
    paymentAccount: {
      /**
       * @default 'Verify your payment account:'
       */
      label: T;

      /**
       * @default 'Please verify that your handle is correct by sending yourself money after clicking "Send Test Payment."'
       */
      test_warning: T;

      /**
       * @default 'Learn more about testing your account.'
       */
      learn_more: T;

      /**
       * @default 'Send Test Payment'
       */
      send_test_payment: T;
    };
    accordion: {
      howItWorks: {
        /**
         * @default 'How will payment apps work for my guests?'
         */
        title: T;

        /**
     * @default '1. Guests will enter the amount they intend to give you, and provide their name and email. This will "reserve" their gift.

2. Guests will then be redirected to sign in to the third-party app or website from your registry. If guests have an account and they can sign in, they then need to send you money.

3. If guests remember to come back to your registry, they'll be asked to confirm they sent payment. If they don't, Joy will follow up via email (you can also send reminders with Joy).'
*/
        content: T;
      };
      whatToKnow: {
        /**
         * @default 'What you need to know before proceeding'
         */
        title: T;

        /**
     * @default '1. Payment apps can be confusing if they're unfamiliar with the app.

2. If they don't have an account, they can get stuck. If they do have an account, they may have to remember their account details to sign in.

3. Some guests think they sent money when they didn't, while other guests simply forget to complete payment.'
*/
        content: T;
      };
      wrongAccount: {
        /**
         * @default 'What happens if I enter the wrong account?'
         */
        title: T;

        /**
     * @default '1. If the account handle is incorrect, funds may be sent to the wrong person, and Joy cannot intervene in these transactions.

2. Venmo, Cash App, and PayPal do not take responsibility in mistaken transactions, meaning you may be left at the mercy of the unintended recipient to return the money. This can create a messy and possibly unresolvable situation where you have to ask your guests to contact the unintended recipient to recover the funds.

'
*/
        content: T;

        /**
         * @default 'Learn more about testing your account.'
         */
        learnMoreLink: T;
      };
    };
    checkboxes: {
      /**
       * @default 'I have tested and verified the link above is correct. I understand that Joy cannot assist if funds are sent to the wrong person.'
       */
      agreement: T;

      /**
       * @default 'I understand that Joy cannot track payments received by third party apps. Joy can only record that a guest says that they've paid. Third party apps are the only source of truth regarding such transactions.'
       */
      tracking: T;
    };
    buttons: {
      /**
       * @default 'Save Payment Method'
       */
      accept: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;
    };
  };
  payoutDialog: {
    /**
     * @default 'Transfer to Bank'
     */
    title: T;

    /**
     * @default 'You are about to transfer your cash balance to the account or card ending in {{accountNumber}}. This transfer cannot be reversed.'
     */
    description: T;

    /**
     * @default 'Balance'
     */
    balance: T;

    /**
     * @default 'Transfer Fee'
     */
    transferFee: T;

    /**
     * @default 'Total Transfer'
     */
    totalTransfer: T;

    /**
     * @default 'Stripe charges a small fee of $1.70 per transfer for processing. To avoid multiple fees, wait until your cash fund is complete, then make a single transfer!'
     */
    feeTooltip: T;

    /**
     * @default 'Yes, Transfer Balance'
     */
    confirmTransfer: T;

    /**
     * @default 'Nevermind'
     */
    nevermind: T;

    /**
     * @default 'Your Transfer is Being Proccessed'
     */
    successTitle: T;

    /**
     * @default 'Woo-hoo! We’re working on moving your cash fund balance to your bank account now. Please note that transferred funds typically arrive within 5 to 7 business days.'
     */
    successDescription: T;

    /**
     * @default 'Close'
     */
    close: T;

    /**
     * @default 'Oops! Something Went Wrong.'
     */
    errorTitle: T;

    /**
     * @default 'We’re unable to complete this transfer. Please ensure the destination account is valid and try again. If this error persists, contact Joy Customer Support.'
     */
    errorDescription: T;

    /**
     * @default 'Sorry! A minimum balance of $2 is needed to process a balance transfer.'
     */
    balanceError: T;
  };
  addressReminder: {
    /**
     * @default 'Now let’s add your shipping address'
     */
    reminderTitleLow: T;

    /**
     * @default 'You’ve picked out some great gifts!'
     */
    reminderTitleModerateLine1: T;

    /**
     * @default 'But where should we send them?'
     */
    reminderTitleModerateLine2: T;

    /**
     * @default 'Where should we send this gift?'
     */
    reminderTitleSevere: T;

    /**
     * @default 'Avoid missing packages and awkward texts!'
     */
    reminderSubtitleLowModerateLine1: T;

    /**
     * @default 'We’ll make sure gift givers know where to send your gifts.'
     */
    reminderSubtitleLowModerateLine2: T;

    /**
     * @default 'Joy requires a shipping address for events happening'
     */
    reminderSubtitleSevereLine1: T;

    /**
     * @default 'within 60 days so your gifts can happily reach you!'
     */
    reminderSubtitleSevereLine2: T;

    /**
     * @default 'Add Shipping Address'
     */
    primaryButton: T;
  };
  publicShop: {
    /**
     * @default 'The All-in-One Registry'
     */
    heroContentHeader: T;

    /**
     * @default 'Shop Here, There, Everywhere.'
     */
    heroContentTitle: T;

    /**
     * @default 'Shop on Joy'
     */
    shopTitle: T;

    /**
     * @default 'Find the perfect gift.'
     */
    shopSubtitle: T;

    /**
     * @default 'Connect Any Registry'
     */
    connectTitle: T;

    /**
     * @default 'Everything in one place.'
     */
    connectSubtitle: T;

    /**
     * @default 'Zero-Fee Cash Funds'
     */
    noFeeTitle: T;

    /**
     * @default 'Yes, really. No fees.'
     */
    noFeeSubtitle: T;

    /**
     * @default 'Shop the Web'
     */
    shopWebTitle: T;

    /**
     * @default 'Add from anywhere.'
     */
    shopWebSubtitle: T;
  };
  departmentNavBar: {
    /**
     * @default 'View {{departmentName}}'
     */
    navItemTooltip: T;
  };
  contact: {
    /**
     * @default '← Please keep this link in the email to make it easier for us to answer your questions.'
     */
    contactSupportMessage: T;
  };
  catalogSearchInput: {
    /**
     * @default 'Search'
     */
    shortPlaceholder: T;

    /**
     * @default 'Search brands, products, and more'
     */
    catalogRoutePlaceholder: T;

    /**
     * @default 'Find new gifts for your Registry'
     */
    manageRoutePlaceholder: T;

    /**
     * @default 'Back to Dashboard'
     */
    homeIconTooltip: T;
  };
  registryNavigationMenu: {
    /**
     * @default 'Event Dashboard'
     */
    eventDashboard: T;

    /**
     * @default 'Dashboard'
     */
    dashboard: T;

    /**
     * @default 'Overview'
     */
    overview: T;

    /**
     * @default 'Shop'
     */
    shop: T;

    /**
     * @default 'Manage'
     */
    manage: T;

    /**
     * @default 'Track'
     */
    track: T;

    /**
     * @default 'Registry'
     */
    registry: T;

    /**
     * @default 'New'
     */
    newBadge: T;

    /**
     * @default 'Registry Settings'
     */
    registrySettings: T;
  };
  alreadyReservedWarning: {
    /**
     * @default 'It looks like you’ve already reserved this gift with this email address.'
     */
    title: T;

    /**
     * @default 'We’ve sent you an email with a link to your reservation so you can complete your purchase or cancel your reservation.'
     */
    text1: T;

    /**
     * @default 'Check your inbox at {{email}}'
     */
    text2: T;
  };
  externalOrderTracking: {
    /**
     * @default 'Order & Tracking Information'
     */
    externalTrackingInfoDialogTitle: T;

    /**
     * @default 'Don’t have tracking details? We can send a request to your guest for you. '
     */
    externalTrackingInfoDialogDetails: T;

    /**
     * @default 'This information was provided by {{guestName}}.'
     */
    informationProvided: T;

    /**
     * @default 'Request Order and Tracking Info'
     */
    requestOrderTracking: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Order Number (Required)'
     */
    orderID: T;

    /**
     * @default 'Tracking Number'
     */
    trackingNumber: T;

    /**
     * @default 'Need tracking info for your gift? We’ve  got you.'
     */
    requestTrackingInfoDialogTitle: T;

    /**
     * @default 'We’ll send a one-time email to your guest to request the Order ID, Tracking Number and Shipping Carrier for this gift. Once provided, the information will appear in your gift tracker.'
     */
    requestTrackingInfoDialogSubtitle: T;

    /**
     * @default 'Send Request'
     */
    sendRequest: T;

    /**
     * @default 'Sample Email:'
     */
    sampleEmail: T;

    /**
     * @default 'Please enter an order number'
     */
    orderNumberRequiredError: T;

    /**
     * @default 'Please enter an tracking number'
     */
    trackingRequiredError: T;

    /**
     * @default 'Please enter shipping carrier number'
     */
    shippingRequiredError: T;

    /**
     * @default 'Quantity : {{qty}}'
     */
    quantity: T;

    /**
     * @default 'Test Link'
     */
    testLink: T;

    /**
     * @default '✨ Tracking info has been added to {{orderTitle}} ✨ '
     */
    successMessage: T;
  };
  subCatHighlights: {
    /**
     * @default 'Learn More'
     */
    itemButtonLabel: T;
  };
  registryPromo: {
    /**
     * @default 'With guests on their way, now’s the time to fill out your registry!'
     */
    reminderTitle: T;

    /**
     * @default 'Continue Adding Gifts'
     */
    addGiftCtaLabel: T;

    /**
     * @default 'Do you have enough gifts in your registry?'
     */
    giftCountReminderTitle: T;

    /**
     * @default 'With guests on their way, now is the time to make sure your registry is ready.'
     */
    giftCountReminderSubTitle: T;

    /**
     * @default 'Maybe Later'
     */
    maybeLaterCta: T;
  };
  quick: {
    /**
     * @default 'Event Settings'
     */
    lXboj: T;

    /**
     * @default 'Account Info'
     */
    bZS93: T;

    /**
     * @default 'Manage Events'
     */
    CGUli: T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'Sign Out'
     */
    bXv8o: T;
  };
};

export type SlapAdsRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Your registry starts here.'
   */
  messageLine1: T;

  /**
   * @default 'Add your first items to unlock gifting.'
   */
  messageLine2: T;

  /**
   * @default 'Explore Registry'
   */
  btn: T;
};

export type SsrServerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  metatags: {
    /**
     * @default 'The only wedding app and website you need'
     */
    title: T;
  };
};

export type StationeryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Search...'
   */
  searchPlaceholder: T;

  /**
   * @default 'No search results.'
   */
  noSearchResults: T;

  /**
   * @default 'Clear'
   */
  clear: T;

  cardCustomizer: {
    editorToolbar: {
      /**
       * @default 'Font Size'
       */
      fontSize: T;

      /**
       * @default 'Line Height'
       */
      lineHeight: T;

      /**
       * @default 'Letter Spacing'
       */
      letterSpacing: T;
    };
    uploadDesignFloatingMessage: {
      /**
       * @default 'Click or tap here to upload your design.'
       */
      title: T;

      /**
       * @default 'Learn More'
       */
      cta: T;
    };
    qrCodeLinkModal: {
      /**
       * @default 'QR Code Link'
       */
      websiteLinkTitle: T;

      /**
       * @default 'Edit Link'
       */
      websiteLinkTitleDigital: T;

      /**
       * @default 'Edit Your Website Details'
       */
      handleAndPasswordTitle: T;

      websiteLink: {
        /**
         * @default 'Add QR code to your card, so guests can easily access your wedding website and see all the details.'
         */
        description: T;

        /**
         * @default 'Add a link to your card, so guests can easily access your wedding website and see all the details.'
         */
        linkDescription: T;

        /**
         * @default 'Your Website'
         */
        yourWebsiteTitle: T;

        /**
         * @default 'Edit'
         */
        edit: T;

        /**
         * @default 'Edit URL and Password'
         */
        editURLAndPassword: T;

        /**
         * @default 'Uh oh! Your website link seems a bit long, you can edit it to make it shorter and more personal to make it easier for your guests.'
         */
        longHandleWarning: T;

        /**
         * @default 'Your Custom Link'
         */
        customLinkTitle: T;

        /**
         * @default 'Contact Collector'
         */
        contactCollectorTitle: T;

        /**
         * @default 'Please ensure you're using the correct format, starting with http:// or https://'
         */
        invalidCustomLinkError: T;
      };
      editLinkAndPassword: {
        /**
         * @default 'URL'
         */
        url: T;

        /**
         * @default 'This URL is available'
         */
        urlAvailable: T;

        /**
         * @default ' This URL is not available'
         */
        urlNotAvailable: T;

        /**
         * @default '/60 Max Chars'
         */
        urlCharsCounter: T;

        /**
         * @default 'URL cannot be blank.'
         */
        urlRequiredError: T;

        /**
         * @default 'URL must be less than 60 characters long.'
         */
        urlLengthError: T;

        /**
         * @default 'Only letters, numbers and '-' are allowed in your URL.'
         */
        urlCharactersError: T;

        /**
         * @default 'Your old Joy URL will no longer work. If you have a custom domain, you’ll need to update your forwarding URL with your domain provider.'
         */
        urlWarning: T;

        /**
         * @default 'Password'
         */
        password: T;

        /**
         * @default 'Password cannot be blank.'
         */
        passwordRequiredError: T;

        /**
         * @default 'Your password can only contain letters and numbers.'
         */
        passwordCharactersError: T;

        /**
         * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
         */
        passwordWarning: T;

        /**
         * @default 'Cancel'
         */
        cancel: T;

        /**
         * @default 'Update Details'
         */
        updateDetails: T;

        /**
         * @default 'Your Event Website has been updated.'
         */
        successToast: T;

        /**
         * @default 'An error occurred while updating your Event Website. Please try again.'
         */
        errorToast: T;
      };
    };
    exitCustomizationWidget: {
      /**
       * @default 'Exit Customization'
       */
      iconTitle: T;

      /**
       * @default 'We saved your draft!'
       */
      title: T;

      /**
       * @default 'You can always find it in the Drafts tab in the main navigation on the top and keep customizing your card.'
       */
      description: T;

      /**
       * @default 'View Drafts'
       */
      viewDraftsCta: T;
    };
    exitEditingWidget: {
      /**
       * @default 'Are you sure you want to exit editing mode?'
       */
      title: T;

      /**
       * @default 'No changes will be made to the card in your original order.'
       */
      description: T;

      /**
       * @default 'Go Back to Editing'
       */
      backToEditingCta: T;

      /**
       * @default 'Keep Original Card'
       */
      keepOriginalCta: T;
    };
    topNavProgressBar: {
      desktop: {
        steps: {
          /**
           * @default 'Front'
           */
          cardFront: T;

          /**
           * @default 'Back'
           */
          cardBack: T;

          /**
           * @default 'Envelope'
           */
          envelope: T;

          /**
           * @default 'Recipients'
           */
          recipients: T;

          /**
           * @default 'Review'
           */
          review: T;

          /**
           * @default 'Front'
           */
          digitalCardFront: T;

          /**
           * @default 'Back'
           */
          digitalCardBack: T;

          /**
           * @default 'Review'
           */
          digitalCardReview: T;
        };
      };

      /**
       * @default 'Step'
       */
      step: T;
    };
    promoCodeBlock: {
      /**
       * @default 'Promo Code'
       */
      title: T;

      /**
       * @default 'Apply'
       */
      applyCta: T;

      /**
       * @default 'Remove'
       */
      removeCta: T;

      /**
       * @default 'Enter code'
       */
      inputPlaceholder: T;

      /**
       * @default 'Promo code {{code}} applied'
       */
      promoCodeApplied: T;

      /**
       * @default 'This is not a valid promo code.'
       */
      invalidPromoCode: T;
    };
    courierErrorMessage: {
      /**
       * @default 'There seems to be an issue with your order delivery. Please visit'
       */
      text1: T;

      /**
       * @default 'the courier page'
       */
      link: T;

      /**
       * @default 'to check the details.'
       */
      text2: T;
    };
    priceSummary: {
      /**
       * @default 'Order Summary'
       */
      orderSummaryLabel: T;

      discountSection: {
        /**
         * @default 'Promo code {{code}} applied <br />(excludes shipping)'
         */
        label: T;

        /**
         * @default '-{{discount}}%'
         */
        value: T;
      };

      /**
       * @default 'Total'
       */
      totalLabel: T;

      /**
       * @default 'Sales Tax'
       */
      taxLabel: T;
    };
    addressDialog: {
      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'Save'
       */
      save: T;

      /**
       * @default 'Edit Address'
       */
      editAddress: T;

      /**
       * @default 'Confirm Address'
       */
      confirmAddress: T;

      formValidation: {
        /**
         * @default 'Required'
         */
        required: T;

        /**
         * @default 'We currently support only contiguous US.'
         */
        contiguousUS: T;

        /**
         * @default 'Invalid Email'
         */
        invalidEmail: T;

        /**
         * @default 'This is not a valid ZIP Code.'
         */
        invalidZipCode: T;
      };
      addressSugestion: {
        /**
         * @default 'It is possible the following modified address will ensure a more successful delivery.'
         */
        title: T;

        /**
         * @default 'Please select the address you’d like to use.'
         */
        subTitle: T;

        /**
         * @default 'We couldn’t validate your address, please make sure it’s correct before proceeding to the next step.'
         */
        errorTitle: T;

        /**
         * @default 'Original Address'
         */
        original: T;

        /**
         * @default 'Suggested Address'
         */
        suggested: T;

        /**
         * @default 'Address Provided'
         */
        provided: T;
      };
    };
    checkoutErrorDialog: {
      generic: {
        /**
         * @default 'We’re having trouble placing your order.'
         */
        title: T;

        /**
         * @default 'Open Drafts'
         */
        buttonLabel: T;
      };
      address: {
        /**
         * @default 'Please check your address.'
         */
        title: T;

        /**
         * @default 'Your shipping address could not be validated. Check that the zip/postal code is correct.'
         */
        error: T;

        /**
         * @default 'Edit Shipping Address'
         */
        buttonLabel: T;
      };
      billingAddress: {
        /**
         * @default 'Please check your address.'
         */
        title: T;

        /**
         * @default 'Your billing address could not be validated. Check that the zip/postal code is correct.'
         */
        error: T;

        /**
         * @default 'Edit Billing Address'
         */
        buttonLabel: T;
      };
    };
    contactDialog: {
      /**
       * @default 'Add New Recipient'
       */
      newRecipientTitle: T;

      /**
       * @default 'Edit Recipient’s Details'
       */
      updateRecipientTitle: T;

      /**
       * @default 'There was an error saving the contact'
       */
      mutationError: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'Save'
       */
      save: T;

      /**
       * @default 'Edit Address'
       */
      editAddress: T;

      /**
       * @default 'Confirm Address'
       */
      confirmAddress: T;

      formValidation: {
        /**
         * @default 'Required'
         */
        required: T;

        /**
         * @default 'Invalid Email'
         */
        invalidEmail: T;
      };
      formFields: {
        /**
         * @default 'First Name'
         */
        firstName: T;

        /**
         * @default 'Last Name'
         */
        lastName: T;

        /**
         * @default 'Email'
         */
        email: T;

        /**
         * @default 'Phone Number'
         */
        phoneNumber: T;

        /**
         * @default 'Address Line'
         */
        address: T;

        /**
         * @default 'Address Line 1'
         */
        address1: T;

        /**
         * @default 'Address Line 2'
         */
        address2: T;

        /**
         * @default 'City'
         */
        city: T;

        /**
         * @default 'State'
         */
        state: T;

        /**
         * @default 'State/Province/Territory'
         */
        stateOrProvince: T;

        /**
         * @default 'Country/Region'
         */
        country: T;

        /**
         * @default 'Zip/Postal Code'
         */
        postalCode: T;

        /**
         * @default 'Mailing Address'
         */
        mailingAddress: T;

        /**
         * @default 'Guest Details'
         */
        guestDetails: T;

        /**
         * @default 'Invalid Phone Number'
         */
        invalidPhone: T;

        /**
         * @default 'Address'
         */
        address1Placeholder: T;

        /**
         * @default 'Apartment, Suite, etc. (optional)'
         */
        address2Placeholder: T;

        /**
         * @default 'Envelope Name'
         */
        envelopeName: T;

        /**
         * @default 'The Smith Family, Mr. and Mrs. Smith, etc'
         */
        envelopeNamePlaceholder: T;
      };
      addressSugestion: {
        /**
         * @default 'It is possible the following modified address will ensure a more successful delivery.'
         */
        title: T;

        /**
         * @default 'Please select the address you’d like to use.'
         */
        subTitle: T;

        /**
         * @default 'We couldn’t validate your address, please make sure it’s correct before proceeding to the next step.'
         */
        errorTitle: T;

        /**
         * @default 'Original Address'
         */
        original: T;

        /**
         * @default 'Suggested Address'
         */
        suggested: T;

        /**
         * @default 'Address Provided'
         */
        provided: T;
      };
    };
    quantityDialog: {
      /**
       * @default 'Oops, you chose more recipients than cards with envelopes.'
       */
      titleGoToReview: T;

      /**
       * @default 'Oops, you might need more cards with envelopes.'
       */
      titleChangeQuantity: T;

      /**
       * @default 'You selected {{recipientsLength}} recipients, so if you change the quantity of the cards with envelopes to {{quantity}}, that won’t match.'
       */
      subtitle: T;

      /**
       * @default 'You selected {{recipientsLength}} recipients, we currently offer suites up to {{maxQuantity}} cards with envelopes. Please get in touch with our support team, so they can make it happen.'
       */
      cardsNeededInvalid: T;

      /**
       * @default 'cards with envelopes'
       */
      cardsWithEnvelopes: T;

      /**
       * @default 'recipients selected'
       */
      recipientsSelected: T;

      /**
       * @default 'cards still needed'
       */
      cardsStillNeeded: T;

      /**
       * @default 'Get in Touch'
       */
      getInTouch: T;

      /**
       * @default 'Increase Card Quantity to {{getNewQuantity}}'
       */
      increaseQuantity: T;

      /**
       * @default 'Adjust Recipient Selection'
       */
      adjustSelection: T;
    };
    noGuestsDialog: {
      /**
       * @default 'Oops, you didn’t choose any recipients.'
       */
      title: T;

      /**
       * @default 'You requested Recipient Addressing, but no recipients were selected. Please choose recipients to print their addresses on the envelopes.'
       */
      subtitle: T;

      /**
       * @default 'If you don’t select recipients, we will proceed with printing return address, and leave the recipient address field blank, so you can address them yourself.'
       */
      warningReturnAddress: T;

      /**
       * @default 'If you don’t select recipients, we will send you blank envelopes with your cards, so you can address them yourself.'
       */
      warningNoReturnAddress: T;

      /**
       * @default 'Adjust Recipient Selection'
       */
      adjustSelection: T;

      /**
       * @default 'Proceed to Review'
       */
      proceedToReview: T;
    };
    weddingWebsiteLink: {
      /**
       * @default 'Wedding Website Link'
       */
      title: T;

      /**
       * @default 'Joy URL'
       */
      joyURL: T;

      /**
       * @default 'Event Password'
       */
      eventPassword: T;

      /**
       * @default 'Edit'
       */
      editButton: T;

      /**
       * @default 'Link Copied.'
       */
      linkCopiedToast: T;

      /**
       * @default 'Password copied.'
       */
      passwordCopiedToast: T;
    };
    urlDialog: {
      /**
       * @default 'Joy URL'
       */
      title: T;

      /**
       * @default 'URL'
       */
      url: T;

      /**
       * @default 'Please Note:'
       */
      urlNoteTitle: T;

      /**
       * @default 'Your old Joy URL will no longer work. If you have a custom domain, you’ll need to update your forwarding URL with your domain provider.'
       */
      urlNoteMessage: T;

      /**
       * @default 'Cancel'
       */
      cancelButton: T;

      /**
       * @default 'Save'
       */
      saveButton: T;

      /**
       * @default 'URL cannot be blank.'
       */
      handleRequiredError: T;

      /**
       * @default 'URL must be less than 60 characters long.'
       */
      handleLengthError: T;

      /**
       * @default 'Only letters, numbers and '-' are allowed in your URL.'
       */
      handleCharactersError: T;

      /**
       * @default 'Your Event Website has been updated.'
       */
      successUpdateToast: T;

      /**
       * @default 'An error occurred while updating your Event Website. Please try again.'
       */
      errorUpdateToast: T;

      /**
       * @default 'This URL is available'
       */
      urlAvailableLabel: T;

      /**
       * @default 'This URL is not available'
       */
      urlUnavailableLabel: T;

      /**
       * @default '/60 Max Chars'
       */
      maxChars: T;
    };
    passwordDialog: {
      /**
       * @default 'Event Password'
       */
      title: T;

      /**
       * @default 'Copy'
       */
      copy: T;

      /**
       * @default 'Cancel'
       */
      cancelButton: T;

      /**
       * @default 'Save'
       */
      saveButton: T;

      /**
       * @default 'Password'
       */
      password: T;

      /**
       * @default 'Password cannot be blank.'
       */
      passwordRequiredError: T;

      /**
       * @default 'Your password can only contain letters and numbers.'
       */
      passwordCharactersError: T;

      /**
       * @default 'Your Event Password has been updated.'
       */
      successUpdateToast: T;

      /**
       * @default 'An error occurred while updating your Event Password. Please try again.'
       */
      errorUpdateToast: T;

      /**
       * @default 'Password copied.'
       */
      passwordCopiedToast: T;

      /**
       * @default 'Please Note:'
       */
      passwordNoteTitle: T;

      /**
       * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
       */
      passwordNoteMessage: T;
    };
    paperTypesDialog: {
      /**
       * @default 'Our Paper Collection'
       */
      title: T;

      /**
       * @default 'Select the paper that matches your vision. All paper is sourced from Mohawk for their renowned archival quality and commitment to environmental stewardship.'
       */
      description: T;

      /**
       * @default 'Done'
       */
      done: T;
    };
    lowResolutionDialog: {
      /**
       * @default 'Oops, this photo is low resolution.'
       */
      title: T;

      /**
       * @default 'The photo you uploaded is low resolution and won’t look great on the printed card. Please find a different photo that meets the following criteria.'
       */
      message: T;

      /**
       * @default 'Please make sure you find the original photo. Upscaling or resizing the photo might get you past this warning, but will still not look good when printed.'
       */
      instructions: T;

      /**
       * @default 'Upload Different Photo'
       */
      uploadDifferentPhoto: T;
    };
    envelope: {
      addressValidation: {
        /**
         * @default 'Please fill in your return address first.'
         */
        addressText: T;

        /**
         * @default 'Please confirm that the return address is correct by ticking the checkbox.'
         */
        checkboxText: T;
      };

      /**
       * @default 'Edit Envelope'
       */
      panelTitle: T;

      quantity: {
        /**
         * @default 'Quantity'
         */
        title: T;

        /**
         * @default '{{quantity}} Cards'
         */
        value: T;
      };
      returnAddressing: {
        /**
         * @default 'Return Addressing'
         */
        title: T;

        /**
         * @default 'Print your return address on the front or back of the envelope.'
         */
        subtitle: T;

        /**
         * @default 'Address Placement'
         */
        placementTitle: T;

        /**
         * @default 'FREE'
         */
        price: T;

        /**
         * @default 'Address Design'
         */
        designTitle: T;
      };
      shippingAddressDialog: {
        /**
         * @default 'Your Return Address'
         */
        title: T;

        /**
         * @default 'Return Address'
         */
        modalTitle: T;

        /**
         * @default 'Please double check your address details or fill in the new one that you’d like to be printed on the envelope as a return address.'
         */
        modalDescription: T;

        /**
         * @default 'Add Return Address'
         */
        emptyButton: T;

        /**
         * @default 'Show Country/Region'
         */
        showCountry: T;
      };
      recipientAddressing: {
        /**
         * @default 'Recipient Addressing'
         */
        title: T;

        /**
         * @default 'Have your guest’s addresses printed on the front of each envelope.'
         */
        subtitle: T;

        /**
         * @default 'FREE'
         */
        price: T;

        /**
         * @default 'Print Addresses'
         */
        firstOption: T;

        /**
         * @default 'Leave Blank'
         */
        secondOption: T;

        /**
         * @default 'The same design you selected applies to recipient addressing. Next we’ll help you add your recipient addresses.'
         */
        description: T;
      };
      checkbox: {
        /**
         * @default 'Please confirm your return address.'
         */
        title: T;

        /**
         * @default 'My return address is correct and ready to be printed on the envelope'
         */
        description: T;
      };
      stickyCta: {
        /**
         * @default 'Next'
         */
        next: T;

        /**
         * @default 'Recipients'
         */
        recipients: T;

        /**
         * @default 'Review'
         */
        review: T;
      };

      /**
       * @default 'Edit Return Address'
       */
      ctaEditReturnAddress: T;

      /**
       * @default 'Add Return Address'
       */
      ctaAddReturnAddress: T;
    };
    recipients: {
      /**
       * @default 'Edit Recipients'
       */
      panelTitle: T;

      quantity: {
        /**
         * @default 'Quantity'
         */
        title: T;

        /**
         * @default '{{quantity}} Cards'
         */
        value: T;

        /**
         * @default 'Changing Quantity is not available in edit mode. Please contact customer support.'
         */
        icon: T;
      };
      recipientAddressing: {
        /**
         * @default 'Recipient Addressing'
         */
        title: T;

        /**
         * @default 'Have your guests’ addresses printed on the front of each envelope.'
         */
        subtitle: T;

        /**
         * @default 'FREE'
         */
        price: T;

        /**
         * @default 'Leave Blank'
         */
        firstOption: T;

        /**
         * @default 'Print Addresses'
         */
        secondOption: T;

        /**
         * @default 'The same design you selected applies to recipient addressing. Next we’ll help you add your recipient addresses.'
         */
        description: T;
      };
      printRecipientAddresses: {
        /**
         * @default 'Print Recipient Addresses'
         */
        title: T;

        /**
         * @default 'Select an option to upload your guests’ addresses to be printed on the envelope.'
         */
        subtitle: T;

        /**
         * @default 'Skip and Add After Ordering'
         */
        firstOption: T;

        /**
         * @default 'Skip and Edit Later'
         */
        firstOptionEditMode: T;

        /**
         * @default 'Select Recipients Now'
         */
        secondOption: T;

        /**
         * @default 'Submit a Spreadsheet'
         */
        thirdOption: T;
      };
      info: {
        /**
         * @default 'Print Guest Addresses'
         */
        title: T;

        /**
         * @default 'These addresses will be printed on the envelopes.'
         */
        subtitle: T;

        /**
         * @default 'envelopes'
         */
        envelopes: T;

        /**
         * @default 'addressed'
         */
        addressed: T;

        /**
         * @default 'blank'
         */
        blank: T;
      };
      contactCollector: {
        /**
         * @default 'Don’t have your guest addresses yet?'
         */
        text1: T;

        /**
         * @default 'Alternatively, you can add them manually.'
         */
        text2: T;
      };

      /**
       * @default 'Add New Recipient'
       */
      addNewRecipient: T;

      stickyCta: {
        /**
         * @default 'Next: Review'
         */
        next: T;
      };

      /**
       * @default 'Please confirm that the recipients number is correct by ticking the checkbox.'
       */
      quantityConfirmation: T;

      howItWorks: {
        /**
         * @default 'How it works:'
         */
        title: T;

        steps: [
          {
            /**
             * @default 'Select “Print Addresses” and place your order. You’ll choose your recipients after the order is placed.'
             */
            title: T;
          },
          {
            /**
             * @default 'After ordering, you’ll be able to access your order and select your guests for envelope addressing from your Joy guest list or Contact Collector.'
             */
            title: T;
          },
          {
            /**
             * @default 'Your order will be paused until we receive your addresses, and sent to print when you’re ready.'
             */
            title: T;
          },
        ];

        /**
         * @default 'Changed your mind? No problem! Send your order to be printed without recipient addressing at any time.'
         */
        subTitle: T;

        /**
         * @default 'Learn More'
         */
        learnMore: T;
      };
      skipPrintType: {
        /**
         * @default 'After placing an order, you can come back any time to add and select your recipients. Your order will be paused until then.'
         */
        title: T;

        /**
         * @default 'I understand my order will be paused until I add recipient addressing or send it to print without it.'
         */
        checkBox: T;
      };
      spreadsheetPrintType: {
        steps: [
          {
            /**
             * @default 'Please download the template'
             */
            title: T;
          },
          {
            /**
             * @default 'We’ll send a digital preview of your final addressed envelopes within 2 business days of receiving the address spreadsheet.'
             */
            title: T;
          },
          {
            /**
             * @default 'When you confirm you’re happy with it, our support team will send your order to printing.'
             */
            title: T;
          },
        ];

        /**
         * @default 'here'
         */
        link: T;

        /**
         * @default 'and send it to our support team at'
         */
        sendIt: T;

        /**
         * @default 'along with your order number.'
         */
        along: T;

        /**
         * @default 'I understand my order will be paused until I submit my spreadsheet and confirm the preview as described above.'
         */
        checkBox: T;
      };

      /**
       * @default 'You sent a CSV file to'
       */
      spreadsheetPrintTypeAlreadySent1: T;

      /**
       * @default 'when you placed your order. Envelopes are typically created from your CSV within 2 business days. If it has been more than 2 business days and you have not been contacted, please reach out to'
       */
      spreadsheetPrintTypeAlreadySent2: T;

      /**
       * @default 'Edit Guest Details'
       */
      ctaEditGuestDetails: T;

      /**
       * @default 'Add Missing Address'
       */
      ctaAddMissingAddress: T;

      /**
       * @default 'Address Formatting Issue'
       */
      legacyAddressLineBreakTitle: T;

      /**
       * @default ''Street Address' and 'City, State, ZIP Code' should be on separate lines. Click Edit Guest Details to add a line break.'
       */
      legacyAddressLineBreakDescription: T;

      /**
       * @default 'Learn more.'
       */
      legacyAddressLineBreakLink: T;
    };
  };
  premiumDigitalCardCustomizer: {
    cardFront: {
      /**
       * @default 'Customize your card whenever you’d like; now, after purchase, or even after sending some cards.'
       */
      editCard: T;
    };
    digitalReview: {
      /**
       * @default 'Please add your billing details.'
       */
      addressFieldErrorMessage: T;

      /**
       * @default 'Please confirm that you checked all the details by ticking the checkbox below.'
       */
      checkboxFieldErrorMessage: T;

      /**
       * @default 'Make sure to carefully check everything before you finalize your order.'
       */
      stepDescription: T;

      /**
       * @default 'Billing Address'
       */
      billingAddressTitle: T;

      /**
       * @default 'Add Billing Address'
       */
      billingAddressEmptyMessage: T;

      /**
       * @default 'Go to Checkout'
       */
      ctaText: T;

      /**
       * @default 'Submit Changes'
       */
      ctaTextOrder: T;

      /**
       * @default 'I understand that any changes submitted will apply to previously sent cards, as well as future cards.'
       */
      orderCtaDescription: T;

      /**
       * @default 'You'll be able to send your Digital Card via personalized email to your guests at the next step.'
       */
      deliveryDescription: T;

      /**
       * @default 'You'll be able to send your Digital Card via personalized email to your guests at the next step.'
       */
      multiOptionsDeliveryDescription: T;

      /**
       * @default 'Delivery Methods'
       */
      deliveryTitle: T;

      /**
       * @default 'Email'
       */
      standardDeliveryTitle: T;

      /**
       * @default 'Personalized Emails'
       */
      standardDeliveryDescription: T;

      /**
       * @default 'Text, Links & Email'
       */
      premiumDeliveryTitle: T;

      /**
       * @default 'Text messaging to USA and Canada'
       */
      premiumDeliveryDescription: T;

      /**
       * @default 'Up to {{count}} guests'
       */
      emailDeliveryLimits: T;

      /**
       * @default 'Included'
       */
      included: T;

      /**
       * @default 'Personalized Emails'
       */
      valuePropEmail: T;

      /**
       * @default 'Shareable Card Link'
       */
      valuePropLink: T;

      /**
       * @default 'Text messaging to USA and Canada'
       */
      valuePropPremium: T;

      /**
       * @default 'International Text *'
       */
      valuePropDiamond: T;

      /**
       * @default 'Email'
       */
      basic: T;

      /**
       * @default 'Text Messaging'
       */
      premium: T;

      /**
       * @default 'International Text Message'
       */
      diamond: T;

      /**
       * @default '*Some country restrictions apply.'
       */
      coutryRestriction: T;

      /**
       * @default 'Learn more'
       */
      learnMore: T;
    };
    digitalDeliveryMethod: {
      /**
       * @default 'Personalized email up to {{count}} guests'
       */
      digitalEmailFor: T;
    };
    postCheckout: {
      /**
       * @default 'Track Cards Sent'
       */
      trackCardsSent: T;

      greetingBlock: {
        /**
         * @default 'Order Confirmed! Up next:'
         */
        eyebrow: T;

        /**
         * @default 'Select recipients and send your card.'
         */
        title: T;
      };
      stepBlocks: {
        step1: {
          /**
           * @default 'First, let's get your email looking great.'
           */
          label: T;

          /**
           * @default 'Edit Subject'
           */
          editSubjectCta: T;

          /**
           * @default 'Send Test Email'
           */
          sendTestEmailCta: T;

          /**
           * @default '💌 Your test email was sent to: {{email}}'
           */
          sendTestEmailToast: T;
        };
        step2: {
          /**
           * @default 'Then, select your recipients and send.'
           */
          label: T;

          /**
           * @default 'Select Recipients'
           */
          selectRecipientsCta: T;

          /**
           * @default 'Modify {{count}} Recipients...'
           */
          modifyRecipients: T;

          /**
           * @default 'Send Card'
           */
          sendCardCta: T;

          /**
           * @default 'Send Card to {{count}} Recipients'
           */
          sendCardToSelectedRecipientsCta: T;

          /**
           * @default 'There was an error sending the Card. Please try again or contact support.'
           */
          sendCardError: T;
        };
      };
      emailPreview: {
        /**
         * @default 'Subject:'
         */
        subjectLabel: T;

        /**
         * @default 'View The Card'
         */
        viewCardCta: T;

        /**
         * @default 'To: {{name}}'
         */
        toMessage: T;
      };
      printCardSellBanner: {
        /**
         * @default 'Add Beautiful Paper Cards'
         */
        title: T;

        /**
         * @default 'Some guests prefer to receive a physical card. Create a matching (or unique) paper card for them. All your details are ready. ☺️'
         */
        description: T;

        /**
         * @default 'See it on Paper'
         */
        ctaText: T;
      };
      linkShareSection: {
        /**
         * @default 'Want to do it yourself?'
         */
        eyebrow: T;

        /**
         * @default 'Share your card link any way you want.'
         */
        title: T;

        /**
         * @default 'Copy Card Link'
         */
        ctaText: T;

        /**
         * @default '🎉 Your link has been copied.'
         */
        copyToast: T;
      };
      emailEditorDialog: {
        /**
         * @default 'Edit Your Message'
         */
        header: T;

        senderNameField: {
          /**
           * @default 'Sender Name'
           */
          label: T;
        };
        subjectField: {
          /**
           * @default 'Subject'
           */
          label: T;

          /**
           * @default 'Your message will appear as an email subject and text message.'
           */
          inputCaption: T;
        };

        /**
         * @default 'Cancel'
         */
        cancelCta: T;

        /**
         * @default 'Save'
         */
        saveCta: T;
      };
    };
    successStep: {
      /**
       * @default 'Congratulations! Your card has been sent.'
       */
      title: T;

      /**
       * @default 'Your message has been sent successfully.'
       */
      messageSuccess: T;

      /**
       * @default '{{count}} Messages sent'
       */
      messageSendCount: T;

      /**
       * @default '1 Message sent'
       */
      messageSendCountSingle: T;

      /**
       * @default 'Messages sent'
       */
      messageSentNoCount: T;

      /**
       * @default 'Track which guests have received and opened your card.'
       */
      trackDescription: T;

      /**
       * @default 'Track Cards Sent'
       */
      trackCardsSentCta: T;

      /**
       * @default 'View Order'
       */
      viewOrderCta: T;
    };
  };
  dashboard: {
    dynamicBanner: {
      /**
       * @default 'Free Shipping to {{countries}} Addresses'
       */
      freeShipping: T;
    };
    primaryNav: {
      desktop: {
        /**
         * @default 'Browse Designs'
         */
        home: T;

        /**
         * @default 'Imagine Your Design'
         */
        imagine: T;

        /**
         * @default 'Drafts'
         */
        drafts: T;

        /**
         * @default 'Orders'
         */
        orders: T;

        /**
         * @default 'Favorites'
         */
        favorites: T;
      };
      mobile: {
        /**
         * @default 'Browse'
         */
        home: T;

        /**
         * @default 'Imagine'
         */
        imagine: T;

        /**
         * @default 'Drafts'
         */
        drafts: T;

        /**
         * @default 'Orders'
         */
        orders: T;

        /**
         * @default 'Favorites'
         */
        favorites: T;
      };
    };
    existingDraftsWarningDialog: {
      variants: {
        single: {
          /**
           * @default 'You already have a draft of this design. What would you like to do?'
           */
          message: T;

          /**
           * @default 'Edit Existing Draft'
           */
          ctaText: T;
        };
        multiple: {
          /**
           * @default 'You have multiple drafts of this design. What would you like to do?'
           */
          message: T;

          /**
           * @default 'View Existing Drafts'
           */
          ctaText: T;
        };
      };

      /**
       * @default 'Start New Draft'
       */
      startNewDraftCtaText: T;
    };
    restrictedInternationalShippingWarningDialog: {
      print: {
        /**
         * @default 'Do you have a supported address?'
         */
        title: T;

        /**
         * @default 'The supported country is {{countries}}.'
         */
        supportedCountriesSingular: T;

        /**
         * @default 'The supported countries are {{countries}}.'
         */
        supportedCountriesPlural: T;

        /**
         * @default 'Paper cards are currently available for the supported addresses only.'
         */
        warningMessageNonStdOrInvitationText: T;

        /**
         * @default 'Paper cards are currently available for the supported addresses only. If you are not in the supported countries you can still '
         */
        warningMessageEcardText: T;

        /**
         * @default 'If you don't have a supported address, you can send digital thank you messages to your guests'
         */
        warningMessageEmailText: T;

        /**
         * @default 'create a free basic digital card.'
         */
        warningMessageLink: T;

        /**
         * @default 'here.'
         */
        warningMessageLinkThankYou: T;

        /**
         * @default 'I have a supported address'
         */
        ctaText: T;
      };
      digital: {
        /**
         * @default 'Do you have a supported address?'
         */
        title: T;

        /**
         * @default 'The supported country is {{countries}}.'
         */
        supportedCountriesSingular: T;

        /**
         * @default 'The supported countries are {{countries}}.'
         */
        supportedCountriesPlural: T;

        /**
         * @default 'Premium digital cards are currently available for the supported addresses only.'
         */
        warningMessageNonStdOrInvitationText: T;

        /**
         * @default 'Premium digital cards are currently available for the supported addresses only. If you are not in the supported countries you can still '
         */
        warningMessageEcardText: T;

        /**
         * @default 'If you don't have a supported address, you can send digital thank you messages to your guests'
         */
        warningMessageEmailText: T;

        /**
         * @default 'create a free basic digital card.'
         */
        warningMessageLink: T;

        /**
         * @default 'here.'
         */
        warningMessageLinkThankYou: T;

        /**
         * @default 'I have a supported address'
         */
        ctaText: T;
      };
    };
    designsGallery: {
      /**
       * @default 'Learn More'
       */
      learnMore: T;

      filterOptions: {
        /**
         * @default 'Color'
         */
        color: T;

        /**
         * @default 'Foil'
         */
        foil: T;

        /**
         * @default 'With Foil'
         */
        'foil with': T;

        /**
         * @default 'Without Foil'
         */
        'foil without': T;

        /**
         * @default 'Paper & Digital'
         */
        format: T;

        /**
         * @default 'Digital'
         */
        'format digital': T;

        /**
         * @default 'Paper'
         */
        'format paper': T;

        /**
         * @default 'Orientation'
         */
        orientation: T;

        /**
         * @default 'Landscape'
         */
        'orientation landscape': T;

        /**
         * @default 'Portrait'
         */
        'orientation portrait': T;

        /**
         * @default 'Square'
         */
        'orientation square': T;

        /**
         * @default 'Photo'
         */
        photo: T;

        /**
         * @default 'With Photo'
         */
        'photo with': T;

        /**
         * @default 'Without Photo'
         */
        'photo without': T;

        /**
         * @default 'Price'
         */
        price: T;

        /**
         * @default 'Free Digital'
         */
        'price basic': T;

        /**
         * @default 'Premium Paper & Digital'
         */
        'price premium': T;

        /**
         * @default 'Style'
         */
        style: T;
      };

      /**
       * @default 'Explore {{designs}}'
       */
      exploreDesigns: T;

      /**
       * @default 'Matches Your Site'
       */
      websiteMatch: T;

      filtersDrawer: {
        /**
         * @default 'Filters'
         */
        header: T;

        /**
         * @default 'Reset All Filters'
         */
        resetCta: T;

        /**
         * @default 'Show Results'
         */
        showResultsCta: T;
      };
      pagination: {
        /**
         * @default 'Previous'
         */
        previous: T;

        /**
         * @default 'Next'
         */
        next: T;

        /**
         * @default 'Page {{page}} / {{totalPages}}'
         */
        page: T;
      };
    };
    favoritesGallery: {
      emptyState: {
        /**
         * @default 'You don't have any favorites just yet!'
         */
        title: T;

        /**
         * @default 'When you browse the gallery, you can add all the designs you like clicking the heart in the top right, and you can come back and see them here.'
         */
        description: T;

        /**
         * @default 'Browse Designs'
         */
        cta: T;
      };
    };
    draftsGallery: {
      /**
       * @default 'Your Drafts'
       */
      sectionTitle: T;

      /**
       * @default 'Edited {{timeAgo}}'
       */
      editedAtLabel: T;

      /**
       * @default 'You don’t have any drafts just yet!'
       */
      emptyStateTitle: T;

      /**
       * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
       */
      emptyStateMessage: T;

      stationerySection: {
        title: {
          /**
           * @default 'Paper Cards'
           */
          print: T;

          /**
           * @default 'Premium Digital Cards'
           */
          digital: T;
        };
        emptyStateText: {
          desktop: {
            /**
             * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
             */
            print: T;

            /**
             * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
             */
            digital: T;
          };
          mobile: {
            /**
             * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
             */
            print: T;

            /**
             * @default 'Once you start designing your cards, we’ll autosave them for you here, so you can access them at any point and continue where you left off.'
             */
            digital: T;
          };
        };
        emptyStateCTA: {
          /**
           * @default 'Browse Paper Cards'
           */
          print: T;

          /**
           * @default 'Browse Premium Digital Cards'
           */
          digital: T;
        };

        /**
         * @default 'Show All'
         */
        buttonTitle: T;
      };
      digitalSection: {
        /**
         * @default 'Basic Digital Cards'
         */
        title: T;

        /**
         * @default 'No Basic Digital Drafts'
         */
        emptyStateTitle: T;

        /**
         * @default 'Art Save the Date'
         */
        saveTheDate: T;

        /**
         * @default 'Photo Save the Date'
         */
        photoSaveTheDate: T;

        /**
         * @default 'Invitation'
         */
        invitation: T;

        /**
         * @default 'Custom Card'
         */
        custom: T;
      };
      deleteDraftDialog: {
        /**
         * @default 'Are you sure you want to delete this draft permanently?'
         */
        title: T;

        /**
         * @default 'You can always create a new draft, but the details saved here will no longer be saved.'
         */
        description: T;

        /**
         * @default 'Cancel'
         */
        cancelCta: T;

        /**
         * @default 'Delete Draft'
         */
        deleteCta: T;

        /**
         * @default 'Draft deleted successfully'
         */
        successToast: T;

        /**
         * @default 'Failed to delete draft'
         */
        errorToast: T;
      };
    };
    conciergeServiceSection: {
      carousel: {
        /**
         * @default 'Design Concierge Service'
         */
        eyebrow: T;

        title: {
          /**
           * @default 'Premium Save the Dates'
           */
          saveTheDate: T;

          /**
           * @default 'Premium Invitation Suites'
           */
          invitation: T;
        };
        tileDescription: {
          /**
           * @default 'Invitation Suite'
           */
          invitation: T;

          /**
           * @default 'Save the Date'
           */
          saveTheDate: T;
        };
      };
      dialog: {
        overviewScreen: {
          /**
           * @default 'COMING SOON'
           */
          comingSoonLabel: T;

          costLabel: {
            /**
             * @default 'From {{cost}} each for order of 100'
             */
            saveTheDate: T;

            /**
             * @default 'From {{cost}} each for order of 100 suites'
             */
            invitation: T;
          };

          /**
           * @default 'Notify Me'
           */
          notifyMeCta: T;

          /**
           * @default 'Order Now'
           */
          orderNowCta: T;

          sections: {
            suiteHighlights: {
              title: {
                /**
                 * @default 'Includes'
                 */
                saveTheDate: T;

                /**
                 * @default 'Suite Includes'
                 */
                invitation: T;
              };
            };
            overview: {
              /**
               * @default 'Design Concierge Service'
               */
              title: T;

              /**
               * @default 'After placing your order, we will provide a link to our wording submission form. You can provide your wedding details to put on the card and introduce tweaks you wish to make.'
               */
              description: T;
            };
            howItWorks: {
              /**
               * @default 'How It Works, Step By Step'
               */
              title: T;

              steps: [
                {
                  /**
                   * @default 'Customization Form'
                   */
                  title: T;

                  /**
                   * @default 'Fill out your wedding details and select your options in the customization form.'
                   */
                  description: T;
                },
                {
                  /**
                   * @default 'Design Preview (Within 2 Days)'
                   */
                  title: T;

                  /**
                   * @default 'Your designer begins working on your customized design. You will receive an email when its time to view your proof.'
                   */
                  description: T;
                },
                {
                  /**
                   * @default 'Feedback & Changes (3-5 Business days)'
                   */
                  title: T;

                  /**
                   * @default 'Work with your designer to tweak your proof and get all the details correct. We won’t move to printing until you approve your design.'
                   */
                  description: T;
                },
                {
                  /**
                   * @default 'Printing ({{quantity}} Business Days)'
                   */
                  title: T;

                  /**
                   * @default 'After you let your design team know your proof is ready, we move to printing phase to make your custom order. Processing times vary between suites given the use of special print techniques, such as white ink or gold foil.'
                   */
                  description: T;
                },
                {
                  /**
                   * @default 'Shipping (3-4 Days)'
                   */
                  title: T;

                  /**
                   * @default 'Orders include free express DHL shipping reaching most destinations in 3-4 business days.'
                   */
                  description: T;
                },
              ];
            };
          };
        };
        successScreen: {
          /**
           * @default 'Success!'
           */
          title: T;

          /**
           * @default 'We'll be in touch as soon as the concierge suites are available on Joy Paper.'
           */
          description: T;

          /**
           * @default 'All Done'
           */
          allDoneCta: T;
        };
      };
    };
    ordersList: {
      digitalOrder: {
        /**
         * @default 'Order Placed'
         */
        orderPlaced: T;

        /**
         * @default 'Order Number'
         */
        orderNumber: T;

        /**
         * @default 'Track Delivery'
         */
        trackDelivery: T;

        /**
         * @default 'Send More or Resend'
         */
        sendMore: T;

        /**
         * @default 'Select Recipients and Send'
         */
        selectRecipients: T;

        /**
         * @default 'Order Matching Paper Card'
         */
        orderMatchingPaperCard: T;

        /**
         * @default 'This order has been cancelled. Please contact customer support if you believe this is an error'
         */
        orderCanceled: T;
      };
    };
  };
  printJobDetails: {
    progressTracker: {
      statusMilestones: {
        /**
         * @default 'Order Placed'
         */
        orderPlaced: T;

        /**
         * @default 'In Progress'
         */
        inProgress: T;

        /**
         * @default 'Ready to Ship'
         */
        readyToShip: T;

        /**
         * @default 'Shipped'
         */
        shipped: T;

        /**
         * @default 'Delivered'
         */
        delivered: T;

        /**
         * @default 'Canceled'
         */
        canceled: T;

        /**
         * @default 'Refunded'
         */
        refunded: T;
      };
    };
  };
  pdpModal: {
    breadcrumbs: {
      /**
       * @default 'Cards'
       */
      root: T;

      category: {
        /**
         * @default 'Save the Dates'
         */
        saveTheDate: T;

        /**
         * @default 'Invitations'
         */
        invitation: T;
      };
    };
    previewPane: {
      assetLabels: {
        /**
         * @default 'Front'
         */
        front: T;

        /**
         * @default 'Back'
         */
        back: T;

        /**
         * @default 'Envelope'
         */
        envelope: T;
      };
    };
    customizationPane: {
      matchingFoilTemplate: {
        /**
         * @default 'Available in Real Foil:'
         */
        title: T;
      };
      customizeCta: {
        /**
         * @default 'Subtotal'
         */
        subtotalLabel: T;

        /**
         * @default 'Customize Now'
         */
        ctaText: T;

        /**
         * @default 'Instant Delivery via Email'
         */
        digitalDeliverySecondaryLabel: T;
      };
      printTemplateConfig: {
        inlineValueProps: {
          /**
           * @default 'Matching Website Designs'
           */
          websiteDesign: T;

          /**
           * @default 'Contact Collector'
           */
          contactCollector: T;

          /**
           * @default 'QR codes for Easy Access'
           */
          qrCodes: T;
        };
        listValueProps: {
          /**
           * @default 'All Joy Prints Include:'
           */
          sectionTitle: T;

          /**
           * @default 'Digital printing on our luxurious signature card stock with a subtle velvety texture'
           */
          paperType: T;

          /**
           * @default 'Add rounded corners and customize your card the way you want'
           */
          silhouette: T;

          /**
           * @default 'QR codes that include your website password for seamless guest digital RSVP'
           */
          qrCodes: T;

          /**
           * @default 'Premium white envelope with complimentary return address printing'
           */
          envelope: T;
        };
      };
      digitalTemplateConfig: {
        inlineValueProps: {
          /**
           * @default 'Matching Website Designs'
           */
          websiteDesign: T;

          /**
           * @default 'Contact Collector'
           */
          contactCollector: T;

          /**
           * @default 'Easy Delivery and Tracking'
           */
          delivery: T;
        };
        listValueProps: {
          /**
           * @default 'All Joy Digital Cards Include:'
           */
          sectionTitle: T;

          /**
           * @default 'Beautiful, unique designs to pick from'
           */
          designs: T;

          /**
           * @default 'Easily tracking which guests have received and opened your Digital Card'
           */
          tracking: T;

          /**
           * @default 'Seamless guests info gathering with Contact Collector'
           */
          contactCollector: T;

          /**
           * @default 'The possibility to link to your wedding website, RSVP, Add to Calendar, Registry and more'
           */
          linking: T;
        };
      };
      premiumDigitalTemplateConfig: {
        listValueProps: {
          /**
           * @default 'Premium Digital Perks'
           */
          sectionTitle: T;

          premium: {
            /**
             * @default 'Premium Designer'
             */
            title: T;

            /**
             * @default 'Customize your card exactly how you like it, with hundreds of font, photo, and layout options.'
             */
            description: T;
          };
          matchingPaperCards: {
            /**
             * @default 'Matching Paper Cards and Website'
             */
            title: T;

            /**
             * @default 'Order printed cards for special guests or keepsakes and match your cards with a free wedding website.'
             */
            description: T;
          };
          textMessage: {
            /**
             * @default 'Text Message Delivery'
             */
            title: T;

            /**
             * @default 'Text messaging to USA and Canada with recipient tracking.'
             */
            description: T;
          };
          personalizedEmail: {
            /**
             * @default 'Personalized Email Delivery'
             */
            title: T;

            /**
             * @default 'Send and easily track which guests have received and opened your digital card.'
             */
            description: T;
          };
          shareableLink: {
            /**
             * @default 'Shareable Link'
             */
            title: T;

            /**
             * @default 'Get a link to your digital card that you can share directly with family and friends.'
             */
            description: T;
          };
          contactCollector: {
            /**
             * @default 'Contact Collector'
             */
            title: T;

            /**
             * @default 'Magically collect guests' contact info in your guest list for sending cards and thank you notes.'
             */
            description: T;
          };
        };
      };

      overviewAccordionTabs: [
        {
          /**
           * @default 'Why Joy?'
           */
          title: T;

          /**
           * @default 'Choose timeless elegance with the Minimalistic Arch design suite. Printed on luxe paper, this design features a classic mix of typography and calligraphy in a chic layout. We think it's a stunning choice for any wedding venue, from formal hotel ballroom to industrial loft.'
           */
          description: T;
        },
        {
          /**
           * @default 'Shipping'
           */
          title: T;

          /**
           * @default 'Choose timeless elegance with the Minimalistic Arch design suite. Printed on luxe paper, this design features a classic mix of typography and calligraphy in a chic layout. We think it's a stunning choice for any wedding venue, from formal hotel ballroom to industrial loft.'
           */
          description: T;
        },
        {
          /**
           * @default 'Need help designing?'
           */
          title: T;

          /**
           * @default 'Choose timeless elegance with the Minimalistic Arch design suite. Printed on luxe paper, this design features a classic mix of typography and calligraphy in a chic layout. We think it's a stunning choice for any wedding venue, from formal hotel ballroom to industrial loft.'
           */
          description: T;
        },
      ];
      foilTooltip: {
        /**
         * @default 'Learn more about foil'
         */
        cta: T;

        /**
         * @default 'Premium Foil Stamping'
         */
        title: T;

        /**
         * @default 'Elevate your design with real foil in gold, rose gold, or silver. Foil stamping uses a machine to press the foil color onto the paper for a smooth, metallic effect.'
         */
        description: T;
      };
    };
  };
  imagineCardAiApp: {
    header: {
      /**
       * @default 'Dream It, Design It.'
       */
      heading: T;

      /**
       * @default 'Your Perfect Card Awaits'
       */
      subheading: T;
    };
    promptbar: {
      /**
       * @default 'Type what you’d like to imagine...'
       */
      placeholder: T;

      /**
       * @default 'Type what you imagine'
       */
      placeholderMobile: T;

      /**
       * @default 'Imagine'
       */
      submit: T;

      /**
       * @default 'These are some fun ideas to get you started'
       */
      subheadingPopular: T;
    };
    cards: {
      hover: {
        /**
         * @default 'Restyle'
         */
        styles: T;

        /**
         * @default 'Refine'
         */
        tweaks: T;

        /**
         * @default 'Customize'
         */
        draft: T;

        /**
         * @default 'Reimagine'
         */
        reimagine: T;
      };

      /**
       * @default 'Paper Card - From $1.09'
       */
      pricing: T;
    };
  };
  digitalFlowWelcomeNotification: {
    /**
     * @default 'Welcome to Premium Card Designer'
     */
    title: T;

    /**
     * @default 'Learn how it works.'
     */
    description: T;

    modal: {
      /**
       * @default 'Learn How the Premium Card Designer Works'
       */
      title: T;

      /**
       * @default 'Customize Your Card'
       */
      cta: T;
    };
  };
  premiumDigitalRecipientViewError: {
    /**
     * @default 'Hmm… we can't find that.'
     */
    title: T;

    /**
     * @default 'This digital card may have been changed or is temporarily unavailable.'
     */
    subtitle: T;

    /**
     * @default 'Find a Couple'
     */
    linkText: T;
  };
  editCardBanner: {
    /**
     * @default 'Noticed a mistake? Don’t worry, that happens! Let’s get it right.'
     */
    paperDescription: T;

    /**
     * @default 'Still working on your card? Any changes you make will be applied to previously sent cards, as well as future ones.'
     */
    digitalDescription: T;

    /**
     * @default 'Edit Your Design'
     */
    cta: T;
  };
  premiumDigitalOrderTracking: {
    header: {
      /**
       * @default 'Card Tracking'
       */
      title: T;

      category: {
        /**
         * @default 'Digital Save the Date'
         */
        saveTheDate: T;

        /**
         * @default 'Digital Invitation'
         */
        invitation: T;

        /**
         * @default 'Digital Thank You'
         */
        thankYou: T;

        /**
         * @default 'Digital Holiday Card'
         */
        holiday: T;

        /**
         * @default 'Digital Enclosure Card'
         */
        enclosure: T;

        /**
         * @default 'Digital Card'
         */
        default: T;
      };
    };

    /**
     * @default 'Send More Cards'
     */
    sendMoreCardsCta: T;

    /**
     * @default 'Send More'
     */
    sendMoreCardsCtaMobile: T;

    /**
     * @default 'Preview as Guest'
     */
    previewAsGuestCta: T;

    /**
     * @default 'Preview'
     */
    previewAsGuestCtaMobile: T;

    statusTrackingBar: {
      sent: {
        /**
         * @default 'Recipients'
         */
        label: T;

        /**
         * @default 'Sent'
         */
        iconTitle: T;
      };
      delivered: {
        /**
         * @default 'Delivered'
         */
        label: T;

        /**
         * @default 'Delivered'
         */
        iconTitle: T;
      };
      failed: {
        /**
         * @default 'Failed'
         */
        label: T;

        /**
         * @default 'Failed'
         */
        iconTitle: T;
      };
      viewed: {
        /**
         * @default 'Viewed'
         */
        label: T;

        /**
         * @default 'Viewed'
         */
        iconTitle: T;
      };
    };
    trackingStatusPill: {
      labels: {
        /**
         * @default 'Delivered'
         */
        delivered: T;

        /**
         * @default 'Failed'
         */
        failed: T;

        /**
         * @default 'Viewed'
         */
        viewed: T;

        /**
         * @default 'Sent'
         */
        sent: T;

        /**
         * @default 'Queued'
         */
        queued: T;
      };
    };
    tableHeaders: {
      /**
       * @default 'Recipient'
       */
      recipient: T;

      /**
       * @default 'Status'
       */
      status: T;

      /**
       * @default 'Resend'
       */
      resend: T;
    };
    resendMenuTooltip: {
      /**
       * @default 'Resend the card'
       */
      title: T;

      /**
       * @default 'Choose the best way to reach {{name}}.'
       */
      description: T;
    };
    contactActions: {
      copyLink: {
        /**
         * @default 'Copy {{name}}'s link'
         */
        title: T;
      };
      whatsapp: {
        /**
         * @default 'Send to {{name}} via WhatsApp'
         */
        title: T;

        /**
         * @default 'If you have WhatsApp app on desktop, click the button below.'
         */
        desktopSubText: T;

        /**
         * @default 'Hi {{name}} view our card!'
         */
        textMessage: T;
      };
      sms: {
        /**
         * @default 'Send to {{name}} via text message'
         */
        title: T;

        /**
         * @default 'If you have text messaging app on desktop, click the button below.'
         */
        desktopSubText: T;

        /**
         * @default 'Hi {{name}} view our card!'
         */
        textMessage: T;
      };
      email: {
        /**
         * @default 'Send to {{name}} via email'
         */
        title: T;

        /**
         * @default 'Hi {{name}} view our card!'
         */
        subject: T;

        /**
         * @default 'Click here to view to view our card:'
         */
        body: T;
      };
    };

    /**
     * @default '✨ {{name}}'s link has been copied.'
     */
    copyLinkToast: T;

    shareLinkDialog: {
      /**
       * @default 'Send to {{name}} via WhatsApp'
       */
      title: T;

      /**
       * @default 'This is a personalized link for {{name}} to allow tracking. Don’t share it with other guests.'
       */
      infoMessage: T;

      sendFromDesktop: {
        /**
         * @default 'Send from desktop'
         */
        title: T;

        /**
         * @default 'Send Now'
         */
        cta: T;
      };
      sendFromMobile: {
        /**
         * @default 'Send from mobile'
         */
        title: T;

        /**
         * @default 'Scan QR code and switch to your mobile device.'
         */
        description: T;
      };
    };
  };
  publicShop: {
    meta: {
      saveTheDate: {
        /**
         * @default 'Save the Date Cards | Paper + Free Online Templates | Joy'
         */
        title: T;

        /**
         * @default 'Explore hundreds of unique Save the Date card templates. Our collection includes free online cards, premium digital options, and elegant paper cards, all with matching wedding websites.'
         */
        description: T;
      };
      invitation: {
        /**
         * @default 'Elegant, Affordable Wedding Invitations | Joy'
         */
        title: T;

        /**
         * @default 'Craft your dream wedding invitations with Joy. Discover stunning designs and personalize every detail. Choose between the convenience of digital cards or the timeless appeal of printed invitations to perfectly capture the spirit of your special day.'
         */
        description: T;
      };
      fallback: {
        /**
         * @default 'Joy - Wedding Website, Guest List, Invitations & More'
         */
        title: T;
      };
    };
  };
  samplePack: {
    order: {
      /**
       * @default 'Order Sample'
       */
      title: T;

      sidebar: {
        /**
         * @default 'Sample Pack'
         */
        title: T;

        /**
         * @default 'A selection of cards showcasing each paper type, trim option, and card size.'
         */
        description: T;

        /**
         * @default 'Delivery Method'
         */
        deliveryMethod: T;

        /**
         * @default 'Place Order'
         */
        cta: T;
      };
    };
  };
  concierge: {
    /**
     * @default 'Tariffs may apply.'
     */
    tariffDisclaimer: T;

    /**
     * @default 'See how we help.'
     */
    seeHowWeHelp: T;
  };
  numerals: {
    cardinals: [
      /**
       * @default ''
       */
      T,
      /**
       * @default 'One'
       */
      T,
      /**
       * @default 'Two'
       */
      T,
      /**
       * @default 'Three'
       */
      T,
      /**
       * @default 'Four'
       */
      T,
      /**
       * @default 'Five'
       */
      T,
      /**
       * @default 'Six'
       */
      T,
      /**
       * @default 'Seven'
       */
      T,
      /**
       * @default 'Eight'
       */
      T,
      /**
       * @default 'Nine'
       */
      T,
      /**
       * @default 'Ten'
       */
      T,
      /**
       * @default 'Eleven'
       */
      T,
      /**
       * @default 'Twelve'
       */
      T,
      /**
       * @default 'Thirteen'
       */
      T,
      /**
       * @default 'Fourteen'
       */
      T,
      /**
       * @default 'Fifteen'
       */
      T,
      /**
       * @default 'Sixteen'
       */
      T,
      /**
       * @default 'Seventeen'
       */
      T,
      /**
       * @default 'Eighteen'
       */
      T,
      /**
       * @default 'Nineteen'
       */
      T,
      /**
       * @default 'Twenty'
       */
      T,
      /**
       * @default 'Twenty-One'
       */
      T,
      /**
       * @default 'Twenty-Two'
       */
      T,
      /**
       * @default 'Twenty-Three'
       */
      T,
      /**
       * @default 'Twenty-Four'
       */
      T,
      /**
       * @default 'Twenty-Five'
       */
      T,
      /**
       * @default 'Twenty-Six'
       */
      T,
      /**
       * @default 'Twenty-Seven'
       */
      T,
      /**
       * @default 'Twenty-Eight'
       */
      T,
      /**
       * @default 'Twenty-Nine'
       */
      T,
      /**
       * @default 'Thirty'
       */
      T,
      /**
       * @default 'Thirty-One'
       */
      T,
      /**
       * @default 'Thirty-Two'
       */
      T,
      /**
       * @default 'Thirty-Three'
       */
      T,
      /**
       * @default 'Thirty-Four'
       */
      T,
      /**
       * @default 'Thirty-Five'
       */
      T,
      /**
       * @default 'Thirty-Six'
       */
      T,
      /**
       * @default 'Thirty-Seven'
       */
      T,
      /**
       * @default 'Thirty-Eight'
       */
      T,
      /**
       * @default 'Thirty-Nine'
       */
      T,
      /**
       * @default 'Forty'
       */
      T,
      /**
       * @default 'Forty-One'
       */
      T,
      /**
       * @default 'Forty-Two'
       */
      T,
      /**
       * @default 'Forty-Three'
       */
      T,
      /**
       * @default 'Forty-Four'
       */
      T,
      /**
       * @default 'Forty-Five'
       */
      T,
      /**
       * @default 'Forty-Six'
       */
      T,
      /**
       * @default 'Forty-Seven'
       */
      T,
      /**
       * @default 'Forty-Eight'
       */
      T,
      /**
       * @default 'Forty-Nine'
       */
      T,
      /**
       * @default 'Fifty'
       */
      T,
      /**
       * @default 'Fifty-One'
       */
      T,
      /**
       * @default 'Fifty-Two'
       */
      T,
      /**
       * @default 'Fifty-Three'
       */
      T,
      /**
       * @default 'Fifty-Four'
       */
      T,
      /**
       * @default 'Fifty-Five'
       */
      T,
      /**
       * @default 'Fifty-Six'
       */
      T,
      /**
       * @default 'Fifty-Seven'
       */
      T,
      /**
       * @default 'Fifty-Eight'
       */
      T,
      /**
       * @default 'Fifty-Nine'
       */
      T,
      /**
       * @default 'Sixty'
       */
      T,
      /**
       * @default 'Sixty-One'
       */
      T,
      /**
       * @default 'Sixty-Two'
       */
      T,
      /**
       * @default 'Sixty-Three'
       */
      T,
      /**
       * @default 'Sixty-Four'
       */
      T,
      /**
       * @default 'Sixty-Five'
       */
      T,
      /**
       * @default 'Sixty-Six'
       */
      T,
      /**
       * @default 'Sixty-Seven'
       */
      T,
      /**
       * @default 'Sixty-Eight'
       */
      T,
      /**
       * @default 'Sixty-Nine'
       */
      T,
      /**
       * @default 'Seventy'
       */
      T,
      /**
       * @default 'Seventy-One'
       */
      T,
      /**
       * @default 'Seventy-Two'
       */
      T,
      /**
       * @default 'Seventy-Three'
       */
      T,
      /**
       * @default 'Seventy-Four'
       */
      T,
      /**
       * @default 'Seventy-Five'
       */
      T,
      /**
       * @default 'Seventy-Six'
       */
      T,
      /**
       * @default 'Seventy-Seven'
       */
      T,
      /**
       * @default 'Seventy-Eight'
       */
      T,
      /**
       * @default 'Seventy-Nine'
       */
      T,
      /**
       * @default 'Eighty'
       */
      T,
      /**
       * @default 'Eighty-One'
       */
      T,
      /**
       * @default 'Eighty-Two'
       */
      T,
      /**
       * @default 'Eighty-Three'
       */
      T,
      /**
       * @default 'Eighty-Four'
       */
      T,
      /**
       * @default 'Eighty-Five'
       */
      T,
      /**
       * @default 'Eighty-Six'
       */
      T,
      /**
       * @default 'Eighty-Seven'
       */
      T,
      /**
       * @default 'Eighty-Eight'
       */
      T,
      /**
       * @default 'Eighty-Nine'
       */
      T,
      /**
       * @default 'Ninety'
       */
      T,
      /**
       * @default 'Ninety-One'
       */
      T,
      /**
       * @default 'Ninety-Two'
       */
      T,
      /**
       * @default 'Ninety-Three'
       */
      T,
      /**
       * @default 'Ninety-Four'
       */
      T,
      /**
       * @default 'Ninety-Five'
       */
      T,
      /**
       * @default 'Ninety-Six'
       */
      T,
      /**
       * @default 'Ninety-Seven'
       */
      T,
      /**
       * @default 'Ninety-Eight'
       */
      T,
      /**
       * @default 'Ninety-Nine'
       */
      T,
    ];

    cardinalOclockQuarters: [
      /**
       * @default 'Twelve O'Clock'
       */
      T,
      /**
       * @default 'Twelve Fifteen'
       */
      T,
      /**
       * @default 'Twelve Thirty'
       */
      T,
      /**
       * @default 'Twelve Forty-Five'
       */
      T,
      /**
       * @default 'One O'Clock'
       */
      T,
      /**
       * @default 'One Fifteen'
       */
      T,
      /**
       * @default 'One Thirty'
       */
      T,
      /**
       * @default 'One Forty-Five'
       */
      T,
      /**
       * @default 'Two O'Clock'
       */
      T,
      /**
       * @default 'Two Fifteen'
       */
      T,
      /**
       * @default 'Two Thirty'
       */
      T,
      /**
       * @default 'Two Forty-Five'
       */
      T,
      /**
       * @default 'Three O'Clock'
       */
      T,
      /**
       * @default 'Three Fifteen'
       */
      T,
      /**
       * @default 'Three Thirty'
       */
      T,
      /**
       * @default 'Three Forty-Five'
       */
      T,
      /**
       * @default 'Four O'Clock'
       */
      T,
      /**
       * @default 'Four Fifteen'
       */
      T,
      /**
       * @default 'Four Thirty'
       */
      T,
      /**
       * @default 'Four Forty-Five'
       */
      T,
      /**
       * @default 'Five O'Clock'
       */
      T,
      /**
       * @default 'Five Fifteen'
       */
      T,
      /**
       * @default 'Five Thirty'
       */
      T,
      /**
       * @default 'Five Forty-Five'
       */
      T,
      /**
       * @default 'Six O'Clock'
       */
      T,
      /**
       * @default 'Six Fifteen'
       */
      T,
      /**
       * @default 'Six Thirty'
       */
      T,
      /**
       * @default 'Six Forty-Five'
       */
      T,
      /**
       * @default 'Seven O'Clock'
       */
      T,
      /**
       * @default 'Seven Fifteen'
       */
      T,
      /**
       * @default 'Seven Thirty'
       */
      T,
      /**
       * @default 'Seven Forty-Five'
       */
      T,
      /**
       * @default 'Eight O'Clock'
       */
      T,
      /**
       * @default 'Eight Fifteen'
       */
      T,
      /**
       * @default 'Eight Thirty'
       */
      T,
      /**
       * @default 'Eight Forty-Five'
       */
      T,
      /**
       * @default 'Nine O'Clock'
       */
      T,
      /**
       * @default 'Nine Fifteen'
       */
      T,
      /**
       * @default 'Nine Thirty'
       */
      T,
      /**
       * @default 'Nine Forty-Five'
       */
      T,
      /**
       * @default 'Ten O'Clock'
       */
      T,
      /**
       * @default 'Ten Fifteen'
       */
      T,
      /**
       * @default 'Ten Thirty'
       */
      T,
      /**
       * @default 'Ten Forty-Five'
       */
      T,
      /**
       * @default 'Eleven O'Clock'
       */
      T,
      /**
       * @default 'Eleven Fifteen'
       */
      T,
      /**
       * @default 'Eleven Thirty'
       */
      T,
      /**
       * @default 'Eleven Forty-Five'
       */
      T,
    ];

    ordinals: [
      /**
       * @default ''
       */
      T,
      /**
       * @default 'First'
       */
      T,
      /**
       * @default 'Second'
       */
      T,
      /**
       * @default 'Third'
       */
      T,
      /**
       * @default 'Fourth'
       */
      T,
      /**
       * @default 'Fifth'
       */
      T,
      /**
       * @default 'Sixth'
       */
      T,
      /**
       * @default 'Seventh'
       */
      T,
      /**
       * @default 'Eighth'
       */
      T,
      /**
       * @default 'Ninth'
       */
      T,
      /**
       * @default 'Tenth'
       */
      T,
      /**
       * @default 'Eleventh'
       */
      T,
      /**
       * @default 'Twelfth'
       */
      T,
      /**
       * @default 'Thirteenth'
       */
      T,
      /**
       * @default 'Fourteenth'
       */
      T,
      /**
       * @default 'Fifteenth'
       */
      T,
      /**
       * @default 'Sixteenth'
       */
      T,
      /**
       * @default 'Seventeenth'
       */
      T,
      /**
       * @default 'Eighteenth'
       */
      T,
      /**
       * @default 'Nineteenth'
       */
      T,
      /**
       * @default 'Twentieth'
       */
      T,
      /**
       * @default 'Twenty-First'
       */
      T,
      /**
       * @default 'Twenty-Second'
       */
      T,
      /**
       * @default 'Twenty-Third'
       */
      T,
      /**
       * @default 'Twenty-Fourth'
       */
      T,
      /**
       * @default 'Twenty-Fifth'
       */
      T,
      /**
       * @default 'Twenty-Sixth'
       */
      T,
      /**
       * @default 'Twenty-Seventh'
       */
      T,
      /**
       * @default 'Twenty-Eighth'
       */
      T,
      /**
       * @default 'Twenty-Ninth'
       */
      T,
      /**
       * @default 'Thirtieth'
       */
      T,
      /**
       * @default 'Thirty-First'
       */
      T,
      /**
       * @default 'Thirty-Second'
       */
      T,
      /**
       * @default 'Thirty-Third'
       */
      T,
      /**
       * @default 'Thirty-Fourth'
       */
      T,
      /**
       * @default 'Thirty-Fifth'
       */
      T,
      /**
       * @default 'Thirty-Sixth'
       */
      T,
      /**
       * @default 'Thirty-Seventh'
       */
      T,
      /**
       * @default 'Thirty-Eighth'
       */
      T,
      /**
       * @default 'Thirty-Ninth'
       */
      T,
      /**
       * @default 'Fortieth'
       */
      T,
      /**
       * @default 'Forty-First'
       */
      T,
      /**
       * @default 'Forty-Second'
       */
      T,
      /**
       * @default 'Forty-Third'
       */
      T,
      /**
       * @default 'Forty-Fourth'
       */
      T,
      /**
       * @default 'Forty-Fifth'
       */
      T,
      /**
       * @default 'Forty-Sixth'
       */
      T,
      /**
       * @default 'Forty-Seventh'
       */
      T,
      /**
       * @default 'Forty-Eighth'
       */
      T,
      /**
       * @default 'Forty-Ninth'
       */
      T,
      /**
       * @default 'Fiftieth'
       */
      T,
      /**
       * @default 'Fifty-First'
       */
      T,
      /**
       * @default 'Fifty-Second'
       */
      T,
      /**
       * @default 'Fifty-Third'
       */
      T,
      /**
       * @default 'Fifty-Fourth'
       */
      T,
      /**
       * @default 'Fifty-Fifth'
       */
      T,
      /**
       * @default 'Fifty-Sixth'
       */
      T,
      /**
       * @default 'Fifty-Seventh'
       */
      T,
      /**
       * @default 'Fifty-Eighth'
       */
      T,
      /**
       * @default 'Fifty-Ninth'
       */
      T,
      /**
       * @default 'Sixtieth'
       */
      T,
      /**
       * @default 'Sixty-First'
       */
      T,
      /**
       * @default 'Sixty-Second'
       */
      T,
      /**
       * @default 'Sixty-Third'
       */
      T,
      /**
       * @default 'Sixty-Fourth'
       */
      T,
      /**
       * @default 'Sixty-Fifth'
       */
      T,
      /**
       * @default 'Sixty-Sixth'
       */
      T,
      /**
       * @default 'Sixty-Seventh'
       */
      T,
      /**
       * @default 'Sixty-Eighth'
       */
      T,
      /**
       * @default 'Sixty-Ninth'
       */
      T,
      /**
       * @default 'Seventieth'
       */
      T,
      /**
       * @default 'Seventy-First'
       */
      T,
      /**
       * @default 'Seventy-Second'
       */
      T,
      /**
       * @default 'Seventy-Third'
       */
      T,
      /**
       * @default 'Seventy-Fourth'
       */
      T,
      /**
       * @default 'Seventy-Fifth'
       */
      T,
      /**
       * @default 'Seventy-Sixth'
       */
      T,
      /**
       * @default 'Seventy-Seventh'
       */
      T,
      /**
       * @default 'Seventy-Eighth'
       */
      T,
      /**
       * @default 'Seventy-Ninth'
       */
      T,
      /**
       * @default 'Eightieth'
       */
      T,
      /**
       * @default 'Eighty-First'
       */
      T,
      /**
       * @default 'Eighty-Second'
       */
      T,
      /**
       * @default 'Eighty-Third'
       */
      T,
      /**
       * @default 'Eighty-Fourth'
       */
      T,
      /**
       * @default 'Eighty-Fifth'
       */
      T,
      /**
       * @default 'Eighty-Sixth'
       */
      T,
      /**
       * @default 'Eighty-Seventh'
       */
      T,
      /**
       * @default 'Eighty-Eighth'
       */
      T,
      /**
       * @default 'Eighty-Ninth'
       */
      T,
      /**
       * @default 'Ninetieth'
       */
      T,
      /**
       * @default 'Ninety-First'
       */
      T,
      /**
       * @default 'Ninety-Second'
       */
      T,
      /**
       * @default 'Ninety-Third'
       */
      T,
      /**
       * @default 'Ninety-Fourth'
       */
      T,
      /**
       * @default 'Ninety-Fifth'
       */
      T,
      /**
       * @default 'Ninety-Sixth'
       */
      T,
      /**
       * @default 'Ninety-Seventh'
       */
      T,
      /**
       * @default 'Ninety-Eighth'
       */
      T,
      /**
       * @default 'Ninety-Ninth'
       */
      T,
    ];

    numericOrdinals: [
      /**
       * @default ''
       */
      T,
      /**
       * @default '1st'
       */
      T,
      /**
       * @default '2nd'
       */
      T,
      /**
       * @default '3rd'
       */
      T,
      /**
       * @default '4th'
       */
      T,
      /**
       * @default '5th'
       */
      T,
      /**
       * @default '6th'
       */
      T,
      /**
       * @default '7th'
       */
      T,
      /**
       * @default '8th'
       */
      T,
      /**
       * @default '9th'
       */
      T,
      /**
       * @default '10th'
       */
      T,
      /**
       * @default '11th'
       */
      T,
      /**
       * @default '12th'
       */
      T,
      /**
       * @default '13th'
       */
      T,
      /**
       * @default '14th'
       */
      T,
      /**
       * @default '15th'
       */
      T,
      /**
       * @default '16th'
       */
      T,
      /**
       * @default '17th'
       */
      T,
      /**
       * @default '18th'
       */
      T,
      /**
       * @default '19th'
       */
      T,
      /**
       * @default '20th'
       */
      T,
      /**
       * @default '21st'
       */
      T,
      /**
       * @default '22nd'
       */
      T,
      /**
       * @default '23rd'
       */
      T,
      /**
       * @default '24th'
       */
      T,
      /**
       * @default '25th'
       */
      T,
      /**
       * @default '26th'
       */
      T,
      /**
       * @default '27th'
       */
      T,
      /**
       * @default '28th'
       */
      T,
      /**
       * @default '29th'
       */
      T,
      /**
       * @default '30th'
       */
      T,
      /**
       * @default '31st'
       */
      T,
    ];
    timeOfDay: {
      /**
       * @default 'Midnight'
       */
      midnight: T;

      /**
       * @default 'Noon'
       */
      noon: T;

      /**
       * @default 'in the Morning'
       */
      morning: T;

      /**
       * @default 'in the Afternoon'
       */
      afternoon: T;

      /**
       * @default 'in the Evening'
       */
      evening: T;
    };
  };
  faq: {
    /**
     * @default 'Frequently Asked Questions'
     */
    title: T;

    /**
     * @default 'Take a look at our most commonly asked questions and answers. For additional support, chat with us.'
     */
    description: T;
  };
  quick: {
    /**
     * @default 'Remove from Favorites'
     */
    bzMSe: T;

    /**
     * @default 'Add to Favorites'
     */
    Dc77o: T;

    /**
     * @default 'Stationery'
     */
    khI0P: T;

    /**
     * @default 'Shipping Method'
     */
    xd9PF: T;

    /**
     * @default 'Taxes'
     */
    DvK9G: T;

    /**
     * @default 'Price Details'
     */
    PvAxL: T;

    /**
     * @default 'Billing Address'
     */
    tHIvo: T;

    /**
     * @default 'Need help with your order?'
     */
    dv5tV: T;

    /**
     * @default 'Contact Support'
     */
    TLnuy: T;

    /**
     * @default 'Card Back'
     */
    VLTu7: T;

    /**
     * @default 'Envelope Front'
     */
    DWGDD: T;

    /**
     * @default 'Envelope Back'
     */
    '9hn50': T;

    /**
     * @default 'Order Summary'
     */
    '8XV9D': T;

    /**
     * @default 'Back'
     */
    rXZKA: T;

    /**
     * @default 'Envelope'
     */
    cnOVq: T;

    /**
     * @default 'Sample Pack'
     */
    nxZHn: T;

    /**
     * @default 'Sales Tax'
     */
    pqyDA: T;

    /**
     * @default 'Total'
     */
    WdQBH: T;

    /**
     * @default 'Order Details'
     */
    AroHV: T;

    /**
     * @default 'Order Number'
     */
    PpyQe: T;

    /**
     * @default 'Order Placed'
     */
    P7nyi: T;

    /**
     * @default 'Refund is Being Processed'
     */
    hgJx3: T;

    /**
     * @default 'You will be refunded within 10 business days.'
     */
    iBWGc: T;

    /**
     * @default 'Shipping To'
     */
    '3jpC2': T;

    /**
     * @default 'Track Your Order'
     */
    CPJrN: T;

    /**
     * @default 'Order Again'
     */
    KF1rM: T;

    /**
     * @default 'Order Matching Digital Card'
     */
    zuyg4: T;

    /**
     * @default 'Order Cancelled'
     */
    FLc3T: T;

    /**
     * @default 'Your order has been successfully cancelled and your refund is being processed within 10 business days.'
     */
    hBEsO: T;

    /**
     * @default 'Your order has been cancelled and your refund has been successfully processed.'
     */
    FRaZV: T;

    /**
     * @default 'We're here to get you sorted.'
     */
    LtDgK: T;

    /**
     * @default 'Foil'
     */
    UxELA: T;

    /**
     * @default 'Gold'
     */
    aKOLA: T;

    /**
     * @default 'Rose Gold'
     */
    F912N: T;

    /**
     * @default 'Silver'
     */
    DL8LV: T;

    /**
     * @default 'Paper Type'
     */
    M3Fn0: T;

    /**
     * @default 'Signature'
     */
    MTnox: T;

    /**
     * @default 'Semi-Gloss'
     */
    DAAEs: T;

    /**
     * @default 'Smooth'
     */
    '0ZSgV': T;

    /**
     * @default 'Pearlescent'
     */
    '8t5mM': T;

    /**
     * @default 'Double Thick'
     */
    E133j: T;

    /**
     * @default 'Shape'
     */
    VQJ5G: T;

    /**
     * @default 'Rectangle'
     */
    LZbUv: T;

    /**
     * @default 'Rounded'
     */
    fLwj6: T;

    /**
     * @default 'Arch'
     */
    m0UKA: T;

    /**
     * @default 'Return Address'
     */
    aofaX: T;

    /**
     * @default 'Front'
     */
    '1CC4F': T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Recipient Addressing'
     */
    bMBSv: T;

    /**
     * @default 'Recipient Address'
     */
    HD8vL: T;

    /**
     * @default 'Have your guests’ addresses printed on the front of each envelope.'
     */
    On5OK: T;

    /**
     * @default 'Leave Blank'
     */
    f3Pd3: T;

    /**
     * @default 'Print Addresses'
     */
    tfbOC: T;

    /**
     * @default 'Free Card Back'
     */
    TN3z1: T;

    /**
     * @default 'Free'
     */
    wlFLA: T;

    /**
     * @default 'Delivery Methods'
     */
    '2dRly': T;

    /**
     * @default 'Delivery Method'
     */
    hKYRQ: T;

    /**
     * @default 'You'll be able to send your Digital Card via personalized email to your guests at the next step.'
     */
    '9J3Bv': T;

    /**
     * @default 'Shareable Card Link'
     */
    Py5Au: T;

    /**
     * @default 'Personalized Emails'
     */
    '72Pe9': T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Text messaging to USA and Canada'
     */
    WQ5yZ: T;

    /**
     * @default 'Text Messaging'
     */
    tN8eL: T;

    /**
     * @default 'International Text *'
     */
    jCsx2: T;

    /**
     * @default 'International Text Messaging'
     */
    VtmTy: T;

    /**
     * @default 'Classic Paper'
     */
    UV8gY: T;

    /**
     * @default 'Paper'
     */
    ebOpG: T;

    /**
     * @default 'Premium Digital'
     */
    '394Gz': T;

    /**
     * @default 'Premium Digital Cards'
     */
    yY852: T;

    /**
     * @default 'Digital'
     */
    gTn5B: T;

    /**
     * @default 'Napkins'
     */
    a76dt: T;

    /**
     * @default 'Napkin'
     */
    R2pTH: T;

    /**
     * @default 'Signs'
     */
    gSU5G: T;

    /**
     * @default 'Foam Board Signs'
     */
    dVjwr: T;

    /**
     * @default 'Basic Digital'
     */
    OpJEa: T;

    /**
     * @default 'Free Digital'
     */
    u9tRW: T;

    /**
     * @default 'Sample Kit'
     */
    '4NNPF': T;

    /**
     * @default 'FREE'
     */
    KQ6KA: T;

    /**
     * @default 'Our luxurious signature card stock has a velvety cotton texture and elegant eggshell finish.'
     */
    Ha5eU: T;

    /**
     * @default '120lb. / 324gsm'
     */
    Un4py: T;

    /**
     * @default 'Similar in feel to our signature stock, but with a smooth, matte finish. Recommended for photo cards.'
     */
    sXSEO: T;

    /**
     * @default 'Bright white with a semi-gloss finish. Recommended for photo cards.'
     */
    Xowfz: T;

    /**
     * @default '130lb. / 352gsm'
     */
    kIhL4: T;

    /**
     * @default 'Add an elegant iridescence to printed cards and a soft glow to photographs with Pearlescent paper.'
     */
    BDHx2: T;

    /**
     * @default '110lb. / 300gsm'
     */
    FJ9iE: T;

    /**
     * @default 'Twice as thick as our signature paper, with the same eggshell finish and velvety cotton texture.'
     */
    wNnxQ: T;

    /**
     * @default '240lb. / 648gsm'
     */
    We6Da: T;

    /**
     * @default 'Triple Thick'
     */
    ZPEBA: T;

    /**
     * @default 'Extra thick and luxurious, with the same eggshell finish and cottony texture as our signature paper.'
     */
    XysbF: T;

    /**
     * @default '360lb. / 972gsm'
     */
    '1WbfB': T;

    /**
     * @default 'Resolution'
     */
    WfjmS: T;

    /**
     * @default 'File size'
     */
    pXyNu: T;

    /**
     * @default 'Current'
     */
    v8RNJ: T;

    /**
     * @default 'Minimum'
     */
    I0fGp: T;

    /**
     * @default 'Optimal'
     */
    KG6kb: T;

    /**
     * @default 'Quantity'
     */
    tT8ln: T;

    /**
     * @default 'Ordered'
     */
    XvJlf: T;

    /**
     * @default 'Shipping to'
     */
    '50pC2': T;

    /**
     * @default 'Shipping Address'
     */
    UoPdP: T;

    /**
     * @default 'Review Your Design'
     */
    '3aYvF': T;

    /**
     * @default 'Submit Changes'
     */
    v9eid: T;

    /**
     * @default 'Standard DHL Shipping'
     */
    Rf64T: T;

    /**
     * @default 'Oops, we're experiencing some trouble!'
     */
    ApxzQ: T;

    /**
     * @default 'We're unable to process your order at this time. Our team will contact you shortly.'
     */
    Ba72G: T;

    /**
     * @default 'Go to Invitations'
     */
    '3Br2M': T;

    /**
     * @default 'Go to Save the Date'
     */
    NthuK: T;

    /**
     * @default 'Arrives in 3-4 business days'
     */
    '4euYd': T;

    /**
     * @default 'Promo Codes'
     */
    ZPI8O: T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Enter code'
     */
    RGHPh: T;

    /**
     * @default 'Apply'
     */
    YD1eF: T;

    /**
     * @default 'Please add your shipping details.'
     */
    '67hEG': T;

    /**
     * @default '{{0}} Cards'
     */
    '9OZ5h': T;

    /**
     * @default 'Upgrade to magnet (+ {{0}} per card)'
     */
    ciTUk: T;

    /**
     * @default 'Promo code {{0}} applied'
     */
    JxqRS: T;

    /**
     * @default 'Subtotal'
     */
    '2Ys37': T;

    /**
     * @default 'Shipping Details'
     */
    '2tfOM': T;

    /**
     * @default 'We currently support only addresses in the US.'
     */
    '9Nl5u': T;

    /**
     * @default 'Add Shipping Details'
     */
    Z86pJ: T;

    /**
     * @default 'Tariffs may apply.'
     */
    '2SADl': T;

    /**
     * @default 'See how we help.'
     */
    YdAck: T;

    /**
     * @default 'Go to Checkout'
     */
    jKEaO: T;

    /**
     * @default 'Includes:'
     */
    l0PnF: T;

    /**
     * @default 'The Suite Includes:'
     */
    aj2of: T;

    /**
     * @default 'Card Details'
     */
    '6XHhW': T;

    /**
     * @default 'Fill out the form below to provide details, so the design concierge team can create the first draft of your card.'
     */
    '0hYFR': T;

    /**
     * @default 'We'll send you the link to fill out the form and provide details, so the design concierge team can create the first draft of your card.'
     */
    '3X9pb': T;

    /**
     * @default 'Design Preview'
     */
    CN79V: T;

    /**
     * @default 'Design concierge team begins working on your customized design based on the information you provided in the form.'
     */
    t44Mz: T;

    /**
     * @default 'Feedback & Changes'
     */
    M69BE: T;

    /**
     * @default 'You'll receive a link via email to provide your feedback and work with your designer to get the cards just the way you want them!'
     */
    jyAHY: T;

    /**
     * @default 'Printing'
     */
    '3qcVc': T;

    /**
     * @default 'Only when you're fully satisfied with the designs, we'll send them to be printed.'
     */
    '43p2D': T;

    /**
     * @default 'What's next?'
     */
    YycnG: T;

    /**
     * @default 'Provide Card Details'
     */
    '3beEo': T;

    /**
     * @default 'Home'
     */
    lgXLA: T;

    /**
     * @default 'Save the Date Cards'
     */
    TUy1R: T;

    /**
     * @default 'Beautifully designed, unbelievably joyful to send. Every design is available as both an elegant paper card and a convenient digital Save the Date, so you can announce your day, your way.'
     */
    lhmdf: T;

    /**
     * @default 'You don't have any drafts just yet!'
     */
    wpHDG: T;

    /**
     * @default 'Paper Stationery Ordered'
     */
    dxBkf: T;

    /**
     * @default 'Digital Stationery Sent'
     */
    UdQCK: T;

    /**
     * @default 'Your Orders'
     */
    mSB9C: T;

    /**
     * @default 'You don't have any orders just yet!'
     */
    fdQtN: T;

    /**
     * @default 'Once you're ready to place your order, you'll be able to find it here and track its progress.'
     */
    bOxPe: T;

    /**
     * @default 'Orientation'
     */
    ESFJe: T;

    /**
     * @default 'From'
     */
    OrFLA: T;

    /**
     * @default 'Product'
     */
    dGAik: T;

    /**
     * @default 'From {{0}}'
     */
    SXEqF: T;

    /**
     * @default 'Size'
     */
    DwANA: T;

    /**
     * @default 'Cocktail'
     */
    '2mIap': T;

    /**
     * @default 'Luncheon'
     */
    Usg2n: T;

    /**
     * @default 'Your Venue'
     */
    sPB4Q: T;

    /**
     * @default 'Edit Envelope'
     */
    OzRDL: T;

    /**
     * @default 'Envelope Color'
     */
    r5rxC: T;

    /**
     * @default 'Reveal Animation'
     */
    tr6oI: T;

    /**
     * @default 'Bring joy to your guests when they open the card from you.'
     */
    FcbyA: T;

    /**
     * @default 'Smart Tip'
     */
    MOPzc: T;

    /**
     * @default 'Your Favorites'
     */
    '81c8y': T;

    /**
     * @default 'Review'
     */
    CCTPS: T;

    /**
     * @default 'When should we send Save the Dates for our wedding?'
     */
    '4TDJF': T;

    /**
     * @default 'Save the Dates are an important part of wedding planning, providing your guests with early notice of your wedding date so they can plan accordingly. For weddings where most of your guests are local, sending Save the Dates 4-6 months before your wedding is typically sufficient. This timing gives guests enough notice to mark their calendars and make any necessary arrangements. If you're hosting a destination wedding, it's best to send Save the Dates at least 9 months before the big day. This extra time allows your guests to arrange travel, accommodations, and time off from work if needed. Early notifications are especially crucial for guests who will need to book flights and hotels in advance.'
     */
    pEIGV: T;

    /**
     * @default 'Whose name goes first on Save the Date?'
     */
    '7y2NS': T;

    /**
     * @default 'Traditionally, the bride's name is listed first on Save the Dates and wedding invitations. This custom is rooted in traditional etiquette where the bride's family would be the primary hosts of the wedding. However, in modern times, many couples choose to list their names in the order that feels right to them. Whether you decide to list the bride's name first or the couple's names in alphabetical order, the most important aspect is that the Save the Date clearly communicates the essential information about your wedding.'
     */
    mo9l9: T;

    /**
     * @default 'What information should we include on Save the Dates?'
     */
    ymStW: T;

    /**
     * @default 'The purpose of Save the Dates is to provide your guests with preliminary information about your wedding. The key details to include are your names, the wedding date, and the location (city or area). Since Save the Dates are less formal than the official wedding invitations, you don't need to include as much detail. It's also a good idea to mention that formal invitations will follow with more comprehensive information. Including your wedding website URL on the Save the Date can be very helpful. This allows guests to access additional information, such as travel details, accommodation options, and updates about your wedding.'
     */
    jsSNH: T;

    /**
     * @default 'Is it okay to just send online Save the Dates?'
     */
    NUAgM: T;

    /**
     * @default 'Yes, sending digital Save the Dates is a perfectly acceptable and increasingly popular option. Digital Save the Dates are cost-effective, environmentally friendly, and convenient. They can also help streamline your wedding planning process by linking directly to your wedding website, where guests can RSVP and access further details. However, keep in mind that some guests, especially those who are less tech-savvy, might need a reminder to check their email. To ensure that everyone receives your Save the Date, consider sending a follow-up message or providing an alternate way for guests to confirm receipt.'
     */
    x4Yxg: T;

    /**
     * @default 'Do we need to follow a specific design or style for Save the Dates?'
     */
    '9nrkM': T;

    /**
     * @default 'There is no strict rule regarding the design or style of Save the Dates. The design should reflect your personal taste and the theme of your wedding. Save the Dates can be formal, casual, whimsical, or traditional, depending on your preference. Many couples choose designs that align with their wedding theme or that give guests a sneak peek of the style and tone of the event. Whether you opt for a minimalist design, a vibrant photo, or a classic script, the goal is to convey the essential information while giving your guests a hint of what's to come.'
     */
    EYhhy: T;

    /**
     * @default 'Do I put my wedding website URL on Save the Dates?'
     */
    '00p20': T;

    /**
     * @default 'Though not required, it's certainly helpful. Because Save the Dates should be sent out 4 to 6 months before your wedding day, and are considered less formal than printed wedding invitations, it's best you complete your wedding website by that time. This way, you can add the URL to your Save the Dates and give your guests plenty of time to absorb all your wedding details.'
     */
    gvWEl: T;

    /**
     * @default 'Can we include photos on our Save the Dates?'
     */
    qUgkS: T;

    /**
     * @default 'Including a photo on your Save the Date can add a personal touch and make the announcement more memorable. Many couples choose to feature an engagement photo or a favorite picture that represents their relationship. Photos can make your Save the Date stand out and give guests a glimpse of the couple they're celebrating. If you decide to include a photo, ensure it complements the design and doesn't overwhelm the important details. A well-chosen photo can enhance the overall aesthetic and make your Save the Date more engaging.'
     */
    bw1Jo: T;

    /**
     * @default 'How do I word my Save the Date?'
     */
    xKhHH: T;

    /**
     * @default 'The wording of your Save the Date should be clear and concise, focusing on the essential information. A simple example of Save the Date wording might be, "Save the Date: [Your Names], [Wedding Date], [Location]. Formal invitation to follow." You can also add a personal touch by including a brief message or quote that reflects your personality. The key is to provide your guests with the crucial details while keeping the tone of the message in line with the style of your wedding.'
     */
    KSXpJ: T;

    /**
     * @default 'Do Save the Dates and invitations have to match?'
     */
    SaP9k: T;

    /**
     * @default 'While it's not necessary for Save the Dates and invitations to match exactly, having a cohesive look can be visually appealing. Many couples choose to align the design elements of their Save the Dates with their wedding invitations to create a consistent theme. However, it's perfectly fine to have different designs as long as they complement each other. The important thing is that both pieces of correspondence clearly convey the necessary information and reflect your wedding style.'
     */
    zmL7J: T;

    /**
     * @default 'What size should the Save the Date card be?'
     */
    HbV1p: T;

    /**
     * @default 'Save the Date cards typically come in standard sizes such as 5x7 inches, which is a common and practical size for mailing. However, you have the flexibility to choose a size that suits your design and budget. Smaller sizes like 4x6 inches or larger formats like 6x8 inches are also options depending on how you want to present your Save the Date. Make sure the size you choose aligns with your overall design and is easy for your guests to handle and store.'
     */
    '0IBz1': T;

    /**
     * @default 'How do I collect addresses for my Save the Dates?'
     */
    fk5E6: T;

    /**
     * @default 'Joy's built-in Contact Collector makes it easy to gather all your guests' contact information in your guest list. Simply share your magic link with guests, they fill out a quick form, and your guest list grows automagically. Every Joy Save the Date includes free recipient and return address printing that integrates seamlessly with your contact list.'
     */
    VUaSa: T;

    /**
     * @default 'Are Save the Dates necessary?'
     */
    Ry8NL: T;

    /**
     * @default 'While it's ultimately your decision, we highly recommend that Save the Dates are a part of your suite of wedding announcements. This way, you'll ensure your guests have access to the who, what, where, and when of your wedding as soon as you've determined these details. Plus, by including your wedding website link on your Save the Dates, you'll enable your guests to learn more about the wedding and RSVP online.'
     */
    hvfa2: T;

    /**
     * @default 'Can you do Save the Dates and invitations together?'
     */
    '9JT1G': T;

    /**
     * @default 'Yes, coordinating your Save the Dates and invitations can create a unified look for your wedding announcements. Many couples choose to use matching or complementary designs for both Save the Dates and invitations to maintain consistency. This approach helps to set the tone for the wedding and provides a cohesive visual experience for your guests. You can work with the same designer or template provider to ensure that your Save the Dates and invitations align seamlessly.'
     */
    uTQAX: T;

    /**
     * @default 'Why choose Joy's Wedding Save the Dates'
     */
    anpBS: T;

    /**
     * @default 'Choosing the right Save the Date template is an essential step in your wedding planning process. It sets the stage for the rest of your wedding communications and provides your guests with the first glimpse of what's to come. Joy offers a wide range of Save the Date templates that cater to various styles and preferences. Whether you're envisioning a rustic countryside wedding, a glamorous city celebration, or a laid-back beach event, Joy has a template that fits your theme. Joy's Save the Date templates are designed with both style and functionality in mind. You can select from hundreds of beautifully crafted designs, each offering unique elements that can be customized to suit your wedding theme. From elegant calligraphy to playful illustrations, Joy provides options that cater to every taste. Additionally, Joy allows you to incorporate your favorite photos into the design, adding a personal touch that makes your Save the Date even more special.'
     */
    '2UCSs': T;

    /**
     * @default 'What does Joy cost?'
     */
    XdzGD: T;

    /**
     * @default 'Joy wedding websites, planning tools, registry, and online RSVP are free! Paper wedding invitations come in a range of price and style options, and all include free back-of-card printing and free recipient and return address printing. On a tight budget? Mix and match Joy's digital and paper cards to save money on paper and postage. Hundreds of digital wedding invitation designs are available to send for free.'
     */
    N01u2: T;

    /**
     * @default 'Do you have a support team we can reach out to if we have questions?'
     */
    oJWCM: T;

    /**
     * @default 'Absolutely! Our amazing support team works hard around the clock, every day of the week, including weekends, to make sure that your questions are answered. You can send us an email at support@withjoy.com.'
     */
    mtFCe: T;

    /**
     * @default 'Are Save the Date magnets essential?'
     */
    '2T51B': T;

    /**
     * @default 'Save the Date magnets are not strictly necessary, and they can be more expensive than traditional paper cards. If you're on a tighter budget, it's perfectly fine to opt for paper Save the Dates instead. Most guests won't mind whether it's a magnet or paper; the key is ensuring the Save the Date reflects your style and provides the essential wedding details.'
     */
    jPt2u: T;

    /**
     * @default 'Do you send save-the-dates to everyone?'
     */
    '4yWLj': T;

    /**
     * @default 'You should only send save-the-dates to individuals you plan to invite to your wedding. Anyone who receives a save-the-date should also be sent a wedding invitation.'
     */
    Y1ZPs: T;

    /**
     * @default 'Read Less'
     */
    DQaLg: T;

    /**
     * @default 'Read More'
     */
    jamLg: T;

    /**
     * @default 'Announce Your Wedding Date with a Save the Date Card from Joy'
     */
    XvIZo: T;

    /**
     * @default 'Whether you mail Save the Dates or send them digitally, we'll ensure a seamless stationery experience'
     */
    FYCDS: T;

    /**
     * @default 'A Save the Date card does more than just claim your wedding date. It frames a momentous occasion, announces an exciting first step towards the aisle, and should set the tone for your big day to come. Reflecting your personality and offering a glimpse of how your celebration will look and feel.'
     */
    RScBw: T;

    /**
     * @default 'We believe Save the Date cards are so much more than a formality. Which is why we've created a way for you to design yours easily, and quickly online. Whether you choose to craft from scratch, or tailor one of our expertly designed templates. Joy will help you build the anticipation for your wedding, and reflect your unique love story.'
     */
    EGXNt: T;

    /**
     * @default 'The Benefits of Save the Dates'
     */
    dH0PY: T;

    /**
     * @default 'Undecided on Save the Dates at this stage? We're not here to convince you, but we'd love to share a few benefits of sending out Save the Dates that we think you'll find useful.'
     */
    '0Ewvz': T;

    /**
     * @default 'Save Money'
     */
    lpzDJ: T;

    /**
     * @default 'Weddings are costly affairs, and unfortunately, not every desire can be fulfilled. But there's no need to skip on things like Save the Dates when they can be created and sent for free online!'
     */
    JarIU: T;

    /**
     * @default 'Helps Build Your Budget'
     */
    IT9qh: T;

    /**
     * @default 'Creating a realistic budget as early in the wedding planning process as possible is key to not overspending. Save the Dates play a pivotal role in gathering information, helping you to quickly understand the guest count you're working with.'
     */
    '0TEMu': T;

    /**
     * @default 'Our connected online RSVP allows you to effortlessly gather details from guests, whether it's an attendance yes/no or something more specific. All of which is then automatically stored in your private online guest list. An invaluable resource at every stage of the wedding planning journey.'
     */
    DX2xH: T;

    /**
     * @default 'Ensure Guests are Available'
     */
    QLVnv: T;

    /**
     * @default 'This point is often easily overlooked, but if your wedding falls during a popular month for celebrations or vacations, you need guests to mark your date on their calendars ASAP. To avoid any clashes or disappointing no shows.'
     */
    mBNnp: T;

    /**
     * @default 'Guest availability is even more critical if you're planning a destination wedding, as guests will need more time to prepare for the travel and cost of attending your celebration.'
     */
    aInJN: T;

    /**
     * @default 'Showcase Your Wedding Theme'
     */
    pK7Cx: T;

    /**
     * @default 'Our couples like to think of Save the Dates as previews of their overall wedding theme. A little taster of what's to come on the big day, and a cohesive element in their wedding stationery suite.'
     */
    yzlPN: T;

    /**
     * @default 'When you choose a Joy save-the-date template, we don't just offer the card design—we gift you the entire package. You'll receive a wedding website, save-the-date, invitation, and printed materials, all designed with one coordinated theme. This ensures every detail of your wedding feels polished and cohesive, with a strong, consistent theme. Everything is crafted using high-quality designs to make your wedding experience even more memorable.'
     */
    '9jdhy': T;

    /**
     * @default 'Customize and Personalize Your Save the Date Cards With Joy'
     */
    '4lR1N': T;

    /**
     * @default 'Joy makes it so easy to curate a wedding suite, complete with a stunning Save the Date that reflects your love story.'
     */
    h7K3F: T;

    /**
     * @default 'Start with Personality'
     */
    '6bgoW': T;

    /**
     * @default 'We make the art of Save the Date designing effortless and fun, by giving you the power to personalize as you wish. In just a couple of clicks you can transform one of our chic templates, or a blank page, into a unique Save the Date card that truly reflects your special day.'
     */
    dAMhq: T;

    /**
     * @default 'You are free to experiment with fonts, colors, and the design of our templates to build something that feels yours. While also excitedly hinting at the overall wedding theme.'
     */
    MFt6B: T;

    /**
     * @default 'Share Your Engagement Photos'
     */
    Cwqmg: T;

    /**
     * @default 'What better way to share your wonderful engagement photos than on your Save the Dates! You'll of course be featuring them on your wedding website, and perhaps on the big day itself. But Save the Dates offer the best opportunity to showcase your favorite image from the shoot, and really celebrate how amazing you guys look together!'
     */
    GrMN5: T;

    /**
     * @default 'You are free to upload your engagement photography to our Save the Date builder, and help give any of our templates a more unique, personal touch. Whether it's a candid snap taken in the moment, or something more professional. Placing your chosen picture within your Save the Dates will help to make the announcement feel even more significant.'
     */
    JAGqe: T;

    /**
     * @default 'Why Choose Joy for Your Wedding Save-the-Date Cards'
     */
    kA10G: T;

    /**
     * @default 'WithJoy gives you the ability to create Save the Dates at your convenience, and then track them every step of the way.'
     */
    OWB9Z: T;

    /**
     * @default 'Seamless Save the Date Integration'
     */
    PYKRv: T;

    /**
     * @default 'Our Save the Date templates are not standalone pieces, they are designed as part of a wedding stationery suite. Meaning your wedding website, invitation (digital and physical) and your Save the Date card will all be coordinated.'
     */
    drxo9: T;

    /**
     * @default 'This coordination goes beyond aesthetics, as our Save the Date cards and invitations can be integrated within your wedding website. Giving you the ability to request RSVPs online, and additional details from your guests before even sending out the wedding invitations. This is incredibly useful if you don't have addresses for all of your guests, or require information that'll directly affect your wedding plans.'
     */
    P6B0a: T;

    /**
     * @default 'Having your Save the Date linked to your wedding website also allows you to share information about your wedding day along the way. Ensuring guests are always up-to-date with your event as it evolves.'
     */
    azInN: T;

    /**
     * @default 'Joy is free to use!'
     */
    j37Cz: T;

    /**
     * @default 'We're committed to helping couples plan their best day, and we know how quickly wedding costs can add up. That's why Joy offers free wedding websites, planning tools, guest list management, and digital save the dates—so you can simplify planning without added expense. And when you're ready to elevate the experience, you can explore our premium digital invitations and printed stationery, designed to make a lasting impression.'
     */
    XUmM5: T;

    /**
     * @default 'Announce Your Wedding Date Today with Joy!'
     */
    Qh4J3: T;

    /**
     * @default 'Explore how Joy can help you create the perfect save-the-date card—and so much more—by browsing our free templates today. Whether you're drawn to minimalistic designs, like our modern minimalist save-the-date card, or something with a more intricate touch, you're sure to find a style that suits your theme and reflects your shared personality. And if not, we've made it easy to start with a blank page and turn it into something uniquely yours.'
     */
    wtpqK: T;

    /**
     * @default 'So whether you're selecting foil color, letterpress, or a matte finish monogram, you can create beautiful save-the-dates that effortlessly match your wedding day. After all, save-the-dates are not just a formality; they are the beginning of your story. Start telling yours with Joy today.'
     */
    '7ZBes': T;

    /**
     * @default 'Alex & Zack'
     */
    BaX4J: T;

    /**
     * @default 'Brooklyn, NY'
     */
    xlnEk: T;

    /**
     * @default 'Just wanted to follow up to thank the entire team for creating the most beautiful save the dates! We put them in the mail yesterday and they looked amazing. I don't have Reddit, but I've been telling all my friends how amazing things turned out and how great the customer service is.'
     */
    fkQQZ: T;

    /**
     * @default 'Sophia & Jimmy'
     */
    '6bLCV': T;

    /**
     * @default 'Pasadena, CA'
     */
    fl8TM: T;

    /**
     * @default 'The card team from Joy is incredible! When our initial Thank You card order was not what we expected, we communicated our concerns with the team. The team worked with us daily to reach a resolution that not only worked but exceeded our expectations. We are so grateful to have worked with the card team to put a beautiful bow of thanks on our wedding.'
     */
    ABUMI: T;

    /**
     * @default 'Guadalupe & Andy'
     */
    ErhLR: T;

    /**
     * @default 'Chicago, IL'
     */
    zCQUg: T;

    /**
     * @default 'We chose Joy for our destination wedding because it was super easy to use and offered all the features we needed. Planning a wedding away from home was a big task, but Joy made it a easy! Our favorite features were definitely the guest list and schedule options – they kept us on track and stress-free!'
     */
    '7UQJL': T;

    /**
     * @default 'Unknown'
     */
    YqNpa: T;

    /**
     * @default 'Queued'
     */
    '5wM0Q': T;

    /**
     * @default 'Sent'
     */
    oh9MA: T;

    /**
     * @default 'Failed'
     */
    Bc7Gw: T;

    /**
     * @default 'Delivered'
     */
    SbKKi: T;

    /**
     * @default 'Viewed'
     */
    CthHd: T;

    /**
     * @default 'Imported Address'
     */
    kxUp0: T;

    /**
     * @default 'We found this address in your guest’s details. It’s for reference only, please enter the formatted address below for printing.'
     */
    ZfLtT: T;

    /**
     * @default 'Heads up:'
     */
    w0fIY: T;

    /**
     * @default 'Carriers sometimes experience delays or show limited tracking updates during transit, especially during busy seasons. Your tracking link always reflects the most current information available.'
     */
    kbA8l: T;

    /**
     * @default '✨ Holiday shipping can get busy, but we’ve got you covered. Order soon for the most reliable delivery timing.'
     */
    '3r5HY': T;

    /**
     * @default 'Personalization with Joy concierge design services'
     */
    '5YRkd': T;

    /**
     * @default 'Recipient and return address printing'
     */
    '9xxLs': T;

    /**
     * @default 'Photographed design suggestions such as ribbons, wax seals, string, etc are not included unless specifically stated'
     */
    naVuw: T;

    /**
     * @default 'The {{0}} invitation blends soft duck-egg blue artwork and classic typography for a refined, romantic look.'
     */
    '6RWgi': T;

    /**
     * @default 'Three-panel, arch-top trifold keeps your invitation, details and RSVP neatly in one all-in-one format.'
     */
    WxDjN: T;

    /**
     * @default 'Printed on 300 gsm Matte Paper for a smooth, luxurious feel and crisp, high-quality reproduction of the design.'
     */
    '8o42K': T;

    /**
     * @default 'Includes a complimentary envelope in your choice of Almond or Desert Blue to complete the suite.'
     */
    SBWrb: T;

    /**
     * @default 'Trifold wedding invitation card, 5" x 16" (5" x 7" folded) on 300 GSM almond colored paper.'
     */
    Q0Ulh: T;

    /**
     * @default 'Premium almond or desert blue color envelopes.'
     */
    IGtXT: T;

    /**
     * @default 'Immerse yourself in the timeless allure of the {{0}} invitation set'
     */
    tsw82: T;

    /**
     * @default 'Customize the information card with the option to add your website or RSVP QR code'
     */
    YTIyT: T;

    /**
     * @default 'Each invitation is encased in a transparent delicate floral print vellum bellyband'
     */
    '3tLSi': T;

    /**
     * @default 'Gold foil invitation card, 5”x 7“ on premium 380GSM paper'
     */
    EdX1t: T;

    /**
     * @default 'Details card, 4.2” x 5.5” on premium 380GSM paper'
     */
    UuyeT: T;

    /**
     * @default 'Vellum bellyband 80GSM '
     */
    zfXyt: T;

    /**
     * @default 'Premium white envelope'
     */
    KCYZS: T;

    /**
     * @default 'Timeless photo gatefold invitation includes all the information for guests on one folded invitation'
     */
    Wy3NG: T;

    /**
     * @default 'This bundle includes a delicate vellum bellyband to wrap around your invitations for a finished look'
     */
    T042S: T;

    /**
     * @default 'Wax seals are not included, but can easily be purchased from suggested vendors'
     */
    zq8Sv: T;

    /**
     * @default 'Photo gatefold wedding invitation card, 10” x 7” on 380 GSM premium paper'
     */
    JsDwW: T;

    /**
     * @default 'Vellum bellyband 80GSM'
     */
    JMybF: T;

    /**
     * @default 'Eye catching modern suite printed on shimmery metallic paper for a subtle glow'
     */
    zEB9O: T;

    /**
     * @default 'Matching arch shaped wedding information card that fits perfectly with the main invitation'
     */
    '4WKhD': T;

    /**
     * @default 'A small landscape arch RSVP card, with the option to add your wedding website QR code'
     */
    StICn: T;

    /**
     * @default 'Wedding invitation card, 5” x 7” arch on 300 GSM metallic paper'
     */
    pxfmH: T;

    /**
     * @default 'Details card, 5.8” x 3.7” arch on 300 GSM metallic paper'
     */
    hWrXC: T;

    /**
     * @default 'RSVP card, 4.2” x 2.1” landscape arch on 300 GSM metallic paper'
     */
    bQ2XD: T;

    /**
     * @default 'Premium almond color envelope'
     */
    rOaaN: T;

    /**
     * @default 'Deep forest colors combined with elegant neutrals combine for a refined but natural look'
     */
    '3gOlE': T;

    /**
     * @default 'Each set comes with gold paper clips to keep all your cards together'
     */
    '6rxuv': T;

    /**
     * @default 'Includes premium almond color envelopes included'
     */
    F8BxQ: T;

    /**
     * @default 'Wedding invitation card, 5” x 7” arch on Forest Green 300GSM paper with white ink'
     */
    tJ0Q3: T;

    /**
     * @default 'Details card, 4.2” x 5.5” curved edge on 300 GSM Almond Paper'
     */
    mATaz: T;

    /**
     * @default 'RSVP card, 4.2” x 2.1” land scape arch on 300GSM paper'
     */
    K9IGe: T;

    /**
     * @default 'Premium Almond Envelope'
     */
    OLGV9: T;

    /**
     * @default 'Gold color paper clip'
     */
    tsQ2O: T;

    /**
     * @default 'Earthy tone invitation package perfect for those wanting neutral colors'
     */
    WTzEf: T;

    /**
     * @default 'The wedding details card features two-tone front and back with for wedding details and RSVP information'
     */
    t7Nw5: T;

    /**
     * @default 'Wedding invitation card, 5” x 7”, on 300GSM cotton'
     */
    XbXX4: T;

    /**
     * @default 'Wedding details card, 5” x 7” half arch on 300 GSM almond paper'
     */
    '3uL1R': T;

    /**
     * @default 'Bellyband 120 GSM matte'
     */
    onchm: T;

    /**
     * @default 'Premium almond color envelopes with options to select to grey, or harvest'
     */
    xSdf3: T;

    /**
     * @default 'The {{0}} gatefold invitation is for those flower and nature lovers, sure to set the tone for your special day'
     */
    SrI5H: T;

    /**
     * @default 'This all-in-one wedding invitation includes all your wedding day finer details and RSVP information'
     */
    '8GsfW': T;

    /**
     * @default 'Gatefold wedding invitation card, 10” x 7” on 380GSM premium paper'
     */
    '1bRSM': T;

    /**
     * @default 'Premium envelopes in forest green or peach'
     */
    '9g0s8': T;

    /**
     * @default 'This set includes arch shaped invitations printed on beautiful cotton paper'
     */
    jDxzG: T;

    /**
     * @default 'Matching double-sided information card to include all your wedding day details'
     */
    dktJD: T;

    /**
     * @default 'A small landscape arch shape RSVP card, with the option to add your wedding website QR code,'
     */
    jjMvW: T;

    /**
     * @default 'Premium black color envelopes included'
     */
    oALCX: T;

    /**
     * @default 'Wedding invitation card, 5” x 7” arch on premium 300 GSM cotten paper'
     */
    '8eD5W': T;

    /**
     * @default 'Details card,  4.2” x 5.5” rounded edge on 300 GSM almond paper'
     */
    W0fQ7: T;

    /**
     * @default 'RSVP card, 4.2” x 2.1” landscape arch on 270 GSM black paper with white ink'
     */
    sB6g1: T;

    /**
     * @default 'Premium black envelopes with white ink'
     */
    wQrYv: T;

    /**
     * @default 'The {{0}} set is a perfect balance between wedding neutrals and greenery. With stunning script fonts and quality print and paper, this layered invitation set is bound to set the tone for your big d'
     */
    Pquv8: T;

    /**
     * @default 'Matching double-sided information card that is big enough for all your wedding details'
     */
    iDjKU: T;

    /**
     * @default 'Small green name card that can be used as a guest name card to tie in a hint of green to this suit'
     */
    iK6PH: T;

    /**
     * @default 'Wedding invitation card, 5”x7” arch on Premium 300 GSM Cotten Paper'
     */
    '8wCiR': T;

    /**
     * @default 'Details card,  4.2” x 5.5” half arch on 300 GSM cotton paper'
     */
    l8J7H: T;

    /**
     * @default 'Guest name card,  3.1” x 3.7”'
     */
    hV1Mw: T;

    /**
     * @default 'Premium grey envelopes'
     */
    TKwBb: T;

    /**
     * @default 'The {{0}} invitations are a perfect way to send your guests all the info they need for the day'
     */
    JG0NA: T;

    /**
     * @default 'High quality photo printing on the outside'
     */
    xeLr3: T;

    /**
     * @default 'The inside of this all in one gatefold invitation includes all your wedding day finer details, RSVP, and wedding timeline'
     */
    VtDVp: T;

    /**
     * @default 'Harvest color envelopes included with each invitation'
     */
    Ly6np: T;

    /**
     * @default 'Gatefold Wedding Invitation, 10” x 7” on premium 380 GSM paper'
     */
    HBpMP: T;

    /**
     * @default 'Premium harvest color envelopes'
     */
    O5okN: T;

    /**
     * @default 'The {{0}} all-in-one Gatefold design is a combination of curvy die-cut and elegant typography'
     */
    '6VeR2': T;

    /**
     * @default 'This all-in-one wedding invitation with high quality photo printing includes all your wedding day finer details and RSVP information in one elegant card'
     */
    nzdex: T;

    /**
     * @default 'Gatefold Wedding Invitation, 11.8” x 7” side wave on premium 380 GSM paper'
     */
    '2dTE9': T;

    /**
     * @default 'All your invitation, RSVP, and wedding details in one gatefold card'
     */
    EAMyA: T;

    /**
     * @default 'Customize with your own photo on the inside'
     */
    IBcGq: T;

    /**
     * @default 'Premium almond color envelopes'
     */
    MrXZS: T;

    /**
     * @default 'The {{0}} Gatefold design is a combination of curvy die-cut and elegant typography'
     */
    OXDlh: T;

    /**
     * @default 'This all-in-one wedding invitation includes all your wedding day finer details and RSVP information in one elegant card'
     */
    xddMX: T;

    /**
     * @default 'Printed in white ink on rich and vibrant Forest Green paper'
     */
    gQYfl: T;

    /**
     * @default 'Gatefold Wedding Invitation, 11.8” x 7” side wave on premium 300 GSM paper'
     */
    oo6a0: T;

    /**
     * @default 'The {{0}} gatefold invitation is perfect for flower lovers and sure to set the tone for your special day'
     */
    LOide: T;

    /**
     * @default 'Gatefold wedding invitation card, 10” x 7” on 380 GSM premium paper'
     */
    f8fig: T;

    /**
     * @default 'Kraft bellyband, 10.5” x 2” 80 GSM'
     */
    sq0C1: T;

    /**
     * @default 'The {{0}} gatefold invitation is for flower and nature lovers, sure to set the tone for your special day'
     */
    Z4chh: T;

    /**
     * @default 'This all-in-one wedding invitation includes space for all your wedding day detail, RSVP, and wedding day timeline information'
     */
    LK7Kt: T;

    /**
     * @default 'Delicate Leaves envelope liners'
     */
    eONuk: T;

    /**
     * @default 'Immerse yourself in the timeless allure of this {{0}} invitation set with foil-printing'
     */
    '2wNMW': T;

    /**
     * @default 'Paired with a delicate transparent vellum info card'
     */
    y4UFR: T;

    /**
     * @default 'Wedding invitation card, 5” x 7”, on 380 GSM premium paper'
     */
    rTygE: T;

    /**
     * @default 'Details card, 4.2” x 5.5,” on 180 GSM Vellum with white ink'
     */
    jgBu3: T;

    /**
     * @default 'A unique arch-shaped trifold with elegant typography and space for all your wedding details'
     */
    tq9xD: T;

    /**
     * @default 'This all-in-one wedding invitation includes a detachable RSVP card'
     */
    BQrZK: T;

    /**
     * @default 'Trifold wedding invitation card, 5” x 16.5” (5” x 7” folded) on 300 GSM almond colored paper'
     */
    '3nK45': T;

    /**
     * @default 'Vibrant red and blush tones invitation suite is perfect for those wanting a pop of color'
     */
    Th1eF: T;

    /**
     * @default 'This set includes a wedding invitation, wedding info card with RSVP details, and an extra card on top customized with a favorite quote or your names'
     */
    UlZZx: T;

    /**
     * @default 'Wedding invitation card, 5” x 7” on Blush 300 GSM paper'
     */
    gWFKC: T;

    /**
     * @default 'Details and RSVP card, 4.3” x 7” side wave edge on Red 270 GSM paper with white ink'
     */
    YmslB: T;

    /**
     * @default 'Top card, 3.7” x 7” side wave edge on 300 GSM cotton paper'
     */
    '1K5Jj': T;

    /**
     * @default 'Premium white envelopes'
     */
    JE21w: T;

    /**
     * @default 'Rich browns and creams combine in this earth-toned invitation suite perfect for a neutral color palette'
     */
    zakm4: T;

    /**
     * @default 'Share the event details and  timeline with your guests across three layers of cards'
     */
    jPjwf: T;

    /**
     * @default 'Wedding invitation card, 5” x 7” on 300 GSM harvest color paper with white ink'
     */
    BQdil: T;

    /**
     * @default 'Program card,  4.3” x 7” side arch on 300 GSM almond color paper'
     */
    Cd6f9: T;

    /**
     * @default 'Info and RSVP card, 3.7” x 5.8” side arch on 300 GSM cotton paper'
     */
    gpWTt: T;

    /**
     * @default 'The {{0}} set is a perfect balance between wedding neutrals and greenery. With stunning script fonts and quality print and paper, this layered invitation set is bound to set the tone for your big day'
     */
    XDrZ0: T;

    /**
     * @default 'Matching double-sided information card that is big enough for all your wedding and RSVP details'
     */
    gnvn4: T;

    /**
     * @default 'Small grey name card that can be used as a guest name card and as a place card for your on-the-day stationery'
     */
    VPzif: T;

    /**
     * @default 'Wedding invitation card, 5” x 7” arch on premium 300 GSM seedling color paper with white ink'
     */
    CXp9B: T;

    /**
     * @default 'Details card,  3.7” x 5.7” arch on 300 GSM almond color paper'
     */
    JBydT: T;

    /**
     * @default 'Guest name card,  3.1” x 3.7” half arch on 300 GSM grey color paper with white ink'
     */
    omjmB: T;

    /**
     * @default 'Premium seedling green color envelopes'
     */
    T29Si: T;

    /**
     * @default 'Immerse yourself in the timeless allure of this {{0}} invitation suite with gold foil lettering'
     */
    OByO6: T;

    /**
     * @default 'Opt for blush RSVP post-cards with your address or share a QR code for digital RSVP'
     */
    ZxCz9: T;

    /**
     * @default 'An information card in an elegant shade of grey for all the finer details'
     */
    RuPo3: T;

    /**
     * @default 'A matching foil printed bellyband to tie it all together'
     */
    W4oMV: T;

    /**
     * @default 'Wedding invitation card, 5” x 7” on premium 380 GSM paper with gold foil'
     */
    '9CxUx': T;

    /**
     * @default 'Details card,  4.2” x 5.5” on 300 GSM grey color paper'
     */
    HmTr8: T;

    /**
     * @default 'RSVP card,  5.5” x 4.2” on 300 GSM blush color paper'
     */
    jyDGU: T;

    /**
     * @default 'Bellyband, 10.5” x 2” on 120 GSM with gold foil'
     */
    scMky: T;

    /**
     * @default 'A blend of gold foil and digital printing, this arch-shaped Save the Date is perfect for setting the tone of your special day. '
     */
    jO9gH: T;

    /**
     * @default 'Upgrade to smooth magnetic backing for a fridge-friendly keepsake.'
     */
    yGEEw: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” arch on luxe 380 GSM paper with gold foil'
     */
    HxFdS: T;

    /**
     * @default 'Modern typography meets premium cotton paper. The {{0}} is all about simplicity and elegance to set the tone for your big day.'
     */
    Vp9dS: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” on 300 GSM cotton paper'
     */
    '2zuQN': T;

    /**
     * @default 'Premium almond envelopes'
     */
    jMQwO: T;

    /**
     * @default 'Personalized photo cards are the perfect way to announce your big day.'
     */
    xSL1l: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” arch on luxe 380 GSM paper'
     */
    BW0o0: T;

    /**
     * @default 'This Foil and personalized photo combo is the perfect way to send out your Save the Dates in style.'
     */
    NO23V: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” on 350 GSM heavyweight paper with gold foil'
     */
    L4fmz: T;

    /**
     * @default 'Announce your big day with your own photo captured on premium stock, creating a keepsake that lasts.'
     */
    qffpG: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” on luxe 380 GSM paper'
     */
    pFEXb: T;

    /**
     * @default 'Inspired by the {{0}} shorelines in Australia, this arch shaped copper foil Save the Date is the perfect way to set the tone for your big day.'
     */
    A2aUA: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” arch on luxe 380 GSM paper with copper foil'
     */
    IeYl7: T;

    /**
     * @default 'The Summer Nights double-arch Save the Date is the perfect way to announce your big day, personalized with your very own photo.'
     */
    c8cIp: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” double arch on luxe 380 GSM paper with white ink'
     */
    ZXHjF: T;

    /**
     * @default 'Where rustic charm meets minimalism, the {{0}} arch-shaped save the dates perfectly set the tone for your special day.'
     */
    '6hsXO': T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” arch on 300 GSM cotton paper'
     */
    KmMV9: T;

    /**
     * @default 'The double-arch {{0}} Save the Date features a graceful blend of blossom prints and typewriter-style fonts. It’s a charming way to announce your special day with a touch of timeless elegance.'
     */
    UUTuI: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” double arch on 300 GSM cotton paper'
     */
    '9cTen': T;

    /**
     * @default '{{0}} Save the Dates are a perfect blend of blue and orange hues, a masterpiece crafted for those who dream of warm sands and the whisper of waves.'
     */
    img8B: T;

    /**
     * @default 'The {{0}} double-layer Save the Dates are a delightful blend of playfulness and elegance. The top layer, printed in white ink on delicate vellum, overlays your personalized photo on the second layer, creating a beautiful keepsake.'
     */
    wxbKT: T;

    /**
     * @default 'Save the Date card, 4.2” x 5.5” on 350 GSM heavyweight paper'
     */
    HKYZQ: T;

    /**
     * @default 'Sheer overlay, 4.2” x 5.5” on 180 GSM vellum with white ink'
     */
    EgUSD: T;

    /**
     * @default 'Hole punch (ribbon not included)'
     */
    '2LBNP': T;

    /**
     * @default 'Gold fastener'
     */
    GS9HG: T;

    /**
     * @default 'Printed on quality premium paper'
     */
    tH9mf: T;

    /**
     * @default 'Customize with your own choice of photo'
     */
    GVImG: T;

    /**
     * @default 'Wax seals are not included, but can easily be purchased externally'
     */
    lrk9Y: T;

    /**
     * @default 'This bundle includes a delicate vellum bellyband, measuring 10.5" × 2" and 80 GSM, to wrap around your invitations for a finished look'
     */
    pwwDu: T;

    /**
     * @default 'Free premium white envelopes included with each invitation'
     */
    JGyRf: T;

    /**
     * @default 'This set includes a wedding invitation, a details card which has the RSVP details on the back'
     */
    WdzD9: T;

    /**
     * @default 'A bellyband to keep it all together and to add a finished touch'
     */
    Btz7i: T;

    /**
     * @default 'Almond color envelopes as seen in the video'
     */
    '1aOwQ': T;

    /**
     * @default 'When it comes to adding all the wedding info we like to keep it simple and elegant as possible.'
     */
    W8MYl: T;

    /**
     * @default 'This set includes arch shape invitations printed on beautiful cotton paper'
     */
    bl54J: T;

    /**
     * @default 'Matching double-sided information card to include all your wedding day finer details'
     */
    lQQKj: T;

    /**
     * @default 'A small landscape arch shape RSVP card, with the option to add your wedding website QR code'
     */
    te43N: T;

    /**
     * @default 'Free black envelopes included'
     */
    AKH28: T;

    /**
     * @default 'Make a grand entrance into your special day with this {{0}} invitation set'
     */
    eHKwD: T;

    /**
     * @default 'Printed on shimmery metallic paper for a subtle glow'
     */
    yXEsM: T;

    /**
     * @default 'A small landscape arch RSVP card, with the option to add your wedding website QR code on'
     */
    Vav9g: T;

    /**
     * @default 'Free Almond color envelopes included to match the invitation set tones'
     */
    er6sL: T;

    /**
     * @default 'Gold paper clips to keep all your cards together'
     */
    ixKoL: T;

    /**
     * @default 'Immerse yourself in the timeless allure of this {{0}} invitations set foil-printed and intertwined with delicate floral print bellyband.'
     */
    VRmWL: T;

    /**
     * @default 'A matching information card'
     */
    Q2kFM: T;

    /**
     * @default 'Transparent vellum bellyband to keep it all together and to add a finished touch'
     */
    jLfB4: T;

    /**
     * @default 'Gold foil invitation card, 5”x 7“ on premium 380 GSM paper'
     */
    AZm1N: T;

    /**
     * @default 'Details card, 4.2” x 5.5” on premium 380 GSM paper'
     */
    w0yMR: T;

    /**
     * @default 'Vellum bellyband, 10.5" x 2"  80 GSM '
     */
    TIBpp: T;

    /**
     * @default 'The {{0}} invitations are a perfect way to send your guests all the info they need for the day.'
     */
    hRtWH: T;

    /**
     * @default 'Printed on our Premium paper with high quality photo printing on the outside'
     */
    BmIOV: T;

    /**
     * @default 'This all-in-one wedding invitation includes all your wedding day finer details, RSVP, and wedding timeline'
     */
    ZV9oP: T;

    /**
     * @default 'The {{0}} set is a perfect balance between wedding neutrals and greenery. With stunning script fonts and quality print and paper, this layered invitation set is bound to set the tone for your big day.'
     */
    nOEBH: T;

    /**
     * @default 'Small green name card that can be used as a guest name card to tie in a hint of green to this suit.'
     */
    Wpmer: T;

    /**
     * @default 'Free Grey envelopes with each invitation set.'
     */
    OI2km: T;

    /**
     * @default 'Customize with your own photo on the inside '
     */
    eOTbT: T;

    /**
     * @default 'Printed on our Premium paper with high quality photo printing'
     */
    gd1Am: T;

    /**
     * @default 'Black envelopes included with each invitation'
     */
    K1ecZ: T;

    /**
     * @default 'Free Almond color envelopes with each invitation'
     */
    LWGHg: T;

    /**
     * @default 'The {{0}} invitation is for those flower and nature lovers, sure to set the tone for your special day.'
     */
    '40Tqo': T;

    /**
     * @default 'Printed on our Premium paper with high quality print showing all the vibrant colors this design has to offer'
     */
    yuACj: T;

    /**
     * @default 'Free envelopes to match for each invitation with a choice of Forest Green or Peach colored envelopes '
     */
    QqaTp: T;

    /**
     * @default 'Printed in white ink on our rich and vibrant Forest Green paper stock'
     */
    OmcCn: T;

    /**
     * @default 'Almond envelopes included with each invitation.'
     */
    Ao1kf: T;

    /**
     * @default 'Die-cut Gatefold Wedding Invitation, 11.8” x 7” side wave on premium 300 GSM paper'
     */
    '3i0XN': T;

    /**
     * @default 'The {{0}} gatefold invitation is for those flower lovers and sure to set the tone for your special day.'
     */
    F5ZyZ: T;

    /**
     * @default 'Printed on our Premium paper with high quality print showing all the vibrant colors this design has to offer '
     */
    '4tCuO': T;

    /**
     * @default 'Tied together with a kraft color bellyband '
     */
    vfa2M: T;

    /**
     * @default ' Almond envelopes included with each invitation'
     */
    M9jBj: T;

    /**
     * @default 'The {{0}} gatefold invitation is for those flower and nature lovers, sure to set the tone for your special day.'
     */
    ScAF2: T;

    /**
     * @default 'This all-in-one wedding invitation includes space for all your wedding day detail, RSVP and wedding day timeline information.'
     */
    dwauN: T;

    /**
     * @default 'Almond color envelopes and envelope liners included with each invitation set (Please note: envelope liners do not come assembled.'
     */
    glH6H: T;

    /**
     * @default 'Ribbon and wax seals are not included. They can be purchased externally.'
     */
    oPzVf: T;

    /**
     * @default 'Immerse yourself in the timeless allure of this {{0}} invitation set foil-printed '
     */
    HxrH2: T;

    /**
     * @default 'Paired with a delicate transparent (vellum) info card. '
     */
    RG3F4: T;

    /**
     * @default 'Almond color envelopes included with each invitation set.'
     */
    fiXjO: T;

    /**
     * @default 'Information card, 4.2” x 5.5,” on 180 GSM Vellum with white ink'
     */
    bWwlE: T;

    /**
     * @default 'All your invitation, RSVP, and wedding details in one arch shape tri-fold '
     */
    UgyNE: T;

    /**
     * @default 'Printed on our Premium Almond colored paper'
     */
    FtYrv: T;

    /**
     * @default 'This all-in-one wedding invitation includes space for all your wedding day finer details and RSVP information'
     */
    pfoOq: T;

    /**
     * @default 'Vibrant red and blush tones invitation package is perfect for those wanting a pop of color'
     */
    zEv6v: T;

    /**
     * @default 'This set includes a wedding invitation, wedding info card with RSVP details included'
     */
    Shp7p: T;

    /**
     * @default 'An extra card on top with a customizable quote or your names printed on it'
     */
    khFnF: T;

    /**
     * @default 'Free Premium white envelopes'
     */
    '5zyT5': T;

    /**
     * @default 'Gold paperclips included with each set.'
     */
    y3TZg: T;

    /**
     * @default 'This set includes a: Wedding invitation, Wedding timeline (program) card with schedule information, and an information card with all the wedding details and RSVP information'
     */
    OdoCG: T;

    /**
     * @default 'Almond color envelopes included.'
     */
    bxYDG: T;

    /**
     * @default 'The {{0}} set is a perfect balance between wedding neutrals and greenery. With stunning new typography and quality print and paper, this layered invitation set is bound to set the tone for your big day.'
     */
    vrrGx: T;

    /**
     * @default 'Matching double-sided information RSVP card '
     */
    d7EAX: T;

    /**
     * @default 'Seedling green envelopes included with each invitation set. '
     */
    vlf4u: T;

    /**
     * @default 'Immerse yourself in the timeless allure of this {{0}} invitation set '
     */
    '4uyHY': T;

    /**
     * @default 'Blush RSVP post-card with your address printed on, making it easier for your guests to rsvp'
     */
    '4NPxQ': T;

    /**
     * @default 'An information card in elegant shade of grey for all the finer details of your big day'
     */
    sVBYe: T;

    /**
     * @default 'A matching foil printed bellyband to tie it all in together '
     */
    HNSBA: T;

    /**
     * @default 'Free white envelopes included with each invitation set.'
     */
    KP30y: T;

    /**
     * @default 'Matching double-sided information RSVP card'
     */
    dFbnG: T;

    /**
     * @default 'Small Hunter Green name card'
     */
    ZfMEb: T;

    /**
     * @default 'Hunter Green envelopes and Delicate Leaves liners included with each invitation set.'
     */
    xdsWT: T;

    /**
     * @default 'Wedding invitation card, 5" x 7" arch on 300 GSM almond paper'
     */
    HFG7y: T;

    /**
     * @default 'Place card, 4.2" x 2.1" landscape arch on Hunter Green 300 GSM paper'
     */
    numpd: T;

    /**
     * @default 'RSVP card, 4.2" x 5.5" half arch on Cotton 300 GSM paper'
     */
    KZQ42: T;

    /**
     * @default 'Premium Hunter Green envelopes'
     */
    X8EDY: T;

    /**
     * @default 'Envelope liners'
     */
    b8qO3: T;

    /**
     * @default 'The {{0}} set is a perfect balance between wedding neutrals and minimalist elegance. With stunning script fonts and quality print and paper, this layered invitation set is bound to set the tone for your big day.'
     */
    '125OP': T;

    /**
     * @default 'Black information card that is big enough for all your wedding details and sure to stand out'
     */
    '2BjW5': T;

    /**
     * @default 'Small round RSVP card for you to place your QR code and any additional details'
     */
    RWrH0: T;

    /**
     * @default 'Grey envelopes with each invitation set'
     */
    '4DjvC': T;

    /**
     * @default 'Wedding invitation card, 5" x 7" arch on 300 GSM cotton paper'
     */
    XDmYr: T;

    /**
     * @default 'Info card, 4.2" x 5.5" half arch on 270 GSM black paper with white ink'
     */
    Mg8zG: T;

    /**
     * @default 'RSVP card, 108mm circle on 300 GSM almond paper'
     */
    gCjBc: T;

    /**
     * @default 'The {{0}} gatefold invitation is for those lavender lovers, sure to set the tone for your special day.'
     */
    K4U3W: T;

    /**
     * @default 'Customize with your own photo on the outside'
     */
    He9Jr: T;

    /**
     * @default 'Printed on our matte paper with high quality photo printing'
     */
    U1hRt: T;

    /**
     * @default 'This all-in-one wedding invitation includes all your wedding day finer details'
     */
    eFYcD: T;

    /**
     * @default 'Free white envelopes with each invitation'
     */
    IvnGH: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 300 GSM matte paper'
     */
    '9Q7zI': T;

    /**
     * @default 'Printed on our matte paper with high quality print showing all the vibrant colors this design has to offer'
     */
    gnqbB: T;

    /**
     * @default 'Free white envelopes to match for each invitation'
     */
    XXGmn: T;

    /**
     * @default 'The {{0}} gatefold invitation is an elegant foil design, sure to set the tone for your special day.'
     */
    TMrTC: T;

    /**
     * @default 'Black envelopes included with each invitation set'
     */
    gYh0w: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 300 GSM matte paper with gold foil'
     */
    THkRX: T;

    /**
     * @default 'Premium black envelopes'
     */
    Fgcfb: T;

    /**
     * @default 'The {{0}} gatefold invitation is for those nature lovers, sure to set the tone for your special day.'
     */
    kQTci: T;

    /**
     * @default 'Free white envelopes included with each invitation set'
     */
    Ckgmb: T;

    /**
     * @default 'Free Almond envelopes included with each invitation set'
     */
    scgqN: T;

    /**
     * @default 'The {{0}} gatefold invitation is for those fine art lovers, sure to set the tone for your special day.'
     */
    C8AGl: T;

    /**
     * @default 'Free Black envelopes included with each invitation set'
     */
    Ceqvs: T;

    /**
     * @default 'Almond colour envelopes included with each invitation set'
     */
    OaNB0: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 300 GSM matte paper with rose gold foil'
     */
    mYeL0: T;

    /**
     * @default 'Free Almond envelopes to match for each invitation'
     */
    pF95X: T;

    /**
     * @default 'Printed on our matte paper with a combination of digital and copper color foil, showing all the vibrant colors this design has to offer'
     */
    giYzD: T;

    /**
     * @default 'Free Forest Green envelopes included with each invitation set'
     */
    nTLag: T;

    /**
     * @default 'Gatefold wedding invitation card, 10" x 7" on 300 GSM matte paper with copper foil'
     */
    si8bw: T;

    /**
     * @default 'Premium Forest Green envelopes'
     */
    M8sCU: T;

    /**
     * @default 'Free Seedling green envelopes included with each invitation set'
     */
    RKOgU: T;

    /**
     * @default 'The {{0}} double-arch Save the Date is the perfect way to announce your big day, personalized with your very own photo.'
     */
    W2JqC: T;

    /**
     * @default 'Economy Shipping'
     */
    KPylT: T;

    /**
     * @default 'Arrives in 14-16 days'
     */
    XPBAi: T;

    /**
     * @default 'Standard Shipping'
     */
    tFU84: T;

    /**
     * @default 'Arrives in 12-14 days'
     */
    Vuo02: T;

    /**
     * @default 'Express Shipping'
     */
    AINFP: T;

    /**
     * @default 'Arrives in 8 days'
     */
    gSIYQ: T;

    /**
     * @default 'International Economy Shipping'
     */
    QSy0U: T;

    /**
     * @default 'Arrives in 12-21 days, tracking only available while in the US'
     */
    gZvxH: T;

    /**
     * @default 'Worldwide Express Shipping'
     */
    j1Jut: T;

    /**
     * @default 'Arrives in 9-12 days'
     */
    FsyvP: T;

    /**
     * @default 'Card Preview'
     */
    eTZSZ: T;

    /**
     * @default 'A selection of cards showcasing each paper type, trim option, and card size'
     */
    BFyan: T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'FOIL'
     */
    sb5KA: T;

    /**
     * @default 'Digital {{0}}'
     */
    K0L6W: T;

    /**
     * @default 'Digital Card'
     */
    epjCf: T;

    /**
     * @default 'Silhouette: {{0}}'
     */
    '8gbbT': T;

    /**
     * @default 'Print Recipient Addresses'
     */
    K8lPI: T;

    /**
     * @default 'Your order will be paused until we receive your list of recipient addresses. When you're ready, add your recipients by clicking the link below.'
     */
    nibVf: T;

    /**
     * @default 'Add/Edit Recipient addresses'
     */
    f0o7S: T;

    /**
     * @default 'Send to Print'
     */
    cJyXG: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Full name'
     */
    SLCaY: T;

    /**
     * @default 'Country/Region'
     */
    vKJHw: T;

    /**
     * @default 'Mobile Phone'
     */
    YD8aE: T;

    /**
     * @default 'Required'
     */
    zNaqf: T;

    /**
     * @default 'Invalid Phone Number'
     */
    Gsdpn: T;

    /**
     * @default 'Address Line 1'
     */
    r2ebI: T;

    /**
     * @default 'Address'
     */
    gDl5Q: T;

    /**
     * @default 'Address Line 2'
     */
    s2ebI: T;

    /**
     * @default 'Apartment, Suite, etc. (optional)'
     */
    LK85B: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'State'
     */
    Be76G: T;

    /**
     * @default 'State/Province/Territory'
     */
    LLPZf: T;

    /**
     * @default 'Postal Code'
     */
    WCbuM: T;

    /**
     * @default 'Tax'
     */
    '9oYAA': T;

    /**
     * @default 'Paid with {{0}} {{1}}'
     */
    jKxtT: T;

    /**
     * @default 'Edit Back'
     */
    vaFHg: T;

    /**
     * @default 'Next: {{0}}'
     */
    tE1Is: T;

    /**
     * @default 'Edit Front'
     */
    TIVJ2: T;

    /**
     * @default 'Silhouette'
     */
    OMy5V: T;

    /**
     * @default 'Product Overview Video'
     */
    joJrb: T;

    /**
     * @default 'Edit'
     */
    mU2KA: T;

    /**
     * @default 'Browse Designs'
     */
    vQAeM: T;

    /**
     * @default 'Coming Soon'
     */
    ODxS0: T;

    /**
     * @default 'Paper Only'
     */
    CASm0: T;

    /**
     * @default 'Paper & Digital'
     */
    yLGFv: T;

    /**
     * @default 'Disabled (Admin View Only)'
     */
    Rh21r: T;

    /**
     * @default 'Digital Only'
     */
    gebEf: T;

    /**
     * @default 'Premium Digital Available'
     */
    aEZRP: T;

    /**
     * @default 'Shop the '{{0}}' Save the Date Card | Joy'
     */
    '9r473': T;

    /**
     * @default 'Shop the '{{0}}' Invitation Card | Joy'
     */
    sxLwy: T;

    /**
     * @default 'Shop the '{{0}}' Thank You Card | Joy'
     */
    '2fXAn': T;

    /**
     * @default 'Shop the '{{0}}' Holiday Card | Joy'
     */
    XqM7m: T;

    /**
     * @default 'Shop the '{{0}}' Enclosure Card | Joy'
     */
    JYi4C: T;

    /**
     * @default 'Shop the '{{0}}' Card | Joy'
     */
    '5uR6a': T;

    /**
     * @default 'Wallpaper Color'
     */
    Xmv4A: T;

    /**
     * @default 'I understand that by clicking Send to Print, I will no longer be able to edit my card or envelopes.'
     */
    '6L95T': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Upload your design'
     */
    ohuch: T;

    /**
     * @default 'Cards'
     */
    PVimF: T;

    /**
     * @default 'Foil template'
     */
    '60tWl': T;

    /**
     * @default 'Shop Matching Designs'
     */
    UhY8i: T;

    /**
     * @default 'We're excited to get your beautiful design printed and get them to you very soon to help you celebrate that amazing day.'
     */
    '1SvQD': T;

    /**
     * @default 'Order {{0}}'
     */
    '6DQZR': T;

    /**
     * @default 'We'll send an email confirmation for your order to'
     */
    gf0JN: T;

    /**
     * @default 'Your order will be paused until we receive your list of recipient addresses. When you're ready, add your recipients by clicking the button below.'
     */
    '7DMSt': T;

    /**
     * @default 'You can track your order status at any time.'
     */
    FoKgz: T;

    /**
     * @default 'View Order'
     */
    ltTsE: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Unselect All'
     */
    M6Bwa: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Filter by:'
     */
    nmoMy: T;

    /**
     * @default 'Missing Addresses'
     */
    OBVd0: T;

    /**
     * @default 'Missing Address'
     */
    SRM6v: T;

    /**
     * @default 'Uh oh, we can't edit your order at this point.'
     */
    D6qZT: T;

    /**
     * @default 'Your order has already been sent to get printed, so we can't make changes at this point.'
     */
    PB5ZC: T;

    /**
     * @default 'If you still need help with your order, please contact printsupport@withjoy.com'
     */
    DK0t2: T;

    /**
     * @default 'Go to Orders'
     */
    AoM3A: T;

    /**
     * @default 'Please add your shipping address.'
     */
    sIx3G: T;

    /**
     * @default 'Please confirm that you checked all the details by ticking the checkbox below.'
     */
    u9zq6: T;

    /**
     * @default 'I have checked all the details and the design and order look good to me.'
     */
    '8hWIK': T;

    /**
     * @default 'I have reviewed the card and recognize that the changes made will replace the existing card order.'
     */
    IpR7E: T;

    /**
     * @default 'Your order includes:'
     */
    kEMgr: T;

    /**
     * @default 'Please double check all the details before we print.'
     */
    Tb80n: T;

    /**
     * @default 'Add Shipping Address'
     */
    '3dTPi': T;

    /**
     * @default 'Preview All Envelopes'
     */
    S3ITI: T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'Front of the Card'
     */
    BgkF1: T;

    /**
     * @default 'Edit Email Subject'
     */
    kvK2Y: T;

    /**
     * @default 'Hang tight!'
     */
    bs36p: T;

    /**
     * @default 'password input'
     */
    LuDfw: T;

    /**
     * @default 'Select a Page'
     */
    o3XtF: T;

    /**
     * @default 'Customize'
     */
    LkOTm: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;
  };
};

export type StationeryTemplateCategoryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  designsGalleryPdpBreadcrumbCategory: {
    /**
     * @default 'Save the Dates'
     */
    saveTheDate: T;

    /**
     * @default 'Invitations'
     */
    invitation: T;

    /**
     * @default 'Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Napkins'
     */
    napkin: T;

    /**
     * @default 'Menus'
     */
    menu: T;

    /**
     * @default 'Signs'
     */
    sign: T;

    /**
     * @default 'All Cards'
     */
    default: T;
  };
  stationeryTemplateCategoryToTile: {
    /**
     * @default 'Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Invitation'
     */
    invitation: T;

    /**
     * @default 'Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Napkins'
     */
    napkin: T;

    /**
     * @default 'Menus'
     */
    menu: T;

    /**
     * @default 'Signs'
     */
    sign: T;

    /**
     * @default 'Paper Card'
     */
    default: T;
  };
  stationeryTemplateCategoryToDigitalTile: {
    /**
     * @default 'Digital Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Digital Invitation'
     */
    invitation: T;

    /**
     * @default 'Digital Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Digital Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Digital Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Digital Card'
     */
    default: T;
  };
  exitCustomizationWidgetBrowseDesignCta: {
    /**
     * @default 'Browse Invitations'
     */
    invitation: T;

    /**
     * @default 'Browse Save the Dates'
     */
    saveTheDate: T;

    /**
     * @default 'Browse Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Browse Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Browse Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Browse Designs'
     */
    default: T;
  };
  premiumDigitalCardCustomizerInitialEmailSubjectByType: {
    /**
     * @default 'Save the Date!'
     */
    saveTheDate: T;

    /**
     * @default 'You're Invited!'
     */
    invitation: T;

    /**
     * @default 'Thank You!'
     */
    thankYou: T;

    /**
     * @default 'Happy Holidays!'
     */
    holiday: T;

    /**
     * @default 'Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Thank You!'
     */
    default: T;
  };
  dashboardCategoryNav: {
    /**
     * @default 'Save the Dates'
     */
    saveTheDate: T;

    /**
     * @default 'Invitations'
     */
    invitation: T;

    /**
     * @default 'Thank You Cards'
     */
    thankYou: T;

    /**
     * @default 'Holiday Cards'
     */
    holiday: T;

    /**
     * @default 'Enclosure Cards'
     */
    enclosure: T;

    /**
     * @default 'Day-of Stationery'
     */
    dayOf: T;

    /**
     * @default 'Napkins'
     */
    napkin: T;

    /**
     * @default 'Menus'
     */
    menu: T;

    /**
     * @default 'Signs'
     */
    sign: T;

    /**
     * @default ''
     */
    default: T;
  };
  dashboardOrderListDigitalOrderOrderType: {
    /**
     * @default 'Digital Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Digital Invitation'
     */
    invitation: T;

    /**
     * @default 'Digital Thank You Card'
     */
    thankYou: T;

    /**
     * @default 'Digital Holiday Card'
     */
    holiday: T;

    /**
     * @default 'Digital Enclosure Card'
     */
    enclosure: T;

    /**
     * @default 'Digital Card'
     */
    default: T;
  };
  premiumDigitalOrderTrackingCategory: {
    /**
     * @default 'Digital Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Digital Invitation'
     */
    invitation: T;

    /**
     * @default 'Digital Thank You'
     */
    thankYou: T;

    /**
     * @default 'Digital Holiday Card'
     */
    holiday: T;

    /**
     * @default 'Digital Enclosure Card'
     */
    enclosure: T;

    /**
     * @default 'Digital Card'
     */
    default: T;
  };
};

export type StayBookingAssistantTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Where'
   */
  Where: T;

  /**
   * @default 'Where?'
   */
  'Where?': T;

  /**
   * @default 'When'
   */
  When: T;

  /**
   * @default 'Who'
   */
  Who: T;

  /**
   * @default 'Search'
   */
  Search: T;

  /**
   * @default 'Search Hotels'
   */
  'Search Hotels': T;

  /**
   * @default 'Configure Rooms'
   */
  'Configure Rooms': T;

  /**
   * @default 'Add Room'
   */
  'Add Room': T;

  /**
   * @default 'Apply'
   */
  Apply: T;

  /**
   * @default 'Room {{number}}'
   */
  'Room {{number}}': T;

  /**
   * @default 'Remove Room'
   */
  'Remove Room': T;

  /**
   * @default 'Adults'
   */
  Adults: T;

  /**
   * @default 'Ages 18+'
   */
  'Ages 18+': T;

  /**
   * @default 'Children'
   */
  Children: T;

  /**
   * @default 'Ages 0-17'
   */
  'Ages 0-17': T;

  /**
   * @default 'Child {{number}}'
   */
  'Child {{number}}': T;

  /**
   * @default 'Age'
   */
  Age: T;

  /**
   * @default 'Select Age'
   */
  'Select Age': T;

  /**
   * @default 'Please provide child age'
   */
  'Please provide child age': T;

  /**
   * @default 'Child age must be at least {{min}}'
   */
  'Child age must be at least {{min}}': T;

  /**
   * @default 'Child age must be at most {{max}}'
   */
  'Child age must be at most {{max}}': T;

  /**
   * @default 'Location is required'
   */
  'Location is required': T;

  /**
   * @default 'Check-in date is required'
   */
  'Check-in date is required': T;

  /**
   * @default 'Check-out date is required'
   */
  'Check-out date is required': T;

  /**
   * @default 'Check-out date must be after check-in date'
   */
  'Check-out date must be after check-in date': T;

  /**
   * @default 'Stay booking assistant updated successfully.'
   */
  'Stay booking assistant updated successfully.': T;

  /**
   * @default 'Stay booking assistant saved successfully.'
   */
  'Stay booking assistant saved successfully.': T;

  /**
   * @default 'Failed to save. Please try again.'
   */
  'Failed to save. Please try again.': T;

  /**
   * @default 'Edit Stay Booking Assistant'
   */
  'Edit Stay Booking Assistant': T;

  /**
   * @default 'Add Stay Booking Assistant'
   */
  'Add Stay Booking Assistant': T;

  /**
   * @default 'Save'
   */
  Save: T;

  /**
   * @default 'Cancel'
   */
  Cancel: T;

  /**
   * @default 'Choose Background Photo'
   */
  'Choose Background Photo': T;

  /**
   * @default 'Add Background Photo'
   */
  'Add Background Photo': T;

  /**
   * @default 'We support jpeg and PNG images.'
   */
  'We support jpeg and PNG images.': T;

  /**
   * @default 'Check-In Date'
   */
  'Check-In Date': T;

  /**
   * @default 'Check-Out Date'
   */
  'Check-Out Date': T;

  /**
   * @default 'Booking Assistant'
   */
  'Booking Assistant': T;

  /**
   * @default 'Delete'
   */
  Delete: T;

  quick: {
    /**
     * @default 'Are you sure you want to delete this stay booking assistant?'
     */
    qHcYj: T;

    /**
     * @default 'The contents of this section will be lost. This action can't be undone.'
     */
    Ddyiq: T;

    /**
     * @default 'Delete Stay Booking Assistant'
     */
    Fdjc8: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Success! Stay booking assistant has been deleted.'
     */
    duGo0: T;

    /**
     * @default 'An error occurred while deleting this stay booking assistant. Please try again.'
     */
    ED47W: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Booking Assistant'
     */
    '9xYfI': T;

    /**
     * @default 'Search Hotels'
     */
    Vq7RA: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Check-In Date'
     */
    YMM6E: T;

    /**
     * @default 'Add a date'
     */
    qrRii: T;

    /**
     * @default 'Check-Out Date'
     */
    jHfIJ: T;

    /**
     * @default 'Edit Booking Assistant'
     */
    vNLvE: T;

    /**
     * @default 'Add Booking Assistant'
     */
    CfOG6: T;

    /**
     * @default 'Update the booking assistant for your guests.'
     */
    '6INNT': T;

    /**
     * @default 'Add a booking assistant to let guests find their own accommodations near your event.'
     */
    tf4fE: T;

    /**
     * @default 'Search near'
     */
    cahk3: T;

    /**
     * @default 'San Francisco, CA, USA'
     */
    zGqUZ: T;

    /**
     * @default 'Choose Background Photo'
     */
    '3KIJJ': T;

    /**
     * @default 'Add Background Photo'
     */
    bYK8o: T;

    /**
     * @default 'We support jpeg and PNG images.'
     */
    ppvro: T;

    /**
     * @default 'Failed to save. Please try again.'
     */
    WDfiJ: T;

    /**
     * @default 'Location is required'
     */
    YNULo: T;

    /**
     * @default 'Check-in date is required'
     */
    NqJ2H: T;

    /**
     * @default 'Check-out date is required'
     */
    aoBk7: T;

    /**
     * @default 'Check-out date must be after check-in date'
     */
    TsSut: T;

    /**
     * @default 'Stay booking assistant updated successfully.'
     */
    qc3M9: T;

    /**
     * @default 'Stay booking assistant saved successfully.'
     */
    wddsE: T;

    /**
     * @default 'An error occurred while uploading your photo. Please try again.'
     */
    '6y3vI': T;

    /**
     * @default 'Simple Hotel List'
     */
    yWxpa: T;

    /**
     * @default 'Hotel Tiles Carousel'
     */
    veeU3: T;

    /**
     * @default '6.0 Pleasant'
     */
    CPA3q: T;

    /**
     * @default '7.0 Good'
     */
    cvgwK: T;

    /**
     * @default '8.0 Very Good'
     */
    fbLE3: T;

    /**
     * @default '9.0 Wonderful'
     */
    HFwWG: T;

    /**
     * @default '2 stars'
     */
    lljVq: T;

    /**
     * @default '3 stars'
     */
    GzyZu: T;

    /**
     * @default '4 stars'
     */
    nnqyJ: T;

    /**
     * @default '5 stars'
     */
    I152N: T;

    /**
     * @default 'Customize Hotel Display'
     */
    piEAk: T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'Show prices for suggested hotels'
     */
    '88P3C': T;

    /**
     * @default 'Show photo for each hotel'
     */
    lhd78: T;

    /**
     * @default 'Curate Hotel Selection'
     */
    cL6Tx: T;

    /**
     * @default 'Customize and display hotel options'
     */
    GbLZu: T;

    /**
     * @default 'Min Nightly Price'
     */
    y4pKI: T;

    /**
     * @default 'Max Nightly Price'
     */
    EwXLH: T;

    /**
     * @default 'Min Customer Rating'
     */
    D0CxE: T;

    /**
     * @default 'Min Hotel Star Rating'
     */
    Vx1XH: T;

    /**
     * @default 'No hotels match your selected filters.'
     */
    Ys0fO: T;

    /**
     * @default 'Recommended Hotels'
     */
    wbMfS: T;

    /**
     * @default 'Show More'
     */
    UaxIB: T;

    /**
     * @default 'Previous page'
     */
    ot9dK: T;

    /**
     * @default 'Next page'
     */
    '2Bgfo': T;

    /**
     * @default 'Simple Mode'
     */
    '1l5yN': T;

    /**
     * @default 'Display hotel search assistant'
     */
    SQG71: T;

    /**
     * @default 'Advanced Mode'
     */
    prMHR: T;

    /**
     * @default 'Navigation'
     */
    avBYb: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default 'Nightly price from:'
     */
    kcLZz: T;

    /**
     * @default 'Price must be positive'
     */
    q49tz: T;

    /**
     * @default 'Min price must be less than max price'
     */
    S6NEZ: T;

    /**
     * @default 'See Availability'
     */
    '2ZFEq': T;

    /**
     * @default 'Special Event Rate'
     */
    bmIeF: T;

    /**
     * @default 'Save {{0}}%'
     */
    u1SBH: T;

    /**
     * @default 'Nightly price from'
     */
    uS1D2: T;

    /**
     * @default 'Page Width'
     */
    zzCpp: T;

    /**
     * @default 'Screen Width'
     */
    wAcoa: T;

    /**
     * @default 'Photo Layout'
     */
    AgcDX: T;

    /**
     * @default 'What's Booking Assistant?'
     */
    '2pdvJ': T;

    /**
     * @default 'We find nearby hotel deals for your guests—no need to list or choose hotels yourself. Customize how the hotels appear on your page.'
     */
    jt4cq: T;

    /**
     * @default 'NEW'
     */
    KsWAA: T;
  };
};

export type StaysTranslations<T extends LeafNodeValue = TranslateFunction> = {
  datesOccupants: {
    /**
     * @default 'Find Hotel Rooms'
     */
    cta: T;

    /**
     * @default 'Rooms starting from'
     */
    roomsStartingFrom: T;

    /**
     * @default '{{price}} Nightly'
     */
    nightlyPrice: T;

    /**
     * @default 'Total: {{price}}'
     */
    totalPrice: T;

    /**
     * @default 'Night'
     */
    night: T;

    /**
     * @default 'Select Room'
     */
    selectRoom: T;

    /**
     * @default 'See Available Rooms'
     */
    seeAvailableRooms: T;

    /**
     * @default 'Configuring Rooms'
     */
    configureRooms: T;

    /**
     * @default 'Room {{number}}'
     */
    roomNumber: T;

    /**
     * @default 'Child {{number}}'
     */
    childNumber: T;

    /**
     * @default 'Adults'
     */
    adults: T;

    /**
     * @default 'Age 17 or under'
     */
    childrenAge: T;

    /**
     * @default 'Age 18 or above'
     */
    adultAge: T;

    /**
     * @default 'Select Dates'
     */
    selectDates: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Apply'
     */
    apply: T;

    /**
     * @default '{{startDate}} - {{endDate}}'
     */
    dateRange: T;

    numberOfAdults: {
      /**
       * @default '1 Adult'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Adult
       * - plural: {{count}} Adults
       */
      adults: T;
    };
    numberOfRooms: {
      /**
       * @default '1 Room'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Room
       * - plural: {{count}} Rooms
       */
      rooms: T;
    };

    /**
     * @default '{{children}} Children'
     */
    numberOfChildren: T;

    /**
     * @default 'Rooms'
     */
    rooms: T;

    /**
     * @default 'Children'
     */
    children: T;

    numberOfGuests: {
      /**
       * @default '1 Guest'
       * @param {number} count - The number of occurrences.
       * - singular: 1 Guest
       * - plural: {{count}} Guests
       */
      guests: T;
    };

    /**
     * @default 'Guests'
     */
    guests: T;

    /**
     * @default 'Add Room'
     */
    addRoom: T;

    /**
     * @default 'Remove Room'
     */
    removeRoom: T;

    /**
     * @default 'Occupancy'
     */
    occupancy: T;

    /**
     * @default 'Dates'
     */
    dates: T;

    /**
     * @default 'Check-In'
     */
    checkIn: T;

    /**
     * @default 'Check-Out'
     */
    checkOut: T;

    /**
     * @default 'Location'
     */
    location: T;

    /**
     * @default 'Add Date'
     */
    addDate: T;

    /**
     * @default '{{percentage}} Special Wedding Discount'
     */
    discountBar: T;

    /**
     * @default 'Select Age'
     */
    selectAge: T;

    /**
     * @default 'Provide the age of child'
     */
    provideChildAge: T;

    validation: {
      /**
       * @default 'Age must be at least 0'
       */
      childAgeMin: T;

      /**
       * @default 'Age must be 17 or under'
       */
      childAgeMax: T;
    };
  };
  hotelPDPPage: {
    seo: {
      /**
       * @default 'Hotel'
       */
      title: T;
    };
    heroPhotos: {
      /**
       * @default '+{{count}}'
       */
      count: T;

      /**
       * @default 'View all photos'
       */
      seeAllPhotos: T;
    };
    offer: {
      /**
       * @default 'Room'
       */
      room: T;

      /**
       * @default 'Check-in'
       */
      checkIn: T;

      /**
       * @default 'Check-out'
       */
      checkOut: T;

      /**
       * @default 'More Details'
       */
      moreDetails: T;

      /**
       * @default 'Free Breakfast'
       */
      freeBreakfast: T;

      /**
       * @default 'Free Wifi'
       */
      freeWifi: T;

      /**
       * @default 'Taxes & Fees'
       */
      taxesAndFees: T;

      /**
       * @default 'Room Information'
       */
      roomInformation: T;

      /**
       * @default 'Room Facilities'
       */
      roomFacilities: T;

      /**
       * @default 'Room Policy'
       */
      roomPolicy: T;

      /**
       * @default 'Refundable'
       */
      refundable: T;

      /**
       * @default 'Non-Refundable'
       */
      nonRefundable: T;

      /**
       * @default 'Cancellation Policy'
       */
      cancellationPolicy: T;

      /**
       * @default 'View Policy'
       */
      viewPolicy: T;

      /**
       * @default '{{distributionType}} Rate'
       */
      distributionRate: T;

      /**
       * @default '{{total}} total includes taxes and fees'
       */
      totalPrice: T;

      /**
       * @default 'Reserve'
       */
      reserveRoom: T;

      /**
       * @default 'You will not be charged yet'
       */
      notChargedYet: T;

      priceForAdults: {
        /**
         * @default 'Price for {{count}} adult'
         * @param {number} count - The number of occurrences.
         * - singular: Price for {{count}} adult
         * - plural: Price for {{count}} adults
         */
        price: T;
      };
      priceForAdultsAndChildren: {
        /**
         * @default 'Price for {{count}} adult and {{children}} children'
         * @param {number} count - The number of occurrences.
         * - singular: Price for {{count}} adult and {{children}} children
         * - plural: Price for {{count}} adults and {{children}} children
         */
        price: T;
      };

      /**
       * @default 'Total'
       */
      total: T;

      /**
       * @default 'Pay Now'
       */
      payNow: T;

      /**
       * @default 'Pay At Property'
       */
      payAtProperty: T;

      /**
       * @default 'Mandatory {{feeName}} (Pay at property)'
       */
      mandatoryFee: T;

      /**
       * @default 'The taxes are tax recovery charges paid to vendors (e.g., hotels) for details, please see our  Terms of Use . Service fees are retained as compensation in servicing your booking and may include fees charged by vendors.'
       */
      taxesTooltip: T;
    };

    /**
     * @default '✨ Link Copied ✨'
     */
    linkCopiedToast: T;

    /**
     * @default 'Share Link'
     */
    copyLinkButtonAria: T;

    /**
     * @default 'Note from {{eventDisplayName}}'
     */
    noteFrom: T;

    /**
     * @default 'Less'
     */
    less: T;

    /**
     * @default 'More'
     */
    more: T;

    /**
     * @default 'About the hotel'
     */
    aboutHotel: T;

    /**
     * @default 'Hotel Overview'
     */
    hotelTooltipTitle: T;

    /**
     * @default 'Discover essential information about our hotel.'
     */
    hotelTooltipDescription: T;

    /**
     * @default 'Read more'
     */
    readMore: T;

    /**
     * @default 'Read less'
     */
    readLess: T;

    /**
     * @default 'Choose your room'
     */
    chooseYourRoom: T;

    offersNotFound: {
      /**
       * @default 'No Available Rooms'
       */
      title: T;

      /**
       * @default 'Modify your search criteria and try again.'
       */
      message: T;

      /**
       * @default 'Modify your search criteria'
       */
      buttonPrimaryCTA: T;

      /**
       * @default 'Explore Other Options'
       */
      buttonSecondaryCTA: T;
    };
    offerExpired: {
      /**
       * @default 'Offer Expired'
       */
      title: T;

      /**
       * @default 'This offer is no longer available. Click here to see the latest offers.'
       */
      message: T;

      /**
       * @default 'See Latest Offers'
       */
      cta: T;
    };
  };
  hotelPDPFooter: {
    navigationLinks: {
      /**
       * @default 'Contact Us'
       */
      contactUs: T;

      /**
       * @default 'Privacy Policy'
       */
      privacyPolicy: T;

      /**
       * @default 'Manage My Bookings'
       */
      manageMyBookings: T;

      /**
       * @default 'Cookie Preferences'
       */
      cookiePreferences: T;

      /**
       * @default 'Terms & Conditions'
       */
      termsAndConditions: T;
    };

    /**
     * @default '© Joy, {{currentYear}}'
     */
    primaryCTA: T;
  };
  closedUserGroupNotVerified: {
    /**
     * @default 'Enjoy Exclusive Rates for All Joy Couples and Guests'
     */
    title: T;

    /**
     * @default 'Please note that the special rates are only available when you're participating in a Joy event as a host or a guest.'
     */
    description: T;

    redirectOptions: {
      findEvent: {
        /**
         * @default 'I'm a Joy event guest.'
         */
        title: T;

        /**
         * @default 'If you're attending an event hosted with Joy, you can find it here.'
         */
        description: T;
      };
      createEvent: {
        /**
         * @default 'I'd like to create a Joy event.'
         */
        title: T;

        /**
         * @default 'If you'd like to use Joy platform to create an event for you and your guests, click here.'
         */
        description: T;
      };
    };
    advancedAccess: {
      /**
       * @default 'Advanced'
       */
      title: T;

      /**
       * @default 'Get Access'
       */
      unlockRates: T;

      /**
       * @default 'Enter access code'
       */
      subTitle: T;

      /**
       * @default 'Invalid code. Please try again.'
       */
      errorMessage: T;
    };
  };
  currencySelectorModal: {
    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'All currencies'
     */
    allCurrencies: T;

    /**
     * @default 'Choose currency'
     */
    chooseCurrency: T;

    /**
     * @default 'Choose a currency'
     */
    chooseACurrency: T;
  };
  quick: {
    /**
     * @default '{{0}}% Discount (Saved {{1}})'
     */
    DqBoG: T;

    /**
     * @default '{{0}} Discount Applied'
     */
    '2NZhl': T;

    /**
     * @default 'Saved {{0}}'
     */
    TibJU: T;

    /**
     * @default 'Pay at property exchange conversion is an approximate price based on the current exchange rate and may change before your stay.'
     */
    vDVnR: T;

    /**
     * @default 'Exchange rate information'
     */
    PnXpC: T;

    /**
     * @default '{{0}}'
     */
    QmzKK: T;

    /**
     * @default 'Select Room'
     */
    hsTPG: T;

    /**
     * @default '{{0}}% Off'
     */
    SZqDF: T;

    /**
     * @default 'Default Hotel Offer Photo'
     */
    REFaz: T;

    /**
     * @default 'Fully Refundable'
     */
    Wvj8m: T;

    /**
     * @default 'Delicious Breakfast Included'
     */
    oMvOo: T;

    /**
     * @default 'No Meals Included'
     */
    BfPDr: T;

    /**
     * @default '{{0}}% Savings'
     */
    mRVxh: T;

    /**
     * @default '{{0}} total includes taxes & fees'
     */
    '5mdrU': T;

    /**
     * @default 'Offer expired animation'
     */
    ZXUjE: T;

    /**
     * @default 'Oops! Offer expired — let's find you a new one.'
     */
    Zo8nL: T;

    /**
     * @default 'We're sorry, the offer you selected is no longer available. We've taken you back to the product page where you can explore our latest offers and find a new one that's perfect for you!'
     */
    flDVI: T;

    /**
     * @default 'Sounds Good'
     */
    xAbHu: T;

    /**
     * @default '{{0}} - {{1}}'
     */
    iy4m2: T;

    /**
     * @default 'Select dates'
     */
    xyVOA: T;

    /**
     * @default 'Provide the age of child'
     */
    qnhUI: T;

    /**
     * @default 'Age must be at least 0'
     */
    XK89v: T;

    /**
     * @default 'Age must be 17 or under'
     */
    CLkze: T;

    /**
     * @default 'Select currency'
     */
    hjyj4: T;

    /**
     * @default 'in {{0}} {{1}}'
     */
    YGP8t: T;
  };
};

export type SuggestionsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  eventSuggestions: {
    'reg-get-started': {
      /**
       * @default 'Get Started'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Start your everything wedding registry today with Joy.'
       */
      hed: T;
    };
    'reg-shop': {
      /**
       * @default 'Add Gifts'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Shop the best brands, gift cards, and experiences in one place.'
       */
      hed: T;
    };
    'reg-connect-registries': {
      /**
       * @default 'Learn How'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Add gifts from any store or an entire registry.'
       */
      hed: T;
    };
    'reg-browse-cash-funds': {
      /**
       * @default 'Explore Cash Funds'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Create a zero-fee cash fund and save for anything.'
       */
      hed: T;
    };
    'reg-discount': {
      /**
       * @default 'Add More Gifts'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Get 20% off after the big day with our newlywed discount.'
       */
      hed: T;
    };
    'onboarding-designs': {
      /**
       * @default 'Edit Design'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Style your registry and give guests one seamless place to shop.'
       */
      hed: T;
    };
    'new-update-designs-2020-01-14': {
      /**
       * @default 'Browse Designs'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Design your website with 70+ new designs.'
       */
      hed: T;
    };
    'onboarding-add-page-photos': {
      /**
       * @default 'Edit Your Photo'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Have you added photos?'
       */
      hed: T;
    };
    writersblock: {
      /**
       * @default 'Try it out'
       */
      cta1: T;

      /**
       * @default ''
       */
      dek: T;

      /**
       * @default 'Overcome Wedding Writer’s Block with AI.'
       */
      hed: T;
    };
  };
  adminFeed: {
    /**
     * @default 'You're all set!

Take a breath, you're doing great.'
*/
    zeroStateMessage: T;

    /**
     * @default 'View Past Suggestions'
     */
    zeroStateViewPast: T;
  };
};

export type SurveyTranslations<T extends LeafNodeValue = TranslateFunction> = {
  buttons: {
    /**
     * @default 'OK'
     */
    nextLabel: T;

    /**
     * @default 'Back'
     */
    backLabel: T;

    /**
     * @default 'Submit'
     */
    submitLabel: T;

    /**
     * @default 'Skip'
     */
    skipLabel: T;
  };
  errors: {
    /**
     * @default 'Please complete the field above'
     */
    required: T;
  };
};

export type TestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'test in-CI translations'
   */
  test: T;
};

export type ThanksForRsvpTranslations<T extends LeafNodeValue = TranslateFunction> = {
  congratulationsCard: {
    /**
     * @default 'Back to Website'
     */
    backToWebsite: T;

    /**
     * @default 'the couple'
     */
    theCouple: T;

    /**
     * @default 'There was an error: {{msg}}. Please try again or contact support.'
     */
    error: T;

    /**
     * @default 'Your RSVP'
     */
    yourRSVP: T;

    /**
     * @default 'and card have'
     */
    andCardHave: T;

    /**
     * @default 'has'
     */
    has: T;

    /**
     * @default 'been sent{{coupleName}}’s event!'
     */
    beenSent: T;

    /**
     * @default 'Your RSVP has been sent.'
     */
    yourRSVPComplete: T;

    /**
     * @default 'Want to send a note of congrats?'
     */
    noteOfCongrats: T;

    /**
     * @default 'Congratulations Note'
     */
    noteTitle: T;

    /**
     * @default 'Your Note'
     */
    yourNoteTitle: T;

    /**
     * @default 'Add a note to the couple'
     */
    notePlaceholder: T;

    /**
     * @default 'Free'
     */
    free: T;

    /**
     * @default 'Congratulations eCard'
     */
    wrapTitle: T;

    /**
     * @default 'Wrap your note in a beautiful design.'
     */
    wrapDescription: T;

    /**
     * @default 'Back to Event Website'
     */
    backToEventWebsite: T;

    /**
     * @default 'Preview Your Note'
     */
    previewYourNote: T;

    /**
     * @default 'Send Message'
     */
    sendMessage: T;

    /**
     * @default 'Continue to Purchase'
     */
    continueToPurchase: T;

    /**
     * @default 'Your Email (Required for Replies)'
     */
    yourEmail: T;

    /**
     * @default 'Are you sure you want to continue without editing the congrats message?'
     */
    uneditedWarningMessage: T;

    /**
     * @default 'Next steps from Joy wedding experts'
     */
    whatNext: T;

    /**
     * @default 'Next steps from Joy wedding experts'
     */
    whatNextV2: T;

    emptyState: {
      /**
       * @default 'Event Details'
       */
      title: T;

      /**
       * @default 'Head back to the event website to find all the details.'
       */
      description: T;

      /**
       * @default 'Back to Website'
       */
      ctaText: T;
    };
    accommodations: {
      /**
       * @default 'We’ve secured discounted rates on a hotel near our venue.'
       */
      title: T;

      /**
       * @default 'Where To Stay'
       */
      titleNoRoomBlock: T;

      /**
       * @default 'Book soon while rooms are available.'
       */
      description: T;

      /**
       * @default 'We have listed our recommended hotel options for your convenience. Book soon while rooms are available.'
       */
      descriptionNoRoomBlock: T;

      /**
       * @default 'View Accommodations'
       */
      ctaText: T;
    };
    nearbyHotels: {
      withCityCopy: {
        /**
         * @default 'Book Your Stay'
         */
        heading: T;

        /**
         * @default 'Check out discounted rates in {{city}} for event guests.'
         */
        subHeading: T;

        /**
         * @default 'Browse Hotels'
         */
        ctaText: T;
      };
      genericCopy: {
        /**
         * @default 'Book Your Stay'
         */
        heading: T;

        /**
         * @default 'Check out discounted rates for event guests'
         */
        subHeading: T;

        /**
         * @default 'Browse Hotels'
         */
        ctaText: T;
      };
    };
    accommodationsV2: {
      /**
       * @default 'Where to Stay'
       */
      title: T;

      /**
       * @default 'We’ve reserved room blocks our special group'
       */
      descriptionRoomBlockOnly: T;

      /**
       * @default 'Here’s are a few places we’d love for everyone to stay.'
       */
      descriptionMultipleAccommodations: T;

      /**
       * @default 'Here’s where we recommend you stay near in the area.'
       */
      descriptionAccommodationPlaceOnly: T;

      /**
       * @default '{{miles}} miles from the venue'
       */
      distanceFromVenue: T;

      /**
       * @default 'Group Rate Ends {{date}}'
       */
      groupRateEnds: T;

      /**
       * @default 'View Room Block'
       */
      ctaRoomBlockOnly: T;

      /**
       * @default 'View Options'
       */
      ctaMultipleAccommodations: T;

      /**
       * @default 'View Stay'
       */
      ctaAccommodationPlaceOnly: T;
    };
    registry: {
      /**
       * @default 'View Registry'
       */
      ctaText: T;

      /**
       * @default 'Browse Registry'
       */
      heading: T;

      /**
       * @default 'Explore gifts {{eventName}} added to their registry.'
       */
      subHeadingWithName: T;
    };
  };
  accommodationsPushStep: {
    /**
     * @default 'Add Your Stay'
     */
    title: T;

    /**
     * @default 'Book your stay for the event and celebrate without a worry in the world.'
     */
    message: T;

    valueProps: {
      refundable: {
        /**
         * @default 'Stay Flexible'
         */
        title: T;

        /**
         * @default 'Pick fully refundable rates for peace of mind.'
         */
        description: T;
      };
      lowestRate: {
        /**
         * @default 'Lowest Rates'
         */
        title: T;

        /**
         * @default 'Exclusive rates for Joy events not available to the public.'
         */
        description: T;
      };
    };
    genericOfferingCard: {
      /**
       * @default 'Book Before Rooms Sell Out'
       */
      sellingFastBadge: T;

      /**
       * @default 'Hotels For Your Stay'
       */
      title: T;

      /**
       * @default 'Browse Hotels'
       */
      browseHotelsCta: T;
    };
    noAccomOrTravelCohort: {
      /**
       * @default 'Add Your Stay'
       */
      title: T;

      /**
       * @default 'Up to 20% off'
       */
      rateDisplayOverride: T;
    };
    hasOwnAccommodationsCohort: {
      /**
       * @default '{{eventDisplayName}}'s Preferred Hotels'
       */
      titleWithDisplayName: T;

      /**
       * @default 'Preferred Hotels'
       */
      genericTitle: T;

      /**
       * @default 'Stay near the venue, so you can spend more time with friends and family.'
       */
      message: T;

      /**
       * @default 'Select Hotel'
       */
      selectHotelCtaText: T;
    };
    offeringCard: {
      rateSection: {
        /**
         * @default 'Rate From'
         */
        title: T;

        rateType: {
          /**
           * @default 'Per Night'
           */
          daily: T;
        };
      };
      roomBlockRateSection: {
        /**
         * @default 'Book Before'
         */
        bookBefore: T;

        /**
         * @default 'Group Rate'
         */
        groupRate: T;

        /**
         * @default '{{price}} / Night'
         */
        pricePerNight: T;
      };
      distanceFromVenue: {
        /**
         * @default '{{distance}} miles from the venue'
         */
        mi: T;

        /**
         * @default '{{distance}} km from the venue'
         */
        km: T;
      };
    };
    footer: {
      /**
       * @default 'Not ready to book your stay?'
       */
      message: T;

      /**
       * @default 'Skip For Now'
       */
      ctaText: T;
    };
  };
  quick: {
    /**
     * @default 'Your RSVP and card have been sent for {{0}}'s event!'
     */
    Zfuw7: T;

    /**
     * @default 'Your RSVP and card have been sent!'
     */
    sU1ni: T;

    /**
     * @default 'Your RSVP has been sent for {{0}}'s event!'
     */
    qcZVi: T;

    /**
     * @default 'Your RSVP has been sent!'
     */
    JbyOY: T;

    /**
     * @default 'We've secured discounted rates on a hotel near our venue.'
     */
    fjK4Q: T;

    /**
     * @default 'Where To Stay'
     */
    xHHwM: T;

    /**
     * @default 'Book soon while rooms are available.'
     */
    u4LsD: T;

    /**
     * @default 'We have listed our recommended hotel options for your convenience. Book soon while rooms are available.'
     */
    bfNMI: T;

    /**
     * @default 'View Accommodations'
     */
    o4DHg: T;

    /**
     * @default 'Browse Registry'
     */
    DSLYE: T;

    /**
     * @default 'Explore gifts {{0}} added to their registry.'
     */
    '2vtJP': T;

    /**
     * @default 'View Registry'
     */
    gIPTc: T;

    /**
     * @default 'Event Details'
     */
    YixyG: T;

    /**
     * @default 'Head back to the event website to find all the details.'
     */
    OuHcC: T;

    /**
     * @default 'Back to Website'
     */
    dNvtn: T;

    /**
     * @default 'Explore gifts the couple added to their registry.'
     */
    r7sp6: T;

    /**
     * @default 'Explore gifts the host added to their registry.'
     */
    '1Dl8P': T;

    /**
     * @default 'Help'
     */
    lqULA: T;

    /**
     * @default 'About'
     */
    t7tcF: T;
  };
};

export type ThingsToDoCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  customPage: {
    thingsToDo: {
      /**
       * @default 'Thing to Do'
       */
      title: T;
    };
  };
  quick: {
    /**
     * @default 'Unable to fetch page info'
     */
    bbmol: T;

    /**
     * @default 'Name is required'
     */
    umtFL: T;

    /**
     * @default 'Please enter a valid URL'
     */
    evr6K: T;

    /**
     * @default 'Category is required'
     */
    B1r37: T;

    /**
     * @default 'Failed to update. Please try again.'
     */
    '8ExJZ': T;

    /**
     * @default 'Failed to create. Please try again.'
     */
    fL8dc: T;

    /**
     * @default 'Edit Thing to Do'
     */
    QRkZG: T;

    /**
     * @default 'Add Thing to Do'
     */
    '3HMGB': T;

    /**
     * @default 'Category'
     */
    Ixu8Y: T;

    /**
     * @default 'Custom Category'
     */
    liMFl: T;

    /**
     * @default 'Website'
     */
    d9Ykf: T;

    /**
     * @default 'thingtodo.com'
     */
    L1nEI: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Louvre Museum'
     */
    bz9OM: T;

    /**
     * @default 'Personal Note'
     */
    eIPUB: T;

    /**
     * @default 'Add some optional details about why you think your guests would enjoy it, things to know, etc.'
     */
    VZNll: T;

    /**
     * @default 'Delete Thing to Do'
     */
    '9Fw8F': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Thing to Do'
     */
    CdK0S: T;

    /**
     * @default 'What's Thing to Do'
     */
    SEDpN: T;

    /**
     * @default 'Give guests ideas for their free time during the trip.'
     */
    d36kk: T;
  };
};

export type TimePickerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Select time'
     */
    V1ZUG: T;

    /**
     * @default 'Clear time'
     */
    QtW3k: T;

    /**
     * @default 'Close time picker'
     */
    '91w6U': T;

    /**
     * @default 'Open time picker'
     */
    jYLit: T;

    /**
     * @default 'Time options'
     */
    rmNz2: T;

    /**
     * @default 'Time is outside the allowed range'
     */
    S6GLK: T;

    /**
     * @default 'Invalid time format'
     */
    lL8mj: T;

    /**
     * @default '{{0}}m'
     */
    NMOGt: T;

    /**
     * @default '{{0}}h'
     */
    IMOGt: T;

    /**
     * @default '{{0}}h {{1}}m'
     */
    '6sN6P': T;
  };
};

export type TourTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Close tour'
     */
    Yingr: T;

    /**
     * @default 'Previous'
     */
    RGyWS: T;

    /**
     * @default 'Next'
     */
    z2OMA: T;

    /**
     * @default 'Done'
     */
    mIwKA: T;

    /**
     * @default 'Show More Details'
     */
    '4PYQU': T;

    /**
     * @default 'Toggle expanded view'
     */
    '2kqqW': T;

    /**
     * @default 'Collapse'
     */
    f8LSD: T;

    /**
     * @default 'Why it’s our pick?'
     */
    JwBwB: T;
  };
};

export type TranslationTranslations<T extends LeafNodeValue = TranslateFunction> = {};

export type TravelAdminTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Why this hotel is a great pick'
     */
    BD018: T;

    /**
     * @default 'Proposed note from host to guest'
     */
    HIOEh: T;
  };
};

export type TravelEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  travelItemList: {
    /**
     * @default 'to'
     */
    to: T;

    /**
     * @default 'Listed Items'
     */
    listedItems: T;
  };
  delete: {
    /**
     * @default 'Are you sure you want to delete this item?'
     */
    title: T;

    /**
     * @default 'Are you sure you want to delete “{{travelItemTitle}}”? This cannot be undone.'
     */
    message: T;

    /**
     * @default 'Delete Travel Tip'
     */
    deleteCta: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'An error occurred while deleting your travel Item. Please try again.'
     */
    deleteError: T;

    /**
     * @default 'Success! Travel item have been deleted.'
     */
    deleteSuccess: T;
  };
  sort: {
    /**
     * @default 'An error occurred while sorting your travel Item. Please try again.'
     */
    sortError: T;

    /**
     * @default 'Success! Your Travel item order has been updated.'
     */
    sortSuccess: T;
  };
  addTravelTip: {
    /**
     * @default 'Add Travel Tip'
     */
    title: T;

    /**
     * @default 'Share travel plans with guests, including transportation options and general tips.'
     */
    subtitle: T;

    /**
     * @default 'General'
     */
    groupGeneral: T;

    /**
     * @default 'Transportation'
     */
    groupTransportation: T;

    /**
     * @default 'Accommodations'
     */
    groupAccommodations: T;

    /**
     * @default 'Share places to stay on the new Where to Stay page. 🎉'
     */
    groupAccommodationsSubtitle: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    booking: {
      /**
       * @default 'Booking Assistant'
       */
      title: T;
    };
    ferry: {
      /**
       * @default 'Ferry'
       */
      title: T;
    };
    flight: {
      /**
       * @default 'Flight / Airport'
       */
      title: T;
    };
    hotel: {
      /**
       * @default 'Hotel'
       */
      title: T;
    };
    list: {
      /**
       * @default 'Travel List'
       */
      title: T;
    };
    note: {
      /**
       * @default 'Travel Note'
       */
      title: T;
    };
    rentalCar: {
      /**
       * @default 'Rental Car'
       */
      title: T;
    };
    rentalHome: {
      /**
       * @default 'House / Rental'
       */
      title: T;
    };
    shuttle: {
      /**
       * @default 'Shuttle Schedule'
       */
      title: T;
    };
    taxi: {
      /**
       * @default 'Taxi Service'
       */
      title: T;
    };
    tent: {
      /**
       * @default 'Tents / Campsite'
       */
      title: T;
    };
    train: {
      /**
       * @default 'Train'
       */
      title: T;
    };
  };
  addTravelItem: {
    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Title'
     */
    title: T;

    /**
     * @default 'List Title'
     */
    listTitle: T;

    /**
     * @default 'Link'
     */
    link: T;

    /**
     * @default 'website.com'
     */
    linkFieldPlaceholder: T;

    /**
     * @default 'Update Url'
     */
    updateLink: T;

    /**
     * @default 'Note for Guests'
     */
    noteForGuests: T;

    /**
     * @default 'Venue Location'
     */
    venueLocation: T;

    /**
     * @default 'Address'
     */
    address: T;

    /**
     * @default 'Check In'
     */
    checkIn: T;

    /**
     * @default 'Check Out'
     */
    checkOut: T;

    /**
     * @default 'Item Description'
     */
    itemDescription: T;

    /**
     * @default 'Item Link'
     */
    itemLink: T;

    /**
     * @default 'website.com'
     */
    itemLinkPlaceholder: T;

    /**
     * @default 'Discount Code'
     */
    discountCode: T;

    /**
     * @default 'Remove Item'
     */
    removeItem: T;

    /**
     * @default 'Add Item'
     */
    addItem: T;

    /**
     * @default '01/01/2024'
     */
    datePlaceholder: T;

    /**
     * @default 'Location'
     */
    location: T;

    /**
     * @default 'Phone'
     */
    phone: T;

    /**
     * @default '+1-555-555-5555'
     */
    phonePlaceholder: T;

    /**
     * @default 'Pick-Up Date'
     */
    pickUpDate: T;

    /**
     * @default 'Start Time'
     */
    startTime: T;

    /**
     * @default 'End Time'
     */
    endTime: T;

    /**
     * @default '12:00pm'
     */
    timePlaceholder: T;

    /**
     * @default 'Shuttle Description'
     */
    shuttleDescription: T;

    /**
     * @default 'Pick Up Description'
     */
    shuttleDescriptionPlaceholder: T;

    /**
     * @default 'Please add a title'
     */
    titleError: T;

    /**
     * @default 'Please search for venue location'
     */
    addressError: T;

    /**
     * @default 'Please add a check in date.'
     */
    checkInDateError: T;

    /**
     * @default 'Please add a check out date.'
     */
    checkOutDateError: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    checkInDateRangeError: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    checkOutDateRangeError: T;

    /**
     * @default 'Your url is invalid.'
     */
    invalidURL: T;

    /**
     * @default 'The description has to be less than 5000 characters long.'
     */
    descriptionError: T;

    /**
     * @default 'Please add a note for guests'
     */
    guestNoteError: T;

    /**
     * @default 'Please add a location'
     */
    locationError: T;

    /**
     * @default 'Please add a pick-up date'
     */
    pickUpDateError: T;

    /**
     * @default 'Please add a start time'
     */
    startTimeError: T;

    /**
     * @default 'Please add an end time'
     */
    endTimeError: T;

    /**
     * @default 'An error occurred while addding your travel item. Please try again.'
     */
    addTravelItemError: T;

    /**
     * @default 'An error occurred while updating your travel item. Please try again.'
     */
    updateTravelItemError: T;

    /**
     * @default 'Success! Your changes have been saved.'
     */
    addTravelItemSuccess: T;

    /**
     * @default 'Delete Travel Tip'
     */
    deleteTravelTip: T;

    /**
     * @default 'Discounted Rates on Rental Cars'
     */
    hertzTitleDefaultText: T;

    /**
     * @default 'All of our guests receive up to 25% off car rentals. Extend your visit and enjoy your trip before and/or after our big day!'
     */
    hertzDescriptionDefaultText: T;

    booking: {
      title: {
        /**
         * @default 'Add Booking Assistant'
         */
        add: T;

        /**
         * @default 'Booking Assistant'
         */
        edit: T;
      };

      /**
       * @default 'Help your guests find and book hotels and rental cars near your venue.'
       */
      subtitle: T;
    };
    ferry: {
      title: {
        /**
         * @default 'Add Ferry'
         */
        add: T;

        /**
         * @default 'Ferry'
         */
        edit: T;
      };

      /**
       * @default 'Share ferry ports, a link to the schedule, and any other valuable info.'
       */
      subtitle: T;
    };
    flight: {
      title: {
        /**
         * @default 'Add Flight / Airport'
         */
        add: T;

        /**
         * @default 'Flight / Airport'
         */
        edit: T;
      };

      /**
       * @default 'Share flight, airport suggestions, or other instructions and details.'
       */
      subtitle: T;
    };
    hotel: {
      title: {
        /**
         * @default 'Add Hotel'
         */
        add: T;

        /**
         * @default 'Hotel'
         */
        edit: T;
      };

      /**
       * @default 'Share a hotel recommendation.'
       */
      subtitle: T;
    };
    list: {
      title: {
        /**
         * @default 'Add Travel List'
         */
        add: T;

        /**
         * @default 'Travel List'
         */
        edit: T;
      };

      /**
       * @default 'Create a list of things to do, what to bring, helpful links—anything!'
       */
      subtitle: T;
    };
    note: {
      title: {
        /**
         * @default 'Add Travel Note'
         */
        add: T;

        /**
         * @default 'Travel Note'
         */
        edit: T;
      };

      /**
       * @default 'This flexible travel tip allows you to write anything you want.'
       */
      subtitle: T;
    };
    rentalCar: {
      title: {
        /**
         * @default 'Add Rental Car'
         */
        add: T;

        /**
         * @default 'Rental Car'
         */
        edit: T;
      };

      /**
       * @default 'Share a rental car recommendation, location, and any other valuable info.'
       */
      subtitle: T;
    };
    rentalHome: {
      title: {
        /**
         * @default 'Add House / Rental'
         */
        add: T;

        /**
         * @default 'House / Rental'
         */
        edit: T;
      };

      /**
       * @default 'Share info about rentals or non-hotel accommodation options.'
       */
      subtitle: T;
    };
    shuttle: {
      title: {
        /**
         * @default 'Add Shuttle Schedule'
         */
        add: T;

        /**
         * @default 'Shuttle Schedule'
         */
        edit: T;
      };

      /**
       * @default 'Share details about your shuttle, the schedule, and any other valuable info.'
       */
      subtitle: T;
    };
    taxi: {
      title: {
        /**
         * @default 'Add Taxi Service'
         */
        add: T;

        /**
         * @default 'Taxi Service'
         */
        edit: T;
      };

      /**
       * @default 'Share a ride share or taxi service recommendation and any valuable info.'
       */
      subtitle: T;
    };
    tent: {
      title: {
        /**
         * @default 'Add Tents / Campsite'
         */
        add: T;

        /**
         * @default 'Tents / Campsite'
         */
        edit: T;
      };

      /**
       * @default 'Share info about camping.'
       */
      subtitle: T;
    };
    train: {
      title: {
        /**
         * @default 'Add Train'
         */
        add: T;

        /**
         * @default 'Train'
         */
        edit: T;
      };

      /**
       * @default 'Share train lines, stations, instructions, and any other valuable info.'
       */
      subtitle: T;
    };
  };
  hertz: {
    /**
     * @default 'Give guests up to 25% off rental cars from Hertz, Dollar and Thrifty.  ✨'
     */
    bannerTitle: T;

    /**
     * @default 'Remove Offer'
     */
    bannerCTA: T;

    /**
     * @default 'Are you sure you want to remove this exclusive deal for your guests?'
     */
    dialogTitleRemove: T;

    /**
     * @default 'Are you sure you want to delete this exclusive deal for your guests?'
     */
    dialogTitleDelete: T;

    /**
     * @default 'Car rentals are the second largest travel expense for your guests after they arrive. Joy has partnered with Hertz, Dollar, and Thrifty to provide your guests up to 25% off their rentals.'
     */
    dialogBody: T;

    /**
     * @default 'Keep discount for my guests'
     */
    dialogCTA1: T;

    /**
     * @default 'Remove this discount'
     */
    dialogCTA2Remove: T;

    /**
     * @default 'Delete this discount'
     */
    dialogCTA2Delete: T;
  };
  accommodationLinkDialog: {
    /**
     * @default 'Introducing Where to Stay'
     */
    title: T;

    /**
     * @default 'We’ve added a Where to Stay page to help you find and recommend the best accommodations for your guests. This page showcases your top picks and lets you see where guests are staying, making planning easier.'
     */
    subTitle: T;

    /**
     * @default 'Edit Page'
     */
    editPageCta: T;

    /**
     * @default 'Maybe Later'
     */
    willDoLaterCta: T;
  };
  quick: {
    /**
     * @default 'We added {{0}} new hotels to {{1}} already on the page.'
     */
    ag7Un: T;

    /**
     * @default 'We added {{0}} new hotels to the page.'
     */
    kfu1Q: T;

    /**
     * @default 'Dismiss summary'
     */
    GI5eC: T;
  };
};

export type TravelMapTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'San Francisco City Hall'
     */
    QSamB: T;

    /**
     * @default 'Martoca Beach Garden, Mexico'
     */
    mDNJp: T;

    /**
     * @default 'Bathers Pavilion, Balmoral Beach, Sydney'
     */
    EmVwH: T;

    /**
     * @default 'Heritage Hall, Vancouver, Canada'
     */
    FLFQv: T;

    /**
     * @default 'Amadeus, Maida Vale, London'
     */
    qQhJQ: T;

    /**
     * @default 'Garfield Park Conservatory, Chicago'
     */
    '7DsAT': T;

    /**
     * @default 'The Grove, Houston'
     */
    s6C2f: T;

    /**
     * @default 'The Plaza Hotel, New York City'
     */
    D7pDb: T;

    /**
     * @default 'Update your venue'
     */
    nT5yS: T;

    /**
     * @default 'Changing your venue location will update wherever it’s used. I.e. if you’ve already added hotels, distance and driving directions will be updated to this new location. '
     */
    nrRwf: T;

    /**
     * @default 'Update Venue'
     */
    oJ6DQ: T;

    /**
     * @default 'Event Venue'
     */
    DR5KP: T;

    /**
     * @default 'Please enter event venue.'
     */
    PuszU: T;

    /**
     * @default 'Confirm your venue'
     */
    YaRjF: T;

    /**
     * @default 'Let’s make sure your venue is up-to-date. Easily include venue details on your website. Get personalized guest travel itineraries near your event that you can customize.'
     */
    IiD72: T;

    /**
     * @default 'Looks Good'
     */
    pEuBw: T;

    /**
     * @default 'Add your venue'
     */
    Da5fk: T;

    /**
     * @default 'We’ll use this to personalize your guest website experience with maps, directions, things-to-do, nearby hotel picks and more.'
     */
    I2nTW: T;

    /**
     * @default 'Save Venue'
     */
    U5GvJ: T;

    /**
     * @default 'Event Venue or Destination'
     */
    GnCfE: T;

    /**
     * @default 'Are you sure you want to remove the venue?'
     */
    '19J67': T;

    /**
     * @default 'This cannot be undone.'
     */
    ps6oM: T;

    /**
     * @default 'Remove Venue'
     */
    TrTxf: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Failed to update event location'
     */
    ygdIS: T;

    /**
     * @default 'Super Admins Only'
     */
    rBTfL: T;

    /**
     * @default 'Also update my event location to {{0}}'
     */
    QznY7: T;

    /**
     * @default 'Also update my event location to match the venue'
     */
    XOTON: T;

    /**
     * @default 'Please search for a hotel'
     */
    sWJYp: T;

    /**
     * @default 'Please add an address'
     */
    WTsxe: T;

    /**
     * @default 'An error occurred while selecting the hotel. Please try again.'
     */
    Bqt1y: T;

    /**
     * @default 'We're sorry, we're having trouble generating a prompt. Try again'
     */
    B602e: T;

    /**
     * @default 'Explore this property'
     */
    YyEr3: T;

    /**
     * @default 'Thumbnail'
     */
    '8G1W3': T;

    /**
     * @default 'This is a preview of how this hotel will be displayed on your website. Guests click on this to view more details and book from your website.'
     */
    '2ruG0': T;

    /**
     * @default 'Why It’s Your Pick'
     */
    jAFA0: T;

    /**
     * @default 'Tell Guests Why'
     */
    GFwTU: T;

    /**
     * @default 'Write a note to guests about why you picked this hotel. Let them know any details you might want to share.'
     */
    k3yTL: T;

    /**
     * @default 'Suggest'
     */
    WmiYP: T;

    /**
     * @default 'Spotlight'
     */
    SQrWb: T;

    /**
     * @default 'Pick one hotel that will be displayed at the top of the list.'
     */
    hUNGC: T;

    /**
     * @default 'Mark as Spotlight'
     */
    jlLFK: T;

    /**
     * @default 'Marking a hotel as a favorite lets guests know you prefer them to book here. Your hotel will show a “favorites” badge on the link.'
     */
    wT0Sh: T;

    /**
     * @default 'We’re Staying Here'
     */
    Z5grC: T;

    /**
     * @default 'Let your guests know where you're staying.'
     */
    ZmHlr: T;

    /**
     * @default 'Where You’re Staying'
     */
    '3s0zf': T;

    /**
     * @default 'Let guests know where you’ll be staying. We’ll put this hotel first on your page and highlight it letting guests know with a label.'
     */
    RHKuh: T;

    /**
     * @default 'Hotel Room Block'
     */
    mLHNM: T;

    /**
     * @default 'Room Block'
     */
    uV3Vh: T;

    /**
     * @default 'Let guests know this is a group room block. You’ll be able to set the booking deadline and discount price.'
     */
    CLqrT: T;

    /**
     * @default 'Remove Stay from Page'
     */
    '4swaB': T;

    /**
     * @default 'Cancel Room Block'
     */
    Oabtb: T;

    /**
     * @default 'Room Block Details'
     */
    q2A2S: T;

    /**
     * @default 'Booking Link'
     */
    PuVic: T;

    /**
     * @default 'Room block booking link where guests will go to reserve your room block. It usually includes your special discount code applied.'
     */
    f6KtC: T;

    /**
     * @default 'www.examplehotel.com/myEvent'
     */
    xv1f3: T;

    /**
     * @default 'We do not have a room block link'
     */
    pZJif: T;

    /**
     * @default 'Check in'
     */
    '5cfjP': T;

    /**
     * @default 'Add a date'
     */
    qrRii: T;

    /**
     * @default 'Check out'
     */
    OY43P: T;

    /**
     * @default 'Dates'
     */
    pahrF: T;

    /**
     * @default 'Dates covered by your hotel room block and the nights you recommend guests book'
     */
    dGHBU: T;

    /**
     * @default 'Check-In'
     */
    O2ijP: T;

    /**
     * @default 'Check-Out'
     */
    V1s5P: T;

    /**
     * @default 'Book By Date'
     */
    Ct55u: T;

    /**
     * @default 'Enter the deadline for guests to book before your room block or special rate expires.'
     */
    jE6DK: T;

    /**
     * @default 'When does this deal expire?'
     */
    DEbsF: T;

    /**
     * @default 'Rooms Reserved'
     */
    '6jDa2': T;

    /**
     * @default 'Number of rooms included in your room block at this hotel.'
     */
    '9TH3a': T;

    /**
     * @default 'Group Price / Night'
     */
    Fi2cL: T;

    /**
     * @default 'The discounted nightly rate negotiated for your group so guests can see the special price.'
     */
    c2B0A: T;

    /**
     * @default 'Standard Price / Night'
     */
    BCeLf: T;

    /**
     * @default 'The regular nightly rate before the group discount is applied.'
     */
    '7r9Vc': T;

    /**
     * @default 'Edit Photo'
     */
    syk52: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Spotlight this hotel as your preferred choice so guests know where you'd like them to book.'
     */
    '5Swxg': T;

    /**
     * @default 'Standard price per night before group discount'
     */
    wLHvH: T;

    /**
     * @default 'Joy Hotel Room Block'
     */
    '2OD2k': T;

    /**
     * @default 'Please check this only if this is a room block that was secured by the Joy room block service.'
     */
    '2aCSW': T;

    /**
     * @default 'Loading...'
     */
    EWwiU: T;

    /**
     * @default 'We found {{0}} hotels near your venue!'
     */
    yjlCz: T;

    /**
     * @default 'Finding the best and most loved spots near your venue...'
     */
    dmw1P: T;

    /**
     * @default 'Unlocking your exclusive Joy rates...'
     */
    afe10: T;

    /**
     * @default 'Creating your personalized 'Where to Stay' guide...'
     */
    Jyhjg: T;

    /**
     * @default 'Locking in the best deals for your guests...'
     */
    JoMbC: T;

    /**
     * @default 'No room blocks needed - simple booking...'
     */
    '1p71E': T;

    /**
     * @default 'Simple & Budget-Friendly'
     */
    JmIrn: T;

    /**
     * @default 'For travelers who value savings and just need the essentials—clean, no-frills stays close to where you need to be.'
     */
    '0w7nY': T;

    /**
     * @default 'Comfort Meets Affordability'
     */
    K3v0E: T;

    /**
     * @default 'Reliable comfort with helpful amenities like free Wi‑Fi or breakfast. Great for quick getaways or overnight stays.'
     */
    ZFpCW: T;

    /**
     * @default 'Well‑Rounded & Convenient'
     */
    '33d3t': T;

    /**
     * @default 'A balanced stay with thoughtful service, comfortable rooms, and extra perks like on‑site dining or a fitness center.'
     */
    tJU9k: T;

    /**
     * @default 'Stylish & Full‑Service'
     */
    fUFEE: T;

    /**
     * @default 'Upscale comfort with modern design, excellent service, and amenities like spas, restaurants, or concierge support.'
     */
    mXvVg: T;

    /**
     * @default 'Luxury Without Limits'
     */
    LAzva: T;

    /**
     * @default 'World‑class hospitality, stunning interiors, and every detail considered—from gourmet dining to personalized experiences.'
     */
    TW8Qn: T;

    /**
     * @default 'Failed to save accommodation. Please try again.'
     */
    u2YRT: T;

    /**
     * @default 'Accommodation saved successfully.'
     */
    OjTEV: T;

    /**
     * @default 'Your Venue'
     */
    sPB4Q: T;

    /**
     * @default 'Why {{0}} is our pick?'
     */
    s4Hx0: T;

    /**
     * @default 'Start accommodations tour'
     */
    NcLdz: T;

    /**
     * @default 'Room Block Rates Without The Contract.'
     */
    YYISn: T;

    /**
     * @default 'Share guest stays, up to 40% with Joy.'
     */
    AI8XK: T;

    /**
     * @default 'We added {{0}} suggestions to get you started.'
     */
    eupdl: T;

    /**
     * @default 'Curate your list the way you want.'
     */
    QtQc7: T;

    /**
     * @default 'Venue tour step'
     */
    XnIoS: T;

    /**
     * @default 'Show Hotel Picks'
     */
    FhpIL: T;

    /**
     * @default 'Add Venue'
     */
    oK4pK: T;

    /**
     * @default 'Great deal for your guests'
     */
    '01ePN': T;

    /**
     * @default 'Unlock special event pricing you can't find anywhere else.'
     */
    y1Q7X: T;

    /**
     * @default 'Close to your venue'
     */
    FVsUU: T;

    /**
     * @default 'Just minutes away to save your guests' time and effort.'
     */
    cN3Js: T;

    /**
     * @default 'Most Trusted'
     */
    UNDnC: T;

    /**
     * @default 'Stays loved by other Joy couples and their guests.'
     */
    kekjH: T;

    /**
     * @default 'Top-tier amenities'
     */
    dfnLX: T;

    /**
     * @default 'Everything guests might need for a comfortable stay.'
     */
    GysTw: T;

    /**
     * @default 'Why is {{0}} our pick?'
     */
    iJ86Q: T;

    /**
     * @default 'On average, 85% of guests ask questions about accommodations.'
     */
    knfpG: T;

    /**
     * @default 'Help your guests save up to 40% on their stays.'
     */
    kNfvK: T;

    /**
     * @default 'We added {{0}} hotel suggestions to get you started.'
     */
    '4rQTC': T;

    /**
     * @default 'Room Block Rates Dialog'
     */
    D4n5x: T;

    /**
     * @default 'Welcome to Your 'Where to Stay' Guide'
     */
    '92ID8': T;

    /**
     * @default 'Room Block Rates Without The Contract'
     */
    '0B2kF': T;

    /**
     * @default 'Close Room Block Rates Dialog'
     */
    Z4hc2: T;

    /**
     * @default 'Your Venue Details'
     */
    WxjNu: T;

    /**
     * @default 'We will add hotel suggestions near your venue to get you started'
     */
    LU4gS: T;

    /**
     * @default 'Add Your Venue'
     */
    tFsbg: T;

    /**
     * @default 'Explore hotels and pick the ones that suit you best.'
     */
    DFfj3: T;

    /**
     * @default 'Explore Hotels with Special Rate'
     */
    B71b3: T;

    /**
     * @default 'I don’t have a venue yet'
     */
    TjZQ0: T;

    /**
     * @default 'This hotel hasn't opened bookings for the event dates yet.'
     */
    b0SEF: T;

    /**
     * @default 'This hotel is fully booked for the event dates.'
     */
    '71IVT': T;

    /**
     * @default 'Rates from'
     */
    F7VK6: T;

    /**
     * @default '{{0}}% off'
     */
    WdzDF: T;

    /**
     * @default 'Compared to'
     */
    SWS2n: T;

    /**
     * @default 'Explore This Property →'
     */
    '8Zn7K': T;

    /**
     * @default 'We will add hotel suggestions near your venue to get you started.'
     */
    dWeLe: T;

    /**
     * @default 'Explore Hotels with Joy Discounts'
     */
    CrBhF: T;

    /**
     * @default 'Room Block Rates Without “The Contract”'
     */
    l5EW6: T;

    /**
     * @default 'Bookings'
     */
    mV0kh: T;

    /**
     * @default 'Stays'
     */
    '4g76G': T;

    /**
     * @default 'Joy will look for the best options around your event date. Click here to update the event date.'
     */
    S0zyM: T;

    /**
     * @default '{{0}} {{1}}'
     */
    jxqdm: T;

    /**
     * @default 'Explore Hotels'
     */
    ucmCV: T;

    /**
     * @default 'Why it’s our pick?'
     */
    JwBwB: T;

    /**
     * @default 'Please select an address from the dropdown'
     */
    ZmjX1: T;

    /**
     * @default 'Please enter a valid URL.'
     */
    oFDkI: T;

    /**
     * @default 'Hotel'
     */
    YWiDG: T;

    /**
     * @default 'House / Rental'
     */
    DHr3V: T;

    /**
     * @default 'Tent / Campsite'
     */
    AEInG: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Use Joy Travel'
     */
    dmr0V: T;

    /**
     * @default 'Use My Own Link'
     */
    JKaRO: T;

    /**
     * @default 'Hotel Link Tip'
     */
    nME3x: T;

    /**
     * @default 'Got your own booking link? Use it here! If you uncheck this, we'll link to the hotel on Joy — where your guests can book rooms at a special group rate just for them (not available to the public) and reserve right from your wedding site.'
     */
    zk3IG: T;

    /**
     * @default 'View hotel on Joy'
     */
    iqopQ: T;

    /**
     * @default 'Type'
     */
    YjONA: T;

    /**
     * @default 'Note for Guests'
     */
    ijXsE: T;

    /**
     * @default 'A note to share with your guests about this hotel.'
     */
    wYK19: T;

    /**
     * @default 'We're Staying Here'
     */
    zR9rJ: T;

    /**
     * @default 'Where You're Staying'
     */
    '5UfVd': T;

    /**
     * @default 'Let guest know where you'll be staying. We'll put this hotel first on your page and highlight it letting guest know with a label.'
     */
    xcqoE: T;

    /**
     * @default 'Let guests know this is a group room block. You'll be able to set the booking deadline and discount price.'
     */
    YvYep: T;

    /**
     * @default 'Please add a hotel booking link.'
     */
    XB2jT: T;

    /**
     * @default 'Please add a check in date.'
     */
    l6DNB: T;

    /**
     * @default 'Check in date must be before check out date'
     */
    gHC0Z: T;

    /**
     * @default 'Please add a check out date.'
     */
    Cg5uL: T;

    /**
     * @default 'Check out date must be after check in date'
     */
    Z8CWJ: T;

    /**
     * @default 'Please add cutoff date.'
     */
    '0L83g': T;

    /**
     * @default 'Please enter the number of rooms reserved.'
     */
    Hv9VA: T;

    /**
     * @default 'Please enter a valid number of rooms reserved.'
     */
    '7RhLK': T;

    /**
     * @default 'Please add price per night.'
     */
    v1UsT: T;

    /**
     * @default 'Please enter the valid Joy price for the hotel.'
     */
    '2dPVz': T;

    /**
     * @default 'Please enter the valid Initial price for the hotel.'
     */
    '84dTt': T;

    /**
     * @default 'Booked on {{0}}'
     */
    tesEN: T;

    /**
     * @default 'Close Auto Populated More Hotels Tooltip'
     */
    '2Y1ik': T;

    /**
     * @default 'We added more hotel suggestions near your new venue.'
     */
    UwFUQ: T;

    /**
     * @default 'Newly Added'
     */
    '37YII': T;

    /**
     * @default 'Handpicked hotels for you. Manage them in Joy'
     */
    e7N8l: T;

    /**
     * @default 'View Hotel Picks'
     */
    '5UwWB': T;

    /**
     * @default 'Help guests save up to 40% on stays'
     */
    V23cp: T;

    /**
     * @default 'More flexibility in room choice and dates'
     */
    Z5fvf: T;

    /**
     * @default 'No commitments or penalties'
     */
    PiSkS: T;

    /**
     * @default 'Big savings, zero commitments'
     */
    DLRbN: T;

    /**
     * @default 'Same hotels. Better rates.'
     */
    '8zGPA': T;

    /**
     * @default 'Exclusive hotel rates for Joy hosts and guests.'
     */
    LFop6: T;
  };
};

export type TravelNativeCheckoutTranslations<T extends LeafNodeValue = TranslateFunction> = {
  errorScreen404: {
    /**
     * @default 'Return to event site'
     */
    action: T;

    /**
     * @default 'That link doesn't seem to exist or may have expired.'
     */
    body: T;

    /**
     * @default 'Let's get this cleaned up.'
     */
    subtitle: T;

    /**
     * @default 'Error on Aisle 404'
     */
    title: T;
  };
  errorScreen500: {
    /**
     * @default 'Return to event site'
     */
    returnToSite: T;

    /**
     * @default 'Choose another room'
     */
    returnToHotelPage: T;

    /**
     * @default 'That link doesn't seem to exist or may have expired.'
     */
    body: T;

    /**
     * @default 'Let's get this cleaned up.'
     */
    subtitle: T;

    /**
     * @default 'Error'
     */
    title: T;
  };
  errorScreenInline: {
    /**
     * @default 'Something went wrong while processing your request. Please try again later or contact support if the issue persists.'
     */
    body: T;

    /**
     * @default 'Let's get this cleaned up.'
     */
    subtitle: T;

    /**
     * @default 'Error'
     */
    title: T;
  };

  /**
   * @default 'or'
   */
  expressPaymentDivide: T;

  formActions: {
    /**
     * @default 'Book Now'
     */
    confirmReservation: T;

    /**
     * @default 'Continue to Payment'
     */
    createReservation: T;
  };

  /**
   * @default 'We couldn't process your reservation at this time. Please try again later or contact support at <link/>.'
   */
  formErrorFailedReservationLine1: T;

  formErrors: {
    /**
     * @default 'There was an error creating your reservation. Please try again later.'
     */
    createReservation: T;

    /**
     * @default 'The hotel offer you tried to book has expired. Please select a new offer to book this hotel.'
     */
    invalidOfferExpired: T;

    /**
     * @default 'Select new offer'
     */
    invalidOfferExpiredAction: T;

    /**
     * @default 'Sorry, we couldn't load your payment options at this time. Please try again.'
     */
    failedLoadingPaymentMethods: T;

    /**
     * @default 'Try Again'
     */
    failedLoadingPaymentMethodsAction: T;

    /**
     * @default 'If you have any questions, please reach out to our support team.'
     */
    failedReservationLine2: T;

    /**
     * @default 'Something went wrong'
     */
    failedReservationTitle: T;

    /**
     * @default 'We couldn't process your credit card information, but don't worry, your card hasn't been charged. Please double-check your details and try again.'
     */
    submissionFailed: T;

    /**
     * @default 'Try again'
     */
    submissionFailedAction: T;
  };
  formFields: {
    /**
     * @default 'Street Address'
     */
    addressLine1: T;

    /**
     * @default 'Street Address is required'
     */
    addressLine1Required: T;

    /**
     * @default 'Apartment, Suite, etc. (optional)'
     */
    addressLine2: T;

    /**
     * @default 'City'
     */
    city: T;

    /**
     * @default 'City is required'
     */
    cityRequired: T;

    /**
     * @default 'Country'
     */
    country: T;

    /**
     * @default 'Country is required'
     */
    countryRequired: T;

    /**
     * @default 'Please select a valid country'
     */
    countryValid: T;

    /**
     * @default 'Please enter a valid credit card number'
     */
    creditCardRequired: T;

    /**
     * @default 'Email Address'
     */
    email: T;

    /**
     * @default 'Please enter a valid email address'
     */
    emailInvalid: T;

    /**
     * @default 'Email address is required'
     */
    emailRequired: T;

    /**
     * @default 'First Name'
     */
    firstName: T;

    /**
     * @default 'First Name is required'
     */
    firstNameRequired: T;

    /**
     * @default 'Last Name'
     */
    lastName: T;

    /**
     * @default 'Last Name is required'
     */
    lastNameRequired: T;

    /**
     * @default 'Title'
     */
    personTitle: T;

    /**
     * @default 'Title is required'
     */
    personTitleRequired: T;

    personTitles: {
      /**
       * @default 'Dr.'
       */
      dr: T;

      /**
       * @default 'Miss'
       */
      miss: T;

      /**
       * @default 'Mr.'
       */
      mr: T;

      /**
       * @default 'Mrs.'
       */
      mrs: T;

      /**
       * @default 'Ms.'
       */
      ms: T;
    };

    /**
     * @default 'Phone Number'
     */
    phone: T;

    /**
     * @default 'Please enter a valid phone number'
     */
    phoneInvalid: T;

    /**
     * @default 'Phone number is required'
     */
    phoneRequired: T;

    /**
     * @default 'ZIP/Postal Code'
     */
    postalCode: T;

    /**
     * @default 'ZIP/Postal Code is required'
     */
    postalCodeRequired: T;

    /**
     * @default 'State/Province/Region'
     */
    state: T;

    /**
     * @default 'State/Province/Region is required'
     */
    stateRequired: T;
  };

  /**
   * @default 'Room {{roomNumber}}'
   */
  formTitleRoom: T;

  /**
   * @default 'Adult {{adultNumber}}'
   */
  formTitleRoomContact: T;

  formTitles: {
    /**
     * @default 'Billing Address'
     */
    billing: T;

    /**
     * @default 'Payment'
     */
    payment: T;

    /**
     * @default 'Protected Checkout'
     */
    protectedPayment: T;
  };
  securityFeatures: {
    /**
     * @default '✓'
     */
    checkMark: T;

    /**
     * @default 'We use secure transmission'
     */
    primaryCta: T;

    /**
     * @default 'We protect your personal information'
     */
    secondaryCta: T;
  };
  paymentErrorOutcome: {
    /**
     * @default 'Your payment was canceled. Please try again.'
     */
    canceled: T;

    /**
     * @default 'We couldn't retrieve your payment. Please try again.'
     */
    failed_to_retrieve: T;

    /**
     * @default 'A valid payment method is required. Please update your payment details.'
     */
    requires_payment_method: T;

    /**
     * @default 'Your payment requires confirmation. Please follow the instructions to complete your payment.'
     */
    requires_confirmation: T;
  };

  /**
   * @default 'Complete Secure Booking'
   */
  checkoutHeader: T;

  /**
   * @default 'Who's checking in?'
   */
  checkingInCta: T;

  /**
   * @default 'This payment will be processed in the US and credit card provided will be charged immediately for the full amount of the reservation.'
   */
  paymentProcessing: T;

  /**
   * @default 'Great pick! Book your room before rates change.'
   */
  promotionalBanner: T;

  /**
   * @default '✨'
   */
  promotionalBannerFlair: T;

  /**
   * @default 'Great pick!'
   */
  promotionalBannerFlairAriaLabel: T;

  /**
     * @default 'Hello,

I have a question about my booking attempt for {{hotelName}} from {{bookingStartDate}} to {{bookingEndDate}} under the name {{guestName}}.

Details:
- Hotel: {{hotelName}}
- Dates: {{bookingStartDate}} to {{bookingEndDate}}
- Guest: {{guestName}}
- Reservation ID: {{reservationId}}
Thank you!'
*/
  checkoutErrorSupportEmailBody: T;

  /**
   * @default 'Booking Inquiry for {{hotelName}}'
   */
  checkoutErrorSupportEmailSubject: T;

  reservationStatus: {
    /**
     * @default 'Booking Status'
     */
    bookingStatusEyebrow: T;

    /**
     * @default '<Icon/> Pending'
     */
    statusPending: T;

    /**
     * @default '<Icon/> Failed'
     */
    statusError: T;

    /**
     * @default 'Room'
     */
    room: T;

    /**
     * @default 'Close'
     */
    close: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'Phone'
     */
    phone: T;

    /**
     * @default 'Check-in'
     */
    checkIn: T;

    /**
     * @default 'Check-out'
     */
    checkOut: T;

    /**
     * @default 'Error: {{error}}'
     */
    error: T;

    /**
     * @default 'Cancelling...'
     */
    cancelling: T;

    /**
     * @default 'Cancel Booking'
     */
    cancelBooking: T;

    /**
     * @default 'Non Refundable'
     */
    nonRefundable: T;

    /**
     * @default 'Free Cancellation'
     */
    freeCancellation: T;

    /**
     * @default 'cancellation policy'
     */
    cancellationPolicy: T;

    /**
     * @default 'Back to event website'
     */
    backToEventWebsite: T;

    /**
     * @default 'Confirming the booking...'
     */
    confirmingBooking: T;

    /**
     * @default 'Awaiting confirmation code'
     */
    awaitingConfirmationCode: T;

    /**
     * @default 'Back to Booking Confirmation'
     */
    backToBookingConfirmation: T;

    /**
     * @default 'We were unable to complete your booking.'
     */
    bookingFailed: T;

    /**
     * @default 'Try again'
     */
    tryAgain: T;

    /**
     * @default 'Thank you, {{firstName}},<LineBreak/>your booking is confirmed.'
     */
    thankYouMessage: T;

    /**
     * @default 'We'll send an email confirmation for your booking to <Email/>'
     */
    emailConfirmation: T;

    /**
     * @default 'We encountered an error while fetching your reservation details.'
     */
    fetchError: T;

    /**
     * @default 'You can cancel this booking for free. Please review our <CancellationPolicy/> for full details on refunds.'
     */
    cancellationRefundable: T;

    /**
     * @default 'The cost of the cancellation was 100% of the total amount due to non refundable cancellation policy for this booking.'
     */
    cancellationNonRefundable: T;

    /**
     * @default 'Booking Number'
     */
    bookingNumber: T;

    /**
     * @default 'Provider Confirmation'
     */
    providerConfirmation: T;

    /**
     * @default 'Manage Booking'
     */
    manageBooking: T;

    /**
     * @default 'It is now safe to close this window.'
     */
    safeToCloseWindow: T;

    /**
     * @default 'Success'
     */
    successImgAlt: T;

    /**
     * @default 'Failure'
     */
    failureImgAlt: T;

    /**
     * @default 'In Progress'
     */
    inProgressImgAlt: T;

    checkingInSection: {
      /**
       * @default 'Who's checking in?'
       */
      title: T;

      /**
       * @default 'Name'
       */
      nameLabel: T;
    };

    /**
     * @default 'Your booking has been cancelled.'
     */
    bookingCancelled: T;

    /**
     * @default 'Reservation Details'
     */
    reservationDetailsTitle: T;

    supportSection: {
      /**
       * @default 'For support'
       */
      title: T;

      /**
       * @default 'Contact {{supportName}} at <SupportEmail/> for booking related questions.'
       */
      message: T;

      /**
       * @default 'Customer Support'
       */
      defaultCustomerSupportName: T;
    };
    fullRefund: {
      /**
       * @default 'This booking is fully refundable'
       */
      title: T;

      /**
       * @default 'You will be refunded entire amount.'
       */
      description: T;
    };
    partialRefund: {
      /**
       * @default 'This booking is partially refundable'
       */
      title: T;

      /**
       * @default 'You will pay around {{estimatedCancellationFeeInPercent}}% of booking.'
       */
      description: T;
    };
    noRefund: {
      /**
       * @default 'This booking is non-refundable'
       */
      title: T;

      /**
       * @default 'You will not be refunded any amount.'
       */
      description: T;
    };
    rateWarning: {
      /**
       * @default 'Rate Will Be Lost'
       */
      title: T;

      /**
       * @default 'If you cancel, you will lose this rate and might not get the similar one.'
       */
      description: T;
    };
    exclusiveDiscount: {
      /**
       * @default 'Exclusive Discounted Rates on Joy'
       */
      title: T;

      /**
       * @default 'On Joy, you get rates available only for our couples and guests.'
       */
      description: T;
    };

    /**
     * @default 'Total Cancellation Cost {{estimatedCancellationFee}}'
     */
    cancellationAmountDescription: T;

    cancellationDialog: {
      /**
       * @default 'Cancellation Unsuccessful'
       */
      cancellationUnsuccessful: T;

      /**
       * @default 'Booking Cancelled Successfully'
       */
      bookingCancelledSuccessfully: T;

      /**
       * @default 'Are you sure you want to cancel this booking?'
       */
      cancelThisBooking: T;

      /**
       * @default 'Your booking has been successfully cancelled. If this was a mistake, please contact customer support at <SupportEmail/>.'
       */
      bookingCancelledRefresh: T;

      /**
       * @default 'We’re sorry, but we couldn’t process your cancellation request. Please contact our support team at <SupportEmail/> with your booking ID for assistance.'
       */
      contactCustomerSupport: T;
    };
    draftStatus: {
      /**
       * @default 'Your payment has been processed successfully!'
       */
      title: T;

      /**
     * @default 'This is not a confirmed booking - at least not yet. 
You’ll get a confirmation email within one hour to
<Email/>'
*/
      message: T;
    };
    failedStatus: {
      /**
       * @default 'Your payment has failed'
       */
      title: T;

      /**
       * @default 'Unfortunately, were not unable to complete you booking. Your payment will be refunded within 24 hours.'
       */
      message: T;
    };
    loadingStatus: {
      /**
       * @default 'Yay! You’re one step away from your trip.'
       */
      title: T;

      /**
       * @default 'We’re currently processing your payment, it might take a couple of moments.'
       */
      message: T;
    };
  };
  reservationStatusSearchPage: {
    /**
     * @default 'Email Address'
     */
    email: T;

    /**
     * @default 'Booking ID'
     */
    bookingId: T;

    /**
     * @default 'Get Details'
     */
    getDetails: T;

    /**
     * @default 'Email address is required'
     */
    emailRequired: T;

    /**
     * @default 'Booking ID is required'
     */
    bookingIdRequired: T;

    /**
     * @default 'Find Your Reservation'
     */
    findYourReservation: T;

    /**
     * @default 'Please enter a valid email address'
     */
    emailInvalid: T;

    /**
     * @default 'Unable to search for reservations. Please try again.'
     */
    unableToSearchForReservations: T;

    /**
     * @default 'No reservations found with the provided details. Please check your booking ID and email address.'
     */
    noReservationsFound: T;

    /**
     * @default 'Enter both your booking ID and email address to view your reservation status'
     */
    enterBothYourBookingIdAndEmailAddressToViewYourReservationStatus: T;
  };
  quick: {
    /**
     * @default 'Uh oh! Seems like this offer is no longer available'
     */
    '4LomP': T;

    /**
     * @default 'Don’t worry we have other great offers at this hotel for you to select from.'
     */
    H7P2W: T;

    /**
     * @default 'Pick New Offer'
     */
    '5NjfN': T;

    /**
     * @default 'Offer expired animation'
     */
    ZXUjE: T;

    /**
     * @default 'Booking ID is required'
     */
    bKd7J: T;

    /**
     * @default 'Please enter a valid email address'
     */
    Zf7AP: T;

    /**
     * @default 'Email is required'
     */
    XN2CQ: T;

    /**
     * @default 'No reservations found with the provided details. Please check your booking ID and email address.'
     */
    SjLQY: T;

    /**
     * @default 'Unable to search for reservations. Please try again.'
     */
    Jabc1: T;

    /**
     * @default 'Find Your Reservation'
     */
    '6iLoS': T;

    /**
     * @default 'Enter both your booking ID and email address to view your reservation status'
     */
    KFbxd: T;

    /**
     * @default 'Booking ID'
     */
    cFX9r: T;

    /**
     * @default 'Email'
     */
    QwOyF: T;

    /**
     * @default 'Get Details'
     */
    '8hjQY': T;
  };
};

export type UniversalRecommendationsTranslations<T extends LeafNodeValue = TranslateFunction> = {
  productTile: {
    /**
     * @default 'While copying your gifts we may have found something better.'
     */
    title: T;

    /**
     * @default 'Added to your registry!'
     */
    postAddTitle: T;

    /**
     * @default 'You might also like this:'
     */
    postAddSubtitle: T;

    /**
     * @default 'Tell Me More'
     */
    TellMeMoreBtn: T;

    /**
     * @default 'Skip'
     */
    SkipBtn: T;

    /**
     * @default 'Swap Gift'
     */
    SwapGiftBtn: T;

    /**
     * @default 'Remind Me Later'
     */
    RemindMeLater: T;
  };
  notifiers: {
    /**
     * @default 'You’ve got recomendations'
     */
    notification: T;

    /**
     * @default 'All your registries have been transferred'
     */
    bannerTitle: T;

    /**
     * @default 'We found some recommendations that you may like!'
     */
    bannerSubtitle: T;

    /**
     * @default 'View Recommendations'
     */
    bannerBtn: T;

    /**
     * @default 'Registry {{currentIndex}} of {{totalItems}}'
     */
    registryCount: T;
  };
};

export type UnpublishedWebsiteTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Welcome'
     */
    oKwVg: T;

    /**
     * @default 'This site is still in the works.'
     */
    PNQZA: T;

    /**
     * @default 'Exciting things are happening behind the scenes. The site is currently under construction and will be unveiled here shortly. Please check back soon for all the details.'
     */
    VwvLV: T;

    /**
     * @default 'Planning your own event?'
     */
    n643y: T;

    /**
     * @default 'Create your own event website, invite guests and share all the details with Joy.'
     */
    kypCp: T;

    /**
     * @default 'Learn More'
     */
    la3zL: T;
  };
};

export type UpdateScheduleDialogTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Would you like to update your Schedule to match the new date?'
     */
    '1vOLL': T;

    /**
     * @default 'Make sure all the events in your Schedule are up to date.'
     */
    HsdbQ: T;

    /**
     * @default 'Take Me to Schedule'
     */
    rAtB3: T;
  };
};

export type VendorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  addCollections: {
    /**
     * @default 'Create'
     */
    create: T;

    /**
     * @default 'Description'
     */
    description: T;

    /**
     * @default 'Create Collection'
     */
    formTitle: T;

    /**
     * @default 'Name'
     */
    name: T;
  };
  addTestimonialDialog: {
    /**
     * @default 'Add'
     */
    add: T;

    /**
     * @default 'Add Testimonial'
     */
    addTestimonial: T;

    /**
     * @default 'Content'
     */
    content: T;

    /**
     * @default 'Reviewer'
     */
    reviewer: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Update Testimonial'
     */
    updateTestimonial: T;
  };
  adminEditCollections: {
    /**
     * @default 'New Collection'
     */
    addCollectionButtonTitle: T;

    /**
     * @default 'Create photo collections to curate and highlight your work to couples.'
     */
    pageDescriptionTest: T;

    /**
     * @default 'Collections'
     */
    pageTitle: T;
  };
  adminEditProfile: {
    /**
     * @default 'Edit Profile'
     */
    pageTitle: T;
  };
  adminEditSingleCollection: {
    /**
     * @default 'Add Photo'
     */
    addCollectionItemButtonTitle: T;

    /**
     * @default 'Collection items could not be saved'
     */
    generalError: T;

    /**
     * @default 'Saving'
     */
    savingCollection: T;
  };

  /**
   * @default 'Recent'
   */
  adminVendorListMostRecent: T;

  collections: {
    /**
     * @default 'More Collections'
     */
    moreCollections: T;
  };

  /**
   * @default 'Create Vendor'
   */
  createVendor: T;

  createVendorDialog: {
    /**
     * @default 'Choose a vendor type'
     */
    chooseAType: T;

    /**
     * @default 'Done'
     */
    done: T;

    /**
     * @default 'Enter vendor information'
     */
    enterVendorInfo: T;

    /**
     * @default 'Failed to create vendor'
     */
    failedToMakeVendor: T;

    /**
     * @default 'Next'
     */
    next: T;

    /**
     * @default 'Submitted'
     */
    submitted: T;

    /**
     * @default 'You made a vendor'
     */
    youMadeAVendor: T;
  };
  createVendorForm: {
    /**
     * @default 'Address'
     */
    addressTitle: T;

    /**
     * @default 'Bio'
     */
    bioTitle: T;

    /**
     * @default 'Contact Email'
     */
    contactEmailTitle: T;

    /**
     * @default 'Handle'
     */
    handleTitle: T;

    /**
     * @default 'Name'
     */
    nameTitle: T;

    /**
     * @default 'Website'
     */
    websiteTitle: T;
  };

  /**
   * @default 'Edit About'
   */
  editAbout: T;

  editCollection: {
    /**
     * @default 'Description'
     */
    description: T;

    /**
     * @default 'Edit Collection'
     */
    formTitle: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Save'
     */
    submitText: T;
  };

  /**
   * @default 'Edit Collections'
   */
  editCollections: T;

  /**
   * @default 'Edit Profile'
   */
  editProfile: T;

  /**
   * @default 'Edit Vendor'
   */
  editVendor: T;

  /**
   * @default 'Put your best foot forward. Edit what guests and your peers see when you’re showcased on your couple’s wedding websites.'
   */
  editWhatGuestsSee: T;

  experienceHeader: {
    /**
     * @default 'Display your services and create beautiful curated collections to highlight your work.'
     */
    bulletADescription: T;

    /**
     * @default 'Present yourself as a professional'
     */
    bulletATitle: T;

    /**
     * @default 'Simple for couples to connect and make sure your services is right for them.'
     */
    bulletBDescription: T;

    /**
     * @default 'Grow your business'
     */
    bulletBTitle: T;

    /**
     * @default 'Grow your photography business with your first upload. Our algorithm surfaces local new photographs and photographers to couples on Joy.'
     */
    description: T;

    /**
     * @default 'Immediate Exposure'
     */
    title: T;
  };
  headerMenu: {
    /**
     * @default 'Account'
     */
    account: T;

    /**
     * @default 'Dashboard'
     */
    dashboard: T;

    /**
     * @default 'Ideabooks'
     */
    ideabooks: T;

    /**
     * @default 'Sign Out'
     */
    signout: T;

    /**
     * @default 'View Profile'
     */
    viewProfile: T;

    /**
     * @default 'Liked Photos'
     */
    likedPhotos: T;

    /**
     * @default 'Vendor Shortlist'
     */
    shortlist: T;

    /**
     * @default 'Sent Messages'
     */
    messages: T;

    /**
     * @default 'Sign Up'
     */
    signup: T;

    /**
     * @default 'Sign In'
     */
    signin: T;
  };

  /**
   * @default 'Here are the Joy couples who have showcased your work on their wedding website.'
   */
  howCouplesSeeYou: T;

  inquiry: {
    /**
     * @default 'Accept Lead'
     */
    acceptButtonTitle: T;

    /**
     * @default 'Unauthorized to accept lead'
     */
    acceptErrorUnauthorized: T;

    /**
     * @default 'Lead Accepted'
     */
    leadAccepted: T;

    /**
     * @default 'Respond'
     */
    replyButtonTitle: T;

    /**
     * @default '{{name}} would like to work with you.'
     */
    title: T;
  };
  lightbox: {
    /**
     * @default 'in {{categoryName}}'
     */
    categoryText: T;

    /**
     * @default 'More from {{collectionName}}'
     */
    moreFrom: T;
  };
  manageCollections: {
    /**
     * @default 'Add Collection'
     */
    addCollection: T;

    /**
     * @default 'Back to Vendor Info'
     */
    backToVendorInfo: T;

    /**
     * @default 'No Collections'
     */
    noCollections: T;
  };
  manageSingleCollection: {
    /**
     * @default 'Add photo'
     */
    addNewPhoto: T;

    /**
     * @default 'Back to vendor collections'
     */
    backToVendorCollections: T;

    /**
     * @default 'Edit Collection'
     */
    editCollection: T;
  };
  manageVendorInfo: {
    /**
     * @default 'Add Review'
     */
    addTestimonial: T;

    /**
     * @default 'Add Vendor User'
     */
    addVendorUserSectionTitle: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Copy Claim Token'
     */
    copyClaimToken: T;

    /**
     * @default 'Vendor CRUD Dashboard'
     */
    dashBoardTitle: T;

    /**
     * @default 'Edit Review'
     */
    editTestimonial: T;

    /**
     * @default 'Edit'
     */
    editVendorUserSectionTitle: T;

    /**
     * @default 'Manage Collections'
     */
    manageCollections: T;

    /**
     * @default 'Refresh Claim Token'
     */
    refreshClaimToken: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Status: {{status}}'
     */
    status: T;

    /**
     * @default 'What folks are saying'
     */
    testimonials: T;

    /**
     * @default 'Help guide couples on if their budget if right for your services by providing some pricing guidelines'
     */
    testimonialsSubTitle: T;

    /**
     * @default 'Title: {{title}}'
     */
    title: T;

    /**
     * @default 'Vendor Users'
     */
    vendorUserSectionTitle: T;

    /**
     * @default 'View Profile'
     */
    viewVendorProfileButton: T;
  };
  menu: {
    /**
     * @default 'About'
     */
    about: T;

    /**
     * @default 'Collections'
     */
    collections: T;

    /**
     * @default 'Photos'
     */
    highlights: T;

    /**
     * @default 'Reviews'
     */
    reviews: T;
  };
  messageVendor: {
    /**
     * @default 'Cancel'
     */
    cancelButtonTitle: T;

    /**
     * @default 'create an account'
     */
    createAccount: T;

    /**
     * @default 'Get Pricing'
     */
    messageButtonTitle: T;

    /**
     * @default 'Get Pricing'
     */
    messageButtonTitleLonger: T;

    /**
     * @default 'Check Availability'
     */
    messageButtonCheckAvailability: T;

    /**
     * @default 'Contact <VendorName/>'
     */
    messageDialogTitle: T;

    /**
     * @default 'Message'
     */
    messageFieldTitle: T;

    /**
     * @default 'Sign in to send your message.'
     */
    mustBeSignedIn: T;

    /**
     * @default 'For a prompt and detailed response, include your date, location, budget, and what draws you to the work.'
     */
    prompt: T;

    /**
     * @default 'Sign-in'
     */
    signIn: T;

    /**
     * @default '<SignIn/> or <CreateAccount/> to continue'
     */
    signInOrCreate: T;

    /**
     * @default 'Send'
     */
    submitButtonTitle: T;

    /**
     * @default 'Your first name'
     */
    ownerInputLabel: T;

    /**
     * @default 'Samantha'
     */
    ownerInputPlaceholder: T;

    /**
     * @default 'Your partner’s first name'
     */
    fianceeInputLabel: T;

    /**
     * @default 'John'
     */
    fianceeInputPlaceholder: T;

    /**
     * @default 'Where are you getting married'
     */
    locationInputLabel: T;

    /**
     * @default 'Search Google Maps'
     */
    locationInputPlaceholder: T;

    /**
     * @default 'On this date'
     */
    dateInputLabel: T;

    /**
     * @default 'I don't have a date yet'
     */
    noDateInputLabel: T;

    /**
     * @default 'Around how much is your budget'
     */
    budgetInputLabel: T;

    /**
     * @default '25,000'
     */
    budgetInputPlaceholder: T;

    /**
     * @default 'Message'
     */
    messageInputLabel: T;

    /**
     * @default 'Message'
     */
    messageInputLabelMultiple: T;

    /**
     * @default 'Hi! We're looking for a photographer to help us remember our rustic barn wedding, which will be a little nontraditional and casual. We are hoping for mostly candids that capture the fun, and a few formal and family photos.'
     */
    messageInputPlaceholder: T;

    /**
     * @default 'Sign up to send your message (we saved it).'
     */
    bannerMessage: T;

    /**
     * @default 'Photo by {{credit}}'
     */
    photoCredit: T;

    /**
     * @default 'Your message is on the way.'
     */
    messageSentSuccess: T;

    /**
     * @default 'Browse photo ideas on Joy and save them to your ideabooks. It helps the photographers you message get a sense of your style.'
     */
    messageSentContent: T;

    /**
     * @default 'Hi, <ownerFirstName/> & <fianceeFirstName/>. We're getting married at <location/> on <date/> and our wedding budget is <budget/>.'
     */
    formParagraph: T;

    /**
     * @default 'Got It'
     */
    gotIt: T;

    /**
     * @default 'Please select atleast one photo'
     */
    errorMessage: T;

    /**
     * @default 'About Us'
     */
    formInfoTitle: T;
  };

  /**
   * @default 'See More Work'
   */
  moreWork: T;

  /**
   * @default 'No route match for: {{pathname}}'
   */
  noPathFound: T;

  pricing: {
    /**
     * @default 'Packages'
     */
    photosStartAtTitle: T;

    /**
     * @default 'Start at <Price/>'
     */
    startAt: T;

    /**
     * @default 'Typical Spend'
     */
    typicalSpendTitle: T;
  };

  /**
   * @default 'Profile'
   */
  profile: T;

  profileAbout: {
    /**
     * @default 'About <NameOfVendor/>'
     */
    aboutTitle: T;

    /**
     * @default 'What folks are saying'
     */
    testimonialHeader: T;
  };

  /**
   * @default 'Search for vendor by id'
   */
  searchForVendorById: T;

  /**
   * @default 'Search for vendor by name'
   */
  searchForVendorByName: T;

  updateVendorUser: {
    /**
     * @default 'Email'
     */
    emailFieldTitle: T;

    /**
     * @default 'First Name'
     */
    firstNameFieldTitle: T;

    /**
     * @default 'Update Vendor User'
     */
    formTitle: T;

    /**
     * @default 'Last Name'
     */
    lastNameFieldTitle: T;

    /**
     * @default 'Phone'
     */
    phoneFieldTitle: T;

    /**
     * @default 'Role'
     */
    roleFieldTitle: T;

    /**
     * @default 'Update'
     */
    updateButton: T;
  };
  vendorContactEdit: {
    /**
     * @default 'As displayed in your profile header. This is the first thing couples, guests and your peers will see.'
     */
    aboutSubtitle: T;

    /**
     * @default 'About'
     */
    aboutTitle: T;

    /**
     * @default 'Bio'
     */
    bioFieldTitle: T;

    /**
     * @default 'General contact information about your business'
     */
    contactSubTitle: T;

    /**
     * @default 'Business Contact'
     */
    contactTitle: T;

    /**
     * @default 'Delete'
     */
    delete: T;

    /**
     * @default 'Email'
     */
    emailFieldTitle: T;

    /**
     * @default 'Handle'
     */
    handleFieldTitle: T;

    /**
     * @default 'Location'
     */
    locationFieldTitle: T;

    /**
     * @default 'Business Name'
     */
    nameFieldTitle: T;

    /**
     * @default 'Phone'
     */
    phoneFieldTitle: T;

    /**
     * @default 'Help guide couples on if their budget if right for your services by providing some pricing guidelines.'
     */
    pricingSubtitle: T;

    /**
     * @default 'Pricing'
     */
    pricingTitle: T;

    /**
     * @default 'Photo Packages Start At'
     */
    startingPriceFieldTitle: T;

    /**
     * @default 'Submit'
     */
    submit: T;

    /**
     * @default 'Help guide couples on if their budget if right for your services by providing some pricing guidelines.'
     */
    testimonialSubtitle: T;

    /**
     * @default 'What folks are saying'
     */
    testimonialTitle: T;

    /**
     * @default 'Couples Typically Spend'
     */
    typicalSpendFieldTitle: T;

    /**
     * @default 'Upload Photo'
     */
    uploadPhoto: T;

    /**
     * @default 'Website'
     */
    websiteFieldTitle: T;
  };
  vendorContactLine: {
    /**
     * @default 'Visit Website'
     */
    viewWebsite: T;
  };

  /**
   * @default 'Vendor Dashboard'
   */
  vendorDashboard: T;

  /**
   * @default 'View Public Profile'
   */
  viewPublicProfile: T;

  /**
   * @default 'View Showcase'
   */
  viewShowcase: T;

  /**
   * @default 'Weddings you’re showcased in'
   */
  weddingsYouIn: T;

  /**
   * @default 'Your profile on Joy.'
   */
  youProfileOnJoy: T;

  informativeDialog: {
    /**
     * @default 'Cool!'
     */
    GotIt: T;

    /**
     * @default 'That little ❤︎ of yours automagically...'
     */
    Message: T;

    /**
     * @default 'Photo by'
     */
    subMessage: T;

    /**
     * @default '🌅 Creates ideabooks'
     */
    p1: T;

    /**
     * @default 'to share with your partner and vendors,'
     */
    p2: T;

    /**
     * @default '📋 Keeps track of photographers'
     */
    p3: T;

    /**
     * @default 'so you can easily reach out, and'
     */
    p4: T;

    /**
     * @default '🙌 Helps photographers'
     */
    p5: T;

    /**
     * @default 'get noticed by more couples.'
     */
    p6: T;
  };
  likingValues: {
    /**
     * @default 'Start with a like'
     */
    valueLikeTitle: T;

    /**
     * @default 'Discover and like thousands of photos from Bay Area wedding photographers.'
     */
    valueLikeSubtitle: T;

    /**
     * @default 'Automagically organize'
     */
    valueOrganizeTitle: T;

    /**
     * @default 'We’ll organize them and save a list of the photographers behind the photos.'
     */
    valueOrganizeSubtitle: T;

    /**
     * @default 'Get pricing'
     */
    valuePriceTitle: T;

    /**
     * @default 'Instantly reach out to all the photographers behind the photos you liked, and book the right one.'
     */
    valuePriceSubtitle: T;
  };
};

export type VerifyEmailTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Let’s verify your email address'
   */
  headerText: T;

  /**
   * @default 'We just sent an email to <Email/>, with the subject “Please verify your email”. Click the link in that email and you’ll be all set to go.'
   */
  emailSentExplanation: T;

  /**
   * @default 'Your verification email has been re-sent.'
   */
  emailReSentCopy: T;

  /**
   * @default 'Sending...'
   */
  emailSendingCopy: T;

  /**
   * @default 'Can't find the email?'
   */
  emailNotFoundCopy: T;

  /**
   * @default 'Resend verification email'
   */
  reSendEmailAction: T;
};

export type VideoBackgroundTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'We couldn't load your video background.'
     */
    e7yCx: T;

    /**
     * @default 'Video Background'
     */
    FJLTh: T;

    /**
     * @default 'Video Background Thumbnail'
     */
    JDUZb: T;

    /**
     * @default 'Choose Video'
     */
    iFOdT: T;

    /**
     * @default 'You reached a maximum number of videos in this header.'
     */
    SozJ7: T;

    /**
     * @default 'Add Video'
     */
    KlcqK: T;

    /**
     * @default 'Text Alignment'
     */
    cgYDA: T;

    /**
     * @default 'Page Alignment'
     */
    sAU84: T;

    /**
     * @default 'Colors'
     */
    U5cSp: T;

    /**
     * @default 'Video thumbnail'
     */
    X2WHP: T;

    /**
     * @default 'Change Video'
     */
    nb97d: T;

    /**
     * @default 'Remove Video'
     */
    zH2xf: T;

    /**
     * @default 'Header Title Style'
     */
    Sxjs6: T;

    /**
     * @default 'Navigation Style'
     */
    Jcoqi: T;

    /**
     * @default 'Navigation Background Style'
     */
    BUiws: T;

    /**
     * @default 'Header Title Background Style'
     */
    AGKYI: T;
  };
};

export type VipCustomComponentTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'VIPs'
     */
    uYTNA: T;

    /**
     * @default 'Filter'
     */
    s1Pvw: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Add VIP'
     */
    izJtQ: T;

    /**
     * @default 'Save VIP'
     */
    sXSbt: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Delete VIP?'
     */
    '7ZsB1': T;

    /**
     * @default 'Exit without saving?'
     */
    pUbF1: T;

    /**
     * @default 'Are you sure you want to delete this VIP? This action cannot be undone.'
     */
    '6cxpA': T;

    /**
     * @default 'Are you sure you want to exit without saving? All unsaved changes will be lost.'
     */
    Y7YP9: T;

    /**
     * @default 'Delete VIP'
     */
    IZHot: T;

    /**
     * @default 'Exit without saving'
     */
    '8VLPp': T;

    /**
     * @default 'confirm'
     */
    wNSec: T;

    /**
     * @default 'cancel'
     */
    q0r5A: T;

    /**
     * @default 'Confirm'
     */
    WeV82: T;

    /**
     * @default 'Move up'
     */
    WJmm5: T;

    /**
     * @default 'Move down'
     */
    XsO1y: T;

    /**
     * @default 'Add your first VIP to get started!'
     */
    '6gmTz': T;

    /**
     * @default 'Error deleting VIP'
     */
    NcsWv: T;

    /**
     * @default 'Add Member'
     */
    HRzIx: T;

    /**
     * @default 'Edit Member'
     */
    ysLd8: T;

    /**
     * @default 'Save Selection'
     */
    '5ikct': T;

    /**
     * @default 'Members'
     */
    '38lZe': T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'Select Members'
     */
    VZYhR: T;

    /**
     * @default 'Add New'
     */
    jyHtQ: T;

    /**
     * @default 'Failed to save VIP'
     */
    eIGGT: T;

    /**
     * @default 'Failed to delete VIP'
     */
    mOSLL: T;

    /**
     * @default 'close dialog'
     */
    '4VEdN': T;

    /**
     * @default 'Your VIP list is empty'
     */
    Ni3yH: T;

    /**
     * @default 'Start adding the faces behind your event.'
     */
    T3Vrg: T;

    /**
     * @default 'Add Your First VIP'
     */
    '9HaJy': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'What's Wedding Party'
     */
    iN0Nn: T;

    /**
     * @default 'Highlight your wedding party with names, roles, and photos so guests can get to know them before the big day.'
     */
    PidN5: T;

    /**
     * @default 'What's VIPs?'
     */
    dZnnE: T;

    /**
     * @default 'Showcase important people or speakers by highlighting them on your event website.'
     */
    jbIaj: T;
  };
};

export type VipFormTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Title'
     */
    UdWAH: T;

    /**
     * @default 'Description'
     */
    g4tSP: T;

    /**
     * @default 'Pick Photo'
     */
    nFdk0: T;

    /**
     * @default 'No Photo'
     */
    xXFMz: T;

    /**
     * @default 'Click to choose'
     */
    '4Jh4G': T;

    /**
     * @default 'Failed to create VIP'
     */
    BxXm6: T;

    /**
     * @default 'Something went wrong, please try again'
     */
    mmJyj: T;

    /**
     * @default 'Choose Photo'
     */
    j4Q9S: T;

    /**
     * @default 'Swap Photo'
     */
    LnQfM: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Remove Photo'
     */
    '064Tf': T;
  };
};

export type WeatherReportGuestTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Low'
     */
    '4fWAA': T;

    /**
     * @default 'Moderate'
     */
    FiWFw: T;

    /**
     * @default 'High'
     */
    EwVLA: T;

    /**
     * @default 'Very High'
     */
    SIn9F: T;

    /**
     * @default 'Extreme'
     */
    kt8wu: T;

    /**
     * @default 'UV: {{0}} · {{1}}'
     */
    VwUbt: T;

    /**
     * @default 'Calm'
     */
    JyiKA: T;

    /**
     * @default 'Breezy'
     */
    '3VF2m': T;

    /**
     * @default 'Windy'
     */
    RPQPH: T;

    /**
     * @default 'Strong'
     */
    z9jFW: T;

    /**
     * @default 'Wind: {{0}} km/h · {{1}}'
     */
    t5ctH: T;

    /**
     * @default 'Precip'
     */
    xR96N: T;

    /**
     * @default 'Humidity'
     */
    tQMCs: T;

    /**
     * @default 'City {{0}}'
     */
    v3W8c: T;

    /**
     * @default '{{0}}-Day Forecast'
     */
    WkrL2: T;

    /**
     * @default 'Today'
     */
    h6LBH: T;
  };
};

export type WebsiteDesignerTranslations<T extends LeafNodeValue = TranslateFunction> = {
  /**
   * @default 'Design'
   */
  titleDesign: T;

  /**
   * @default 'Select a Design Template'
   */
  selectTemplateTitle: T;

  /**
   * @default 'Select a Template'
   */
  selectTemplateTitleV2: T;

  /**
   * @default 'Save and Open'
   */
  saveAndOpen: T;

  /**
   * @default 'Add your custom CSS here'
   */
  cssCodePlaceholder: T;

  /**
   * @default 'Custom CSS is an experimental feature. We can't guarantee your custom CSS will work indefinitely.'
   */
  cssWarning: T;

  /**
   * @default 'Using CSS requires a separate preview.'
   */
  cssPreviewTitle: T;

  /**
   * @default 'To see your changes, publish your design and open your live website.'
   */
  cssPreviewContent: T;

  /**
   * @default 'Edit Design'
   */
  editDesign: T;

  /**
   * @default 'Preview'
   */
  preview: T;

  /**
   * @default 'View Site'
   */
  previewSite: T;

  /**
   * @default 'Publish'
   */
  ctaPublish: T;

  /**
   * @default 'Apply Template'
   */
  ctaApplyTemplate: T;

  /**
   * @default 'Back'
   */
  ctaBack: T;

  /**
   * @default 'Design'
   */
  design: T;

  /**
   * @default 'Back to Dashboard'
   */
  back: T;

  /**
   * @default 'Preview site with this theme'
   */
  previewSiteWithThisTheme: T;

  /**
   * @default 'Publish'
   */
  publish: T;

  /**
   * @default 'Publish Changes'
   */
  publishChanges: T;

  /**
   * @default 'Publishing...'
   */
  publishing: T;

  /**
   * @default 'Saving...'
   */
  saving: T;

  /**
   * @default 'Nice work! Now, check out your site.'
   */
  niceWork: T;

  /**
   * @default 'View current site without your changes.'
   */
  viewCurrentSite: T;

  /**
   * @default 'Not seeing your changes on your website? Make sure to apply changes.'
   */
  notSeeingChangesMessage: T;

  /**
   * @default 'View Site'
   */
  viewSite: T;

  /**
   * @default 'Updates have been published'
   */
  changesPublishedSuccessfully: T;

  /**
   * @default 'Preview Website'
   */
  'titlePreview.desktop': T;

  /**
   * @default 'Preview Mobile'
   */
  'titlePreview.mobile': T;

  /**
   * @default 'Preview Stationery'
   */
  'titlePreview.stationery': T;

  /**
   * @default 'Sorry but your theme is no longer available to preview.'
   */
  themeNotSupportedText: T;

  /**
   * @default 'Learn Why'
   */
  themeNotSupportedButton: T;

  /**
   * @default 'Explore Matching Prints'
   */
  stationeryExplorePrints: T;

  /**
   * @default 'Select unique print stationery from'
   */
  stationerySelectUnique: T;

  /**
   * @default 'Or pair your theme with free matching digital stationery'
   */
  stationaryDigitalOption: T;

  /**
   * @default 'Pair your theme with free matching digital stationery'
   */
  stationaryDigitalOptionPair: T;

  /**
   * @default 'Create Save the Date'
   */
  stationarySaveTheDate: T;

  /**
   * @default 'Create Invitation'
   */
  stationaryInvitation: T;

  /**
   * @default 'Save the Date'
   */
  saveTheDate: T;

  /**
   * @default 'Invitation'
   */
  invitation: T;

  /**
   * @default 'Current'
   */
  current: T;

  /**
   * @default 'Headers'
   */
  headers: T;

  /**
   * @default 'Filter'
   */
  filter: T;

  /**
   * @default 'Filters'
   */
  filters: T;

  /**
   * @default 'Clear'
   */
  clear: T;

  /**
   * @default 'reset'
   */
  reset: T;

  /**
   * @default 'Graphic Accent'
   */
  graphicAccent: T;

  /**
   * @default 'Layout'
   */
  layout: T;

  /**
   * @default 'Choose between single and multi-page layout.'
   */
  layoutDescription: T;

  /**
   * @default 'Site Layout'
   */
  siteLayout: T;

  /**
   * @default 'Accent Color'
   */
  accentColor: T;

  /**
   * @default ' is used for links and buttons. It can also be used as a background color for some themes using the single page layout.'
   */
  accentColorTooltip: T;

  /**
   * @default 'Font'
   */
  font: T;

  /**
   * @default 'Art background'
   */
  artBackground: T;

  /**
   * @default 'Art font'
   */
  artFont: T;

  /**
   * @default 'Page background'
   */
  pageBackground: T;

  /**
   * @default 'Page font'
   */
  pageFont: T;

  /**
   * @default 'Link & button'
   */
  linkAndButton: T;

  /**
   * @default 'Colors'
   */
  colors: T;

  /**
   * @default 'Photo Palette'
   */
  photoPalette: T;

  /**
   * @default 'Art'
   */
  art: T;

  /**
   * @default 'Border'
   */
  border: T;

  /**
   * @default 'Transparency'
   */
  transparency: T;

  /**
   * @default 'Page Transparency'
   */
  pageTransparency: T;

  /**
   * @default 'Page Shadow'
   */
  pageShadow: T;

  /**
   * @default 'Sorry, there&apos;s been an error. Refresh the page.'
   */
  dataLoadError: T;

  /**
   * @default 'Multi-Page'
   */
  multiPage: T;

  /**
   * @default 'Simple Scroll'
   */
  simpleScroll: T;

  /**
   * @default 'Split View'
   */
  splitView: T;

  /**
   * @default 'Classic Navigation'
   */
  classicNavigation: T;

  /**
   * @default 'Collection'
   */
  collection: T;

  /**
   * @default 'Single Page'
   */
  singlePage: T;

  /**
   * @default 'No Exact Matches'
   */
  noMatches: T;

  /**
   * @default 'Clear All Filters'
   */
  clearAllFilters: T;

  /**
   * @default 'Reset All Filters'
   */
  resetAllFilters: T;

  /**
   * @default 'Show Results'
   */
  showResults: T;

  /**
   * @default 'Show All'
   */
  showAllButton: T;

  /**
   * @default 'Show All Templates'
   */
  showAllButton_template: T;

  /**
   * @default 'Show All Fonts'
   */
  showAllButton_font: T;

  /**
   * @default 'Show All Themes'
   */
  showAllButton_theme: T;

  /**
   * @default 'Show it'
   */
  showOneButton: T;

  /**
   * @default 'Show 1 Template'
   */
  showOneButton_template: T;

  /**
   * @default 'Show 1 Font'
   */
  showOneButton_font: T;

  /**
   * @default 'Show 1 Theme'
   */
  showOneButton_theme: T;

  /**
   * @default 'Show them'
   */
  showManyButton: T;

  /**
   * @default 'Show {{count}} Templates'
   */
  showManyButton_template: T;

  /**
   * @default 'Show {{count}} Fonts'
   */
  showManyButton_font: T;

  /**
   * @default 'Show {{count}} Themes'
   */
  showManyButton_theme: T;

  /**
   * @default 'Filter Options'
   */
  filterBaseTitle: T;

  /**
   * @default 'Filter Templates'
   */
  filterBaseTitle_template: T;

  /**
   * @default 'Filter Fonts'
   */
  filterBaseTitle_font: T;

  /**
   * @default 'Filter Themes'
   */
  filterBaseTitle_theme: T;

  /**
   * @default 'Designs Gallery'
   */
  designsGallery: T;

  /**
   * @default 'Color'
   */
  color: T;

  /**
   * @default 'Guide to Customizing Colors'
   */
  guideToCustomizingColors: T;

  /**
   * @default 'Customize'
   */
  customizeThisDesign: T;

  /**
   * @default 'Change Design'
   */
  changeDesign: T;

  /**
   * @default 'View with Your Photo'
   */
  viewWithYourPhoto: T;

  /**
   * @default 'You must select one photo.'
   */
  youMustSelectOnePhoto: T;

  /**
   * @default 'Clear Photo'
   */
  clearPhoto: T;

  customCssError: {
    /**
     * @default 'Custom CSS Error'
     */
    title: T;

    /**
     * @default 'Your custom CSS is invalid. Please review and make any necessary adjustments.'
     */
    message: T;

    /**
     * @default 'Review'
     */
    action: T;
  };
  customErrorDefault: {
    /**
     * @default 'Error'
     */
    title: T;

    /**
     * @default 'Something went wrong. Please try again.'
     */
    message: T;

    /**
     * @default 'Try Again'
     */
    action: T;
  };

  /**
   * @default 'Templates'
   */
  templates: T;

  /**
   * @default 'Details'
   */
  details: T;

  /**
   * @default 'CSS'
   */
  css: T;

  smartTip: {
    /**
     * @default 'SMART TIP'
     */
    label: T;

    /**
     * @default 'Easily link to your website with a QR code on your cards.'
     */
    browse: T;

    /**
     * @default 'Link to your website with a QR code on matching cards.'
     */
    matching: T;

    /**
     * @default 'Browse Cards'
     */
    browseButton: T;

    /**
     * @default 'Add QR Code'
     */
    matchingButton: T;
  };
  stationeryTabV2: {
    externalProviderBlock: {
      /**
       * @default 'Beautiful Matching Paper Cards from {{providerName}}'
       */
      title: T;

      /**
       * @default 'Customize and send beautiful Save the Dates and Invitations matching your wedding site.'
       */
      description: T;

      /**
       * @default 'Customize on {{providerName}}'
       */
      primaryCta: T;
    };
    joyProviderBlock: {
      /**
       * @default 'Beautiful Paper & Digital Cards to Match Your Wedding Website'
       */
      defaultTitle: T;

      /**
       * @default 'Digital Cards to Match Your Wedding Website'
       */
      externalProviderTitle: T;

      /**
       * @default 'Customize and send beautiful Save the Dates and Invitations matching your wedding site.'
       */
      description: T;

      /**
       * @default 'Explore Print Designs'
       */
      primaryCta: T;

      /**
       * @default 'Explore Digital Designs'
       */
      secondaryCta: T;

      /**
       * @default 'Save the Date'
       */
      saveTheDateAlt: T;

      /**
       * @default 'Invitation'
       */
      invitationAlt: T;

      /**
       * @default 'test'
       */
      testAlt: T;
    };
  };

  /**
   * @default 'Favorites'
   */
  favorites: T;

  emptyResults: {
    /**
     * @default 'Clear Filters'
     */
    clearFilters: T;

    /**
     * @default 'Clear Search'
     */
    clearSearch: T;

    /**
     * @default 'Once you favorite fonts, you’ll see them here.'
     */
    fontsFavoritesSubTitle: T;

    state: {
      filters: {
        /**
         * @default 'No results for those filters.'
         */
        title: T;

        /**
         * @default 'Try changing them or using fewer filters.'
         */
        subTitle: T;
      };
      search: {
        /**
         * @default 'No results found.'
         */
        title: T;

        /**
         * @default 'Look out for typos or try a different search.'
         */
        subTitle: T;
      };
      favorite: {
        /**
         * @default 'Press the heart button on anything you love to favorite it.'
         */
        title: T;

        /**
         * @default 'Your favorite designs will be collected here.'
         */
        subTitle: T;
      };
    };

    /**
     * @default 'Looking for something we don't have yet?'
     */
    notFoundMessage: T;

    /**
     * @default 'Let us know!'
     */
    letUsKnow: T;
  };
  search: {
    /**
     * @default 'Search for {{tab}}'
     */
    placeholder: T;
  };
  tabs: {
    /**
     * @default 'Templates'
     */
    templates: T;
  };
  localStorageError: {
    /**
     * @default 'LocalStorage Not Available'
     */
    title: T;

    /**
     * @default 'Close'
     */
    closeCta: T;

    /**
     * @default 'It looks like LocalStorage is not available in your browser. LocalStorage is required for favorite application to function correctly.'
     */
    applicationMessage: T;

    /**
     * @default 'Please ensure that LocalStorage is enabled in your browser settings. You can usually find these settings under privacy or site-specific settings.'
     */
    privacyMessage: T;

    /**
     * @default 'If you are using incognito mode or a privacy-focused browser, try switching to a normal browsing window or adjusting your privacy settings.'
     */
    incognitoMessage: T;
  };
  matchingPrintModal: {
    /**
     * @default 'Complement your website with matching cards.'
     */
    title: T;

    /**
     * @default 'Share your style your way with paper and digital Save the Dates and invitations.'
     */
    subtitle: T;

    /**
     * @default 'Browse Card Designs'
     */
    browseButton: T;
  };
  unsupportedThemeLayout: {
    /**
     * @default 'This theme is not available in your current layout.'
     */
    title: T;

    /**
     * @default 'Switch Layout'
     */
    switchButton: T;
  };
  altText: {
    /**
     * @default 'Save the Date'
     */
    saveTheDate: T;

    /**
     * @default 'Invitation'
     */
    invitation: T;

    /**
     * @default 'test'
     */
    test: T;
  };
  badges: {
    /**
     * @default 'Matching Paper'
     */
    matchingPaper: T;

    /**
     * @default 'New'
     */
    new: T;
  };
  fontPacks: {
    /**
     * @default 'Customize Fonts'
     */
    customizeFonts: T;

    /**
     * @default 'Font Sets'
     */
    fontSets: T;

    categories: {
      /**
       * @default 'Buttons'
       */
      BUTTONS: T;

      /**
       * @default 'Event Date'
       */
      DATE: T;

      /**
       * @default 'Event Name'
       */
      EVENT_TITLE: T;

      /**
       * @default 'Heading'
       */
      HEADING: T;

      /**
       * @default 'Event Location'
       */
      LOCATION: T;

      /**
       * @default 'Navigation'
       */
      NAVIGATION: T;

      /**
       * @default 'Paragraph'
       */
      PARAGRAPH: T;

      /**
       * @default 'Subhead'
       */
      SUB_HEADING: T;

      /**
       * @default 'Caption'
       */
      CAPTION: T;

      /**
       * @default 'Page Title'
       */
      PAGE_TITLE: T;
    };

    /**
     * @default 'Reset All Fonts'
     */
    resetAllFonts: T;

    /**
     * @default 'All Styles'
     */
    allStyles: T;

    /**
     * @default '{{category}} Style'
     */
    fontCategoryTitle: T;

    /**
     * @default '{{category}} Size'
     */
    fontCategorySize: T;

    /**
     * @default '{{category}} style updated.'
     */
    fontConfigEditSuccess: T;

    /**
     * @default 'Error updating font configuration. Please try again later.'
     */
    fontConfigEditError: T;

    /**
     * @default 'A'
     */
    a: T;

    /**
     * @default 'Search by name, style, or vibes'
     */
    fontPackSearchPlaceholder: T;

    /**
     * @default 'Select a font pack for customization'
     */
    selectAFontPackForCustomization: T;

    sampleFontText: {
      /**
       * @default 'The Ceremony'
       */
      heading: T;

      /**
       * @default 'Rehearsal Dinner'
       */
      subHeading: T;

      /**
     * @default 'Please see our Schedule 
 for the dress code.'
*/
      paragraph: T;

      /**
       * @default 'Don't forget to RSVP'
       */
      buttons: T;

      /**
       * @default 'Schedule    Travel    Registry'
       */
      navigation: T;

      /**
       * @default '10:00 AM'
       */
      caption: T;

      /**
       * @default 'Schedule'
       */
      pageTitle: T;
    };
    discardDialog: {
      /**
       * @default 'Do you want to discard font customizations?'
       */
      title: T;

      /**
       * @default 'You will lose the custom page fonts you have selected if you switch to this font set.'
       */
      subtitle: T;

      /**
       * @default 'Keep Custom Fonts'
       */
      CTA1: T;

      /**
       * @default 'Discard Custom Fonts'
       */
      CTA2: T;
    };
  };
  header: {
    photo: {
      /**
       * @default 'Header Layout'
       */
      headerLayout: T;

      /**
       * @default 'Choose the layout for the header photo.'
       */
      headerLayoutDescription: T;

      /**
       * @default 'Choose Photos ({{countRange}} required)'
       */
      photoSelectionCount: T;

      photoPresentationLayouts: {
        /**
         * @default 'Screen Width Photo'
         */
        fullWidth: T;

        /**
         * @default 'Page Width Photo'
         */
        pageWidth: T;

        /**
         * @default 'Centered Photo'
         */
        center: T;

        /**
         * @default 'Photo Slider'
         */
        photoSlider: T;

        /**
         * @default 'Photo Marquee'
         */
        photoMarquee: T;

        /**
         * @default 'Photo Trio'
         */
        photoTrio: T;

        /**
         * @default 'Page Width Photo Trio'
         */
        photoTrioPageWidth: T;

        /**
         * @default 'Photo Duo Left'
         */
        photoDuoLeft: T;

        /**
         * @default 'Photo Duo Right'
         */
        photoDuoRight: T;

        /**
         * @default 'Photo Arch'
         */
        photoArch: T;

        /**
         * @default 'No Photo'
         */
        noPhoto: T;

        /**
         * @default 'Monogram'
         */
        monogram: T;

        /**
         * @default 'Photo Background'
         */
        photoBackground: T;

        /**
         * @default 'Video Background'
         */
        videoBackground: T;

        /**
         * @default 'Video Arch'
         */
        videoArch: T;
      };
    };
    text: {
      /**
       * @default 'Text Alignment'
       */
      textAlignment: T;

      /**
       * @default 'Colors'
       */
      colors: T;
    };
    eventDisplayName: {
      /**
       * @default 'Your Event Display Name'
       */
      displayNameLabel: T;

      /**
       * @default 'Enter your event display name'
       */
      displayNamePlaceholder: T;

      /**
       * @default 'Event Display Name is required.'
       */
      displayNameRequired: T;

      /**
       * @default 'Event Display Name saved successfully.'
       */
      saveDisplayNameSuccess: T;

      /**
       * @default 'Error saving Event Display Name. Please try again later.'
       */
      saveDisplayNameError: T;
    };
    eventGreetingMessage: {
      /**
       * @default 'Greeting Message'
       */
      greetingMessageLabel: T;

      /**
       * @default 'Enter your greeting message'
       */
      greetingMessagePlaceholder: T;

      /**
       * @default 'Greeting Message is required.'
       */
      greetingMessageRequired: T;

      /**
       * @default 'Greeting Message saved successfully.'
       */
      saveGreetingMessageSuccess: T;

      /**
       * @default 'Error saving Greeting Message. Please try again later.'
       */
      saveGreetingMessageError: T;
    };
  };
  monogramEditorDialog: {
    /**
     * @default 'Select Layout and Edit'
     */
    selectLayoutAndEdit: T;

    /**
     * @default 'Edit Monogram'
     */
    editMonogram: T;

    /**
     * @default 'Customize Monogram'
     */
    title: T;

    layoutTab: {
      /**
       * @default 'Layouts'
       */
      title: T;

      /**
       * @default 'Thumbnail of Monogram'
       */
      monogramAlt: T;

      /**
       * @default 'Select and Customize'
       */
      cta: T;
    };
    editorTab: {
      /**
       * @default 'Editor'
       */
      title: T;

      /**
       * @default 'Save'
       */
      cta: T;

      /**
       * @default 'Failed to save Monogram'
       */
      saveError: T;
    };
  };
  websitePreviewPhoto: {
    /**
     * @default 'Event Photo'
     */
    title: T;

    /**
     * @default 'Select a photo to use as the website preview photo.'
     */
    description: T;

    /**
     * @default 'Shown when sharing the link with guests.'
     */
    descriptionInfo: T;

    /**
     * @default 'Add Photo'
     */
    addPhoto: T;
  };

  /**
   * @default 'Not available for this design'
   */
  notAvailableForThisDesign: T;

  designTile: {
    /**
     * @default 'Selected'
     */
    selected: T;

    /**
     * @default 'Animated'
     */
    animated: T;

    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Customize'
     */
    customize: T;
  };
  editorV3Tabs: {
    /**
     * @default 'Templates'
     */
    templates: T;

    /**
     * @default 'Layout'
     */
    layout: T;

    /**
     * @default 'Color'
     */
    color: T;

    /**
     * @default 'Details'
     */
    details: T;

    /**
     * @default 'Art'
     */
    art: T;

    /**
     * @default 'Font'
     */
    font: T;

    /**
     * @default 'Event Photo'
     */
    eventPhoto: T;

    /**
     * @default 'Custom CSS'
     */
    css: T;
  };
  quick: {
    /**
     * @default 'Beautiful Matching Paper Cards from {{0}}'
     */
    P5sPl: T;

    /**
     * @default 'Customize and send beautiful Save the Dates and Invitations matching your wedding site.'
     */
    Ot4Bq: T;

    /**
     * @default 'Customize on {{0}}'
     */
    eb4vD: T;

    /**
     * @default 'Save the Date'
     */
    ymYpv: T;

    /**
     * @default 'Invitation'
     */
    LbEQO: T;

    /**
     * @default 'Default stationary banner'
     */
    HFxDO: T;

    /**
     * @default 'Digital Cards to Match Your Wedding Website'
     */
    ZhyQE: T;

    /**
     * @default 'Beautiful Paper & Digital Cards to Match Your Wedding Website'
     */
    w9MBw: T;

    /**
     * @default 'Explore Paper Designs'
     */
    ytXUz: T;

    /**
     * @default 'Explore Digital Designs'
     */
    meqv3: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Search and Filters'
     */
    aoIfX: T;

    /**
     * @default 'Up'
     */
    DvAAA: T;

    /**
     * @default 'Down'
     */
    iNwKA: T;

    /**
     * @default 'Layout'
     */
    obnCC: T;

    /**
     * @default 'Color'
     */
    fmnoF: T;

    /**
     * @default 'Font'
     */
    H0ELA: T;

    /**
     * @default 'Art'
     */
    PaTAA: T;

    /**
     * @default 'Event Photo'
     */
    kggrO: T;

    /**
     * @default 'Custom CSS'
     */
    YSgYn: T;

    /**
     * @default 'Change Design'
     */
    Aw2TS: T;

    /**
     * @default 'Templates'
     */
    PwUcN: T;

    /**
     * @default 'Gallery View'
     */
    '5fIqQ': T;

    /**
     * @default '2 in a row'
     */
    '2Ebzq': T;

    /**
     * @default '1 in a row'
     */
    R06Om: T;

    /**
     * @default '4 in a row'
     */
    EiZA0: T;

    /**
     * @default '3 in a row'
     */
    dT5Zv: T;

    /**
     * @default 'Search'
     */
    mIY0U: T;

    /**
     * @default 'Favorites'
     */
    rOPR1: T;

    /**
     * @default 'Reset All Filters'
     */
    bnE3D: T;

    /**
     * @default 'Show Results'
     */
    ttgga: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Saving...'
     */
    '60ObM': T;

    /**
     * @default 'You must select one photo.'
     */
    aVU2n: T;

    /**
     * @default 'Looking for something we don't have yet?'
     */
    BgFSj: T;

    /**
     * @default 'Let us know!'
     */
    dWnm7: T;

    /**
     * @default 'Publish Website'
     */
    C04Ki: T;

    /**
     * @default 'Keep the Site Hidden'
     */
    RRW4O: T;

    /**
     * @default 'Publish your site before sharing.'
     */
    Aqnsm: T;

    /**
     * @default 'Your website is hidden from guests right now. Publish it so they can view the event details when they receive your message.'
     */
    A46Hn: T;

    /**
     * @default '🥳 Your site has been published.'
     */
    xmHdM: T;

    /**
     * @default 'View Your Site →'
     */
    V6unB: T;

    /**
     * @default '😬 Failed to publish website. Please try again.'
     */
    QWLqh: T;

    /**
     * @default 'Publish'
     */
    PqFdr: T;

    /**
     * @default 'Publish Changes'
     */
    Cd49l: T;

    /**
     * @default 'Publishing...'
     */
    X4Uld: T;

    /**
     * @default 'Not seeing your changes on your website? Make sure to apply changes.'
     */
    '5X7D2': T;

    /**
     * @default 'Site Unpublished'
     */
    C5i4q: T;

    /**
     * @default 'View website in a new tab.'
     */
    blTVK: T;

    /**
     * @default 'View current site without your changes.'
     */
    FY2GA: T;

    /**
     * @default 'Nice work! Now, check out your site.'
     */
    hX0Rr: T;

    /**
     * @default 'View Site'
     */
    G17zU: T;

    /**
     * @default '🥳 Your site looks awesome! All changes saved!'
     */
    fR0FP: T;

    /**
     * @default 'Site Artwork'
     */
    TiIOC: T;

    /**
     * @default 'Pages'
     */
    a3LpG: T;

    /**
     * @default 'Guide to Customizing Colors'
     */
    lp17V: T;

    /**
     * @default 'Photo Palette'
     */
    XVXYp: T;

    /**
     * @default '  Current Website Colors'
     */
    qZ63c: T;

    /**
     * @default 'Failed to copy color to clipboard.'
     */
    N56MU: T;

    /**
     * @default 'Color {{0}} copied to clipboard.'
     */
    QsH4u: T;

    /**
     * @default 'We’ve created a color palette that matches your photo and applied them to your site. You can adjust each element individually.'
     */
    atP6w: T;

    /**
     * @default 'Art background'
     */
    hdWXC: T;

    /**
     * @default 'Art font'
     */
    '2CZvi': T;

    /**
     * @default 'Page background'
     */
    '9ylUZ': T;

    /**
     * @default 'Page font'
     */
    yBlwf: T;

    /**
     * @default 'Link & button'
     */
    Yaz0c: T;

    /**
     * @default 'Page Background'
     */
    '52mzX': T;

    /**
     * @default 'Page Text'
     */
    KA0tf: T;

    /**
     * @default 'Buttons & Links'
     */
    IjlEQ: T;

    /**
     * @default 'Background Behind Art'
     */
    '7TxDJ': T;

    /**
     * @default 'Text on Art'
     */
    F851y: T;

    /**
     * @default 'Current Selection'
     */
    Rmj9W: T;

    /**
     * @default 'Graphic Accent'
     */
    uJOr5: T;

    /**
     * @default 'Simple Scroll'
     */
    RkAkj: T;

    /**
     * @default 'Split View'
     */
    j6uMY: T;

    /**
     * @default 'Classic Navigation'
     */
    c96Le: T;

    /**
     * @default 'Navigation'
     */
    avBYb: T;

    /**
     * @default 'Sorry, there's been an error. Refresh the page.'
     */
    Rq7WI: T;

    /**
     * @default 'Select a font pack for customization'
     */
    FplAz: T;

    /**
     * @default 'Customize Fonts'
     */
    zfALJ: T;

    /**
     * @default 'Select Font Pack '
     */
    '8DStQ': T;

    /**
     * @default 'Choose from designer-curated font pairings that work beautifully together.'
     */
    r92IH: T;

    /**
     * @default 'Search Fonts'
     */
    SRImk: T;

    /**
     * @default 'Event Display Name is required.'
     */
    OvJID: T;

    /**
     * @default 'Error saving Event Display Name. Please try again later.'
     */
    MWKAt: T;

    /**
     * @default 'Event Display Name saved successfully.'
     */
    b2sOT: T;

    /**
     * @default 'Event Display Name'
     */
    rZqZK: T;

    /**
     * @default 'Enter your event display name'
     */
    mSBCX: T;

    /**
     * @default 'Name and Menu Font'
     */
    ezSad: T;

    /**
     * @default 'Name and Menu Background'
     */
    rFWkL: T;

    /**
     * @default 'Text Alignment'
     */
    cgYDA: T;

    /**
     * @default 'Page Alignment'
     */
    sAU84: T;

    /**
     * @default 'Colors'
     */
    U5cSp: T;

    /**
     * @default 'Header Style'
     */
    YRPfC: T;

    /**
     * @default 'Choose between single and multi-page layout.'
     */
    xAMqx: T;

    /**
     * @default 'Link Preview Image'
     */
    '3o7AO': T;

    /**
     * @default 'Choose the photo that appears when you share your website link in text messages, social posts, or chats.'
     */
    dICDM: T;

    /**
     * @default 'Suggested 1200 x 630 pixels'
     */
    mXNDK: T;

    /**
     * @default 'Add Photo'
     */
    LafMK: T;

    /**
     * @default 'Photo has been deleted'
     */
    XG519: T;

    /**
     * @default 'Failed to delete photo.'
     */
    VTRSR: T;

    /**
     * @default 'Custom CSS is an experimental feature. We can't guarantee your custom CSS will work indefinitely.'
     */
    QQPCM: T;

    /**
     * @default 'Loading CSS editor...'
     */
    '4e1pL': T;

    /**
     * @default 'This is an experimental feature. Your custom code may not always work as we update the platform.'
     */
    DSNmU: T;

    /**
     * @default 'Add Custom CSS'
     */
    ZIN62: T;

    /**
     * @default 'Your Current Template'
     */
    qAn5v: T;

    /**
     * @default 'Continue Editing →'
     */
    v6o2J: T;

    /**
     * @default 'Clear Your Photo'
     */
    M4LrP: T;

    /**
     * @default 'Preview With Your Photo'
     */
    xLr2O: T;

    /**
     * @default 'Clear Photo'
     */
    PP04z: T;

    /**
     * @default 'View with Your Photo'
     */
    an1wN: T;

    /**
     * @default 'Search for Templates'
     */
    '84ccJ': T;

    /**
     * @default 'Selected'
     */
    '5gqDQ': T;

    /**
     * @default 'Animated'
     */
    nET1O: T;

    /**
     * @default 'Switch to This Design'
     */
    rsHvB: T;

    /**
     * @default 'Preview'
     */
    i23wj: T;

    /**
     * @default 'Select →'
     */
    MJsDQ: T;

    /**
     * @default 'Select This Design →'
     */
    eRoXw: T;

    /**
     * @default 'Select This Design'
     */
    yoiPS: T;

    /**
     * @default 'Filters'
     */
    '5CleK': T;

    /**
     * @default 'Choose a Starting Design'
     */
    qPvuz: T;

    /**
     * @default 'Load more'
     */
    '5lJ2f': T;

    /**
     * @default 'Change Video'
     */
    nb97d: T;

    /**
     * @default 'Remove Video'
     */
    zH2xf: T;

    /**
     * @default 'Please enter a valid Vimeo or YouTube URL'
     */
    sh6fB: T;

    /**
     * @default 'Video Background'
     */
    FJLTh: T;

    /**
     * @default 'Vimeo or Youtube Link - Desktop View'
     */
    u2LcN: T;

    /**
     * @default 'Vimeo or Youtube Link - Mobile View'
     */
    Gt0WB: T;

    /**
     * @default 'Optional'
     */
    KozAy: T;

    /**
     * @default 'Save Video'
     */
    '0VpvJ': T;

    /**
     * @default 'Read our video guide'
     */
    dBBbr: T;

    /**
     * @default 'How it works:'
     */
    JTmeh: T;

    /**
     * @default 'Upload your video to Youtube or Vimeo. We recommend Vimeo for best quality.'
     */
    WVaHp: T;

    /**
     * @default 'Once that's complete, copy the URL (starts with https://vimeo.com) of that video and paste it here.'
     */
    u2lIv: T;

    /**
     * @default 'Vimeo Logo'
     */
    pyV1i: T;

    /**
     * @default 'Upload to Vimeo'
     */
    '63ppO': T;

    /**
     * @default 'Youtube Logo'
     */
    '2Gd8m': T;

    /**
     * @default 'Upload to Youtube'
     */
    hMXMB: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Prepare your video in 16:9 for desktop and 4:3 for mobile to avoid cropping or distortion.'
     */
    yvlBh: T;

    /**
     * @default 'Please select a thumbnail photo'
     */
    rX15A: T;

    /**
     * @default 'Thumbnail Photo'
     */
    qSUHx: T;

    /**
     * @default 'Displayed when video is loading'
     */
    GqKRj: T;

    /**
     * @default 'Video thumbnail'
     */
    X2WHP: T;

    /**
     * @default 'Change Thumbnail'
     */
    '0ZauZ': T;

    /**
     * @default 'Remove Thumbnail'
     */
    gjKQR: T;

    /**
     * @default 'Thumbnail photo already selected.'
     */
    pvNDA: T;

    /**
     * @default 'Add Thumbnail'
     */
    lOLtS: T;

    /**
     * @default 'Once that's complete, copy the website address of that video and paste it here.'
     */
    orVsO: T;

    /**
     * @default 'Select a thumbnail photo for your video'
     */
    '21Y8L': T;

    /**
     * @default 'Single Page'
     */
    n4aK5: T;

    /**
     * @default 'Multi-Page'
     */
    VmF7N: T;

    /**
     * @default 'Categories'
     */
    ElZ5Z: T;

    /**
     * @default 'Bold'
     */
    RadKA: T;

    /**
     * @default 'Classic'
     */
    UZCBu: T;

    /**
     * @default 'Cultural'
     */
    '27tDJ': T;

    /**
     * @default 'Destination'
     */
    Su78A: T;

    /**
     * @default 'Floral & Botanical'
     */
    tbZR0: T;

    /**
     * @default 'Metallic'
     */
    rsWwE: T;

    /**
     * @default 'Modern'
     */
    tUSvF: T;

    /**
     * @default 'Rustic'
     */
    SUggT: T;

    /**
     * @default 'Seasonal'
     */
    gN0Ey: T;

    /**
     * @default 'Textured'
     */
    jHGVF: T;

    /**
     * @default 'Red'
     */
    pHYAA: T;

    /**
     * @default 'Orange'
     */
    OFOSL: T;

    /**
     * @default 'Yellow'
     */
    '2xQvk': T;

    /**
     * @default 'Green'
     */
    Fo78F: T;

    /**
     * @default 'Blue'
     */
    YocKA: T;

    /**
     * @default 'Brown'
     */
    gEIkF: T;

    /**
     * @default 'Purple'
     */
    AE6NO: T;

    /**
     * @default 'Pink'
     */
    '2miMA': T;

    /**
     * @default 'Beige'
     */
    SrIiF: T;

    /**
     * @default 'Gray'
     */
    l5OLA: T;

    /**
     * @default 'Black'
     */
    J0JjF: T;

    /**
     * @default 'White'
     */
    BmFPH: T;

    /**
     * @default 'Gold'
     */
    aKOLA: T;

    /**
     * @default 'Rose Gold'
     */
    F912N: T;

    /**
     * @default 'Silver'
     */
    DL8LV: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default '1 Photo'
     */
    '3oxGO': T;

    /**
     * @default '2+ Photos'
     */
    oBjxd: T;

    /**
     * @default 'No Photo'
     */
    xXFMz: T;

    /**
     * @default 'Animation'
     */
    i5SX2: T;

    /**
     * @default 'Photo Slider'
     */
    nnLbq: T;

    /**
     * @default 'Photo Marquee'
     */
    gfqWI: T;

    /**
     * @default 'No Animation'
     */
    jp3gB: T;

    /**
     * @default 'Collection'
     */
    q9Pcu: T;

    /**
     * @default 'Designed by Joy'
     */
    y7nxw: T;

    /**
     * @default 'Rachel Zoe'
     */
    jTKnF: T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Paper Culture'
     */
    uBmzD: T;

    /**
     * @default 'Paperlust'
     */
    Ymn9O: T;

    /**
     * @default 'Please select a placeholder photo'
     */
    UIvJB: T;

    /**
     * @default 'Placeholder Photo'
     */
    Ruqaq: T;

    /**
     * @default 'Video placeholder'
     */
    '0Dn4B': T;

    /**
     * @default 'Change Placeholder'
     */
    nHAUN: T;

    /**
     * @default 'Remove Placeholder'
     */
    XdZgx: T;

    /**
     * @default 'Placeholder photo already selected.'
     */
    iaoZO: T;

    /**
     * @default 'Add Placeholder'
     */
    '2TVFJ': T;

    /**
     * @default 'Connection trouble.'
     */
    tB6VH: T;

    /**
     * @default 'Refresh'
     */
    jQp3e: T;

    /**
     * @default 'Apologies, we weren't able to {{0}} your changes. Please click "{{1}}" to reconnect.'
     */
    RTqJ6: T;

    /**
     * @default 'Preview Website'
     */
    XdIft: T;

    /**
     * @default 'Preview Mobile'
     */
    iSRTD: T;

    /**
     * @default 'Preview Stationery'
     */
    Q4tS1: T;

    /**
     * @default 'Go back'
     */
    Pyxnt: T;

    /**
     * @default 'Apologies, we weren't able to process your changes. Please click "{{0}}" to reconnect.'
     */
    '31L0V': T;

    /**
     * @default 'Sorry but your theme is no longer available to preview.'
     */
    U87JE: T;

    /**
     * @default 'Learn Why'
     */
    CwSgI: T;

    /**
     * @default 'Nerd face'
     */
    Ii7B3: T;

    /**
     * @default 'Sparkle'
     */
    EfVrB: T;

    /**
     * @default 'Test Tube'
     */
    Uqu9W: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Header Title Style'
     */
    Sxjs6: T;

    /**
     * @default 'Navigation Style'
     */
    Jcoqi: T;

    /**
     * @default 'None'
     */
    '4mRMA': T;

    /**
     * @default 'Glass'
     */
    khC8F: T;

    /**
     * @default 'Glass Effect Background'
     */
    Dgvtp: T;

    /**
     * @default 'Transparent'
     */
    OWUKl: T;

    /**
     * @default 'Transparent Background'
     */
    m8tCk: T;

    /**
     * @default 'Solid'
     */
    NvP6G: T;

    /**
     * @default 'Solid Background'
     */
    XOoWV: T;

    /**
     * @default 'Header Title Background Style'
     */
    AGKYI: T;

    /**
     * @default 'Navigation Background Style'
     */
    BUiws: T;

    /**
     * @default 'Header Background'
     */
    dW64d: T;

    /**
     * @default 'Navigation Background'
     */
    O130H: T;

    /**
     * @default 'Header Text'
     */
    WOrpF: T;

    /**
     * @default 'Navigation Text'
     */
    JGoRk: T;

    /**
     * @default 'Recommended Fonts'
     */
    LrkBR: T;

    /**
     * @default 'View All Fonts'
     */
    aUHSa: T;

    /**
     * @default 'More Fonts'
     */
    '7bi6g': T;

    /**
     * @default 'Header Background Color'
     */
    iFUUG: T;

    /**
     * @default 'Navigation Background Color'
     */
    NtHer: T;

    /**
     * @default 'Header Text Color'
     */
    L5J6m: T;

    /**
     * @default 'Navigation Text Color'
     */
    '6ZH2Q': T;

    /**
     * @default 'We’ve created a color palette that matches your photo and applied them to your site. You can adjust each element individually.'
     */
    cUaqu: T;

    /**
     * @default 'Upload Your Own'
     */
    O9lGl: T;
  };
};

export type WebsiteEditorTranslations<T extends LeafNodeValue = TranslateFunction> = {
  topBar: {
    /**
     * @default 'Home'
     */
    home: T;

    /**
     * @default 'Page Settings'
     */
    pageSettings: T;

    /**
     * @default 'New'
     */
    new: T;

    /**
     * @default 'Publish'
     */
    publish: T;

    /**
     * @default 'Publish Changes'
     */
    publishChanges: T;

    /**
     * @default 'Publishing...'
     */
    publishing: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Save Changes'
     */
    saveChanges: T;

    /**
     * @default 'Saving...'
     */
    saving: T;

    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Not seeing your changes on your website? Make sure to apply changes.'
     */
    notSeeingChangesMessage: T;

    /**
     * @default 'Nice work! Now, check out your page.'
     */
    niceWork: T;

    /**
     * @default 'View current page without your changes.'
     */
    viewCurrentPage: T;

    /**
     * @default 'View Page'
     */
    viewPage: T;

    visibility: {
      /**
       * @default 'Hidden'
       */
      hidden: T;

      /**
       * @default 'Password Protected'
       */
      protected: T;

      /**
       * @default 'Public'
       */
      visible: T;
    };

    /**
     * @default 'An error occurred while updating your {{resource}} Visibility. Please try again.'
     */
    changeVisibilityFailed: T;

    /**
     * @default 'Your {{resource}} is now {{visibility}}.'
     */
    changeVisibilitySuccessful: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Password. Please try again.'
     */
    changePasswordFailed: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    changePasswordSuccessful: T;

    /**
     * @default 'An error occurred while updating your page. Please try again.'
     */
    updatePageError: T;
  };
  panel: {
    /**
     * @default 'Page Photo'
     */
    pagePhoto: T;

    /**
     * @default 'Settings'
     */
    settings: T;

    /**
     * @default 'Add Label'
     */
    addLabel: T;

    /**
     * @default 'View Page'
     */
    viewPage: T;

    /**
     * @default 'Edit Page'
     */
    editPage: T;

    /**
     * @default 'Add Content'
     */
    addContent: T;

    /**
     * @default 'Skip'
     */
    skip: T;
  };
  customPage: {
    /**
     * @default 'An error occurred while creating page container. Please try again.'
     */
    createPageContainerError: T;

    /**
     * @default 'An error occurred while updating page container. Please try again.'
     */
    updatePageContainerError: T;

    /**
     * @default 'An error occurred while creating travelMap component. Please try again.'
     */
    travelMapComponentError: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Visibility. Please try again.'
     */
    changeVisibilityFailed: T;

    /**
     * @default 'Your {{resource}} is now {{visibility}}.'
     */
    changeVisibilitySuccessful: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Password. Please try again.'
     */
    changePasswordFailed: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    changePasswordSuccessful: T;

    /**
     * @default 'An error occurred while updating hotel order. Please try again.'
     */
    changeBlockOrderFailed: T;

    /**
     * @default 'Your Hotel order has been updated.'
     */
    changeBlockOrderSuccess: T;

    /**
     * @default 'An error occurred while updating component order. Please try again.'
     */
    changeComponentOrderFailed: T;

    /**
     * @default 'Your component order has been updated.'
     */
    changeComponentOrderSuccess: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    matchedHotelDialog: {
      /**
       * @default 'High five! Joy already has special group rates at this hotel—save your guests money and skip the manual setup.'
       */
      description: T;

      /**
       * @default 'Save money with Joy's rates'
       */
      saveWithJoy: T;

      /**
       * @default 'No thanks, I'll use my own booking link'
       */
      haveBookingLink: T;

      /**
       * @default 'Starting at'
       */
      startingAt: T;

      /**
       * @default 'An error occurred while saving your hotel. Please try again.'
       */
      submitError: T;

      /**
       * @default 'Success! Hotel details have been saved.'
       */
      savedHotelSuccess: T;
    };
    emptyState: {
      /**
       * @default 'Add hotel recommendations to save guests time and money'
       */
      title: T;

      /**
       * @default 'Give your guests the best rates on hotels close to your venue, available exclusively to the millions of people using Joy.'
       */
      content: T;

      /**
       * @default 'Explore Hotels'
       */
      buttonLabel: T;
    };
    customPageEmptyState: {
      /**
       * @default 'Dive in and start creating.'
       */
      title: T;

      /**
       * @default 'Add your first content block to start crafting your perfect page.'
       */
      content: T;
    };
    addNewPage: {
      /**
       * @default 'Add New Page'
       */
      title: T;

      /**
       * @default 'Name'
       */
      name: T;

      /**
       * @default 'A Memorable Name'
       */
      placeholder: T;

      /**
       * @default 'Create Page'
       */
      createPage: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'An error occurred while creating page. Please try again.'
       */
      addPageError: T;

      /**
       * @default 'Page path unavailable for the entered title. Please choose a different one.'
       */
      pagePathNotAvailable: T;
    };
    deletePage: {
      /**
       * @default 'Are you sure you want to delete this custom page?'
       */
      title: T;

      /**
       * @default 'The contents of this page will be lost. This action can’t be undone.'
       */
      subTitle: T;

      /**
       * @default 'Delete Custom Page'
       */
      deleteCustomPageCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Success! Page has been deleted.'
       */
      deletePageSuccess: T;

      /**
       * @default 'An error occurred while deleting your page. Please try again.'
       */
      deletePageError: T;
    };
    addCustomComponent: {
      /**
       * @default 'Start Creating'
       */
      title: T;

      /**
       * @default 'Add a content block and continue crafting your page.'
       */
      subTitle: T;

      /**
       * @default 'Add your first content block to craft your perfect page.'
       */
      subTitleFirst: T;

      supportedCustomComponents: {
        text: {
          /**
           * @default 'Text'
           */
          title: T;

          /**
           * @default 'Tell your guests what to expect here—make it fun, exciting, and uniquely you.'
           */
          subTitle: T;
        };
        photo: {
          /**
           * @default 'Photo'
           */
          title: T;
        };
        travel: {
          /**
           * @default 'Travel'
           */
          title: T;
        };
        eventCountdown: {
          /**
           * @default 'Event Countdown'
           */
          title: T;
        };
        video: {
          /**
           * @default 'Video'
           */
          title: T;
        };
        graphicAccent: {
          /**
           * @default 'Graphic Accent'
           */
          title: T;
        };
        photoGallery: {
          /**
           * @default 'Photo Gallery'
           */
          title: T;
        };
        eventDetails: {
          /**
           * @default 'Event Details'
           */
          title: T;
        };
        photoBlock: {
          /**
           * @default 'Photo Block'
           */
          title: T;
        };

        /**
         * @default 'Accommodations'
         */
        accommodations: T;
      };
    };
    eventDetails: {
      /**
       * @default 'Event Details'
       */
      title: T;

      /**
       * @default '{{date}}, {{location}}'
       */
      subTitle: T;

      /**
       * @default 'Are you sure you want to delete this event details block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Event details have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your event details. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Delete Event Details Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Event details have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your event details. Please try again.'
       */
      saveComponentError: T;

      form: {
        /**
         * @default 'Date'
         */
        dateLabel: T;

        /**
         * @default 'MM/DD/YYYY'
         */
        datePlaceholder: T;

        /**
         * @default 'Please re-enter the date in MM/DD/YYYY format'
         */
        dateError: T;

        /**
         * @default 'Location'
         */
        locationLabel: T;

        /**
         * @default 'San Francisco, CA'
         */
        locationPlaceholder: T;

        /**
         * @default 'Pick a place, any place. You can always change it.'
         */
        locationError: T;
      };
    };
    graphicAccent: {
      /**
       * @default 'Graphic Accent'
       */
      title: T;

      /**
       * @default 'Are you sure you want to delete this graphic accent block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Graphic accent have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your graphic accent. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Delete Graphic Accent Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Graphic accent have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your graphic accent. Please try again.'
       */
      saveComponentError: T;
    };
    eventDisplayName: {
      /**
       * @default 'Event Display Name'
       */
      title: T;

      /**
       * @default 'Are you sure you want to delete this event details block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Event details have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your event details. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Delete Event Details Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Event details have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your event details. Please try again.'
       */
      saveComponentError: T;

      form: {
        /**
         * @default 'Your Event Display Name'
         */
        displayNameLabel: T;

        /**
         * @default 'Enter your event display name'
         */
        displayNamePlaceholder: T;

        /**
         * @default 'Event Display Name is required.'
         */
        displayNameRequired: T;
      };
    };
    jsonBlobComponent: {
      form: {
        /**
         * @default 'Cancel'
         */
        cancelCta: T;

        /**
         * @default 'Delete Section'
         */
        deleteCta: T;

        /**
         * @default 'Are you sure you want to delete this section?'
         */
        deleteTitle: T;

        /**
         * @default 'The contents of this section will be lost. This action can’t be undone.'
         */
        deleteSubtitle: T;

        /**
         * @default 'Success! Section has been deleted.'
         */
        deleteComponentSuccess: T;

        /**
         * @default 'An error occurred while deleting this section. Please try again.'
         */
        deleteComponentError: T;
      };
    };
    richText: {
      form: {
        /**
         * @default 'Please enter a text.'
         */
        textRequiredError: T;

        /**
         * @default 'Share a great story with your guests'
         */
        placeholder: T;

        /**
         * @default 'Save'
         */
        saveCta: T;

        /**
         * @default 'Cancel'
         */
        cancelCta: T;

        /**
         * @default 'Success! Text has been saved.'
         */
        saveComponentSuccess: T;

        /**
         * @default 'An error occurred while saving your text. Please try again.'
         */
        saveComponentError: T;

        /**
         * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
         */
        saveComponentLimitError: T;

        /**
         * @default 'Delete Text Block'
         */
        deleteCta: T;

        /**
         * @default 'Are you sure you want to delete this text block?'
         */
        deleteTitle: T;

        /**
         * @default 'The contents of this section will be lost. This action can’t be undone.'
         */
        deleteSubtitle: T;

        /**
         * @default 'Success! Text has been deleted.'
         */
        deleteComponentSuccess: T;

        /**
         * @default 'An error occurred while deleting your text. Please try again.'
         */
        deleteComponentError: T;

        /**
         * @default 'Insert'
         */
        insert: T;

        /**
         * @default 'Update'
         */
        update: T;

        /**
         * @default 'URL'
         */
        url: T;

        /**
         * @default 'Text'
         */
        text: T;

        /**
         * @default 'https://'
         */
        linkPlaceholder: T;

        /**
         * @default 'Unlink'
         */
        unlink: T;

        /**
         * @default 'Inserting...'
         */
        inserting: T;

        /**
         * @default 'Updating...'
         */
        updating: T;
      };
      hotelSuggestionDialog: {
        /**
         * @default 'We found this hotel with exclusive rates for Joy couples and guests.'
         */
        title: T;

        /**
         * @default 'Save your guests money by adding the link to your hotel with exclusive discount up to 40%.'
         */
        description: T;

        /**
         * @default 'Save Link with Exclusive Rates'
         */
        saveLinkCta: T;

        /**
         * @default 'Keep the Original Link'
         */
        keepOriginalLinkCta: T;

        /**
         * @default 'Guest only price'
         */
        guestOnlyPrice: T;

        /**
         * @default '{{value}}'
         */
        value: T;
      };
    };
    photo: {
      /**
       * @default 'Save'
       */
      saveCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Add Your Photo'
       */
      addTitle: T;

      /**
       * @default 'We support jpeg and PNG images.'
       */
      addSubtitle: T;

      /**
       * @default 'Upload Photo'
       */
      addCta: T;

      /**
       * @default 'Replace Photo'
       */
      replaceCta: T;

      /**
       * @default 'Delete Photo Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Photo have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your photo. Please try again.'
       */
      saveComponentError: T;

      /**
       * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
       */
      saveComponentLimitError: T;

      /**
       * @default 'Are you sure you want to delete this photo block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Photo has been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your photo. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Photo'
       */
      photoCardHeader: T;
    };
    eventCountdown: {
      /**
       * @default 'Save'
       */
      saveCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Event Countdown'
       */
      title: T;

      /**
       * @default 'Add Your Event Countdown'
       */
      addTitle: T;

      /**
       * @default 'Delete Event Countdown Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Event Countdown have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your event countdown. Please try again.'
       */
      saveComponentError: T;

      /**
       * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
       */
      saveComponentLimitError: T;

      /**
       * @default 'Are you sure you want to delete this event countdown block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Event Countdown have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your event countdown. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Display event countdown'
       */
      displayEventCountdown: T;

      /**
       * @default 'Countdown to your {{eventName}} for {{date}}. You can edit event times in your'
       */
      displayCountdownNoteWithEvent: T;

      /**
       * @default 'Countdown to {{date}}.'
       */
      displayCountdownNoteWithoutEvent: T;

      /**
       * @default 'Schedule.'
       */
      schedule: T;

      /**
       * @default 'Schedule Event'
       */
      scheduleEvent: T;

      /**
       * @default 'Add an event to your schedule to customize'
       */
      scheduleEmptyPlaceholder: T;

      /**
       * @default 'Select...'
       */
      scheduleNotSelectedPlaceholder: T;
    };
    video: {
      /**
       * @default 'Save'
       */
      saveCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Video URL'
       */
      videoUrlLabel: T;

      /**
       * @default 'Video Caption'
       */
      captionLabel: T;

      /**
       * @default 'Delete Video Block'
       */
      deleteCta: T;

      /**
       * @default 'Success! Video has been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your video. Please try again.'
       */
      saveComponentError: T;

      /**
       * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
       */
      saveComponentLimitError: T;

      /**
       * @default 'Are you sure you want to delete this video block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Video has been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your video. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Please enter a valid video URL.'
       */
      formInvalidError: T;

      helpDialog: {
        /**
         * @default 'Adding a Video'
         */
        title: T;

        /**
         * @default 'Add a video to your website using a share link (URL) from Youtube or Vimeo. For the best quality, use Vimeo.'
         */
        description: T;

        /**
         * @default 'Got It'
         */
        cta: T;
      };

      /**
       * @default 'Video'
       */
      videoCardHeader: T;
    };
    photoGallery: {
      /**
       * @default 'Create Album'
       */
      createAlbum: T;

      /**
       * @default 'Select Album'
       */
      selectAlbum: T;

      /**
       * @default 'All your albums will appear here.'
       */
      selectAlbumSubText: T;

      /**
       * @default 'Photo'
       */
      photo: T;

      /**
       * @default 'Photos'
       */
      photos: T;

      /**
       * @default 'Success! Photo Gallery have been saved.'
       */
      saveComponentSuccess: T;

      /**
       * @default 'An error occurred while saving your photo gallery. Please try again.'
       */
      saveComponentError: T;

      /**
       * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
       */
      saveComponentLimitError: T;

      /**
       * @default 'Are you sure you want to delete this photo gallery block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Photo Gallery have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your photo gallery. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Delete Photo Gallery Block'
       */
      deleteCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Public'
       */
      public: T;

      /**
       * @default 'Hidden'
       */
      hidden: T;

      /**
       * @default 'Edit Album'
       */
      editAlbum: T;

      /**
       * @default 'Photo Gallery'
       */
      photoGalleryCardHeader: T;
    };
    photoBlock: {
      /**
       * @default 'Photo Block'
       */
      photoBlock: T;

      /**
       * @default 'Header Layout'
       */
      headerLayout: T;

      /**
       * @default 'Create Album'
       */
      createAlbum: T;

      /**
       * @default 'Select Album'
       */
      selectAlbum: T;

      /**
       * @default 'All your albums will appear here.'
       */
      selectAlbumSubText: T;

      /**
       * @default 'Add Photos'
       */
      addPhotos: T;

      /**
       * @default 'Photo Selection ({{countRange}} required)'
       */
      photoSelectionCount: T;

      /**
       * @default 'You must select {{countRange}} for the {{layout}}.'
       */
      photoSelectionHelperText: T;

      /**
       * @default 'You must select one photo.'
       */
      singlePhotoSelectionHelperText: T;

      /**
       * @default 'Remove Photo'
       */
      removePhoto: T;

      /**
       * @default 'Swap Photo'
       */
      swapPhoto: T;

      /**
       * @default 'Are you sure you want to delete this photo block?'
       */
      deleteTitle: T;

      /**
       * @default 'The contents of this section will be lost. This action can’t be undone.'
       */
      deleteSubtitle: T;

      /**
       * @default 'Success! Photo Block have been deleted.'
       */
      deleteComponentSuccess: T;

      /**
       * @default 'An error occurred while deleting your photo block. Please try again.'
       */
      deleteComponentError: T;

      /**
       * @default 'Delete Photo Block'
       */
      deleteCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Animated'
       */
      animated: T;

      /**
       * @default 'Continue'
       */
      continue: T;

      /**
       * @default 'Header - {{layout}}'
       */
      photoBlockCardHeader: T;

      photoPresentationLayouts: {
        /**
         * @default 'Screen Width Photo'
         */
        fullWidth: T;

        /**
         * @default 'Page Width Photo'
         */
        pageWidth: T;

        /**
         * @default 'Centered Photo'
         */
        center: T;

        /**
         * @default 'Photo Slider'
         */
        photoSlider: T;

        /**
         * @default 'Photo Marquee'
         */
        photoMarquee: T;

        /**
         * @default 'Photo Trio'
         */
        photoTrio: T;

        /**
         * @default 'Page Width Photo Trio'
         */
        photoTrioPageWidth: T;

        /**
         * @default 'Photo Duo Left'
         */
        photoDuoLeft: T;

        /**
         * @default 'Photo Duo Right'
         */
        photoDuoRight: T;

        /**
         * @default 'Photo Arch'
         */
        photoArch: T;

        /**
         * @default 'No Photo'
         */
        noPhoto: T;

        /**
         * @default 'Monogram'
         */
        monogram: T;

        /**
         * @default 'Photo Background'
         */
        photoBackground: T;

        /**
         * @default 'Video Background'
         */
        videoBackground: T;
      };
    };
    greetingMessage: {
      /**
       * @default 'Greeting Message'
       */
      title: T;

      form: {
        /**
         * @default 'We can't wait to share our special day with you. Help us capture our wedding with Joy.'
         */
        greetingMessagePlaceholder: T;
      };
    };
    itemTypes: {
      travelMapVenue: {
        title: {
          /**
           * @default 'Add Venue'
           */
          add: T;

          /**
           * @default 'Venue'
           */
          edit: T;
        };

        /**
         * @default 'Your event location.'
         */
        subTitle: T;
      };
      travelMapHotels: {
        title: {
          /**
           * @default 'Add Hotel Room Block'
           */
          add: T;

          /**
           * @default 'Hotel Room Block'
           */
          edit: T;

          /**
           * @default 'Delete Hotel Room Block'
           */
          deleteCta: T;

          /**
           * @default 'Cancel Room Block'
           */
          cancelCta: T;
        };

        /**
         * @default 'Your reserved room block.'
         */
        subTitle: T;
      };
      travelMapAccommodationsCustom: {
        title: {
          /**
           * @default 'Add Custom Property'
           */
          add: T;

          /**
           * @default 'Add your own stay'
           */
          addV2: T;

          /**
           * @default 'Edit Hotel Link'
           */
          editV2: T;

          /**
           * @default 'Custom Property'
           */
          edit: T;

          /**
           * @default 'Delete Custom Property'
           */
          deleteCta: T;
        };
        list: {
          /**
           * @default 'Custom Property'
           */
          title: T;

          /**
           * @default 'Existing Room Blocks, homes, and other unique stays.'
           */
          subtitle: T;
        };
        listV2: {
          /**
           * @default 'Other'
           */
          title: T;

          /**
           * @default 'Add custom link. From a rental home to a campsite to an existing room block.'
           */
          subtitle: T;
        };

        /**
         * @default 'Share an existing room block, homes or other unique stays.'
         */
        subTitle: T;

        /**
         * @default 'Add an existing room block, homes or other unique stays link to your page.'
         */
        subTitleV2: T;
      };
      travelMapAccommodationsGetRoomBlock: {
        listV2: {
          /**
           * @default 'Get Hotel Room Blocks'
           */
          title: T;

          /**
           * @default 'Work with your Joy concierge to get the best room block rates for you and your guests.'
           */
          subtitle: T;
        };
      };
      travelMapAccommodationsHotel: {
        title: {
          /**
           * @default 'Add Hotel'
           */
          add: T;

          /**
           * @default 'Hotel'
           */
          edit: T;

          /**
           * @default 'Edit Hotel'
           */
          editHotel: T;

          /**
           * @default 'Delete Hotel'
           */
          deleteCta: T;
        };
        list: {
          /**
           * @default 'Hotel'
           */
          title: T;

          /**
           * @default 'Share a hotel with your guests.'
           */
          subtitle: T;
        };
        listV2: {
          /**
           * @default 'Add Hotel'
           */
          title: T;

          /**
           * @default 'Add hotels to your page. Need more options? Explore nearby hotels with top discounts.'
           */
          subtitle: T;
        };

        /**
         * @default 'Share a hotel with your guests.'
         */
        subTitle: T;

        starRatingTooltip: {
          /**
           * @default 'Star ratings show hotel quality, not reviews. '
           */
          title: T;

          /**
           * @default 'More stars = fancier place with better service and amenities.'
           */
          content: T;
        };

        /**
         * @default '{{miles}} mi from venue'
         */
        milesFromVenue: T;

        editHotelTooltip: {
          /**
           * @default 'How Guest See It'
           */
          title: T;

          /**
           * @default 'Edit how this hotel is shown to guests on your website. Choose the cover photo, let guests know where you’re staying and write a personal note why you’re recommending it.'
           */
          content: T;
        };
      };
      travelMapAccommodationsRoomblock: {
        title: {
          /**
           * @default 'Add Hotel Room Block'
           */
          add: T;

          /**
           * @default 'Hotel Room Block'
           */
          edit: T;

          /**
           * @default 'Delete Hotel Room Block'
           */
          deleteCta: T;

          /**
           * @default 'Cancel Room Block'
           */
          cancelCta: T;
        };

        /**
         * @default 'Your reserved room block.'
         */
        subTitle: T;
      };
    };
    travelMap: {
      feedback: {
        /**
         * @default 'How'd we do with our recommendations?'
         */
        howDidWeDo: T;

        /**
         * @default 'What could we do better?'
         */
        whatCouldWeDoBetter: T;

        /**
         * @default 'Send Feedback'
         */
        sendFeedback: T;

        /**
         * @default 'Start typing...'
         */
        startTyping: T;
      };

      /**
       * @default 'Your Venue Details'
       */
      yourVenueDetails: T;

      venue: {
        /**
         * @default 'Your Venue'
         */
        title: T;

        /**
         * @default 'Add Venue'
         */
        addVenue: T;

        addEditForm: {
          /**
           * @default 'Success! Venue details have been saved.'
           */
          submitSuccess: T;

          /**
           * @default 'An error occurred while saving your venue. Please try again.'
           */
          submitError: T;

          /**
           * @default 'An error occurred while deleting your venue. Please try again.'
           */
          deleteError: T;

          form: {
            /**
             * @default 'Venue'
             */
            venue: T;

            /**
             * @default 'Latitude'
             */
            latitude: T;

            /**
             * @default 'Longitude'
             */
            longitude: T;

            /**
             * @default '-34.5628781'
             */
            latitudePlaceholder: T;

            /**
             * @default '-58.4600246'
             */
            longitudePlaceholder: T;

            /**
             * @default 'Please enter a venue.'
             */
            venueError: T;

            /**
             * @default 'Please enter a valid latitude.'
             */
            latitudeError: T;

            /**
             * @default 'Please enter a valid longitude.'
             */
            longitudeError: T;

            /**
             * @default 'Please enter a valid latitude.'
             */
            latitudeTypeError: T;

            /**
             * @default 'Please enter a valid longitude.'
             */
            longitudeTypeError: T;
          };
        };
        eventVenueDialog: {
          searchPlaceholders: [
            /**
             * @default 'San Francisco City Hall'
             */
            T,
            /**
             * @default 'Martoca Beach Garden, Mexico'
             */
            T,
            /**
             * @default 'Bathers Pavilion, Balmoral Beach, Sydney'
             */
            T,
            /**
             * @default 'Heritage Hall, Vancouver, Canada'
             */
            T,
            /**
             * @default 'Amadeus, Maida Vale, London'
             */
            T,
            /**
             * @default 'Garfield Park Conservatory, Chicago'
             */
            T,
            /**
             * @default 'The Grove, Houston'
             */
            T,
            /**
             * @default 'The Plaza Hotel, New York City'
             */
            T,
          ];
          createVenue: {
            /**
             * @default 'Add your venue'
             */
            title: T;

            /**
             * @default 'We’ll use this to personalize your guest website experience with maps, directions, things-to-do, nearby hotel picks and more.'
             */
            message: T;

            /**
             * @default 'Save Venue'
             */
            cta: T;

            /**
             * @default 'Event Venue or Destination'
             */
            searchLabel: T;

            /**
             * @default 'Please enter event venue.'
             */
            saveVenueError: T;
          };
          updateVenue: {
            /**
             * @default 'Update your venue'
             */
            title: T;

            /**
             * @default 'Changing your venue location will update wherever it’s used. I.e. if you’ve already added hotels, distance and driving directions will be updated to this new location. '
             */
            message: T;

            /**
             * @default 'Update Venue'
             */
            cta: T;

            /**
             * @default 'Event Venue'
             */
            searchLabel: T;

            /**
             * @default 'Please enter event venue.'
             */
            saveVenueError: T;
          };
          confirmVenue: {
            /**
             * @default 'Confirm your venue'
             */
            title: T;

            /**
             * @default 'Let’s make sure your venue is up-to-date. Easily include venue details on your website. Get personalized guest travel itineraries near your event that you can customize.'
             */
            message: T;

            /**
             * @default 'Looks Good'
             */
            cta: T;

            /**
             * @default 'Event Venue'
             */
            searchLabel: T;

            /**
             * @default 'Please enter event venue.'
             */
            saveVenueError: T;
          };
          createdVenue: {
            /**
             * @default 'Do you think your guests might need a hotel nearby?'
             */
            title: T;

            /**
             * @default 'Whether your guests are travelling from out of town, or just want a quick walk home after the night of fun.'
             */
            message: T;

            /**
             * @default 'Yes, they might'
             */
            cta: T;

            /**
             * @default 'Probably not'
             */
            cta2: T;
          };
          filters: {
            /**
             * @default 'Select your preferences to get personalized recommendations'
             */
            title: T;

            /**
             * @default 'Show Recommended Hotels'
             */
            cta: T;
          };
          results: {
            /**
             * @default 'We curated the best of 5,000 Joy hotels, chosen for your guests.'
             */
            title: T;

            /**
             * @default 'Preview Page'
             */
            previewPage: T;

            /**
             * @default 'Browse 5,000 More Stays'
             */
            browseMoreStays: T;

            hotelCard: {
              /**
               * @default '{{price}} / night'
               */
              price: T;

              /**
               * @default '{{percentage}}% off'
               */
              percentageOff: T;

              /**
               * @default '{{min}} min'
               */
              travelTime: T;

              /**
               * @default '{{miles}} mi'
               */
              distance: T;

              /**
               * @default 'Highest discount'
               */
              highestDiscount: T;

              /**
               * @default 'Picked by {{count}}+ Joy couples'
               */
              pickedBy: T;

              /**
               * @default '{{miles}} mi to your venue'
               */
              toVenue: T;

              /**
               * @default 'Added'
               */
              added: T;
            };
          };
        };
        venueAutoPopulateLoadingState: {
          /**
           * @default 'We’ve found {{populatedHotels}} hotels offering special rates near your venue!  🎉'
           */
          title: T;

          /**
           * @default 'We searched thousands of places to stay near your venue. Based on the last 10 years of weddings in your area, we’ve optimized for distance, price, and rating. Add and remove hotels to make it your own.'
           */
          message: T;

          /**
           * @default 'Reveal Hotel Picks'
           */
          cta: T;

          messages: [
            /**
             * @default 'Finding the best deals for your guests. 🙏'
             */
            T,
            /**
             * @default 'Making sure the rooms are nice. 💅'
             */
            T,
            /**
             * @default 'Calculating walking time and driving distance… 🏃‍♀️'
             */
            T,
            /**
             * @default 'Because who doesn’t love a lil’ stroll after the party?'
             */
            T,
          ];
        };
        venueAutoPopulateLoadingEmptyState: {
          /**
           * @default 'We are having trouble finding hotel rates near your venue.'
           */
          title: T;

          /**
           * @default 'You’re welcome to add any place you want, manually.'
           */
          message: T;

          /**
           * @default 'Add a Place to Stay'
           */
          cta: T;
        };
      };
      guestHotelBookings: {
        /**
         * @default 'Booked on {{month}} {{day}}, {{year}} at {{time}}'
         */
        bookedOn: T;

        /**
         * @default '{{checkInMonth}} {{checkInDay}} — {{checkOutMonth}} {{checkOutDay}}'
         */
        dateRange: T;

        /**
         * @default '{{value}}'
         */
        translateValue: T;

        featureDialog: {
          /**
           * @default 'Track Guest Hotel Bookings'
           */
          title: T;

          /**
           * @default ' When you use Joy Hotels, your guests get access to exclusive closed user group rates and you get to see where everyone’s staying. We’ll notify you when a guest books, and you can view all bookings here to help with planning.'
           */
          message: T;

          /**
           * @default 'Got it'
           */
          gotIt: T;

          /**
           * @default 'New'
           */
          new: T;
        };

        /**
         * @default '{{firstName}} {{lastName}}'
         */
        guestName: T;

        /**
         * @default '{{distance}} from venue'
         */
        distanceFromVenue: T;
      };
      hotel: {
        /**
         * @default 'Solid'
         */
        solid: T;

        /**
         * @default 'Luxe'
         */
        luxe: T;

        /**
         * @default '{{rooms}} rooms'
         */
        rooms: T;

        /**
         * @default '{{groupDiscount}}% Group Discount'
         */
        groupDiscount: T;

        /**
         * @default 'and more'
         */
        andMore: T;

        /**
         * @default 'Group Rate ({{noOfRooms}} Rooms)'
         */
        groupRateRooms: T;

        /**
         * @default 'Rooms starting from'
         */
        roomsStartingFrom: T;

        /**
         * @default 'Standard Price'
         */
        standardPrice: T;

        /**
         * @default 'Edit'
         */
        editStay: T;

        /**
         * @default 'Remove'
         */
        remove: T;

        /**
         * @default 'Hotels'
         */
        hotels: T;

        /**
         * @default 'Places to Stay'
         */
        placesToStay: T;

        /**
         * @default 'Accommodations'
         */
        accommodations: T;

        /**
         * @default 'Share the perfect stay with your guests.'
         */
        noHotelsAdded: T;

        /**
         * @default 'Deal ends:'
         */
        dealends: T;

        /**
         * @default 'Group Rate ({noOfRooms})'
         */
        groupRate: T;

        /**
         * @default 'Add Hotel'
         */
        addHotelCta: T;

        /**
         * @default 'Add Stay'
         */
        addStayCta: T;

        /**
         * @default 'Add Place to Stay'
         */
        addPlaceToStay: T;

        /**
         * @default 'Search and add more hotels at any time.'
         */
        fabTooltip: T;

        /**
         * @default 'Add hotels, room blocks or custom links'
         */
        addStaySubtitle: T;

        /**
         * @default 'SUPER ADMIN ONLY'
         */
        superAdminOnly: T;

        /**
         * @default 'Room Block'
         */
        labelRoomblock: T;

        /**
         * @default '{{percentage}}% off'
         */
        percentageOff: T;

        /**
         * @default 'Favorite'
         */
        labelFavorite: T;

        /**
         * @default 'Manage Your Hotels'
         */
        manageYourHotels: T;

        /**
     * @default 'You can’t drag an item 
 above your preferred hotel.'
*/
        changeOrderInfo: T;

        /**
         * @default 'Book by'
         */
        bookBy: T;

        /**
         * @default 'Explore'
         */
        explore: T;

        /**
         * @default 'By'
         */
        by: T;

        addEditForm: {
          /**
           * @default 'Use My Own Booking Link'
           */
          updateLink: T;

          /**
           * @default 'ZentrumHub ID'
           */
          zhId: T;

          /**
           * @default 'ZentrumHub ID (Super Admin Only)'
           */
          zhIdLabel: T;

          /**
           * @default '+1-555-555-5555'
           */
          phonePlaceholder: T;

          /**
           * @default 'Phone'
           */
          phone: T;

          /**
           * @default 'Add Hotel'
           */
          addHotel: T;

          /**
           * @default 'Hotel Photo'
           */
          hotelPhoto: T;

          /**
           * @default 'Add Hotel Photo'
           */
          addHotelPhoto: T;

          /**
           * @default 'Add Photo'
           */
          addPhoto: T;

          /**
           * @default 'Edit Photo'
           */
          editPhoto: T;

          /**
           * @default 'Edit Hotel'
           */
          editHotel: T;

          /**
           * @default 'Delete Hotel'
           */
          deleteCta: T;

          /**
           * @default 'Mark as favorite hotel'
           */
          markAsFavoriteHotel: T;

          /**
           * @default 'We're sorry, we're having trouble generating a prompt. Try again'
           */
          promptError: T;

          /**
           * @default 'Latitude'
           */
          latitude: T;

          /**
           * @default 'Longitude'
           */
          longitude: T;

          /**
           * @default 'Star Rating'
           */
          starRating: T;

          /**
           * @default 'Check in'
           */
          checkIn: T;

          /**
           * @default 'Check out'
           */
          checkOut: T;

          /**
           * @default 'Cutoff Date'
           */
          cutoffDate: T;

          /**
           * @default 'Initial Price'
           */
          initialPrice: T;

          /**
           * @default 'Joy Price'
           */
          joyPrice: T;

          /**
           * @default 'Hotel Note'
           */
          hotelNote: T;

          /**
           * @default 'Save'
           */
          saveCta: T;

          /**
           * @default 'Cancel'
           */
          cancelCta: T;

          /**
           * @default 'Search for hotels'
           */
          namePlaceholder: T;

          /**
           * @default '-34.5628781'
           */
          latitudePlaceholder: T;

          /**
           * @default '-58.4600246'
           */
          longitudePlaceholder: T;

          /**
           * @default 'www.hotel.com/mywedding'
           */
          bookingLinkPlaceholder: T;

          /**
           * @default '4.5'
           */
          starRatingPlaceholder: T;

          /**
           * @default '20'
           */
          numberOfRoomsPlaceholder: T;

          /**
           * @default '400'
           */
          initialPricePlaceholder: T;

          /**
           * @default '200'
           */
          joyPricePlaceholder: T;

          /**
           * @default 'Please add a hotel photo.'
           */
          photoError: T;

          /**
           * @default 'Please add a hotel booking link.'
           */
          bookingLinkError: T;

          /**
           * @default 'Please add a check in date.'
           */
          checkInDateError: T;

          /**
           * @default 'Please add a check out date.'
           */
          checkOutDateError: T;

          /**
           * @default 'Check in date must be before check out date'
           */
          checkInDateRangeError: T;

          /**
           * @default 'Check out date must be after check in date'
           */
          checkOutDateRangeError: T;

          /**
           * @default 'Please add cutoff date.'
           */
          cutoffDateError: T;

          /**
           * @default 'Please add the Initial price for the hotel.'
           */
          initialPriceError: T;

          /**
           * @default 'Please enter the valid Initial price for the hotel.'
           */
          initialPriceTypeError: T;

          /**
           * @default 'Please add price per night.'
           */
          joyPriceError: T;

          /**
           * @default 'Please enter the valid Joy price for the hotel.'
           */
          joyPriceTypeError: T;

          /**
           * @default 'Please enter a valid latitude.'
           */
          latitudeTypeError: T;

          /**
           * @default 'Please enter a valid longitude.'
           */
          longitudeTypeError: T;

          /**
           * @default 'Please enter a valid star rating.'
           */
          starRatingTypeError: T;

          /**
           * @default 'An error occurred while saving your hotel. Please try again.'
           */
          submitError: T;

          /**
           * @default 'An error occurred while deleting your hotel. Please try again.'
           */
          deleteError: T;

          /**
           * @default 'User not submitted hotel room blocks request.'
           */
          hotelRoomBlocksError: T;

          /**
           * @default 'Success! Hotel details have been saved.'
           */
          savedHotelSuccess: T;

          /**
           * @default 'Please enter the number of rooms reserved.'
           */
          numberOfRoomsReservedError: T;

          /**
           * @default 'Please enter a valid number of rooms reserved.'
           */
          numberOfRoomsReservedTypeError: T;

          /**
           * @default 'An error occurred while saving your photo. Please try again.'
           */
          photoSaveError: T;

          thumbnail: {
            /**
             * @default 'Thumbnail'
             */
            title: T;

            tooltip: {
              /**
               * @default 'Thumbnail'
               */
              title: T;

              /**
               * @default 'This is a preview of how this hotel will be displayed on your website. Guests click on this to view more details and book from your website.'
               */
              content: T;
            };
          };
          spotlight: {
            /**
             * @default 'Spotlight'
             */
            title: T;

            /**
             * @default 'Pick one hotel that will be displayed at the top of the list.'
             */
            sideNote: T;

            tooltip: {
              /**
               * @default 'Mark as Spotlight'
               */
              title: T;

              /**
               * @default 'Marking a hotel as a favorite lets guests know you prefer them to book here. Your hotel will show a “favorites” badge on the link.'
               */
              content: T;
            };
          };
          isJoyManagedRoomBlock: {
            /**
             * @default 'Joy Hotel Room Block'
             */
            title: T;

            tooltip: {
              /**
               * @default 'Joy Hotel Room Block'
               */
              title: T;

              /**
               * @default 'Please check this only if this is a Joy room block that the host got through Joy.'
               */
              content: T;
            };
          };
          coupleNote: {
            /**
             * @default 'Why It’s Your Pick'
             */
            title: T;

            /**
             * @default 'Suggest'
             */
            suggest: T;

            tooltip: {
              /**
               * @default 'Tell Guests Why'
               */
              title: T;

              /**
               * @default 'Write a note to guest why you picked this hotel. Let me know any details you might want to share.'
               */
              content: T;
            };
          };

          /**
           * @default 'About this property'
           */
          aboutThisProperty: T;
        };
      };
      leadState: {
        comingSoon: {
          /**
           * @default 'Coming Soon'
           */
          eyebrowTitle: T;

          /**
           * @default 'Joy's Free Hotel Concierge Service'
           */
          title: T;

          /**
           * @default 'Add courtesy blocks at discounted rates and zero deposit requirements with our free hotel concierge service.'
           */
          message: T;

          /**
           * @default 'I'm Interested'
           */
          cta: T;

          /**
           * @default 'Interest Confirmed!'
           */
          toastMessage: T;
        };
        pitch: {
          /**
           * @default 'Introducing Joy Room Blocks'
           */
          eyebrowTitle: T;

          /**
           * @default 'Get discounted rates for you and your guests.'
           */
          title: T;

          /**
           * @default 'Let our concierge team call hotels on your behalf and unlock all the benefits below so that you can focus on what matters most.'
           */
          message: T;

          /**
           * @default 'Get Started'
           */
          cta: T;

          /**
           * @default 'Save up to 30% off room rates'
           */
          valuePropOneTitle: T;

          /**
           * @default 'Enjoy exclusive group rate discounts with your favorite hotels and resorts.'
           */
          valuePropOneDescription: T;

          /**
           * @default 'No Financial Commitments'
           */
          valuePropTwoTitle: T;

          /**
           * @default 'We’ll take on the risk—that means no cancelation fees if your hotel room blocks aren’t fully booked.'
           */
          valuePropTwoDescription: T;

          /**
           * @default 'Perks'
           */
          valuePropThreeTitle: T;

          /**
           * @default 'From bridal suite upgrades and spa experiences, to in‑room amenities for you and your guests.'
           */
          valuePropThreeDescription: T;

          /**
           * @default 'Dedicated Concierge Team'
           */
          valuePropFourTitle: T;

          /**
           * @default 'Your personal hotel consultant can help  book rooms, and answer all your questions before your event.'
           */
          valuePropFourDescription: T;
        };
        inProgress: {
          /**
           * @default 'Your room blocks request is being processed.'
           */
          title: T;

          /**
           * @default 'The typical request takes 6 days. We'll send you an email when your rates are ready.'
           */
          text: T;

          /**
           * @default 'Once you receive your booking link, we'll populate this page with your hotels and help you share your room block with guests.'
           */
          subText: T;

          /**
           * @default 'View Hotel Request'
           */
          cta: T;
        };
        getAccommodations: {
          /**
           * @default 'Your hotels will soon be visible in your accommodations page.'
           */
          title: T;

          /**
           * @default 'If you have questions please contact our concierge team.'
           */
          subtext: T;

          /**
           * @default 'Manage Hotel Request'
           */
          cta: T;
        };
        adminAccommodations: {
          /**
           * @default 'To update your hotels and venue content, please contact our concierge team.'
           */
          message: T;

          /**
           * @default 'Contact Concierge'
           */
          contactCta: T;

          /**
           * @default 'Manage Room Blocks'
           */
          manageCta: T;
        };
      };
      leadStateV2: {
        getAccommodations: {
          /**
           * @default 'Unlock exclusive group rates with our free hotel concierge service.'
           */
          title: T;

          /**
           * @default 'We’ll show you which hotels couples and guests consistently choose and negotiate exclusive rates on your behalf.'
           */
          subText: T;

          /**
           * @default 'Get Started'
           */
          cta: T;
        };
        inProgress: {
          /**
           * @default 'Your room blocks request is being processed.'
           */
          title: T;

          /**
           * @default 'The typical request takes 6 days. We'll send you an email when your rates are ready.'
           */
          subText: T;

          /**
           * @default 'View Hotel Request'
           */
          cta: T;
        };
      };
      updateRoomBlockMessage: {
        /**
         * @default 'To update your hotels and venue content, please contact our concierge team.'
         */
        message: T;

        /**
         * @default 'Contact Concierge'
         */
        contactCta: T;

        /**
         * @default 'Manage Room Blocks'
         */
        manageCta: T;
      };
      updateExploreCTA: {
        /**
         * @default 'Explore Other Options'
         */
        label: T;

        /**
         * @default 'Success! 'Explore Other Options' has been updated.'
         */
        successMessage: T;

        /**
         * @default 'An error occurred while updating. Please try again.'
         */
        failedMessage: T;
      };
      ourPicks: {
        /**
         * @default 'How did we pick these hotels?'
         */
        title: T;

        picks: [
          {
            /**
             * @default 'Amazing Exclusive Rates'
             */
            title: T;

            /**
             * @default 'We help MILLIONS of guests each year, giving you access to cheaper group rates than Expedia—up to 40% off per night!'
             */
            subTitle: T;
          },
          {
            /**
             * @default 'Something for Everyone'
             */
            title: T;

            /**
             * @default 'A range of price points that include hotels with the best event-friendly amenities.'
             */
            subTitle: T;
          },
          {
            /**
             * @default 'Close to Your Venue'
             */
            title: T;

            /**
             * @default 'Balancing travel time and distance, we’ve picked the most popular and conveniently located hotels near your event.'
             */
            subTitle: T;
          },
        ];
      };
    };
    delete: {
      /**
       * @default 'Are you sure you want to delete this item?'
       */
      title: T;

      /**
       * @default 'This cannot be undone.'
       */
      message: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      travelMapVenue: {
        /**
         * @default 'Delete Venue'
         */
        deleteCta: T;
      };
      travelMapHotels: {
        /**
         * @default 'Delete Hotel'
         */
        deleteCta: T;
      };
      travelMapAccommodationsHotel: {
        /**
         * @default 'Delete Accommodation'
         */
        deleteCta: T;
      };
      travelMapAccommodationsCustom: {
        /**
         * @default 'Delete Custom Property'
         */
        deleteCta: T;
      };
      travelMapAccommodationsRoomblock: {
        /**
         * @default 'Remove Stay from Page'
         */
        deleteCta: T;
      };
    };
    cancelRoomBlock: {
      /**
       * @default 'Request to Cancel Your Room Block'
       */
      title: T;

      /**
       * @default 'Let us know if you need to cancel your room block, and we’ll follow up via email within 3 business days.'
       */
      message: T;

      /**
       * @default 'Reason for cancelling'
       */
      label: T;

      /**
       * @default 'Please enter a reason for canceling the room block.'
       */
      inputError: T;

      /**
       * @default 'An error occurred while canceling your room block. Please try again.'
       */
      submitError: T;

      /**
       * @default 'Your room block cancellation request has been sent.'
       */
      successMessage: T;

      /**
       * @default 'Request Cancellation'
       */
      cancelRoomBlockCta: T;

      /**
       * @default 'Cancel'
       */
      cancelCta: T;

      /**
       * @default 'Cancel Room Block'
       */
      cancelOption: T;
    };
    registryLinks: {
      /**
       * @default 'Welcome Note'
       */
      welcomeNoteLabel: T;

      /**
       * @default 'Manage Registry'
       */
      manageRegistryCta: T;

      welcomeWidget: {
        /**
         * @default 'Welcome to your registry.'
         */
        title: T;

        /**
         * @default 'With Joy, your website IS your registry, so you’ll never share an awkward link or worry about people finding it. Guests can access your gifts, cash funds, and more all in one place.'
         */
        description: T;
      };
      registryActions: {
        /**
         * @default 'Guests will give you gifts no matter what—why not pick things you’ll actually love?'
         */
        title: T;
      };

      /**
       * @default 'Build Your Registry'
       */
      buildRegistry: T;

      /**
       * @default 'The registry trusted by millions.'
       */
      heroTitle: T;

      /**
       * @default 'Add Gifts'
       */
      addGifts: T;

      /**
       * @default 'Track Gifts'
       */
      trackGifts: T;

      /**
       * @default 'Background video'
       */
      backgroundVideo: T;

      /**
       * @default 'Emoji'
       */
      emoji: T;
    };
    thingsToDo: {
      /**
       * @default 'Thing to Do'
       */
      title: T;

      /**
       * @default 'Add'
       */
      add: T;

      /**
       * @default 'Edit'
       */
      edit: T;

      /**
       * @default 'Delete Thing to Do'
       */
      delete: T;

      /**
       * @default 'Category'
       */
      category: T;

      /**
       * @default 'Website'
       */
      website: T;

      /**
       * @default 'thingtodo.com'
       */
      websitePlaceholder: T;

      /**
       * @default 'Name'
       */
      name: T;

      /**
       * @default 'Louvre Museum'
       */
      namePlaceholder: T;

      /**
       * @default 'Personal Note'
       */
      personalNote: T;

      /**
       * @default 'Add some optional details about why you think your guests would enjoy it, things to know, etc.'
       */
      personalNotePlaceholder: T;

      /**
       * @default 'Name is required'
       */
      titleRequired: T;

      /**
       * @default 'Please enter a valid URL'
       */
      urlInvalid: T;

      /**
       * @default 'Category is required'
       */
      categoryRequired: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'Save'
       */
      save: T;

      /**
       * @default 'Custom Category'
       */
      customCategory: T;

      /**
       * @default 'Custom Category'
       */
      customCategoryPlaceholder: T;

      /**
       * @default 'Recommended Things to Do'
       */
      recommendedThingsToDo: T;

      /**
       * @default 'Failed to update. Please try again.'
       */
      failedUpdate: T;

      /**
       * @default 'Failed to create. Please try again.'
       */
      failedCreate: T;
    };
    weatherReport: {
      /**
       * @default 'Weather Report'
       */
      title: T;

      /**
       * @default 'Keep details crisp and clear for guests.'
       */
      subtitle: T;

      location: {
        /**
         * @default 'Location'
         */
        title: T;

        /**
         * @default 'Search location'
         */
        search: T;

        /**
         * @default 'Display name'
         */
        displayName: T;

        /**
         * @default 'e.g., Napa Valley'
         */
        displayNamePlaceholder: T;

        /**
         * @default 'City'
         */
        city: T;

        /**
         * @default 'Country'
         */
        country: T;
      };
      dates: {
        /**
         * @default 'Dates'
         */
        title: T;

        /**
         * @default 'Date range'
         */
        range: T;
      };
      daily: {
        /**
         * @default 'Daily forecast'
         */
        title: T;

        /**
         * @default 'Populate from date range'
         */
        populateFromRange: T;

        /**
         * @default 'Date'
         */
        date: T;

        /**
         * @default 'Remove'
         */
        remove: T;

        /**
         * @default 'Summary'
         */
        summary: T;

        /**
         * @default 'Sunny, showers, cloudy...'
         */
        summaryPlaceholder: T;

        /**
         * @default 'High °C'
         */
        highC: T;

        /**
         * @default 'Low °C'
         */
        lowC: T;

        /**
         * @default 'Precip (0–1)'
         */
        precip01: T;

        /**
         * @default 'Humidity %'
         */
        humidityPct: T;

        /**
         * @default 'Wind kph'
         */
        windKph: T;

        /**
         * @default 'UV Index'
         */
        uvIndex: T;

        /**
         * @default 'Add day'
         */
        addDay: T;
      };
      cities: {
        /**
         * @default 'Cities'
         */
        title: T;

        /**
         * @default '+ Add city'
         */
        add: T;

        /**
         * @default 'Remove city'
         */
        remove: T;

        /**
         * @default 'City {{index}}'
         */
        fallback: T;
      };
      cityHighlights: {
        /**
         * @default 'City guest highlights'
         */
        label: T;

        /**
         * @default 'Helpful notes specific to this city...'
         */
        placeholder: T;
      };
      guestHighlights: {
        /**
         * @default 'Guest highlights'
         */
        label: T;

        /**
         * @default 'Helpful notes for your guests...'
         */
        placeholder: T;
      };

      /**
       * @default 'Save'
       */
      saveCta: T;

      toast: {
        /**
         * @default 'Weather report saved'
         */
        saved: T;

        /**
         * @default 'We couldn't save your weather report. Please try again.'
         */
        failed: T;
      };
      guest: {
        /**
         * @default 'Today'
         */
        today: T;

        /**
         * @default '{{count}}-Day Forecast'
         */
        nDayForecast: T;

        /**
         * @default 'Host planning notes'
         */
        hostPlanningNotes: T;
      };
      metrics: {
        labels: {
          /**
           * @default 'Precip'
           */
          precip: T;

          /**
           * @default 'Humidity'
           */
          humidity: T;

          /**
           * @default 'Wind'
           */
          wind: T;

          /**
           * @default 'UV'
           */
          uv: T;
        };

        /**
         * @default 'UV: {{uv}} · {{category}}'
         */
        uvLabel: T;

        uvCategory: {
          /**
           * @default 'Low'
           */
          low: T;

          /**
           * @default 'Moderate'
           */
          moderate: T;

          /**
           * @default 'High'
           */
          high: T;

          /**
           * @default 'Very High'
           */
          veryHigh: T;

          /**
           * @default 'Extreme'
           */
          extreme: T;
        };

        /**
         * @default 'Wind: {{kph}} km/h · {{label}}'
         */
        windLabel: T;

        windCategory: {
          /**
           * @default 'Calm'
           */
          calm: T;

          /**
           * @default 'Breezy'
           */
          breezy: T;

          /**
           * @default 'Windy'
           */
          windy: T;

          /**
           * @default 'Strong'
           */
          strong: T;
        };
      };
    };
  };

  /**
   * @default 'Compared to <ExpediaCompareTo/>'
   */
  expediaCompareTo: T;

  venueDialog: {
    /**
     * @default 'Map'
     */
    map: T;

    /**
     * @default 'Remove Venue'
     */
    removeVenue: T;

    /**
     * @default 'Are you sure you want to remove the venue?'
     */
    removeConfirm: T;

    /**
     * @default 'Super Admins Only'
     */
    superAdminsOnly: T;
  };
  venueIntro: {
    /**
     * @default 'Your venue is the center of your “Where to Stay” guide'
     */
    title: T;

    /**
     * @default 'It’s more than a page. It’s a smart hotel guide you create, with Joy Travel Closed User Group (CUG) rates only your guests can see. It’s helpful for anyone who wants to stay nearby, not just out-of-town guests. No room blocks, codes, or setup.'
     */
    message: T;

    /**
     * @default 'Listen to how it works'
     */
    audioCta: T;

    /**
     * @default 'Curate this page'
     */
    cta: T;

    hotelTile: {
      /**
       * @default 'Closest to Venue'
       */
      closestToVenue: T;

      /**
       * @default 'For Our Guests'
       */
      forOurGuests: T;

      /**
       * @default 'Joy Travel'
       */
      joyTravel: T;

      /**
       * @default 'Save {{percentageOff}}%'
       */
      savePercentageOff: T;

      /**
       * @default '{{price}} / night'
       */
      pricePerNight: T;

      /**
       * @default 'public rates from {{strikeOutPrice}}'
       */
      strikeOutPrice: T;
    };
  };
  venueFilters: {
    /**
     * @default 'Rank what matters most and Joy’s AI will find hotels your guests will love.'
     */
    title: T;

    /**
     * @default 'Listen to how it works'
     */
    audioCta: T;

    /**
     * @default 'Reveal Matches'
     */
    cta: T;

    standardRoomPriceDiscountPercent: {
      /**
       * @default 'Best Deals with Closed User Group Rates 💰'
       */
      title: T;

      /**
       * @default 'Prioritizes hotels offering private, discounted rates only available to your guests through Joy. These rates are typically 20% to 40% lower than public prices. No room blocks or special codes needed.'
       */
      tooltip: T;
    };
    userRating: {
      /**
       * @default 'Highest Star Hotels for Every Guest Budget ⭐️'
       */
      title: T;

      /**
       * @default 'Find the best quality hotels (3 to 5 stars) across a range of prices so all your guests can stay somewhere nice, regardless of their budget.'
       */
      tooltip: T;
    };
    distanceFromSearchLocation: {
      /**
       * @default 'Distance From Venue 📍'
       */
      title: T;

      /**
       * @default 'Prioritizes hotels that are nearest to your ceremony or reception and easiest to get to. Great for guests who prefer walking, quick rides, or simple directions.'
       */
      tooltip: T;
    };
    couplesPicks: {
      /**
       * @default 'Picked by Couples (2M+ Joy Weddings) 🏆'
       */
      title: T;

      /**
       * @default 'Uses data from millions of Joy weddings to highlight hotels other couples have recommended. This helps you choose trusted options with confidence.'
       */
      tooltip: T;
    };
  };
  venueHotels: {
    /**
     * @default 'Analyzing {{allHotelCount}} hotels in your area, {{goodMatchedHotelsCount}} are a good match with {{bestHotelsCount}} we think work best.'
     */
    title: T;

    /**
     * @default 'Analyzing hotels to find the best matches'
     */
    loadingTitle: T;

    /**
     * @default 'Guest Special Rate'
     */
    guestSpecialRate: T;

    /**
     * @default 'Joy Travel'
     */
    joyTravel: T;

    /**
     * @default 'Save {{percentageOff}}%'
     */
    savePercentageOff: T;

    /**
     * @default '{{price}} / night'
     */
    pricePerNight: T;

    /**
     * @default 'public rates from {{strikeOutPrice}}'
     */
    strikeOutPrice: T;

    /**
     * @default 'Explore All Options'
     */
    exploreAllOptions: T;

    /**
     * @default 'See “Where to Stay” Page'
     */
    whereToStayPage: T;

    /**
     * @default 'Reviewing Hotels'
     */
    reviewingHotels: T;

    /**
     * @default 'Added'
     */
    added: T;
  };
  venueError: {
    /**
     * @default 'Oops! Something Went Wrong.'
     */
    title: T;

    /**
     * @default 'We’re unable to store event venue.'
     */
    message: T;

    /**
     * @default 'Please try again'
     */
    cta: T;
  };
  noHotels: {
    /**
     * @default 'Hmm something didn’t go quite right and we couldn’t show recommended hotels.'
     */
    title: T;

    /**
     * @default 'But don’t worry! Explore discounted hotels near your venue and pick the ones to best suit your guests.'
     */
    message: T;

    /**
     * @default 'Browse Hotels'
     */
    cta: T;
  };
  quick: {
    /**
     * @default 'Page Settings'
     */
    qiWuC: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Password Protected'
     */
    Ny5ma: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Nice work! Now, check out your page.'
     */
    '3WoBr': T;

    /**
     * @default 'View current page without your changes.'
     */
    jBnPS: T;

    /**
     * @default 'View Page'
     */
    wadzU: T;

    /**
     * @default 'Page Photo'
     */
    NBHGp: T;

    /**
     * @default 'Your component order has been updated.'
     */
    '9qKbj': T;

    /**
     * @default 'An error occurred while updating component order. Please try again.'
     */
    X1JHd: T;

    /**
     * @default 'Photo / Video / Gallery'
     */
    '5JURA': T;

    /**
     * @default 'Are you sure you want to delete this section?'
     */
    HVyJJ: T;

    /**
     * @default 'The contents of this section will be lost. This action can’t be undone.'
     */
    T0G41: T;

    /**
     * @default 'Delete Section'
     */
    '48cfN': T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'Success! Section has been deleted.'
     */
    QTO9P: T;

    /**
     * @default 'An error occurred while deleting this section. Please try again.'
     */
    tdBWp: T;

    /**
     * @default 'Photo'
     */
    QtRqG: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Photo Gallery'
     */
    '6Kpcr': T;

    /**
     * @default 'Success! Photo has been saved.'
     */
    NbZ2b: T;

    /**
     * @default 'You have reached the block limit. To add more blocks please create a new page or replace an existing block.'
     */
    '983Rd': T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;

    /**
     * @default 'Are you sure you want to delete this photo block?'
     */
    '1oWWy': T;

    /**
     * @default 'The contents of this section will be lost. This can’t be undone.'
     */
    BKEBe: T;

    /**
     * @default 'Delete Photo Block'
     */
    Q4E3b: T;

    /**
     * @default 'Success! Photo has been deleted.'
     */
    trYPA: T;

    /**
     * @default 'An error occurred while deleting your photo. Please try again.'
     */
    HqKXy: T;

    /**
     * @default 'Replace Photo'
     */
    '6czvN': T;

    /**
     * @default 'Add Your Photo'
     */
    QVT8f: T;

    /**
     * @default 'We support jpeg and PNG images.'
     */
    ppvro: T;

    /**
     * @default 'Upload Photo'
     */
    '5p4bA': T;

    /**
     * @default 'Success! Photo Gallery has been saved.'
     */
    Tq38L: T;

    /**
     * @default 'An error occurred while saving your photo gallery. Please try again.'
     */
    DCq5D: T;

    /**
     * @default 'Create Album'
     */
    Zy6Dw: T;

    /**
     * @default 'Select Album'
     */
    bvvb7: T;

    /**
     * @default 'All your albums will appear here.'
     */
    vO9z6: T;

    /**
     * @default 'Text'
     */
    l8INA: T;

    /**
     * @default 'Are you sure you want to delete this text block?'
     */
    Yg4ea: T;

    /**
     * @default 'Delete Text Block'
     */
    FHdDL: T;

    /**
     * @default 'Success! Text has been deleted.'
     */
    I1TIT: T;

    /**
     * @default 'An error occurred while deleting your text. Please try again.'
     */
    kLC95: T;

    /**
     * @default 'Tell your guests what to expect here—make it fun, exciting, and uniquely you.'
     */
    wQjhB: T;

    /**
     * @default 'Delete Custom Property'
     */
    Zl7ta: T;

    /**
     * @default 'Delete Accommodation'
     */
    VQJHt: T;

    /**
     * @default 'Remove Stay from Page'
     */
    '4swaB': T;

    /**
     * @default 'Delete Venue'
     */
    '6Yh9F': T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Are you sure you want to delete this item?'
     */
    PsQI1: T;

    /**
     * @default 'This cannot be undone.'
     */
    ps6oM: T;

    /**
     * @default 'Guests Bookings'
     */
    rGq8Z: T;

    /**
     * @default 'Guests haven’t booked yet'
     */
    mPWeb: T;

    /**
     * @default 'When they do, you’ll see their hotel bookings here. Nearby hotels fill up quickly, so send a reminder to help guests lock in the best rates.'
     */
    kM0WQ: T;

    /**
     * @default 'Remind Guests to Book'
     */
    KhgiN: T;

    /**
     * @default 'Hotel map preview'
     */
    '6jKeh': T;

    /**
     * @default 'Your hotel map just got an upgrade.'
     */
    iuUpv: T;

    /**
     * @default 'Guests love using the map to find a place to stay, so we’ve made it bigger and better. Now it's easier to see where everything is in relation to your venue.'
     */
    lECOR: T;

    /**
     * @default 'Try the New Map'
     */
    OTqhS: T;

    /**
     * @default 'Where Your Guests Are Staying'
     */
    A28pQ: T;

    /**
     * @default 'See the bookings your guests have made on your site.'
     */
    OwGBj: T;

    /**
     * @default 'Remind Other Guests to Book'
     */
    uE54a: T;

    /**
     * @default 'You’re missing booking insights for {{0}} manually added hotels. Add Joy hotels to see who books, track engagement, and make the most of every stay.'
     */
    EU2e3: T;

    /**
     * @default 'Swap to Joy Hotels'
     */
    DEjlC: T;

    /**
     * @default 'An error occurred while deleting the venue. Please try again.'
     */
    mcqrt: T;

    /**
     * @default 'An error occurred while deleting the hotel. Please try again.'
     */
    '13oks': T;

    /**
     * @default 'An error occurred while creating the page container. Please try again.'
     */
    G71vk: T;

    /**
     * @default 'An error occurred while creating the travel map component. Please try again.'
     */
    '1HdGK': T;

    /**
     * @default 'Your Venue Details'
     */
    WxjNu: T;

    /**
     * @default 'Success! Video has been saved.'
     */
    mlpvI: T;

    /**
     * @default 'An error occurred while saving your video. Please try again.'
     */
    AOgz8: T;

    /**
     * @default 'Please enter a valid video URL.'
     */
    X7AwG: T;

    /**
     * @default 'Are you sure you want to delete this video block?'
     */
    Gs5hl: T;

    /**
     * @default 'Delete Video Block'
     */
    bTaDz: T;

    /**
     * @default 'Success! Video has been deleted.'
     */
    erhG5: T;

    /**
     * @default 'An error occurred while deleting your video. Please try again.'
     */
    sw1Ul: T;

    /**
     * @default 'Video URL'
     */
    Sep8P: T;

    /**
     * @default 'Video Caption'
     */
    DNXWJ: T;

    /**
     * @default 'An error occurred while deleting the accommodation. Please try again.'
     */
    '5m93k': T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    ZTnCp: T;

    /**
     * @default 'An error occurred while updating your Event Password. Please try again.'
     */
    klFYf: T;

    /**
     * @default 'Your {{0}} Page is now {{1}}.'
     */
    '3ohKV': T;

    /**
     * @default 'An error occurred while updating your {{0}} Page Visibility. Please try again.'
     */
    S01Ux: T;

    /**
     * @default 'An error occurred while updating page container. Please try again.'
     */
    CC7UR: T;

    /**
     * @default 'Edit Page'
     */
    lVMJg: T;

    /**
     * @default 'Start Creating'
     */
    zgURS: T;

    /**
     * @default 'Add your first content block to craft your perfect page.'
     */
    a1hdj: T;

    /**
     * @default 'Add a content block and continue crafting your page.'
     */
    MoNeF: T;

    /**
     * @default 'Add hotel recommendations to save guests time and money'
     */
    UAOFc: T;

    /**
     * @default 'Give your guests the best rates on hotels close to your venue, available exclusively to Joy customers.'
     */
    adprM: T;

    /**
     * @default 'Explore Hotels'
     */
    ucmCV: T;

    /**
     * @default 'See where your guests are staying.'
     */
    nIO5o: T;

    /**
     * @default 'We'll notify you when a guest books, and you can view all bookings here to help with planning.'
     */
    xqPYM: T;

    /**
     * @default 'Guests badge tour step'
     */
    q3sfE: T;

    /**
     * @default 'Explore More Hotels'
     */
    BmXGM: T;

    /**
     * @default 'See where your guests are staying when booked with Joy.'
     */
    '511rl': T;

    /**
     * @default 'If you’d like, we can notify you when a guest books, and you can view all bookings here to help with planning.'
     */
    eSXWE: T;

    /**
     * @default 'Close tour'
     */
    Yingr: T;

    /**
     * @default 'Upload Photos'
     */
    u8bMa: T;

    /**
     * @default 'Add Album'
     */
    ecZAJ: T;

    /**
     * @default 'Settings'
     */
    FQPIR: T;

    /**
     * @default 'Container for Page Components'
     */
    LBflH: T;

    /**
     * @default 'Visibility'
     */
    OZrIO: T;

    /**
     * @default 'emoji'
     */
    '4IhXI': T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Universal'
     */
    rPhtt: T;

    /**
     * @default 'Plan Your Trip'
     */
    TL13G: T;

    /**
     * @default 'Event Details'
     */
    YixyG: T;

    /**
     * @default 'What's Weather Report'
     */
    OWmyR: T;

    /**
     * @default 'Share the local weather forecast for your event dates, helping guests pack and plan appropriately.'
     */
    oakgL: T;

    /**
     * @default 'Weather Report'
     */
    '0W1ym': T;

    /**
     * @default 'Edit {{0}}'
     */
    srIa6: T;

    /**
     * @default 'You will be taken to {{0}} page editor. Your current changes are saved'
     */
    MVK09: T;

    /**
     * @default 'Continue'
     */
    jHmPJ: T;

    /**
     * @default 'Weather report saved'
     */
    lDw04: T;

    /**
     * @default 'We couldn't save your weather report. Please try again.'
     */
    tVem3: T;

    /**
     * @default 'City {{0}}'
     */
    v3W8c: T;

    /**
     * @default 'Keep details crisp and clear for guests.'
     */
    yeOtR: T;

    /**
     * @default 'Cities'
     */
    fzwzo: T;

    /**
     * @default '+ Add city'
     */
    JqwDB: T;

    /**
     * @default 'Remove city'
     */
    TOi1N: T;

    /**
     * @default 'Location'
     */
    XjYhF: T;

    /**
     * @default 'Search location'
     */
    DolLE: T;

    /**
     * @default 'Display name'
     */
    XavHB: T;

    /**
     * @default 'e.g., Napa Valley'
     */
    zrXBd: T;

    /**
     * @default 'City'
     */
    HJlKA: T;

    /**
     * @default 'Country'
     */
    G9ai3: T;

    /**
     * @default 'Dates'
     */
    pahrF: T;

    /**
     * @default 'Date range'
     */
    z4uUJ: T;

    /**
     * @default 'Daily forecast'
     */
    kPjh6: T;

    /**
     * @default 'Populate from date range'
     */
    '7v36U': T;

    /**
     * @default 'Date'
     */
    '4NsKA': T;

    /**
     * @default 'Remove'
     */
    gt8NS: T;

    /**
     * @default 'Summary'
     */
    '8nS3P': T;

    /**
     * @default 'Sunny, showers, cloudy...'
     */
    GKovY: T;

    /**
     * @default 'High °C'
     */
    '3Ssgn': T;

    /**
     * @default 'Low °C'
     */
    BCoJD: T;

    /**
     * @default 'Precip (0–1)'
     */
    '6Tli9': T;

    /**
     * @default 'Humidity %'
     */
    airKQ: T;

    /**
     * @default 'Wind kph'
     */
    n18X0: T;

    /**
     * @default 'UV Index'
     */
    '1dsBi': T;

    /**
     * @default '+ Add day'
     */
    EHt5X: T;

    /**
     * @default 'City guest highlights'
     */
    MwwYs: T;

    /**
     * @default 'Helpful notes specific to this city...'
     */
    '1SHsN': T;

    /**
     * @default 'Guest highlights'
     */
    jEAps: T;

    /**
     * @default 'Helpful notes for your guests...'
     */
    yNBNE: T;
  };
};

export type WebsiteHeaderTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Photo'
     */
    QtRqG: T;
  };
};

export type WebsiteOverviewTranslations<T extends LeafNodeValue = TranslateFunction> = {
  header: {
    /**
     * @default 'Website'
     */
    website: T;

    /**
     * @default 'Share'
     */
    share: T;

    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Support'
     */
    support: T;

    /**
     * @default 'Settings'
     */
    settings: T;
  };
  inviteAdminDialog: {
    /**
     * @default 'Event Admins'
     */
    title: T;
  };
  overview: {
    /**
     * @default 'Get Started'
     */
    getStarted: T;

    /**
     * @default '{{completedCount}} / {{totalCount}} Done'
     */
    completedCount: T;

    /**
     * @default 'Edit Design'
     */
    editDesign: T;

    /**
     * @default 'Share Website'
     */
    shareWebsite: T;

    /**
     * @default 'Settings'
     */
    settings: T;

    /**
     * @default 'Event URL copied.'
     */
    eventUrlCopiedToast: T;

    /**
     * @default 'RSVP is On'
     */
    rsvpOnText: T;

    /**
     * @default 'RSVP is Off'
     */
    rsvpOffText: T;

    /**
     * @default 'Event URL updated'
     */
    eventUrlUpdateSuccess: T;

    /**
     * @default 'Error updating event URL. Please try again later.'
     */
    eventUrlUpdateError: T;
  };
  photos: {
    /**
     * @default 'Albums'
     */
    albums: T;

    /**
     * @default 'New Album'
     */
    newAlbum: T;

    /**
     * @default 'Public'
     */
    public: T;

    /**
     * @default 'Hidden'
     */
    hidden: T;

    /**
     * @default 'View'
     */
    view: T;

    /**
     * @default 'Manage Album'
     */
    manageAlbum: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Delete'
     */
    Delete: T;

    /**
     * @default 'Item'
     */
    item: T;

    /**
     * @default 'Items'
     */
    items: T;

    /**
     * @default 'Photos'
     */
    photos: T;

    /**
     * @default 'We support JPEG and PNG images.'
     */
    photoLabel: T;

    /**
     * @default 'Upload Photo'
     */
    uploadPhoto: T;

    /**
     * @default 'Add Photos'
     */
    addPhotos: T;

    /**
     * @default 'Manage Photos'
     */
    managePhotos: T;

    /**
     * @default 'Add Album'
     */
    addAlbum: T;

    /**
     * @default 'Edit Album'
     */
    editAlbum: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Save'
     */
    save: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Allow Uploads'
     */
    allowUploads: T;

    /**
     * @default 'Link'
     */
    link: T;

    /**
     * @default 'Magic Link'
     */
    magicLink: T;

    /**
     * @default 'Generating...'
     */
    magicLinkPlaceholder: T;

    /**
     * @default 'Share Link'
     */
    shareLink: T;

    /**
     * @default 'Share'
     */
    share: T;

    /**
     * @default 'Copy Upload Link'
     */
    copyUploadLink: T;

    /**
     * @default 'Share Link copied.'
     */
    shareLinkCopied: T;

    /**
     * @default 'Send this link to your guests. They'll be able to upload all their photos straight into your collection. Please note this link will also allow anyone to see photos uploaded to this album.'
     */
    uploadLinkInfo: T;

    noCollections: {
      /**
       * @default 'Introducing Shared Photo Albums'
       */
      eyebrow: T;

      /**
       * @default 'Collect and share memories from friends and family before and after the big day.'
       */
      title: T;

      /**
       * @default 'From your childhood photos and early days together to the ceremony and after party, friends and family can now upload photos and notes before and after your big day.'
       */
      description: T;
    };

    /**
     * @default 'Create Album'
     */
    createAlbum: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    savePhotoError: T;

    /**
     * @default 'Upload'
     */
    upload: T;

    /**
     * @default 'Looking for Moments?'
     */
    lookingForMoments: T;

    /**
     * @default ' View your Moments'
     */
    viewYourMoments: T;

    /**
     * @default 'Looking to set your website page photos?'
     */
    lookingForPagePhotos: T;

    /**
     * @default 'Set page photos'
     */
    setPagePhotos: T;

    faqs: {
      questions: [
        {
          /**
           * @default 'What is Joy Collections?'
           */
          Q: T;

          /**
           * @default 'Joy Collections is your dedicated service for organizing, collecting, and sharing all your wedding photos and videos in one beautifully designed platform. Guests can easily upload their moments, and you can relive every magical memory with ease.'
           */
          A: T;
        },
        {
          /**
           * @default 'How do I invite guests to share their photos?'
           */
          Q: T;

          /**
           * @default 'You can invite guests to upload their photos through your wedding website on Joy. Simply share your unique link via email, text, or on your event website. Guests can upload directly without needing to create an account.'
           */
          A: T;
        },
        {
          /**
           * @default 'Is there a limit to the number of photos or videos we can collect?'
           */
          Q: T;

          /**
           * @default 'Nope! Joy Collections offers unlimited uploads, so you won’t miss a single shot of your big day.'
           */
          A: T;
        },
        {
          /**
           * @default 'Can we organize the photos into albums?'
           */
          Q: T;

          /**
           * @default 'Yes! You can create albums for different events (e.g., rehearsal dinner, ceremony, reception) or themes (e.g., candid moments, dance floor fun).'
           */
          A: T;
        },
      ];
    };

    /**
     * @default 'Album Options'
     */
    albumOptions: T;

    /**
     * @default 'Options'
     */
    options: T;

    /**
     * @default 'Album name is required'
     */
    albumNameRequired: T;

    /**
     * @default 'Name should be 30 characters or less.'
     */
    maxCharacters: T;

    /**
     * @default 'This album has no images.'
     */
    noImages: T;

    /**
     * @default 'An error occurred while updating your album settings. Please try again.'
     */
    mediaSettingsError: T;

    /**
     * @default 'All Photos'
     */
    allPhotos: T;

    photoPickerDialog: {
      /**
       * @default 'Select All'
       */
      selectAll: T;

      /**
       * @default 'Deselect All'
       */
      deselectAll: T;

      /**
       * @default 'Add to Album'
       */
      addToAlbum: T;

      /**
       * @default 'Add'
       */
      add: T;

      /**
       * @default 'Cancel'
       */
      cancel: T;

      /**
       * @default 'Upload Photos'
       */
      uploadPhotos: T;

      /**
       * @default 'Add Photos'
       */
      addPhotos: T;

      /**
       * @default 'Select {{count}} Photos'
       */
      selectPhotosCount: T;

      /**
       * @default 'Select {{count}} Photo'
       */
      selectPhotoCount: T;

      /**
       * @default 'Select Photos'
       */
      selectPhotos: T;
    };

    /**
     * @default 'Photos added to album.'
     */
    addMediaToCollectionSuccess: T;

    /**
     * @default 'Some of the items could not be added. Please check the album and try again.'
     */
    addMediaToCollectionPartialSuccess: T;

    /**
     * @default 'An error occurred while adding photos to your album. Please try again.'
     */
    addMediaToCollectionError: T;

    /**
     * @default 'This album is hidden. Make it public to enable guest uploads.'
     */
    toggleTooltipText: T;

    /**
     * @default 'Select Photos…'
     */
    selectPhotosCTALabel: T;

    /**
     * @default 'Select…'
     */
    selectCTALabel: T;

    /**
     * @default 'Select photos'
     */
    selectPhotos: T;

    /**
     * @default 'Add to Album…'
     */
    addToAlbumCTALabel: T;

    /**
     * @default '{{count}} Photos Selected'
     */
    selectedPhotosCount: T;

    /**
     * @default '{{count}} Photo Selected'
     */
    selectedPhotoCount: T;

    /**
     * @default 'Add to Album'
     */
    addToAlbum: T;

    /**
     * @default 'Remove from album'
     */
    removeFromAlbum: T;

    /**
     * @default 'Happy face 1'
     */
    happyFace1: T;

    /**
     * @default 'Happy face 2'
     */
    happyFace2: T;
  };
  quick: {
    /**
     * @default 'Edit Pages'
     */
    '28e42': T;

    /**
     * @default 'New'
     */
    s9WAA: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'Photos'
     */
    VgyKN: T;

    /**
     * @default '🥳 Your website has been successfully published!'
     */
    rQbtw: T;

    /**
     * @default '🥳 Your website has been successfully unpublished!'
     */
    '2OqIt': T;

    /**
     * @default '😬 Failed to update website visibility. Please try again.'
     */
    '2rtoX': T;

    /**
     * @default 'Website Visibility:'
     */
    DNxDm: T;

    /**
     * @default 'Published'
     */
    Wtd2q: T;

    /**
     * @default 'Unpublished'
     */
    F7vbD: T;

    /**
     * @default 'View'
     */
    DocNA: T;

    /**
     * @default 'Download'
     */
    '2RRMK': T;

    /**
     * @default 'Manage Photos'
     */
    mAenA: T;

    /**
     * @default 'An error occurred while updating your album settings. Please try again.'
     */
    dVCSs: T;

    /**
     * @default 'Share Link copied.'
     */
    Z1zfQ: T;

    /**
     * @default 'Remove from album'
     */
    vwTJs: T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'Albums'
     */
    cuntj: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'This album is hidden. Make it public to enable guest uploads.'
     */
    JG58J: T;

    /**
     * @default 'Allow Uploads'
     */
    fkQif: T;

    /**
     * @default 'Album Options'
     */
    '3vXJp': T;

    /**
     * @default 'Options'
     */
    Uw6kb: T;

    /**
     * @default 'Download All'
     */
    flldB: T;

    /**
     * @default 'An error occurred while saving your photo. Please try again.'
     */
    ZHz1L: T;

    /**
     * @default 'Upload Photo'
     */
    '5p4bA': T;

    /**
     * @default 'We support JPEG and PNG images.'
     */
    '32yZ1': T;

    /**
     * @default 'This album has no images.'
     */
    '0zSUX': T;

    /**
     * @default '1 item'
     */
    GDylI: T;

    /**
     * @default '{{0}} items'
     */
    MtSBl: T;

    /**
     * @default 'Manage Album'
     */
    UbvYs: T;

    /**
     * @default '1 photo'
     */
    JDCqQ: T;

    /**
     * @default '{{0}} photos'
     */
    H5QnO: T;

    /**
     * @default '{{0}} Selected'
     */
    FsX46: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'Add to Album'
     */
    douf3: T;

    /**
     * @default 'All Photos'
     */
    m8UFC: T;

    /**
     * @default 'Add Album'
     */
    ecZAJ: T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'Upload Your Photos'
     */
    heJjO: T;

    /**
     * @default 'Add as many as you'd like to easily access them and add to your site.'
     */
    '2G9cX': T;

    /**
     * @default 'Show All'
     */
    E73y6: T;

    /**
     * @default 'Album Visibility:'
     */
    T6tCX: T;

    /**
     * @default 'Guest Uploads:'
     */
    EJyeJ: T;

    /**
     * @default 'Allowed'
     */
    QsEaR: T;

    /**
     * @default 'Disabled'
     */
    CNgc3: T;

    /**
     * @default 'Edit Album'
     */
    B1et1: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'Get Started'
     */
    bMLhD: T;

    /**
     * @default '{{0}} / {{1}} Done'
     */
    c7CJl: T;
  };
};

export type WebsitePagesTranslations<T extends LeafNodeValue = TranslateFunction> = {
  general: {
    /**
     * @default 'New'
     */
    new: T;
  };
  seo: {
    pageTitle: {
      /**
       * @default '{{eventName}} | Joy'
       */
      withEventName: T;

      /**
       * @default 'Joy'
       */
      default: T;

      /**
       * @default '{{eventName}} | Baby Registry | Joy'
       */
      babyRegistry: T;

      /**
       * @default 'Baby Registry | Joy'
       */
      babyRegistryDefault: T;
    };
    pageDescription: {
      /**
       * @default 'Welcome to {{eventName}}! Explore photos, {{keywords}}, and more on Joy.'
       */
      welcomeWithEvent: T;

      /**
       * @default 'Welcome! Explore photos, {{keywords}}, and more on Joy.'
       */
      welcomeDefault: T;

      /**
       * @default 'Welcome to the website for {{names}}! Explore photos, {{keywords}}, and more on Joy.'
       */
      welcomeWithNames: T;

      /**
       * @default 'Welcome to {{eventName}}! Explore photos, baby registry information, and more on Joy.'
       */
      babyRegistryWithEvent: T;

      /**
       * @default 'Welcome! Explore photos, baby registry information, and more on Joy.'
       */
      babyRegistryDefault: T;
    };

    /**
     * @default 'accommodations'
     */
    accommodations: T;

    /**
     * @default 'travel details'
     */
    travelDetails: T;

    /**
     * @default 'registry information'
     */
    registryInformation: T;

    /**
     * @default 'event information'
     */
    eventInformation: T;
  };
  pages: {
    accommodations: {
      /**
       * @default 'Accommodations'
       */
      title: T;
    };
    moments: {
      /**
       * @default 'Moments'
       */
      title: T;
    };
    rsvp: {
      /**
       * @default 'RSVP'
       */
      title: T;
    };
  };
  quick: {
    /**
     * @default 'Overview'
     */
    t11al: T;

    /**
     * @default 'Design'
     */
    '0V6Jr': T;

    /**
     * @default 'Event Settings'
     */
    lXboj: T;

    /**
     * @default 'Home'
     */
    lgXLA: T;

    /**
     * @default 'Pages'
     */
    a3LpG: T;

    /**
     * @default 'Video'
     */
    P4OKH: T;

    /**
     * @default 'Story & Tidbits'
     */
    MZCpe: T;

    /**
     * @default 'Schedule'
     */
    vj39l: T;

    /**
     * @default 'Travel'
     */
    '20ShY': T;

    /**
     * @default 'Where to Stay'
     */
    N1DSw: T;

    /**
     * @default 'Guest Q & A'
     */
    sWsGi: T;

    /**
     * @default 'Wedding Party'
     */
    QfgiL: T;

    /**
     * @default 'Registry'
     */
    PNJQE: T;

    /**
     * @default 'Add New Page'
     */
    wsKWg: T;

    /**
     * @default 'Manage Pages'
     */
    Ljvjt: T;

    /**
     * @default 'Guest Q&A'
     */
    gMg7F: T;
  };
};

export type WebsitePhotosTranslations<T extends LeafNodeValue = TranslateFunction> = {
  quick: {
    /**
     * @default 'Add to Album'
     */
    douf3: T;

    /**
     * @default 'Close'
     */
    OcMoF: T;

    /**
     * @default 'New Album'
     */
    raB6X: T;

    /**
     * @default 'Public'
     */
    DUfLO: T;

    /**
     * @default 'Hidden'
     */
    mVYC2: T;

    /**
     * @default '{{0}} Selected'
     */
    FsX46: T;

    /**
     * @default 'Select All'
     */
    ZmboI: T;

    /**
     * @default 'Deselect All'
     */
    CQwcs: T;

    /**
     * @default 'View'
     */
    DocNA: T;

    /**
     * @default 'Download'
     */
    '2RRMK': T;

    /**
     * @default 'Share Link copied.'
     */
    Z1zfQ: T;

    /**
     * @default 'Album name is required.'
     */
    Vkc4Y: T;

    /**
     * @default 'Name should be 30 characters or less.'
     */
    wmdRL: T;

    /**
     * @default 'Edit Album'
     */
    B1et1: T;

    /**
     * @default 'Add Album'
     */
    ecZAJ: T;

    /**
     * @default 'Name'
     */
    doNMA: T;

    /**
     * @default 'Allow Uploads'
     */
    fkQif: T;

    /**
     * @default 'Link'
     */
    WO7LA: T;

    /**
     * @default 'Generating...'
     */
    qOw0Q: T;

    /**
     * @default 'Share Link'
     */
    F4p3q: T;

    /**
     * @default 'Send this link to your guests. They'll be able to upload all their photos straight into your collection. Please note this link will also allow anyone to see photos uploaded to this album.'
     */
    PVAPM: T;

    /**
     * @default 'Save'
     */
    Zd8MA: T;

    /**
     * @default 'Cancel'
     */
    K6CLo: T;

    /**
     * @default 'An error occurred while updating your album settings. Please try again.'
     */
    dVCSs: T;

    /**
     * @default 'Albums'
     */
    cuntj: T;

    /**
     * @default 'Manage Album'
     */
    UbvYs: T;

    /**
     * @default 'Add Photos'
     */
    MZvU5: T;

    /**
     * @default 'Remove from album'
     */
    vwTJs: T;

    /**
     * @default 'Upload Your Photos'
     */
    heJjO: T;

    /**
     * @default 'Add as many as you'd like to easily access them and add to your site.'
     */
    '2G9cX': T;

    /**
     * @default 'Delete'
     */
    '721Ir': T;

    /**
     * @default 'All Photos'
     */
    m8UFC: T;

    /**
     * @default 'Show All'
     */
    E73y6: T;

    /**
     * @default 'Upload Your Photo'
     */
    W63sG: T;

    /**
     * @default 'Edit Page Photos'
     */
    sGizj: T;

    /**
     * @default 'Add Page'
     */
    u0IsO: T;

    /**
     * @default 'Album Visibility:'
     */
    T6tCX: T;

    /**
     * @default 'This album is hidden. Make it public to enable guest uploads.'
     */
    JG58J: T;

    /**
     * @default 'Guest Uploads:'
     */
    EJyeJ: T;

    /**
     * @default 'Allowed'
     */
    QsEaR: T;

    /**
     * @default 'Disabled'
     */
    CNgc3: T;

    /**
     * @default 'Share'
     */
    ZRJ5G: T;

    /**
     * @default 'Download All'
     */
    flldB: T;

    /**
     * @default 'Upload Photos'
     */
    u8bMa: T;

    /**
     * @default 'Edit Your Website Header Photo'
     */
    XCknl: T;

    /**
     * @default 'Failed to create album. Please try again.'
     */
    '8xuOw': T;

    /**
     * @default 'Browse Albums'
     */
    WcCOK: T;

    /**
     * @default 'Create Album'
     */
    Zy6Dw: T;

    /**
     * @default 'Select {{0}}'
     */
    ImZIC: T;

    /**
     * @default 'Create Your First Album'
     */
    gk7Bk: T;

    /**
     * @default 'Add albums with your photos so you can easily use them in your website.'
     */
    nCxjs: T;

    /**
     * @default 'An error occurred while adding photos to your album. Please try again.'
     */
    h4DHM: T;

    /**
     * @default 'Some of the items could not be added. Please check the album and try again.'
     */
    bJz4t: T;

    /**
     * @default 'Photos added to album.'
     */
    fVd3i: T;
  };
};

export type WebsitePreviewTranslations<T extends LeafNodeValue = TranslateFunction> = {
  websitePreview: {
    /**
     * @default 'Preview'
     */
    preview: T;

    /**
     * @default 'Save and Open'
     */
    saveAndOpen: T;

    /**
     * @default 'Sorry but your theme is no longer available to preview.'
     */
    themeNotSupportedText: T;

    /**
     * @default 'Learn Why'
     */
    themeNotSupportedButton: T;

    titlePreview: {
      /**
       * @default 'Preview Website'
       */
      desktop: T;

      /**
       * @default 'Preview Mobile'
       */
      mobile: T;

      /**
       * @default 'Preview Stationery'
       */
      stationery: T;
    };
    stationery: {
      /**
       * @default 'Explore Matching Prints'
       */
      explorePrints: T;

      /**
       * @default 'Select unique print stationery from'
       */
      selectUnique: T;

      /**
       * @default 'Or pair your theme with free matching digital stationery'
       */
      digitalOption: T;

      /**
       * @default 'Pair your theme with free matching digital stationery'
       */
      digitalOptionPair: T;

      /**
       * @default 'Create Save the Date'
       */
      saveTheDate: T;

      /**
       * @default 'Create Invitation'
       */
      invitation: T;
    };
  };
};

export type WeddingPartyTranslations<T extends LeafNodeValue = TranslateFunction> = {
  titles: {
    /**
     * @default 'Bride'
     */
    Bride: T;

    /**
     * @default 'Groom'
     */
    Groom: T;

    /**
     * @default 'Bridesmaid'
     */
    Bridesmaid: T;

    /**
     * @default 'Groomsman'
     */
    Groomsman: T;

    /**
     * @default 'Mother In Law'
     */
    motherInLaw: T;

    /**
     * @default 'Matron of Honor'
     */
    'Matron of Honor': T;

    array: [
      {
        /**
         * @default 'Howdy!'
         */
        greeting: T;

        /**
         * @default '/groom.jpg'
         */
        _url: string;
      },
    ];
  };

  /**
   * @default 'Learn more about {{name}}'
   */
  learnAbout: T;
};

export type YourRegistryTranslations<T extends LeafNodeValue = TranslateFunction> = {
  registrySection: {
    /**
     * @default 'Connected Registries'
     */
    title: T;

    /**
     * @default 'For tracking gifts on your linked registries, visit those registries directly.'
     */
    subtitle: T;

    /**
     * @default 'Drag and drop to reorder your list.'
     */
    dndLabel: T;

    /**
     * @default 'Modify'
     */
    modify: T;

    /**
     * @default 'Reorder List'
     */
    reorder: T;

    /**
     * @default 'Finish'
     */
    finish: T;

    /**
     * @default 'Looks like you haven’t added any registries yet.'
     */
    emptyRegistries: T;

    /**
     * @default 'No worries. Go ahead and <CreateOneLink/>.'
     */
    goAheadAnd: T;

    /**
     * @default 'create one'
     */
    createOne: T;

    /**
     * @default 'Syncing'
     */
    registrySyncing: T;

    /**
     * @default 'Synced'
     */
    registrySynced: T;

    /**
     * @default 'Transferred'
     */
    registryTransferred: T;

    /**
     * @default 'Transferring'
     */
    registryTransferInProgress: T;

    /**
     * @default 'Linked'
     */
    registryLinked: T;

    /**
     * @default 'Update'
     */
    registryUpdate: T;

    /**
     * @default 'Edit'
     */
    actionEdit: T;

    /**
     * @default 'View'
     */
    actionView: T;

    /**
     * @default 'Waiting on updates?'
     */
    registryToolTipText: T;

    /**
     * @default 'Connected registries sync daily.'
     */
    syncDaily: T;

    /**
     * @default '{{count}} External Registries'
     */
    subTitleManageRegistry: T;

    /**
     * @default 'We will display any external registries that you add here on your Joy registry. We also support item syncing for retailers like Amazon and Target and we are continuously adding more stores.'
     */
    helpText: T;

    /**
     * @default 'link an existing registry'
     */
    linkExistingRegistry: T;

    /**
     * @default 'Add Registry'
     */
    addRegistry: T;
  };
  validation: {
    /**
     * @default 'Invalid URL'
     */
    invalidDomain: T;

    /**
     * @default 'Required'
     */
    required: T;
  };
  updateRegistryDialog: {
    /**
     * @default 'Update Registry'
     */
    title: T;

    /**
     * @default 'Update Registry'
     */
    actionText: T;

    /**
     * @default 'Cancel'
     */
    cancelActionText: T;

    /**
     * @default 'Registry Link'
     */
    urlInputLabel: T;

    /**
     * @default 'Registry Title'
     */
    nameInputLabel: T;

    /**
     * @default 'Link'
     */
    urlInputPlaceholder: T;

    /**
     * @default 'Title'
     */
    nameInputPlaceholder: T;

    /**
     * @default 'Registry Image'
     */
    registryImageLabel: T;

    /**
     * @default 'Delete Registry'
     */
    deleteActionText: T;
  };
  errorDialog: {
    /**
     * @default 'Connection trouble.'
     */
    titleText: T;

    /**
     * @default 'Apologies, we weren’t able to '
     */
    messageTextStart: T;

    /**
     * @default 'your changes. Please click 'Refresh' to reconnect.'
     */
    messageTextEnd: T;

    /**
     * @default 'Refresh'
     */
    actionText: T;
  };

  /**
   * @default 'Learn More'
   */
  learnMore: T;

  /**
   * @default 'Registry URL'
   */
  registryUrl: T;

  publishPage: {
    /**
     * @default 'Make Registry Visible'
     */
    newTitle: T;

    /**
     * @default 'Allow guests to see your registry'
     */
    info: T;

    /**
     * @default 'On'
     */
    labelOn: T;

    /**
     * @default 'Off'
     */
    labelOff: T;

    /**
     * @default 'Info'
     */
    allyLabel: T;

    /**
     * @default 'Manage Visibility and Sharing'
     */
    newDialogTitle: T;

    /**
     * @default 'Turning this on makes your registry available to gift givers.'
     */
    newToggleDescription: T;

    /**
     * @default 'Registry URL'
     */
    registryUrlLabel: T;

    /**
     * @default 'Add'
     */
    addLink: T;

    /**
     * @default 'Edit'
     */
    editLink: T;

    /**
     * @default 'Save'
     */
    actionButton: T;

    /**
     * @default 'Cancel'
     */
    secondaryButton: T;

    /**
     * @default 'Your registry is visible'
     */
    registryVisibleText: T;

    /**
     * @default 'Your registry is hidden'
     */
    registryHiddenText: T;

    /**
     * @default 'Modify registry visibility'
     */
    registryHoverText: T;

    /**
     * @default '✨ Link Copied ✨'
     */
    linkCopied: T;

    /**
     * @default 'Share it with gift givers so they can shop in one place!'
     */
    linkCopiedDescription: T;

    /**
     * @default 'Shipping Address'
     */
    shippingAddressLabel: T;

    /**
     * @default 'Your shipping address is missing. Let gift givers know where to send your gifts.'
     */
    shippingAddressWarning: T;

    /**
     * @default 'Let gift givers know where to send your gifts.'
     */
    emptyShippingAddressMsg: T;
  };
  registrySettingsDialog: {
    /**
     * @default 'Your Registry settings were updated successfully'
     */
    updateSuccessToast: T;

    /**
     * @default 'An error occurred when updating your settings. Please try again'
     */
    updateErrorToast: T;

    /**
     * @default 'Save'
     */
    saveButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'A first name is required'
     */
    firstNameRequired: T;

    /**
     * @default 'URL copied'
     */
    urlCopiedToast: T;

    /**
     * @default 'Joy URL'
     */
    url: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Partner One'
     */
    partnerOne: T;

    /**
     * @default 'Partner Two'
     */
    partnerTwo: T;

    /**
     * @default 'Date'
     */
    date: T;

    dateInfo: {
      /**
       * @default 'Show Date in your Registry and App'
       */
      general: T;

      /**
       * @default 'Show Date in your Registry and App'
       */
      wedding: T;

      /**
       * @default 'Show Date in your Registry'
       */
      babyRegistry: T;
    };

    /**
     * @default 'Your date is currently hidden'
     */
    dateHidden: T;

    /**
     * @default 'Changes may take time to take effect.'
     */
    hideRegistryInfo: T;

    /**
     * @default 'Registry Settings'
     */
    registrySettingsDialogTitle: T;

    /**
     * @default 'Registry URL'
     */
    registrySettingsDialogTitleRegistryUrl: T;

    /**
     * @default 'Registry Display Name'
     */
    registrySettingsDialogDisplayNameLabel: T;

    /**
     * @default 'Prevent my registry from appearing in search results when guests search the Joy Website'
     */
    registrySettingsDialoghideRegistryLabel: T;

    /**
     * @default 'URL cannot be blank.'
     */
    urlRequired: T;

    /**
     * @default 'URL must be less than 60 characters long.'
     */
    urlLengthLimit: T;

    /**
     * @default 'Only letters, numbers and '-' are allowed in your URL.'
     */
    urlCharacterValidation: T;

    /**
     * @default 'URL is not available'
     */
    urlNotAvailable: T;

    /**
     * @default 'Your old Joy URL will no longer work. If you have a custom domain, you’ll need to update your forwarding URL with your domain provider.'
     */
    warningBoxText: T;

    /**
     * @default 'Please Note:'
     */
    warningBoxHeader: T;

    /**
     * @default 'This URL is available'
     */
    urlAvailable: T;

    /**
     * @default 'This URL is not available'
     */
    urlUnavailable: T;

    /**
     * @default '/60 Max Chars'
     */
    maxChars: T;

    /**
     * @default 'Enter an Epic Registry display name'
     */
    eventNamePlaceholder: T;

    /**
     * @default 'Your Registry name can't be left blank.'
     */
    eventNameRequired: T;

    /**
     * @default 'The Registry name should be 30 characters or less.'
     */
    eventNameLengthLimit: T;

    /**
     * @default 'Please re-enter the date in MM/DD/YYYY format'
     */
    invalidDate: T;
  };
  visibilityDialog: {
    /**
     * @default '{{resource}} Visibility'
     */
    title: T;

    /**
     * @default 'Hidden'
     */
    hidden: T;

    /**
     * @default 'Public'
     */
    public: T;

    /**
     * @default 'Password Protected'
     */
    passwordProtected: T;

    /**
     * @default 'Save'
     */
    saveButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Password copied.'
     */
    passwordCopiedToast: T;

    /**
     * @default 'Event Password'
     */
    eventPassword: T;

    /**
     * @default 'Edit'
     */
    edit: T;

    /**
     * @default 'Please Note:'
     */
    passwordNoteTitle: T;

    /**
     * @default 'If you change your password, guests will no longer be able to use your current password to unlock your event.'
     */
    passwordNoteMessage: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Visibility. Please try again.'
     */
    changeVisibilityFailed: T;

    /**
     * @default 'Your {{resource}} is now {{visibility}}.'
     */
    changeVisibilitySuccessful: T;

    /**
     * @default 'An error occurred while updating your {{resource}} Password. Please try again.'
     */
    changePasswordFailed: T;

    /**
     * @default 'Your Event Password has been updated.'
     */
    changePasswordSuccessful: T;

    /**
     * @default 'Your password can only contain letters and numbers.'
     */
    passwordError: T;

    /**
     * @default 'Registry'
     */
    registry: T;
  };
  inviteAdminDialog: {
    /**
     * @default 'Registry Admins'
     */
    registryInviteAdminDialogTitle: T;

    /**
     * @default 'Invite Collaborator'
     */
    addAdminTitle: T;

    /**
     * @default 'Revoke Collaborator Invitation'
     */
    revokeAdminInvitationTitle: T;

    /**
     * @default 'Are you sure you want to revoke <fullname/> admin privileges?'
     */
    revokeAdminMessage: T;

    /**
     * @default 'Transfer Ownership'
     */
    transferOwnershipTitle: T;

    /**
     * @default 'Are you sure you want to transfer the ownership of this Joy event to <fullname/>?'
     */
    transferOwnershipMessage: T;

    /**
     * @default '<fullname/> will become the primary account owner for this event and your current account will be downgraded to an admin account.'
     */
    transferOwnershipConfirmation: T;

    /**
     * @default 'Type “{{confirmationWord}}” in the input below to confirm this change'
     */
    transferOwnershipInputLabel: T;

    /**
     * @default 'Owner'
     */
    owner: T;

    /**
     * @default 'Collaborators'
     */
    collaborators: T;

    /**
     * @default 'Transfer'
     */
    transfer: T;

    /**
     * @default 'Revoke'
     */
    revoke: T;

    /**
     * @default 'Cancel'
     */
    cancel: T;

    /**
     * @default 'Done'
     */
    done: T;

    /**
     * @default 'Invite Collaborator'
     */
    inviteNewAdmin: T;

    /**
     * @default 'Add {{page}} Admin'
     */
    addAdmin: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Email'
     */
    email: T;

    /**
     * @default 'An email invitation has been sent'
     */
    sentInvitation: T;

    /**
     * @default 'Resend'
     */
    resend: T;

    /**
     * @default 'Pending Invitations'
     */
    pendingInvitations: T;

    /**
     * @default 'Send Invitation'
     */
    sendInvitation: T;

    /**
     * @default 'Confirm Transfer'
     */
    confirmTransfer: T;

    /**
     * @default 'Verify your email address to invite collaborators'
     */
    verifyYourEmail: T;

    /**
     * @default 'First name is required'
     */
    firstNameRequired: T;

    /**
     * @default 'Last name is required'
     */
    lastNameRequired: T;

    /**
     * @default 'Email is required'
     */
    emailRequired: T;

    /**
     * @default 'Invalid email format'
     */
    invalidEmail: T;

    /**
     * @default 'First name'
     */
    firstNameAriaLabel: T;

    /**
     * @default 'First name'
     */
    firstNamePlaceholder: T;

    /**
     * @default 'Last name'
     */
    lastNameAriaLabel: T;

    /**
     * @default 'Last name'
     */
    lastNamePlaceholder: T;

    /**
     * @default 'Email'
     */
    emailAriaLabel: T;

    /**
     * @default 'email@example.com'
     */
    emailPlaceholder: T;

    /**
     * @default 'An email invitation has been sent'
     */
    invitationHasBeenSent: T;

    /**
     * @default 'An error occurred while send your invitation'
     */
    errorSendingInvitation: T;

    /**
     * @default 'We resent your invitation'
     */
    weResentYourInvitation: T;

    /**
     * @default 'Please wait a short time to resend this invitation'
     */
    errorResendingYourInvitation: T;

    /**
     * @default 'You have transferred ownership of this Joy event'
     */
    transferredOwnership: T;

    /**
     * @default 'Error transfering ownership'
     */
    errorTransferingOwnership: T;

    /**
     * @default 'This invitation has been cancelled'
     */
    invitationCancelled: T;

    /**
     * @default 'Error cancelling invitation'
     */
    errorCancellingInvitation: T;

    /**
     * @default 'Admin removed'
     */
    adminRemoved: T;

    /**
     * @default 'Error removing admin'
     */
    errorRemovingAdmin: T;
  };
  registryProductRow: {
    /**
     * @default 'Gift Purchased'
     */
    giftPurchased: T;

    /**
     * @default '{{amount}} Reserved'
     */
    giftsPurchased: T;

    /**
     * @default '{{amount}} Requested'
     */
    giftsRequested: T;

    /**
     * @default 'Favorite'
     */
    favorite: T;

    /**
     * @default '{{amount}} Still Needed'
     */
    giftStillNeeded: T;

    rewardPhrasesCompleted: [
      /**
       * @default 'Hooray! 🎉'
       */
      T,
      /**
       * @default 'A fabulous choice! 😍'
       */
      T,
      /**
       * @default 'Purchased with love! 💕'
       */
      T,
      /**
       * @default 'Someone got you this! 🎁'
       */
      T,
      /**
       * @default 'Gift purchased! 💃'
       */
      T,
      /**
       * @default 'Congratulations! 🎊'
       */
      T,
      /**
       * @default 'Oh, the generosity! 🫶'
       */
      T,
      /**
       * @default 'Consider it gifted! 🥳'
       */
      T,
    ];

    /**
     * @default 'Item Still Needed'
     */
    itemStillNeeded: T;

    /**
     * @default 'Items Still Needed'
     */
    itemsStillNeeded: T;

    /**
     * @default 'Reorder Gifts'
     */
    reorderGifts: T;

    /**
     * @default 'Done'
     */
    doneReordering: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default 'Purchased'
     */
    purchased: T;

    /**
     * @default 'Reserved by You'
     */
    reservedByYou: T;

    /**
     * @default 'Purchased by You'
     */
    purchasedByYou: T;

    /**
     * @default 'Reserved by'
     */
    reservedByColumnHeader: T;

    /**
     * @default 'Purchased by'
     */
    purchasedByColumnHeader: T;

    /**
     * @default '{{initialEntry}} & {{remaining}} others...'
     */
    purchasedByOverflow: T;

    /**
     * @default 'Removing gift...'
     */
    removingGift: T;

    /**
     * @default 'Cash Fund'
     */
    categoryCashFundText: T;

    /**
     * @default 'Charity Fund'
     */
    categoryCharityFundText: T;

    /**
     * @default 'Drag to reorder items'
     */
    reorderMessage: T;

    /**
     * @default 'gifted so far'
     */
    giftedSoFarText: T;

    /**
     * @default 'Reorder'
     */
    reorder: T;

    /**
     * @default 'Gift Reserved'
     */
    giftReserved: T;

    /**
     * @default '{{action}} from'
     */
    storeAction: T;

    /**
     * @default '{{store}} Registry'
     */
    storeName: T;

    /**
     * @default 'Remove filters to reorder your items.'
     */
    disabledReorderText: T;

    /**
     * @default ' Hidden Gifts ({{count}}) '
     */
    hideItemText: T;

    /**
     * @default 'New'
     */
    newItem: T;

    /**
     * @default 'Funded'
     */
    funded: T;

    /**
     * @default 'Most Wanted'
     */
    mostWanted: T;

    /**
     * @default 'Marked as Most Wanted'
     */
    markedAsMostWanted: T;

    /**
     * @default 'Removed as Most Wanted'
     */
    removedAsMostWanted: T;

    /**
     * @default 'Our Most Wanted'
     */
    ourMostWanted: T;
  };
  registryStats: {
    /**
     * @default 'Gifts Added'
     */
    giftsAdded: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default 'Still Needed'
     */
    stillNeeded: T;
  };
  amazonRegistry: {
    /**
     * @default 'Amazon Registry'
     */
    heading: T;

    /**
     * @default 'Last Synced'
     */
    lastSync: T;

    /**
     * @default 'Manage Registry'
     */
    manageReg: T;

    /**
     * @default 'We are grabbing your gifts right now. They’ll be ready to view soon.'
     */
    inProgressSync: T;

    /**
     * @default 'Syncing...'
     */
    syncing: T;
  };
  registry: {
    /**
     * @default ''s Registry'
     */
    heading: T;
  };
  emptyFilter: {
    /**
     * @default 'Cleaned out the aisles'
     */
    stillNeededTitle: T;

    /**
     * @default 'Looks like your guests purchased everything currently on your registry. If you find anything new that suits your fancy, add  them your registry so there are items for all your guests to buy.'
     */
    stillNeededSubtitle: T;

    /**
     * @default 'Nothing gifted yet'
     */
    purchasedTitle: T;

    /**
     * @default 'Once your guests purchase items on your registry,  you'll see the items here.'
     */
    purchasedSubtitle: T;

    /**
     * @default 'Looks like you don’t have any favorites yet'
     */
    favoriteTitle: T;

    /**
     * @default 'That’s totally cool, but if you did they’d show up here to help your guests purchase what you really want.'
     */
    favoriteSubtitle: T;

    /**
     * @default 'Looks like you don’t have any items on your registry'
     */
    defaultTitle: T;

    /**
     * @default 'Please add items to your registry'
     */
    defaultSubTitle: T;

    /**
     * @default 'No gifts added yet'
     */
    noSyncableRegistryTitle: T;

    /**
     * @default 'Once you add gifts or sync a registry, they will appear here.'
     */
    noSyncableRegistrySubtitle: T;
  };
  publishRegistryItems: {
    /**
     * @default 'Display Gifts In Registry'
     */
    title: T;

    /**
     * @default 'Show or hide products synced from this registry. If products are not displayed, guests can still shop for them using the external registry link.'
     */
    info: T;

    /**
     * @default 'Show'
     */
    labelOn: T;

    /**
     * @default 'Hide'
     */
    labelOff: T;
  };
  filterSectionRegistry: {
    /**
     * @default 'Everything'
     */
    everything: T;

    /**
     * @default 'Gifts Available'
     */
    stillNeeded: T;

    /**
     * @default 'Purchased'
     */
    purchased: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default 'Reserved & Purchased'
     */
    reservedAndPurchased: T;
  };
  productDialog: {
    /**
     * @default 'Gift added from {{storeName}}'
     */
    giftAddedFrom: T;

    /**
     * @default 'To edit or remove this gift you’ll need to do it on your'
     */
    alertEditRegistry: T;

    /**
     * @default 'linked registry'
     */
    linkRegistry: T;

    /**
     * @default 'Remove from Registry'
     */
    removedCustomItem: T;

    /**
     * @default 'was removed from your registry.'
     */
    giftRemoved: T;

    /**
     * @default 'Edit Gift'
     */
    giftEditDetails: T;
  };
  productListHeaderButtons: {
    /**
     * @default 'Add Gift'
     */
    addGift: T;

    /**
     * @default 'Add Gifts'
     */
    addGiftV2: T;

    /**
     * @default 'Filter By'
     */
    filterBy: T;

    /**
     * @default 'Manage Gifts'
     */
    title: T;

    /**
     * @default 'New Gift'
     */
    newGift: T;
  };
  notification: {
    /**
     * @default 'Notifications'
     */
    title: T;

    bankAccount: {
      /**
       * @default 'Connect your bank account to allow guests to give by credit card.'
       */
      primaryText: T;

      /**
       * @default 'Guests prefer the flexibility of giving to cash funds by card, and right now they can't.'
       */
      secondaryText: T;
    };
  };
  giftTypeOptionsButtons: {
    /**
     * @default 'Product'
     */
    product: T;

    /**
     * @default 'Cash Fund'
     */
    cashFund: T;

    /**
     * @default 'Charity'
     */
    charity: T;
  };
  addGiftFromUrl: {
    /**
     * @default 'Save time and <browserButtonCta/> or <appCta/>
'
*/
    saveTime: T;

    /**
     * @default 'install the browser button
'
*/
    browserButtonCta: T;

    /**
     * @default 'get the app'
     */
    appCta: T;

    /**
     * @default 'Continue adding from
'
*/
    continueAdding: T;
  };
  addressDialog: {
    /**
     * @default 'Edit shipping address'
     */
    editShippingAddressButton: T;

    /**
     * @default 'Your shipping address'
     */
    yourShippingAddressButton: T;

    /**
     * @default 'Shipping Settings'
     */
    shippingSettingsTitle: T;

    /**
     * @default 'With Joy, you choose when your gifts ship.'
     */
    shippingControlMessageTitle: T;

    /**
     * @default 'You’re in control with gifts fulfilled by Joy. We’ll hold them until you’re ready to ship.'
     */
    shippingControlMessageDescription: T;

    /**
     * @default ' Learn More'
     */
    learnMore: T;

    /**
     * @default 'Let gift givers know where to send their gifts.'
     */
    note: T;

    /**
     * @default 'Items sold by Joy are only shippable within the contiguous U.S. (excludes Alaska/Hawaii).'
     */
    shippingPolicyExceptions: T;

    /**
     * @default 'Name'
     */
    name: T;

    /**
     * @default 'Phone'
     */
    phone: T;

    /**
     * @default 'Only one recipient name is recommended'
     */
    nameCaption: T;

    /**
     * @default 'Address Line 1'
     */
    address1: T;

    /**
     * @default 'We cannot ship to P.O. boxes'
     */
    poBoxWarningCaption: T;

    /**
     * @default 'Address Line 2'
     */
    address2: T;

    /**
     * @default 'City'
     */
    city: T;

    /**
     * @default 'State/Region/Province'
     */
    state: T;

    /**
     * @default 'Zip/Postal Code'
     */
    postalCode: T;

    /**
     * @default 'Country'
     */
    country: T;

    /**
     * @default 'Country Code'
     */
    countryCode: T;

    /**
     * @default 'Save'
     */
    saveButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Clear Address'
     */
    resetButton: T;

    /**
     * @default '*Required fields'
     */
    requiredFields: T;

    /**
     * @default 'Other'
     */
    countryOtherByCode: T;

    /**
     * @default 'Confirm Shipping Address'
     */
    addressConfirmationTitle: T;

    /**
     * @default 'To ensure accurate delivery, we suggest the slightly modified address below. Please select the address you’d like to use.'
     */
    addressConfirmationNote: T;

    /**
     * @default 'Original Address'
     */
    originalAddressText: T;

    /**
     * @default 'Suggested Address'
     */
    suggestedAddressText: T;

    /**
     * @default 'Back'
     */
    backButton: T;

    /**
     * @default 'Confirm Address'
     */
    confirmButton: T;

    /**
     * @default 'Full name'
     */
    fullName: T;

    /**
     * @default '555-555-5555'
     */
    phonePlaceholder: T;

    /**
     * @default 'Address'
     */
    address: T;

    /**
     * @default 'Apartment, suite, etc. (optional)'
     */
    addressPlaceholder2: T;
  };
  delayShipping: {
    /**
     * @default 'You decide when you want your gifts to ship. Exclusively for gifts sold by Joy.'
     */
    delayShippingDescription: T;

    /**
     * @default 'Note: Previously delayed gifts will need your review before they can be shipped.'
     */
    widgetCounterNoteMessage: T;

    /**
     * @default 'Gifts to Review'
     */
    counterLabel: T;

    /**
     * @default 'Review and Ship'
     */
    reviewAndShip: T;

    /**
     * @default 'Activate Delay Shipping'
     */
    activateDelayShippingTitle: T;

    /**
     * @default 'Deactivate Delay Shipping'
     */
    deactivateDelayShippingTitle: T;

    /**
     * @default 'By enabling Delay Shipping, any new orders you receive will not be shipped until you give us the go-ahead. You can easily turn off Delay Shipping from the Track page at any time. Are you sure you want to confirm this action?'
     */
    activateDelayShippingDescription: T;

    /**
     * @default 'You are about to disable Delay Shipping. Newly placed orders will ship automatically as soon as they’re received. Previously delayed orders must still be shipped from the Gift Tracker.'
     */
    deactivateDelayShippingDescription: T;

    /**
     * @default 'Got it'
     */
    confirmButton: T;

    /**
     * @default ' Newly received gifts will ship automatically unless Delay Shipping is on. Please note: toggling delay shipping only impacts new orders. Existing delayed orders will still require action.'
     */
    tooltipDescription: T;

    /**
     * @default 'Delay Shipping is '
     */
    toggleLabel: T;

    /**
     * @default 'Confirm Shipping'
     */
    confirmShipping: T;

    /**
     * @default 'Ship Order Now'
     */
    shipOrderNow: T;

    /**
     * @default 'Ship {{count}} Orders'
     */
    shipOrdersNow: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Review Orders'
     */
    reviewOrders: T;

    /**
     * @default 'Your order is being processed.'
     */
    inProcessSingular: T;

    /**
     * @default 'Your orders are being processed.'
     */
    inProcessPlural: T;

    /**
     * @default 'Most items will ship via Standard Ground Shipping and arrive within 5-10 business days from when the order was processed. We’ll send you an email once it ships!'
     */
    inProcessDescription: T;

    /**
     * @default 'Show Details'
     */
    showDetailsText: T;

    /**
     * @default 'Hide Details'
     */
    hideDetailsText: T;

    /**
     * @default 'You have {{count}} Orders Pending Shipment'
     */
    countMessage: T;

    /**
     * @default 'Shipping to:'
     */
    shipTo: T;

    /**
     * @default 'One or more orders was placed with an old shipping address. Which address would like to use?'
     */
    shippingConflict: T;

    /**
     * @default 'Please select if you’d prefer this address:'
     */
    newAddressOnFile: T;

    /**
     * @default 'Mmm... Something went wrong. Please try again or contact support'
     */
    mutationGenericError: T;

    /**
     * @default 'Shipping is limited to the continental USA; PO boxes are not eligible.'
     */
    invalidShippingAddress: T;

    /**
     * @default 'When we receive your order, we will begin to process shipping for your available items.'
     */
    shipWhatWeCanNotice: T;
  };
  delayShippingV2: {
    /**
     * @default 'You have gifts ready to ship.'
     */
    enabledDelayShippingTitle: T;

    /**
     * @default 'You decide when gifts ship.'
     */
    disabledDelayShippingTitle: T;

    /**
     * @default 'You’re in control with gifts sold by Joy. We’ll hold them until you’re ready to ship.'
     */
    delayShippingDescription: T;

    /**
     * @default 'Gifts Ready to Ship'
     */
    enabledCounterLabel: T;

    /**
     * @default 'No gifts are ready to ship.'
     */
    disabledCounterLabel: T;

    /**
     * @default 'Review and Ship'
     */
    reviewAndShip: T;
  };
  addressAutocompleteField: {
    /**
     * @default 'Address not found'
     */
    addressNotFound: T;

    /**
     * @default 'Keep typing to display more results'
     */
    firstOptionAddress1Field: T;

    /**
     * @default '-- Add Address Manually --'
     */
    lastOptionAddress1Field: T;

    /**
     * @default 'Click for {{entries}} more entries'
     */
    addressWithMoreThanOneSuggestion: T;
  };
  giftProgressTracker: {
    progressBarStateStart: [
      /**
       * @default 'Let's get it started!'
       */
      T,
      /**
       * @default 'Start your engines!'
       */
      T,
      /**
       * @default 'It's good to have goals!'
       */
      T,
      /**
       * @default 'There is so much potential here!'
       */
      T,
    ];

    progressBarStateComplete: [
      /**
       * @default 'We did it! 🎉'
       */
      T,
      /**
       * @default 'Cash fund complete! ✅'
       */
      T,
      /**
       * @default 'Mission accomplished! 🏆'
       */
      T,
      /**
       * @default 'Goal crushed! ⭐️'
       */
      T,
      /**
       * @default 'Time to celebrate! 🎊'
       */
      T,
    ];

    /**
     * @default '{{goal}} Goal'
     */
    cashGiftLabel: T;

    /**
     * @default '{{goal}} Goal Reached!'
     */
    cashGiftLabelComplete: T;

    /**
     * @default '{{amount}} Received'
     */
    cashGiftProgress: T;

    /**
     * @default '{{amount}}'
     */
    cashGiftProgressV2: T;

    /**
     * @default '{{amount}} Gifted'
     */
    groupGiftProgress: T;

    /**
     * @default '{{requested}} Requested'
     */
    physicalGiftLabel: T;

    /**
     * @default '{{requested}} Received!'
     */
    physicalGiftLabelComplete: T;

    /**
     * @default '{{purchased}} of {{requested}} reserved/purchased'
     */
    physicalGiftProgress: T;

    /**
     * @default '{{amount}} still needed'
     */
    remainingText: T;

    /**
     * @default '{{amount}} Goal'
     */
    remainingTextV2: T;

    /**
     * @default '{{amount}} Contribution'
     */
    contributionText: T;

    /**
     * @default '{{amount}} Contributed'
     */
    contributedText: T;

    /**
     * @default 'Contribute what you wish'
     */
    contributionAnyAmountText: T;

    /**
     * @default 'Group Gift'
     */
    groupGifting: T;
  };
  itemPurchaseTracker: {
    /**
     * @default 'Purchased By'
     */
    tableHeaderPurchasedBy: T;

    /**
     * @default 'Total'
     */
    tableHeaderTotal: T;

    /**
     * @default 'Copy'
     */
    copyButton: T;

    /**
     * @default 'Copied'
     */
    copied: T;
  };
  customItemDetailsDialog: {
    /**
     * @default 'Payment via {{provider}} @{{handle}}'
     */
    paymentSource: T;

    /**
     * @default 'Fulfilled by {{retailer}}'
     */
    fulfillmentSource: T;

    /**
     * @default 'No one has purchased this (yet).'
     */
    zeroStateMsgHeader: T;

    /**
     * @default 'After someone has purchased this gift, you'll be able to see it here.'
     */
    zeroStateMsgBody: T;

    /**
     * @default 'Edit Gift'
     */
    editGiftButton: T;

    /**
     * @default 'Remove from Registry'
     */
    removeGiftButton: T;

    /**
     * @default 'Remove registry gift?'
     */
    removeGiftDialogHeader: T;

    /**
     * @default 'This item will be permanently deleted from your registry.'
     */
    removeGiftDialogBody: T;

    /**
     * @default 'Nevermind'
     */
    cancelRemoveGiftButton: T;

    /**
     * @default 'Are you sure you want to remove this gift?'
     */
    removeGiftDialogHeaderHasPurchases: T;

    /**
     * @default 'Someone has already reserved it, and they (or your future self) may be confused if you delete it from your registry.'
     */
    removeGiftDialogBodyHasPurchases: T;

    /**
     * @default 'gifted so far'
     */
    giftedSoFarText: T;

    /**
     * @default 'View Item on {{storeName}}'
     */
    viewOnWebsite: T;

    /**
     * @default 'View Contribution link'
     */
    contributionLink: T;

    /**
     * @default 'cash'
     */
    cash: T;

    /**
     * @default 'Gift Message'
     */
    noteLabel: T;

    /**
     * @default 'and Cash/Check'
     */
    cashOrCheckFulfillmentText: T;

    /**
     * @default 'Credit card'
     */
    creditCardFullfillmentText: T;

    /**
     * @default 'Note to Family and Friends'
     */
    noteToFamilyTitle: T;

    /**
     * @default 'Tracking Unavailable on Joy'
     */
    noTrackingTitle: T;

    /**
     * @default 'This item was purchased on an external registry prior to being transferred to Joy.'
     */
    noTrackingSubtitle: T;

    /**
     * @default 'To track this gift, please refer to your'
     */
    noTrackingPreText: T;

    /**
     * @default 'external'
     */
    noTrackingExternalText: T;

    /**
     * @default 'registry.'
     */
    noTrackingPostText: T;

    /**
     * @default 'This gift cannot be removed from your registry because it has been reserved or purchased.'
     */
    cannotRemoveExplanation: T;

    /**
     * @default 'Hide Gift'
     */
    hideButton: T;

    /**
     * @default 'Show on Registry'
     */
    showButton: T;

    /**
     * @default '🙈 {{title}} has been hidden from your registry.'
     */
    hideTostText: T;

    /**
     * @default '{{title}} is now being shown on your registry.'
     */
    showTostText: T;
  };
  cancelReservationDialog: {
    /**
     * @default 'Are you sure you want to cancel this reservation?'
     */
    cancelReservationHeader: T;

    /**
     * @default 'This will make the gift available for reservation on your registry again.'
     */
    cancelReservationBody: T;

    /**
     * @default 'Nevermind'
     */
    cancelReservationCancelButton: T;

    /**
     * @default 'Confirm Cancellation'
     */
    cancelReservationConfirmButton: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservationButtonText: T;
  };
  cashFundPreviewSendEmailReminderDialog: {
    /**
     * @default 'Missing your cash gift?'
     */
    header: T;

    /**
     * @default 'Joy can send a friendly reminder to {{guestName}}.'
     */
    body: T;

    /**
     * @default 'EMAIL PREVIEW'
     */
    emailPreview: T;

    /**
     * @default 'From:'
     */
    from: T;

    /**
     * @default ' Joy'
     */
    joy: T;

    /**
     * @default 'To:'
     */
    to: T;

    /**
     * @default '{{guestName}}'
     */
    toText: T;

    /**
     * @default 'Subject:'
     */
    subject: T;

    /**
     * @default ' Following up on your gift for {{eventName}}'
     */
    subjectText: T;

    /**
     * @default 'Reminder Sent'
     */
    successText: T;

    /**
     * @default 'Haven't received this gift?'
     */
    haventReceivedTitle: T;

    /**
     * @default 'Joy can send a reminder email to your guest for you. You'll see a preview first.'
     */
    haventReceivedDescription: T;

    /**
     * @default 'Still have questions?'
     */
    stillHaveQuestions: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Send Reminder from Joy'
     */
    confirmButton: T;

    /**
     * @default 'Sample Email:'
     */
    sampleText: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;
  };
  previewSendEmailReminderDialog: {
    /**
     * @default 'Need tracking info for your gift? We’ve got you.'
     */
    header: T;

    /**
     * @default 'We’ll send a one-time email to your guest to request the Order ID, Tracking Number and Shipping Carrier for this gift. Once provided, the information will appear in your gift tracker.'
     */
    body: T;

    /**
     * @default 'Your guest may have forgotten to complete the gift reservation process. If you’d like, we’ll send them a friendly nudge. The email will come right from Joy, they won’t ever know you asked us to remind them.'
     */
    bodyCashFundOrCharity: T;

    /**
     * @default 'Sample Email:'
     */
    sampleText: T;

    /**
     * @default 'unknown'
     */
    unknown: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Send Request'
     */
    confirmButton: T;

    /**
     * @default 'Haven’t received your gift yet? We can send a reminder email to your guest for you.'
     */
    prompt: T;

    /**
     * @default 'Preview and Send Reminder'
     */
    buttonText: T;

    /**
     * @default 'Reminder Sent'
     */
    successText: T;

    /**
     * @default 'Haven't received this gift?'
     */
    haventReceivedTitle: T;

    /**
     * @default 'Joy can send a reminder email to your guest for you. You'll see a preview first.'
     */
    haventReceivedDescription: T;

    /**
     * @default 'Still have questions?'
     */
    stillHaveQuestions: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;
  };
  reminderSentConfirmationDialog: {
    /**
     * @default 'Reminder Sent to {{guestName}}'
     */
    title: T;

    /**
     * @default 'You can remind guests as many times as needed.'
     */
    subtitle: T;

    /**
     * @default 'Joy does not perform {{paymentMethod}} transactions for your guests. Guests have to leave your registry and go to the payment app to send you money.'
     */
    paymentMethodInfo: T;

    /**
     * @default 'What might have happened?'
     */
    whatMightHaveHappenedTitle: T;

    /**
     * @default 'Most of the time this happens because guests are unfamiliar with payment apps, or they simply forgot to complete their payment or mark it as given.'
     */
    whatMightHaveHappenedBody: T;

    /**
     * @default 'How can I avoid this problem?'
     */
    howToAvoidTitle: T;

    /**
     * @default 'Securely connect your bank account to allow your guests to pay by credit and debit card. These transactions are simpler, automatically tracked by Joy, and are more flexible for guests.'
     */
    howToAvoidBody: T;

    /**
     * @default 'Connect Your Bank Account'
     */
    connectBankAccountButton: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;
  };
  downloadDialog: {
    /**
     * @default 'Add Gifts on the Go'
     */
    downloadDialogEyebrowText: T;

    /**
     * @default 'Use the app to add items wherever, whenever'
     */
    downloadDialogHeaderText: T;

    /**
     * @default 'You can download the app on both Android and iOS.'
     */
    downloadDialogBodyText: T;
  };
  addRegistry: {
    /**
     * @default 'anyregistry.com/our-registry'
     */
    inputPlaceholder: T;

    /**
     * @default 'Registry URL'
     */
    inputLabel: T;

    /**
     * @default 'Add Registry'
     */
    buttonText: T;

    /**
     * @default 'Maybe Later'
     */
    maybeLater: T;

    /**
     * @default 'Already have another registry?'
     */
    connectRegistriesTitle: T;

    /**
     * @default 'Connect external registries for your guests’ convenience.'
     */
    connectRegistriesSubtitle: T;

    /**
     * @default '🙌 ️Sounds good. ✨'
     */
    soundsGood: T;

    /**
     * @default 'You can connect another registry at any time in the sidebar or on the build page.'
     */
    connectMessage: T;

    /**
     * @default 'Already have a registry?'
     */
    connectTitle: T;
  };
  addGiftDialog: {
    /**
     * @default 'Add your own gift'
     */
    title: T;
  };
  giftTypeSection: {
    /**
     * @default 'Get Gift Ideas'
     */
    getGiftIdeas: T;

    /**
     * @default 'Add Gift Manually'
     */
    addGiftManually: T;

    /**
     * @default 'Add Item'
     */
    addProduct: T;

    /**
     * @default 'Add Cash Fund'
     */
    addCashFund: T;

    /**
     * @default 'Add Charity'
     */
    addCharity: T;

    /**
     * @default 'Browse Products'
     */
    browseProducts: T;

    /**
     * @default 'Explore Cash Funds'
     */
    exploreCashFunds: T;

    /**
     * @default 'See Top Picks For You'
     */
    topPicks: T;

    /**
     * @default 'Start Your Checklist'
     */
    checklist: T;

    /**
     * @default 'Install the Joy Quick Add Button'
     */
    quickAddSectionTitle: T;

    /**
     * @default 'Joy Mobile App'
     */
    quickAddSectionTitleMobile: T;

    /**
     * @default 'Add anything as you browse the web.'
     */
    quickAddSectionSubtitle: T;

    /**
     * @default 'Add anything as you browse the web on your phone.'
     */
    quickAddSectionSubtitleMobile: T;

    /**
     * @default 'Get the button'
     */
    quickAddSectionBtn: T;

    /**
     * @default 'Get the app'
     */
    quickAddSectionBtnMobile: T;

    /**
     * @default 'Joy Quick Add'
     */
    quickAddSectionImgAlt: T;

    /**
     * @default 'Shop from Any Store'
     */
    shopFromAnyStore: T;

    /**
     * @default 'Add Gift from Anywhere'
     */
    addGiftFromAnywhere: T;
  };
  giftLinkDialog: {
    /**
     * @default 'Paste a link to add a gift'
     */
    title: T;

    /**
     * @default 'https://anywebsite.com/linktoyourgift'
     */
    placeholder: T;

    /**
     * @default 'Save time and'
     */
    saveTime: T;

    /**
     * @default 'install the browser button'
     */
    browserButton: T;

    /**
     * @default 'or'
     */
    or: T;

    /**
     * @default 'get the app'
     */
    getApp: T;

    /**
     * @default 'Add Gift'
     */
    addGift: T;
  };
  newAddRegistryDialog: {
    /**
     * @default 'Have Another Registry? Let’s Connect!'
     */
    landingTitle: T;

    /**
     * @default 'Keep your registries in one place for easy access.'
     */
    landingSubtitle: T;

    /**
     * @default 'Hmm… we were unable to add this registry.'
     */
    errorTitle: T;

    /**
     * @default 'Please try again later or contact us if you’re still having trouble.'
     */
    errorSubtitle: T;

    /**
     * @default 'Awesome. We’re syncing your gifts so gift givers can shop in one place.'
     */
    syncingTitle: T;

    /**
     * @default 'Your gifts from {{storeName}} will soon appear in your Joy registry.'
     */
    syncingSubtitle: T;

    /**
     * @default 'Awesome. We’ve added a link on your Joy registry so gift givers will easily find it.'
     */
    linkedTitle: T;

    /**
     * @default 'Test Registry Link'
     */
    testRegistryLink: T;

    /**
     * @default 'Add Registry'
     */
    addRegistry_short: T;

    /**
     * @default 'Add Another Registry'
     */
    addAnotherRegistry: T;

    /**
     * @default 'Make sure the registry you’re connecting is set to "Public".'
     */
    makeSureRegistryIsPublic: T;

    /**
     * @default 'How does it work?'
     */
    howItWorks_short: T;

    /**
     * @default 'How does syncing work?'
     */
    howItWorks_long: T;
  };
  transferRegistry: {
    /**
     * @default 'Transfer Your {{retailer}} Registry to Joy'
     */
    title: T;

    /**
     * @default 'Make a one-time registry transfer. All your items will be hosted and managed through Joy so you don’t have to worry about juggling multiple registries.'
     */
    subtitle: T;

    /**
     * @default 'Start Transfer'
     */
    button: T;

    /**
     * @default 'I’d rather manage my gifts through {{retailer}}'
     */
    secondaryButton: T;

    /**
     * @default 'Add, update, and track gifts in one place'
     */
    ctaOne: T;

    /**
     * @default 'Guests look for available gifts on Joy'
     */
    ctaThree: T;

    /**
     * @default 'Shop anywhere with the Joy Browser Button'
     */
    ctaTwo: T;

    /**
     * @default 'Hang Tight! We’re Transferring Your Registry…'
     */
    loadingTitle: T;

    /**
     * @default 'In a moment your {{retailer}} items will appear in your Joy registry.'
     */
    loadingSubtitle: T;

    /**
     * @default 'Your gifts are now in Joy!'
     */
    completeTitle: T;

    /**
     * @default 'Next let’s hide your old registry.'
     */
    completeTitleLineTwo: T;

    /**
     * @default 'By making your {{retailer}} registry private, your guests won’t accidentally purchase the same Mickey Mouse Waffle Maker twice. 😉'
     */
    completeSubtitle: T;

    /**
     * @default 'Sit tight, your transfer is still in progress.'
     */
    stillTransferingTitle: T;

    /**
     * @default 'Refresh the page in a few minutes and it should be complete.'
     */
    stillTransferingSubtitle: T;

    /**
     * @default 'Thousands of unique gifts and brands you love are waiting for you. Shop with Joy!'
     */
    shopPromoTitle: T;

    /**
     * @default 'Shop Now'
     */
    shopPromoButton: T;

    /**
     * @default 'Next'
     */
    nextButton: T;

    /**
     * @default 'Add gifts from {{retailer}} or any store easily with the Joy Browser Button'
     */
    joyButtonTitle: T;

    /**
     * @default 'Drag the button below to your browser’s Bookmark bar to save it.'
     */
    joyButtonSubtitle: T;

    /**
     * @default 'Add gifts easily'
     */
    joyAppTitle: T;

    /**
     * @default 'Download the Joy app & add new items from {{retailer}} or any store.'
     */
    joyAppSubtitle: T;

    /**
     * @default 'Need help?'
     */
    needHelp: T;

    /**
     * @default 'Read our step-by-step guide.'
     */
    readOurGuide: T;

    /**
     * @default 'Edit Old Registry Settings'
     */
    editOldButton: T;

    /**
     * @default 'Want to add more gifts to your registry? Get the '
     */
    tryBrowserButton: T;

    /**
     * @default 'Joy Browser Button!'
     */
    joyBrowserButton: T;

    /**
     * @default 'Delete Registry and Gifts'
     */
    deleteRegistry: T;

    /**
     * @default 'As of {{date}} your registry is still set to Public.'
     */
    asOfPublic: T;

    /**
     * @default 'Set your {{storeName}} registry to private to avoid confusion and duplicate gifts.'
     */
    turnToPrivate: T;

    /**
     * @default 'Fix Registry Privacy'
     */
    fixRegPrivacy: T;

    /**
     * @default 'Please note: if you already have purchased gifts on your other registry, your gift tracking and purchase data will NOT be transferred to Joy.'
     */
    transferWarning: T;

    /**
     * @default 'Edit Registry'
     */
    viewRegistry: T;

    /**
     * @default 'How does this work?'
     */
    howTo: T;

    /**
     * @default 'Want to add more gifts from {{storeName}}?'
     */
    browserButtonCTATitle: T;

    /**
     * @default 'Get the Joy Browser Button'
     */
    browserButtonCTASubtitle: T;

    /**
     * @default 'Please hide your {{storeName}} registry'
     */
    hideRegistryTitle: T;

    /**
     * @default 'Transferring'
     */
    registryTransferInProgress: T;

    /**
     * @default 'We only check this once a day, so if it doesn't seem accurate please check back tomorrow.'
     */
    bannerTooltip: T;

    giftCounts: {
      /**
       * @default '{{count}} gift transferred'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} gift transferred
       * - plural: {{count}} gifts transferred
       */
      transferredGiftCount: T;
    };
  };
  addGiftsPostTransfer: {
    /**
     * @default 'New gifts found on your {{storeName}} registry'
     */
    bannerTitle: T;

    /**
     * @default 'New gifts found on your {{storeNames}} registries'
     */
    bannerTitlePlural: T;

    /**
     * @default 'New gifts found.'
     */
    bannerTitleMobile: T;

    /**
     * @default 'Bring them into your Joy registry.'
     */
    bannerSubTitle: T;

    /**
     * @default 'Transferred Registry'
     */
    tooltipHeader: T;

    /**
     * @default 'If you’ve added new gifts after transferring your registry, Joy will let you bring those gifts in to keep everything in sync. Just click on the Transfer All button to make it happen.'
     */
    tooltipText: T;

    /**
     * @default 'Transfer All'
     */
    bannerButtonCTA: T;

    /**
     * @default '{{giftCount}} New Gifts Found'
     */
    newGiftsTitle: T;

    /**
     * @default 'New gifts found on your {{storeName}} registry. Would you like to add them to Joy?'
     */
    newGiftsSubtitle: T;

    /**
     * @default 'New gifts found in your {{storeNames}} registries. Would you like to add them to Joy?'
     */
    newGiftsSubtitlePlural: T;

    /**
     * @default 'Price (ea)'
     */
    priceTitle: T;

    /**
     * @default 'Quantity'
     */
    quantityTitle: T;

    /**
     * @default 'Maybe Later'
     */
    secondaryCTA: T;

    /**
     * @default 'Add Gifts to Joy'
     */
    newGiftsPrimaryCTA: T;

    /**
     * @default 'Your new gifts have been copied to your Joy registry.'
     */
    giftsAddedConfirmation: T;

    /**
     * @default 'Tired of updating your gifts?
There’s a better way!'
*/
    getButtonTitle: T;

    /**
     * @default 'The Joy Quick Add Button makes it easy to add new items from any store directly into your Joy registry.'
     */
    getButtonSubtitle: T;

    /**
     * @default 'Get the Button'
     */
    getButtonPrimaryCTA: T;
  };
  syncRegistry: {
    /**
     * @default 'Sync Your Registry'
     */
    title: T;

    /**
     * @default 'Keep your current {{retailer}} registry and sync your items daily to your Joy registry. Guests will be sent to {{retailer}} to purchase your gifts.'
     */
    subtitle: T;

    /**
     * @default 'Start Sync'
     */
    button: T;

    /**
     * @default 'I want to manage my gifts on Joy'
     */
    secondaryButton: T;

    /**
     * @default 'Add items on your other registry'
     */
    ctaOne: T;

    /**
     * @default 'Manage and track gifts through your other registry'
     */
    ctaTwo: T;

    /**
     * @default 'Guests browse for gifts on your Joy site'
     */
    ctaThree: T;
  };
  giftTracker: {
    /**
     * @default 'Qty {{qty}}'
     */
    quantityTitle: T;

    /**
     * @default 'Order #{{orderNumber}}'
     */
    orderTitle: T;

    /**
     * @default 'Order number or tracking not available'
     */
    orderNotAvailableInfo: T;

    /**
     * @default 'Add Order & Tracking Info'
     */
    addOrderInfo: T;

    /**
     * @default 'Re: Gift tracking from Joy'
     */
    mailSubject: T;

    /**
     * @default 'Track Shipment'
     */
    trackShipmentLinkText: T;

    /**
     * @default 'Where's my gift?'
     */
    mailLinkText: T;

    /**
     * @default 'To be sent via <storeLink/>'
     */
    toBeSent: T;

    /**
     * @default 'Sent via <storeLink/>'
     */
    sentBy: T;

    /**
     * @default 'Gift Giver'
     */
    tableName: T;

    /**
     * @default 'Thank You Manager'
     */
    tableGift: T;

    /**
     * @default 'Track Gifts & Send Thanks'
     */
    trackingGiftTitle: T;

    /**
     * @default 'Tracking'
     */
    trackGiftNavOption: T;

    /**
     * @default 'Gifts & Registries'
     */
    giftsAndRegistriesNavOption: T;

    /**
     * @default '{{guestName}} marked this as purchased.'
     */
    tooltipPurchased: T;

    /**
     * @default '{{guestName}} marked this as given.'
     */
    tooltipGiven: T;

    /**
     * @default '{{guestName}} intends to get you this gift, but they have not marked it as purchased yet.'
     */
    tooltipReserved: T;

    /**
     * @default 'These gifts have been marked as purchased by your guests.'
     */
    tooltipReservedPurchased: T;

    /**
     * @default 'Your guests intend to get you these gifts, but they have not yet marked them as purchased.'
     */
    tooltipReservedRequested: T;

    /**
     * @default 'This gift has not been shipped yet'
     */
    statusTooltipNotShipped: T;

    /**
     * @default 'We will provide tracking information as soon as it is available.'
     */
    statusTooltipTracking: T;

    /**
     * @default 'This gift has been shipped.'
     */
    statusTooltipShipped: T;

    /**
     * @default 'Request Refund'
     */
    requestRefund: T;

    /**
     * @default 'Mark as not purchased'
     */
    markAsNotPurchased: T;

    /**
     * @default 'Contact Support'
     */
    contact: T;

    /**
     * @default 'Return Policy'
     */
    returnPolicy: T;

    /**
     * @default 'Cancel Reservation'
     */
    cancelReservation: T;

    /**
     * @default 'Mark as not given'
     */
    markAsNotGiven: T;

    /**
     * @default 'The order was cancelled'
     */
    orderCancelledText: T;

    /**
     * @default 'Cancelling reservation...'
     */
    cancellingReservation: T;

    /**
     * @default 'order has not selected'
     */
    errorOrderNotSelected: T;

    /**
     * @default 'Hidden from registry'
     */
    hideGiftText: T;

    /**
     * @default 'More Options...'
     */
    moreOptions: T;

    /**
     * @default 'This gift has an issue with the delivery address'
     */
    noticeTitleText: T;

    /**
     * @default 'Instructions for how to fix...'
     */
    noticeInstructionsText: T;

    /**
     * @default 'Write Thank You'
     */
    thankYouLabelLong: T;

    /**
     * @default 'Thank'
     */
    thankYouLabelShort: T;

    /**
     * @default 'Thank You Sent'
     */
    thankedLabelLong: T;

    /**
     * @default 'Thanked'
     */
    thankedLabelShort: T;

    /**
     * @default 'Gift'
     */
    giftLabelSingular: T;

    /**
     * @default 'Gifts'
     */
    giftLabelPlural: T;

    /**
     * @default 'Tracking Info requested from guest'
     */
    trackingInfoRequested: T;

    /**
     * @default 'Reserved'
     */
    reserved: T;

    /**
     * @default 'Purchased'
     */
    purchased: T;

    /**
     * @default 'Partially Shipped'
     */
    partiallyFulfilled: T;

    /**
     * @default 'Partially Delivered'
     */
    partiallyDelivered: T;

    /**
     * @default 'Credit Issued'
     */
    creditIssued: T;

    /**
     * @default 'Unavailable: Credit Issued'
     */
    unavailableCreditIssued: T;

    /**
     * @default 'Copy Promo Code'
     */
    copyPromoCode: T;

    /**
     * @default '✨  Copied!  ✨'
     */
    copyPromoCodeTooltip: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Tracking'
     */
    tracking: T;

    /**
     * @default 'Given'
     */
    given: T;

    /**
     * @default 'Processing'
     */
    draft: T;

    /**
     * @default 'Shipped'
     */
    shipping: T;

    /**
     * @default 'Ready to Ship'
     */
    readyToFulfill: T;

    /**
     * @default 'Processing'
     */
    fulFillmentStarted: T;

    /**
     * @default 'Needs Action'
     */
    failed: T;

    /**
     * @default 'Delivered'
     */
    delivered: T;

    /**
     * @default 'Processing'
     */
    processing: T;

    /**
     * @default 'Needs Action'
     */
    pendingRefundAction: T;

    /**
     * @default 'Ship Now'
     */
    shipNow: T;

    /**
     * @default 'Status'
     */
    statusColumn: T;

    /**
     * @default 'Cash Received'
     */
    cashReceived: T;

    /**
     * @default 'Resolve Issue'
     */
    resolveIssue: T;

    /**
     * @default 'Manage {{count}} unresolved issues.'
     */
    manageUnresolvedIssues: T;

    /**
     * @default 'Swapped for cash'
     */
    swappedForCash: T;

    /**
     * @default 'Refunded Guest'
     */
    guestRefunded: T;

    /**
     * @default 'Exchanged for cash'
     */
    swappedForCashOrderLabel: T;

    /**
     * @default 'Guest Refund Issued'
     */
    guestRefundedOrderLabel: T;

    /**
     * @default 'Out For Delivery'
     */
    outForDelivery: T;

    /**
     * @default 'Canceled'
     */
    canceled: T;

    /**
     * @default 'Processing'
     */
    notReady: T;

    /**
     * @default 'Given by'
     */
    givenBy: T;

    /**
     * @default 'Total'
     */
    total: T;
  };
  joyCreditWidget: {
    /**
     * @default 'Learn more about Joy Credit'
     */
    learnMore: T;

    /**
     * @default 'Joy Credit'
     */
    title: T;

    /**
     * @default 'Available for Purchases'
     */
    subtitle: T;

    /**
     * @default 'Copy Promo Code'
     */
    copyPromoCode: T;

    /**
     * @default '✨  Copied!  ✨'
     */
    copyPromoCodeTooltip: T;

    /**
     * @default 'Promo Code'
     */
    promoCode: T;
  };
  refundDialog: {
    /**
     * @default 'Action needed'
     */
    header: T;

    /**
     * @default 'We’re unable to fulfill your order.'
     */
    title: T;

    /**
     * @default 'We can give you cash or refund your guest.'
     */
    subTitle: T;

    /**
     * @default 'Convert {{amount}} to Cash'
     */
    swapAmountForCash: T;

    /**
     * @default 'We won’t tell your guests you swapped the physical gift for cash. A Stripe account is required for this option.'
     */
    swapForCashDesc: T;

    /**
     * @default 'Refund {{amount}} to Guest'
     */
    refundAmount: T;

    /**
     * @default 'Your gift’s status will be reverted back to “Available” and your guest will receive an email notifying them of the refund. Refunds usually takes 3-5 business days.'
     */
    refundDesc: T;

    /**
     * @default 'Learn More'
     */
    learnMore: T;

    /**
     * @default 'Use Stripe to enable credit card payments and transfer cash to your bank account or debit card.'
     */
    stripeInfo: T;

    /**
     * @default 'Stripe needs more information.'
     */
    stripeInfoError: T;

    /**
     * @default 'Credit card payment enabled.'
     */
    stripeInfoReady: T;

    /**
     * @default 'Cancel'
     */
    cancelCta: T;

    /**
     * @default 'Confirm'
     */
    confirmCta: T;

    /**
     * @default 'Close'
     */
    close: T;

    /**
     * @default '{{amount}} will be refunded to your guest.'
     */
    refundHandledTitle: T;

    /**
     * @default 'Your guest will receive an email notifying them of the refund. Refunds usually takes 3-5 business days. Your gift’s status will be reverted back to Available.'
     */
    refundHandledSubtitle: T;

    /**
     * @default '{{amount}} has been added to your Joy Wallet.'
     */
    sg4cHandledTitle: T;

    /**
     * @default 'You’ve chosen to swap the gift for cash. Your gift’s status will be reverted back to Available.'
     */
    sg4cHandledSubtitle: T;
  };
  giftTrackerDialog: {
    /**
     * @default 'Returning a gift?'
     */
    returnDialogTitle: T;

    /**
     * @default 'customer support'
     */
    dialogEdeliveryLine2Contact: T;

    /**
     * @default 'Returns for this product are handled directly by the store it was purchased from.'
     */
    returnDialogLine1: T;

    /**
     * @default 'This gift was given by {{guestName}} and purchased at {{retailer}}.'
     */
    returnDialogLine2: T;

    /**
     * @default 'Got It'
     */
    buttonText: T;

    /**
     * @default 'Quantity {{qty}}'
     */
    quantityTitle: T;

    /**
     * @default 'If unredeemed, this experience can be returned for a merchandise credit.'
     */
    spurText: T;

    /**
     * @default 'Request a refund for this gift or exchange within 90 days of purchase or event date.'
     */
    dropshipText: T;

    /**
     * @default 'Gift cards and eGift cards are non-refundable.'
     */
    eDeliveryText: T;

    /**
     * @default 'See Details'
     */
    linkText: T;

    /**
     * @default 'Credit Card for Cash and Get Cash Equivalent purchases are non-refundable.'
     */
    gceText: T;
  };
  giftTrackerEDeliveryDialog: {
    /**
     * @default 'Where is my gift?'
     */
    dialogTitle: T;

    /**
     * @default 'This item is scheduled for eDelivery to your email.'
     */
    dialogEdeliveryLine1: T;

    /**
     * @default 'If you have not received your gift via email after 1 -2 days Please contact <customerLink/>'
     */
    dialogEdeliveryLine2: T;

    /**
     * @default 'customer support'
     */
    dialogEdeliveryLine2Contact: T;

    /**
     * @default 'Ok'
     */
    buttonText: T;
  };
  giftTrackerZeroState: {
    /**
     * @default 'Gifts you’ve received and thank you notes sent will appear here.'
     */
    title: T;
  };
  currency: {
    /**
     * @default 'Registry Currency'
     */
    currencyDialogTitle: T;

    /**
     * @default 'Select the currency displayed on your registry.'
     */
    currencyDialogSubtitle: T;

    /**
     * @default 'We will use this currency symbol for any gift that isn’t added from the Joy Shop or synced from an external registry.'
     */
    currencyDialogSecondarySubtitle: T;

    /**
     * @default 'If you have an existing cash fund with contributions, the currency for that gift will not be changed.'
     */
    currencyDialogThirdSubtitle: T;

    /**
     * @default 'Save'
     */
    currencyDialogActionButton: T;

    /**
     * @default 'Cancel'
     */
    currencyDialogSecondaryButton: T;
  };
  hideShowDialog: {
    /**
     * @default 'Are you sure you want to {{status}} this gift?'
     */
    title: T;

    /**
     * @default 'This will allow guests to see it in your registry.'
     */
    showTitle: T;

    /**
     * @default 'This will prevent anyone from seeing this gift on your registry. You can still view any reservations for this gift in the Tracking tab.'
     */
    hideTitle: T;

    /**
     * @default 'Please note that you may still receive the gift if a guest has already purchased it.'
     */
    hideSubtitle: T;

    /**
     * @default 'Cancel'
     */
    cancelButton: T;

    /**
     * @default 'Yes, Show on Registry'
     */
    showButton: T;

    /**
     * @default 'Hide Gift'
     */
    hideButton: T;
  };
  quickAdd: {
    /**
     * @default 'Use the Joy Quick Add Button to add items from any store.'
     */
    title: T;

    /**
     * @default 'Just drag the button below to your<lineBreak/>Bookmarks Bar to get started.'
     */
    subtitle: T;

    /**
     * @default 'Add to Joy'
     */
    addButton: T;

    /**
     * @default 'Verify your Bookmarks Bar is visible.'
     */
    step1: T;

    /**
     * @default 'View'
     */
    viewChrome: T;

    /**
     * @default 'View > Toolbars > Bookmarks Toolbar'
     */
    viewFirefox: T;

    /**
     * @default 'Always Show Bookmarks Bar'
     */
    bookmarksChrome: T;

    /**
     * @default 'Always Show'
     */
    bookmarksFirefox: T;

    /**
     * @default 'In <browser/>’s menu, go to <view/> and make sure there’s a checkmark next to <bookmarks/>.'
     */
    step1Description: T;

    /**
     * @default 'Click and drag the Joy Quick Add Button to your Bookmarks Bar, found above this page.'
     */
    step2: T;

    /**
     * @default 'Now try it out! Visit any store you love, find a gift you want, and then click the Joy Quick Add Button.'
     */
    step3: T;

    /**
     * @default 'We’re still working on the Joy Quick Add Button for Safari, but in the meantime, you can add the button in <chromeLink/> or <firefoxLink/> instead.'
     */
    stepSafari: T;

    /**
     * @default 'You can also get the “Add to Joy” Button for <link/>.'
     */
    footer: T;

    emptyCatalogState: {
      /**
       * @default 'Add Gifts from Anywhere!'
       */
      title: T;

      /**
       * @default 'Just drag the this Joy Quick Add button to your browser bookmark bar in the header and add gifts from anywhere.'
       */
      subtitle: T;

      /**
       * @default 'Add to Joy'
       */
      addButton: T;

      /**
       * @default 'Show me how it works'
       */
      showMeLink: T;
    };
  };
  transferRegistryDialog: {
    screens: {
      selectRegistry: {
        /**
         * @default 'Welcome to Your Universal Registry'
         */
        subTitle: T;

        /**
         * @default 'Select the registry you’d like to connect'
         */
        title: T;

        ukCambium: {
          /**
           * @default 'We've partnered with the best gift lists in the United Kingdom.'
           */
          title: T;

          /**
           * @default 'Where would you like to start?'
           */
          subTitle: T;
        };

        /**
         * @default 'Other Registries'
         */
        allStoresHeader: T;

        /**
         * @default 'Connect a different registry…'
         */
        showAllStores: T;
      };
      createExternalRegistryLink: {
        /**
         * @default 'Let’s get your gift list started'
         */
        title: T;

        /**
         * @default 'You can start a new list or connect an existing list.'
         */
        subTitle: T;

        /**
         * @default 'Back'
         */
        backButton: T;

        /**
         * @default 'Create New Gift List'
         */
        createNewButton: T;

        /**
         * @default 'Connect Existing Gift List'
         */
        transferExistingButton: T;
      };
      enterLink: {
        title: {
          /**
           * @default 'Let’s connect to {{registry}}'
           */
          transfer: T;

          /**
           * @default 'Let’s connect to {{registry}}'
           */
          sync: T;

          /**
           * @default 'Let’s connect to {{registry}}'
           */
          linkToStore: T;

          /**
           * @default 'Let’s connect your registries in one place'
           */
          link: T;
        };
        subTitle: {
          /**
           * @default 'Add your registry link below. After we’ve found your registry, you’ll choose whether to make a one-time copy of your gifts into Joy or sync daily.'
           */
          transfer: T;

          /**
           * @default 'Add your registry link below and we’ll get started.'
           */
          sync: T;

          /**
           * @default 'Add your registry link below and we’ll get started.'
           */
          link: T;
        };
        errors: {
          /**
           * @default 'Please enter a valid registry link.'
           */
          invalidDomain: T;

          /**
           * @default '{{brandName}} registry link should include {{hostname}}.'
           */
          invalidBrandUrl: T;

          /**
           * @default 'Please enter a registry link.'
           */
          required: T;

          /**
           * @default 'This registry can be synced or transferred. Please choose your registry accordingly.'
           */
          canSyncOrTransfer: T;

          /**
           * @default 'Hmm... we can’t find your registry. Check your URL or make sure your registry is set to “Public.”'
           */
          genericError: T;
        };

        /**
         * @default 'Learn More'
         */
        learnButton: T;

        /**
         * @default 'Get Started'
         */
        startButton: T;

        /**
         * @default 'Next'
         */
        next: T;

        /**
         * @default 'Connect Registry'
         */
        connectButton: T;

        /**
         * @default 'Back'
         */
        backButton: T;

        /**
         * @default 'Make sure the registry you’re connecting is set to "Public".'
         */
        makeSureRegistryIsPublic: T;
      };
      linkAdded: {
        /**
         * @default 'Awesome. We’ve added a link on your Joy registry so gift givers will easily find it.'
         */
        title: T;

        /**
         * @default 'Add Another Registry'
         */
        addButton: T;

        /**
         * @default 'View My Registry'
         */
        viewRegistry: T;

        /**
         * @default 'Learn about other ways to add gifts'
         */
        learnPhrase: T;
      };
      registryFound: {
        /**
         * @default 'Registry Found'
         */
        title: T;

        /**
         * @default '{{coupleName}}'s Registry'
         */
        coupleSubtitle: T;

        /**
         * @default 'Now let’s import and supercharge it with Joy.'
         */
        newTitle: T;

        /**
         * @default 'We found your registry at {{brandName}}'
         */
        subtitle: T;

        /**
         * @default 'Move Registry to Joy'
         */
        moveButton: T;

        /**
         * @default 'No thanks, I’d like to continue adding gifts through {{brandName}}'
         */
        syncInsteadButton: T;

        /**
         * @default 'No thanks, just display a link to {{brandName}}.'
         */
        linkInsteadButton: T;

        /**
         * @default 'How does this work?'
         */
        howButton: T;

        /**
         * @default 'Sync Registry'
         */
        syncButton: T;

        /**
         * @default 'Learn more about syncing'
         */
        learnAboutSyncButton: T;

        /**
         * @default 'Back'
         */
        backButton: T;

        /**
         * @default 'Add gifts from ANY store, not just {{brandName}}.'
         */
        addGiftsFromAnyStore: T;

        /**
         * @default 'We’ll hold your packages during your honeymoon!'
         */
        holdPackagesDuringHoneymoon: T;

        /**
         * @default 'Shop right on your website (no annoying link-outs).'
         */
        shopOnWebsite: T;

        /**
         * @default 'Zero-fee cash funds help you reach your goals faster.'
         */
        zeroFeeCashFunds: T;

        /**
         * @default 'Price match promise guarantees you and your guests get the best price.'
         */
        priceMatchPromise: T;

        /**
         * @default 'It’s easy to be grateful with automagic thank you cards.'
         */
        automagicThankYouCards: T;
      };
      gettingGifts: {
        /**
         * @default 'We’re getting your gifts from {{registry}}'
         */
        title: T;

        /**
         * @default 'In the meantime, feel free to explore Registry. Refresh your Manage Gifts page shortly to see your gifts.'
         */
        subTitle: T;

        /**
         * @default 'You’ll begin seeing your gifts in the next few minutes, and we’ll update changes, pricing, and availability once daily.'
         */
        subTitleVariant: T;

        /**
         * @default 'Connect Another Registry'
         */
        addAnotherButton: T;

        /**
         * @default 'Learn about other ways to add gifts'
         */
        learnAboutButton: T;

        /**
         * @default 'Done'
         */
        done: T;
      };
      gettingGiftsForSync: {
        /**
         * @default 'We’re getting your gifts from {{registry}}'
         */
        title: T;

        /**
         * @default 'This could take up to a few minutes. Refresh your Manage page shortly to see your synced gifts. If you have another registry to add, you can do that now.'
         */
        subTitle: T;

        /**
         * @default 'Add Another Registry'
         */
        addAnotherButton: T;

        /**
         * @default 'Learn about other ways to add gifts'
         */
        learnAboutButton: T;
      };
      linkInstead: {
        /**
         * @default 'Great! Before we link your registry, some things to keep in mind:'
         */
        title: T;

        /**
         * @default 'Guests will have to leave your website to purchase gifts.'
         */
        listItem1: T;

        /**
         * @default 'You won’t have control over when your packages arrive on your doorstep.'
         */
        listItem2: T;

        /**
         * @default 'Gifts outside of Joy aren’t eligible for Joy’s AI-assisted thank you cards.'
         */
        listItem3: T;

        /**
         * @default 'I understand and I still want to link this Registry.'
         */
        checkboxLabel: T;

        /**
         * @default 'Nevermind, transfer gifts to Joy'
         */
        transferButton: T;

        /**
         * @default 'Continue Without Transferring'
         */
        linkButton: T;

        /**
         * @default 'Learn about other ways to add gifts'
         */
        learnAboutButton: T;
      };
      gettingGiftsForTransfer: {
        /**
         * @default 'We’re bringing your {{registry}} gifts into Joy'
         */
        title: T;

        /**
         * @default 'one-time copy'
         */
        boldSubtitle: T;

        /**
     * @default 'In a few minutes, this <bold/> will be complete.

🎁 If you plan to add more items from {{registry}} or other stores, you’ll need to use the Quick Add Button.

💡 Once your gifts are copied, we also recommend turning your registry to private to avoid potential duplicate gifts.'
*/
        subTitle: T;

        /**
         * @default 'Next'
         */
        nextButton: T;
      };
      reminderShippingAddressForTransfer: {
        /**
         * @default 'Back'
         */
        backButton: T;

        /**
         * @default 'Now let’s add your shipping address'
         */
        title: T;

        /**
         * @default 'Avoid missing packages and awkward texts! We’ll make sure gift givers know where to send your gifts.'
         */
        body: T;

        /**
         * @default 'Add Shipping Address'
         */
        addButton: T;

        /**
         * @default 'I’ll Do It Later'
         */
        laterButton: T;
      };
      syncInstead: {
        /**
         * @default 'Sync this registry instead'
         */
        title: T;

        /**
         * @default 'While we recommend moving your registry to Joy so you can <strong>do everything in one place</strong>, syncing is another option if you want to continue using your {{retailer}} registry.'
         */
        subTitle: T;

        /**
         * @default 'Move to Joy'
         */
        moveToJoy: T;

        /**
         * @default 'Syncing'
         */
        syncing: T;

        /**
         * @default 'Adding Gifts'
         */
        addingGifts: T;

        /**
         * @default 'Tracking Gifts'
         */
        trackingGifts: T;

        /**
         * @default 'Buying Gifts'
         */
        buyingGifts: T;

        /**
         * @default 'Completion Discount'
         */
        completionDiscount: T;

        /**
         * @default 'Add and update items in Joy, not {{retailer}}, changes reflect instantly'
         */
        addingTransfer: T;

        /**
         * @default 'Add and update items in {{retailer}}, they’ll sync daily'
         */
        addingSyncing: T;

        /**
         * @default 'Manage and track your gifts, across all stores, in Joy'
         */
        trackingTransfer: T;

        /**
         * @default 'Manage and track registries one-by-one on each site'
         */
        trackingSyncing: T;

        /**
         * @default 'Guests can buy their gifts on {{retailer}} or Joy'
         */
        buyingTransfer: T;

        /**
         * @default 'Guests are taken to your {{retailer}} registry to purchase'
         */
        buyingSyncing: T;

        /**
         * @default 'Get access to Joy’s completion discount on Joy gifts in addition to a completion discount from {{retailer}}'
         */
        completionDiscountTransfer: T;

        /**
     * @default 'Get access to Joy's completion discount on Joy gifts.

Note: With guests purchasing gifts off of your Joy registry instead of your {{retailer}} registry, you are not likely to qualify for {{retailer}}'s completion discount, which requires $500 to be bought off of the original {{retailer}} registry.'
*/
        noCompletionDiscountTransfer: T;

        /**
         * @default 'Receive a completion discount from {{retailer}}'
         */
        completionDiscountSyncing: T;

        /**
         * @default 'Go Back'
         */
        backButton: T;

        /**
         * @default 'Sync Registry'
         */
        syncRegistryButton: T;
      };
      seamlessCheckout: {
        /**
         * @default 'Seamless Checkout'
         */
        title: T;

        /**
         * @default 'Simplify your guests checkout experience for eligible gifts.'
         */
        subTitle: T;

        /**
         * @default 'Seamless Checkout is On'
         */
        seamlessCheckoutOn: T;

        /**
         * @default 'Seamless Checkout is Off'
         */
        seamlessCheckoutOff: T;

        /**
         * @default 'Go Back'
         */
        backButton: T;

        /**
         * @default 'Next'
         */
        nextButton: T;

        /**
         * @default 'With Seamless Checkout:'
         */
        withSeamelessCheckout: T;

        /**
         * @default 'Without Seamless Checkout:'
         */
        withoutSeamlessCheckout: T;

        /**
         * @default 'Still have questions?'
         */
        stillHaveQuestions: T;

        /**
         * @default 'Learn more'
         */
        learnMore: T;

        seamlessCheckoutValueProps: {
          /**
           * @default 'Your guests will check out easily without leaving your website.'
           */
          guestsCheckoutEasily: T;

          /**
           * @default 'Guests won’t need to know your address, confirm purchase, or give you their purchase details.'
           */
          guestsNoAddressNeeded: T;

          /**
           * @default 'Gifts are tracked on Joy.'
           */
          giftsTrackedOnJoy: T;

          /**
           * @default 'Hassle-free returns with Joy.'
           */
          hassleFreeReturns: T;

          /**
           * @default '24/7 order support from Joy.'
           */
          orderSupport24_7: T;
        };
        risks: {
          /**
           * @default 'Your guests will leave your Joy website to complete purchase.'
           */
          guestsLeaveSite: T;

          /**
           * @default 'Guests will have to come back to your Joy website to add their purchase details.'
           */
          guestsReturnToAddDetails: T;

          /**
           * @default 'You are more likely to receive duplicate gifts.'
           */
          moreDuplicateGifts: T;

          /**
           * @default 'You’ll work with your retailer for customer support and returns.'
           */
          retailerSupportAndReturns: T;
        };

        /**
         * @default 'Don’t Optimize Checkout'
         */
        dontOptimize: T;

        /**
         * @default 'Enable Seamless Checkout'
         */
        enableSeamless: T;
      };
      quickAdd: {
        /**
         * @default 'Back'
         */
        backButton: T;

        step1: {
          /**
           * @default 'Shop on {{retailer}} and any other store with the Joy Quick Add Button'
           */
          title: T;

          /**
           * @default 'Add items from anywhere with the Joy Quick Add Button'
           */
          linkedTitle: T;

          /**
           * @default 'Install it today to keep shopping with a simple click.'
           */
          subTitle: T;

          /**
           * @default 'Learn More'
           */
          learnMoreLink: T;

          /**
           * @default 'I’ll Do It Later'
           */
          laterButton: T;

          /**
           * @default 'Get the Button'
           */
          getButton: T;
        };
        step2: {
          /**
           * @default 'Install the Joy Quick Add Button in Chrome/Firefox'
           */
          title: T;

          /**
           * @default 'Just drag the button below to your browser’s bookmark bar.'
           */
          subTitle: T;

          /**
           * @default 'Add to Joy'
           */
          browserButton: T;

          /**
           * @default 'I’ve Installed It'
           */
          doneButton: T;

          /**
           * @default 'Need Help? Read our'
           */
          help: T;

          /**
           * @default 'step-by-step guide'
           */
          helpLink: T;
        };
      };
      joyApp: {
        /**
         * @default 'Add & track gifts on the go'
         */
        title: T;

        /**
         * @default 'Download the Joy App to shop, edit, and manage your registry all from your phone.'
         */
        subTitle: T;

        /**
         * @default 'Get the App'
         */
        downloadButton: T;

        /**
         * @default 'View My Registry'
         */
        viewRegistryButton: T;

        /**
         * @default 'Download the Joy Mobile App'
         */
        qrCodeAltText: T;

        /**
         * @default 'Add Gifts'
         */
        addGiftsAltText: T;

        /**
         * @default 'Back'
         */
        backButton: T;
      };
    };
  };
  confirmRegistryNotification: {
    /**
     * @default 'No, Contact Support'
     */
    contactSupport: T;

    /**
     * @default 'Yes'
     */
    yes: T;

    /**
     * @default 'Do your gifts from {{storeName}} look correct?'
     */
    looksCorrect: T;

    /**
     * @default 'We’ve copied your gifts from {{storeName}}. Make sure everything looks good.'
     */
    confirmRegistry: T;

    /**
     * @default 'Review Gifts'
     */
    reviewGifts: T;

    /**
     * @default 'Maybe Later'
     */
    maybeLater: T;
  };
  sidebar: {
    greeting: {
      /**
       * @default 'Happy {{dayOfWeek}}!'
       */
      dailyMessage: T;

      /**
       * @default '{{count}} day to go 🎉'
       * @param {number} count - The number of occurrences.
       * - singular: {{count}} day to go 🎉
       * - plural: {{count}} days to go 🎉
       */
      countdownToWedding: T;

      /**
       * @default '{{count}} days ago ️💘'
       */
      countdownPostWedding: T;

      /**
       * @default 'Today’s the big day! 🥂'
       */
      weddingDay: T;
    };
    counters: {
      /**
       * @default 'Gifts Available'
       */
      giftsAddedLabel: T;

      /**
       * @default 'Reserved & Purchased'
       */
      reservedLabel: T;
    };
    quickActions: {
      /**
       * @default 'Close'
       */
      mobileToggleButtonOn: T;

      /**
       * @default 'Quick Actions'
       */
      mobileToggleButtonOff: T;

      /**
       * @default 'Your registry is hidden'
       */
      visibilityPrivate: T;

      /**
       * @default 'Your registry is visible'
       */
      visibilityPublic: T;

      /**
       * @default 'Registry is hidden'
       */
      visibilityOptionHidden: T;

      /**
       * @default 'Registry is visible'
       */
      visibilityOptionPublic: T;

      /**
       * @default 'Registry is password protected'
       */
      visibilityOptionPasswordProtected: T;

      /**
       * @default 'Change Privacy'
       */
      changeVisibility: T;

      /**
       * @default 'Add Shipping Address'
       */
      addShippingAddress: T;

      /**
       * @default 'Edit Shipping Address'
       */
      editShippingAddress: T;

      /**
       * @default 'Set Currency'
       */
      setCurrency: T;

      /**
       * @default 'View as Guest'
       */
      viewAsGuest: T;

      /**
       * @default 'Preview Registry'
       */
      previewRegistry: T;

      /**
       * @default 'Copy Registry Link'
       */
      copyGuestsiteUrl: T;

      /**
       * @default 'Get the Quick Add Button'
       */
      getBrowserButton: T;

      /**
       * @default 'Connect a Registry'
       */
      linkAnotherRegistry: T;

      /**
       * @default 'Download the App'
       */
      downloadApp: T;

      /**
       * @default 'Registry Completion Discount'
       */
      postWeddingDiscount: T;

      /**
       * @default '✨ Link Copied ✨'
       */
      linkCopied: T;

      /**
       * @default 'Share it with gift givers so they can shop in one place!'
       */
      linkCopiedMessage: T;

      /**
       * @default 'Edit Welcome Note'
       */
      editNote: T;

      /**
       * @default 'External Registries'
       */
      externalRegistries: T;

      /**
       * @default 'Registry Settings'
       */
      registrySettings: T;

      /**
       * @default 'Registry URL'
       */
      registrySettingsNonStandalone: T;

      /**
       * @default 'Invite a Collaborator'
       */
      inviteCollaborator: T;
    };
  };
  shippingAddressWarningBanner: {
    /**
     * @default 'Your shipping address is missing'
     */
    emptyAddressMessage: T;

    /**
     * @default 'It looks like your shipping address is invalid.'
     */
    noValidatedAddressMessage: T;

    /**
     * @default 'Update it so guests can send you your gifts'
     */
    noValidatedAddressSubTextMessage: T;

    /**
     * @default 'Add it so guests can send you your gifts!'
     */
    addressSubTextMessage: T;

    /**
     * @default 'Add Address'
     */
    buttonText: T;
  };
  completionDiscountBanner: {
    /**
     * @default 'Registry Completion Discount'
     */
    title: T;

    /**
     * @default 'Get 20% off on all the gifts your guests didn't buy.'
     */
    subTitle: T;

    /**
     * @default 'View Discount'
     */
    button: T;
  };
  quickAddButtonBanner: {
    /**
     * @default 'Add anything from anywhere. Like, literally.'
     */
    title: T;

    /**
     * @default 'Install Quick Add Button'
     */
    button: T;
  };
  completionDiscountCountdown: {
    /**
     * @default 'Register now, save later.'
     */
    registerMessage: T;

    /**
     * @default 'Now Available'
     */
    nowAvailableMessage: T;

    /**
     * @default 'Registry Completion Discount'
     */
    discountMessage: T;

    /**
     * @default 'Available in {{days}} days'
     */
    availableMessage: T;

    /**
     * @default 'Save 20% on all remaining items on your registry.'
     */
    saveMessage: T;

    /**
     * @default 'Shop Now'
     */
    shopButton: T;

    /**
     * @default 'Add More Gifts'
     */
    addMoreButton: T;

    /**
     * @default 'Discounts available for gifts added before your event date. 
Gifts added after won’t qualify. U.S Shipping Only. 
<learnMoreLink/>'
*/
    learnMoreMessage: T;

    /**
     * @default 'Learn more'
     */
    learnMoreCta: T;

    congratulationsMessage: {
      /**
       * @default 'Congratulations on your wedding! As our gift to you, we’d like to help you purchase any of the remaining gifts in your registry with a 20% discount.'
       */
      wedding: T;

      /**
       * @default 'Congratulations on your wedding! As our gift to you, we’d like to help you purchase any of the remaining gifts in your registry with a 20% discount.'
       */
      babyRegistry: T;

      /**
       * @default 'Congratulations! As our gift to you, we’d like to help you purchase any of the remaining gifts in your registry with a 20% discount.'
       */
      general: T;
    };

    /**
     * @default 'Expires in {{days}} days'
     */
    expiresInMessage: T;

    /**
     * @default 'Discounts available for gifts added before your event date. Gifts added after won’t qualify. U.S Shipping Only. Offer valid only until {{timestamp}}. <learnMoreLink/>'
     */
    availabilityMessage: T;
  };
  discountGiftList: {
    /**
     * @default 'Total Savings {{total}}'
     */
    totalSavings: T;

    /**
     * @default 'Sorry, it looks like none of your gifts currently qualify for the discount! <learnMoreLink/>'
     */
    emptyStateMessage: T;

    /**
     * @default 'Learn more'
     */
    learnMoreCta: T;
  };
  discountGift: {
    /**
     * @default 'Save {{discount}}'
     */
    save: T;

    /**
     * @default 'Buy Now'
     */
    buyNowCta: T;
  };
  externalRegistries: {
    /**
     * @default 'Already registered somewhere else? Connect it to Joy to make your registry a success.'
     */
    emptyListMessage: T;

    /**
     * @default 'Learn More'
     */
    emptyListLink: T;

    /**
     * @default 'New Gifts'
     */
    newGifts: T;

    /**
     * @default 'Update All'
     */
    updateAll: T;

    /**
     * @default 'Connect Registry'
     */
    connectRegistry: T;

    /**
     * @default 'and {{count}} More...'
     */
    andMore: T;

    /**
     * @default 'External Registries'
     */
    externalRegistries: T;
  };
  externalRegistriesManage: {
    /**
     * @default 'Connect Registry'
     */
    connectRegistry: T;

    /**
     * @default 'and {{count}} More...'
     */
    andMore: T;

    /**
     * @default 'External Registries'
     */
    externalRegistries: T;

    /**
     * @default 'Manage'
     */
    manage: T;
  };
  eventPreview: {
    /**
     * @default 'Edit Photo & Note'
     */
    showMore: T;
  };
  paidAds: {
    /**
     * @default 'Shop Top Brands'
     */
    brandCarouselTitle: T;

    /**
     * @default 'Shop All Brands'
     */
    brandCarouselLink: T;

    /**
     * @default 'Sponsored'
     */
    sponsored: T;

    /**
     * @default 'Shop Now'
     */
    shopNow: T;
  };
  favoriteRetailer: {
    /**
     * @default '👋 Hey, we’re trying to build the best universal registry! Help us by picking your favorite retailers.'
     */
    bannerMessage: T;

    /**
     * @default 'Choose Now'
     */
    bannerButtonLabel: T;

    /**
     * @default 'Add gifts from Amazon, Crate, or anywhere with our <link/>:'
     */
    universalSearchMessage: T;

    /**
     * @default 'Shop your favorite stores and easily add items using our <link/> button:'
     */
    quickAddMessage: T;

    /**
     * @default '<link/> your other registries to Joy with a simple link:'
     */
    connectRegistryMessage: T;

    /**
     * @default 'Shop from anywhere with our mobile app:'
     */
    mobileAppMessage: T;

    /**
     * @default 'Available in the <appStoreLink/> and <playStoreLink/>'
     */
    mobileAppDownloadMessage: T;

    /**
     * @default 'Universal Search'
     */
    universalSearchLabel: T;

    /**
     * @default 'Quick Add'
     */
    quickAddLabel: T;

    /**
     * @default 'Connect'
     */
    connectLabel: T;

    /**
     * @default 'Add to Joy'
     */
    quickAddButtonLabel: T;

    /**
     * @default 'Available on Chrome and Firefox'
     */
    quickAddAvailabilityMessage: T;

    /**
     * @default 'Drag this button to your bookmarks bar.'
     */
    quickAddDragMessage: T;

    /**
     * @default 'Fantastic! You can have them all with Joy.'
     */
    universalMessageDialogTitle: T;

    /**
     * @default 'Get more gifts with less stress when you keep them all in one place.'
     */
    universalMessageDialogSubTitle: T;

    /**
     * @default 'Select the retailers you’d consider building a registry with:'
     */
    selectFavoriteRetailerDialogTitle: T;

    /**
     * @default 'Next'
     */
    nextButtonLabel: T;

    /**
     * @default 'App Store'
     */
    appStore: T;

    /**
     * @default 'Google Play'
     */
    playStore: T;
  };
  paperThankYouBanner: {
    /**
     * @default 'Show your gratitude with paper thank you cards.'
     */
    title: T;

    /**
     * @default 'Choose from a variety of customizable art and photo cards, or upload your own design, to share your heartfelt thanks.'
     */
    subTitle: T;

    /**
     * @default 'Browse Thank Yous'
     */
    button: T;
  };
  deleteConfirmationModal: {
    /**
     * @default 'Are you sure you want to delete this gift?'
     */
    title: T;

    /**
     * @default 'This item will be permanently deleted from your registry.'
     */
    description: T;

    /**
     * @default 'Remove from Registry'
     */
    primaryButtonText: T;

    /**
     * @default 'Don’t Remove'
     */
    secondaryButtonText: T;
  };
  departmentFooter: {
    /**
     * @default 'Shipping'
     */
    shipping: T;

    /**
     * @default 'Returns'
     */
    returns: T;

    /**
     * @default 'Terms & Privacy'
     */
    termsAndPrivacy: T;

    /**
     * @default 'Support'
     */
    support: T;
  };
  quick: {
    /**
     * @default 'Add anything from anywhere. Like, literally.'
     */
    tsRNh: T;

    /**
     * @default 'Install Quick Add Button'
     */
    '1YzpB': T;
  };
};

export type TranslationsByNamespace<T extends LeafNodeValue = TranslateFunction> = {
  accommodationsAdmin: AccommodationsAdminTranslations<T>;
  accommodationsConsole: AccommodationsConsoleTranslations<T>;
  accommodationsGuest: AccommodationsGuestTranslations<T>;
  account: AccountTranslations<T>;
  actionBar: ActionBarTranslations<T>;
  addFromFriendsRegistry: AddFromFriendsRegistryTranslations<T>;
  addGiftFromStoresPopup: AddGiftFromStoresPopupTranslations<T>;
  addToCalendar: AddToCalendarTranslations<T>;
  adminDashboard: AdminDashboardTranslations<T>;
  adminDashboardV2: AdminDashboardV2Translations<T>;
  adminDashboardV3: AdminDashboardV3Translations<T>;
  aiReviewTextarea: AiReviewTextareaTranslations<T>;
  artUpload: ArtUploadTranslations<T>;
  autoPopulation: AutoPopulationTranslations<T>;
  bnpl: BnplTranslations<T>;
  bookmarklet: BookmarkletTranslations<T>;
  cashFunds: CashFundsTranslations<T>;
  catalogRegistry: CatalogRegistryTranslations<T>;
  checklist: ChecklistTranslations<T>;
  collaboration: CollaborationTranslations<T>;
  colors: ColorsTranslations<T>;
  companyPolicies: CompanyPoliciesTranslations<T>;
  contactCollector: ContactCollectorTranslations<T>;
  countries: CountriesTranslations<T>;
  createBabyRegistry: CreateBabyRegistryTranslations<T>;
  createEvent: CreateEventTranslations<T>;
  createGeneral: CreateGeneralTranslations<T>;
  createRegistry: CreateRegistryTranslations<T>;
  createWedding: CreateWeddingTranslations<T>;
  curationsRegistry: CurationsRegistryTranslations<T>;
  currencies: CurrenciesTranslations<T>;
  customDomain: CustomDomainTranslations<T>;
  dates: DatesTranslations<T>;
  discountedRates: DiscountedRatesTranslations<T>;
  emailPreferences: EmailPreferencesTranslations<T>;
  emailsAndEcards: EmailsAndEcardsTranslations<T>;
  errors: ErrorsTranslations<T>;
  eventCountdown: EventCountdownTranslations<T>;
  eventCountdownCustomComponent: EventCountdownCustomComponentTranslations<T>;
  eventDetailsCustomComponent: EventDetailsCustomComponentTranslations<T>;
  eventFormDisplay: EventFormDisplayTranslations<T>;
  eventMenu: EventMenuTranslations<T>;
  eventPhotoPicker: EventPhotoPickerTranslations<T>;
  eventRedirect: EventRedirectTranslations<T>;
  eventServiceCenter: EventServiceCenterTranslations<T>;
  eventSite: EventSiteTranslations<T>;
  eventSiteApps: EventSiteAppsTranslations<T>;
  eventWorkspace: EventWorkspaceTranslations<T>;
  exampleConfigUsage: ExampleConfigUsageTranslations<T>;
  faqCustomComponent: FaqCustomComponentTranslations<T>;
  focusPoint: FocusPointTranslations<T>;
  form: FormTranslations<T>;
  formCustomComponent: FormCustomComponentTranslations<T>;
  generalEventSchedule: GeneralEventScheduleTranslations<T>;
  generalEventScheduleEditor: GeneralEventScheduleEditorTranslations<T>;
  generalFormValidation: GeneralFormValidationTranslations<T>;
  graphicAccentCustomComponent: GraphicAccentCustomComponentTranslations<T>;
  guestGuide: GuestGuideTranslations<T>;
  guestKit: GuestKitTranslations<T>;
  guestList: GuestListTranslations<T>;
  guestRegistry: GuestRegistryTranslations<T>;
  guestSiteCustom: GuestSiteCustomTranslations<T>;
  guestSiteTravel: GuestSiteTravelTranslations<T>;
  guestSiteWelcome: GuestSiteWelcomeTranslations<T>;
  guestUnlock: GuestUnlockTranslations<T>;
  guestVacationRentals: GuestVacationRentalsTranslations<T>;
  headerHelpMenu: HeaderHelpMenuTranslations<T>;
  headerLayoutUpgrade: HeaderLayoutUpgradeTranslations<T>;
  hostBanners: HostBannersTranslations<T>;
  hotelBlock: HotelBlockTranslations<T>;
  hotelReminder: HotelReminderTranslations<T>;
  hotelTile: HotelTileTranslations<T>;
  ideabook: IdeabookTranslations<T>;
  ideas: IdeasTranslations<T>;
  imageFilePicker: ImageFilePickerTranslations<T>;
  impermissible: ImpermissibleTranslations<T>;
  joykit: JoykitTranslations<T>;
  layoutEngine: LayoutEngineTranslations<T>;
  locationDatesOccupants: LocationDatesOccupantsTranslations<T>;
  locationVenueSyncDialog: LocationVenueSyncDialogTranslations<T>;
  marcom: MarcomTranslations<T>;
  message: MessageTranslations<T>;
  messaging: MessagingTranslations<T>;
  multiPhotoSelector: MultiPhotoSelectorTranslations<T>;
  pageNotFound: PageNotFoundTranslations<T>;
  pageSettingsDialog: PageSettingsDialogTranslations<T>;
  photoPickerDialog: PhotoPickerDialogTranslations<T>;
  photoUploader: PhotoUploaderTranslations<T>;
  placeToStayComponent: PlaceToStayComponentTranslations<T>;
  placeToStayGuest: PlaceToStayGuestTranslations<T>;
  planningAccommodations: PlanningAccommodationsTranslations<T>;
  postOffice: PostOfficeTranslations<T>;
  productSelectionDialog: ProductSelectionDialogTranslations<T>;
  publishReminder: PublishReminderTranslations<T>;
  registration: RegistrationTranslations<T>;
  registryChecklist: RegistryChecklistTranslations<T>;
  registryOnboardingSurvey: RegistryOnboardingSurveyTranslations<T>;
  registryOnboardingSurveyV2: RegistryOnboardingSurveyV2Translations<T>;
  registryOverview: RegistryOverviewTranslations<T>;
  richTextEditor: RichTextEditorTranslations<T>;
  rsvpAdmin: RsvpAdminTranslations<T>;
  rsvpCustomComponent: RsvpCustomComponentTranslations<T>;
  rsvpReminder: RsvpReminderTranslations<T>;
  scheduleEditor: ScheduleEditorTranslations<T>;
  settings: SettingsTranslations<T>;
  sharedComponents: SharedComponentsTranslations<T>;
  shareDialog: ShareDialogTranslations<T>;
  sharedRegistry: SharedRegistryTranslations<T>;
  slapAdsRegistry: SlapAdsRegistryTranslations<T>;
  ssrServer: SsrServerTranslations<T>;
  stationery: StationeryTranslations<T>;
  stationeryTemplateCategory: StationeryTemplateCategoryTranslations<T>;
  stayBookingAssistant: StayBookingAssistantTranslations<T>;
  stays: StaysTranslations<T>;
  suggestions: SuggestionsTranslations<T>;
  survey: SurveyTranslations<T>;
  test: TestTranslations<T>;
  thanksForRSVP: ThanksForRsvpTranslations<T>;
  thingsToDoCustomComponent: ThingsToDoCustomComponentTranslations<T>;
  timePicker: TimePickerTranslations<T>;
  tour: TourTranslations<T>;
  translation: TranslationTranslations<T>;
  travelAdmin: TravelAdminTranslations<T>;
  travelEditor: TravelEditorTranslations<T>;
  travelMap: TravelMapTranslations<T>;
  travelNativeCheckout: TravelNativeCheckoutTranslations<T>;
  universalRecommendations: UniversalRecommendationsTranslations<T>;
  unpublishedWebsite: UnpublishedWebsiteTranslations<T>;
  updateScheduleDialog: UpdateScheduleDialogTranslations<T>;
  vendor: VendorTranslations<T>;
  verifyEmail: VerifyEmailTranslations<T>;
  videoBackground: VideoBackgroundTranslations<T>;
  VIPCustomComponent: VipCustomComponentTranslations<T>;
  VIPForm: VipFormTranslations<T>;
  weatherReportGuest: WeatherReportGuestTranslations<T>;
  websiteDesigner: WebsiteDesignerTranslations<T>;
  websiteEditor: WebsiteEditorTranslations<T>;
  websiteHeader: WebsiteHeaderTranslations<T>;
  websiteOverview: WebsiteOverviewTranslations<T>;
  websitePages: WebsitePagesTranslations<T>;
  websitePhotos: WebsitePhotosTranslations<T>;
  websitePreview: WebsitePreviewTranslations<T>;
  weddingParty: WeddingPartyTranslations<T>;
  yourRegistry: YourRegistryTranslations<T>;
};

export type TranslationNamespaces = keyof TranslationsByNamespace;

export const manifest = {
  de: {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/de/accommodationsAdmin.d615d3c8.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/de/accommodationsConsole.63026b6e.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/de/accommodationsGuest.da451970.json',
    account: '/bliss-apps/joy-web/static/locales/de/account.f5f28c5e.json',
    actionBar: '/bliss-apps/joy-web/static/locales/de/actionBar.d8392c65.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/de/addFromFriendsRegistry.5ec48fcc.json',
    addGiftFromStoresPopup: '/bliss-apps/joy-web/static/locales/de/addGiftFromStoresPopup.12c29f64.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/de/addToCalendar.10dab788.json',
    adminDashboard: '/bliss-apps/joy-web/static/locales/de/adminDashboard.ab7c76fc.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/de/adminDashboardV2.2bed6aa7.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/de/adminDashboardV3.9ca5d815.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/de/aiReviewTextarea.ec9e639c.json',
    artUpload: '/bliss-apps/joy-web/static/locales/de/artUpload.13b74136.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/de/autoPopulation.43fa903a.json',
    bnpl: '/bliss-apps/joy-web/static/locales/de/bnpl.6132e985.json',
    bookingAssistant: '/bliss-apps/joy-web/static/locales/de/bookingAssistant.103425c7.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/de/bookmarklet.16cf077a.json',
    cashFunds: '/bliss-apps/joy-web/static/locales/de/cashFunds.2032900c.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/de/catalogRegistry.2d58ae73.json',
    checklist: '/bliss-apps/joy-web/static/locales/de/checklist.92781ec6.json',
    collaboration: '/bliss-apps/joy-web/static/locales/de/collaboration.c3f86394.json',
    colors: '/bliss-apps/joy-web/static/locales/de/colors.7b3a87e1.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/de/companyPolicies.e7f5716a.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/de/contactCollector.a55f33b4.json',
    countries: '/bliss-apps/joy-web/static/locales/de/countries.a2b5aaf4.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/de/createBabyRegistry.c8a93a3d.json',
    createEvent: '/bliss-apps/joy-web/static/locales/de/createEvent.83075fdd.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/de/createGeneral.2b7a5e32.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/de/createRegistry.adcb04f0.json',
    createWedding: '/bliss-apps/joy-web/static/locales/de/createWedding.89cbb80f.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/de/curationsRegistry.9e0de4ae.json',
    currencies: '/bliss-apps/joy-web/static/locales/de/currencies.487bbf86.json',
    customDomain: '/bliss-apps/joy-web/static/locales/de/customDomain.c3ae2f58.json',
    dates: '/bliss-apps/joy-web/static/locales/de/dates.d786c64a.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/de/discountedRates.da474bfc.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/de/emailPreferences.9c60a63a.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/de/emailsAndEcards.3676104e.json',
    errors: '/bliss-apps/joy-web/static/locales/de/errors.7f46111e.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/de/eventCountdown.e8a64d3f.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/de/eventCountdownCustomComponent.b0c4d520.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/de/eventDetailsCustomComponent.5770885d.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/de/eventFormDisplay.e3c14df8.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/de/eventMenu.7ac50618.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/de/eventPhotoPicker.d1653f9e.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/de/eventRedirect.beccd276.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/de/eventServiceCenter.4d90e619.json',
    eventSite: '/bliss-apps/joy-web/static/locales/de/eventSite.55d4409d.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/de/eventSiteApps.c9446332.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/de/eventWorkspace.43da1cec.json',
    exampleConfigUsage: '/bliss-apps/joy-web/static/locales/de/exampleConfigUsage.d03128c7.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/de/faqCustomComponent.3d13b37e.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/de/focusPoint.8c06dad8.json',
    form: '/bliss-apps/joy-web/static/locales/de/form.f9d492ac.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/de/formCustomComponent.75b4dab7.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/de/generalEventSchedule.236c66ab.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/de/generalEventScheduleEditor.dd4c5184.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/de/generalFormValidation.f7849f83.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/de/graphicAccentCustomComponent.98b62067.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/de/guestGuide.09e17202.json',
    guestKit: '/bliss-apps/joy-web/static/locales/de/guestKit.9f72e9db.json',
    guestList: '/bliss-apps/joy-web/static/locales/de/guestList.16ed9364.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/de/guestRegistry.9dc6c47d.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/de/guestSiteCustom.69696a9a.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/de/guestSiteTravel.dd6a5be6.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/de/guestSiteWelcome.26c73136.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/de/guestUnlock.422d1cba.json',
    guestVacationRentals: '/bliss-apps/joy-web/static/locales/de/guestVacationRentals.b21ae4e6.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/de/headerHelpMenu.92b95591.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/de/headerLayoutUpgrade.493c6574.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/de/hotelBlock.3132c09d.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/de/hotelReminder.3b94897b.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/de/hotelTile.c21a0d01.json',
    ideabook: '/bliss-apps/joy-web/static/locales/de/ideabook.47a0ecd5.json',
    ideas: '/bliss-apps/joy-web/static/locales/de/ideas.1d0be411.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/de/imageFilePicker.c6d3e2e6.json',
    impermissible: '/bliss-apps/joy-web/static/locales/de/impermissible.f25dc585.json',
    joykit: '/bliss-apps/joy-web/static/locales/de/joykit.afb27768.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/de/layoutEngine.def635eb.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/de/locationDatesOccupants.a92a5e3b.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/de/locationVenueSyncDialog.5f5c0140.json',
    marcom: '/bliss-apps/joy-web/static/locales/de/marcom.a422b79d.json',
    message: '/bliss-apps/joy-web/static/locales/de/message.9a7a93b3.json',
    messaging: '/bliss-apps/joy-web/static/locales/de/messaging.84c14d6b.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/de/multiPhotoSelector.dc880089.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/de/pageNotFound.e80516e1.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/de/pageSettingsDialog.8df875ec.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/de/photoPickerDialog.5ee12f19.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/de/photoUploader.d96ca3c3.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/de/placeToStayComponent.ad748e9b.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/de/placeToStayGuest.72e3ea70.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/de/planningAccommodations.a15a7ca6.json',
    postOffice: '/bliss-apps/joy-web/static/locales/de/postOffice.5cfc90e3.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/de/productSelectionDialog.70f41da6.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/de/publishReminder.37af7fc9.json',
    registration: '/bliss-apps/joy-web/static/locales/de/registration.935c7409.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/de/registryChecklist.bff1923e.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/de/registryOnboardingSurvey.122f34ed.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/de/registryOnboardingSurveyV2.2ba7e41a.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/de/registryOverview.f79d8102.json',
    retargetTravelDialog: '/bliss-apps/joy-web/static/locales/de/retargetTravelDialog.30e1ed12.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/de/richTextEditor.d5953f37.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/de/rsvpAdmin.f0306dc9.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/de/rsvpCustomComponent.19414ee8.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/de/rsvpReminder.b8624951.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/de/scheduleEditor.e092504b.json',
    settings: '/bliss-apps/joy-web/static/locales/de/settings.a72d56d3.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/de/sharedComponents.263ae789.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/de/shareDialog.aeeff718.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/de/sharedRegistry.509b3481.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/de/slapAdsRegistry.3be3f56a.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/de/ssrServer.c74c8d3b.json',
    stationery: '/bliss-apps/joy-web/static/locales/de/stationery.0007e4fe.json',
    stationeryPriceConfigMapping: '/bliss-apps/joy-web/static/locales/de/stationeryPriceConfigMapping.edeb7bbc.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/de/stationeryTemplateCategory.08e3fb15.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/de/stayBookingAssistant.4db78f8c.json',
    stays: '/bliss-apps/joy-web/static/locales/de/stays.b1143c57.json',
    suggestions: '/bliss-apps/joy-web/static/locales/de/suggestions.917e9904.json',
    survey: '/bliss-apps/joy-web/static/locales/de/survey.9e7dc2db.json',
    test: '/bliss-apps/joy-web/static/locales/de/test.901afc98.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/de/thanksForRSVP.1286266d.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/de/thingsToDoCustomComponent.daed1eb3.json',
    timePicker: '/bliss-apps/joy-web/static/locales/de/timePicker.c050ca13.json',
    tour: '/bliss-apps/joy-web/static/locales/de/tour.cbd6c326.json',
    translation: '/bliss-apps/joy-web/static/locales/de/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/de/travelAdmin.2efc65dd.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/de/travelEditor.80906272.json',
    travelMap: '/bliss-apps/joy-web/static/locales/de/travelMap.3bea684e.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/de/travelNativeCheckout.d39a7375.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/de/universalRecommendations.a15d25cc.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/de/unpublishedWebsite.2e2b81a4.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/de/updateScheduleDialog.43e3b787.json',
    vendor: '/bliss-apps/joy-web/static/locales/de/vendor.705181ad.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/de/verifyEmail.e41d5c41.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/de/videoBackground.150f502b.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/de/VIPCustomComponent.2aa62504.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/de/VIPForm.726f49cf.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/de/weatherReportGuest.8f9a852f.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/de/websiteDesigner.a08d19a7.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/de/websiteEditor.7365d6dd.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/de/websiteHeader.70ffbb6f.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/de/websiteOverview.ec4b7fc2.json',
    websitePages: '/bliss-apps/joy-web/static/locales/de/websitePages.bb517a4a.json',
    websitePhotos: '/bliss-apps/joy-web/static/locales/de/websitePhotos.00697581.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/de/websitePreview.3f348e58.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/de/weddingParty.a9e63f90.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/de/yourRegistry.14465bbb.json',
  },
  en: {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/en/accommodationsAdmin.dad40501.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/en/accommodationsConsole.57a72448.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/en/accommodationsGuest.c1de7b66.json',
    account: '/bliss-apps/joy-web/static/locales/en/account.d1278fec.json',
    actionBar: '/bliss-apps/joy-web/static/locales/en/actionBar.a5f38a00.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/en/addFromFriendsRegistry.9e68360b.json',
    addGiftFromStoresPopup: '/bliss-apps/joy-web/static/locales/en/addGiftFromStoresPopup.6f5e0141.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/en/addToCalendar.8b347153.json',
    adminDashboard: '/bliss-apps/joy-web/static/locales/en/adminDashboard.6aafcb2a.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/en/adminDashboardV2.b7dc28f1.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/en/adminDashboardV3.66e80abd.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/en/aiReviewTextarea.7ee6135e.json',
    artUpload: '/bliss-apps/joy-web/static/locales/en/artUpload.859be443.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/en/autoPopulation.28f2b39c.json',
    bnpl: '/bliss-apps/joy-web/static/locales/en/bnpl.81bafaa3.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/en/bookmarklet.7e784e7f.json',
    cashFunds: '/bliss-apps/joy-web/static/locales/en/cashFunds.7bd4eb01.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/en/catalogRegistry.557025e3.json',
    checklist: '/bliss-apps/joy-web/static/locales/en/checklist.d09063a2.json',
    collaboration: '/bliss-apps/joy-web/static/locales/en/collaboration.e29fc42e.json',
    colors: '/bliss-apps/joy-web/static/locales/en/colors.18830638.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/en/companyPolicies.28fb77c4.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/en/contactCollector.a2295a1c.json',
    countries: '/bliss-apps/joy-web/static/locales/en/countries.c25e8fff.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/en/createBabyRegistry.682c96ea.json',
    createEvent: '/bliss-apps/joy-web/static/locales/en/createEvent.2b1114a5.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/en/createGeneral.3baffc43.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/en/createRegistry.2739f2c4.json',
    createWedding: '/bliss-apps/joy-web/static/locales/en/createWedding.f9a69dd6.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/en/curationsRegistry.c0aa8170.json',
    currencies: '/bliss-apps/joy-web/static/locales/en/currencies.a5465dd8.json',
    customDomain: '/bliss-apps/joy-web/static/locales/en/customDomain.d22247ac.json',
    dates: '/bliss-apps/joy-web/static/locales/en/dates.a65632d0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/en/discountedRates.3182c358.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/en/emailPreferences.2d6eac91.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/en/emailsAndEcards.00f86f02.json',
    errors: '/bliss-apps/joy-web/static/locales/en/errors.05dad04f.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/en/eventCountdown.3365fd79.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/en/eventCountdownCustomComponent.64ab5737.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/en/eventDetailsCustomComponent.f356d727.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/en/eventFormDisplay.57709919.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/en/eventMenu.ba2346ea.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/en/eventPhotoPicker.f52d0813.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/en/eventRedirect.7530e171.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/en/eventServiceCenter.5b83a8bd.json',
    eventSite: '/bliss-apps/joy-web/static/locales/en/eventSite.1e1fc32f.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/en/eventSiteApps.2ad37bd1.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/en/eventWorkspace.9275f556.json',
    exampleConfigUsage: '/bliss-apps/joy-web/static/locales/en/exampleConfigUsage.cc50a20b.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/en/faqCustomComponent.b81f300a.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/en/focusPoint.991ce776.json',
    form: '/bliss-apps/joy-web/static/locales/en/form.42c806d0.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/en/formCustomComponent.0bffb34c.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/en/generalEventSchedule.7a370f6a.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/en/generalEventScheduleEditor.a48660f7.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/en/generalFormValidation.cdab1225.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/en/graphicAccentCustomComponent.82eef864.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/en/guestGuide.c0666d41.json',
    guestKit: '/bliss-apps/joy-web/static/locales/en/guestKit.754505ef.json',
    guestList: '/bliss-apps/joy-web/static/locales/en/guestList.12f4dff0.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/en/guestRegistry.edc2a247.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/en/guestSiteCustom.bbabfab8.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/en/guestSiteTravel.58807abf.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/en/guestSiteWelcome.dee04230.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/en/guestUnlock.8362cbde.json',
    guestVacationRentals: '/bliss-apps/joy-web/static/locales/en/guestVacationRentals.da28b98d.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/en/headerHelpMenu.ee71f6c3.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/en/headerLayoutUpgrade.ba812319.json',
    hostBanners: '/bliss-apps/joy-web/static/locales/en/hostBanners.99914b93.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/en/hotelBlock.9bc3b583.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/en/hotelReminder.18ab0470.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/en/hotelTile.25e34cf4.json',
    ideabook: '/bliss-apps/joy-web/static/locales/en/ideabook.dddc6055.json',
    ideas: '/bliss-apps/joy-web/static/locales/en/ideas.c4f253fe.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/en/imageFilePicker.14fbe066.json',
    impermissible: '/bliss-apps/joy-web/static/locales/en/impermissible.81146127.json',
    joykit: '/bliss-apps/joy-web/static/locales/en/joykit.0ea85fc3.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/en/layoutEngine.7222cf03.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/en/locationDatesOccupants.82a6eb04.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/en/locationVenueSyncDialog.90f3ddd4.json',
    marcom: '/bliss-apps/joy-web/static/locales/en/marcom.a6d82934.json',
    message: '/bliss-apps/joy-web/static/locales/en/message.1391790b.json',
    messaging: '/bliss-apps/joy-web/static/locales/en/messaging.e4aff2eb.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/en/multiPhotoSelector.6e334cd8.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/en/pageNotFound.aad2bb88.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/en/pageSettingsDialog.d4d8e4d0.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/en/photoPickerDialog.7155d762.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/en/photoUploader.501a1926.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/en/placeToStayComponent.015db3ce.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/en/placeToStayGuest.4eced807.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/en/planningAccommodations.d27e3dde.json',
    postOffice: '/bliss-apps/joy-web/static/locales/en/postOffice.9685dff3.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/en/productSelectionDialog.fbe2ea73.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/en/publishReminder.ffab842c.json',
    registration: '/bliss-apps/joy-web/static/locales/en/registration.ca4cf19c.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/en/registryChecklist.fef61ee2.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/en/registryOnboardingSurvey.c169e9da.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/en/registryOnboardingSurveyV2.c0855d6c.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/en/registryOverview.cfbe64c5.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/en/richTextEditor.f165c5f0.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/en/rsvpAdmin.49ce618a.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/en/rsvpCustomComponent.914936d5.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/en/rsvpReminder.ddc1cc08.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/en/scheduleEditor.f5fb8416.json',
    settings: '/bliss-apps/joy-web/static/locales/en/settings.fce8bd56.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/en/sharedComponents.423e3122.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/en/shareDialog.00d71a40.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/en/sharedRegistry.195af199.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/en/slapAdsRegistry.3e78dffc.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/en/ssrServer.24259b78.json',
    stationery: '/bliss-apps/joy-web/static/locales/en/stationery.303a0e65.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/en/stationeryTemplateCategory.bee5d5b9.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/en/stayBookingAssistant.f7c153d3.json',
    stays: '/bliss-apps/joy-web/static/locales/en/stays.7ad6a18d.json',
    suggestions: '/bliss-apps/joy-web/static/locales/en/suggestions.327b70e6.json',
    survey: '/bliss-apps/joy-web/static/locales/en/survey.e60d4dff.json',
    test: '/bliss-apps/joy-web/static/locales/en/test.93535bb5.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/en/thanksForRSVP.078d9b0a.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/en/thingsToDoCustomComponent.f019ba9f.json',
    timePicker: '/bliss-apps/joy-web/static/locales/en/timePicker.a9875105.json',
    tour: '/bliss-apps/joy-web/static/locales/en/tour.c5f820a4.json',
    translation: '/bliss-apps/joy-web/static/locales/en/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/en/travelAdmin.f1bcffc9.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/en/travelEditor.c1072ff3.json',
    travelMap: '/bliss-apps/joy-web/static/locales/en/travelMap.e77dfa8c.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/en/travelNativeCheckout.81dc7485.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/en/universalRecommendations.309737e0.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/en/unpublishedWebsite.ea96bc1d.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/en/updateScheduleDialog.4e057033.json',
    vendor: '/bliss-apps/joy-web/static/locales/en/vendor.5ca56cd3.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/en/verifyEmail.6ce1b9a3.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/en/videoBackground.d9da8276.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/en/VIPCustomComponent.4ef2d37e.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/en/VIPForm.520d23dc.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/en/weatherReportGuest.0f9c262e.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/en/websiteDesigner.44bd2093.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/en/websiteEditor.6f3cdd73.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/en/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/en/websiteOverview.6cd44729.json',
    websitePages: '/bliss-apps/joy-web/static/locales/en/websitePages.813d55dc.json',
    websitePhotos: '/bliss-apps/joy-web/static/locales/en/websitePhotos.98078295.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/en/websitePreview.9bd55a76.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/en/weddingParty.9b78bbd3.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/en/yourRegistry.f252a46a.json',
  },
  'en-AU': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/en-AU/accommodationsAdmin.3efec917.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/en-AU/accommodationsConsole.fe979502.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/en-AU/accommodationsGuest.f15f9eb7.json',
    account: '/bliss-apps/joy-web/static/locales/en-AU/account.a569d0de.json',
    actionBar: '/bliss-apps/joy-web/static/locales/en-AU/actionBar.a3c986cb.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/en-AU/addFromFriendsRegistry.2f42cb76.json',
    addGiftFromStoresPopup: '/bliss-apps/joy-web/static/locales/en-AU/addGiftFromStoresPopup.b09940c2.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/en-AU/addToCalendar.8b347153.json',
    adminDashboard: '/bliss-apps/joy-web/static/locales/en-AU/adminDashboard.6aafcb2a.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/en-AU/adminDashboardV2.88c7328f.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/en-AU/adminDashboardV3.b990d656.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/en-AU/aiReviewTextarea.859d583e.json',
    artUpload: '/bliss-apps/joy-web/static/locales/en-AU/artUpload.99c27c06.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/en-AU/autoPopulation.4b8940d9.json',
    bnpl: '/bliss-apps/joy-web/static/locales/en-AU/bnpl.af361e3e.json',
    bookingAssistant: '/bliss-apps/joy-web/static/locales/en-AU/bookingAssistant.47f868e1.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/en-AU/bookmarklet.5c0428dc.json',
    cashFunds: '/bliss-apps/joy-web/static/locales/en-AU/cashFunds.2fe85151.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/en-AU/catalogRegistry.52461ae5.json',
    checklist: '/bliss-apps/joy-web/static/locales/en-AU/checklist.1f54cfae.json',
    collaboration: '/bliss-apps/joy-web/static/locales/en-AU/collaboration.0a2ff50c.json',
    colors: '/bliss-apps/joy-web/static/locales/en-AU/colors.7132b3f2.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/en-AU/companyPolicies.67232a28.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/en-AU/contactCollector.fc4594c9.json',
    countries: '/bliss-apps/joy-web/static/locales/en-AU/countries.c25e8fff.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/en-AU/createBabyRegistry.593170f4.json',
    createEvent: '/bliss-apps/joy-web/static/locales/en-AU/createEvent.09cfc841.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/en-AU/createGeneral.8b441457.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/en-AU/createRegistry.e10bbeac.json',
    createWedding: '/bliss-apps/joy-web/static/locales/en-AU/createWedding.a56289a4.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/en-AU/curationsRegistry.c0aa8170.json',
    currencies: '/bliss-apps/joy-web/static/locales/en-AU/currencies.e6cf126e.json',
    customDomain: '/bliss-apps/joy-web/static/locales/en-AU/customDomain.f09e638c.json',
    dates: '/bliss-apps/joy-web/static/locales/en-AU/dates.a65632d0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/en-AU/discountedRates.5d944820.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/en-AU/emailPreferences.b3cc2283.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/en-AU/emailsAndEcards.b2ea8e81.json',
    errors: '/bliss-apps/joy-web/static/locales/en-AU/errors.a25502db.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/en-AU/eventCountdown.3365fd79.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/eventCountdownCustomComponent.7ac9faf6.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/eventDetailsCustomComponent.91450f30.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/en-AU/eventFormDisplay.f80a87eb.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/en-AU/eventMenu.ba2346ea.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/en-AU/eventPhotoPicker.2be5bb9e.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/en-AU/eventRedirect.2d9d2da9.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/en-AU/eventServiceCenter.869e1ab4.json',
    eventSite: '/bliss-apps/joy-web/static/locales/en-AU/eventSite.2c207aaf.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/en-AU/eventSiteApps.5358a65f.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/en-AU/eventWorkspace.ec27679d.json',
    exampleConfigUsage: '/bliss-apps/joy-web/static/locales/en-AU/exampleConfigUsage.58d7730d.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/faqCustomComponent.16b7e3ed.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/en-AU/focusPoint.537bc75e.json',
    form: '/bliss-apps/joy-web/static/locales/en-AU/form.f7bdf9c9.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/formCustomComponent.3b4b66b0.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/en-AU/generalEventSchedule.8ca63b3f.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/en-AU/generalEventScheduleEditor.04f411df.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/en-AU/generalFormValidation.68bdd124.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/graphicAccentCustomComponent.82eef864.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/en-AU/guestGuide.73bf5465.json',
    guestKit: '/bliss-apps/joy-web/static/locales/en-AU/guestKit.e9b21d07.json',
    guestList: '/bliss-apps/joy-web/static/locales/en-AU/guestList.78a6c293.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/en-AU/guestRegistry.99016be5.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/en-AU/guestSiteCustom.4df70e17.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/en-AU/guestSiteTravel.0a87ba78.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/en-AU/guestSiteWelcome.1bc25882.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/en-AU/guestUnlock.6aeb134d.json',
    guestVacationRentals: '/bliss-apps/joy-web/static/locales/en-AU/guestVacationRentals.edd174a6.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/en-AU/headerHelpMenu.ee71f6c3.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/en-AU/headerLayoutUpgrade.43f4e13a.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/en-AU/hotelBlock.3544e239.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/en-AU/hotelReminder.47304bd8.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/en-AU/hotelTile.158d4fb2.json',
    ideabook: '/bliss-apps/joy-web/static/locales/en-AU/ideabook.dddc6055.json',
    ideas: '/bliss-apps/joy-web/static/locales/en-AU/ideas.38f82ea5.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/en-AU/imageFilePicker.b1ff057d.json',
    impermissible: '/bliss-apps/joy-web/static/locales/en-AU/impermissible.4cb89332.json',
    joykit: '/bliss-apps/joy-web/static/locales/en-AU/joykit.8690a5b7.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/en-AU/layoutEngine.040bd98c.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/en-AU/locationDatesOccupants.1a19d6e9.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/en-AU/locationVenueSyncDialog.83a5cdda.json',
    marcom: '/bliss-apps/joy-web/static/locales/en-AU/marcom.6877e713.json',
    message: '/bliss-apps/joy-web/static/locales/en-AU/message.27e4d06b.json',
    messaging: '/bliss-apps/joy-web/static/locales/en-AU/messaging.9d7e6796.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/en-AU/multiPhotoSelector.f46b5993.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/en-AU/pageNotFound.739f64bf.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/en-AU/pageSettingsDialog.36557825.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/en-AU/photoPickerDialog.6717ca0c.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/en-AU/photoUploader.4c7c503d.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/en-AU/placeToStayComponent.8eccd037.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/en-AU/placeToStayGuest.b2dba3bd.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/en-AU/planningAccommodations.6d2598d3.json',
    postOffice: '/bliss-apps/joy-web/static/locales/en-AU/postOffice.57ce1f53.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/en-AU/productSelectionDialog.0017d418.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/en-AU/publishReminder.9842b8b2.json',
    registration: '/bliss-apps/joy-web/static/locales/en-AU/registration.176e82b9.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/en-AU/registryChecklist.59198b4b.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/en-AU/registryOnboardingSurvey.fc9ab6ad.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/en-AU/registryOnboardingSurveyV2.abda4824.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/en-AU/registryOverview.86a1acbb.json',
    retargetTravelDialog: '/bliss-apps/joy-web/static/locales/en-AU/retargetTravelDialog.dd964dd2.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/en-AU/richTextEditor.6be01739.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/en-AU/rsvpAdmin.de792da7.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/rsvpCustomComponent.8e6d0e24.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/en-AU/rsvpReminder.d3971ec1.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/en-AU/scheduleEditor.f9da6efe.json',
    settings: '/bliss-apps/joy-web/static/locales/en-AU/settings.1672a1d0.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/en-AU/sharedComponents.0873e8a8.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/en-AU/shareDialog.ceebaad8.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/en-AU/sharedRegistry.f540e9d0.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/en-AU/slapAdsRegistry.d5561201.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/en-AU/ssrServer.82b36cdc.json',
    stationery: '/bliss-apps/joy-web/static/locales/en-AU/stationery.addb4b1a.json',
    stationeryPriceConfigMapping: '/bliss-apps/joy-web/static/locales/en-AU/stationeryPriceConfigMapping.ce6d2bff.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/en-AU/stationeryTemplateCategory.5b0114fc.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/en-AU/stayBookingAssistant.a2042ef3.json',
    stays: '/bliss-apps/joy-web/static/locales/en-AU/stays.f602afb3.json',
    suggestions: '/bliss-apps/joy-web/static/locales/en-AU/suggestions.492cdcfc.json',
    survey: '/bliss-apps/joy-web/static/locales/en-AU/survey.e60d4dff.json',
    test: '/bliss-apps/joy-web/static/locales/en-AU/test.93535bb5.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/en-AU/thanksForRSVP.b980c981.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/thingsToDoCustomComponent.db9eeb69.json',
    timePicker: '/bliss-apps/joy-web/static/locales/en-AU/timePicker.3d0fbcd4.json',
    tour: '/bliss-apps/joy-web/static/locales/en-AU/tour.4579f487.json',
    translation: '/bliss-apps/joy-web/static/locales/en-AU/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/en-AU/travelAdmin.9e71b1a3.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/en-AU/travelEditor.03eaa379.json',
    travelMap: '/bliss-apps/joy-web/static/locales/en-AU/travelMap.e0c4a22b.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/en-AU/travelNativeCheckout.5d5abb43.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/en-AU/universalRecommendations.f2942646.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/en-AU/unpublishedWebsite.39f0124b.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/en-AU/updateScheduleDialog.7fd0c440.json',
    vendor: '/bliss-apps/joy-web/static/locales/en-AU/vendor.76c89b43.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/en-AU/verifyEmail.fe978e71.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/en-AU/videoBackground.6b1f7194.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/en-AU/VIPCustomComponent.4bfbe6f4.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/en-AU/VIPForm.520d23dc.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/en-AU/weatherReportGuest.0f9c262e.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/en-AU/websiteDesigner.4bb9402f.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/en-AU/websiteEditor.8ea6ee83.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/en-AU/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/en-AU/websiteOverview.42827815.json',
    websitePages: '/bliss-apps/joy-web/static/locales/en-AU/websitePages.dc0571f9.json',
    websitePhotos: '/bliss-apps/joy-web/static/locales/en-AU/websitePhotos.aa68dc90.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/en-AU/websitePreview.9bd55a76.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/en-AU/weddingParty.e5a1f434.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/en-AU/yourRegistry.c0301042.json',
  },
  'en-GB': {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/en-GB/accommodationsAdmin.8b629cc3.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/en-GB/accommodationsConsole.4ffa6ec3.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/en-GB/accommodationsGuest.88e70d8f.json',
    account: '/bliss-apps/joy-web/static/locales/en-GB/account.0e6f64c4.json',
    actionBar: '/bliss-apps/joy-web/static/locales/en-GB/actionBar.d7d6a8e6.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/en-GB/addFromFriendsRegistry.aa0da612.json',
    addGiftFromStoresPopup: '/bliss-apps/joy-web/static/locales/en-GB/addGiftFromStoresPopup.de98ffd7.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/en-GB/addToCalendar.8b347153.json',
    adminDashboard: '/bliss-apps/joy-web/static/locales/en-GB/adminDashboard.4b52ebc4.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/en-GB/adminDashboardV2.348cca6b.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/en-GB/adminDashboardV3.43c1e2ce.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/en-GB/aiReviewTextarea.fde07661.json',
    artUpload: '/bliss-apps/joy-web/static/locales/en-GB/artUpload.4aa98777.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/en-GB/autoPopulation.bd8997b9.json',
    bnpl: '/bliss-apps/joy-web/static/locales/en-GB/bnpl.afe5a8ca.json',
    bookingAssistant: '/bliss-apps/joy-web/static/locales/en-GB/bookingAssistant.47f868e1.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/en-GB/bookmarklet.f874c9a8.json',
    cashFunds: '/bliss-apps/joy-web/static/locales/en-GB/cashFunds.89234a3d.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/en-GB/catalogRegistry.1a3fc998.json',
    checklist: '/bliss-apps/joy-web/static/locales/en-GB/checklist.984b7e54.json',
    collaboration: '/bliss-apps/joy-web/static/locales/en-GB/collaboration.455f5a01.json',
    colors: '/bliss-apps/joy-web/static/locales/en-GB/colors.7132b3f2.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/en-GB/companyPolicies.2a6fd7df.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/en-GB/contactCollector.7eb036f1.json',
    countries: '/bliss-apps/joy-web/static/locales/en-GB/countries.c25e8fff.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/en-GB/createBabyRegistry.b119c9b0.json',
    createEvent: '/bliss-apps/joy-web/static/locales/en-GB/createEvent.52809598.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/en-GB/createGeneral.7319bc70.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/en-GB/createRegistry.4cd28843.json',
    createWedding: '/bliss-apps/joy-web/static/locales/en-GB/createWedding.49f9a5c8.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/en-GB/curationsRegistry.87f31cd1.json',
    currencies: '/bliss-apps/joy-web/static/locales/en-GB/currencies.e6cf126e.json',
    customDomain: '/bliss-apps/joy-web/static/locales/en-GB/customDomain.3b9b5f30.json',
    dates: '/bliss-apps/joy-web/static/locales/en-GB/dates.a65632d0.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/en-GB/discountedRates.a8d06c20.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/en-GB/emailPreferences.85ba8363.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/en-GB/emailsAndEcards.55dc7b32.json',
    errors: '/bliss-apps/joy-web/static/locales/en-GB/errors.321b6137.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/en-GB/eventCountdown.3365fd79.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/eventCountdownCustomComponent.a96b6303.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/eventDetailsCustomComponent.9acb9bdd.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/en-GB/eventFormDisplay.76571263.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/en-GB/eventMenu.ba2346ea.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/en-GB/eventPhotoPicker.55399b93.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/en-GB/eventRedirect.ed823f22.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/en-GB/eventServiceCenter.d75973fe.json',
    eventSite: '/bliss-apps/joy-web/static/locales/en-GB/eventSite.a1d4b8ef.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/en-GB/eventSiteApps.2ad37bd1.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/en-GB/eventWorkspace.c4e245af.json',
    exampleConfigUsage: '/bliss-apps/joy-web/static/locales/en-GB/exampleConfigUsage.46ab21f7.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/faqCustomComponent.a6598644.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/en-GB/focusPoint.ea709b36.json',
    form: '/bliss-apps/joy-web/static/locales/en-GB/form.67652204.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/formCustomComponent.6c34afbc.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/en-GB/generalEventSchedule.ef05db54.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/en-GB/generalEventScheduleEditor.76ba884b.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/en-GB/generalFormValidation.b9f00d6b.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/graphicAccentCustomComponent.443bfd7c.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/en-GB/guestGuide.d5b2a180.json',
    guestKit: '/bliss-apps/joy-web/static/locales/en-GB/guestKit.1ca95d69.json',
    guestList: '/bliss-apps/joy-web/static/locales/en-GB/guestList.e3ffda00.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/en-GB/guestRegistry.89d883e7.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/en-GB/guestSiteCustom.3e62d6de.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/en-GB/guestSiteTravel.afa47482.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/en-GB/guestSiteWelcome.8704a195.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/en-GB/guestUnlock.eec9564a.json',
    guestVacationRentals: '/bliss-apps/joy-web/static/locales/en-GB/guestVacationRentals.957b173f.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/en-GB/headerHelpMenu.ee71f6c3.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/en-GB/headerLayoutUpgrade.204df0bb.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/en-GB/hotelBlock.075d91c9.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/en-GB/hotelReminder.5a4b2ba7.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/en-GB/hotelTile.28dfd51b.json',
    ideabook: '/bliss-apps/joy-web/static/locales/en-GB/ideabook.dddc6055.json',
    ideas: '/bliss-apps/joy-web/static/locales/en-GB/ideas.dd66145b.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/en-GB/imageFilePicker.9b2394c1.json',
    impermissible: '/bliss-apps/joy-web/static/locales/en-GB/impermissible.b94bb60f.json',
    joykit: '/bliss-apps/joy-web/static/locales/en-GB/joykit.d003d4fa.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/en-GB/layoutEngine.343d87d6.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/en-GB/locationDatesOccupants.05b39495.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/en-GB/locationVenueSyncDialog.5dbbf854.json',
    marcom: '/bliss-apps/joy-web/static/locales/en-GB/marcom.7b292db9.json',
    message: '/bliss-apps/joy-web/static/locales/en-GB/message.bcef528b.json',
    messaging: '/bliss-apps/joy-web/static/locales/en-GB/messaging.0e7f5625.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/en-GB/multiPhotoSelector.e4c4891d.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/en-GB/pageNotFound.33eb49b3.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/en-GB/pageSettingsDialog.63f9acec.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/en-GB/photoPickerDialog.3dfe5045.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/en-GB/photoUploader.57c3c10a.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/en-GB/placeToStayComponent.fecdae74.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/en-GB/placeToStayGuest.4eced807.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/en-GB/planningAccommodations.95f3021e.json',
    postOffice: '/bliss-apps/joy-web/static/locales/en-GB/postOffice.9fd26865.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/en-GB/productSelectionDialog.83195730.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/en-GB/publishReminder.d221586d.json',
    registration: '/bliss-apps/joy-web/static/locales/en-GB/registration.82f5bc6b.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/en-GB/registryChecklist.990448c8.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/en-GB/registryOnboardingSurvey.742d9edf.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/en-GB/registryOnboardingSurveyV2.cecc0248.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/en-GB/registryOverview.4c2183e7.json',
    retargetTravelDialog: '/bliss-apps/joy-web/static/locales/en-GB/retargetTravelDialog.cc6f5c1c.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/en-GB/richTextEditor.8fb9e72c.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/en-GB/rsvpAdmin.dc458c7c.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/rsvpCustomComponent.acf5eeb0.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/en-GB/rsvpReminder.761f33b8.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/en-GB/scheduleEditor.6271e57c.json',
    settings: '/bliss-apps/joy-web/static/locales/en-GB/settings.07623af5.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/en-GB/sharedComponents.63ddf93d.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/en-GB/shareDialog.c32eaf8d.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/en-GB/sharedRegistry.1f2eaf76.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/en-GB/slapAdsRegistry.85246404.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/en-GB/ssrServer.82b36cdc.json',
    stationery: '/bliss-apps/joy-web/static/locales/en-GB/stationery.6355ff5f.json',
    stationeryPriceConfigMapping: '/bliss-apps/joy-web/static/locales/en-GB/stationeryPriceConfigMapping.0202c312.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/en-GB/stationeryTemplateCategory.826e03ec.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/en-GB/stayBookingAssistant.0241e2fe.json',
    stays: '/bliss-apps/joy-web/static/locales/en-GB/stays.ecd07089.json',
    suggestions: '/bliss-apps/joy-web/static/locales/en-GB/suggestions.f47bc5e6.json',
    survey: '/bliss-apps/joy-web/static/locales/en-GB/survey.e60d4dff.json',
    test: '/bliss-apps/joy-web/static/locales/en-GB/test.93535bb5.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/en-GB/thanksForRSVP.3a926de8.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/thingsToDoCustomComponent.e35bf54b.json',
    timePicker: '/bliss-apps/joy-web/static/locales/en-GB/timePicker.1035b5ec.json',
    tour: '/bliss-apps/joy-web/static/locales/en-GB/tour.7744f7f8.json',
    translation: '/bliss-apps/joy-web/static/locales/en-GB/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/en-GB/travelAdmin.07712c83.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/en-GB/travelEditor.e88d1dd1.json',
    travelMap: '/bliss-apps/joy-web/static/locales/en-GB/travelMap.f52df036.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/en-GB/travelNativeCheckout.087113dc.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/en-GB/universalRecommendations.baae19df.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/en-GB/unpublishedWebsite.a4bda309.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/en-GB/updateScheduleDialog.7fd0c440.json',
    vendor: '/bliss-apps/joy-web/static/locales/en-GB/vendor.1d98adda.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/en-GB/verifyEmail.60a204df.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/en-GB/videoBackground.6b1f7194.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/en-GB/VIPCustomComponent.051deb4e.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/en-GB/VIPForm.520d23dc.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/en-GB/weatherReportGuest.0f9c262e.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/en-GB/websiteDesigner.c76c486d.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/en-GB/websiteEditor.fecf6f23.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/en-GB/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/en-GB/websiteOverview.c2423166.json',
    websitePages: '/bliss-apps/joy-web/static/locales/en-GB/websitePages.6af17db6.json',
    websitePhotos: '/bliss-apps/joy-web/static/locales/en-GB/websitePhotos.aeb9bf7b.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/en-GB/websitePreview.48691ab8.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/en-GB/weddingParty.83479da2.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/en-GB/yourRegistry.84c82b1c.json',
  },
  es: {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/es/accommodationsAdmin.fbfface4.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/es/accommodationsConsole.887859e1.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/es/accommodationsGuest.271224f3.json',
    account: '/bliss-apps/joy-web/static/locales/es/account.18e6fa3a.json',
    actionBar: '/bliss-apps/joy-web/static/locales/es/actionBar.af81ea17.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/es/addFromFriendsRegistry.b8a1d367.json',
    addGiftFromStoresPopup: '/bliss-apps/joy-web/static/locales/es/addGiftFromStoresPopup.ce64a9af.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/es/addToCalendar.731dba60.json',
    adminDashboard: '/bliss-apps/joy-web/static/locales/es/adminDashboard.94100d13.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/es/adminDashboardV2.ea1a9c5c.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/es/adminDashboardV3.c5ca608e.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/es/aiReviewTextarea.10f26c11.json',
    artUpload: '/bliss-apps/joy-web/static/locales/es/artUpload.cdff9158.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/es/autoPopulation.6de315c4.json',
    bnpl: '/bliss-apps/joy-web/static/locales/es/bnpl.63122453.json',
    bookingAssistant: '/bliss-apps/joy-web/static/locales/es/bookingAssistant.1258138f.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/es/bookmarklet.208ef085.json',
    cashFunds: '/bliss-apps/joy-web/static/locales/es/cashFunds.53a57080.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/es/catalogRegistry.d60fa1d3.json',
    checklist: '/bliss-apps/joy-web/static/locales/es/checklist.bb1b6645.json',
    collaboration: '/bliss-apps/joy-web/static/locales/es/collaboration.186e225a.json',
    colors: '/bliss-apps/joy-web/static/locales/es/colors.0e1825c3.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/es/companyPolicies.936e8e47.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/es/contactCollector.dc276405.json',
    countries: '/bliss-apps/joy-web/static/locales/es/countries.282359ed.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/es/createBabyRegistry.8422f01a.json',
    createEvent: '/bliss-apps/joy-web/static/locales/es/createEvent.56f93b9c.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/es/createGeneral.0f6b04f5.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/es/createRegistry.ded367b0.json',
    createWedding: '/bliss-apps/joy-web/static/locales/es/createWedding.9b62a31a.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/es/curationsRegistry.478e0941.json',
    currencies: '/bliss-apps/joy-web/static/locales/es/currencies.98240cac.json',
    customDomain: '/bliss-apps/joy-web/static/locales/es/customDomain.15fc2db8.json',
    dates: '/bliss-apps/joy-web/static/locales/es/dates.ab12382b.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/es/discountedRates.ea162d81.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/es/emailPreferences.6437bfb3.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/es/emailsAndEcards.77a9b8b0.json',
    errors: '/bliss-apps/joy-web/static/locales/es/errors.8fba1580.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/es/eventCountdown.9633219c.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/es/eventCountdownCustomComponent.b5fdea43.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/es/eventDetailsCustomComponent.50a83476.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/es/eventFormDisplay.1f8142f7.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/es/eventMenu.cabb957c.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/es/eventPhotoPicker.9d871fb6.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/es/eventRedirect.9ea1f29c.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/es/eventServiceCenter.7aeb8da1.json',
    eventSite: '/bliss-apps/joy-web/static/locales/es/eventSite.1c5fd3a8.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/es/eventSiteApps.be891142.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/es/eventWorkspace.90cb0ab4.json',
    exampleConfigUsage: '/bliss-apps/joy-web/static/locales/es/exampleConfigUsage.dbd72fd6.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/es/faqCustomComponent.4cd4f92d.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/es/focusPoint.cc64172e.json',
    form: '/bliss-apps/joy-web/static/locales/es/form.20fe6248.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/es/formCustomComponent.95ad3ac6.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/es/generalEventSchedule.6db35926.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/es/generalEventScheduleEditor.02ec57ae.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/es/generalFormValidation.1dab6edc.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/es/graphicAccentCustomComponent.4e3ee7ba.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/es/guestGuide.08b2bfb9.json',
    guestKit: '/bliss-apps/joy-web/static/locales/es/guestKit.e4517f24.json',
    guestList: '/bliss-apps/joy-web/static/locales/es/guestList.c68c0103.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/es/guestRegistry.aa7a3b49.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/es/guestSiteCustom.053c1a04.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/es/guestSiteTravel.13235f2e.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/es/guestSiteWelcome.54315439.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/es/guestUnlock.db17e2e0.json',
    guestVacationRentals: '/bliss-apps/joy-web/static/locales/es/guestVacationRentals.8da5b7df.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/es/headerHelpMenu.af32fe66.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/es/headerLayoutUpgrade.5d1c35cb.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/es/hotelBlock.9b2ecc51.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/es/hotelReminder.6841a2b0.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/es/hotelTile.15acea79.json',
    ideabook: '/bliss-apps/joy-web/static/locales/es/ideabook.21d8ec19.json',
    ideas: '/bliss-apps/joy-web/static/locales/es/ideas.c0dc03ba.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/es/imageFilePicker.448c5b16.json',
    impermissible: '/bliss-apps/joy-web/static/locales/es/impermissible.9d0f218e.json',
    joykit: '/bliss-apps/joy-web/static/locales/es/joykit.c537cbfd.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/es/layoutEngine.e3ed4d17.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/es/locationDatesOccupants.d35a8745.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/es/locationVenueSyncDialog.c36458cf.json',
    marcom: '/bliss-apps/joy-web/static/locales/es/marcom.8e3f036b.json',
    message: '/bliss-apps/joy-web/static/locales/es/message.d567a850.json',
    messaging: '/bliss-apps/joy-web/static/locales/es/messaging.4c284da9.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/es/multiPhotoSelector.a2a7d2ef.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/es/pageNotFound.04b664ec.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/es/pageSettingsDialog.294acb36.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/es/photoPickerDialog.ad94ef3f.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/es/photoUploader.01782ac4.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/es/placeToStayComponent.91831079.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/es/placeToStayGuest.45999e0b.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/es/planningAccommodations.71263a89.json',
    postOffice: '/bliss-apps/joy-web/static/locales/es/postOffice.cdb09460.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/es/productSelectionDialog.b706feab.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/es/publishReminder.286e7abc.json',
    registration: '/bliss-apps/joy-web/static/locales/es/registration.91dd1c9b.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/es/registryChecklist.4e97ad49.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/es/registryOnboardingSurvey.4b07760b.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/es/registryOnboardingSurveyV2.791989b8.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/es/registryOverview.52c5e035.json',
    retargetTravelDialog: '/bliss-apps/joy-web/static/locales/es/retargetTravelDialog.3e34b837.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/es/richTextEditor.51e45c58.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/es/rsvpAdmin.f36f6663.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/es/rsvpCustomComponent.c9a1ab43.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/es/rsvpReminder.b8198f63.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/es/scheduleEditor.35a25d28.json',
    settings: '/bliss-apps/joy-web/static/locales/es/settings.1888236c.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/es/sharedComponents.70973b11.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/es/shareDialog.75adaf5e.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/es/sharedRegistry.6839cfc6.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/es/slapAdsRegistry.b2c00316.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/es/ssrServer.23e14d21.json',
    stationery: '/bliss-apps/joy-web/static/locales/es/stationery.44cefcd0.json',
    stationeryPriceConfigMapping: '/bliss-apps/joy-web/static/locales/es/stationeryPriceConfigMapping.03d74e98.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/es/stationeryTemplateCategory.7f37cf7d.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/es/stayBookingAssistant.7624f849.json',
    stays: '/bliss-apps/joy-web/static/locales/es/stays.21b21a5f.json',
    suggestions: '/bliss-apps/joy-web/static/locales/es/suggestions.4bc2e215.json',
    survey: '/bliss-apps/joy-web/static/locales/es/survey.61d57170.json',
    test: '/bliss-apps/joy-web/static/locales/es/test.f83b08d6.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/es/thanksForRSVP.7314ae77.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/es/thingsToDoCustomComponent.a2990f24.json',
    timePicker: '/bliss-apps/joy-web/static/locales/es/timePicker.b1646d85.json',
    tour: '/bliss-apps/joy-web/static/locales/es/tour.c1d795b4.json',
    translation: '/bliss-apps/joy-web/static/locales/es/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/es/travelAdmin.70dfe250.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/es/travelEditor.be55fe21.json',
    travelMap: '/bliss-apps/joy-web/static/locales/es/travelMap.a89868d0.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/es/travelNativeCheckout.c2432be5.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/es/universalRecommendations.5d01762f.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/es/unpublishedWebsite.49ddd7ff.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/es/updateScheduleDialog.c93e7b28.json',
    vendor: '/bliss-apps/joy-web/static/locales/es/vendor.69b3592f.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/es/verifyEmail.91f1dd03.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/es/videoBackground.30c4505f.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/es/VIPCustomComponent.3bf1699c.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/es/VIPForm.8a926a99.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/es/weatherReportGuest.f607ad1a.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/es/websiteDesigner.d92edd00.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/es/websiteEditor.4e4ac08e.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/es/websiteHeader.70ffbb6f.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/es/websiteOverview.bae3e897.json',
    websitePages: '/bliss-apps/joy-web/static/locales/es/websitePages.009c1e4c.json',
    websitePhotos: '/bliss-apps/joy-web/static/locales/es/websitePhotos.aa244d67.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/es/websitePreview.4ea9dc11.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/es/weddingParty.707527e0.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/es/yourRegistry.b192afaa.json',
  },
  fr: {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/fr/accommodationsAdmin.65ced3ec.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/fr/accommodationsConsole.7c9a4032.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/fr/accommodationsGuest.279ee7cc.json',
    account: '/bliss-apps/joy-web/static/locales/fr/account.bf9b58b9.json',
    actionBar: '/bliss-apps/joy-web/static/locales/fr/actionBar.e073856a.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/fr/addFromFriendsRegistry.9adb7769.json',
    addGiftFromStoresPopup: '/bliss-apps/joy-web/static/locales/fr/addGiftFromStoresPopup.e7879a96.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/fr/addToCalendar.7ed0cf9f.json',
    adminDashboard: '/bliss-apps/joy-web/static/locales/fr/adminDashboard.62263cea.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/fr/adminDashboardV2.05418401.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/fr/adminDashboardV3.176e5a6a.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/fr/aiReviewTextarea.ba38ba94.json',
    artUpload: '/bliss-apps/joy-web/static/locales/fr/artUpload.5b7a334b.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/fr/autoPopulation.78002ce3.json',
    bnpl: '/bliss-apps/joy-web/static/locales/fr/bnpl.63bfef1e.json',
    bookingAssistant: '/bliss-apps/joy-web/static/locales/fr/bookingAssistant.ca0bee1c.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/fr/bookmarklet.c9cfc174.json',
    cashFunds: '/bliss-apps/joy-web/static/locales/fr/cashFunds.1ee39960.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/fr/catalogRegistry.0a0ce52b.json',
    checklist: '/bliss-apps/joy-web/static/locales/fr/checklist.4b444438.json',
    collaboration: '/bliss-apps/joy-web/static/locales/fr/collaboration.717f3ca0.json',
    colors: '/bliss-apps/joy-web/static/locales/fr/colors.ced0ae08.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/fr/companyPolicies.41aa0462.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/fr/contactCollector.a880373f.json',
    countries: '/bliss-apps/joy-web/static/locales/fr/countries.48a6f83f.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/fr/createBabyRegistry.7beb5146.json',
    createEvent: '/bliss-apps/joy-web/static/locales/fr/createEvent.e04219f4.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/fr/createGeneral.615b8e7d.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/fr/createRegistry.e703a065.json',
    createWedding: '/bliss-apps/joy-web/static/locales/fr/createWedding.98ed82e3.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/fr/curationsRegistry.cbea32b4.json',
    currencies: '/bliss-apps/joy-web/static/locales/fr/currencies.f17de09e.json',
    customDomain: '/bliss-apps/joy-web/static/locales/fr/customDomain.31e1f829.json',
    dates: '/bliss-apps/joy-web/static/locales/fr/dates.f9db5608.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/fr/discountedRates.40143acb.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/fr/emailPreferences.5bfc7a77.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/fr/emailsAndEcards.7c23d24d.json',
    errors: '/bliss-apps/joy-web/static/locales/fr/errors.0cd9c417.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/fr/eventCountdown.04bdd6e4.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/fr/eventCountdownCustomComponent.2174494e.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/fr/eventDetailsCustomComponent.f5e76f68.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/fr/eventFormDisplay.c02d0d3c.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/fr/eventMenu.04300b9b.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/fr/eventPhotoPicker.7104fde7.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/fr/eventRedirect.debdbf9c.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/fr/eventServiceCenter.b659f627.json',
    eventSite: '/bliss-apps/joy-web/static/locales/fr/eventSite.015b30c5.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/fr/eventSiteApps.ffb83e72.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/fr/eventWorkspace.a5b25fb1.json',
    exampleConfigUsage: '/bliss-apps/joy-web/static/locales/fr/exampleConfigUsage.8fe6a2a4.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/fr/faqCustomComponent.44e55ec2.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/fr/focusPoint.58e2f065.json',
    form: '/bliss-apps/joy-web/static/locales/fr/form.c5b1e802.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/fr/formCustomComponent.2fe035de.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/fr/generalEventSchedule.58a0b736.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/fr/generalEventScheduleEditor.981c65da.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/fr/generalFormValidation.84e03426.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/fr/graphicAccentCustomComponent.84ec4166.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/fr/guestGuide.8b28249f.json',
    guestKit: '/bliss-apps/joy-web/static/locales/fr/guestKit.e879093f.json',
    guestList: '/bliss-apps/joy-web/static/locales/fr/guestList.cc9e76cc.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/fr/guestRegistry.1dcb2f13.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/fr/guestSiteCustom.cb909982.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/fr/guestSiteTravel.fe182908.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/fr/guestSiteWelcome.2c1cafbc.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/fr/guestUnlock.11ff4b33.json',
    guestVacationRentals: '/bliss-apps/joy-web/static/locales/fr/guestVacationRentals.7cb723b7.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/fr/headerHelpMenu.d2bb1dbc.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/fr/headerLayoutUpgrade.32e7af03.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/fr/hotelBlock.0d054cc8.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/fr/hotelReminder.b05bcd8b.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/fr/hotelTile.c6bf4337.json',
    ideabook: '/bliss-apps/joy-web/static/locales/fr/ideabook.59cea8ec.json',
    ideas: '/bliss-apps/joy-web/static/locales/fr/ideas.d34566a5.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/fr/imageFilePicker.3e97cd24.json',
    impermissible: '/bliss-apps/joy-web/static/locales/fr/impermissible.68541b1e.json',
    joykit: '/bliss-apps/joy-web/static/locales/fr/joykit.09728dd2.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/fr/layoutEngine.b61057e7.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/fr/locationDatesOccupants.28c3113d.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/fr/locationVenueSyncDialog.7e0eb738.json',
    marcom: '/bliss-apps/joy-web/static/locales/fr/marcom.3fffc180.json',
    message: '/bliss-apps/joy-web/static/locales/fr/message.9e8de11e.json',
    messaging: '/bliss-apps/joy-web/static/locales/fr/messaging.de9fca97.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/fr/multiPhotoSelector.5bed2c06.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/fr/pageNotFound.98544671.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/fr/pageSettingsDialog.981cd25b.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/fr/photoPickerDialog.e7654768.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/fr/photoUploader.a55a2683.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/fr/placeToStayComponent.d1a6bc29.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/fr/placeToStayGuest.08161b91.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/fr/planningAccommodations.c1a0d3a7.json',
    postOffice: '/bliss-apps/joy-web/static/locales/fr/postOffice.239c75f7.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/fr/productSelectionDialog.ca14a09b.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/fr/publishReminder.6585b231.json',
    registration: '/bliss-apps/joy-web/static/locales/fr/registration.3ae75b73.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/fr/registryChecklist.0b41fc18.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/fr/registryOnboardingSurvey.bf807db9.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/fr/registryOnboardingSurveyV2.7ff98747.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/fr/registryOverview.96b741b9.json',
    retargetTravelDialog: '/bliss-apps/joy-web/static/locales/fr/retargetTravelDialog.b1f7fc3a.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/fr/richTextEditor.a61663e6.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/fr/rsvpAdmin.25d0d2f4.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/fr/rsvpCustomComponent.08193006.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/fr/rsvpReminder.dcda6085.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/fr/scheduleEditor.50cdda0b.json',
    settings: '/bliss-apps/joy-web/static/locales/fr/settings.1e5849a1.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/fr/sharedComponents.273169bd.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/fr/shareDialog.eda38c87.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/fr/sharedRegistry.cc9d7844.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/fr/slapAdsRegistry.08cc4724.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/fr/ssrServer.4eb33790.json',
    stationery: '/bliss-apps/joy-web/static/locales/fr/stationery.2b73965d.json',
    stationeryPriceConfigMapping: '/bliss-apps/joy-web/static/locales/fr/stationeryPriceConfigMapping.53a3c65d.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/fr/stationeryTemplateCategory.2d0abecf.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/fr/stayBookingAssistant.9a7cd4b0.json',
    stays: '/bliss-apps/joy-web/static/locales/fr/stays.fa514b56.json',
    suggestions: '/bliss-apps/joy-web/static/locales/fr/suggestions.bf8058b3.json',
    survey: '/bliss-apps/joy-web/static/locales/fr/survey.4af0c224.json',
    test: '/bliss-apps/joy-web/static/locales/fr/test.739951c9.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/fr/thanksForRSVP.66871cf0.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/fr/thingsToDoCustomComponent.17c82b51.json',
    timePicker: '/bliss-apps/joy-web/static/locales/fr/timePicker.75c2e41c.json',
    tour: '/bliss-apps/joy-web/static/locales/fr/tour.6b84a629.json',
    translation: '/bliss-apps/joy-web/static/locales/fr/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/fr/travelAdmin.9a536827.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/fr/travelEditor.ef75128f.json',
    travelMap: '/bliss-apps/joy-web/static/locales/fr/travelMap.c1d6c269.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/fr/travelNativeCheckout.fb292a3e.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/fr/universalRecommendations.c66b85fe.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/fr/unpublishedWebsite.80cd8846.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/fr/updateScheduleDialog.9e818237.json',
    vendor: '/bliss-apps/joy-web/static/locales/fr/vendor.f18c6e4e.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/fr/verifyEmail.aa1c6a2e.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/fr/videoBackground.f98e54e4.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/fr/VIPCustomComponent.17ac37b8.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/fr/VIPForm.9fd05cca.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/fr/weatherReportGuest.9ca4add7.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/fr/websiteDesigner.197ef20e.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/fr/websiteEditor.c81db918.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/fr/websiteHeader.69a8b7ae.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/fr/websiteOverview.17d21b3c.json',
    websitePages: '/bliss-apps/joy-web/static/locales/fr/websitePages.19b36602.json',
    websitePhotos: '/bliss-apps/joy-web/static/locales/fr/websitePhotos.28cf9651.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/fr/websitePreview.633b5483.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/fr/weddingParty.26750c57.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/fr/yourRegistry.0856776e.json',
  },
  it: {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/it/accommodationsAdmin.a392770a.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/it/accommodationsConsole.0b3a2303.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/it/accommodationsGuest.26a1d553.json',
    account: '/bliss-apps/joy-web/static/locales/it/account.5c59379b.json',
    actionBar: '/bliss-apps/joy-web/static/locales/it/actionBar.12129910.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/it/addFromFriendsRegistry.75443368.json',
    addGiftFromStoresPopup: '/bliss-apps/joy-web/static/locales/it/addGiftFromStoresPopup.37da49a9.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/it/addToCalendar.a37cd626.json',
    adminDashboard: '/bliss-apps/joy-web/static/locales/it/adminDashboard.1ed003ad.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/it/adminDashboardV2.3f8f7a84.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/it/adminDashboardV3.40ab9010.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/it/aiReviewTextarea.d0695c2f.json',
    artUpload: '/bliss-apps/joy-web/static/locales/it/artUpload.d8571012.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/it/autoPopulation.be0dc4ad.json',
    bnpl: '/bliss-apps/joy-web/static/locales/it/bnpl.5a713d2f.json',
    bookingAssistant: '/bliss-apps/joy-web/static/locales/it/bookingAssistant.e7581580.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/it/bookmarklet.3ca8688c.json',
    cashFunds: '/bliss-apps/joy-web/static/locales/it/cashFunds.5a179d7a.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/it/catalogRegistry.f9185bab.json',
    checklist: '/bliss-apps/joy-web/static/locales/it/checklist.2a7f899e.json',
    collaboration: '/bliss-apps/joy-web/static/locales/it/collaboration.0026c3c6.json',
    colors: '/bliss-apps/joy-web/static/locales/it/colors.1593455c.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/it/companyPolicies.0e2ae78f.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/it/contactCollector.be0de1df.json',
    countries: '/bliss-apps/joy-web/static/locales/it/countries.9bab4c1a.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/it/createBabyRegistry.178b1b83.json',
    createEvent: '/bliss-apps/joy-web/static/locales/it/createEvent.627e5c65.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/it/createGeneral.e9d722c2.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/it/createRegistry.f458003a.json',
    createWedding: '/bliss-apps/joy-web/static/locales/it/createWedding.d48c81ac.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/it/curationsRegistry.32112bff.json',
    currencies: '/bliss-apps/joy-web/static/locales/it/currencies.7917c97a.json',
    customDomain: '/bliss-apps/joy-web/static/locales/it/customDomain.51104363.json',
    dates: '/bliss-apps/joy-web/static/locales/it/dates.1002b6a8.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/it/discountedRates.f05c23e1.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/it/emailPreferences.2380d828.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/it/emailsAndEcards.f0384b21.json',
    errors: '/bliss-apps/joy-web/static/locales/it/errors.5cc76d3e.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/it/eventCountdown.8c366dfe.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/it/eventCountdownCustomComponent.abd6f43d.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/it/eventDetailsCustomComponent.15b609e4.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/it/eventFormDisplay.bf5a6117.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/it/eventMenu.b98609af.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/it/eventPhotoPicker.379b93ba.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/it/eventRedirect.912aa86b.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/it/eventServiceCenter.be623604.json',
    eventSite: '/bliss-apps/joy-web/static/locales/it/eventSite.5cdc4516.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/it/eventSiteApps.67119182.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/it/eventWorkspace.2569e42b.json',
    exampleConfigUsage: '/bliss-apps/joy-web/static/locales/it/exampleConfigUsage.f3a9a370.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/it/faqCustomComponent.fceb36ae.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/it/focusPoint.3e692913.json',
    form: '/bliss-apps/joy-web/static/locales/it/form.8a37da9b.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/it/formCustomComponent.e4d8c502.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/it/generalEventSchedule.123a271a.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/it/generalEventScheduleEditor.3d970f2b.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/it/generalFormValidation.fe8bfe0f.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/it/graphicAccentCustomComponent.bd29cf58.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/it/guestGuide.67c487d9.json',
    guestKit: '/bliss-apps/joy-web/static/locales/it/guestKit.0b8f9e90.json',
    guestList: '/bliss-apps/joy-web/static/locales/it/guestList.b5543019.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/it/guestRegistry.f0d458d8.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/it/guestSiteCustom.4e930440.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/it/guestSiteTravel.32d88564.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/it/guestSiteWelcome.8ada3f5a.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/it/guestUnlock.d3f29cd6.json',
    guestVacationRentals: '/bliss-apps/joy-web/static/locales/it/guestVacationRentals.7883e32b.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/it/headerHelpMenu.0977cc15.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/it/headerLayoutUpgrade.6e0c4272.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/it/hotelBlock.e55398b3.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/it/hotelReminder.530e5331.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/it/hotelTile.cee3f39c.json',
    ideabook: '/bliss-apps/joy-web/static/locales/it/ideabook.f78c8c62.json',
    ideas: '/bliss-apps/joy-web/static/locales/it/ideas.c6177e02.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/it/imageFilePicker.aa124aa2.json',
    impermissible: '/bliss-apps/joy-web/static/locales/it/impermissible.38de9dfd.json',
    joykit: '/bliss-apps/joy-web/static/locales/it/joykit.cea9007b.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/it/layoutEngine.28ffd3b2.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/it/locationDatesOccupants.3942d603.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/it/locationVenueSyncDialog.761b687e.json',
    marcom: '/bliss-apps/joy-web/static/locales/it/marcom.cc2e7d61.json',
    message: '/bliss-apps/joy-web/static/locales/it/message.0df558a4.json',
    messaging: '/bliss-apps/joy-web/static/locales/it/messaging.a622fb46.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/it/multiPhotoSelector.fab7631b.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/it/pageNotFound.46094875.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/it/pageSettingsDialog.83df65d8.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/it/photoPickerDialog.73ef73a5.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/it/photoUploader.55f4b67f.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/it/placeToStayComponent.30d6931b.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/it/placeToStayGuest.4eb53392.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/it/planningAccommodations.388349d0.json',
    postOffice: '/bliss-apps/joy-web/static/locales/it/postOffice.a862b90d.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/it/productSelectionDialog.8b15d598.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/it/publishReminder.015b9d1a.json',
    registration: '/bliss-apps/joy-web/static/locales/it/registration.66322a18.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/it/registryChecklist.c385821d.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/it/registryOnboardingSurvey.33ce0bdf.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/it/registryOnboardingSurveyV2.4acf01c9.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/it/registryOverview.e3a1ce00.json',
    retargetTravelDialog: '/bliss-apps/joy-web/static/locales/it/retargetTravelDialog.585d3061.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/it/richTextEditor.a92a4cee.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/it/rsvpAdmin.ee996d89.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/it/rsvpCustomComponent.9411a743.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/it/rsvpReminder.cb4cf19f.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/it/scheduleEditor.ee629cfa.json',
    settings: '/bliss-apps/joy-web/static/locales/it/settings.86779bf6.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/it/sharedComponents.2ab7aafe.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/it/shareDialog.72b2eeec.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/it/sharedRegistry.936ee9df.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/it/slapAdsRegistry.91fbc37a.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/it/ssrServer.b1243000.json',
    stationery: '/bliss-apps/joy-web/static/locales/it/stationery.74629b8b.json',
    stationeryPriceConfigMapping: '/bliss-apps/joy-web/static/locales/it/stationeryPriceConfigMapping.c79f4d4e.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/it/stationeryTemplateCategory.15df879e.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/it/stayBookingAssistant.c8bea9dd.json',
    stays: '/bliss-apps/joy-web/static/locales/it/stays.7d9aec84.json',
    suggestions: '/bliss-apps/joy-web/static/locales/it/suggestions.8990f217.json',
    survey: '/bliss-apps/joy-web/static/locales/it/survey.04a6fd79.json',
    test: '/bliss-apps/joy-web/static/locales/it/test.a0352993.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/it/thanksForRSVP.9c90e6c9.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/it/thingsToDoCustomComponent.430f42a3.json',
    timePicker: '/bliss-apps/joy-web/static/locales/it/timePicker.a3aa36e4.json',
    tour: '/bliss-apps/joy-web/static/locales/it/tour.7e5ade78.json',
    translation: '/bliss-apps/joy-web/static/locales/it/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/it/travelAdmin.59c80bd3.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/it/travelEditor.80b0b52a.json',
    travelMap: '/bliss-apps/joy-web/static/locales/it/travelMap.2e308c42.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/it/travelNativeCheckout.a01b95a8.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/it/universalRecommendations.2e6520e7.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/it/unpublishedWebsite.080c9752.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/it/updateScheduleDialog.d091723e.json',
    vendor: '/bliss-apps/joy-web/static/locales/it/vendor.859ef60a.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/it/verifyEmail.3a509401.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/it/videoBackground.f7507dd1.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/it/VIPCustomComponent.301e05ba.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/it/VIPForm.687836e2.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/it/weatherReportGuest.78527a0a.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/it/websiteDesigner.d14c7d18.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/it/websiteEditor.30f49961.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/it/websiteHeader.70ffbb6f.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/it/websiteOverview.1607b085.json',
    websitePages: '/bliss-apps/joy-web/static/locales/it/websitePages.f6fd33a2.json',
    websitePhotos: '/bliss-apps/joy-web/static/locales/it/websitePhotos.720254ad.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/it/websitePreview.fdc914b0.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/it/weddingParty.5e302c41.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/it/yourRegistry.a8d3a2fa.json',
  },
  ja: {
    accommodationsAdmin: '/bliss-apps/joy-web/static/locales/ja/accommodationsAdmin.24c00a62.json',
    accommodationsConsole: '/bliss-apps/joy-web/static/locales/ja/accommodationsConsole.bbb02b1c.json',
    accommodationsGuest: '/bliss-apps/joy-web/static/locales/ja/accommodationsGuest.2d9b3a0f.json',
    account: '/bliss-apps/joy-web/static/locales/ja/account.d692d03a.json',
    actionBar: '/bliss-apps/joy-web/static/locales/ja/actionBar.2c76a85e.json',
    addFromFriendsRegistry: '/bliss-apps/joy-web/static/locales/ja/addFromFriendsRegistry.60b2d73a.json',
    addGiftFromStoresPopup: '/bliss-apps/joy-web/static/locales/ja/addGiftFromStoresPopup.5ec47cda.json',
    addToCalendar: '/bliss-apps/joy-web/static/locales/ja/addToCalendar.85f70159.json',
    adminDashboard: '/bliss-apps/joy-web/static/locales/ja/adminDashboard.eb7143c8.json',
    adminDashboardV2: '/bliss-apps/joy-web/static/locales/ja/adminDashboardV2.44790115.json',
    adminDashboardV3: '/bliss-apps/joy-web/static/locales/ja/adminDashboardV3.fda46679.json',
    aiReviewTextarea: '/bliss-apps/joy-web/static/locales/ja/aiReviewTextarea.dd6140b2.json',
    artUpload: '/bliss-apps/joy-web/static/locales/ja/artUpload.06f426a2.json',
    autoPopulation: '/bliss-apps/joy-web/static/locales/ja/autoPopulation.29f1b958.json',
    bnpl: '/bliss-apps/joy-web/static/locales/ja/bnpl.0f2d8c72.json',
    bookingAssistant: '/bliss-apps/joy-web/static/locales/ja/bookingAssistant.163213e6.json',
    bookmarklet: '/bliss-apps/joy-web/static/locales/ja/bookmarklet.ed306dde.json',
    cashFunds: '/bliss-apps/joy-web/static/locales/ja/cashFunds.015adc9d.json',
    catalogRegistry: '/bliss-apps/joy-web/static/locales/ja/catalogRegistry.b8939c5e.json',
    checklist: '/bliss-apps/joy-web/static/locales/ja/checklist.7317853a.json',
    collaboration: '/bliss-apps/joy-web/static/locales/ja/collaboration.3b3ca78c.json',
    colors: '/bliss-apps/joy-web/static/locales/ja/colors.f6556251.json',
    companyPolicies: '/bliss-apps/joy-web/static/locales/ja/companyPolicies.19bfdf42.json',
    contactCollector: '/bliss-apps/joy-web/static/locales/ja/contactCollector.ecaa4828.json',
    countries: '/bliss-apps/joy-web/static/locales/ja/countries.168f975b.json',
    createBabyRegistry: '/bliss-apps/joy-web/static/locales/ja/createBabyRegistry.6335c21e.json',
    createEvent: '/bliss-apps/joy-web/static/locales/ja/createEvent.1ada6b66.json',
    createGeneral: '/bliss-apps/joy-web/static/locales/ja/createGeneral.a7b6384d.json',
    createRegistry: '/bliss-apps/joy-web/static/locales/ja/createRegistry.2589202f.json',
    createWedding: '/bliss-apps/joy-web/static/locales/ja/createWedding.f9944cc2.json',
    curationsRegistry: '/bliss-apps/joy-web/static/locales/ja/curationsRegistry.c6e18a85.json',
    currencies: '/bliss-apps/joy-web/static/locales/ja/currencies.1c59f24a.json',
    customDomain: '/bliss-apps/joy-web/static/locales/ja/customDomain.e6742bc6.json',
    dates: '/bliss-apps/joy-web/static/locales/ja/dates.5cef61ab.json',
    discountedRates: '/bliss-apps/joy-web/static/locales/ja/discountedRates.fbce3140.json',
    emailPreferences: '/bliss-apps/joy-web/static/locales/ja/emailPreferences.6e57c351.json',
    emailsAndEcards: '/bliss-apps/joy-web/static/locales/ja/emailsAndEcards.6a3da67f.json',
    errors: '/bliss-apps/joy-web/static/locales/ja/errors.bf79e2d8.json',
    eventCountdown: '/bliss-apps/joy-web/static/locales/ja/eventCountdown.f827a000.json',
    eventCountdownCustomComponent: '/bliss-apps/joy-web/static/locales/ja/eventCountdownCustomComponent.2284b474.json',
    eventDetailsCustomComponent: '/bliss-apps/joy-web/static/locales/ja/eventDetailsCustomComponent.ac15d588.json',
    eventFormDisplay: '/bliss-apps/joy-web/static/locales/ja/eventFormDisplay.8e2386a4.json',
    eventMenu: '/bliss-apps/joy-web/static/locales/ja/eventMenu.1f6580f8.json',
    eventPhotoPicker: '/bliss-apps/joy-web/static/locales/ja/eventPhotoPicker.50734e8c.json',
    eventRedirect: '/bliss-apps/joy-web/static/locales/ja/eventRedirect.8e4694cc.json',
    eventServiceCenter: '/bliss-apps/joy-web/static/locales/ja/eventServiceCenter.d4363dfb.json',
    eventSite: '/bliss-apps/joy-web/static/locales/ja/eventSite.8bb3aa69.json',
    eventSiteApps: '/bliss-apps/joy-web/static/locales/ja/eventSiteApps.6ce556da.json',
    eventWorkspace: '/bliss-apps/joy-web/static/locales/ja/eventWorkspace.d752ffe2.json',
    exampleConfigUsage: '/bliss-apps/joy-web/static/locales/ja/exampleConfigUsage.982bab18.json',
    faqCustomComponent: '/bliss-apps/joy-web/static/locales/ja/faqCustomComponent.2407b268.json',
    focusPoint: '/bliss-apps/joy-web/static/locales/ja/focusPoint.776a4ac6.json',
    form: '/bliss-apps/joy-web/static/locales/ja/form.e2e93b23.json',
    formCustomComponent: '/bliss-apps/joy-web/static/locales/ja/formCustomComponent.798a1fd0.json',
    generalEventSchedule: '/bliss-apps/joy-web/static/locales/ja/generalEventSchedule.fcbf623e.json',
    generalEventScheduleEditor: '/bliss-apps/joy-web/static/locales/ja/generalEventScheduleEditor.30712d03.json',
    generalFormValidation: '/bliss-apps/joy-web/static/locales/ja/generalFormValidation.c0f541d0.json',
    graphicAccentCustomComponent: '/bliss-apps/joy-web/static/locales/ja/graphicAccentCustomComponent.d0d2272c.json',
    guestGuide: '/bliss-apps/joy-web/static/locales/ja/guestGuide.9d092635.json',
    guestKit: '/bliss-apps/joy-web/static/locales/ja/guestKit.4d72e021.json',
    guestList: '/bliss-apps/joy-web/static/locales/ja/guestList.f3a95ae3.json',
    guestRegistry: '/bliss-apps/joy-web/static/locales/ja/guestRegistry.fd25d935.json',
    guestSiteCustom: '/bliss-apps/joy-web/static/locales/ja/guestSiteCustom.4baef529.json',
    guestSiteTravel: '/bliss-apps/joy-web/static/locales/ja/guestSiteTravel.5efdca6e.json',
    guestSiteWelcome: '/bliss-apps/joy-web/static/locales/ja/guestSiteWelcome.76048658.json',
    guestUnlock: '/bliss-apps/joy-web/static/locales/ja/guestUnlock.da90f60d.json',
    guestVacationRentals: '/bliss-apps/joy-web/static/locales/ja/guestVacationRentals.20135414.json',
    headerHelpMenu: '/bliss-apps/joy-web/static/locales/ja/headerHelpMenu.2ea56b76.json',
    headerLayoutUpgrade: '/bliss-apps/joy-web/static/locales/ja/headerLayoutUpgrade.5afbf4ba.json',
    hotelBlock: '/bliss-apps/joy-web/static/locales/ja/hotelBlock.da29785b.json',
    hotelReminder: '/bliss-apps/joy-web/static/locales/ja/hotelReminder.33ec2cb4.json',
    hotelTile: '/bliss-apps/joy-web/static/locales/ja/hotelTile.2e417211.json',
    ideabook: '/bliss-apps/joy-web/static/locales/ja/ideabook.dde6be6e.json',
    ideas: '/bliss-apps/joy-web/static/locales/ja/ideas.eb7318bd.json',
    imageFilePicker: '/bliss-apps/joy-web/static/locales/ja/imageFilePicker.fcdd1a6c.json',
    impermissible: '/bliss-apps/joy-web/static/locales/ja/impermissible.b50bb494.json',
    joykit: '/bliss-apps/joy-web/static/locales/ja/joykit.37d3501b.json',
    layoutEngine: '/bliss-apps/joy-web/static/locales/ja/layoutEngine.64028235.json',
    locationDatesOccupants: '/bliss-apps/joy-web/static/locales/ja/locationDatesOccupants.eb8915cb.json',
    locationVenueSyncDialog: '/bliss-apps/joy-web/static/locales/ja/locationVenueSyncDialog.bbb236ed.json',
    marcom: '/bliss-apps/joy-web/static/locales/ja/marcom.8b17f0a9.json',
    message: '/bliss-apps/joy-web/static/locales/ja/message.f33537ed.json',
    messaging: '/bliss-apps/joy-web/static/locales/ja/messaging.24eb24c3.json',
    multiPhotoSelector: '/bliss-apps/joy-web/static/locales/ja/multiPhotoSelector.be6a2c34.json',
    pageNotFound: '/bliss-apps/joy-web/static/locales/ja/pageNotFound.715b14bf.json',
    pageSettingsDialog: '/bliss-apps/joy-web/static/locales/ja/pageSettingsDialog.cc142aaa.json',
    photoPickerDialog: '/bliss-apps/joy-web/static/locales/ja/photoPickerDialog.ff4ef069.json',
    photoUploader: '/bliss-apps/joy-web/static/locales/ja/photoUploader.b1c04759.json',
    placeToStayComponent: '/bliss-apps/joy-web/static/locales/ja/placeToStayComponent.f2aaa950.json',
    placeToStayGuest: '/bliss-apps/joy-web/static/locales/ja/placeToStayGuest.314968b0.json',
    planningAccommodations: '/bliss-apps/joy-web/static/locales/ja/planningAccommodations.36aff414.json',
    postOffice: '/bliss-apps/joy-web/static/locales/ja/postOffice.34aaa66a.json',
    productSelectionDialog: '/bliss-apps/joy-web/static/locales/ja/productSelectionDialog.0d705693.json',
    publishReminder: '/bliss-apps/joy-web/static/locales/ja/publishReminder.a8c234eb.json',
    registration: '/bliss-apps/joy-web/static/locales/ja/registration.f2d2bc88.json',
    registryChecklist: '/bliss-apps/joy-web/static/locales/ja/registryChecklist.8f0c4b4f.json',
    registryOnboardingSurvey: '/bliss-apps/joy-web/static/locales/ja/registryOnboardingSurvey.be0db975.json',
    registryOnboardingSurveyV2: '/bliss-apps/joy-web/static/locales/ja/registryOnboardingSurveyV2.e1d67fb6.json',
    registryOverview: '/bliss-apps/joy-web/static/locales/ja/registryOverview.f166be7a.json',
    retargetTravelDialog: '/bliss-apps/joy-web/static/locales/ja/retargetTravelDialog.e61ba877.json',
    richTextEditor: '/bliss-apps/joy-web/static/locales/ja/richTextEditor.37936b9f.json',
    rsvpAdmin: '/bliss-apps/joy-web/static/locales/ja/rsvpAdmin.44834e95.json',
    rsvpCustomComponent: '/bliss-apps/joy-web/static/locales/ja/rsvpCustomComponent.bf37656f.json',
    rsvpReminder: '/bliss-apps/joy-web/static/locales/ja/rsvpReminder.61ed648d.json',
    scheduleEditor: '/bliss-apps/joy-web/static/locales/ja/scheduleEditor.68083453.json',
    settings: '/bliss-apps/joy-web/static/locales/ja/settings.6ae9b314.json',
    sharedComponents: '/bliss-apps/joy-web/static/locales/ja/sharedComponents.8b411d50.json',
    shareDialog: '/bliss-apps/joy-web/static/locales/ja/shareDialog.fae13269.json',
    sharedRegistry: '/bliss-apps/joy-web/static/locales/ja/sharedRegistry.97d33a71.json',
    slapAdsRegistry: '/bliss-apps/joy-web/static/locales/ja/slapAdsRegistry.ab7a18d5.json',
    ssrServer: '/bliss-apps/joy-web/static/locales/ja/ssrServer.01cf6742.json',
    stationery: '/bliss-apps/joy-web/static/locales/ja/stationery.c3a9b8d3.json',
    stationeryPriceConfigMapping: '/bliss-apps/joy-web/static/locales/ja/stationeryPriceConfigMapping.fc10a81b.json',
    stationeryTemplateCategory: '/bliss-apps/joy-web/static/locales/ja/stationeryTemplateCategory.295cca4a.json',
    stayBookingAssistant: '/bliss-apps/joy-web/static/locales/ja/stayBookingAssistant.e75c8822.json',
    stays: '/bliss-apps/joy-web/static/locales/ja/stays.447fbe8e.json',
    suggestions: '/bliss-apps/joy-web/static/locales/ja/suggestions.c9dce132.json',
    survey: '/bliss-apps/joy-web/static/locales/ja/survey.5536d831.json',
    test: '/bliss-apps/joy-web/static/locales/ja/test.db6d5c15.json',
    thanksForRSVP: '/bliss-apps/joy-web/static/locales/ja/thanksForRSVP.b40306b5.json',
    thingsToDoCustomComponent: '/bliss-apps/joy-web/static/locales/ja/thingsToDoCustomComponent.1c759fff.json',
    timePicker: '/bliss-apps/joy-web/static/locales/ja/timePicker.8f26adc1.json',
    tour: '/bliss-apps/joy-web/static/locales/ja/tour.aa364433.json',
    translation: '/bliss-apps/joy-web/static/locales/ja/translation.99914b93.json',
    travelAdmin: '/bliss-apps/joy-web/static/locales/ja/travelAdmin.9234b4aa.json',
    travelEditor: '/bliss-apps/joy-web/static/locales/ja/travelEditor.1a64b9c9.json',
    travelMap: '/bliss-apps/joy-web/static/locales/ja/travelMap.558c2bc6.json',
    travelNativeCheckout: '/bliss-apps/joy-web/static/locales/ja/travelNativeCheckout.36e567a4.json',
    universalRecommendations: '/bliss-apps/joy-web/static/locales/ja/universalRecommendations.020b9c61.json',
    unpublishedWebsite: '/bliss-apps/joy-web/static/locales/ja/unpublishedWebsite.eb9806a9.json',
    updateScheduleDialog: '/bliss-apps/joy-web/static/locales/ja/updateScheduleDialog.f5b90466.json',
    vendor: '/bliss-apps/joy-web/static/locales/ja/vendor.e4c38220.json',
    verifyEmail: '/bliss-apps/joy-web/static/locales/ja/verifyEmail.695c0219.json',
    videoBackground: '/bliss-apps/joy-web/static/locales/ja/videoBackground.c7d1fa65.json',
    VIPCustomComponent: '/bliss-apps/joy-web/static/locales/ja/VIPCustomComponent.a72b849e.json',
    VIPForm: '/bliss-apps/joy-web/static/locales/ja/VIPForm.0a708d26.json',
    weatherReportGuest: '/bliss-apps/joy-web/static/locales/ja/weatherReportGuest.864c388d.json',
    websiteDesigner: '/bliss-apps/joy-web/static/locales/ja/websiteDesigner.d8865769.json',
    websiteEditor: '/bliss-apps/joy-web/static/locales/ja/websiteEditor.3d30eba8.json',
    websiteHeader: '/bliss-apps/joy-web/static/locales/ja/websiteHeader.1df51243.json',
    websiteOverview: '/bliss-apps/joy-web/static/locales/ja/websiteOverview.5704418d.json',
    websitePages: '/bliss-apps/joy-web/static/locales/ja/websitePages.59041de4.json',
    websitePhotos: '/bliss-apps/joy-web/static/locales/ja/websitePhotos.2be35ef2.json',
    websitePreview: '/bliss-apps/joy-web/static/locales/ja/websitePreview.812caef9.json',
    weddingParty: '/bliss-apps/joy-web/static/locales/ja/weddingParty.91e34fea.json',
    yourRegistry: '/bliss-apps/joy-web/static/locales/ja/yourRegistry.c5f1e716.json',
  },
};
